(function () {
	'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getDefaultExportFromCjs (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function getAugmentedNamespace(n) {
		if (n.__esModule) return n;
		var a = Object.defineProperty({}, '__esModule', {value: true});
		Object.keys(n).forEach(function (k) {
			var d = Object.getOwnPropertyDescriptor(n, k);
			Object.defineProperty(a, k, d.get ? d : {
				enumerable: true,
				get: function () {
					return n[k];
				}
			});
		});
		return a;
	}

	function createCommonjsModule(fn) {
	  var module = { exports: {} };
		return fn(module, module.exports), module.exports;
	}

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var runtime_1 = createCommonjsModule(function (module) {
	var runtime = (function (exports) {

	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined$1; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

	  function define(obj, key, value) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	    return obj[key];
	  }
	  try {
	    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
	    define({}, "");
	  } catch (err) {
	    define = function(obj, key, value) {
	      return obj[key] = value;
	    };
	  }

	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);

	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);

	    return generator;
	  }
	  exports.wrap = wrap;

	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }

	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";

	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};

	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}

	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };

	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }

	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunction.displayName = define(
	    GeneratorFunctionPrototype,
	    toStringTagSymbol,
	    "GeneratorFunction"
	  );

	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      define(prototype, method, function(arg) {
	        return this._invoke(method, arg);
	      });
	    });
	  }

	  exports.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };

	  exports.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      define(genFun, toStringTagSymbol, "GeneratorFunction");
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };

	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  exports.awrap = function(arg) {
	    return { __await: arg };
	  };

	  function AsyncIterator(generator, PromiseImpl) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return PromiseImpl.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }

	        return PromiseImpl.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration.
	          result.value = unwrapped;
	          resolve(result);
	        }, function(error) {
	          // If a rejected Promise was yielded, throw the rejection back
	          // into the async generator function so it can be handled there.
	          return invoke("throw", error, resolve, reject);
	        });
	      }
	    }

	    var previousPromise;

	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new PromiseImpl(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }

	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }

	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }

	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  exports.AsyncIterator = AsyncIterator;

	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	    if (PromiseImpl === void 0) PromiseImpl = Promise;

	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList),
	      PromiseImpl
	    );

	    return exports.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };

	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;

	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }

	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }

	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }

	      context.method = method;
	      context.arg = arg;

	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }

	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;

	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }

	          context.dispatchException(context.arg);

	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }

	        state = GenStateExecuting;

	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;

	          if (record.arg === ContinueSentinel) {
	            continue;
	          }

	          return {
	            value: record.arg,
	            done: context.done
	          };

	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }

	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined$1) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;

	      if (context.method === "throw") {
	        // Note: ["return"] must be used for ES3 parsing compatibility.
	        if (delegate.iterator["return"]) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined$1;
	          maybeInvokeDelegate(delegate, context);

	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }

	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }

	      return ContinueSentinel;
	    }

	    var record = tryCatch(method, delegate.iterator, context.arg);

	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    var info = record.arg;

	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;

	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;

	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined$1;
	      }

	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }

	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }

	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);

	  define(Gp, toStringTagSymbol, "Generator");

	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };

	  Gp.toString = function() {
	    return "[object Generator]";
	  };

	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };

	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }

	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }

	    this.tryEntries.push(entry);
	  }

	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }

	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }

	  exports.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();

	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }

	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };

	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }

	      if (typeof iterable.next === "function") {
	        return iterable;
	      }

	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }

	          next.value = undefined$1;
	          next.done = true;

	          return next;
	        };

	        return next.next = next;
	      }
	    }

	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  exports.values = values;

	  function doneResult() {
	    return { value: undefined$1, done: true };
	  }

	  Context.prototype = {
	    constructor: Context,

	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined$1;
	      this.done = false;
	      this.delegate = null;

	      this.method = "next";
	      this.arg = undefined$1;

	      this.tryEntries.forEach(resetTryEntry);

	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined$1;
	          }
	        }
	      }
	    },

	    stop: function() {
	      this.done = true;

	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }

	      return this.rval;
	    },

	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }

	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;

	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined$1;
	        }

	        return !! caught;
	      }

	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;

	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }

	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");

	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }

	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },

	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }

	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }

	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;

	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }

	      return this.complete(record);
	    },

	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }

	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }

	      return ContinueSentinel;
	    },

	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },

	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }

	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },

	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };

	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined$1;
	      }

	      return ContinueSentinel;
	    }
	  };

	  // Regardless of whether this script is executing as a CommonJS module
	  // or not, return the runtime object so that we can declare the variable
	  // regeneratorRuntime in the outer scope, which allows this module to be
	  // injected easily by `bin/regenerator --include-runtime script.js`.
	  return exports;

	}(
	  // If this script is executing as a CommonJS module, use module.exports
	  // as the regeneratorRuntime namespace. Otherwise create a new empty
	  // object. Either way, the resulting object will be used to initialize
	  // the regeneratorRuntime variable at the top of this file.
	   module.exports 
	));

	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  // This module should not be running in strict mode, so the above
	  // assignment should always work unless something is misconfigured. Just
	  // in case runtime.js accidentally runs in strict mode, we can escape
	  // strict mode using a global Function call. This could conceivably fail
	  // if a Content Security Policy forbids using Function, but in that case
	  // the proper solution is to fix the accidental strict mode problem. If
	  // you've misconfigured your bundler to force strict mode and applied a
	  // CSP to forbid Function, and you're not willing to fix either of those
	  // problems, please detail your unique predicament in a GitHub issue.
	  Function("r", "regeneratorRuntime = r")(runtime);
	}
	});

	/**
	 * Make a map and return a function for checking if a key
	 * is in that map.
	 * IMPORTANT: all calls of this function must be prefixed with
	 * \/\*#\_\_PURE\_\_\*\/
	 * So that rollup can tree-shake them if necessary.
	 */
	function makeMap(str, expectsLowerCase) {
	    const map = Object.create(null);
	    const list = str.split(',');
	    for (let i = 0; i < list.length; i++) {
	        map[list[i]] = true;
	    }
	    return expectsLowerCase ? val => !!map[val.toLowerCase()] : val => !!map[val];
	}

	/**
	 * dev only flag -> name mapping
	 */
	const PatchFlagNames = {
	    [1 /* TEXT */]: `TEXT`,
	    [2 /* CLASS */]: `CLASS`,
	    [4 /* STYLE */]: `STYLE`,
	    [8 /* PROPS */]: `PROPS`,
	    [16 /* FULL_PROPS */]: `FULL_PROPS`,
	    [32 /* HYDRATE_EVENTS */]: `HYDRATE_EVENTS`,
	    [64 /* STABLE_FRAGMENT */]: `STABLE_FRAGMENT`,
	    [128 /* KEYED_FRAGMENT */]: `KEYED_FRAGMENT`,
	    [256 /* UNKEYED_FRAGMENT */]: `UNKEYED_FRAGMENT`,
	    [512 /* NEED_PATCH */]: `NEED_PATCH`,
	    [1024 /* DYNAMIC_SLOTS */]: `DYNAMIC_SLOTS`,
	    [2048 /* DEV_ROOT_FRAGMENT */]: `DEV_ROOT_FRAGMENT`,
	    [-1 /* HOISTED */]: `HOISTED`,
	    [-2 /* BAIL */]: `BAIL`
	};

	/**
	 * Dev only
	 */
	const slotFlagsText = {
	    [1 /* STABLE */]: 'STABLE',
	    [2 /* DYNAMIC */]: 'DYNAMIC',
	    [3 /* FORWARDED */]: 'FORWARDED'
	};

	const GLOBALS_WHITE_LISTED = 'Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,' +
	    'decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,' +
	    'Object,Boolean,String,RegExp,Map,Set,JSON,Intl';
	const isGloballyWhitelisted = /*#__PURE__*/ makeMap(GLOBALS_WHITE_LISTED);

	const range = 2;
	function generateCodeFrame(source, start = 0, end = source.length) {
	    const lines = source.split(/\r?\n/);
	    let count = 0;
	    const res = [];
	    for (let i = 0; i < lines.length; i++) {
	        count += lines[i].length + 1;
	        if (count >= start) {
	            for (let j = i - range; j <= i + range || end > count; j++) {
	                if (j < 0 || j >= lines.length)
	                    continue;
	                const line = j + 1;
	                res.push(`${line}${' '.repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
	                const lineLength = lines[j].length;
	                if (j === i) {
	                    // push underline
	                    const pad = start - (count - lineLength) + 1;
	                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
	                    res.push(`   |  ` + ' '.repeat(pad) + '^'.repeat(length));
	                }
	                else if (j > i) {
	                    if (end > count) {
	                        const length = Math.max(Math.min(end - count, lineLength), 1);
	                        res.push(`   |  ` + '^'.repeat(length));
	                    }
	                    count += lineLength + 1;
	                }
	            }
	            break;
	        }
	    }
	    return res.join('\n');
	}

	/**
	 * On the client we only need to offer special cases for boolean attributes that
	 * have different names from their corresponding dom properties:
	 * - itemscope -> N/A
	 * - allowfullscreen -> allowFullscreen
	 * - formnovalidate -> formNoValidate
	 * - ismap -> isMap
	 * - nomodule -> noModule
	 * - novalidate -> noValidate
	 * - readonly -> readOnly
	 */
	const specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
	const isSpecialBooleanAttr = /*#__PURE__*/ makeMap(specialBooleanAttrs);

	function normalizeStyle(value) {
	    if (isArray(value)) {
	        const res = {};
	        for (let i = 0; i < value.length; i++) {
	            const item = value[i];
	            const normalized = normalizeStyle(isString(item) ? parseStringStyle(item) : item);
	            if (normalized) {
	                for (const key in normalized) {
	                    res[key] = normalized[key];
	                }
	            }
	        }
	        return res;
	    }
	    else if (isObject(value)) {
	        return value;
	    }
	}
	const listDelimiterRE = /;(?![^(]*\))/g;
	const propertyDelimiterRE = /:(.+)/;
	function parseStringStyle(cssText) {
	    const ret = {};
	    cssText.split(listDelimiterRE).forEach(item => {
	        if (item) {
	            const tmp = item.split(propertyDelimiterRE);
	            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
	        }
	    });
	    return ret;
	}
	function normalizeClass(value) {
	    let res = '';
	    if (isString(value)) {
	        res = value;
	    }
	    else if (isArray(value)) {
	        for (let i = 0; i < value.length; i++) {
	            res += normalizeClass(value[i]) + ' ';
	        }
	    }
	    else if (isObject(value)) {
	        for (const name in value) {
	            if (value[name]) {
	                res += name + ' ';
	            }
	        }
	    }
	    return res.trim();
	}

	// These tag configs are shared between compiler-dom and runtime-dom, so they
	// https://developer.mozilla.org/en-US/docs/Web/HTML/Element
	const HTML_TAGS = 'html,body,base,head,link,meta,style,title,address,article,aside,footer,' +
	    'header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,' +
	    'figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,' +
	    'data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,' +
	    'time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,' +
	    'canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,' +
	    'th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,' +
	    'option,output,progress,select,textarea,details,dialog,menu,' +
	    'summary,template,blockquote,iframe,tfoot';
	// https://developer.mozilla.org/en-US/docs/Web/SVG/Element
	const SVG_TAGS = 'svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,' +
	    'defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,' +
	    'feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,' +
	    'feDistanceLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,' +
	    'feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,' +
	    'fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,' +
	    'foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,' +
	    'mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,' +
	    'polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,' +
	    'text,textPath,title,tspan,unknown,use,view';
	const VOID_TAGS = 'area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr';
	const isHTMLTag = /*#__PURE__*/ makeMap(HTML_TAGS);
	const isSVGTag = /*#__PURE__*/ makeMap(SVG_TAGS);
	const isVoidTag = /*#__PURE__*/ makeMap(VOID_TAGS);

	function looseCompareArrays(a, b) {
	    if (a.length !== b.length)
	        return false;
	    let equal = true;
	    for (let i = 0; equal && i < a.length; i++) {
	        equal = looseEqual(a[i], b[i]);
	    }
	    return equal;
	}
	function looseEqual(a, b) {
	    if (a === b)
	        return true;
	    let aValidType = isDate(a);
	    let bValidType = isDate(b);
	    if (aValidType || bValidType) {
	        return aValidType && bValidType ? a.getTime() === b.getTime() : false;
	    }
	    aValidType = isArray(a);
	    bValidType = isArray(b);
	    if (aValidType || bValidType) {
	        return aValidType && bValidType ? looseCompareArrays(a, b) : false;
	    }
	    aValidType = isObject(a);
	    bValidType = isObject(b);
	    if (aValidType || bValidType) {
	        /* istanbul ignore if: this if will probably never be called */
	        if (!aValidType || !bValidType) {
	            return false;
	        }
	        const aKeysCount = Object.keys(a).length;
	        const bKeysCount = Object.keys(b).length;
	        if (aKeysCount !== bKeysCount) {
	            return false;
	        }
	        for (const key in a) {
	            const aHasKey = a.hasOwnProperty(key);
	            const bHasKey = b.hasOwnProperty(key);
	            if ((aHasKey && !bHasKey) ||
	                (!aHasKey && bHasKey) ||
	                !looseEqual(a[key], b[key])) {
	                return false;
	            }
	        }
	    }
	    return String(a) === String(b);
	}
	function looseIndexOf(arr, val) {
	    return arr.findIndex(item => looseEqual(item, val));
	}

	/**
	 * For converting {{ interpolation }} values to displayed strings.
	 * @private
	 */
	const toDisplayString = (val) => {
	    return val == null
	        ? ''
	        : isObject(val)
	            ? JSON.stringify(val, replacer, 2)
	            : String(val);
	};
	const replacer = (_key, val) => {
	    if (isMap(val)) {
	        return {
	            [`Map(${val.size})`]: [...val.entries()].reduce((entries, [key, val]) => {
	                entries[`${key} =>`] = val;
	                return entries;
	            }, {})
	        };
	    }
	    else if (isSet(val)) {
	        return {
	            [`Set(${val.size})`]: [...val.values()]
	        };
	    }
	    else if (isObject(val) && !isArray(val) && !isPlainObject(val)) {
	        return String(val);
	    }
	    return val;
	};
	const EMPTY_OBJ =  Object.freeze({})
	    ;
	const EMPTY_ARR =  Object.freeze([]) ;
	const NOOP = () => { };
	/**
	 * Always return false.
	 */
	const NO = () => false;
	const onRE = /^on[^a-z]/;
	const isOn = (key) => onRE.test(key);
	const isModelListener = (key) => key.startsWith('onUpdate:');
	const extend = Object.assign;
	const remove = (arr, el) => {
	    const i = arr.indexOf(el);
	    if (i > -1) {
	        arr.splice(i, 1);
	    }
	};
	const hasOwnProperty = Object.prototype.hasOwnProperty;
	const hasOwn = (val, key) => hasOwnProperty.call(val, key);
	const isArray = Array.isArray;
	const isMap = (val) => toTypeString(val) === '[object Map]';
	const isSet = (val) => toTypeString(val) === '[object Set]';
	const isDate = (val) => val instanceof Date;
	const isFunction = (val) => typeof val === 'function';
	const isString = (val) => typeof val === 'string';
	const isSymbol = (val) => typeof val === 'symbol';
	const isObject = (val) => val !== null && typeof val === 'object';
	const isPromise = (val) => {
	    return isObject(val) && isFunction(val.then) && isFunction(val.catch);
	};
	const objectToString = Object.prototype.toString;
	const toTypeString = (value) => objectToString.call(value);
	const toRawType = (value) => {
	    // extract "RawType" from strings like "[object RawType]"
	    return toTypeString(value).slice(8, -1);
	};
	const isPlainObject = (val) => toTypeString(val) === '[object Object]';
	const isIntegerKey = (key) => isString(key) &&
	    key !== 'NaN' &&
	    key[0] !== '-' &&
	    '' + parseInt(key, 10) === key;
	const isReservedProp = /*#__PURE__*/ makeMap(
	// the leading comma is intentional so empty string "" is also included
	',key,ref,' +
	    'onVnodeBeforeMount,onVnodeMounted,' +
	    'onVnodeBeforeUpdate,onVnodeUpdated,' +
	    'onVnodeBeforeUnmount,onVnodeUnmounted');
	const cacheStringFunction = (fn) => {
	    const cache = Object.create(null);
	    return ((str) => {
	        const hit = cache[str];
	        return hit || (cache[str] = fn(str));
	    });
	};
	const camelizeRE = /-(\w)/g;
	/**
	 * @private
	 */
	const camelize = cacheStringFunction((str) => {
	    return str.replace(camelizeRE, (_, c) => (c ? c.toUpperCase() : ''));
	});
	const hyphenateRE = /\B([A-Z])/g;
	/**
	 * @private
	 */
	const hyphenate = cacheStringFunction((str) => str.replace(hyphenateRE, '-$1').toLowerCase());
	/**
	 * @private
	 */
	const capitalize = cacheStringFunction((str) => str.charAt(0).toUpperCase() + str.slice(1));
	/**
	 * @private
	 */
	const toHandlerKey = cacheStringFunction((str) => (str ? `on${capitalize(str)}` : ``));
	// compare whether a value has changed, accounting for NaN.
	const hasChanged = (value, oldValue) => value !== oldValue && (value === value || oldValue === oldValue);
	const invokeArrayFns = (fns, arg) => {
	    for (let i = 0; i < fns.length; i++) {
	        fns[i](arg);
	    }
	};
	const def = (obj, key, value) => {
	    Object.defineProperty(obj, key, {
	        configurable: true,
	        enumerable: false,
	        value
	    });
	};
	const toNumber = (val) => {
	    const n = parseFloat(val);
	    return isNaN(n) ? val : n;
	};
	let _globalThis;
	const getGlobalThis = () => {
	    return (_globalThis ||
	        (_globalThis =
	            typeof globalThis !== 'undefined'
	                ? globalThis
	                : typeof self !== 'undefined'
	                    ? self
	                    : typeof window !== 'undefined'
	                        ? window
	                        : typeof global !== 'undefined'
	                            ? global
	                            : {}));
	};

	const targetMap = new WeakMap();
	const effectStack = [];
	let activeEffect;
	const ITERATE_KEY = Symbol( 'iterate' );
	const MAP_KEY_ITERATE_KEY = Symbol( 'Map key iterate' );
	function isEffect(fn) {
	    return fn && fn._isEffect === true;
	}
	function effect(fn, options = EMPTY_OBJ) {
	    if (isEffect(fn)) {
	        fn = fn.raw;
	    }
	    const effect = createReactiveEffect(fn, options);
	    if (!options.lazy) {
	        effect();
	    }
	    return effect;
	}
	function stop(effect) {
	    if (effect.active) {
	        cleanup(effect);
	        if (effect.options.onStop) {
	            effect.options.onStop();
	        }
	        effect.active = false;
	    }
	}
	let uid = 0;
	function createReactiveEffect(fn, options) {
	    const effect = function reactiveEffect() {
	        if (!effect.active) {
	            return options.scheduler ? undefined : fn();
	        }
	        if (!effectStack.includes(effect)) {
	            cleanup(effect);
	            try {
	                enableTracking();
	                effectStack.push(effect);
	                activeEffect = effect;
	                return fn();
	            }
	            finally {
	                effectStack.pop();
	                resetTracking();
	                activeEffect = effectStack[effectStack.length - 1];
	            }
	        }
	    };
	    effect.id = uid++;
	    effect.allowRecurse = !!options.allowRecurse;
	    effect._isEffect = true;
	    effect.active = true;
	    effect.raw = fn;
	    effect.deps = [];
	    effect.options = options;
	    return effect;
	}
	function cleanup(effect) {
	    const { deps } = effect;
	    if (deps.length) {
	        for (let i = 0; i < deps.length; i++) {
	            deps[i].delete(effect);
	        }
	        deps.length = 0;
	    }
	}
	let shouldTrack = true;
	const trackStack = [];
	function pauseTracking() {
	    trackStack.push(shouldTrack);
	    shouldTrack = false;
	}
	function enableTracking() {
	    trackStack.push(shouldTrack);
	    shouldTrack = true;
	}
	function resetTracking() {
	    const last = trackStack.pop();
	    shouldTrack = last === undefined ? true : last;
	}
	function track(target, type, key) {
	    if (!shouldTrack || activeEffect === undefined) {
	        return;
	    }
	    let depsMap = targetMap.get(target);
	    if (!depsMap) {
	        targetMap.set(target, (depsMap = new Map()));
	    }
	    let dep = depsMap.get(key);
	    if (!dep) {
	        depsMap.set(key, (dep = new Set()));
	    }
	    if (!dep.has(activeEffect)) {
	        dep.add(activeEffect);
	        activeEffect.deps.push(dep);
	        if ( activeEffect.options.onTrack) {
	            activeEffect.options.onTrack({
	                effect: activeEffect,
	                target,
	                type,
	                key
	            });
	        }
	    }
	}
	function trigger(target, type, key, newValue, oldValue, oldTarget) {
	    const depsMap = targetMap.get(target);
	    if (!depsMap) {
	        // never been tracked
	        return;
	    }
	    const effects = new Set();
	    const add = (effectsToAdd) => {
	        if (effectsToAdd) {
	            effectsToAdd.forEach(effect => {
	                if (effect !== activeEffect || effect.allowRecurse) {
	                    effects.add(effect);
	                }
	            });
	        }
	    };
	    if (type === "clear" /* CLEAR */) {
	        // collection being cleared
	        // trigger all effects for target
	        depsMap.forEach(add);
	    }
	    else if (key === 'length' && isArray(target)) {
	        depsMap.forEach((dep, key) => {
	            if (key === 'length' || key >= newValue) {
	                add(dep);
	            }
	        });
	    }
	    else {
	        // schedule runs for SET | ADD | DELETE
	        if (key !== void 0) {
	            add(depsMap.get(key));
	        }
	        // also run for iteration key on ADD | DELETE | Map.SET
	        switch (type) {
	            case "add" /* ADD */:
	                if (!isArray(target)) {
	                    add(depsMap.get(ITERATE_KEY));
	                    if (isMap(target)) {
	                        add(depsMap.get(MAP_KEY_ITERATE_KEY));
	                    }
	                }
	                else if (isIntegerKey(key)) {
	                    // new index added to array -> length changes
	                    add(depsMap.get('length'));
	                }
	                break;
	            case "delete" /* DELETE */:
	                if (!isArray(target)) {
	                    add(depsMap.get(ITERATE_KEY));
	                    if (isMap(target)) {
	                        add(depsMap.get(MAP_KEY_ITERATE_KEY));
	                    }
	                }
	                break;
	            case "set" /* SET */:
	                if (isMap(target)) {
	                    add(depsMap.get(ITERATE_KEY));
	                }
	                break;
	        }
	    }
	    const run = (effect) => {
	        if ( effect.options.onTrigger) {
	            effect.options.onTrigger({
	                effect,
	                target,
	                key,
	                type,
	                newValue,
	                oldValue,
	                oldTarget
	            });
	        }
	        if (effect.options.scheduler) {
	            effect.options.scheduler(effect);
	        }
	        else {
	            effect();
	        }
	    };
	    effects.forEach(run);
	}

	const builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol)
	    .map(key => Symbol[key])
	    .filter(isSymbol));
	const get = /*#__PURE__*/ createGetter();
	const shallowGet = /*#__PURE__*/ createGetter(false, true);
	const readonlyGet = /*#__PURE__*/ createGetter(true);
	const shallowReadonlyGet = /*#__PURE__*/ createGetter(true, true);
	const arrayInstrumentations = {};
	['includes', 'indexOf', 'lastIndexOf'].forEach(key => {
	    const method = Array.prototype[key];
	    arrayInstrumentations[key] = function (...args) {
	        const arr = toRaw(this);
	        for (let i = 0, l = this.length; i < l; i++) {
	            track(arr, "get" /* GET */, i + '');
	        }
	        // we run the method using the original args first (which may be reactive)
	        const res = method.apply(arr, args);
	        if (res === -1 || res === false) {
	            // if that didn't work, run it again using raw values.
	            return method.apply(arr, args.map(toRaw));
	        }
	        else {
	            return res;
	        }
	    };
	});
	['push', 'pop', 'shift', 'unshift', 'splice'].forEach(key => {
	    const method = Array.prototype[key];
	    arrayInstrumentations[key] = function (...args) {
	        pauseTracking();
	        const res = method.apply(this, args);
	        resetTracking();
	        return res;
	    };
	});
	function createGetter(isReadonly = false, shallow = false) {
	    return function get(target, key, receiver) {
	        if (key === "__v_isReactive" /* IS_REACTIVE */) {
	            return !isReadonly;
	        }
	        else if (key === "__v_isReadonly" /* IS_READONLY */) {
	            return isReadonly;
	        }
	        else if (key === "__v_raw" /* RAW */ &&
	            receiver === (isReadonly ? readonlyMap : reactiveMap).get(target)) {
	            return target;
	        }
	        const targetIsArray = isArray(target);
	        if (!isReadonly && targetIsArray && hasOwn(arrayInstrumentations, key)) {
	            return Reflect.get(arrayInstrumentations, key, receiver);
	        }
	        const res = Reflect.get(target, key, receiver);
	        if (isSymbol(key)
	            ? builtInSymbols.has(key)
	            : key === `__proto__` || key === `__v_isRef`) {
	            return res;
	        }
	        if (!isReadonly) {
	            track(target, "get" /* GET */, key);
	        }
	        if (shallow) {
	            return res;
	        }
	        if (isRef(res)) {
	            // ref unwrapping - does not apply for Array + integer key.
	            const shouldUnwrap = !targetIsArray || !isIntegerKey(key);
	            return shouldUnwrap ? res.value : res;
	        }
	        if (isObject(res)) {
	            // Convert returned value into a proxy as well. we do the isObject check
	            // here to avoid invalid value warning. Also need to lazy access readonly
	            // and reactive here to avoid circular dependency.
	            return isReadonly ? readonly(res) : reactive(res);
	        }
	        return res;
	    };
	}
	const set = /*#__PURE__*/ createSetter();
	const shallowSet = /*#__PURE__*/ createSetter(true);
	function createSetter(shallow = false) {
	    return function set(target, key, value, receiver) {
	        const oldValue = target[key];
	        if (!shallow) {
	            value = toRaw(value);
	            if (!isArray(target) && isRef(oldValue) && !isRef(value)) {
	                oldValue.value = value;
	                return true;
	            }
	        }
	        const hadKey = isArray(target) && isIntegerKey(key)
	            ? Number(key) < target.length
	            : hasOwn(target, key);
	        const result = Reflect.set(target, key, value, receiver);
	        // don't trigger if target is something up in the prototype chain of original
	        if (target === toRaw(receiver)) {
	            if (!hadKey) {
	                trigger(target, "add" /* ADD */, key, value);
	            }
	            else if (hasChanged(value, oldValue)) {
	                trigger(target, "set" /* SET */, key, value, oldValue);
	            }
	        }
	        return result;
	    };
	}
	function deleteProperty(target, key) {
	    const hadKey = hasOwn(target, key);
	    const oldValue = target[key];
	    const result = Reflect.deleteProperty(target, key);
	    if (result && hadKey) {
	        trigger(target, "delete" /* DELETE */, key, undefined, oldValue);
	    }
	    return result;
	}
	function has(target, key) {
	    const result = Reflect.has(target, key);
	    if (!isSymbol(key) || !builtInSymbols.has(key)) {
	        track(target, "has" /* HAS */, key);
	    }
	    return result;
	}
	function ownKeys(target) {
	    track(target, "iterate" /* ITERATE */, isArray(target) ? 'length' : ITERATE_KEY);
	    return Reflect.ownKeys(target);
	}
	const mutableHandlers = {
	    get,
	    set,
	    deleteProperty,
	    has,
	    ownKeys
	};
	const readonlyHandlers = {
	    get: readonlyGet,
	    set(target, key) {
	        {
	            console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
	        }
	        return true;
	    },
	    deleteProperty(target, key) {
	        {
	            console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
	        }
	        return true;
	    }
	};
	const shallowReactiveHandlers = extend({}, mutableHandlers, {
	    get: shallowGet,
	    set: shallowSet
	});
	// Props handlers are special in the sense that it should not unwrap top-level
	// refs (in order to allow refs to be explicitly passed down), but should
	// retain the reactivity of the normal readonly object.
	const shallowReadonlyHandlers = extend({}, readonlyHandlers, {
	    get: shallowReadonlyGet
	});

	const toReactive = (value) => isObject(value) ? reactive(value) : value;
	const toReadonly = (value) => isObject(value) ? readonly(value) : value;
	const toShallow = (value) => value;
	const getProto = (v) => Reflect.getPrototypeOf(v);
	function get$1(target, key, isReadonly = false, isShallow = false) {
	    // #1772: readonly(reactive(Map)) should return readonly + reactive version
	    // of the value
	    target = target["__v_raw" /* RAW */];
	    const rawTarget = toRaw(target);
	    const rawKey = toRaw(key);
	    if (key !== rawKey) {
	        !isReadonly && track(rawTarget, "get" /* GET */, key);
	    }
	    !isReadonly && track(rawTarget, "get" /* GET */, rawKey);
	    const { has } = getProto(rawTarget);
	    const wrap = isReadonly ? toReadonly : isShallow ? toShallow : toReactive;
	    if (has.call(rawTarget, key)) {
	        return wrap(target.get(key));
	    }
	    else if (has.call(rawTarget, rawKey)) {
	        return wrap(target.get(rawKey));
	    }
	}
	function has$1(key, isReadonly = false) {
	    const target = this["__v_raw" /* RAW */];
	    const rawTarget = toRaw(target);
	    const rawKey = toRaw(key);
	    if (key !== rawKey) {
	        !isReadonly && track(rawTarget, "has" /* HAS */, key);
	    }
	    !isReadonly && track(rawTarget, "has" /* HAS */, rawKey);
	    return key === rawKey
	        ? target.has(key)
	        : target.has(key) || target.has(rawKey);
	}
	function size(target, isReadonly = false) {
	    target = target["__v_raw" /* RAW */];
	    !isReadonly && track(toRaw(target), "iterate" /* ITERATE */, ITERATE_KEY);
	    return Reflect.get(target, 'size', target);
	}
	function add(value) {
	    value = toRaw(value);
	    const target = toRaw(this);
	    const proto = getProto(target);
	    const hadKey = proto.has.call(target, value);
	    target.add(value);
	    if (!hadKey) {
	        trigger(target, "add" /* ADD */, value, value);
	    }
	    return this;
	}
	function set$1(key, value) {
	    value = toRaw(value);
	    const target = toRaw(this);
	    const { has, get } = getProto(target);
	    let hadKey = has.call(target, key);
	    if (!hadKey) {
	        key = toRaw(key);
	        hadKey = has.call(target, key);
	    }
	    else {
	        checkIdentityKeys(target, has, key);
	    }
	    const oldValue = get.call(target, key);
	    target.set(key, value);
	    if (!hadKey) {
	        trigger(target, "add" /* ADD */, key, value);
	    }
	    else if (hasChanged(value, oldValue)) {
	        trigger(target, "set" /* SET */, key, value, oldValue);
	    }
	    return this;
	}
	function deleteEntry(key) {
	    const target = toRaw(this);
	    const { has, get } = getProto(target);
	    let hadKey = has.call(target, key);
	    if (!hadKey) {
	        key = toRaw(key);
	        hadKey = has.call(target, key);
	    }
	    else {
	        checkIdentityKeys(target, has, key);
	    }
	    const oldValue = get ? get.call(target, key) : undefined;
	    // forward the operation before queueing reactions
	    const result = target.delete(key);
	    if (hadKey) {
	        trigger(target, "delete" /* DELETE */, key, undefined, oldValue);
	    }
	    return result;
	}
	function clear() {
	    const target = toRaw(this);
	    const hadItems = target.size !== 0;
	    const oldTarget =  isMap(target)
	            ? new Map(target)
	            : new Set(target)
	        ;
	    // forward the operation before queueing reactions
	    const result = target.clear();
	    if (hadItems) {
	        trigger(target, "clear" /* CLEAR */, undefined, undefined, oldTarget);
	    }
	    return result;
	}
	function createForEach(isReadonly, isShallow) {
	    return function forEach(callback, thisArg) {
	        const observed = this;
	        const target = observed["__v_raw" /* RAW */];
	        const rawTarget = toRaw(target);
	        const wrap = isReadonly ? toReadonly : isShallow ? toShallow : toReactive;
	        !isReadonly && track(rawTarget, "iterate" /* ITERATE */, ITERATE_KEY);
	        return target.forEach((value, key) => {
	            // important: make sure the callback is
	            // 1. invoked with the reactive map as `this` and 3rd arg
	            // 2. the value received should be a corresponding reactive/readonly.
	            return callback.call(thisArg, wrap(value), wrap(key), observed);
	        });
	    };
	}
	function createIterableMethod(method, isReadonly, isShallow) {
	    return function (...args) {
	        const target = this["__v_raw" /* RAW */];
	        const rawTarget = toRaw(target);
	        const targetIsMap = isMap(rawTarget);
	        const isPair = method === 'entries' || (method === Symbol.iterator && targetIsMap);
	        const isKeyOnly = method === 'keys' && targetIsMap;
	        const innerIterator = target[method](...args);
	        const wrap = isReadonly ? toReadonly : isShallow ? toShallow : toReactive;
	        !isReadonly &&
	            track(rawTarget, "iterate" /* ITERATE */, isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
	        // return a wrapped iterator which returns observed versions of the
	        // values emitted from the real iterator
	        return {
	            // iterator protocol
	            next() {
	                const { value, done } = innerIterator.next();
	                return done
	                    ? { value, done }
	                    : {
	                        value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
	                        done
	                    };
	            },
	            // iterable protocol
	            [Symbol.iterator]() {
	                return this;
	            }
	        };
	    };
	}
	function createReadonlyMethod(type) {
	    return function (...args) {
	        {
	            const key = args[0] ? `on key "${args[0]}" ` : ``;
	            console.warn(`${capitalize(type)} operation ${key}failed: target is readonly.`, toRaw(this));
	        }
	        return type === "delete" /* DELETE */ ? false : this;
	    };
	}
	const mutableInstrumentations = {
	    get(key) {
	        return get$1(this, key);
	    },
	    get size() {
	        return size(this);
	    },
	    has: has$1,
	    add,
	    set: set$1,
	    delete: deleteEntry,
	    clear,
	    forEach: createForEach(false, false)
	};
	const shallowInstrumentations = {
	    get(key) {
	        return get$1(this, key, false, true);
	    },
	    get size() {
	        return size(this);
	    },
	    has: has$1,
	    add,
	    set: set$1,
	    delete: deleteEntry,
	    clear,
	    forEach: createForEach(false, true)
	};
	const readonlyInstrumentations = {
	    get(key) {
	        return get$1(this, key, true);
	    },
	    get size() {
	        return size(this, true);
	    },
	    has(key) {
	        return has$1.call(this, key, true);
	    },
	    add: createReadonlyMethod("add" /* ADD */),
	    set: createReadonlyMethod("set" /* SET */),
	    delete: createReadonlyMethod("delete" /* DELETE */),
	    clear: createReadonlyMethod("clear" /* CLEAR */),
	    forEach: createForEach(true, false)
	};
	const iteratorMethods = ['keys', 'values', 'entries', Symbol.iterator];
	iteratorMethods.forEach(method => {
	    mutableInstrumentations[method] = createIterableMethod(method, false, false);
	    readonlyInstrumentations[method] = createIterableMethod(method, true, false);
	    shallowInstrumentations[method] = createIterableMethod(method, false, true);
	});
	function createInstrumentationGetter(isReadonly, shallow) {
	    const instrumentations = shallow
	        ? shallowInstrumentations
	        : isReadonly
	            ? readonlyInstrumentations
	            : mutableInstrumentations;
	    return (target, key, receiver) => {
	        if (key === "__v_isReactive" /* IS_REACTIVE */) {
	            return !isReadonly;
	        }
	        else if (key === "__v_isReadonly" /* IS_READONLY */) {
	            return isReadonly;
	        }
	        else if (key === "__v_raw" /* RAW */) {
	            return target;
	        }
	        return Reflect.get(hasOwn(instrumentations, key) && key in target
	            ? instrumentations
	            : target, key, receiver);
	    };
	}
	const mutableCollectionHandlers = {
	    get: createInstrumentationGetter(false, false)
	};
	const shallowCollectionHandlers = {
	    get: createInstrumentationGetter(false, true)
	};
	const readonlyCollectionHandlers = {
	    get: createInstrumentationGetter(true, false)
	};
	function checkIdentityKeys(target, has, key) {
	    const rawKey = toRaw(key);
	    if (rawKey !== key && has.call(target, rawKey)) {
	        const type = toRawType(target);
	        console.warn(`Reactive ${type} contains both the raw and reactive ` +
	            `versions of the same object${type === `Map` ? ` as keys` : ``}, ` +
	            `which can lead to inconsistencies. ` +
	            `Avoid differentiating between the raw and reactive versions ` +
	            `of an object and only use the reactive version if possible.`);
	    }
	}

	const reactiveMap = new WeakMap();
	const readonlyMap = new WeakMap();
	function targetTypeMap(rawType) {
	    switch (rawType) {
	        case 'Object':
	        case 'Array':
	            return 1 /* COMMON */;
	        case 'Map':
	        case 'Set':
	        case 'WeakMap':
	        case 'WeakSet':
	            return 2 /* COLLECTION */;
	        default:
	            return 0 /* INVALID */;
	    }
	}
	function getTargetType(value) {
	    return value["__v_skip" /* SKIP */] || !Object.isExtensible(value)
	        ? 0 /* INVALID */
	        : targetTypeMap(toRawType(value));
	}
	function reactive(target) {
	    // if trying to observe a readonly proxy, return the readonly version.
	    if (target && target["__v_isReadonly" /* IS_READONLY */]) {
	        return target;
	    }
	    return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers);
	}
	/**
	 * Return a shallowly-reactive copy of the original object, where only the root
	 * level properties are reactive. It also does not auto-unwrap refs (even at the
	 * root level).
	 */
	function shallowReactive(target) {
	    return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers);
	}
	/**
	 * Creates a readonly copy of the original object. Note the returned copy is not
	 * made reactive, but `readonly` can be called on an already reactive object.
	 */
	function readonly(target) {
	    return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers);
	}
	/**
	 * Returns a reactive-copy of the original object, where only the root level
	 * properties are readonly, and does NOT unwrap refs nor recursively convert
	 * returned properties.
	 * This is used for creating the props proxy object for stateful components.
	 */
	function shallowReadonly(target) {
	    return createReactiveObject(target, true, shallowReadonlyHandlers, readonlyCollectionHandlers);
	}
	function createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers) {
	    if (!isObject(target)) {
	        {
	            console.warn(`value cannot be made reactive: ${String(target)}`);
	        }
	        return target;
	    }
	    // target is already a Proxy, return it.
	    // exception: calling readonly() on a reactive object
	    if (target["__v_raw" /* RAW */] &&
	        !(isReadonly && target["__v_isReactive" /* IS_REACTIVE */])) {
	        return target;
	    }
	    // target already has corresponding Proxy
	    const proxyMap = isReadonly ? readonlyMap : reactiveMap;
	    const existingProxy = proxyMap.get(target);
	    if (existingProxy) {
	        return existingProxy;
	    }
	    // only a whitelist of value types can be observed.
	    const targetType = getTargetType(target);
	    if (targetType === 0 /* INVALID */) {
	        return target;
	    }
	    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */ ? collectionHandlers : baseHandlers);
	    proxyMap.set(target, proxy);
	    return proxy;
	}
	function isReactive(value) {
	    if (isReadonly(value)) {
	        return isReactive(value["__v_raw" /* RAW */]);
	    }
	    return !!(value && value["__v_isReactive" /* IS_REACTIVE */]);
	}
	function isReadonly(value) {
	    return !!(value && value["__v_isReadonly" /* IS_READONLY */]);
	}
	function isProxy(value) {
	    return isReactive(value) || isReadonly(value);
	}
	function toRaw(observed) {
	    return ((observed && toRaw(observed["__v_raw" /* RAW */])) || observed);
	}
	function markRaw(value) {
	    def(value, "__v_skip" /* SKIP */, true);
	    return value;
	}

	const convert = (val) => isObject(val) ? reactive(val) : val;
	function isRef(r) {
	    return Boolean(r && r.__v_isRef === true);
	}
	function ref(value) {
	    return createRef(value);
	}
	function shallowRef(value) {
	    return createRef(value, true);
	}
	class RefImpl {
	    constructor(_rawValue, _shallow = false) {
	        this._rawValue = _rawValue;
	        this._shallow = _shallow;
	        this.__v_isRef = true;
	        this._value = _shallow ? _rawValue : convert(_rawValue);
	    }
	    get value() {
	        track(toRaw(this), "get" /* GET */, 'value');
	        return this._value;
	    }
	    set value(newVal) {
	        if (hasChanged(toRaw(newVal), this._rawValue)) {
	            this._rawValue = newVal;
	            this._value = this._shallow ? newVal : convert(newVal);
	            trigger(toRaw(this), "set" /* SET */, 'value', newVal);
	        }
	    }
	}
	function createRef(rawValue, shallow = false) {
	    if (isRef(rawValue)) {
	        return rawValue;
	    }
	    return new RefImpl(rawValue, shallow);
	}
	function triggerRef(ref) {
	    trigger(toRaw(ref), "set" /* SET */, 'value',  ref.value );
	}
	function unref(ref) {
	    return isRef(ref) ? ref.value : ref;
	}
	const shallowUnwrapHandlers = {
	    get: (target, key, receiver) => unref(Reflect.get(target, key, receiver)),
	    set: (target, key, value, receiver) => {
	        const oldValue = target[key];
	        if (isRef(oldValue) && !isRef(value)) {
	            oldValue.value = value;
	            return true;
	        }
	        else {
	            return Reflect.set(target, key, value, receiver);
	        }
	    }
	};
	function proxyRefs(objectWithRefs) {
	    return isReactive(objectWithRefs)
	        ? objectWithRefs
	        : new Proxy(objectWithRefs, shallowUnwrapHandlers);
	}
	class CustomRefImpl {
	    constructor(factory) {
	        this.__v_isRef = true;
	        const { get, set } = factory(() => track(this, "get" /* GET */, 'value'), () => trigger(this, "set" /* SET */, 'value'));
	        this._get = get;
	        this._set = set;
	    }
	    get value() {
	        return this._get();
	    }
	    set value(newVal) {
	        this._set(newVal);
	    }
	}
	function customRef(factory) {
	    return new CustomRefImpl(factory);
	}
	function toRefs(object) {
	    if ( !isProxy(object)) {
	        console.warn(`toRefs() expects a reactive object but received a plain one.`);
	    }
	    const ret = isArray(object) ? new Array(object.length) : {};
	    for (const key in object) {
	        ret[key] = toRef(object, key);
	    }
	    return ret;
	}
	class ObjectRefImpl {
	    constructor(_object, _key) {
	        this._object = _object;
	        this._key = _key;
	        this.__v_isRef = true;
	    }
	    get value() {
	        return this._object[this._key];
	    }
	    set value(newVal) {
	        this._object[this._key] = newVal;
	    }
	}
	function toRef(object, key) {
	    return isRef(object[key])
	        ? object[key]
	        : new ObjectRefImpl(object, key);
	}

	class ComputedRefImpl {
	    constructor(getter, _setter, isReadonly) {
	        this._setter = _setter;
	        this._dirty = true;
	        this.__v_isRef = true;
	        this.effect = effect(getter, {
	            lazy: true,
	            scheduler: () => {
	                if (!this._dirty) {
	                    this._dirty = true;
	                    trigger(toRaw(this), "set" /* SET */, 'value');
	                }
	            }
	        });
	        this["__v_isReadonly" /* IS_READONLY */] = isReadonly;
	    }
	    get value() {
	        if (this._dirty) {
	            this._value = this.effect();
	            this._dirty = false;
	        }
	        track(toRaw(this), "get" /* GET */, 'value');
	        return this._value;
	    }
	    set value(newValue) {
	        this._setter(newValue);
	    }
	}
	function computed(getterOrOptions) {
	    let getter;
	    let setter;
	    if (isFunction(getterOrOptions)) {
	        getter = getterOrOptions;
	        setter =  () => {
	                console.warn('Write operation failed: computed value is readonly');
	            }
	            ;
	    }
	    else {
	        getter = getterOrOptions.get;
	        setter = getterOrOptions.set;
	    }
	    return new ComputedRefImpl(getter, setter, isFunction(getterOrOptions) || !getterOrOptions.set);
	}

	const stack = [];
	function pushWarningContext(vnode) {
	    stack.push(vnode);
	}
	function popWarningContext() {
	    stack.pop();
	}
	function warn(msg, ...args) {
	    // avoid props formatting or warn handler tracking deps that might be mutated
	    // during patch, leading to infinite recursion.
	    pauseTracking();
	    const instance = stack.length ? stack[stack.length - 1].component : null;
	    const appWarnHandler = instance && instance.appContext.config.warnHandler;
	    const trace = getComponentTrace();
	    if (appWarnHandler) {
	        callWithErrorHandling(appWarnHandler, instance, 11 /* APP_WARN_HANDLER */, [
	            msg + args.join(''),
	            instance && instance.proxy,
	            trace
	                .map(({ vnode }) => `at <${formatComponentName(instance, vnode.type)}>`)
	                .join('\n'),
	            trace
	        ]);
	    }
	    else {
	        const warnArgs = [`[Vue warn]: ${msg}`, ...args];
	        /* istanbul ignore if */
	        if (trace.length &&
	            // avoid spamming console during tests
	            !false) {
	            warnArgs.push(`\n`, ...formatTrace(trace));
	        }
	        console.warn(...warnArgs);
	    }
	    resetTracking();
	}
	function getComponentTrace() {
	    let currentVNode = stack[stack.length - 1];
	    if (!currentVNode) {
	        return [];
	    }
	    // we can't just use the stack because it will be incomplete during updates
	    // that did not start from the root. Re-construct the parent chain using
	    // instance parent pointers.
	    const normalizedStack = [];
	    while (currentVNode) {
	        const last = normalizedStack[0];
	        if (last && last.vnode === currentVNode) {
	            last.recurseCount++;
	        }
	        else {
	            normalizedStack.push({
	                vnode: currentVNode,
	                recurseCount: 0
	            });
	        }
	        const parentInstance = currentVNode.component && currentVNode.component.parent;
	        currentVNode = parentInstance && parentInstance.vnode;
	    }
	    return normalizedStack;
	}
	/* istanbul ignore next */
	function formatTrace(trace) {
	    const logs = [];
	    trace.forEach((entry, i) => {
	        logs.push(...(i === 0 ? [] : [`\n`]), ...formatTraceEntry(entry));
	    });
	    return logs;
	}
	function formatTraceEntry({ vnode, recurseCount }) {
	    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
	    const isRoot = vnode.component ? vnode.component.parent == null : false;
	    const open = ` at <${formatComponentName(vnode.component, vnode.type, isRoot)}`;
	    const close = `>` + postfix;
	    return vnode.props
	        ? [open, ...formatProps(vnode.props), close]
	        : [open + close];
	}
	/* istanbul ignore next */
	function formatProps(props) {
	    const res = [];
	    const keys = Object.keys(props);
	    keys.slice(0, 3).forEach(key => {
	        res.push(...formatProp(key, props[key]));
	    });
	    if (keys.length > 3) {
	        res.push(` ...`);
	    }
	    return res;
	}
	/* istanbul ignore next */
	function formatProp(key, value, raw) {
	    if (isString(value)) {
	        value = JSON.stringify(value);
	        return raw ? value : [`${key}=${value}`];
	    }
	    else if (typeof value === 'number' ||
	        typeof value === 'boolean' ||
	        value == null) {
	        return raw ? value : [`${key}=${value}`];
	    }
	    else if (isRef(value)) {
	        value = formatProp(key, toRaw(value.value), true);
	        return raw ? value : [`${key}=Ref<`, value, `>`];
	    }
	    else if (isFunction(value)) {
	        return [`${key}=fn${value.name ? `<${value.name}>` : ``}`];
	    }
	    else {
	        value = toRaw(value);
	        return raw ? value : [`${key}=`, value];
	    }
	}

	const ErrorTypeStrings = {
	    ["bc" /* BEFORE_CREATE */]: 'beforeCreate hook',
	    ["c" /* CREATED */]: 'created hook',
	    ["bm" /* BEFORE_MOUNT */]: 'beforeMount hook',
	    ["m" /* MOUNTED */]: 'mounted hook',
	    ["bu" /* BEFORE_UPDATE */]: 'beforeUpdate hook',
	    ["u" /* UPDATED */]: 'updated',
	    ["bum" /* BEFORE_UNMOUNT */]: 'beforeUnmount hook',
	    ["um" /* UNMOUNTED */]: 'unmounted hook',
	    ["a" /* ACTIVATED */]: 'activated hook',
	    ["da" /* DEACTIVATED */]: 'deactivated hook',
	    ["ec" /* ERROR_CAPTURED */]: 'errorCaptured hook',
	    ["rtc" /* RENDER_TRACKED */]: 'renderTracked hook',
	    ["rtg" /* RENDER_TRIGGERED */]: 'renderTriggered hook',
	    [0 /* SETUP_FUNCTION */]: 'setup function',
	    [1 /* RENDER_FUNCTION */]: 'render function',
	    [2 /* WATCH_GETTER */]: 'watcher getter',
	    [3 /* WATCH_CALLBACK */]: 'watcher callback',
	    [4 /* WATCH_CLEANUP */]: 'watcher cleanup function',
	    [5 /* NATIVE_EVENT_HANDLER */]: 'native event handler',
	    [6 /* COMPONENT_EVENT_HANDLER */]: 'component event handler',
	    [7 /* VNODE_HOOK */]: 'vnode hook',
	    [8 /* DIRECTIVE_HOOK */]: 'directive hook',
	    [9 /* TRANSITION_HOOK */]: 'transition hook',
	    [10 /* APP_ERROR_HANDLER */]: 'app errorHandler',
	    [11 /* APP_WARN_HANDLER */]: 'app warnHandler',
	    [12 /* FUNCTION_REF */]: 'ref function',
	    [13 /* ASYNC_COMPONENT_LOADER */]: 'async component loader',
	    [14 /* SCHEDULER */]: 'scheduler flush. This is likely a Vue internals bug. ' +
	        'Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/vue-next'
	};
	function callWithErrorHandling(fn, instance, type, args) {
	    let res;
	    try {
	        res = args ? fn(...args) : fn();
	    }
	    catch (err) {
	        handleError(err, instance, type);
	    }
	    return res;
	}
	function callWithAsyncErrorHandling(fn, instance, type, args) {
	    if (isFunction(fn)) {
	        const res = callWithErrorHandling(fn, instance, type, args);
	        if (res && isPromise(res)) {
	            res.catch(err => {
	                handleError(err, instance, type);
	            });
	        }
	        return res;
	    }
	    const values = [];
	    for (let i = 0; i < fn.length; i++) {
	        values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
	    }
	    return values;
	}
	function handleError(err, instance, type, throwInDev = true) {
	    const contextVNode = instance ? instance.vnode : null;
	    if (instance) {
	        let cur = instance.parent;
	        // the exposed instance is the render proxy to keep it consistent with 2.x
	        const exposedInstance = instance.proxy;
	        // in production the hook receives only the error code
	        const errorInfo =  ErrorTypeStrings[type] ;
	        while (cur) {
	            const errorCapturedHooks = cur.ec;
	            if (errorCapturedHooks) {
	                for (let i = 0; i < errorCapturedHooks.length; i++) {
	                    if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) {
	                        return;
	                    }
	                }
	            }
	            cur = cur.parent;
	        }
	        // app-level handling
	        const appErrorHandler = instance.appContext.config.errorHandler;
	        if (appErrorHandler) {
	            callWithErrorHandling(appErrorHandler, null, 10 /* APP_ERROR_HANDLER */, [err, exposedInstance, errorInfo]);
	            return;
	        }
	    }
	    logError(err, type, contextVNode, throwInDev);
	}
	function logError(err, type, contextVNode, throwInDev = true) {
	    {
	        const info = ErrorTypeStrings[type];
	        if (contextVNode) {
	            pushWarningContext(contextVNode);
	        }
	        warn(`Unhandled error${info ? ` during execution of ${info}` : ``}`);
	        if (contextVNode) {
	            popWarningContext();
	        }
	        // crash in dev by default so it's more noticeable
	        if (throwInDev) {
	            throw err;
	        }
	        else {
	            console.error(err);
	        }
	    }
	}

	let isFlushing = false;
	let isFlushPending = false;
	const queue = [];
	let flushIndex = 0;
	const pendingPreFlushCbs = [];
	let activePreFlushCbs = null;
	let preFlushIndex = 0;
	const pendingPostFlushCbs = [];
	let activePostFlushCbs = null;
	let postFlushIndex = 0;
	const resolvedPromise = Promise.resolve();
	let currentFlushPromise = null;
	let currentPreFlushParentJob = null;
	const RECURSION_LIMIT = 100;
	function nextTick(fn) {
	    const p = currentFlushPromise || resolvedPromise;
	    return fn ? p.then(this ? fn.bind(this) : fn) : p;
	}
	function queueJob(job) {
	    // the dedupe search uses the startIndex argument of Array.includes()
	    // by default the search index includes the current job that is being run
	    // so it cannot recursively trigger itself again.
	    // if the job is a watch() callback, the search will start with a +1 index to
	    // allow it recursively trigger itself - it is the user's responsibility to
	    // ensure it doesn't end up in an infinite loop.
	    if ((!queue.length ||
	        !queue.includes(job, isFlushing && job.allowRecurse ? flushIndex + 1 : flushIndex)) &&
	        job !== currentPreFlushParentJob) {
	        queue.push(job);
	        queueFlush();
	    }
	}
	function queueFlush() {
	    if (!isFlushing && !isFlushPending) {
	        isFlushPending = true;
	        currentFlushPromise = resolvedPromise.then(flushJobs);
	    }
	}
	function invalidateJob(job) {
	    const i = queue.indexOf(job);
	    if (i > -1) {
	        queue.splice(i, 1);
	    }
	}
	function queueCb(cb, activeQueue, pendingQueue, index) {
	    if (!isArray(cb)) {
	        if (!activeQueue ||
	            !activeQueue.includes(cb, cb.allowRecurse ? index + 1 : index)) {
	            pendingQueue.push(cb);
	        }
	    }
	    else {
	        // if cb is an array, it is a component lifecycle hook which can only be
	        // triggered by a job, which is already deduped in the main queue, so
	        // we can skip duplicate check here to improve perf
	        pendingQueue.push(...cb);
	    }
	    queueFlush();
	}
	function queuePreFlushCb(cb) {
	    queueCb(cb, activePreFlushCbs, pendingPreFlushCbs, preFlushIndex);
	}
	function queuePostFlushCb(cb) {
	    queueCb(cb, activePostFlushCbs, pendingPostFlushCbs, postFlushIndex);
	}
	function flushPreFlushCbs(seen, parentJob = null) {
	    if (pendingPreFlushCbs.length) {
	        currentPreFlushParentJob = parentJob;
	        activePreFlushCbs = [...new Set(pendingPreFlushCbs)];
	        pendingPreFlushCbs.length = 0;
	        {
	            seen = seen || new Map();
	        }
	        for (preFlushIndex = 0; preFlushIndex < activePreFlushCbs.length; preFlushIndex++) {
	            {
	                checkRecursiveUpdates(seen, activePreFlushCbs[preFlushIndex]);
	            }
	            activePreFlushCbs[preFlushIndex]();
	        }
	        activePreFlushCbs = null;
	        preFlushIndex = 0;
	        currentPreFlushParentJob = null;
	        // recursively flush until it drains
	        flushPreFlushCbs(seen, parentJob);
	    }
	}
	function flushPostFlushCbs(seen) {
	    if (pendingPostFlushCbs.length) {
	        const deduped = [...new Set(pendingPostFlushCbs)];
	        pendingPostFlushCbs.length = 0;
	        // #1947 already has active queue, nested flushPostFlushCbs call
	        if (activePostFlushCbs) {
	            activePostFlushCbs.push(...deduped);
	            return;
	        }
	        activePostFlushCbs = deduped;
	        {
	            seen = seen || new Map();
	        }
	        activePostFlushCbs.sort((a, b) => getId(a) - getId(b));
	        for (postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
	            {
	                checkRecursiveUpdates(seen, activePostFlushCbs[postFlushIndex]);
	            }
	            activePostFlushCbs[postFlushIndex]();
	        }
	        activePostFlushCbs = null;
	        postFlushIndex = 0;
	    }
	}
	const getId = (job) => job.id == null ? Infinity : job.id;
	function flushJobs(seen) {
	    isFlushPending = false;
	    isFlushing = true;
	    {
	        seen = seen || new Map();
	    }
	    flushPreFlushCbs(seen);
	    // Sort queue before flush.
	    // This ensures that:
	    // 1. Components are updated from parent to child. (because parent is always
	    //    created before the child so its render effect will have smaller
	    //    priority number)
	    // 2. If a component is unmounted during a parent component's update,
	    //    its update can be skipped.
	    queue.sort((a, b) => getId(a) - getId(b));
	    try {
	        for (flushIndex = 0; flushIndex < queue.length; flushIndex++) {
	            const job = queue[flushIndex];
	            if (job) {
	                if (("development" !== 'production')) {
	                    checkRecursiveUpdates(seen, job);
	                }
	                callWithErrorHandling(job, null, 14 /* SCHEDULER */);
	            }
	        }
	    }
	    finally {
	        flushIndex = 0;
	        queue.length = 0;
	        flushPostFlushCbs(seen);
	        isFlushing = false;
	        currentFlushPromise = null;
	        // some postFlushCb queued jobs!
	        // keep flushing until it drains.
	        if (queue.length || pendingPostFlushCbs.length) {
	            flushJobs(seen);
	        }
	    }
	}
	function checkRecursiveUpdates(seen, fn) {
	    if (!seen.has(fn)) {
	        seen.set(fn, 1);
	    }
	    else {
	        const count = seen.get(fn);
	        if (count > RECURSION_LIMIT) {
	            throw new Error(`Maximum recursive updates exceeded. ` +
	                `This means you have a reactive effect that is mutating its own ` +
	                `dependencies and thus recursively triggering itself. Possible sources ` +
	                `include component template, render function, updated hook or ` +
	                `watcher source function.`);
	        }
	        else {
	            seen.set(fn, count + 1);
	        }
	    }
	}

	/* eslint-disable no-restricted-globals */
	let isHmrUpdating = false;
	const hmrDirtyComponents = new Set();
	// Expose the HMR runtime on the global object
	// This makes it entirely tree-shakable without polluting the exports and makes
	// it easier to be used in toolings like vue-loader
	// Note: for a component to be eligible for HMR it also needs the __hmrId option
	// to be set so that its instances can be registered / removed.
	{
	    const globalObject = typeof global !== 'undefined'
	        ? global
	        : typeof self !== 'undefined'
	            ? self
	            : typeof window !== 'undefined'
	                ? window
	                : {};
	    globalObject.__VUE_HMR_RUNTIME__ = {
	        createRecord: tryWrap(createRecord),
	        rerender: tryWrap(rerender),
	        reload: tryWrap(reload)
	    };
	}
	const map = new Map();
	function registerHMR(instance) {
	    const id = instance.type.__hmrId;
	    let record = map.get(id);
	    if (!record) {
	        createRecord(id, instance.type);
	        record = map.get(id);
	    }
	    record.instances.add(instance);
	}
	function unregisterHMR(instance) {
	    map.get(instance.type.__hmrId).instances.delete(instance);
	}
	function createRecord(id, component) {
	    if (!component) {
	        warn(`HMR API usage is out of date.\n` +
	            `Please upgrade vue-loader/vite/rollup-plugin-vue or other relevant ` +
	            `depdendency that handles Vue SFC compilation.`);
	        component = {};
	    }
	    if (map.has(id)) {
	        return false;
	    }
	    map.set(id, {
	        component: isClassComponent(component) ? component.__vccOpts : component,
	        instances: new Set()
	    });
	    return true;
	}
	function rerender(id, newRender) {
	    const record = map.get(id);
	    if (!record)
	        return;
	    if (newRender)
	        record.component.render = newRender;
	    // Array.from creates a snapshot which avoids the set being mutated during
	    // updates
	    Array.from(record.instances).forEach(instance => {
	        if (newRender) {
	            instance.render = newRender;
	        }
	        instance.renderCache = [];
	        // this flag forces child components with slot content to update
	        isHmrUpdating = true;
	        instance.update();
	        isHmrUpdating = false;
	    });
	}
	function reload(id, newComp) {
	    const record = map.get(id);
	    if (!record)
	        return;
	    // Array.from creates a snapshot which avoids the set being mutated during
	    // updates
	    const { component, instances } = record;
	    if (!hmrDirtyComponents.has(component)) {
	        // 1. Update existing comp definition to match new one
	        newComp = isClassComponent(newComp) ? newComp.__vccOpts : newComp;
	        extend(component, newComp);
	        for (const key in component) {
	            if (!(key in newComp)) {
	                delete component[key];
	            }
	        }
	        // 2. Mark component dirty. This forces the renderer to replace the component
	        // on patch.
	        hmrDirtyComponents.add(component);
	        // 3. Make sure to unmark the component after the reload.
	        queuePostFlushCb(() => {
	            hmrDirtyComponents.delete(component);
	        });
	    }
	    Array.from(instances).forEach(instance => {
	        if (instance.parent) {
	            // 4. Force the parent instance to re-render. This will cause all updated
	            // components to be unmounted and re-mounted. Queue the update so that we
	            // don't end up forcing the same parent to re-render multiple times.
	            queueJob(instance.parent.update);
	        }
	        else if (instance.appContext.reload) {
	            // root instance mounted via createApp() has a reload method
	            instance.appContext.reload();
	        }
	        else if (typeof window !== 'undefined') {
	            // root instance inside tree created via raw render(). Force reload.
	            window.location.reload();
	        }
	        else {
	            console.warn('[HMR] Root or manually mounted instance modified. Full reload required.');
	        }
	    });
	}
	function tryWrap(fn) {
	    return (id, arg) => {
	        try {
	            return fn(id, arg);
	        }
	        catch (e) {
	            console.error(e);
	            console.warn(`[HMR] Something went wrong during Vue component hot-reload. ` +
	                `Full reload required.`);
	        }
	    };
	}

	let devtools;
	function setDevtoolsHook(hook) {
	    devtools = hook;
	}
	function devtoolsInitApp(app, version) {
	    // TODO queue if devtools is undefined
	    if (!devtools)
	        return;
	    devtools.emit("app:init" /* APP_INIT */, app, version, {
	        Fragment,
	        Text,
	        Comment,
	        Static
	    });
	}
	function devtoolsUnmountApp(app) {
	    if (!devtools)
	        return;
	    devtools.emit("app:unmount" /* APP_UNMOUNT */, app);
	}
	const devtoolsComponentAdded = /*#__PURE__*/ createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */);
	const devtoolsComponentUpdated = /*#__PURE__*/ createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */);
	const devtoolsComponentRemoved = /*#__PURE__*/ createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */);
	function createDevtoolsComponentHook(hook) {
	    return (component) => {
	        if (!devtools)
	            return;
	        devtools.emit(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : undefined, component);
	    };
	}
	function devtoolsComponentEmit(component, event, params) {
	    if (!devtools)
	        return;
	    devtools.emit("component:emit" /* COMPONENT_EMIT */, component.appContext.app, component, event, params);
	}

	function emit(instance, event, ...rawArgs) {
	    const props = instance.vnode.props || EMPTY_OBJ;
	    {
	        const { emitsOptions, propsOptions: [propsOptions] } = instance;
	        if (emitsOptions) {
	            if (!(event in emitsOptions)) {
	                if (!propsOptions || !(toHandlerKey(event) in propsOptions)) {
	                    warn(`Component emitted event "${event}" but it is neither declared in ` +
	                        `the emits option nor as an "${toHandlerKey(event)}" prop.`);
	                }
	            }
	            else {
	                const validator = emitsOptions[event];
	                if (isFunction(validator)) {
	                    const isValid = validator(...rawArgs);
	                    if (!isValid) {
	                        warn(`Invalid event arguments: event validation failed for event "${event}".`);
	                    }
	                }
	            }
	        }
	    }
	    let args = rawArgs;
	    const isModelListener = event.startsWith('update:');
	    // for v-model update:xxx events, apply modifiers on args
	    const modelArg = isModelListener && event.slice(7);
	    if (modelArg && modelArg in props) {
	        const modifiersKey = `${modelArg === 'modelValue' ? 'model' : modelArg}Modifiers`;
	        const { number, trim } = props[modifiersKey] || EMPTY_OBJ;
	        if (trim) {
	            args = rawArgs.map(a => a.trim());
	        }
	        else if (number) {
	            args = rawArgs.map(toNumber);
	        }
	    }
	    {
	        devtoolsComponentEmit(instance, event, args);
	    }
	    {
	        const lowerCaseEvent = event.toLowerCase();
	        if (lowerCaseEvent !== event && props[toHandlerKey(lowerCaseEvent)]) {
	            warn(`Event "${lowerCaseEvent}" is emitted in component ` +
	                `${formatComponentName(instance, instance.type)} but the handler is registered for "${event}". ` +
	                `Note that HTML attributes are case-insensitive and you cannot use ` +
	                `v-on to listen to camelCase events when using in-DOM templates. ` +
	                `You should probably use "${hyphenate(event)}" instead of "${event}".`);
	        }
	    }
	    // convert handler name to camelCase. See issue #2249
	    let handlerName = toHandlerKey(camelize(event));
	    let handler = props[handlerName];
	    // for v-model update:xxx events, also trigger kebab-case equivalent
	    // for props passed via kebab-case
	    if (!handler && isModelListener) {
	        handlerName = toHandlerKey(hyphenate(event));
	        handler = props[handlerName];
	    }
	    if (handler) {
	        callWithAsyncErrorHandling(handler, instance, 6 /* COMPONENT_EVENT_HANDLER */, args);
	    }
	    const onceHandler = props[handlerName + `Once`];
	    if (onceHandler) {
	        if (!instance.emitted) {
	            (instance.emitted = {})[handlerName] = true;
	        }
	        else if (instance.emitted[handlerName]) {
	            return;
	        }
	        callWithAsyncErrorHandling(onceHandler, instance, 6 /* COMPONENT_EVENT_HANDLER */, args);
	    }
	}
	function normalizeEmitsOptions(comp, appContext, asMixin = false) {
	    if (!appContext.deopt && comp.__emits !== undefined) {
	        return comp.__emits;
	    }
	    const raw = comp.emits;
	    let normalized = {};
	    // apply mixin/extends props
	    let hasExtends = false;
	    if ( !isFunction(comp)) {
	        const extendEmits = (raw) => {
	            hasExtends = true;
	            extend(normalized, normalizeEmitsOptions(raw, appContext, true));
	        };
	        if (!asMixin && appContext.mixins.length) {
	            appContext.mixins.forEach(extendEmits);
	        }
	        if (comp.extends) {
	            extendEmits(comp.extends);
	        }
	        if (comp.mixins) {
	            comp.mixins.forEach(extendEmits);
	        }
	    }
	    if (!raw && !hasExtends) {
	        return (comp.__emits = null);
	    }
	    if (isArray(raw)) {
	        raw.forEach(key => (normalized[key] = null));
	    }
	    else {
	        extend(normalized, raw);
	    }
	    return (comp.__emits = normalized);
	}
	// Check if an incoming prop key is a declared emit event listener.
	// e.g. With `emits: { click: null }`, props named `onClick` and `onclick` are
	// both considered matched listeners.
	function isEmitListener(options, key) {
	    if (!options || !isOn(key)) {
	        return false;
	    }
	    key = key.slice(2).replace(/Once$/, '');
	    return (hasOwn(options, key[0].toLowerCase() + key.slice(1)) ||
	        hasOwn(options, hyphenate(key)) ||
	        hasOwn(options, key));
	}

	/**
	 * mark the current rendering instance for asset resolution (e.g.
	 * resolveComponent, resolveDirective) during render
	 */
	let currentRenderingInstance = null;
	function setCurrentRenderingInstance(instance) {
	    currentRenderingInstance = instance;
	}
	/**
	 * dev only flag to track whether $attrs was used during render.
	 * If $attrs was used during render then the warning for failed attrs
	 * fallthrough can be suppressed.
	 */
	let accessedAttrs = false;
	function markAttrsAccessed() {
	    accessedAttrs = true;
	}
	function renderComponentRoot(instance) {
	    const { type: Component, vnode, proxy, withProxy, props, propsOptions: [propsOptions], slots, attrs, emit, render, renderCache, data, setupState, ctx } = instance;
	    let result;
	    currentRenderingInstance = instance;
	    {
	        accessedAttrs = false;
	    }
	    try {
	        let fallthroughAttrs;
	        if (vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */) {
	            // withProxy is a proxy with a different `has` trap only for
	            // runtime-compiled render functions using `with` block.
	            const proxyToUse = withProxy || proxy;
	            result = normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
	            fallthroughAttrs = attrs;
	        }
	        else {
	            // functional
	            const render = Component;
	            // in dev, mark attrs accessed if optional props (attrs === props)
	            if (("development" !== 'production') && attrs === props) {
	                markAttrsAccessed();
	            }
	            result = normalizeVNode(render.length > 1
	                ? render(props, ("development" !== 'production')
	                    ? {
	                        get attrs() {
	                            markAttrsAccessed();
	                            return attrs;
	                        },
	                        slots,
	                        emit
	                    }
	                    : { attrs, slots, emit })
	                : render(props, null /* we know it doesn't need it */));
	            fallthroughAttrs = Component.props
	                ? attrs
	                : getFunctionalFallthrough(attrs);
	        }
	        // attr merging
	        // in dev mode, comments are preserved, and it's possible for a template
	        // to have comments along side the root element which makes it a fragment
	        let root = result;
	        let setRoot = undefined;
	        if (("development" !== 'production') && result.patchFlag & 2048 /* DEV_ROOT_FRAGMENT */) {
	            ;
	            [root, setRoot] = getChildRoot(result);
	        }
	        if (Component.inheritAttrs !== false && fallthroughAttrs) {
	            const keys = Object.keys(fallthroughAttrs);
	            const { shapeFlag } = root;
	            if (keys.length) {
	                if (shapeFlag & 1 /* ELEMENT */ ||
	                    shapeFlag & 6 /* COMPONENT */) {
	                    if (propsOptions && keys.some(isModelListener)) {
	                        // If a v-model listener (onUpdate:xxx) has a corresponding declared
	                        // prop, it indicates this component expects to handle v-model and
	                        // it should not fallthrough.
	                        // related: #1543, #1643, #1989
	                        fallthroughAttrs = filterModelListeners(fallthroughAttrs, propsOptions);
	                    }
	                    root = cloneVNode(root, fallthroughAttrs);
	                }
	                else if (("development" !== 'production') && !accessedAttrs && root.type !== Comment) {
	                    const allAttrs = Object.keys(attrs);
	                    const eventAttrs = [];
	                    const extraAttrs = [];
	                    for (let i = 0, l = allAttrs.length; i < l; i++) {
	                        const key = allAttrs[i];
	                        if (isOn(key)) {
	                            // ignore v-model handlers when they fail to fallthrough
	                            if (!isModelListener(key)) {
	                                // remove `on`, lowercase first letter to reflect event casing
	                                // accurately
	                                eventAttrs.push(key[2].toLowerCase() + key.slice(3));
	                            }
	                        }
	                        else {
	                            extraAttrs.push(key);
	                        }
	                    }
	                    if (extraAttrs.length) {
	                        warn(`Extraneous non-props attributes (` +
	                            `${extraAttrs.join(', ')}) ` +
	                            `were passed to component but could not be automatically inherited ` +
	                            `because component renders fragment or text root nodes.`);
	                    }
	                    if (eventAttrs.length) {
	                        warn(`Extraneous non-emits event listeners (` +
	                            `${eventAttrs.join(', ')}) ` +
	                            `were passed to component but could not be automatically inherited ` +
	                            `because component renders fragment or text root nodes. ` +
	                            `If the listener is intended to be a component custom event listener only, ` +
	                            `declare it using the "emits" option.`);
	                    }
	                }
	            }
	        }
	        // inherit directives
	        if (vnode.dirs) {
	            if (("development" !== 'production') && !isElementRoot(root)) {
	                warn(`Runtime directive used on component with non-element root node. ` +
	                    `The directives will not function as intended.`);
	            }
	            root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
	        }
	        // inherit transition data
	        if (vnode.transition) {
	            if (("development" !== 'production') && !isElementRoot(root)) {
	                warn(`Component inside <Transition> renders non-element root node ` +
	                    `that cannot be animated.`);
	            }
	            root.transition = vnode.transition;
	        }
	        if (("development" !== 'production') && setRoot) {
	            setRoot(root);
	        }
	        else {
	            result = root;
	        }
	    }
	    catch (err) {
	        handleError(err, instance, 1 /* RENDER_FUNCTION */);
	        result = createVNode(Comment);
	    }
	    currentRenderingInstance = null;
	    return result;
	}
	/**
	 * dev only
	 * In dev mode, template root level comments are rendered, which turns the
	 * template into a fragment root, but we need to locate the single element
	 * root for attrs and scope id processing.
	 */
	const getChildRoot = (vnode) => {
	    const rawChildren = vnode.children;
	    const dynamicChildren = vnode.dynamicChildren;
	    const childRoot = filterSingleRoot(rawChildren);
	    if (!childRoot) {
	        return [vnode, undefined];
	    }
	    const index = rawChildren.indexOf(childRoot);
	    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
	    const setRoot = (updatedRoot) => {
	        rawChildren[index] = updatedRoot;
	        if (dynamicChildren) {
	            if (dynamicIndex > -1) {
	                dynamicChildren[dynamicIndex] = updatedRoot;
	            }
	            else if (updatedRoot.patchFlag > 0) {
	                vnode.dynamicChildren = [...dynamicChildren, updatedRoot];
	            }
	        }
	    };
	    return [normalizeVNode(childRoot), setRoot];
	};
	function filterSingleRoot(children) {
	    let singleRoot;
	    for (let i = 0; i < children.length; i++) {
	        const child = children[i];
	        if (isVNode(child)) {
	            // ignore user comment
	            if (child.type !== Comment || child.children === 'v-if') {
	                if (singleRoot) {
	                    // has more than 1 non-comment child, return now
	                    return;
	                }
	                else {
	                    singleRoot = child;
	                }
	            }
	        }
	        else {
	            return;
	        }
	    }
	    return singleRoot;
	}
	const getFunctionalFallthrough = (attrs) => {
	    let res;
	    for (const key in attrs) {
	        if (key === 'class' || key === 'style' || isOn(key)) {
	            (res || (res = {}))[key] = attrs[key];
	        }
	    }
	    return res;
	};
	const filterModelListeners = (attrs, props) => {
	    const res = {};
	    for (const key in attrs) {
	        if (!isModelListener(key) || !(key.slice(9) in props)) {
	            res[key] = attrs[key];
	        }
	    }
	    return res;
	};
	const isElementRoot = (vnode) => {
	    return (vnode.shapeFlag & 6 /* COMPONENT */ ||
	        vnode.shapeFlag & 1 /* ELEMENT */ ||
	        vnode.type === Comment // potential v-if branch switch
	    );
	};
	function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
	    const { props: prevProps, children: prevChildren, component } = prevVNode;
	    const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
	    const emits = component.emitsOptions;
	    // Parent component's render function was hot-updated. Since this may have
	    // caused the child component's slots content to have changed, we need to
	    // force the child to update as well.
	    if ( (prevChildren || nextChildren) && isHmrUpdating) {
	        return true;
	    }
	    // force child update for runtime directive or transition on component vnode.
	    if (nextVNode.dirs || nextVNode.transition) {
	        return true;
	    }
	    if (optimized && patchFlag >= 0) {
	        if (patchFlag & 1024 /* DYNAMIC_SLOTS */) {
	            // slot content that references values that might have changed,
	            // e.g. in a v-for
	            return true;
	        }
	        if (patchFlag & 16 /* FULL_PROPS */) {
	            if (!prevProps) {
	                return !!nextProps;
	            }
	            // presence of this flag indicates props are always non-null
	            return hasPropsChanged(prevProps, nextProps, emits);
	        }
	        else if (patchFlag & 8 /* PROPS */) {
	            const dynamicProps = nextVNode.dynamicProps;
	            for (let i = 0; i < dynamicProps.length; i++) {
	                const key = dynamicProps[i];
	                if (nextProps[key] !== prevProps[key] &&
	                    !isEmitListener(emits, key)) {
	                    return true;
	                }
	            }
	        }
	    }
	    else {
	        // this path is only taken by manually written render functions
	        // so presence of any children leads to a forced update
	        if (prevChildren || nextChildren) {
	            if (!nextChildren || !nextChildren.$stable) {
	                return true;
	            }
	        }
	        if (prevProps === nextProps) {
	            return false;
	        }
	        if (!prevProps) {
	            return !!nextProps;
	        }
	        if (!nextProps) {
	            return true;
	        }
	        return hasPropsChanged(prevProps, nextProps, emits);
	    }
	    return false;
	}
	function hasPropsChanged(prevProps, nextProps, emitsOptions) {
	    const nextKeys = Object.keys(nextProps);
	    if (nextKeys.length !== Object.keys(prevProps).length) {
	        return true;
	    }
	    for (let i = 0; i < nextKeys.length; i++) {
	        const key = nextKeys[i];
	        if (nextProps[key] !== prevProps[key] &&
	            !isEmitListener(emitsOptions, key)) {
	            return true;
	        }
	    }
	    return false;
	}
	function updateHOCHostEl({ vnode, parent }, el // HostNode
	) {
	    while (parent && parent.subTree === vnode) {
	        (vnode = parent.vnode).el = el;
	        parent = parent.parent;
	    }
	}

	const isSuspense = (type) => type.__isSuspense;
	// Suspense exposes a component-like API, and is treated like a component
	// in the compiler, but internally it's a special built-in type that hooks
	// directly into the renderer.
	const SuspenseImpl = {
	    // In order to make Suspense tree-shakable, we need to avoid importing it
	    // directly in the renderer. The renderer checks for the __isSuspense flag
	    // on a vnode's type and calls the `process` method, passing in renderer
	    // internals.
	    __isSuspense: true,
	    process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized, 
	    // platform-specific impl passed from renderer
	    rendererInternals) {
	        if (n1 == null) {
	            mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized, rendererInternals);
	        }
	        else {
	            patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, rendererInternals);
	        }
	    },
	    hydrate: hydrateSuspense,
	    create: createSuspenseBoundary
	};
	// Force-casted public typing for h and TSX props inference
	const Suspense = ( SuspenseImpl
	    );
	function mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, optimized, rendererInternals) {
	    const { p: patch, o: { createElement } } = rendererInternals;
	    const hiddenContainer = createElement('div');
	    const suspense = (vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, optimized, rendererInternals));
	    // start mounting the content subtree in an off-dom container
	    patch(null, (suspense.pendingBranch = vnode.ssContent), hiddenContainer, null, parentComponent, suspense, isSVG);
	    // now check if we have encountered any async deps
	    if (suspense.deps > 0) {
	        // has async
	        // mount the fallback tree
	        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
	        isSVG);
	        setActiveBranch(suspense, vnode.ssFallback);
	    }
	    else {
	        // Suspense has no async deps. Just resolve.
	        suspense.resolve();
	    }
	}
	function patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, { p: patch, um: unmount, o: { createElement } }) {
	    const suspense = (n2.suspense = n1.suspense);
	    suspense.vnode = n2;
	    n2.el = n1.el;
	    const newBranch = n2.ssContent;
	    const newFallback = n2.ssFallback;
	    const { activeBranch, pendingBranch, isInFallback, isHydrating } = suspense;
	    if (pendingBranch) {
	        suspense.pendingBranch = newBranch;
	        if (isSameVNodeType(newBranch, pendingBranch)) {
	            // same root type but content may have changed.
	            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG);
	            if (suspense.deps <= 0) {
	                suspense.resolve();
	            }
	            else if (isInFallback) {
	                patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
	                isSVG);
	                setActiveBranch(suspense, newFallback);
	            }
	        }
	        else {
	            // toggled before pending tree is resolved
	            suspense.pendingId++;
	            if (isHydrating) {
	                // if toggled before hydration is finished, the current DOM tree is
	                // no longer valid. set it as the active branch so it will be unmounted
	                // when resolved
	                suspense.isHydrating = false;
	                suspense.activeBranch = pendingBranch;
	            }
	            else {
	                unmount(pendingBranch, parentComponent, suspense);
	            }
	            // increment pending ID. this is used to invalidate async callbacks
	            // reset suspense state
	            suspense.deps = 0;
	            // discard effects from pending branch
	            suspense.effects.length = 0;
	            // discard previous container
	            suspense.hiddenContainer = createElement('div');
	            if (isInFallback) {
	                // already in fallback state
	                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG);
	                if (suspense.deps <= 0) {
	                    suspense.resolve();
	                }
	                else {
	                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
	                    isSVG);
	                    setActiveBranch(suspense, newFallback);
	                }
	            }
	            else if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
	                // toggled "back" to current active branch
	                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG);
	                // force resolve
	                suspense.resolve(true);
	            }
	            else {
	                // switched to a 3rd branch
	                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG);
	                if (suspense.deps <= 0) {
	                    suspense.resolve();
	                }
	            }
	        }
	    }
	    else {
	        if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
	            // root did not change, just normal patch
	            patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG);
	            setActiveBranch(suspense, newBranch);
	        }
	        else {
	            // root node toggled
	            // invoke @pending event
	            const onPending = n2.props && n2.props.onPending;
	            if (isFunction(onPending)) {
	                onPending();
	            }
	            // mount pending branch in off-dom container
	            suspense.pendingBranch = newBranch;
	            suspense.pendingId++;
	            patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG);
	            if (suspense.deps <= 0) {
	                // incoming branch has no async deps, resolve now.
	                suspense.resolve();
	            }
	            else {
	                const { timeout, pendingId } = suspense;
	                if (timeout > 0) {
	                    setTimeout(() => {
	                        if (suspense.pendingId === pendingId) {
	                            suspense.fallback(newFallback);
	                        }
	                    }, timeout);
	                }
	                else if (timeout === 0) {
	                    suspense.fallback(newFallback);
	                }
	            }
	        }
	    }
	}
	let hasWarned = false;
	function createSuspenseBoundary(vnode, parent, parentComponent, container, hiddenContainer, anchor, isSVG, optimized, rendererInternals, isHydrating = false) {
	    /* istanbul ignore if */
	    if ( !hasWarned) {
	        hasWarned = true;
	        // @ts-ignore `console.info` cannot be null error
	        console[console.info ? 'info' : 'log'](`<Suspense> is an experimental feature and its API will likely change.`);
	    }
	    const { p: patch, m: move, um: unmount, n: next, o: { parentNode, remove } } = rendererInternals;
	    const timeout = toNumber(vnode.props && vnode.props.timeout);
	    const suspense = {
	        vnode,
	        parent,
	        parentComponent,
	        isSVG,
	        container,
	        hiddenContainer,
	        anchor,
	        deps: 0,
	        pendingId: 0,
	        timeout: typeof timeout === 'number' ? timeout : -1,
	        activeBranch: null,
	        pendingBranch: null,
	        isInFallback: true,
	        isHydrating,
	        isUnmounted: false,
	        effects: [],
	        resolve(resume = false) {
	            {
	                if (!resume && !suspense.pendingBranch) {
	                    throw new Error(`suspense.resolve() is called without a pending branch.`);
	                }
	                if (suspense.isUnmounted) {
	                    throw new Error(`suspense.resolve() is called on an already unmounted suspense boundary.`);
	                }
	            }
	            const { vnode, activeBranch, pendingBranch, pendingId, effects, parentComponent, container } = suspense;
	            if (suspense.isHydrating) {
	                suspense.isHydrating = false;
	            }
	            else if (!resume) {
	                const delayEnter = activeBranch &&
	                    pendingBranch.transition &&
	                    pendingBranch.transition.mode === 'out-in';
	                if (delayEnter) {
	                    activeBranch.transition.afterLeave = () => {
	                        if (pendingId === suspense.pendingId) {
	                            move(pendingBranch, container, anchor, 0 /* ENTER */);
	                        }
	                    };
	                }
	                // this is initial anchor on mount
	                let { anchor } = suspense;
	                // unmount current active tree
	                if (activeBranch) {
	                    // if the fallback tree was mounted, it may have been moved
	                    // as part of a parent suspense. get the latest anchor for insertion
	                    anchor = next(activeBranch);
	                    unmount(activeBranch, parentComponent, suspense, true);
	                }
	                if (!delayEnter) {
	                    // move content from off-dom container to actual container
	                    move(pendingBranch, container, anchor, 0 /* ENTER */);
	                }
	            }
	            setActiveBranch(suspense, pendingBranch);
	            suspense.pendingBranch = null;
	            suspense.isInFallback = false;
	            // flush buffered effects
	            // check if there is a pending parent suspense
	            let parent = suspense.parent;
	            let hasUnresolvedAncestor = false;
	            while (parent) {
	                if (parent.pendingBranch) {
	                    // found a pending parent suspense, merge buffered post jobs
	                    // into that parent
	                    parent.effects.push(...effects);
	                    hasUnresolvedAncestor = true;
	                    break;
	                }
	                parent = parent.parent;
	            }
	            // no pending parent suspense, flush all jobs
	            if (!hasUnresolvedAncestor) {
	                queuePostFlushCb(effects);
	            }
	            suspense.effects = [];
	            // invoke @resolve event
	            const onResolve = vnode.props && vnode.props.onResolve;
	            if (isFunction(onResolve)) {
	                onResolve();
	            }
	        },
	        fallback(fallbackVNode) {
	            if (!suspense.pendingBranch) {
	                return;
	            }
	            const { vnode, activeBranch, parentComponent, container, isSVG } = suspense;
	            // invoke @fallback event
	            const onFallback = vnode.props && vnode.props.onFallback;
	            if (isFunction(onFallback)) {
	                onFallback();
	            }
	            const anchor = next(activeBranch);
	            const mountFallback = () => {
	                if (!suspense.isInFallback) {
	                    return;
	                }
	                // mount the fallback tree
	                patch(null, fallbackVNode, container, anchor, parentComponent, null, // fallback tree will not have suspense context
	                isSVG);
	                setActiveBranch(suspense, fallbackVNode);
	            };
	            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === 'out-in';
	            if (delayEnter) {
	                activeBranch.transition.afterLeave = mountFallback;
	            }
	            // unmount current active branch
	            unmount(activeBranch, parentComponent, null, // no suspense so unmount hooks fire now
	            true // shouldRemove
	            );
	            suspense.isInFallback = true;
	            if (!delayEnter) {
	                mountFallback();
	            }
	        },
	        move(container, anchor, type) {
	            suspense.activeBranch &&
	                move(suspense.activeBranch, container, anchor, type);
	            suspense.container = container;
	        },
	        next() {
	            return suspense.activeBranch && next(suspense.activeBranch);
	        },
	        registerDep(instance, setupRenderEffect) {
	            const isInPendingSuspense = !!suspense.pendingBranch;
	            if (isInPendingSuspense) {
	                suspense.deps++;
	            }
	            const hydratedEl = instance.vnode.el;
	            instance
	                .asyncDep.catch(err => {
	                handleError(err, instance, 0 /* SETUP_FUNCTION */);
	            })
	                .then(asyncSetupResult => {
	                // retry when the setup() promise resolves.
	                // component may have been unmounted before resolve.
	                if (instance.isUnmounted ||
	                    suspense.isUnmounted ||
	                    suspense.pendingId !== instance.suspenseId) {
	                    return;
	                }
	                // retry from this component
	                instance.asyncResolved = true;
	                const { vnode } = instance;
	                {
	                    pushWarningContext(vnode);
	                }
	                handleSetupResult(instance, asyncSetupResult);
	                if (hydratedEl) {
	                    // vnode may have been replaced if an update happened before the
	                    // async dep is resolved.
	                    vnode.el = hydratedEl;
	                }
	                const placeholder = !hydratedEl && instance.subTree.el;
	                setupRenderEffect(instance, vnode, 
	                // component may have been moved before resolve.
	                // if this is not a hydration, instance.subTree will be the comment
	                // placeholder.
	                parentNode(hydratedEl || instance.subTree.el), 
	                // anchor will not be used if this is hydration, so only need to
	                // consider the comment placeholder case.
	                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
	                if (placeholder) {
	                    remove(placeholder);
	                }
	                updateHOCHostEl(instance, vnode.el);
	                {
	                    popWarningContext();
	                }
	                // only decrease deps count if suspense is not already resolved
	                if (isInPendingSuspense && --suspense.deps === 0) {
	                    suspense.resolve();
	                }
	            });
	        },
	        unmount(parentSuspense, doRemove) {
	            suspense.isUnmounted = true;
	            if (suspense.activeBranch) {
	                unmount(suspense.activeBranch, parentComponent, parentSuspense, doRemove);
	            }
	            if (suspense.pendingBranch) {
	                unmount(suspense.pendingBranch, parentComponent, parentSuspense, doRemove);
	            }
	        }
	    };
	    return suspense;
	}
	function hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, optimized, rendererInternals, hydrateNode) {
	    /* eslint-disable no-restricted-globals */
	    const suspense = (vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement('div'), null, isSVG, optimized, rendererInternals, true /* hydrating */));
	    // there are two possible scenarios for server-rendered suspense:
	    // - success: ssr content should be fully resolved
	    // - failure: ssr content should be the fallback branch.
	    // however, on the client we don't really know if it has failed or not
	    // attempt to hydrate the DOM assuming it has succeeded, but we still
	    // need to construct a suspense boundary first
	    const result = hydrateNode(node, (suspense.pendingBranch = vnode.ssContent), parentComponent, suspense, optimized);
	    if (suspense.deps === 0) {
	        suspense.resolve();
	    }
	    return result;
	    /* eslint-enable no-restricted-globals */
	}
	function normalizeSuspenseChildren(vnode) {
	    const { shapeFlag, children } = vnode;
	    let content;
	    let fallback;
	    if (shapeFlag & 32 /* SLOTS_CHILDREN */) {
	        content = normalizeSuspenseSlot(children.default);
	        fallback = normalizeSuspenseSlot(children.fallback);
	    }
	    else {
	        content = normalizeSuspenseSlot(children);
	        fallback = normalizeVNode(null);
	    }
	    return {
	        content,
	        fallback
	    };
	}
	function normalizeSuspenseSlot(s) {
	    if (isFunction(s)) {
	        s = s();
	    }
	    if (isArray(s)) {
	        const singleChild = filterSingleRoot(s);
	        if ( !singleChild) {
	            warn(`<Suspense> slots expect a single root node.`);
	        }
	        s = singleChild;
	    }
	    return normalizeVNode(s);
	}
	function queueEffectWithSuspense(fn, suspense) {
	    if (suspense && suspense.pendingBranch) {
	        if (isArray(fn)) {
	            suspense.effects.push(...fn);
	        }
	        else {
	            suspense.effects.push(fn);
	        }
	    }
	    else {
	        queuePostFlushCb(fn);
	    }
	}
	function setActiveBranch(suspense, branch) {
	    suspense.activeBranch = branch;
	    const { vnode, parentComponent } = suspense;
	    const el = (vnode.el = branch.el);
	    // in case suspense is the root node of a component,
	    // recursively update the HOC el
	    if (parentComponent && parentComponent.subTree === vnode) {
	        parentComponent.vnode.el = el;
	        updateHOCHostEl(parentComponent, el);
	    }
	}

	let isRenderingCompiledSlot = 0;
	const setCompiledSlotRendering = (n) => (isRenderingCompiledSlot += n);
	/**
	 * Compiler runtime helper for rendering `<slot/>`
	 * @private
	 */
	function renderSlot(slots, name, props = {}, 
	// this is not a user-facing function, so the fallback is always generated by
	// the compiler and guaranteed to be a function returning an array
	fallback) {
	    let slot = slots[name];
	    if ( slot && slot.length > 1) {
	        warn(`SSR-optimized slot function detected in a non-SSR-optimized render ` +
	            `function. You need to mark this component with $dynamic-slots in the ` +
	            `parent template.`);
	        slot = () => [];
	    }
	    // a compiled slot disables block tracking by default to avoid manual
	    // invocation interfering with template-based block tracking, but in
	    // `renderSlot` we can be sure that it's template-based so we can force
	    // enable it.
	    isRenderingCompiledSlot++;
	    openBlock();
	    const validSlotContent = slot && ensureValidVNode(slot(props));
	    const rendered = createBlock(Fragment, { key: props.key || `_${name}` }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 /* STABLE */
	        ? 64 /* STABLE_FRAGMENT */
	        : -2 /* BAIL */);
	    isRenderingCompiledSlot--;
	    return rendered;
	}
	function ensureValidVNode(vnodes) {
	    return vnodes.some(child => {
	        if (!isVNode(child))
	            return true;
	        if (child.type === Comment)
	            return false;
	        if (child.type === Fragment &&
	            !ensureValidVNode(child.children))
	            return false;
	        return true;
	    })
	        ? vnodes
	        : null;
	}

	/**
	 * Wrap a slot function to memoize current rendering instance
	 * @private
	 */
	function withCtx(fn, ctx = currentRenderingInstance) {
	    if (!ctx)
	        return fn;
	    const renderFnWithContext = (...args) => {
	        // If a user calls a compiled slot inside a template expression (#1745), it
	        // can mess up block tracking, so by default we need to push a null block to
	        // avoid that. This isn't necessary if rendering a compiled `<slot>`.
	        if (!isRenderingCompiledSlot) {
	            openBlock(true /* null block that disables tracking */);
	        }
	        const owner = currentRenderingInstance;
	        setCurrentRenderingInstance(ctx);
	        const res = fn(...args);
	        setCurrentRenderingInstance(owner);
	        if (!isRenderingCompiledSlot) {
	            closeBlock();
	        }
	        return res;
	    };
	    renderFnWithContext._c = true;
	    return renderFnWithContext;
	}

	// SFC scoped style ID management.
	let currentScopeId = null;
	const scopeIdStack = [];
	/**
	 * @private
	 */
	function pushScopeId(id) {
	    scopeIdStack.push((currentScopeId = id));
	}
	/**
	 * @private
	 */
	function popScopeId() {
	    scopeIdStack.pop();
	    currentScopeId = scopeIdStack[scopeIdStack.length - 1] || null;
	}
	/**
	 * @private
	 */
	function withScopeId(id) {
	    return ((fn) => withCtx(function () {
	        pushScopeId(id);
	        const res = fn.apply(this, arguments);
	        popScopeId();
	        return res;
	    }));
	}

	function initProps(instance, rawProps, isStateful, // result of bitwise flag comparison
	isSSR = false) {
	    const props = {};
	    const attrs = {};
	    def(attrs, InternalObjectKey, 1);
	    setFullProps(instance, rawProps, props, attrs);
	    // validation
	    {
	        validateProps(props, instance);
	    }
	    if (isStateful) {
	        // stateful
	        instance.props = isSSR ? props : shallowReactive(props);
	    }
	    else {
	        if (!instance.type.props) {
	            // functional w/ optional props, props === attrs
	            instance.props = attrs;
	        }
	        else {
	            // functional w/ declared props
	            instance.props = props;
	        }
	    }
	    instance.attrs = attrs;
	}
	function updateProps(instance, rawProps, rawPrevProps, optimized) {
	    const { props, attrs, vnode: { patchFlag } } = instance;
	    const rawCurrentProps = toRaw(props);
	    const [options] = instance.propsOptions;
	    if (
	    // always force full diff in dev
	    // - #1942 if hmr is enabled with sfc component
	    // - vite#872 non-sfc component used by sfc component
	    !(
	        (instance.type.__hmrId ||
	            (instance.parent && instance.parent.type.__hmrId))) &&
	        (optimized || patchFlag > 0) &&
	        !(patchFlag & 16 /* FULL_PROPS */)) {
	        if (patchFlag & 8 /* PROPS */) {
	            // Compiler-generated props & no keys change, just set the updated
	            // the props.
	            const propsToUpdate = instance.vnode.dynamicProps;
	            for (let i = 0; i < propsToUpdate.length; i++) {
	                const key = propsToUpdate[i];
	                // PROPS flag guarantees rawProps to be non-null
	                const value = rawProps[key];
	                if (options) {
	                    // attr / props separation was done on init and will be consistent
	                    // in this code path, so just check if attrs have it.
	                    if (hasOwn(attrs, key)) {
	                        attrs[key] = value;
	                    }
	                    else {
	                        const camelizedKey = camelize(key);
	                        props[camelizedKey] = resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance);
	                    }
	                }
	                else {
	                    attrs[key] = value;
	                }
	            }
	        }
	    }
	    else {
	        // full props update.
	        setFullProps(instance, rawProps, props, attrs);
	        // in case of dynamic props, check if we need to delete keys from
	        // the props object
	        let kebabKey;
	        for (const key in rawCurrentProps) {
	            if (!rawProps ||
	                // for camelCase
	                (!hasOwn(rawProps, key) &&
	                    // it's possible the original props was passed in as kebab-case
	                    // and converted to camelCase (#955)
	                    ((kebabKey = hyphenate(key)) === key || !hasOwn(rawProps, kebabKey)))) {
	                if (options) {
	                    if (rawPrevProps &&
	                        // for camelCase
	                        (rawPrevProps[key] !== undefined ||
	                            // for kebab-case
	                            rawPrevProps[kebabKey] !== undefined)) {
	                        props[key] = resolvePropValue(options, rawProps || EMPTY_OBJ, key, undefined, instance);
	                    }
	                }
	                else {
	                    delete props[key];
	                }
	            }
	        }
	        // in the case of functional component w/o props declaration, props and
	        // attrs point to the same object so it should already have been updated.
	        if (attrs !== rawCurrentProps) {
	            for (const key in attrs) {
	                if (!rawProps || !hasOwn(rawProps, key)) {
	                    delete attrs[key];
	                }
	            }
	        }
	    }
	    // trigger updates for $attrs in case it's used in component slots
	    trigger(instance, "set" /* SET */, '$attrs');
	    if ( rawProps) {
	        validateProps(props, instance);
	    }
	}
	function setFullProps(instance, rawProps, props, attrs) {
	    const [options, needCastKeys] = instance.propsOptions;
	    if (rawProps) {
	        for (const key in rawProps) {
	            const value = rawProps[key];
	            // key, ref are reserved and never passed down
	            if (isReservedProp(key)) {
	                continue;
	            }
	            // prop option names are camelized during normalization, so to support
	            // kebab -> camel conversion here we need to camelize the key.
	            let camelKey;
	            if (options && hasOwn(options, (camelKey = camelize(key)))) {
	                props[camelKey] = value;
	            }
	            else if (!isEmitListener(instance.emitsOptions, key)) {
	                // Any non-declared (either as a prop or an emitted event) props are put
	                // into a separate `attrs` object for spreading. Make sure to preserve
	                // original key casing
	                attrs[key] = value;
	            }
	        }
	    }
	    if (needCastKeys) {
	        const rawCurrentProps = toRaw(props);
	        for (let i = 0; i < needCastKeys.length; i++) {
	            const key = needCastKeys[i];
	            props[key] = resolvePropValue(options, rawCurrentProps, key, rawCurrentProps[key], instance);
	        }
	    }
	}
	function resolvePropValue(options, props, key, value, instance) {
	    const opt = options[key];
	    if (opt != null) {
	        const hasDefault = hasOwn(opt, 'default');
	        // default values
	        if (hasDefault && value === undefined) {
	            const defaultValue = opt.default;
	            if (opt.type !== Function && isFunction(defaultValue)) {
	                setCurrentInstance(instance);
	                value = defaultValue(props);
	                setCurrentInstance(null);
	            }
	            else {
	                value = defaultValue;
	            }
	        }
	        // boolean casting
	        if (opt[0 /* shouldCast */]) {
	            if (!hasOwn(props, key) && !hasDefault) {
	                value = false;
	            }
	            else if (opt[1 /* shouldCastTrue */] &&
	                (value === '' || value === hyphenate(key))) {
	                value = true;
	            }
	        }
	    }
	    return value;
	}
	function normalizePropsOptions(comp, appContext, asMixin = false) {
	    if (!appContext.deopt && comp.__props) {
	        return comp.__props;
	    }
	    const raw = comp.props;
	    const normalized = {};
	    const needCastKeys = [];
	    // apply mixin/extends props
	    let hasExtends = false;
	    if ( !isFunction(comp)) {
	        const extendProps = (raw) => {
	            hasExtends = true;
	            const [props, keys] = normalizePropsOptions(raw, appContext, true);
	            extend(normalized, props);
	            if (keys)
	                needCastKeys.push(...keys);
	        };
	        if (!asMixin && appContext.mixins.length) {
	            appContext.mixins.forEach(extendProps);
	        }
	        if (comp.extends) {
	            extendProps(comp.extends);
	        }
	        if (comp.mixins) {
	            comp.mixins.forEach(extendProps);
	        }
	    }
	    if (!raw && !hasExtends) {
	        return (comp.__props = EMPTY_ARR);
	    }
	    if (isArray(raw)) {
	        for (let i = 0; i < raw.length; i++) {
	            if ( !isString(raw[i])) {
	                warn(`props must be strings when using array syntax.`, raw[i]);
	            }
	            const normalizedKey = camelize(raw[i]);
	            if (validatePropName(normalizedKey)) {
	                normalized[normalizedKey] = EMPTY_OBJ;
	            }
	        }
	    }
	    else if (raw) {
	        if ( !isObject(raw)) {
	            warn(`invalid props options`, raw);
	        }
	        for (const key in raw) {
	            const normalizedKey = camelize(key);
	            if (validatePropName(normalizedKey)) {
	                const opt = raw[key];
	                const prop = (normalized[normalizedKey] =
	                    isArray(opt) || isFunction(opt) ? { type: opt } : opt);
	                if (prop) {
	                    const booleanIndex = getTypeIndex(Boolean, prop.type);
	                    const stringIndex = getTypeIndex(String, prop.type);
	                    prop[0 /* shouldCast */] = booleanIndex > -1;
	                    prop[1 /* shouldCastTrue */] =
	                        stringIndex < 0 || booleanIndex < stringIndex;
	                    // if the prop needs boolean casting or default value
	                    if (booleanIndex > -1 || hasOwn(prop, 'default')) {
	                        needCastKeys.push(normalizedKey);
	                    }
	                }
	            }
	        }
	    }
	    return (comp.__props = [normalized, needCastKeys]);
	}
	function validatePropName(key) {
	    if (key[0] !== '$') {
	        return true;
	    }
	    else {
	        warn(`Invalid prop name: "${key}" is a reserved property.`);
	    }
	    return false;
	}
	// use function string name to check type constructors
	// so that it works across vms / iframes.
	function getType(ctor) {
	    const match = ctor && ctor.toString().match(/^\s*function (\w+)/);
	    return match ? match[1] : '';
	}
	function isSameType(a, b) {
	    return getType(a) === getType(b);
	}
	function getTypeIndex(type, expectedTypes) {
	    if (isArray(expectedTypes)) {
	        for (let i = 0, len = expectedTypes.length; i < len; i++) {
	            if (isSameType(expectedTypes[i], type)) {
	                return i;
	            }
	        }
	    }
	    else if (isFunction(expectedTypes)) {
	        return isSameType(expectedTypes, type) ? 0 : -1;
	    }
	    return -1;
	}
	/**
	 * dev only
	 */
	function validateProps(props, instance) {
	    const rawValues = toRaw(props);
	    const options = instance.propsOptions[0];
	    for (const key in options) {
	        let opt = options[key];
	        if (opt == null)
	            continue;
	        validateProp(key, rawValues[key], opt, !hasOwn(rawValues, key));
	    }
	}
	/**
	 * dev only
	 */
	function validateProp(name, value, prop, isAbsent) {
	    const { type, required, validator } = prop;
	    // required!
	    if (required && isAbsent) {
	        warn('Missing required prop: "' + name + '"');
	        return;
	    }
	    // missing but optional
	    if (value == null && !prop.required) {
	        return;
	    }
	    // type check
	    if (type != null && type !== true) {
	        let isValid = false;
	        const types = isArray(type) ? type : [type];
	        const expectedTypes = [];
	        // value is valid as long as one of the specified types match
	        for (let i = 0; i < types.length && !isValid; i++) {
	            const { valid, expectedType } = assertType(value, types[i]);
	            expectedTypes.push(expectedType || '');
	            isValid = valid;
	        }
	        if (!isValid) {
	            warn(getInvalidTypeMessage(name, value, expectedTypes));
	            return;
	        }
	    }
	    // custom validator
	    if (validator && !validator(value)) {
	        warn('Invalid prop: custom validator check failed for prop "' + name + '".');
	    }
	}
	const isSimpleType = /*#__PURE__*/ makeMap('String,Number,Boolean,Function,Symbol');
	/**
	 * dev only
	 */
	function assertType(value, type) {
	    let valid;
	    const expectedType = getType(type);
	    if (isSimpleType(expectedType)) {
	        const t = typeof value;
	        valid = t === expectedType.toLowerCase();
	        // for primitive wrapper objects
	        if (!valid && t === 'object') {
	            valid = value instanceof type;
	        }
	    }
	    else if (expectedType === 'Object') {
	        valid = isObject(value);
	    }
	    else if (expectedType === 'Array') {
	        valid = isArray(value);
	    }
	    else {
	        valid = value instanceof type;
	    }
	    return {
	        valid,
	        expectedType
	    };
	}
	/**
	 * dev only
	 */
	function getInvalidTypeMessage(name, value, expectedTypes) {
	    let message = `Invalid prop: type check failed for prop "${name}".` +
	        ` Expected ${expectedTypes.map(capitalize).join(', ')}`;
	    const expectedType = expectedTypes[0];
	    const receivedType = toRawType(value);
	    const expectedValue = styleValue(value, expectedType);
	    const receivedValue = styleValue(value, receivedType);
	    // check if we need to specify expected value
	    if (expectedTypes.length === 1 &&
	        isExplicable(expectedType) &&
	        !isBoolean(expectedType, receivedType)) {
	        message += ` with value ${expectedValue}`;
	    }
	    message += `, got ${receivedType} `;
	    // check if we need to specify received value
	    if (isExplicable(receivedType)) {
	        message += `with value ${receivedValue}.`;
	    }
	    return message;
	}
	/**
	 * dev only
	 */
	function styleValue(value, type) {
	    if (type === 'String') {
	        return `"${value}"`;
	    }
	    else if (type === 'Number') {
	        return `${Number(value)}`;
	    }
	    else {
	        return `${value}`;
	    }
	}
	/**
	 * dev only
	 */
	function isExplicable(type) {
	    const explicitTypes = ['string', 'number', 'boolean'];
	    return explicitTypes.some(elem => type.toLowerCase() === elem);
	}
	/**
	 * dev only
	 */
	function isBoolean(...args) {
	    return args.some(elem => elem.toLowerCase() === 'boolean');
	}

	function injectHook(type, hook, target = currentInstance, prepend = false) {
	    if (target) {
	        const hooks = target[type] || (target[type] = []);
	        // cache the error handling wrapper for injected hooks so the same hook
	        // can be properly deduped by the scheduler. "__weh" stands for "with error
	        // handling".
	        const wrappedHook = hook.__weh ||
	            (hook.__weh = (...args) => {
	                if (target.isUnmounted) {
	                    return;
	                }
	                // disable tracking inside all lifecycle hooks
	                // since they can potentially be called inside effects.
	                pauseTracking();
	                // Set currentInstance during hook invocation.
	                // This assumes the hook does not synchronously trigger other hooks, which
	                // can only be false when the user does something really funky.
	                setCurrentInstance(target);
	                const res = callWithAsyncErrorHandling(hook, target, type, args);
	                setCurrentInstance(null);
	                resetTracking();
	                return res;
	            });
	        if (prepend) {
	            hooks.unshift(wrappedHook);
	        }
	        else {
	            hooks.push(wrappedHook);
	        }
	        return wrappedHook;
	    }
	    else {
	        const apiName = toHandlerKey(ErrorTypeStrings[type].replace(/ hook$/, ''));
	        warn(`${apiName} is called when there is no active component instance to be ` +
	            `associated with. ` +
	            `Lifecycle injection APIs can only be used during execution of setup().` +
	            ( ` If you are using async setup(), make sure to register lifecycle ` +
	                    `hooks before the first await statement.`
	                ));
	    }
	}
	const createHook = (lifecycle) => (hook, target = currentInstance) => 
	// post-create lifecycle registrations are noops during SSR
	!isInSSRComponentSetup && injectHook(lifecycle, hook, target);
	const onBeforeMount = createHook("bm" /* BEFORE_MOUNT */);
	const onMounted = createHook("m" /* MOUNTED */);
	const onBeforeUpdate = createHook("bu" /* BEFORE_UPDATE */);
	const onUpdated = createHook("u" /* UPDATED */);
	const onBeforeUnmount = createHook("bum" /* BEFORE_UNMOUNT */);
	const onUnmounted = createHook("um" /* UNMOUNTED */);
	const onRenderTriggered = createHook("rtg" /* RENDER_TRIGGERED */);
	const onRenderTracked = createHook("rtc" /* RENDER_TRACKED */);
	const onErrorCaptured = (hook, target = currentInstance) => {
	    injectHook("ec" /* ERROR_CAPTURED */, hook, target);
	};

	// Simple effect.
	function watchEffect(effect, options) {
	    return doWatch(effect, null, options);
	}
	// initial value for watchers to trigger on undefined initial values
	const INITIAL_WATCHER_VALUE = {};
	// implementation
	function watch(source, cb, options) {
	    if ( !isFunction(cb)) {
	        warn(`\`watch(fn, options?)\` signature has been moved to a separate API. ` +
	            `Use \`watchEffect(fn, options?)\` instead. \`watch\` now only ` +
	            `supports \`watch(source, cb, options?) signature.`);
	    }
	    return doWatch(source, cb, options);
	}
	function doWatch(source, cb, { immediate, deep, flush, onTrack, onTrigger } = EMPTY_OBJ, instance = currentInstance) {
	    if ( !cb) {
	        if (immediate !== undefined) {
	            warn(`watch() "immediate" option is only respected when using the ` +
	                `watch(source, callback, options?) signature.`);
	        }
	        if (deep !== undefined) {
	            warn(`watch() "deep" option is only respected when using the ` +
	                `watch(source, callback, options?) signature.`);
	        }
	    }
	    const warnInvalidSource = (s) => {
	        warn(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, ` +
	            `a reactive object, or an array of these types.`);
	    };
	    let getter;
	    let forceTrigger = false;
	    if (isRef(source)) {
	        getter = () => source.value;
	        forceTrigger = !!source._shallow;
	    }
	    else if (isReactive(source)) {
	        getter = () => source;
	        deep = true;
	    }
	    else if (isArray(source)) {
	        getter = () => source.map(s => {
	            if (isRef(s)) {
	                return s.value;
	            }
	            else if (isReactive(s)) {
	                return traverse(s);
	            }
	            else if (isFunction(s)) {
	                return callWithErrorHandling(s, instance, 2 /* WATCH_GETTER */);
	            }
	            else {
	                 warnInvalidSource(s);
	            }
	        });
	    }
	    else if (isFunction(source)) {
	        if (cb) {
	            // getter with cb
	            getter = () => callWithErrorHandling(source, instance, 2 /* WATCH_GETTER */);
	        }
	        else {
	            // no cb -> simple effect
	            getter = () => {
	                if (instance && instance.isUnmounted) {
	                    return;
	                }
	                if (cleanup) {
	                    cleanup();
	                }
	                return callWithErrorHandling(source, instance, 3 /* WATCH_CALLBACK */, [onInvalidate]);
	            };
	        }
	    }
	    else {
	        getter = NOOP;
	         warnInvalidSource(source);
	    }
	    if (cb && deep) {
	        const baseGetter = getter;
	        getter = () => traverse(baseGetter());
	    }
	    let cleanup;
	    const onInvalidate = (fn) => {
	        cleanup = runner.options.onStop = () => {
	            callWithErrorHandling(fn, instance, 4 /* WATCH_CLEANUP */);
	        };
	    };
	    let oldValue = isArray(source) ? [] : INITIAL_WATCHER_VALUE;
	    const job = () => {
	        if (!runner.active) {
	            return;
	        }
	        if (cb) {
	            // watch(source, cb)
	            const newValue = runner();
	            if (deep || forceTrigger || hasChanged(newValue, oldValue)) {
	                // cleanup before running cb again
	                if (cleanup) {
	                    cleanup();
	                }
	                callWithAsyncErrorHandling(cb, instance, 3 /* WATCH_CALLBACK */, [
	                    newValue,
	                    // pass undefined as the old value when it's changed for the first time
	                    oldValue === INITIAL_WATCHER_VALUE ? undefined : oldValue,
	                    onInvalidate
	                ]);
	                oldValue = newValue;
	            }
	        }
	        else {
	            // watchEffect
	            runner();
	        }
	    };
	    // important: mark the job as a watcher callback so that scheduler knows
	    // it is allowed to self-trigger (#1727)
	    job.allowRecurse = !!cb;
	    let scheduler;
	    if (flush === 'sync') {
	        scheduler = job;
	    }
	    else if (flush === 'post') {
	        scheduler = () => queuePostRenderEffect(job, instance && instance.suspense);
	    }
	    else {
	        // default: 'pre'
	        scheduler = () => {
	            if (!instance || instance.isMounted) {
	                queuePreFlushCb(job);
	            }
	            else {
	                // with 'pre' option, the first call must happen before
	                // the component is mounted so it is called synchronously.
	                job();
	            }
	        };
	    }
	    const runner = effect(getter, {
	        lazy: true,
	        onTrack,
	        onTrigger,
	        scheduler
	    });
	    recordInstanceBoundEffect(runner, instance);
	    // initial run
	    if (cb) {
	        if (immediate) {
	            job();
	        }
	        else {
	            oldValue = runner();
	        }
	    }
	    else if (flush === 'post') {
	        queuePostRenderEffect(runner, instance && instance.suspense);
	    }
	    else {
	        runner();
	    }
	    return () => {
	        stop(runner);
	        if (instance) {
	            remove(instance.effects, runner);
	        }
	    };
	}
	// this.$watch
	function instanceWatch(source, cb, options) {
	    const publicThis = this.proxy;
	    const getter = isString(source)
	        ? () => publicThis[source]
	        : source.bind(publicThis);
	    return doWatch(getter, cb.bind(publicThis), options, this);
	}
	function traverse(value, seen = new Set()) {
	    if (!isObject(value) || seen.has(value)) {
	        return value;
	    }
	    seen.add(value);
	    if (isRef(value)) {
	        traverse(value.value, seen);
	    }
	    else if (isArray(value)) {
	        for (let i = 0; i < value.length; i++) {
	            traverse(value[i], seen);
	        }
	    }
	    else if (isSet(value) || isMap(value)) {
	        value.forEach((v) => {
	            traverse(v, seen);
	        });
	    }
	    else {
	        for (const key in value) {
	            traverse(value[key], seen);
	        }
	    }
	    return value;
	}

	function useTransitionState() {
	    const state = {
	        isMounted: false,
	        isLeaving: false,
	        isUnmounting: false,
	        leavingVNodes: new Map()
	    };
	    onMounted(() => {
	        state.isMounted = true;
	    });
	    onBeforeUnmount(() => {
	        state.isUnmounting = true;
	    });
	    return state;
	}
	const TransitionHookValidator = [Function, Array];
	const BaseTransitionImpl = {
	    name: `BaseTransition`,
	    props: {
	        mode: String,
	        appear: Boolean,
	        persisted: Boolean,
	        // enter
	        onBeforeEnter: TransitionHookValidator,
	        onEnter: TransitionHookValidator,
	        onAfterEnter: TransitionHookValidator,
	        onEnterCancelled: TransitionHookValidator,
	        // leave
	        onBeforeLeave: TransitionHookValidator,
	        onLeave: TransitionHookValidator,
	        onAfterLeave: TransitionHookValidator,
	        onLeaveCancelled: TransitionHookValidator,
	        // appear
	        onBeforeAppear: TransitionHookValidator,
	        onAppear: TransitionHookValidator,
	        onAfterAppear: TransitionHookValidator,
	        onAppearCancelled: TransitionHookValidator
	    },
	    setup(props, { slots }) {
	        const instance = getCurrentInstance();
	        const state = useTransitionState();
	        let prevTransitionKey;
	        return () => {
	            const children = slots.default && getTransitionRawChildren(slots.default(), true);
	            if (!children || !children.length) {
	                return;
	            }
	            // warn multiple elements
	            if ( children.length > 1) {
	                warn('<transition> can only be used on a single element or component. Use ' +
	                    '<transition-group> for lists.');
	            }
	            // there's no need to track reactivity for these props so use the raw
	            // props for a bit better perf
	            const rawProps = toRaw(props);
	            const { mode } = rawProps;
	            // check mode
	            if ( mode && !['in-out', 'out-in', 'default'].includes(mode)) {
	                warn(`invalid <transition> mode: ${mode}`);
	            }
	            // at this point children has a guaranteed length of 1.
	            const child = children[0];
	            if (state.isLeaving) {
	                return emptyPlaceholder(child);
	            }
	            // in the case of <transition><keep-alive/></transition>, we need to
	            // compare the type of the kept-alive children.
	            const innerChild = getKeepAliveChild(child);
	            if (!innerChild) {
	                return emptyPlaceholder(child);
	            }
	            const enterHooks = resolveTransitionHooks(innerChild, rawProps, state, instance);
	            setTransitionHooks(innerChild, enterHooks);
	            const oldChild = instance.subTree;
	            const oldInnerChild = oldChild && getKeepAliveChild(oldChild);
	            let transitionKeyChanged = false;
	            const { getTransitionKey } = innerChild.type;
	            if (getTransitionKey) {
	                const key = getTransitionKey();
	                if (prevTransitionKey === undefined) {
	                    prevTransitionKey = key;
	                }
	                else if (key !== prevTransitionKey) {
	                    prevTransitionKey = key;
	                    transitionKeyChanged = true;
	                }
	            }
	            // handle mode
	            if (oldInnerChild &&
	                oldInnerChild.type !== Comment &&
	                (!isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
	                const leavingHooks = resolveTransitionHooks(oldInnerChild, rawProps, state, instance);
	                // update old tree's hooks in case of dynamic transition
	                setTransitionHooks(oldInnerChild, leavingHooks);
	                // switching between different views
	                if (mode === 'out-in') {
	                    state.isLeaving = true;
	                    // return placeholder node and queue update when leave finishes
	                    leavingHooks.afterLeave = () => {
	                        state.isLeaving = false;
	                        instance.update();
	                    };
	                    return emptyPlaceholder(child);
	                }
	                else if (mode === 'in-out') {
	                    leavingHooks.delayLeave = (el, earlyRemove, delayedLeave) => {
	                        const leavingVNodesCache = getLeavingNodesForType(state, oldInnerChild);
	                        leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
	                        // early removal callback
	                        el._leaveCb = () => {
	                            earlyRemove();
	                            el._leaveCb = undefined;
	                            delete enterHooks.delayedLeave;
	                        };
	                        enterHooks.delayedLeave = delayedLeave;
	                    };
	                }
	            }
	            return child;
	        };
	    }
	};
	// export the public type for h/tsx inference
	// also to avoid inline import() in generated d.ts files
	const BaseTransition = BaseTransitionImpl;
	function getLeavingNodesForType(state, vnode) {
	    const { leavingVNodes } = state;
	    let leavingVNodesCache = leavingVNodes.get(vnode.type);
	    if (!leavingVNodesCache) {
	        leavingVNodesCache = Object.create(null);
	        leavingVNodes.set(vnode.type, leavingVNodesCache);
	    }
	    return leavingVNodesCache;
	}
	// The transition hooks are attached to the vnode as vnode.transition
	// and will be called at appropriate timing in the renderer.
	function resolveTransitionHooks(vnode, props, state, instance) {
	    const { appear, mode, persisted = false, onBeforeEnter, onEnter, onAfterEnter, onEnterCancelled, onBeforeLeave, onLeave, onAfterLeave, onLeaveCancelled, onBeforeAppear, onAppear, onAfterAppear, onAppearCancelled } = props;
	    const key = String(vnode.key);
	    const leavingVNodesCache = getLeavingNodesForType(state, vnode);
	    const callHook = (hook, args) => {
	        hook &&
	            callWithAsyncErrorHandling(hook, instance, 9 /* TRANSITION_HOOK */, args);
	    };
	    const hooks = {
	        mode,
	        persisted,
	        beforeEnter(el) {
	            let hook = onBeforeEnter;
	            if (!state.isMounted) {
	                if (appear) {
	                    hook = onBeforeAppear || onBeforeEnter;
	                }
	                else {
	                    return;
	                }
	            }
	            // for same element (v-show)
	            if (el._leaveCb) {
	                el._leaveCb(true /* cancelled */);
	            }
	            // for toggled element with same key (v-if)
	            const leavingVNode = leavingVNodesCache[key];
	            if (leavingVNode &&
	                isSameVNodeType(vnode, leavingVNode) &&
	                leavingVNode.el._leaveCb) {
	                // force early removal (not cancelled)
	                leavingVNode.el._leaveCb();
	            }
	            callHook(hook, [el]);
	        },
	        enter(el) {
	            let hook = onEnter;
	            let afterHook = onAfterEnter;
	            let cancelHook = onEnterCancelled;
	            if (!state.isMounted) {
	                if (appear) {
	                    hook = onAppear || onEnter;
	                    afterHook = onAfterAppear || onAfterEnter;
	                    cancelHook = onAppearCancelled || onEnterCancelled;
	                }
	                else {
	                    return;
	                }
	            }
	            let called = false;
	            const done = (el._enterCb = (cancelled) => {
	                if (called)
	                    return;
	                called = true;
	                if (cancelled) {
	                    callHook(cancelHook, [el]);
	                }
	                else {
	                    callHook(afterHook, [el]);
	                }
	                if (hooks.delayedLeave) {
	                    hooks.delayedLeave();
	                }
	                el._enterCb = undefined;
	            });
	            if (hook) {
	                hook(el, done);
	                if (hook.length <= 1) {
	                    done();
	                }
	            }
	            else {
	                done();
	            }
	        },
	        leave(el, remove) {
	            const key = String(vnode.key);
	            if (el._enterCb) {
	                el._enterCb(true /* cancelled */);
	            }
	            if (state.isUnmounting) {
	                return remove();
	            }
	            callHook(onBeforeLeave, [el]);
	            let called = false;
	            const done = (el._leaveCb = (cancelled) => {
	                if (called)
	                    return;
	                called = true;
	                remove();
	                if (cancelled) {
	                    callHook(onLeaveCancelled, [el]);
	                }
	                else {
	                    callHook(onAfterLeave, [el]);
	                }
	                el._leaveCb = undefined;
	                if (leavingVNodesCache[key] === vnode) {
	                    delete leavingVNodesCache[key];
	                }
	            });
	            leavingVNodesCache[key] = vnode;
	            if (onLeave) {
	                onLeave(el, done);
	                if (onLeave.length <= 1) {
	                    done();
	                }
	            }
	            else {
	                done();
	            }
	        },
	        clone(vnode) {
	            return resolveTransitionHooks(vnode, props, state, instance);
	        }
	    };
	    return hooks;
	}
	// the placeholder really only handles one special case: KeepAlive
	// in the case of a KeepAlive in a leave phase we need to return a KeepAlive
	// placeholder with empty content to avoid the KeepAlive instance from being
	// unmounted.
	function emptyPlaceholder(vnode) {
	    if (isKeepAlive(vnode)) {
	        vnode = cloneVNode(vnode);
	        vnode.children = null;
	        return vnode;
	    }
	}
	function getKeepAliveChild(vnode) {
	    return isKeepAlive(vnode)
	        ? vnode.children
	            ? vnode.children[0]
	            : undefined
	        : vnode;
	}
	function setTransitionHooks(vnode, hooks) {
	    if (vnode.shapeFlag & 6 /* COMPONENT */ && vnode.component) {
	        setTransitionHooks(vnode.component.subTree, hooks);
	    }
	    else if ( vnode.shapeFlag & 128 /* SUSPENSE */) {
	        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
	        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
	    }
	    else {
	        vnode.transition = hooks;
	    }
	}
	function getTransitionRawChildren(children, keepComment = false) {
	    let ret = [];
	    let keyedFragmentCount = 0;
	    for (let i = 0; i < children.length; i++) {
	        const child = children[i];
	        // handle fragment children case, e.g. v-for
	        if (child.type === Fragment) {
	            if (child.patchFlag & 128 /* KEYED_FRAGMENT */)
	                keyedFragmentCount++;
	            ret = ret.concat(getTransitionRawChildren(child.children, keepComment));
	        }
	        // comment placeholders should be skipped, e.g. v-if
	        else if (keepComment || child.type !== Comment) {
	            ret.push(child);
	        }
	    }
	    // #1126 if a transition children list contains multiple sub fragments, these
	    // fragments will be merged into a flat children array. Since each v-for
	    // fragment may contain different static bindings inside, we need to de-op
	    // these children to force full diffs to ensure correct behavior.
	    if (keyedFragmentCount > 1) {
	        for (let i = 0; i < ret.length; i++) {
	            ret[i].patchFlag = -2 /* BAIL */;
	        }
	    }
	    return ret;
	}

	const isKeepAlive = (vnode) => vnode.type.__isKeepAlive;
	const KeepAliveImpl = {
	    name: `KeepAlive`,
	    // Marker for special handling inside the renderer. We are not using a ===
	    // check directly on KeepAlive in the renderer, because importing it directly
	    // would prevent it from being tree-shaken.
	    __isKeepAlive: true,
	    inheritRef: true,
	    props: {
	        include: [String, RegExp, Array],
	        exclude: [String, RegExp, Array],
	        max: [String, Number]
	    },
	    setup(props, { slots }) {
	        const cache = new Map();
	        const keys = new Set();
	        let current = null;
	        const instance = getCurrentInstance();
	        const parentSuspense = instance.suspense;
	        // KeepAlive communicates with the instantiated renderer via the
	        // ctx where the renderer passes in its internals,
	        // and the KeepAlive instance exposes activate/deactivate implementations.
	        // The whole point of this is to avoid importing KeepAlive directly in the
	        // renderer to facilitate tree-shaking.
	        const sharedContext = instance.ctx;
	        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement } } } = sharedContext;
	        const storageContainer = createElement('div');
	        sharedContext.activate = (vnode, container, anchor, isSVG, optimized) => {
	            const instance = vnode.component;
	            move(vnode, container, anchor, 0 /* ENTER */, parentSuspense);
	            // in case props have changed
	            patch(instance.vnode, vnode, container, anchor, instance, parentSuspense, isSVG, optimized);
	            queuePostRenderEffect(() => {
	                instance.isDeactivated = false;
	                if (instance.a) {
	                    invokeArrayFns(instance.a);
	                }
	                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
	                if (vnodeHook) {
	                    invokeVNodeHook(vnodeHook, instance.parent, vnode);
	                }
	            }, parentSuspense);
	        };
	        sharedContext.deactivate = (vnode) => {
	            const instance = vnode.component;
	            move(vnode, storageContainer, null, 1 /* LEAVE */, parentSuspense);
	            queuePostRenderEffect(() => {
	                if (instance.da) {
	                    invokeArrayFns(instance.da);
	                }
	                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
	                if (vnodeHook) {
	                    invokeVNodeHook(vnodeHook, instance.parent, vnode);
	                }
	                instance.isDeactivated = true;
	            }, parentSuspense);
	        };
	        function unmount(vnode) {
	            // reset the shapeFlag so it can be properly unmounted
	            resetShapeFlag(vnode);
	            _unmount(vnode, instance, parentSuspense);
	        }
	        function pruneCache(filter) {
	            cache.forEach((vnode, key) => {
	                const name = getComponentName(vnode.type);
	                if (name && (!filter || !filter(name))) {
	                    pruneCacheEntry(key);
	                }
	            });
	        }
	        function pruneCacheEntry(key) {
	            const cached = cache.get(key);
	            if (!current || cached.type !== current.type) {
	                unmount(cached);
	            }
	            else if (current) {
	                // current active instance should no longer be kept-alive.
	                // we can't unmount it now but it might be later, so reset its flag now.
	                resetShapeFlag(current);
	            }
	            cache.delete(key);
	            keys.delete(key);
	        }
	        // prune cache on include/exclude prop change
	        watch(() => [props.include, props.exclude], ([include, exclude]) => {
	            include && pruneCache(name => matches(include, name));
	            exclude && pruneCache(name => !matches(exclude, name));
	        }, 
	        // prune post-render after `current` has been updated
	        { flush: 'post', deep: true });
	        // cache sub tree after render
	        let pendingCacheKey = null;
	        const cacheSubtree = () => {
	            // fix #1621, the pendingCacheKey could be 0
	            if (pendingCacheKey != null) {
	                cache.set(pendingCacheKey, getInnerChild(instance.subTree));
	            }
	        };
	        onMounted(cacheSubtree);
	        onUpdated(cacheSubtree);
	        onBeforeUnmount(() => {
	            cache.forEach(cached => {
	                const { subTree, suspense } = instance;
	                const vnode = getInnerChild(subTree);
	                if (cached.type === vnode.type) {
	                    // current instance will be unmounted as part of keep-alive's unmount
	                    resetShapeFlag(vnode);
	                    // but invoke its deactivated hook here
	                    const da = vnode.component.da;
	                    da && queuePostRenderEffect(da, suspense);
	                    return;
	                }
	                unmount(cached);
	            });
	        });
	        return () => {
	            pendingCacheKey = null;
	            if (!slots.default) {
	                return null;
	            }
	            const children = slots.default();
	            const rawVNode = children[0];
	            if (children.length > 1) {
	                {
	                    warn(`KeepAlive should contain exactly one component child.`);
	                }
	                current = null;
	                return children;
	            }
	            else if (!isVNode(rawVNode) ||
	                (!(rawVNode.shapeFlag & 4 /* STATEFUL_COMPONENT */) &&
	                    !(rawVNode.shapeFlag & 128 /* SUSPENSE */))) {
	                current = null;
	                return rawVNode;
	            }
	            let vnode = getInnerChild(rawVNode);
	            const comp = vnode.type;
	            const name = getComponentName(comp);
	            const { include, exclude, max } = props;
	            if ((include && (!name || !matches(include, name))) ||
	                (exclude && name && matches(exclude, name))) {
	                current = vnode;
	                return rawVNode;
	            }
	            const key = vnode.key == null ? comp : vnode.key;
	            const cachedVNode = cache.get(key);
	            // clone vnode if it's reused because we are going to mutate it
	            if (vnode.el) {
	                vnode = cloneVNode(vnode);
	                if (rawVNode.shapeFlag & 128 /* SUSPENSE */) {
	                    rawVNode.ssContent = vnode;
	                }
	            }
	            // #1513 it's possible for the returned vnode to be cloned due to attr
	            // fallthrough or scopeId, so the vnode here may not be the final vnode
	            // that is mounted. Instead of caching it directly, we store the pending
	            // key and cache `instance.subTree` (the normalized vnode) in
	            // beforeMount/beforeUpdate hooks.
	            pendingCacheKey = key;
	            if (cachedVNode) {
	                // copy over mounted state
	                vnode.el = cachedVNode.el;
	                vnode.component = cachedVNode.component;
	                if (vnode.transition) {
	                    // recursively update transition hooks on subTree
	                    setTransitionHooks(vnode, vnode.transition);
	                }
	                // avoid vnode being mounted as fresh
	                vnode.shapeFlag |= 512 /* COMPONENT_KEPT_ALIVE */;
	                // make this key the freshest
	                keys.delete(key);
	                keys.add(key);
	            }
	            else {
	                keys.add(key);
	                // prune oldest entry
	                if (max && keys.size > parseInt(max, 10)) {
	                    pruneCacheEntry(keys.values().next().value);
	                }
	            }
	            // avoid vnode being unmounted
	            vnode.shapeFlag |= 256 /* COMPONENT_SHOULD_KEEP_ALIVE */;
	            current = vnode;
	            return rawVNode;
	        };
	    }
	};
	// export the public type for h/tsx inference
	// also to avoid inline import() in generated d.ts files
	const KeepAlive = KeepAliveImpl;
	function matches(pattern, name) {
	    if (isArray(pattern)) {
	        return pattern.some((p) => matches(p, name));
	    }
	    else if (isString(pattern)) {
	        return pattern.split(',').indexOf(name) > -1;
	    }
	    else if (pattern.test) {
	        return pattern.test(name);
	    }
	    /* istanbul ignore next */
	    return false;
	}
	function onActivated(hook, target) {
	    registerKeepAliveHook(hook, "a" /* ACTIVATED */, target);
	}
	function onDeactivated(hook, target) {
	    registerKeepAliveHook(hook, "da" /* DEACTIVATED */, target);
	}
	function registerKeepAliveHook(hook, type, target = currentInstance) {
	    // cache the deactivate branch check wrapper for injected hooks so the same
	    // hook can be properly deduped by the scheduler. "__wdc" stands for "with
	    // deactivation check".
	    const wrappedHook = hook.__wdc ||
	        (hook.__wdc = () => {
	            // only fire the hook if the target instance is NOT in a deactivated branch.
	            let current = target;
	            while (current) {
	                if (current.isDeactivated) {
	                    return;
	                }
	                current = current.parent;
	            }
	            hook();
	        });
	    injectHook(type, wrappedHook, target);
	    // In addition to registering it on the target instance, we walk up the parent
	    // chain and register it on all ancestor instances that are keep-alive roots.
	    // This avoids the need to walk the entire component tree when invoking these
	    // hooks, and more importantly, avoids the need to track child components in
	    // arrays.
	    if (target) {
	        let current = target.parent;
	        while (current && current.parent) {
	            if (isKeepAlive(current.parent.vnode)) {
	                injectToKeepAliveRoot(wrappedHook, type, target, current);
	            }
	            current = current.parent;
	        }
	    }
	}
	function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
	    // injectHook wraps the original for error handling, so make sure to remove
	    // the wrapped version.
	    const injected = injectHook(type, hook, keepAliveRoot, true /* prepend */);
	    onUnmounted(() => {
	        remove(keepAliveRoot[type], injected);
	    }, target);
	}
	function resetShapeFlag(vnode) {
	    let shapeFlag = vnode.shapeFlag;
	    if (shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */) {
	        shapeFlag -= 256 /* COMPONENT_SHOULD_KEEP_ALIVE */;
	    }
	    if (shapeFlag & 512 /* COMPONENT_KEPT_ALIVE */) {
	        shapeFlag -= 512 /* COMPONENT_KEPT_ALIVE */;
	    }
	    vnode.shapeFlag = shapeFlag;
	}
	function getInnerChild(vnode) {
	    return vnode.shapeFlag & 128 /* SUSPENSE */ ? vnode.ssContent : vnode;
	}

	const isInternalKey = (key) => key[0] === '_' || key === '$stable';
	const normalizeSlotValue = (value) => isArray(value)
	    ? value.map(normalizeVNode)
	    : [normalizeVNode(value)];
	const normalizeSlot = (key, rawSlot, ctx) => withCtx((props) => {
	    if ( currentInstance) {
	        warn(`Slot "${key}" invoked outside of the render function: ` +
	            `this will not track dependencies used in the slot. ` +
	            `Invoke the slot function inside the render function instead.`);
	    }
	    return normalizeSlotValue(rawSlot(props));
	}, ctx);
	const normalizeObjectSlots = (rawSlots, slots) => {
	    const ctx = rawSlots._ctx;
	    for (const key in rawSlots) {
	        if (isInternalKey(key))
	            continue;
	        const value = rawSlots[key];
	        if (isFunction(value)) {
	            slots[key] = normalizeSlot(key, value, ctx);
	        }
	        else if (value != null) {
	            {
	                warn(`Non-function value encountered for slot "${key}". ` +
	                    `Prefer function slots for better performance.`);
	            }
	            const normalized = normalizeSlotValue(value);
	            slots[key] = () => normalized;
	        }
	    }
	};
	const normalizeVNodeSlots = (instance, children) => {
	    if ( !isKeepAlive(instance.vnode)) {
	        warn(`Non-function value encountered for default slot. ` +
	            `Prefer function slots for better performance.`);
	    }
	    const normalized = normalizeSlotValue(children);
	    instance.slots.default = () => normalized;
	};
	const initSlots = (instance, children) => {
	    if (instance.vnode.shapeFlag & 32 /* SLOTS_CHILDREN */) {
	        const type = children._;
	        if (type) {
	            instance.slots = children;
	            // make compiler marker non-enumerable
	            def(children, '_', type);
	        }
	        else {
	            normalizeObjectSlots(children, (instance.slots = {}));
	        }
	    }
	    else {
	        instance.slots = {};
	        if (children) {
	            normalizeVNodeSlots(instance, children);
	        }
	    }
	    def(instance.slots, InternalObjectKey, 1);
	};
	const updateSlots = (instance, children) => {
	    const { vnode, slots } = instance;
	    let needDeletionCheck = true;
	    let deletionComparisonTarget = EMPTY_OBJ;
	    if (vnode.shapeFlag & 32 /* SLOTS_CHILDREN */) {
	        const type = children._;
	        if (type) {
	            // compiled slots.
	            if ( isHmrUpdating) {
	                // Parent was HMR updated so slot content may have changed.
	                // force update slots and mark instance for hmr as well
	                extend(slots, children);
	            }
	            else if (type === 1 /* STABLE */) {
	                // compiled AND stable.
	                // no need to update, and skip stale slots removal.
	                needDeletionCheck = false;
	            }
	            else {
	                // compiled but dynamic (v-if/v-for on slots) - update slots, but skip
	                // normalization.
	                extend(slots, children);
	            }
	        }
	        else {
	            needDeletionCheck = !children.$stable;
	            normalizeObjectSlots(children, slots);
	        }
	        deletionComparisonTarget = children;
	    }
	    else if (children) {
	        // non slot object children (direct value) passed to a component
	        normalizeVNodeSlots(instance, children);
	        deletionComparisonTarget = { default: 1 };
	    }
	    // delete stale slots
	    if (needDeletionCheck) {
	        for (const key in slots) {
	            if (!isInternalKey(key) && !(key in deletionComparisonTarget)) {
	                delete slots[key];
	            }
	        }
	    }
	};

	/**
	Runtime helper for applying directives to a vnode. Example usage:

	const comp = resolveComponent('comp')
	const foo = resolveDirective('foo')
	const bar = resolveDirective('bar')

	return withDirectives(h(comp), [
	  [foo, this.x],
	  [bar, this.y]
	])
	*/
	const isBuiltInDirective = /*#__PURE__*/ makeMap('bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text');
	function validateDirectiveName(name) {
	    if (isBuiltInDirective(name)) {
	        warn('Do not use built-in directive ids as custom directive id: ' + name);
	    }
	}
	/**
	 * Adds directives to a VNode.
	 */
	function withDirectives(vnode, directives) {
	    const internalInstance = currentRenderingInstance;
	    if (internalInstance === null) {
	         warn(`withDirectives can only be used inside render functions.`);
	        return vnode;
	    }
	    const instance = internalInstance.proxy;
	    const bindings = vnode.dirs || (vnode.dirs = []);
	    for (let i = 0; i < directives.length; i++) {
	        let [dir, value, arg, modifiers = EMPTY_OBJ] = directives[i];
	        if (isFunction(dir)) {
	            dir = {
	                mounted: dir,
	                updated: dir
	            };
	        }
	        bindings.push({
	            dir,
	            instance,
	            value,
	            oldValue: void 0,
	            arg,
	            modifiers
	        });
	    }
	    return vnode;
	}
	function invokeDirectiveHook(vnode, prevVNode, instance, name) {
	    const bindings = vnode.dirs;
	    const oldBindings = prevVNode && prevVNode.dirs;
	    for (let i = 0; i < bindings.length; i++) {
	        const binding = bindings[i];
	        if (oldBindings) {
	            binding.oldValue = oldBindings[i].value;
	        }
	        const hook = binding.dir[name];
	        if (hook) {
	            callWithAsyncErrorHandling(hook, instance, 8 /* DIRECTIVE_HOOK */, [
	                vnode.el,
	                binding,
	                vnode,
	                prevVNode
	            ]);
	        }
	    }
	}

	function createAppContext() {
	    return {
	        app: null,
	        config: {
	            isNativeTag: NO,
	            performance: false,
	            globalProperties: {},
	            optionMergeStrategies: {},
	            isCustomElement: NO,
	            errorHandler: undefined,
	            warnHandler: undefined
	        },
	        mixins: [],
	        components: {},
	        directives: {},
	        provides: Object.create(null)
	    };
	}
	let uid$1 = 0;
	function createAppAPI(render, hydrate) {
	    return function createApp(rootComponent, rootProps = null) {
	        if (rootProps != null && !isObject(rootProps)) {
	             warn(`root props passed to app.mount() must be an object.`);
	            rootProps = null;
	        }
	        const context = createAppContext();
	        const installedPlugins = new Set();
	        let isMounted = false;
	        const app = (context.app = {
	            _uid: uid$1++,
	            _component: rootComponent,
	            _props: rootProps,
	            _container: null,
	            _context: context,
	            version,
	            get config() {
	                return context.config;
	            },
	            set config(v) {
	                {
	                    warn(`app.config cannot be replaced. Modify individual options instead.`);
	                }
	            },
	            use(plugin, ...options) {
	                if (installedPlugins.has(plugin)) {
	                     warn(`Plugin has already been applied to target app.`);
	                }
	                else if (plugin && isFunction(plugin.install)) {
	                    installedPlugins.add(plugin);
	                    plugin.install(app, ...options);
	                }
	                else if (isFunction(plugin)) {
	                    installedPlugins.add(plugin);
	                    plugin(app, ...options);
	                }
	                else {
	                    warn(`A plugin must either be a function or an object with an "install" ` +
	                        `function.`);
	                }
	                return app;
	            },
	            mixin(mixin) {
	                {
	                    if (!context.mixins.includes(mixin)) {
	                        context.mixins.push(mixin);
	                        // global mixin with props/emits de-optimizes props/emits
	                        // normalization caching.
	                        if (mixin.props || mixin.emits) {
	                            context.deopt = true;
	                        }
	                    }
	                    else {
	                        warn('Mixin has already been applied to target app' +
	                            (mixin.name ? `: ${mixin.name}` : ''));
	                    }
	                }
	                return app;
	            },
	            component(name, component) {
	                {
	                    validateComponentName(name, context.config);
	                }
	                if (!component) {
	                    return context.components[name];
	                }
	                if ( context.components[name]) {
	                    warn(`Component "${name}" has already been registered in target app.`);
	                }
	                context.components[name] = component;
	                return app;
	            },
	            directive(name, directive) {
	                {
	                    validateDirectiveName(name);
	                }
	                if (!directive) {
	                    return context.directives[name];
	                }
	                if ( context.directives[name]) {
	                    warn(`Directive "${name}" has already been registered in target app.`);
	                }
	                context.directives[name] = directive;
	                return app;
	            },
	            mount(rootContainer, isHydrate) {
	                if (!isMounted) {
	                    const vnode = createVNode(rootComponent, rootProps);
	                    // store app context on the root VNode.
	                    // this will be set on the root instance on initial mount.
	                    vnode.appContext = context;
	                    // HMR root reload
	                    {
	                        context.reload = () => {
	                            render(cloneVNode(vnode), rootContainer);
	                        };
	                    }
	                    if (isHydrate && hydrate) {
	                        hydrate(vnode, rootContainer);
	                    }
	                    else {
	                        render(vnode, rootContainer);
	                    }
	                    isMounted = true;
	                    app._container = rootContainer;
	                    rootContainer.__vue_app__ = app;
	                    {
	                        devtoolsInitApp(app, version);
	                    }
	                    return vnode.component.proxy;
	                }
	                else {
	                    warn(`App has already been mounted.\n` +
	                        `If you want to remount the same app, move your app creation logic ` +
	                        `into a factory function and create fresh app instances for each ` +
	                        `mount - e.g. \`const createMyApp = () => createApp(App)\``);
	                }
	            },
	            unmount() {
	                if (isMounted) {
	                    render(null, app._container);
	                    {
	                        devtoolsUnmountApp(app);
	                    }
	                }
	                else {
	                    warn(`Cannot unmount an app that is not mounted.`);
	                }
	            },
	            provide(key, value) {
	                if ( key in context.provides) {
	                    warn(`App already provides property with key "${String(key)}". ` +
	                        `It will be overwritten with the new value.`);
	                }
	                // TypeScript doesn't allow symbols as index type
	                // https://github.com/Microsoft/TypeScript/issues/24587
	                context.provides[key] = value;
	                return app;
	            }
	        });
	        return app;
	    };
	}

	let hasMismatch = false;
	const isSVGContainer = (container) => /svg/.test(container.namespaceURI) && container.tagName !== 'foreignObject';
	const isComment = (node) => node.nodeType === 8 /* COMMENT */;
	// Note: hydration is DOM-specific
	// But we have to place it in core due to tight coupling with core - splitting
	// it out creates a ton of unnecessary complexity.
	// Hydration also depends on some renderer internal logic which needs to be
	// passed in via arguments.
	function createHydrationFunctions(rendererInternals) {
	    const { mt: mountComponent, p: patch, o: { patchProp, nextSibling, parentNode, remove, insert, createComment } } = rendererInternals;
	    const hydrate = (vnode, container) => {
	        if ( !container.hasChildNodes()) {
	            warn(`Attempting to hydrate existing markup but container is empty. ` +
	                `Performing full mount instead.`);
	            patch(null, vnode, container);
	            return;
	        }
	        hasMismatch = false;
	        hydrateNode(container.firstChild, vnode, null, null);
	        flushPostFlushCbs();
	        if (hasMismatch && !false) {
	            // this error should show up in production
	            console.error(`Hydration completed but contains mismatches.`);
	        }
	    };
	    const hydrateNode = (node, vnode, parentComponent, parentSuspense, optimized = false) => {
	        const isFragmentStart = isComment(node) && node.data === '[';
	        const onMismatch = () => handleMismatch(node, vnode, parentComponent, parentSuspense, isFragmentStart);
	        const { type, ref, shapeFlag } = vnode;
	        const domType = node.nodeType;
	        vnode.el = node;
	        let nextNode = null;
	        switch (type) {
	            case Text:
	                if (domType !== 3 /* TEXT */) {
	                    nextNode = onMismatch();
	                }
	                else {
	                    if (node.data !== vnode.children) {
	                        hasMismatch = true;
	                        
	                            warn(`Hydration text mismatch:` +
	                                `\n- Client: ${JSON.stringify(node.data)}` +
	                                `\n- Server: ${JSON.stringify(vnode.children)}`);
	                        node.data = vnode.children;
	                    }
	                    nextNode = nextSibling(node);
	                }
	                break;
	            case Comment:
	                if (domType !== 8 /* COMMENT */ || isFragmentStart) {
	                    nextNode = onMismatch();
	                }
	                else {
	                    nextNode = nextSibling(node);
	                }
	                break;
	            case Static:
	                if (domType !== 1 /* ELEMENT */) {
	                    nextNode = onMismatch();
	                }
	                else {
	                    // determine anchor, adopt content
	                    nextNode = node;
	                    // if the static vnode has its content stripped during build,
	                    // adopt it from the server-rendered HTML.
	                    const needToAdoptContent = !vnode.children.length;
	                    for (let i = 0; i < vnode.staticCount; i++) {
	                        if (needToAdoptContent)
	                            vnode.children += nextNode.outerHTML;
	                        if (i === vnode.staticCount - 1) {
	                            vnode.anchor = nextNode;
	                        }
	                        nextNode = nextSibling(nextNode);
	                    }
	                    return nextNode;
	                }
	                break;
	            case Fragment:
	                if (!isFragmentStart) {
	                    nextNode = onMismatch();
	                }
	                else {
	                    nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, optimized);
	                }
	                break;
	            default:
	                if (shapeFlag & 1 /* ELEMENT */) {
	                    if (domType !== 1 /* ELEMENT */ ||
	                        vnode.type !== node.tagName.toLowerCase()) {
	                        nextNode = onMismatch();
	                    }
	                    else {
	                        nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, optimized);
	                    }
	                }
	                else if (shapeFlag & 6 /* COMPONENT */) {
	                    // when setting up the render effect, if the initial vnode already
	                    // has .el set, the component will perform hydration instead of mount
	                    // on its sub-tree.
	                    const container = parentNode(node);
	                    const hydrateComponent = () => {
	                        mountComponent(vnode, container, null, parentComponent, parentSuspense, isSVGContainer(container), optimized);
	                    };
	                    // async component
	                    const loadAsync = vnode.type.__asyncLoader;
	                    if (loadAsync) {
	                        loadAsync().then(hydrateComponent);
	                    }
	                    else {
	                        hydrateComponent();
	                    }
	                    // component may be async, so in the case of fragments we cannot rely
	                    // on component's rendered output to determine the end of the fragment
	                    // instead, we do a lookahead to find the end anchor node.
	                    nextNode = isFragmentStart
	                        ? locateClosingAsyncAnchor(node)
	                        : nextSibling(node);
	                }
	                else if (shapeFlag & 64 /* TELEPORT */) {
	                    if (domType !== 8 /* COMMENT */) {
	                        nextNode = onMismatch();
	                    }
	                    else {
	                        nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, optimized, rendererInternals, hydrateChildren);
	                    }
	                }
	                else if ( shapeFlag & 128 /* SUSPENSE */) {
	                    nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, isSVGContainer(parentNode(node)), optimized, rendererInternals, hydrateNode);
	                }
	                else {
	                    warn('Invalid HostVNode type:', type, `(${typeof type})`);
	                }
	        }
	        if (ref != null) {
	            setRef(ref, null, parentSuspense, vnode);
	        }
	        return nextNode;
	    };
	    const hydrateElement = (el, vnode, parentComponent, parentSuspense, optimized) => {
	        optimized = optimized || !!vnode.dynamicChildren;
	        const { props, patchFlag, shapeFlag, dirs } = vnode;
	        // skip props & children if this is hoisted static nodes
	        if (patchFlag !== -1 /* HOISTED */) {
	            if (dirs) {
	                invokeDirectiveHook(vnode, null, parentComponent, 'created');
	            }
	            // props
	            if (props) {
	                if (!optimized ||
	                    (patchFlag & 16 /* FULL_PROPS */ ||
	                        patchFlag & 32 /* HYDRATE_EVENTS */)) {
	                    for (const key in props) {
	                        if (!isReservedProp(key) && isOn(key)) {
	                            patchProp(el, key, null, props[key]);
	                        }
	                    }
	                }
	                else if (props.onClick) {
	                    // Fast path for click listeners (which is most often) to avoid
	                    // iterating through props.
	                    patchProp(el, 'onClick', null, props.onClick);
	                }
	            }
	            // vnode / directive hooks
	            let vnodeHooks;
	            if ((vnodeHooks = props && props.onVnodeBeforeMount)) {
	                invokeVNodeHook(vnodeHooks, parentComponent, vnode);
	            }
	            if (dirs) {
	                invokeDirectiveHook(vnode, null, parentComponent, 'beforeMount');
	            }
	            if ((vnodeHooks = props && props.onVnodeMounted) || dirs) {
	                queueEffectWithSuspense(() => {
	                    vnodeHooks && invokeVNodeHook(vnodeHooks, parentComponent, vnode);
	                    dirs && invokeDirectiveHook(vnode, null, parentComponent, 'mounted');
	                }, parentSuspense);
	            }
	            // children
	            if (shapeFlag & 16 /* ARRAY_CHILDREN */ &&
	                // skip if element has innerHTML / textContent
	                !(props && (props.innerHTML || props.textContent))) {
	                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, optimized);
	                let hasWarned = false;
	                while (next) {
	                    hasMismatch = true;
	                    if ( !hasWarned) {
	                        warn(`Hydration children mismatch in <${vnode.type}>: ` +
	                            `server rendered element contains more child nodes than client vdom.`);
	                        hasWarned = true;
	                    }
	                    // The SSRed DOM contains more nodes than it should. Remove them.
	                    const cur = next;
	                    next = next.nextSibling;
	                    remove(cur);
	                }
	            }
	            else if (shapeFlag & 8 /* TEXT_CHILDREN */) {
	                if (el.textContent !== vnode.children) {
	                    hasMismatch = true;
	                    
	                        warn(`Hydration text content mismatch in <${vnode.type}>:\n` +
	                            `- Client: ${el.textContent}\n` +
	                            `- Server: ${vnode.children}`);
	                    el.textContent = vnode.children;
	                }
	            }
	        }
	        return el.nextSibling;
	    };
	    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, optimized) => {
	        optimized = optimized || !!parentVNode.dynamicChildren;
	        const children = parentVNode.children;
	        const l = children.length;
	        let hasWarned = false;
	        for (let i = 0; i < l; i++) {
	            const vnode = optimized
	                ? children[i]
	                : (children[i] = normalizeVNode(children[i]));
	            if (node) {
	                node = hydrateNode(node, vnode, parentComponent, parentSuspense, optimized);
	            }
	            else {
	                hasMismatch = true;
	                if ( !hasWarned) {
	                    warn(`Hydration children mismatch in <${container.tagName.toLowerCase()}>: ` +
	                        `server rendered element contains fewer child nodes than client vdom.`);
	                    hasWarned = true;
	                }
	                // the SSRed DOM didn't contain enough nodes. Mount the missing ones.
	                patch(null, vnode, container, null, parentComponent, parentSuspense, isSVGContainer(container));
	            }
	        }
	        return node;
	    };
	    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, optimized) => {
	        const container = parentNode(node);
	        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, optimized);
	        if (next && isComment(next) && next.data === ']') {
	            return nextSibling((vnode.anchor = next));
	        }
	        else {
	            // fragment didn't hydrate successfully, since we didn't get a end anchor
	            // back. This should have led to node/children mismatch warnings.
	            hasMismatch = true;
	            // since the anchor is missing, we need to create one and insert it
	            insert((vnode.anchor = createComment(`]`)), container, next);
	            return next;
	        }
	    };
	    const handleMismatch = (node, vnode, parentComponent, parentSuspense, isFragment) => {
	        hasMismatch = true;
	        
	            warn(`Hydration node mismatch:\n- Client vnode:`, vnode.type, `\n- Server rendered DOM:`, node, node.nodeType === 3 /* TEXT */
	                ? `(text)`
	                : isComment(node) && node.data === '['
	                    ? `(start of fragment)`
	                    : ``);
	        vnode.el = null;
	        if (isFragment) {
	            // remove excessive fragment nodes
	            const end = locateClosingAsyncAnchor(node);
	            while (true) {
	                const next = nextSibling(node);
	                if (next && next !== end) {
	                    remove(next);
	                }
	                else {
	                    break;
	                }
	            }
	        }
	        const next = nextSibling(node);
	        const container = parentNode(node);
	        remove(node);
	        patch(null, vnode, container, next, parentComponent, parentSuspense, isSVGContainer(container));
	        return next;
	    };
	    const locateClosingAsyncAnchor = (node) => {
	        let match = 0;
	        while (node) {
	            node = nextSibling(node);
	            if (node && isComment(node)) {
	                if (node.data === '[')
	                    match++;
	                if (node.data === ']') {
	                    if (match === 0) {
	                        return nextSibling(node);
	                    }
	                    else {
	                        match--;
	                    }
	                }
	            }
	        }
	        return node;
	    };
	    return [hydrate, hydrateNode];
	}

	let supported;
	let perf;
	function startMeasure(instance, type) {
	    if (instance.appContext.config.performance && isSupported()) {
	        perf.mark(`vue-${type}-${instance.uid}`);
	    }
	}
	function endMeasure(instance, type) {
	    if (instance.appContext.config.performance && isSupported()) {
	        const startTag = `vue-${type}-${instance.uid}`;
	        const endTag = startTag + `:end`;
	        perf.mark(endTag);
	        perf.measure(`<${formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
	        perf.clearMarks(startTag);
	        perf.clearMarks(endTag);
	    }
	}
	function isSupported() {
	    if (supported !== undefined) {
	        return supported;
	    }
	    /* eslint-disable no-restricted-globals */
	    if (typeof window !== 'undefined' && window.performance) {
	        supported = true;
	        perf = window.performance;
	    }
	    else {
	        supported = false;
	    }
	    /* eslint-enable no-restricted-globals */
	    return supported;
	}

	// implementation, close to no-op
	function defineComponent(options) {
	    return isFunction(options) ? { setup: options, name: options.name } : options;
	}

	const isAsyncWrapper = (i) => !!i.type.__asyncLoader;
	function defineAsyncComponent(source) {
	    if (isFunction(source)) {
	        source = { loader: source };
	    }
	    const { loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay = 200, timeout, // undefined = never times out
	    suspensible = true, onError: userOnError } = source;
	    let pendingRequest = null;
	    let resolvedComp;
	    let retries = 0;
	    const retry = () => {
	        retries++;
	        pendingRequest = null;
	        return load();
	    };
	    const load = () => {
	        let thisRequest;
	        return (pendingRequest ||
	            (thisRequest = pendingRequest = loader()
	                .catch(err => {
	                err = err instanceof Error ? err : new Error(String(err));
	                if (userOnError) {
	                    return new Promise((resolve, reject) => {
	                        const userRetry = () => resolve(retry());
	                        const userFail = () => reject(err);
	                        userOnError(err, userRetry, userFail, retries + 1);
	                    });
	                }
	                else {
	                    throw err;
	                }
	            })
	                .then((comp) => {
	                if (thisRequest !== pendingRequest && pendingRequest) {
	                    return pendingRequest;
	                }
	                if ( !comp) {
	                    warn(`Async component loader resolved to undefined. ` +
	                        `If you are using retry(), make sure to return its return value.`);
	                }
	                // interop module default
	                if (comp &&
	                    (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
	                    comp = comp.default;
	                }
	                if ( comp && !isObject(comp) && !isFunction(comp)) {
	                    throw new Error(`Invalid async component load result: ${comp}`);
	                }
	                resolvedComp = comp;
	                return comp;
	            })));
	    };
	    return defineComponent({
	        __asyncLoader: load,
	        name: 'AsyncComponentWrapper',
	        setup() {
	            const instance = currentInstance;
	            // already resolved
	            if (resolvedComp) {
	                return () => createInnerComp(resolvedComp, instance);
	            }
	            const onError = (err) => {
	                pendingRequest = null;
	                handleError(err, instance, 13 /* ASYNC_COMPONENT_LOADER */, !errorComponent /* do not throw in dev if user provided error component */);
	            };
	            // suspense-controlled or SSR.
	            if (( suspensible && instance.suspense) ||
	                (false )) {
	                return load()
	                    .then(comp => {
	                    return () => createInnerComp(comp, instance);
	                })
	                    .catch(err => {
	                    onError(err);
	                    return () => errorComponent
	                        ? createVNode(errorComponent, {
	                            error: err
	                        })
	                        : null;
	                });
	            }
	            const loaded = ref(false);
	            const error = ref();
	            const delayed = ref(!!delay);
	            if (delay) {
	                setTimeout(() => {
	                    delayed.value = false;
	                }, delay);
	            }
	            if (timeout != null) {
	                setTimeout(() => {
	                    if (!loaded.value && !error.value) {
	                        const err = new Error(`Async component timed out after ${timeout}ms.`);
	                        onError(err);
	                        error.value = err;
	                    }
	                }, timeout);
	            }
	            load()
	                .then(() => {
	                loaded.value = true;
	            })
	                .catch(err => {
	                onError(err);
	                error.value = err;
	            });
	            return () => {
	                if (loaded.value && resolvedComp) {
	                    return createInnerComp(resolvedComp, instance);
	                }
	                else if (error.value && errorComponent) {
	                    return createVNode(errorComponent, {
	                        error: error.value
	                    });
	                }
	                else if (loadingComponent && !delayed.value) {
	                    return createVNode(loadingComponent);
	                }
	            };
	        }
	    });
	}
	function createInnerComp(comp, { vnode: { ref, props, children } }) {
	    const vnode = createVNode(comp, props, children);
	    // ensure inner component inherits the async wrapper's ref owner
	    vnode.ref = ref;
	    return vnode;
	}
	function createDevEffectOptions(instance) {
	    return {
	        scheduler: queueJob,
	        allowRecurse: true,
	        onTrack: instance.rtc ? e => invokeArrayFns(instance.rtc, e) : void 0,
	        onTrigger: instance.rtg ? e => invokeArrayFns(instance.rtg, e) : void 0
	    };
	}
	const queuePostRenderEffect =  queueEffectWithSuspense
	    ;
	const setRef = (rawRef, oldRawRef, parentSuspense, vnode) => {
	    if (isArray(rawRef)) {
	        rawRef.forEach((r, i) => setRef(r, oldRawRef && (isArray(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode));
	        return;
	    }
	    let value;
	    if (!vnode || isAsyncWrapper(vnode)) {
	        value = null;
	    }
	    else {
	        if (vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */) {
	            value = vnode.component.exposed || vnode.component.proxy;
	        }
	        else {
	            value = vnode.el;
	        }
	    }
	    const { i: owner, r: ref } = rawRef;
	    if ( !owner) {
	        warn(`Missing ref owner context. ref cannot be used on hoisted vnodes. ` +
	            `A vnode with ref must be created inside the render function.`);
	        return;
	    }
	    const oldRef = oldRawRef && oldRawRef.r;
	    const refs = owner.refs === EMPTY_OBJ ? (owner.refs = {}) : owner.refs;
	    const setupState = owner.setupState;
	    // unset old ref
	    if (oldRef != null && oldRef !== ref) {
	        if (isString(oldRef)) {
	            refs[oldRef] = null;
	            if (hasOwn(setupState, oldRef)) {
	                setupState[oldRef] = null;
	            }
	        }
	        else if (isRef(oldRef)) {
	            oldRef.value = null;
	        }
	    }
	    if (isString(ref)) {
	        const doSet = () => {
	            refs[ref] = value;
	            if (hasOwn(setupState, ref)) {
	                setupState[ref] = value;
	            }
	        };
	        // #1789: for non-null values, set them after render
	        // null values means this is unmount and it should not overwrite another
	        // ref with the same key
	        if (value) {
	            doSet.id = -1;
	            queuePostRenderEffect(doSet, parentSuspense);
	        }
	        else {
	            doSet();
	        }
	    }
	    else if (isRef(ref)) {
	        const doSet = () => {
	            ref.value = value;
	        };
	        if (value) {
	            doSet.id = -1;
	            queuePostRenderEffect(doSet, parentSuspense);
	        }
	        else {
	            doSet();
	        }
	    }
	    else if (isFunction(ref)) {
	        callWithErrorHandling(ref, owner, 12 /* FUNCTION_REF */, [value, refs]);
	    }
	    else {
	        warn('Invalid template ref type:', value, `(${typeof value})`);
	    }
	};
	/**
	 * The createRenderer function accepts two generic arguments:
	 * HostNode and HostElement, corresponding to Node and Element types in the
	 * host environment. For example, for runtime-dom, HostNode would be the DOM
	 * `Node` interface and HostElement would be the DOM `Element` interface.
	 *
	 * Custom renderers can pass in the platform specific types like this:
	 *
	 * ``` js
	 * const { render, createApp } = createRenderer<Node, Element>({
	 *   patchProp,
	 *   ...nodeOps
	 * })
	 * ```
	 */
	function createRenderer(options) {
	    return baseCreateRenderer(options);
	}
	// Separate API for creating hydration-enabled renderer.
	// Hydration logic is only used when calling this function, making it
	// tree-shakable.
	function createHydrationRenderer(options) {
	    return baseCreateRenderer(options, createHydrationFunctions);
	}
	// implementation
	function baseCreateRenderer(options, createHydrationFns) {
	    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, forcePatchProp: hostForcePatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = NOOP, cloneNode: hostCloneNode, insertStaticContent: hostInsertStaticContent } = options;
	    // Note: functions inside this closure should use `const xxx = () => {}`
	    // style in order to prevent being inlined by minifiers.
	    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, optimized = false) => {
	        // patching & not same type, unmount old tree
	        if (n1 && !isSameVNodeType(n1, n2)) {
	            anchor = getNextHostNode(n1);
	            unmount(n1, parentComponent, parentSuspense, true);
	            n1 = null;
	        }
	        if (n2.patchFlag === -2 /* BAIL */) {
	            optimized = false;
	            n2.dynamicChildren = null;
	        }
	        const { type, ref, shapeFlag } = n2;
	        switch (type) {
	            case Text:
	                processText(n1, n2, container, anchor);
	                break;
	            case Comment:
	                processCommentNode(n1, n2, container, anchor);
	                break;
	            case Static:
	                if (n1 == null) {
	                    mountStaticNode(n2, container, anchor, isSVG);
	                }
	                else {
	                    patchStaticNode(n1, n2, container, isSVG);
	                }
	                break;
	            case Fragment:
	                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
	                break;
	            default:
	                if (shapeFlag & 1 /* ELEMENT */) {
	                    processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
	                }
	                else if (shapeFlag & 6 /* COMPONENT */) {
	                    processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
	                }
	                else if (shapeFlag & 64 /* TELEPORT */) {
	                    type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized, internals);
	                }
	                else if ( shapeFlag & 128 /* SUSPENSE */) {
	                    type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized, internals);
	                }
	                else {
	                    warn('Invalid VNode type:', type, `(${typeof type})`);
	                }
	        }
	        // set ref
	        if (ref != null && parentComponent) {
	            setRef(ref, n1 && n1.ref, parentSuspense, n2);
	        }
	    };
	    const processText = (n1, n2, container, anchor) => {
	        if (n1 == null) {
	            hostInsert((n2.el = hostCreateText(n2.children)), container, anchor);
	        }
	        else {
	            const el = (n2.el = n1.el);
	            if (n2.children !== n1.children) {
	                hostSetText(el, n2.children);
	            }
	        }
	    };
	    const processCommentNode = (n1, n2, container, anchor) => {
	        if (n1 == null) {
	            hostInsert((n2.el = hostCreateComment(n2.children || '')), container, anchor);
	        }
	        else {
	            // there's no support for dynamic comments
	            n2.el = n1.el;
	        }
	    };
	    const mountStaticNode = (n2, container, anchor, isSVG) => {
	        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
	    };
	    /**
	     * Dev / HMR only
	     */
	    const patchStaticNode = (n1, n2, container, isSVG) => {
	        // static nodes are only patched during dev for HMR
	        if (n2.children !== n1.children) {
	            const anchor = hostNextSibling(n1.anchor);
	            // remove existing
	            removeStaticNode(n1);
	            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
	        }
	        else {
	            n2.el = n1.el;
	            n2.anchor = n1.anchor;
	        }
	    };
	    const moveStaticNode = ({ el, anchor }, container, nextSibling) => {
	        let next;
	        while (el && el !== anchor) {
	            next = hostNextSibling(el);
	            hostInsert(el, container, nextSibling);
	            el = next;
	        }
	        hostInsert(anchor, container, nextSibling);
	    };
	    const removeStaticNode = ({ el, anchor }) => {
	        let next;
	        while (el && el !== anchor) {
	            next = hostNextSibling(el);
	            hostRemove(el);
	            el = next;
	        }
	        hostRemove(anchor);
	    };
	    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized) => {
	        isSVG = isSVG || n2.type === 'svg';
	        if (n1 == null) {
	            mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
	        }
	        else {
	            patchElement(n1, n2, parentComponent, parentSuspense, isSVG, optimized);
	        }
	    };
	    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, optimized) => {
	        let el;
	        let vnodeHook;
	        const { type, props, shapeFlag, transition, scopeId, patchFlag, dirs } = vnode;
	        {
	            el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is);
	            // mount children first, since some props may rely on child content
	            // being already rendered, e.g. `<select value>`
	            if (shapeFlag & 8 /* TEXT_CHILDREN */) {
	                hostSetElementText(el, vnode.children);
	            }
	            else if (shapeFlag & 16 /* ARRAY_CHILDREN */) {
	                mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== 'foreignObject', optimized || !!vnode.dynamicChildren);
	            }
	            if (dirs) {
	                invokeDirectiveHook(vnode, null, parentComponent, 'created');
	            }
	            // props
	            if (props) {
	                for (const key in props) {
	                    if (!isReservedProp(key)) {
	                        hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
	                    }
	                }
	                if ((vnodeHook = props.onVnodeBeforeMount)) {
	                    invokeVNodeHook(vnodeHook, parentComponent, vnode);
	                }
	            }
	            // scopeId
	            setScopeId(el, scopeId, vnode, parentComponent);
	        }
	        {
	            Object.defineProperty(el, '__vnode', {
	                value: vnode,
	                enumerable: false
	            });
	            Object.defineProperty(el, '__vueParentComponent', {
	                value: parentComponent,
	                enumerable: false
	            });
	        }
	        if (dirs) {
	            invokeDirectiveHook(vnode, null, parentComponent, 'beforeMount');
	        }
	        // #1583 For inside suspense + suspense not resolved case, enter hook should call when suspense resolved
	        // #1689 For inside suspense + suspense resolved case, just call it
	        const needCallTransitionHooks = (!parentSuspense || (parentSuspense && !parentSuspense.pendingBranch)) &&
	            transition &&
	            !transition.persisted;
	        if (needCallTransitionHooks) {
	            transition.beforeEnter(el);
	        }
	        hostInsert(el, container, anchor);
	        if ((vnodeHook = props && props.onVnodeMounted) ||
	            needCallTransitionHooks ||
	            dirs) {
	            queuePostRenderEffect(() => {
	                vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
	                needCallTransitionHooks && transition.enter(el);
	                dirs && invokeDirectiveHook(vnode, null, parentComponent, 'mounted');
	            }, parentSuspense);
	        }
	    };
	    const setScopeId = (el, scopeId, vnode, parentComponent) => {
	        if (scopeId) {
	            hostSetScopeId(el, scopeId);
	        }
	        if (parentComponent) {
	            const treeOwnerId = parentComponent.type.__scopeId;
	            // vnode's own scopeId and the current patched component's scopeId is
	            // different - this is a slot content node.
	            if (treeOwnerId && treeOwnerId !== scopeId) {
	                hostSetScopeId(el, treeOwnerId + '-s');
	            }
	            let subTree = parentComponent.subTree;
	            if ( subTree.type === Fragment) {
	                subTree =
	                    filterSingleRoot(subTree.children) || subTree;
	            }
	            if (vnode === subTree) {
	                setScopeId(el, parentComponent.vnode.scopeId, parentComponent.vnode, parentComponent.parent);
	            }
	        }
	    };
	    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, optimized, start = 0) => {
	        for (let i = start; i < children.length; i++) {
	            const child = (children[i] = optimized
	                ? cloneIfMounted(children[i])
	                : normalizeVNode(children[i]));
	            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
	        }
	    };
	    const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, optimized) => {
	        const el = (n2.el = n1.el);
	        let { patchFlag, dynamicChildren, dirs } = n2;
	        // #1426 take the old vnode's patch flag into account since user may clone a
	        // compiler-generated vnode, which de-opts to FULL_PROPS
	        patchFlag |= n1.patchFlag & 16 /* FULL_PROPS */;
	        const oldProps = n1.props || EMPTY_OBJ;
	        const newProps = n2.props || EMPTY_OBJ;
	        let vnodeHook;
	        if ((vnodeHook = newProps.onVnodeBeforeUpdate)) {
	            invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
	        }
	        if (dirs) {
	            invokeDirectiveHook(n2, n1, parentComponent, 'beforeUpdate');
	        }
	        if ( isHmrUpdating) {
	            // HMR updated, force full diff
	            patchFlag = 0;
	            optimized = false;
	            dynamicChildren = null;
	        }
	        if (patchFlag > 0) {
	            // the presence of a patchFlag means this element's render code was
	            // generated by the compiler and can take the fast path.
	            // in this path old node and new node are guaranteed to have the same shape
	            // (i.e. at the exact same position in the source template)
	            if (patchFlag & 16 /* FULL_PROPS */) {
	                // element props contain dynamic keys, full diff needed
	                patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
	            }
	            else {
	                // class
	                // this flag is matched when the element has dynamic class bindings.
	                if (patchFlag & 2 /* CLASS */) {
	                    if (oldProps.class !== newProps.class) {
	                        hostPatchProp(el, 'class', null, newProps.class, isSVG);
	                    }
	                }
	                // style
	                // this flag is matched when the element has dynamic style bindings
	                if (patchFlag & 4 /* STYLE */) {
	                    hostPatchProp(el, 'style', oldProps.style, newProps.style, isSVG);
	                }
	                // props
	                // This flag is matched when the element has dynamic prop/attr bindings
	                // other than class and style. The keys of dynamic prop/attrs are saved for
	                // faster iteration.
	                // Note dynamic keys like :[foo]="bar" will cause this optimization to
	                // bail out and go through a full diff because we need to unset the old key
	                if (patchFlag & 8 /* PROPS */) {
	                    // if the flag is present then dynamicProps must be non-null
	                    const propsToUpdate = n2.dynamicProps;
	                    for (let i = 0; i < propsToUpdate.length; i++) {
	                        const key = propsToUpdate[i];
	                        const prev = oldProps[key];
	                        const next = newProps[key];
	                        if (next !== prev ||
	                            (hostForcePatchProp && hostForcePatchProp(el, key))) {
	                            hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
	                        }
	                    }
	                }
	            }
	            // text
	            // This flag is matched when the element has only dynamic text children.
	            if (patchFlag & 1 /* TEXT */) {
	                if (n1.children !== n2.children) {
	                    hostSetElementText(el, n2.children);
	                }
	            }
	        }
	        else if (!optimized && dynamicChildren == null) {
	            // unoptimized, full diff
	            patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
	        }
	        const areChildrenSVG = isSVG && n2.type !== 'foreignObject';
	        if (dynamicChildren) {
	            patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG);
	            if ( parentComponent && parentComponent.type.__hmrId) {
	                traverseStaticChildren(n1, n2);
	            }
	        }
	        else if (!optimized) {
	            // full diff
	            patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG);
	        }
	        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) {
	            queuePostRenderEffect(() => {
	                vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
	                dirs && invokeDirectiveHook(n2, n1, parentComponent, 'updated');
	            }, parentSuspense);
	        }
	    };
	    // The fast path for blocks.
	    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG) => {
	        for (let i = 0; i < newChildren.length; i++) {
	            const oldVNode = oldChildren[i];
	            const newVNode = newChildren[i];
	            // Determine the container (parent element) for the patch.
	            const container = 
	            // - In the case of a Fragment, we need to provide the actual parent
	            // of the Fragment itself so it can move its children.
	            oldVNode.type === Fragment ||
	                // - In the case of different nodes, there is going to be a replacement
	                // which also requires the correct parent container
	                !isSameVNodeType(oldVNode, newVNode) ||
	                // - In the case of a component, it could contain anything.
	                oldVNode.shapeFlag & 6 /* COMPONENT */ ||
	                oldVNode.shapeFlag & 64 /* TELEPORT */
	                ? hostParentNode(oldVNode.el)
	                : // In other cases, the parent container is not actually used so we
	                    // just pass the block element here to avoid a DOM parentNode call.
	                    fallbackContainer;
	            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, true);
	        }
	    };
	    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG) => {
	        if (oldProps !== newProps) {
	            for (const key in newProps) {
	                // empty string is not valid prop
	                if (isReservedProp(key))
	                    continue;
	                const next = newProps[key];
	                const prev = oldProps[key];
	                if (next !== prev ||
	                    (hostForcePatchProp && hostForcePatchProp(el, key))) {
	                    hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
	                }
	            }
	            if (oldProps !== EMPTY_OBJ) {
	                for (const key in oldProps) {
	                    if (!isReservedProp(key) && !(key in newProps)) {
	                        hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
	                    }
	                }
	            }
	        }
	    };
	    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized) => {
	        const fragmentStartAnchor = (n2.el = n1 ? n1.el : hostCreateText(''));
	        const fragmentEndAnchor = (n2.anchor = n1 ? n1.anchor : hostCreateText(''));
	        let { patchFlag, dynamicChildren } = n2;
	        if (patchFlag > 0) {
	            optimized = true;
	        }
	        if ( isHmrUpdating) {
	            // HMR updated, force full diff
	            patchFlag = 0;
	            optimized = false;
	            dynamicChildren = null;
	        }
	        if (n1 == null) {
	            hostInsert(fragmentStartAnchor, container, anchor);
	            hostInsert(fragmentEndAnchor, container, anchor);
	            // a fragment can only have array children
	            // since they are either generated by the compiler, or implicitly created
	            // from arrays.
	            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, optimized);
	        }
	        else {
	            if (patchFlag > 0 &&
	                patchFlag & 64 /* STABLE_FRAGMENT */ &&
	                dynamicChildren &&
	                // #2715 the previous fragment could've been a BAILed one as a result
	                // of renderSlot() with no valid children
	                n1.dynamicChildren) {
	                // a stable fragment (template root or <template v-for>) doesn't need to
	                // patch children order, but it may contain dynamicChildren.
	                patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG);
	                if ( parentComponent && parentComponent.type.__hmrId) {
	                    traverseStaticChildren(n1, n2);
	                }
	                else if (
	                // #2080 if the stable fragment has a key, it's a <template v-for> that may
	                //  get moved around. Make sure all root level vnodes inherit el.
	                // #2134 or if it's a component root, it may also get moved around
	                // as the component is being moved.
	                n2.key != null ||
	                    (parentComponent && n2 === parentComponent.subTree)) {
	                    traverseStaticChildren(n1, n2, true /* shallow */);
	                }
	            }
	            else {
	                // keyed / unkeyed, or manual fragments.
	                // for keyed & unkeyed, since they are compiler generated from v-for,
	                // each child is guaranteed to be a block so the fragment will never
	                // have dynamicChildren.
	                patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, optimized);
	            }
	        }
	    };
	    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized) => {
	        if (n1 == null) {
	            if (n2.shapeFlag & 512 /* COMPONENT_KEPT_ALIVE */) {
	                parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
	            }
	            else {
	                mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
	            }
	        }
	        else {
	            updateComponent(n1, n2, optimized);
	        }
	    };
	    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized) => {
	        const instance = (initialVNode.component = createComponentInstance(initialVNode, parentComponent, parentSuspense));
	        if ( instance.type.__hmrId) {
	            registerHMR(instance);
	        }
	        {
	            pushWarningContext(initialVNode);
	            startMeasure(instance, `mount`);
	        }
	        // inject renderer internals for keepAlive
	        if (isKeepAlive(initialVNode)) {
	            instance.ctx.renderer = internals;
	        }
	        // resolve props and slots for setup context
	        {
	            startMeasure(instance, `init`);
	        }
	        setupComponent(instance);
	        {
	            endMeasure(instance, `init`);
	        }
	        // setup() is async. This component relies on async logic to be resolved
	        // before proceeding
	        if ( instance.asyncDep) {
	            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
	            // Give it a placeholder if this is not hydration
	            // TODO handle self-defined fallback
	            if (!initialVNode.el) {
	                const placeholder = (instance.subTree = createVNode(Comment));
	                processCommentNode(null, placeholder, container, anchor);
	            }
	            return;
	        }
	        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
	        {
	            popWarningContext();
	            endMeasure(instance, `mount`);
	        }
	    };
	    const updateComponent = (n1, n2, optimized) => {
	        const instance = (n2.component = n1.component);
	        if (shouldUpdateComponent(n1, n2, optimized)) {
	            if (
	                instance.asyncDep &&
	                !instance.asyncResolved) {
	                // async & still pending - just update props and slots
	                // since the component's reactive effect for render isn't set-up yet
	                {
	                    pushWarningContext(n2);
	                }
	                updateComponentPreRender(instance, n2, optimized);
	                {
	                    popWarningContext();
	                }
	                return;
	            }
	            else {
	                // normal update
	                instance.next = n2;
	                // in case the child component is also queued, remove it to avoid
	                // double updating the same child component in the same flush.
	                invalidateJob(instance.update);
	                // instance.update is the reactive effect runner.
	                instance.update();
	            }
	        }
	        else {
	            // no update needed. just copy over properties
	            n2.component = n1.component;
	            n2.el = n1.el;
	            instance.vnode = n2;
	        }
	    };
	    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized) => {
	        // create reactive effect for rendering
	        instance.update = effect(function componentEffect() {
	            if (!instance.isMounted) {
	                let vnodeHook;
	                const { el, props } = initialVNode;
	                const { bm, m, parent } = instance;
	                // beforeMount hook
	                if (bm) {
	                    invokeArrayFns(bm);
	                }
	                // onVnodeBeforeMount
	                if ((vnodeHook = props && props.onVnodeBeforeMount)) {
	                    invokeVNodeHook(vnodeHook, parent, initialVNode);
	                }
	                // render
	                {
	                    startMeasure(instance, `render`);
	                }
	                const subTree = (instance.subTree = renderComponentRoot(instance));
	                {
	                    endMeasure(instance, `render`);
	                }
	                if (el && hydrateNode) {
	                    {
	                        startMeasure(instance, `hydrate`);
	                    }
	                    // vnode has adopted host node - perform hydration instead of mount.
	                    hydrateNode(initialVNode.el, subTree, instance, parentSuspense);
	                    {
	                        endMeasure(instance, `hydrate`);
	                    }
	                }
	                else {
	                    {
	                        startMeasure(instance, `patch`);
	                    }
	                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
	                    {
	                        endMeasure(instance, `patch`);
	                    }
	                    initialVNode.el = subTree.el;
	                }
	                // mounted hook
	                if (m) {
	                    queuePostRenderEffect(m, parentSuspense);
	                }
	                // onVnodeMounted
	                if ((vnodeHook = props && props.onVnodeMounted)) {
	                    const scopedInitialVNode = initialVNode;
	                    queuePostRenderEffect(() => {
	                        invokeVNodeHook(vnodeHook, parent, scopedInitialVNode);
	                    }, parentSuspense);
	                }
	                // activated hook for keep-alive roots.
	                // #1742 activated hook must be accessed after first render
	                // since the hook may be injected by a child keep-alive
	                const { a } = instance;
	                if (a &&
	                    initialVNode.shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */) {
	                    queuePostRenderEffect(a, parentSuspense);
	                }
	                instance.isMounted = true;
	                // #2458: deference mount-only object parameters to prevent memleaks
	                initialVNode = container = anchor = null;
	            }
	            else {
	                // updateComponent
	                // This is triggered by mutation of component's own state (next: null)
	                // OR parent calling processComponent (next: VNode)
	                let { next, bu, u, parent, vnode } = instance;
	                let originNext = next;
	                let vnodeHook;
	                {
	                    pushWarningContext(next || instance.vnode);
	                }
	                if (next) {
	                    next.el = vnode.el;
	                    updateComponentPreRender(instance, next, optimized);
	                }
	                else {
	                    next = vnode;
	                }
	                // beforeUpdate hook
	                if (bu) {
	                    invokeArrayFns(bu);
	                }
	                // onVnodeBeforeUpdate
	                if ((vnodeHook = next.props && next.props.onVnodeBeforeUpdate)) {
	                    invokeVNodeHook(vnodeHook, parent, next, vnode);
	                }
	                // render
	                {
	                    startMeasure(instance, `render`);
	                }
	                const nextTree = renderComponentRoot(instance);
	                {
	                    endMeasure(instance, `render`);
	                }
	                const prevTree = instance.subTree;
	                instance.subTree = nextTree;
	                {
	                    startMeasure(instance, `patch`);
	                }
	                patch(prevTree, nextTree, 
	                // parent may have changed if it's in a teleport
	                hostParentNode(prevTree.el), 
	                // anchor may have changed if it's in a fragment
	                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
	                {
	                    endMeasure(instance, `patch`);
	                }
	                next.el = nextTree.el;
	                if (originNext === null) {
	                    // self-triggered update. In case of HOC, update parent component
	                    // vnode el. HOC is indicated by parent instance's subTree pointing
	                    // to child component's vnode
	                    updateHOCHostEl(instance, nextTree.el);
	                }
	                // updated hook
	                if (u) {
	                    queuePostRenderEffect(u, parentSuspense);
	                }
	                // onVnodeUpdated
	                if ((vnodeHook = next.props && next.props.onVnodeUpdated)) {
	                    queuePostRenderEffect(() => {
	                        invokeVNodeHook(vnodeHook, parent, next, vnode);
	                    }, parentSuspense);
	                }
	                {
	                    devtoolsComponentUpdated(instance);
	                }
	                {
	                    popWarningContext();
	                }
	            }
	        },  createDevEffectOptions(instance) );
	    };
	    const updateComponentPreRender = (instance, nextVNode, optimized) => {
	        nextVNode.component = instance;
	        const prevProps = instance.vnode.props;
	        instance.vnode = nextVNode;
	        instance.next = null;
	        updateProps(instance, nextVNode.props, prevProps, optimized);
	        updateSlots(instance, nextVNode.children);
	        // props update may have triggered pre-flush watchers.
	        // flush them before the render update.
	        flushPreFlushCbs(undefined, instance.update);
	    };
	    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized = false) => {
	        const c1 = n1 && n1.children;
	        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
	        const c2 = n2.children;
	        const { patchFlag, shapeFlag } = n2;
	        // fast path
	        if (patchFlag > 0) {
	            if (patchFlag & 128 /* KEYED_FRAGMENT */) {
	                // this could be either fully-keyed or mixed (some keyed some not)
	                // presence of patchFlag means children are guaranteed to be arrays
	                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
	                return;
	            }
	            else if (patchFlag & 256 /* UNKEYED_FRAGMENT */) {
	                // unkeyed
	                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
	                return;
	            }
	        }
	        // children has 3 possibilities: text, array or no children.
	        if (shapeFlag & 8 /* TEXT_CHILDREN */) {
	            // text children fast path
	            if (prevShapeFlag & 16 /* ARRAY_CHILDREN */) {
	                unmountChildren(c1, parentComponent, parentSuspense);
	            }
	            if (c2 !== c1) {
	                hostSetElementText(container, c2);
	            }
	        }
	        else {
	            if (prevShapeFlag & 16 /* ARRAY_CHILDREN */) {
	                // prev children was array
	                if (shapeFlag & 16 /* ARRAY_CHILDREN */) {
	                    // two arrays, cannot assume anything, do full diff
	                    patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
	                }
	                else {
	                    // no new children, just unmount old
	                    unmountChildren(c1, parentComponent, parentSuspense, true);
	                }
	            }
	            else {
	                // prev children was text OR null
	                // new children is array OR null
	                if (prevShapeFlag & 8 /* TEXT_CHILDREN */) {
	                    hostSetElementText(container, '');
	                }
	                // mount new if array
	                if (shapeFlag & 16 /* ARRAY_CHILDREN */) {
	                    mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
	                }
	            }
	        }
	    };
	    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, optimized) => {
	        c1 = c1 || EMPTY_ARR;
	        c2 = c2 || EMPTY_ARR;
	        const oldLength = c1.length;
	        const newLength = c2.length;
	        const commonLength = Math.min(oldLength, newLength);
	        let i;
	        for (i = 0; i < commonLength; i++) {
	            const nextChild = (c2[i] = optimized
	                ? cloneIfMounted(c2[i])
	                : normalizeVNode(c2[i]));
	            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, optimized);
	        }
	        if (oldLength > newLength) {
	            // remove old
	            unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
	        }
	        else {
	            // mount new
	            mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, optimized, commonLength);
	        }
	    };
	    // can be all-keyed or mixed
	    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, optimized) => {
	        let i = 0;
	        const l2 = c2.length;
	        let e1 = c1.length - 1; // prev ending index
	        let e2 = l2 - 1; // next ending index
	        // 1. sync from start
	        // (a b) c
	        // (a b) d e
	        while (i <= e1 && i <= e2) {
	            const n1 = c1[i];
	            const n2 = (c2[i] = optimized
	                ? cloneIfMounted(c2[i])
	                : normalizeVNode(c2[i]));
	            if (isSameVNodeType(n1, n2)) {
	                patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, optimized);
	            }
	            else {
	                break;
	            }
	            i++;
	        }
	        // 2. sync from end
	        // a (b c)
	        // d e (b c)
	        while (i <= e1 && i <= e2) {
	            const n1 = c1[e1];
	            const n2 = (c2[e2] = optimized
	                ? cloneIfMounted(c2[e2])
	                : normalizeVNode(c2[e2]));
	            if (isSameVNodeType(n1, n2)) {
	                patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, optimized);
	            }
	            else {
	                break;
	            }
	            e1--;
	            e2--;
	        }
	        // 3. common sequence + mount
	        // (a b)
	        // (a b) c
	        // i = 2, e1 = 1, e2 = 2
	        // (a b)
	        // c (a b)
	        // i = 0, e1 = -1, e2 = 0
	        if (i > e1) {
	            if (i <= e2) {
	                const nextPos = e2 + 1;
	                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
	                while (i <= e2) {
	                    patch(null, (c2[i] = optimized
	                        ? cloneIfMounted(c2[i])
	                        : normalizeVNode(c2[i])), container, anchor, parentComponent, parentSuspense, isSVG);
	                    i++;
	                }
	            }
	        }
	        // 4. common sequence + unmount
	        // (a b) c
	        // (a b)
	        // i = 2, e1 = 2, e2 = 1
	        // a (b c)
	        // (b c)
	        // i = 0, e1 = 0, e2 = -1
	        else if (i > e2) {
	            while (i <= e1) {
	                unmount(c1[i], parentComponent, parentSuspense, true);
	                i++;
	            }
	        }
	        // 5. unknown sequence
	        // [i ... e1 + 1]: a b [c d e] f g
	        // [i ... e2 + 1]: a b [e d c h] f g
	        // i = 2, e1 = 4, e2 = 5
	        else {
	            const s1 = i; // prev starting index
	            const s2 = i; // next starting index
	            // 5.1 build key:index map for newChildren
	            const keyToNewIndexMap = new Map();
	            for (i = s2; i <= e2; i++) {
	                const nextChild = (c2[i] = optimized
	                    ? cloneIfMounted(c2[i])
	                    : normalizeVNode(c2[i]));
	                if (nextChild.key != null) {
	                    if ( keyToNewIndexMap.has(nextChild.key)) {
	                        warn(`Duplicate keys found during update:`, JSON.stringify(nextChild.key), `Make sure keys are unique.`);
	                    }
	                    keyToNewIndexMap.set(nextChild.key, i);
	                }
	            }
	            // 5.2 loop through old children left to be patched and try to patch
	            // matching nodes & remove nodes that are no longer present
	            let j;
	            let patched = 0;
	            const toBePatched = e2 - s2 + 1;
	            let moved = false;
	            // used to track whether any node has moved
	            let maxNewIndexSoFar = 0;
	            // works as Map<newIndex, oldIndex>
	            // Note that oldIndex is offset by +1
	            // and oldIndex = 0 is a special value indicating the new node has
	            // no corresponding old node.
	            // used for determining longest stable subsequence
	            const newIndexToOldIndexMap = new Array(toBePatched);
	            for (i = 0; i < toBePatched; i++)
	                newIndexToOldIndexMap[i] = 0;
	            for (i = s1; i <= e1; i++) {
	                const prevChild = c1[i];
	                if (patched >= toBePatched) {
	                    // all new children have been patched so this can only be a removal
	                    unmount(prevChild, parentComponent, parentSuspense, true);
	                    continue;
	                }
	                let newIndex;
	                if (prevChild.key != null) {
	                    newIndex = keyToNewIndexMap.get(prevChild.key);
	                }
	                else {
	                    // key-less node, try to locate a key-less node of the same type
	                    for (j = s2; j <= e2; j++) {
	                        if (newIndexToOldIndexMap[j - s2] === 0 &&
	                            isSameVNodeType(prevChild, c2[j])) {
	                            newIndex = j;
	                            break;
	                        }
	                    }
	                }
	                if (newIndex === undefined) {
	                    unmount(prevChild, parentComponent, parentSuspense, true);
	                }
	                else {
	                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
	                    if (newIndex >= maxNewIndexSoFar) {
	                        maxNewIndexSoFar = newIndex;
	                    }
	                    else {
	                        moved = true;
	                    }
	                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, optimized);
	                    patched++;
	                }
	            }
	            // 5.3 move and mount
	            // generate longest stable subsequence only when nodes have moved
	            const increasingNewIndexSequence = moved
	                ? getSequence(newIndexToOldIndexMap)
	                : EMPTY_ARR;
	            j = increasingNewIndexSequence.length - 1;
	            // looping backwards so that we can use last patched node as anchor
	            for (i = toBePatched - 1; i >= 0; i--) {
	                const nextIndex = s2 + i;
	                const nextChild = c2[nextIndex];
	                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
	                if (newIndexToOldIndexMap[i] === 0) {
	                    // mount new
	                    patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG);
	                }
	                else if (moved) {
	                    // move if:
	                    // There is no stable subsequence (e.g. a reverse)
	                    // OR current node is not among the stable sequence
	                    if (j < 0 || i !== increasingNewIndexSequence[j]) {
	                        move(nextChild, container, anchor, 2 /* REORDER */);
	                    }
	                    else {
	                        j--;
	                    }
	                }
	            }
	        }
	    };
	    const move = (vnode, container, anchor, moveType, parentSuspense = null) => {
	        const { el, type, transition, children, shapeFlag } = vnode;
	        if (shapeFlag & 6 /* COMPONENT */) {
	            move(vnode.component.subTree, container, anchor, moveType);
	            return;
	        }
	        if ( shapeFlag & 128 /* SUSPENSE */) {
	            vnode.suspense.move(container, anchor, moveType);
	            return;
	        }
	        if (shapeFlag & 64 /* TELEPORT */) {
	            type.move(vnode, container, anchor, internals);
	            return;
	        }
	        if (type === Fragment) {
	            hostInsert(el, container, anchor);
	            for (let i = 0; i < children.length; i++) {
	                move(children[i], container, anchor, moveType);
	            }
	            hostInsert(vnode.anchor, container, anchor);
	            return;
	        }
	        if (type === Static) {
	            moveStaticNode(vnode, container, anchor);
	            return;
	        }
	        // single nodes
	        const needTransition = moveType !== 2 /* REORDER */ &&
	            shapeFlag & 1 /* ELEMENT */ &&
	            transition;
	        if (needTransition) {
	            if (moveType === 0 /* ENTER */) {
	                transition.beforeEnter(el);
	                hostInsert(el, container, anchor);
	                queuePostRenderEffect(() => transition.enter(el), parentSuspense);
	            }
	            else {
	                const { leave, delayLeave, afterLeave } = transition;
	                const remove = () => hostInsert(el, container, anchor);
	                const performLeave = () => {
	                    leave(el, () => {
	                        remove();
	                        afterLeave && afterLeave();
	                    });
	                };
	                if (delayLeave) {
	                    delayLeave(el, remove, performLeave);
	                }
	                else {
	                    performLeave();
	                }
	            }
	        }
	        else {
	            hostInsert(el, container, anchor);
	        }
	    };
	    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false) => {
	        const { type, props, ref, children, dynamicChildren, shapeFlag, patchFlag, dirs } = vnode;
	        // unset ref
	        if (ref != null) {
	            setRef(ref, null, parentSuspense, null);
	        }
	        if (shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */) {
	            parentComponent.ctx.deactivate(vnode);
	            return;
	        }
	        const shouldInvokeDirs = shapeFlag & 1 /* ELEMENT */ && dirs;
	        let vnodeHook;
	        if ((vnodeHook = props && props.onVnodeBeforeUnmount)) {
	            invokeVNodeHook(vnodeHook, parentComponent, vnode);
	        }
	        if (shapeFlag & 6 /* COMPONENT */) {
	            unmountComponent(vnode.component, parentSuspense, doRemove);
	        }
	        else {
	            if ( shapeFlag & 128 /* SUSPENSE */) {
	                vnode.suspense.unmount(parentSuspense, doRemove);
	                return;
	            }
	            if (shouldInvokeDirs) {
	                invokeDirectiveHook(vnode, null, parentComponent, 'beforeUnmount');
	            }
	            if (dynamicChildren &&
	                // #1153: fast path should not be taken for non-stable (v-for) fragments
	                (type !== Fragment ||
	                    (patchFlag > 0 && patchFlag & 64 /* STABLE_FRAGMENT */))) {
	                // fast path for block nodes: only need to unmount dynamic children.
	                unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
	            }
	            else if ((type === Fragment &&
	                (patchFlag & 128 /* KEYED_FRAGMENT */ ||
	                    patchFlag & 256 /* UNKEYED_FRAGMENT */)) ||
	                (!optimized && shapeFlag & 16 /* ARRAY_CHILDREN */)) {
	                unmountChildren(children, parentComponent, parentSuspense);
	            }
	            // an unmounted teleport should always remove its children if not disabled
	            if (shapeFlag & 64 /* TELEPORT */ &&
	                (doRemove || !isTeleportDisabled(vnode.props))) {
	                vnode.type.remove(vnode, internals);
	            }
	            if (doRemove) {
	                remove(vnode);
	            }
	        }
	        if ((vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) {
	            queuePostRenderEffect(() => {
	                vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
	                shouldInvokeDirs &&
	                    invokeDirectiveHook(vnode, null, parentComponent, 'unmounted');
	            }, parentSuspense);
	        }
	    };
	    const remove = vnode => {
	        const { type, el, anchor, transition } = vnode;
	        if (type === Fragment) {
	            removeFragment(el, anchor);
	            return;
	        }
	        if (type === Static) {
	            removeStaticNode(vnode);
	            return;
	        }
	        const performRemove = () => {
	            hostRemove(el);
	            if (transition && !transition.persisted && transition.afterLeave) {
	                transition.afterLeave();
	            }
	        };
	        if (vnode.shapeFlag & 1 /* ELEMENT */ &&
	            transition &&
	            !transition.persisted) {
	            const { leave, delayLeave } = transition;
	            const performLeave = () => leave(el, performRemove);
	            if (delayLeave) {
	                delayLeave(vnode.el, performRemove, performLeave);
	            }
	            else {
	                performLeave();
	            }
	        }
	        else {
	            performRemove();
	        }
	    };
	    const removeFragment = (cur, end) => {
	        // For fragments, directly remove all contained DOM nodes.
	        // (fragment child nodes cannot have transition)
	        let next;
	        while (cur !== end) {
	            next = hostNextSibling(cur);
	            hostRemove(cur);
	            cur = next;
	        }
	        hostRemove(end);
	    };
	    const unmountComponent = (instance, parentSuspense, doRemove) => {
	        if ( instance.type.__hmrId) {
	            unregisterHMR(instance);
	        }
	        const { bum, effects, update, subTree, um } = instance;
	        // beforeUnmount hook
	        if (bum) {
	            invokeArrayFns(bum);
	        }
	        if (effects) {
	            for (let i = 0; i < effects.length; i++) {
	                stop(effects[i]);
	            }
	        }
	        // update may be null if a component is unmounted before its async
	        // setup has resolved.
	        if (update) {
	            stop(update);
	            unmount(subTree, instance, parentSuspense, doRemove);
	        }
	        // unmounted hook
	        if (um) {
	            queuePostRenderEffect(um, parentSuspense);
	        }
	        queuePostRenderEffect(() => {
	            instance.isUnmounted = true;
	        }, parentSuspense);
	        // A component with async dep inside a pending suspense is unmounted before
	        // its async dep resolves. This should remove the dep from the suspense, and
	        // cause the suspense to resolve immediately if that was the last dep.
	        if (
	            parentSuspense &&
	            parentSuspense.pendingBranch &&
	            !parentSuspense.isUnmounted &&
	            instance.asyncDep &&
	            !instance.asyncResolved &&
	            instance.suspenseId === parentSuspense.pendingId) {
	            parentSuspense.deps--;
	            if (parentSuspense.deps === 0) {
	                parentSuspense.resolve();
	            }
	        }
	        {
	            devtoolsComponentRemoved(instance);
	        }
	    };
	    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0) => {
	        for (let i = start; i < children.length; i++) {
	            unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
	        }
	    };
	    const getNextHostNode = vnode => {
	        if (vnode.shapeFlag & 6 /* COMPONENT */) {
	            return getNextHostNode(vnode.component.subTree);
	        }
	        if ( vnode.shapeFlag & 128 /* SUSPENSE */) {
	            return vnode.suspense.next();
	        }
	        return hostNextSibling((vnode.anchor || vnode.el));
	    };
	    const render = (vnode, container) => {
	        if (vnode == null) {
	            if (container._vnode) {
	                unmount(container._vnode, null, null, true);
	            }
	        }
	        else {
	            patch(container._vnode || null, vnode, container);
	        }
	        flushPostFlushCbs();
	        container._vnode = vnode;
	    };
	    const internals = {
	        p: patch,
	        um: unmount,
	        m: move,
	        r: remove,
	        mt: mountComponent,
	        mc: mountChildren,
	        pc: patchChildren,
	        pbc: patchBlockChildren,
	        n: getNextHostNode,
	        o: options
	    };
	    let hydrate;
	    let hydrateNode;
	    if (createHydrationFns) {
	        [hydrate, hydrateNode] = createHydrationFns(internals);
	    }
	    return {
	        render,
	        hydrate,
	        createApp: createAppAPI(render, hydrate)
	    };
	}
	function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
	    callWithAsyncErrorHandling(hook, instance, 7 /* VNODE_HOOK */, [
	        vnode,
	        prevVNode
	    ]);
	}
	/**
	 * #1156
	 * When a component is HMR-enabled, we need to make sure that all static nodes
	 * inside a block also inherit the DOM element from the previous tree so that
	 * HMR updates (which are full updates) can retrieve the element for patching.
	 *
	 * #2080
	 * Inside keyed `template` fragment static children, if a fragment is moved,
	 * the children will always moved so that need inherit el form previous nodes
	 * to ensure correct moved position.
	 */
	function traverseStaticChildren(n1, n2, shallow = false) {
	    const ch1 = n1.children;
	    const ch2 = n2.children;
	    if (isArray(ch1) && isArray(ch2)) {
	        for (let i = 0; i < ch1.length; i++) {
	            // this is only called in the optimized path so array children are
	            // guaranteed to be vnodes
	            const c1 = ch1[i];
	            let c2 = ch2[i];
	            if (c2.shapeFlag & 1 /* ELEMENT */ && !c2.dynamicChildren) {
	                if (c2.patchFlag <= 0 || c2.patchFlag === 32 /* HYDRATE_EVENTS */) {
	                    c2 = ch2[i] = cloneIfMounted(ch2[i]);
	                    c2.el = c1.el;
	                }
	                if (!shallow)
	                    traverseStaticChildren(c1, c2);
	            }
	            // also inherit for comment nodes, but not placeholders (e.g. v-if which
	            // would have received .el during block patch)
	            if ( c2.type === Comment && !c2.el) {
	                c2.el = c1.el;
	            }
	        }
	    }
	}
	// https://en.wikipedia.org/wiki/Longest_increasing_subsequence
	function getSequence(arr) {
	    const p = arr.slice();
	    const result = [0];
	    let i, j, u, v, c;
	    const len = arr.length;
	    for (i = 0; i < len; i++) {
	        const arrI = arr[i];
	        if (arrI !== 0) {
	            j = result[result.length - 1];
	            if (arr[j] < arrI) {
	                p[i] = j;
	                result.push(i);
	                continue;
	            }
	            u = 0;
	            v = result.length - 1;
	            while (u < v) {
	                c = ((u + v) / 2) | 0;
	                if (arr[result[c]] < arrI) {
	                    u = c + 1;
	                }
	                else {
	                    v = c;
	                }
	            }
	            if (arrI < arr[result[u]]) {
	                if (u > 0) {
	                    p[i] = result[u - 1];
	                }
	                result[u] = i;
	            }
	        }
	    }
	    u = result.length;
	    v = result[u - 1];
	    while (u-- > 0) {
	        result[u] = v;
	        v = p[v];
	    }
	    return result;
	}

	const isTeleport = (type) => type.__isTeleport;
	const isTeleportDisabled = (props) => props && (props.disabled || props.disabled === '');
	const isTargetSVG = (target) => typeof SVGElement !== 'undefined' && target instanceof SVGElement;
	const resolveTarget = (props, select) => {
	    const targetSelector = props && props.to;
	    if (isString(targetSelector)) {
	        if (!select) {
	            
	                warn(`Current renderer does not support string target for Teleports. ` +
	                    `(missing querySelector renderer option)`);
	            return null;
	        }
	        else {
	            const target = select(targetSelector);
	            if (!target) {
	                
	                    warn(`Failed to locate Teleport target with selector "${targetSelector}". ` +
	                        `Note the target element must exist before the component is mounted - ` +
	                        `i.e. the target cannot be rendered by the component itself, and ` +
	                        `ideally should be outside of the entire Vue component tree.`);
	            }
	            return target;
	        }
	    }
	    else {
	        if ( !targetSelector && !isTeleportDisabled(props)) {
	            warn(`Invalid Teleport target: ${targetSelector}`);
	        }
	        return targetSelector;
	    }
	};
	const TeleportImpl = {
	    __isTeleport: true,
	    process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized, internals) {
	        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert, querySelector, createText, createComment } } = internals;
	        const disabled = isTeleportDisabled(n2.props);
	        const { shapeFlag, children } = n2;
	        if (n1 == null) {
	            // insert anchors in the main view
	            const placeholder = (n2.el =  createComment('teleport start')
	                );
	            const mainAnchor = (n2.anchor =  createComment('teleport end')
	                );
	            insert(placeholder, container, anchor);
	            insert(mainAnchor, container, anchor);
	            const target = (n2.target = resolveTarget(n2.props, querySelector));
	            const targetAnchor = (n2.targetAnchor = createText(''));
	            if (target) {
	                insert(targetAnchor, target);
	                // #2652 we could be teleporting from a non-SVG tree into an SVG tree
	                isSVG = isSVG || isTargetSVG(target);
	            }
	            else if ( !disabled) {
	                warn('Invalid Teleport target on mount:', target, `(${typeof target})`);
	            }
	            const mount = (container, anchor) => {
	                // Teleport *always* has Array children. This is enforced in both the
	                // compiler and vnode children normalization.
	                if (shapeFlag & 16 /* ARRAY_CHILDREN */) {
	                    mountChildren(children, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
	                }
	            };
	            if (disabled) {
	                mount(container, mainAnchor);
	            }
	            else if (target) {
	                mount(target, targetAnchor);
	            }
	        }
	        else {
	            // update content
	            n2.el = n1.el;
	            const mainAnchor = (n2.anchor = n1.anchor);
	            const target = (n2.target = n1.target);
	            const targetAnchor = (n2.targetAnchor = n1.targetAnchor);
	            const wasDisabled = isTeleportDisabled(n1.props);
	            const currentContainer = wasDisabled ? container : target;
	            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
	            isSVG = isSVG || isTargetSVG(target);
	            if (n2.dynamicChildren) {
	                // fast path when the teleport happens to be a block root
	                patchBlockChildren(n1.dynamicChildren, n2.dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG);
	                // even in block tree mode we need to make sure all root-level nodes
	                // in the teleport inherit previous DOM references so that they can
	                // be moved in future patches.
	                traverseStaticChildren(n1, n2, true);
	            }
	            else if (!optimized) {
	                patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG);
	            }
	            if (disabled) {
	                if (!wasDisabled) {
	                    // enabled -> disabled
	                    // move into main container
	                    moveTeleport(n2, container, mainAnchor, internals, 1 /* TOGGLE */);
	                }
	            }
	            else {
	                // target changed
	                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
	                    const nextTarget = (n2.target = resolveTarget(n2.props, querySelector));
	                    if (nextTarget) {
	                        moveTeleport(n2, nextTarget, null, internals, 0 /* TARGET_CHANGE */);
	                    }
	                    else {
	                        warn('Invalid Teleport target on update:', target, `(${typeof target})`);
	                    }
	                }
	                else if (wasDisabled) {
	                    // disabled -> enabled
	                    // move into teleport target
	                    moveTeleport(n2, target, targetAnchor, internals, 1 /* TOGGLE */);
	                }
	            }
	        }
	    },
	    remove(vnode, { r: remove, o: { remove: hostRemove } }) {
	        const { shapeFlag, children, anchor } = vnode;
	        hostRemove(anchor);
	        if (shapeFlag & 16 /* ARRAY_CHILDREN */) {
	            for (let i = 0; i < children.length; i++) {
	                remove(children[i]);
	            }
	        }
	    },
	    move: moveTeleport,
	    hydrate: hydrateTeleport
	};
	function moveTeleport(vnode, container, parentAnchor, { o: { insert }, m: move }, moveType = 2 /* REORDER */) {
	    // move target anchor if this is a target change.
	    if (moveType === 0 /* TARGET_CHANGE */) {
	        insert(vnode.targetAnchor, container, parentAnchor);
	    }
	    const { el, anchor, shapeFlag, children, props } = vnode;
	    const isReorder = moveType === 2 /* REORDER */;
	    // move main view anchor if this is a re-order.
	    if (isReorder) {
	        insert(el, container, parentAnchor);
	    }
	    // if this is a re-order and teleport is enabled (content is in target)
	    // do not move children. So the opposite is: only move children if this
	    // is not a reorder, or the teleport is disabled
	    if (!isReorder || isTeleportDisabled(props)) {
	        // Teleport has either Array children or no children.
	        if (shapeFlag & 16 /* ARRAY_CHILDREN */) {
	            for (let i = 0; i < children.length; i++) {
	                move(children[i], container, parentAnchor, 2 /* REORDER */);
	            }
	        }
	    }
	    // move main view anchor if this is a re-order.
	    if (isReorder) {
	        insert(anchor, container, parentAnchor);
	    }
	}
	function hydrateTeleport(node, vnode, parentComponent, parentSuspense, optimized, { o: { nextSibling, parentNode, querySelector } }, hydrateChildren) {
	    const target = (vnode.target = resolveTarget(vnode.props, querySelector));
	    if (target) {
	        // if multiple teleports rendered to the same target element, we need to
	        // pick up from where the last teleport finished instead of the first node
	        const targetNode = target._lpa || target.firstChild;
	        if (vnode.shapeFlag & 16 /* ARRAY_CHILDREN */) {
	            if (isTeleportDisabled(vnode.props)) {
	                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, optimized);
	                vnode.targetAnchor = targetNode;
	            }
	            else {
	                vnode.anchor = nextSibling(node);
	                vnode.targetAnchor = hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, optimized);
	            }
	            target._lpa =
	                vnode.targetAnchor && nextSibling(vnode.targetAnchor);
	        }
	    }
	    return vnode.anchor && nextSibling(vnode.anchor);
	}
	// Force-casted public typing for h and TSX props inference
	const Teleport = TeleportImpl;

	const COMPONENTS = 'components';
	const DIRECTIVES = 'directives';
	/**
	 * @private
	 */
	function resolveComponent(name) {
	    return resolveAsset(COMPONENTS, name) || name;
	}
	const NULL_DYNAMIC_COMPONENT = Symbol();
	/**
	 * @private
	 */
	function resolveDynamicComponent(component) {
	    if (isString(component)) {
	        return resolveAsset(COMPONENTS, component, false) || component;
	    }
	    else {
	        // invalid types will fallthrough to createVNode and raise warning
	        return (component || NULL_DYNAMIC_COMPONENT);
	    }
	}
	/**
	 * @private
	 */
	function resolveDirective(name) {
	    return resolveAsset(DIRECTIVES, name);
	}
	// implementation
	function resolveAsset(type, name, warnMissing = true) {
	    const instance = currentRenderingInstance || currentInstance;
	    if (instance) {
	        const Component = instance.type;
	        // self name has highest priority
	        if (type === COMPONENTS) {
	            // special self referencing call generated by compiler
	            // inferred from SFC filename
	            if (name === `_self`) {
	                return Component;
	            }
	            const selfName = getComponentName(Component);
	            if (selfName &&
	                (selfName === name ||
	                    selfName === camelize(name) ||
	                    selfName === capitalize(camelize(name)))) {
	                return Component;
	            }
	        }
	        const res = 
	        // local registration
	        // check instance[type] first for components with mixin or extends.
	        resolve(instance[type] || Component[type], name) ||
	            // global registration
	            resolve(instance.appContext[type], name);
	        if ( warnMissing && !res) {
	            warn(`Failed to resolve ${type.slice(0, -1)}: ${name}`);
	        }
	        return res;
	    }
	    else {
	        warn(`resolve${capitalize(type.slice(0, -1))} ` +
	            `can only be used in render() or setup().`);
	    }
	}
	function resolve(registry, name) {
	    return (registry &&
	        (registry[name] ||
	            registry[camelize(name)] ||
	            registry[capitalize(camelize(name))]));
	}

	const Fragment = Symbol( 'Fragment' );
	const Text = Symbol( 'Text' );
	const Comment = Symbol( 'Comment' );
	const Static = Symbol( 'Static' );
	// Since v-if and v-for are the two possible ways node structure can dynamically
	// change, once we consider v-if branches and each v-for fragment a block, we
	// can divide a template into nested blocks, and within each block the node
	// structure would be stable. This allows us to skip most children diffing
	// and only worry about the dynamic nodes (indicated by patch flags).
	const blockStack = [];
	let currentBlock = null;
	/**
	 * Open a block.
	 * This must be called before `createBlock`. It cannot be part of `createBlock`
	 * because the children of the block are evaluated before `createBlock` itself
	 * is called. The generated code typically looks like this:
	 *
	 * ```js
	 * function render() {
	 *   return (openBlock(),createBlock('div', null, [...]))
	 * }
	 * ```
	 * disableTracking is true when creating a v-for fragment block, since a v-for
	 * fragment always diffs its children.
	 *
	 * @private
	 */
	function openBlock(disableTracking = false) {
	    blockStack.push((currentBlock = disableTracking ? null : []));
	}
	function closeBlock() {
	    blockStack.pop();
	    currentBlock = blockStack[blockStack.length - 1] || null;
	}
	// Whether we should be tracking dynamic child nodes inside a block.
	// Only tracks when this value is > 0
	// We are not using a simple boolean because this value may need to be
	// incremented/decremented by nested usage of v-once (see below)
	let shouldTrack$1 = 1;
	/**
	 * Block tracking sometimes needs to be disabled, for example during the
	 * creation of a tree that needs to be cached by v-once. The compiler generates
	 * code like this:
	 *
	 * ``` js
	 * _cache[1] || (
	 *   setBlockTracking(-1),
	 *   _cache[1] = createVNode(...),
	 *   setBlockTracking(1),
	 *   _cache[1]
	 * )
	 * ```
	 *
	 * @private
	 */
	function setBlockTracking(value) {
	    shouldTrack$1 += value;
	}
	/**
	 * Create a block root vnode. Takes the same exact arguments as `createVNode`.
	 * A block root keeps track of dynamic nodes within the block in the
	 * `dynamicChildren` array.
	 *
	 * @private
	 */
	function createBlock(type, props, children, patchFlag, dynamicProps) {
	    const vnode = createVNode(type, props, children, patchFlag, dynamicProps, true /* isBlock: prevent a block from tracking itself */);
	    // save current block children on the block vnode
	    vnode.dynamicChildren = currentBlock || EMPTY_ARR;
	    // close block
	    closeBlock();
	    // a block is always going to be patched, so track it as a child of its
	    // parent block
	    if (shouldTrack$1 > 0 && currentBlock) {
	        currentBlock.push(vnode);
	    }
	    return vnode;
	}
	function isVNode(value) {
	    return value ? value.__v_isVNode === true : false;
	}
	function isSameVNodeType(n1, n2) {
	    if (
	        n2.shapeFlag & 6 /* COMPONENT */ &&
	        hmrDirtyComponents.has(n2.type)) {
	        // HMR only: if the component has been hot-updated, force a reload.
	        return false;
	    }
	    return n1.type === n2.type && n1.key === n2.key;
	}
	let vnodeArgsTransformer;
	/**
	 * Internal API for registering an arguments transform for createVNode
	 * used for creating stubs in the test-utils
	 * It is *internal* but needs to be exposed for test-utils to pick up proper
	 * typings
	 */
	function transformVNodeArgs(transformer) {
	    vnodeArgsTransformer = transformer;
	}
	const createVNodeWithArgsTransform = (...args) => {
	    return _createVNode(...(vnodeArgsTransformer
	        ? vnodeArgsTransformer(args, currentRenderingInstance)
	        : args));
	};
	const InternalObjectKey = `__vInternal`;
	const normalizeKey = ({ key }) => key != null ? key : null;
	const normalizeRef = ({ ref }) => {
	    return (ref != null
	        ? isString(ref) || isRef(ref) || isFunction(ref)
	            ? { i: currentRenderingInstance, r: ref }
	            : ref
	        : null);
	};
	const createVNode = ( createVNodeWithArgsTransform
	    );
	function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
	    if (!type || type === NULL_DYNAMIC_COMPONENT) {
	        if ( !type) {
	            warn(`Invalid vnode type when creating vnode: ${type}.`);
	        }
	        type = Comment;
	    }
	    if (isVNode(type)) {
	        // createVNode receiving an existing vnode. This happens in cases like
	        // <component :is="vnode"/>
	        // #2078 make sure to merge refs during the clone instead of overwriting it
	        const cloned = cloneVNode(type, props, true /* mergeRef: true */);
	        if (children) {
	            normalizeChildren(cloned, children);
	        }
	        return cloned;
	    }
	    // class component normalization.
	    if (isClassComponent(type)) {
	        type = type.__vccOpts;
	    }
	    // class & style normalization.
	    if (props) {
	        // for reactive or proxy objects, we need to clone it to enable mutation.
	        if (isProxy(props) || InternalObjectKey in props) {
	            props = extend({}, props);
	        }
	        let { class: klass, style } = props;
	        if (klass && !isString(klass)) {
	            props.class = normalizeClass(klass);
	        }
	        if (isObject(style)) {
	            // reactive state objects need to be cloned since they are likely to be
	            // mutated
	            if (isProxy(style) && !isArray(style)) {
	                style = extend({}, style);
	            }
	            props.style = normalizeStyle(style);
	        }
	    }
	    // encode the vnode type information into a bitmap
	    const shapeFlag = isString(type)
	        ? 1 /* ELEMENT */
	        :  isSuspense(type)
	            ? 128 /* SUSPENSE */
	            : isTeleport(type)
	                ? 64 /* TELEPORT */
	                : isObject(type)
	                    ? 4 /* STATEFUL_COMPONENT */
	                    : isFunction(type)
	                        ? 2 /* FUNCTIONAL_COMPONENT */
	                        : 0;
	    if ( shapeFlag & 4 /* STATEFUL_COMPONENT */ && isProxy(type)) {
	        type = toRaw(type);
	        warn(`Vue received a Component which was made a reactive object. This can ` +
	            `lead to unnecessary performance overhead, and should be avoided by ` +
	            `marking the component with \`markRaw\` or using \`shallowRef\` ` +
	            `instead of \`ref\`.`, `\nComponent that was made reactive: `, type);
	    }
	    const vnode = {
	        __v_isVNode: true,
	        ["__v_skip" /* SKIP */]: true,
	        type,
	        props,
	        key: props && normalizeKey(props),
	        ref: props && normalizeRef(props),
	        scopeId: currentScopeId,
	        children: null,
	        component: null,
	        suspense: null,
	        ssContent: null,
	        ssFallback: null,
	        dirs: null,
	        transition: null,
	        el: null,
	        anchor: null,
	        target: null,
	        targetAnchor: null,
	        staticCount: 0,
	        shapeFlag,
	        patchFlag,
	        dynamicProps,
	        dynamicChildren: null,
	        appContext: null
	    };
	    // validate key
	    if ( vnode.key !== vnode.key) {
	        warn(`VNode created with invalid key (NaN). VNode type:`, vnode.type);
	    }
	    normalizeChildren(vnode, children);
	    // normalize suspense children
	    if ( shapeFlag & 128 /* SUSPENSE */) {
	        const { content, fallback } = normalizeSuspenseChildren(vnode);
	        vnode.ssContent = content;
	        vnode.ssFallback = fallback;
	    }
	    if (shouldTrack$1 > 0 &&
	        // avoid a block node from tracking itself
	        !isBlockNode &&
	        // has current parent block
	        currentBlock &&
	        // presence of a patch flag indicates this node needs patching on updates.
	        // component nodes also should always be patched, because even if the
	        // component doesn't need to update, it needs to persist the instance on to
	        // the next vnode so that it can be properly unmounted later.
	        (patchFlag > 0 || shapeFlag & 6 /* COMPONENT */) &&
	        // the EVENTS flag is only for hydration and if it is the only flag, the
	        // vnode should not be considered dynamic due to handler caching.
	        patchFlag !== 32 /* HYDRATE_EVENTS */) {
	        currentBlock.push(vnode);
	    }
	    return vnode;
	}
	function cloneVNode(vnode, extraProps, mergeRef = false) {
	    // This is intentionally NOT using spread or extend to avoid the runtime
	    // key enumeration cost.
	    const { props, ref, patchFlag } = vnode;
	    const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
	    return {
	        __v_isVNode: true,
	        ["__v_skip" /* SKIP */]: true,
	        type: vnode.type,
	        props: mergedProps,
	        key: mergedProps && normalizeKey(mergedProps),
	        ref: extraProps && extraProps.ref
	            ? // #2078 in the case of <component :is="vnode" ref="extra"/>
	                // if the vnode itself already has a ref, cloneVNode will need to merge
	                // the refs so the single vnode can be set on multiple refs
	                mergeRef && ref
	                    ? isArray(ref)
	                        ? ref.concat(normalizeRef(extraProps))
	                        : [ref, normalizeRef(extraProps)]
	                    : normalizeRef(extraProps)
	            : ref,
	        scopeId: vnode.scopeId,
	        children: vnode.children,
	        target: vnode.target,
	        targetAnchor: vnode.targetAnchor,
	        staticCount: vnode.staticCount,
	        shapeFlag: vnode.shapeFlag,
	        // if the vnode is cloned with extra props, we can no longer assume its
	        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
	        // note: perserve flag for fragments since they use the flag for children
	        // fast paths only.
	        patchFlag: extraProps && vnode.type !== Fragment
	            ? patchFlag === -1 // hoisted node
	                ? 16 /* FULL_PROPS */
	                : patchFlag | 16 /* FULL_PROPS */
	            : patchFlag,
	        dynamicProps: vnode.dynamicProps,
	        dynamicChildren: vnode.dynamicChildren,
	        appContext: vnode.appContext,
	        dirs: vnode.dirs,
	        transition: vnode.transition,
	        // These should technically only be non-null on mounted VNodes. However,
	        // they *should* be copied for kept-alive vnodes. So we just always copy
	        // them since them being non-null during a mount doesn't affect the logic as
	        // they will simply be overwritten.
	        component: vnode.component,
	        suspense: vnode.suspense,
	        ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
	        ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
	        el: vnode.el,
	        anchor: vnode.anchor
	    };
	}
	/**
	 * @private
	 */
	function createTextVNode(text = ' ', flag = 0) {
	    return createVNode(Text, null, text, flag);
	}
	/**
	 * @private
	 */
	function createStaticVNode(content, numberOfNodes) {
	    // A static vnode can contain multiple stringified elements, and the number
	    // of elements is necessary for hydration.
	    const vnode = createVNode(Static, null, content);
	    vnode.staticCount = numberOfNodes;
	    return vnode;
	}
	/**
	 * @private
	 */
	function createCommentVNode(text = '', 
	// when used as the v-else branch, the comment node must be created as a
	// block to ensure correct updates.
	asBlock = false) {
	    return asBlock
	        ? (openBlock(), createBlock(Comment, null, text))
	        : createVNode(Comment, null, text);
	}
	function normalizeVNode(child) {
	    if (child == null || typeof child === 'boolean') {
	        // empty placeholder
	        return createVNode(Comment);
	    }
	    else if (isArray(child)) {
	        // fragment
	        return createVNode(Fragment, null, child);
	    }
	    else if (typeof child === 'object') {
	        // already vnode, this should be the most common since compiled templates
	        // always produce all-vnode children arrays
	        return child.el === null ? child : cloneVNode(child);
	    }
	    else {
	        // strings and numbers
	        return createVNode(Text, null, String(child));
	    }
	}
	// optimized normalization for template-compiled render fns
	function cloneIfMounted(child) {
	    return child.el === null ? child : cloneVNode(child);
	}
	function normalizeChildren(vnode, children) {
	    let type = 0;
	    const { shapeFlag } = vnode;
	    if (children == null) {
	        children = null;
	    }
	    else if (isArray(children)) {
	        type = 16 /* ARRAY_CHILDREN */;
	    }
	    else if (typeof children === 'object') {
	        if (shapeFlag & 1 /* ELEMENT */ || shapeFlag & 64 /* TELEPORT */) {
	            // Normalize slot to plain children for plain element and Teleport
	            const slot = children.default;
	            if (slot) {
	                // _c marker is added by withCtx() indicating this is a compiled slot
	                slot._c && setCompiledSlotRendering(1);
	                normalizeChildren(vnode, slot());
	                slot._c && setCompiledSlotRendering(-1);
	            }
	            return;
	        }
	        else {
	            type = 32 /* SLOTS_CHILDREN */;
	            const slotFlag = children._;
	            if (!slotFlag && !(InternalObjectKey in children)) {
	                children._ctx = currentRenderingInstance;
	            }
	            else if (slotFlag === 3 /* FORWARDED */ && currentRenderingInstance) {
	                // a child component receives forwarded slots from the parent.
	                // its slot type is determined by its parent's slot type.
	                if (currentRenderingInstance.vnode.patchFlag & 1024 /* DYNAMIC_SLOTS */) {
	                    children._ = 2 /* DYNAMIC */;
	                    vnode.patchFlag |= 1024 /* DYNAMIC_SLOTS */;
	                }
	                else {
	                    children._ = 1 /* STABLE */;
	                }
	            }
	        }
	    }
	    else if (isFunction(children)) {
	        children = { default: children, _ctx: currentRenderingInstance };
	        type = 32 /* SLOTS_CHILDREN */;
	    }
	    else {
	        children = String(children);
	        // force teleport children to array so it can be moved around
	        if (shapeFlag & 64 /* TELEPORT */) {
	            type = 16 /* ARRAY_CHILDREN */;
	            children = [createTextVNode(children)];
	        }
	        else {
	            type = 8 /* TEXT_CHILDREN */;
	        }
	    }
	    vnode.children = children;
	    vnode.shapeFlag |= type;
	}
	function mergeProps(...args) {
	    const ret = extend({}, args[0]);
	    for (let i = 1; i < args.length; i++) {
	        const toMerge = args[i];
	        for (const key in toMerge) {
	            if (key === 'class') {
	                if (ret.class !== toMerge.class) {
	                    ret.class = normalizeClass([ret.class, toMerge.class]);
	                }
	            }
	            else if (key === 'style') {
	                ret.style = normalizeStyle([ret.style, toMerge.style]);
	            }
	            else if (isOn(key)) {
	                const existing = ret[key];
	                const incoming = toMerge[key];
	                if (existing !== incoming) {
	                    ret[key] = existing
	                        ? [].concat(existing, toMerge[key])
	                        : incoming;
	                }
	            }
	            else if (key !== '') {
	                ret[key] = toMerge[key];
	            }
	        }
	    }
	    return ret;
	}

	function provide(key, value) {
	    if (!currentInstance) {
	        {
	            warn(`provide() can only be used inside setup().`);
	        }
	    }
	    else {
	        let provides = currentInstance.provides;
	        // by default an instance inherits its parent's provides object
	        // but when it needs to provide values of its own, it creates its
	        // own provides object using parent provides object as prototype.
	        // this way in `inject` we can simply look up injections from direct
	        // parent and let the prototype chain do the work.
	        const parentProvides = currentInstance.parent && currentInstance.parent.provides;
	        if (parentProvides === provides) {
	            provides = currentInstance.provides = Object.create(parentProvides);
	        }
	        // TS doesn't allow symbol as index type
	        provides[key] = value;
	    }
	}
	function inject(key, defaultValue, treatDefaultAsFactory = false) {
	    // fallback to `currentRenderingInstance` so that this can be called in
	    // a functional component
	    const instance = currentInstance || currentRenderingInstance;
	    if (instance) {
	        // #2400
	        // to support `app.use` plugins,
	        // fallback to appContext's `provides` if the intance is at root
	        const provides = instance.parent == null
	            ? instance.vnode.appContext && instance.vnode.appContext.provides
	            : instance.parent.provides;
	        if (provides && key in provides) {
	            // TS doesn't allow symbol as index type
	            return provides[key];
	        }
	        else if (arguments.length > 1) {
	            return treatDefaultAsFactory && isFunction(defaultValue)
	                ? defaultValue()
	                : defaultValue;
	        }
	        else {
	            warn(`injection "${String(key)}" not found.`);
	        }
	    }
	    else {
	        warn(`inject() can only be used inside setup() or functional components.`);
	    }
	}

	function createDuplicateChecker() {
	    const cache = Object.create(null);
	    return (type, key) => {
	        if (cache[key]) {
	            warn(`${type} property "${key}" is already defined in ${cache[key]}.`);
	        }
	        else {
	            cache[key] = type;
	        }
	    };
	}
	let isInBeforeCreate = false;
	function applyOptions(instance, options, deferredData = [], deferredWatch = [], deferredProvide = [], asMixin = false) {
	    const { 
	    // composition
	    mixins, extends: extendsOptions, 
	    // state
	    data: dataOptions, computed: computedOptions, methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, 
	    // assets
	    components, directives, 
	    // lifecycle
	    beforeMount, mounted, beforeUpdate, updated, activated, deactivated, beforeDestroy, beforeUnmount, destroyed, unmounted, render, renderTracked, renderTriggered, errorCaptured, 
	    // public API
	    expose } = options;
	    const publicThis = instance.proxy;
	    const ctx = instance.ctx;
	    const globalMixins = instance.appContext.mixins;
	    if (asMixin && render && instance.render === NOOP) {
	        instance.render = render;
	    }
	    // applyOptions is called non-as-mixin once per instance
	    if (!asMixin) {
	        isInBeforeCreate = true;
	        callSyncHook('beforeCreate', "bc" /* BEFORE_CREATE */, options, instance, globalMixins);
	        isInBeforeCreate = false;
	        // global mixins are applied first
	        applyMixins(instance, globalMixins, deferredData, deferredWatch, deferredProvide);
	    }
	    // extending a base component...
	    if (extendsOptions) {
	        applyOptions(instance, extendsOptions, deferredData, deferredWatch, deferredProvide, true);
	    }
	    // local mixins
	    if (mixins) {
	        applyMixins(instance, mixins, deferredData, deferredWatch, deferredProvide);
	    }
	    const checkDuplicateProperties =  createDuplicateChecker() ;
	    {
	        const [propsOptions] = instance.propsOptions;
	        if (propsOptions) {
	            for (const key in propsOptions) {
	                checkDuplicateProperties("Props" /* PROPS */, key);
	            }
	        }
	    }
	    // options initialization order (to be consistent with Vue 2):
	    // - props (already done outside of this function)
	    // - inject
	    // - methods
	    // - data (deferred since it relies on `this` access)
	    // - computed
	    // - watch (deferred since it relies on `this` access)
	    if (injectOptions) {
	        if (isArray(injectOptions)) {
	            for (let i = 0; i < injectOptions.length; i++) {
	                const key = injectOptions[i];
	                ctx[key] = inject(key);
	                {
	                    checkDuplicateProperties("Inject" /* INJECT */, key);
	                }
	            }
	        }
	        else {
	            for (const key in injectOptions) {
	                const opt = injectOptions[key];
	                if (isObject(opt)) {
	                    ctx[key] = inject(opt.from || key, opt.default, true /* treat default function as factory */);
	                }
	                else {
	                    ctx[key] = inject(opt);
	                }
	                {
	                    checkDuplicateProperties("Inject" /* INJECT */, key);
	                }
	            }
	        }
	    }
	    if (methods) {
	        for (const key in methods) {
	            const methodHandler = methods[key];
	            if (isFunction(methodHandler)) {
	                ctx[key] = methodHandler.bind(publicThis);
	                {
	                    checkDuplicateProperties("Methods" /* METHODS */, key);
	                }
	            }
	            else {
	                warn(`Method "${key}" has type "${typeof methodHandler}" in the component definition. ` +
	                    `Did you reference the function correctly?`);
	            }
	        }
	    }
	    if (!asMixin) {
	        if (deferredData.length) {
	            deferredData.forEach(dataFn => resolveData(instance, dataFn, publicThis));
	        }
	        if (dataOptions) {
	            // @ts-ignore dataOptions is not fully type safe
	            resolveData(instance, dataOptions, publicThis);
	        }
	        {
	            const rawData = toRaw(instance.data);
	            for (const key in rawData) {
	                checkDuplicateProperties("Data" /* DATA */, key);
	                // expose data on ctx during dev
	                if (key[0] !== '$' && key[0] !== '_') {
	                    Object.defineProperty(ctx, key, {
	                        configurable: true,
	                        enumerable: true,
	                        get: () => rawData[key],
	                        set: NOOP
	                    });
	                }
	            }
	        }
	    }
	    else if (dataOptions) {
	        deferredData.push(dataOptions);
	    }
	    if (computedOptions) {
	        for (const key in computedOptions) {
	            const opt = computedOptions[key];
	            const get = isFunction(opt)
	                ? opt.bind(publicThis, publicThis)
	                : isFunction(opt.get)
	                    ? opt.get.bind(publicThis, publicThis)
	                    : NOOP;
	            if ( get === NOOP) {
	                warn(`Computed property "${key}" has no getter.`);
	            }
	            const set = !isFunction(opt) && isFunction(opt.set)
	                ? opt.set.bind(publicThis)
	                :  () => {
	                        warn(`Write operation failed: computed property "${key}" is readonly.`);
	                    }
	                    ;
	            const c = computed$1({
	                get,
	                set
	            });
	            Object.defineProperty(ctx, key, {
	                enumerable: true,
	                configurable: true,
	                get: () => c.value,
	                set: v => (c.value = v)
	            });
	            {
	                checkDuplicateProperties("Computed" /* COMPUTED */, key);
	            }
	        }
	    }
	    if (watchOptions) {
	        deferredWatch.push(watchOptions);
	    }
	    if (!asMixin && deferredWatch.length) {
	        deferredWatch.forEach(watchOptions => {
	            for (const key in watchOptions) {
	                createWatcher(watchOptions[key], ctx, publicThis, key);
	            }
	        });
	    }
	    if (provideOptions) {
	        deferredProvide.push(provideOptions);
	    }
	    if (!asMixin && deferredProvide.length) {
	        deferredProvide.forEach(provideOptions => {
	            const provides = isFunction(provideOptions)
	                ? provideOptions.call(publicThis)
	                : provideOptions;
	            Reflect.ownKeys(provides).forEach(key => {
	                provide(key, provides[key]);
	            });
	        });
	    }
	    // asset options.
	    // To reduce memory usage, only components with mixins or extends will have
	    // resolved asset registry attached to instance.
	    if (asMixin) {
	        if (components) {
	            extend(instance.components ||
	                (instance.components = extend({}, instance.type.components)), components);
	        }
	        if (directives) {
	            extend(instance.directives ||
	                (instance.directives = extend({}, instance.type.directives)), directives);
	        }
	    }
	    // lifecycle options
	    if (!asMixin) {
	        callSyncHook('created', "c" /* CREATED */, options, instance, globalMixins);
	    }
	    if (beforeMount) {
	        onBeforeMount(beforeMount.bind(publicThis));
	    }
	    if (mounted) {
	        onMounted(mounted.bind(publicThis));
	    }
	    if (beforeUpdate) {
	        onBeforeUpdate(beforeUpdate.bind(publicThis));
	    }
	    if (updated) {
	        onUpdated(updated.bind(publicThis));
	    }
	    if (activated) {
	        onActivated(activated.bind(publicThis));
	    }
	    if (deactivated) {
	        onDeactivated(deactivated.bind(publicThis));
	    }
	    if (errorCaptured) {
	        onErrorCaptured(errorCaptured.bind(publicThis));
	    }
	    if (renderTracked) {
	        onRenderTracked(renderTracked.bind(publicThis));
	    }
	    if (renderTriggered) {
	        onRenderTriggered(renderTriggered.bind(publicThis));
	    }
	    if ( beforeDestroy) {
	        warn(`\`beforeDestroy\` has been renamed to \`beforeUnmount\`.`);
	    }
	    if (beforeUnmount) {
	        onBeforeUnmount(beforeUnmount.bind(publicThis));
	    }
	    if ( destroyed) {
	        warn(`\`destroyed\` has been renamed to \`unmounted\`.`);
	    }
	    if (unmounted) {
	        onUnmounted(unmounted.bind(publicThis));
	    }
	    if (isArray(expose)) {
	        if (!asMixin) {
	            if (expose.length) {
	                const exposed = instance.exposed || (instance.exposed = proxyRefs({}));
	                expose.forEach(key => {
	                    exposed[key] = toRef(publicThis, key);
	                });
	            }
	            else if (!instance.exposed) {
	                instance.exposed = EMPTY_OBJ;
	            }
	        }
	        else {
	            warn(`The \`expose\` option is ignored when used in mixins.`);
	        }
	    }
	}
	function callSyncHook(name, type, options, instance, globalMixins) {
	    callHookFromMixins(name, type, globalMixins, instance);
	    const { extends: base, mixins } = options;
	    if (base) {
	        callHookFromExtends(name, type, base, instance);
	    }
	    if (mixins) {
	        callHookFromMixins(name, type, mixins, instance);
	    }
	    const selfHook = options[name];
	    if (selfHook) {
	        callWithAsyncErrorHandling(selfHook.bind(instance.proxy), instance, type);
	    }
	}
	function callHookFromExtends(name, type, base, instance) {
	    if (base.extends) {
	        callHookFromExtends(name, type, base.extends, instance);
	    }
	    const baseHook = base[name];
	    if (baseHook) {
	        callWithAsyncErrorHandling(baseHook.bind(instance.proxy), instance, type);
	    }
	}
	function callHookFromMixins(name, type, mixins, instance) {
	    for (let i = 0; i < mixins.length; i++) {
	        const chainedMixins = mixins[i].mixins;
	        if (chainedMixins) {
	            callHookFromMixins(name, type, chainedMixins, instance);
	        }
	        const fn = mixins[i][name];
	        if (fn) {
	            callWithAsyncErrorHandling(fn.bind(instance.proxy), instance, type);
	        }
	    }
	}
	function applyMixins(instance, mixins, deferredData, deferredWatch, deferredProvide) {
	    for (let i = 0; i < mixins.length; i++) {
	        applyOptions(instance, mixins[i], deferredData, deferredWatch, deferredProvide, true);
	    }
	}
	function resolveData(instance, dataFn, publicThis) {
	    if ( !isFunction(dataFn)) {
	        warn(`The data option must be a function. ` +
	            `Plain object usage is no longer supported.`);
	    }
	    const data = dataFn.call(publicThis, publicThis);
	    if ( isPromise(data)) {
	        warn(`data() returned a Promise - note data() cannot be async; If you ` +
	            `intend to perform data fetching before component renders, use ` +
	            `async setup() + <Suspense>.`);
	    }
	    if (!isObject(data)) {
	         warn(`data() should return an object.`);
	    }
	    else if (instance.data === EMPTY_OBJ) {
	        instance.data = reactive(data);
	    }
	    else {
	        // existing data: this is a mixin or extends.
	        extend(instance.data, data);
	    }
	}
	function createWatcher(raw, ctx, publicThis, key) {
	    const getter = key.includes('.')
	        ? createPathGetter(publicThis, key)
	        : () => publicThis[key];
	    if (isString(raw)) {
	        const handler = ctx[raw];
	        if (isFunction(handler)) {
	            watch(getter, handler);
	        }
	        else {
	            warn(`Invalid watch handler specified by key "${raw}"`, handler);
	        }
	    }
	    else if (isFunction(raw)) {
	        watch(getter, raw.bind(publicThis));
	    }
	    else if (isObject(raw)) {
	        if (isArray(raw)) {
	            raw.forEach(r => createWatcher(r, ctx, publicThis, key));
	        }
	        else {
	            const handler = isFunction(raw.handler)
	                ? raw.handler.bind(publicThis)
	                : ctx[raw.handler];
	            if (isFunction(handler)) {
	                watch(getter, handler, raw);
	            }
	            else {
	                warn(`Invalid watch handler specified by key "${raw.handler}"`, handler);
	            }
	        }
	    }
	    else {
	        warn(`Invalid watch option: "${key}"`, raw);
	    }
	}
	function createPathGetter(ctx, path) {
	    const segments = path.split('.');
	    return () => {
	        let cur = ctx;
	        for (let i = 0; i < segments.length && cur; i++) {
	            cur = cur[segments[i]];
	        }
	        return cur;
	    };
	}
	function resolveMergedOptions(instance) {
	    const raw = instance.type;
	    const { __merged, mixins, extends: extendsOptions } = raw;
	    if (__merged)
	        return __merged;
	    const globalMixins = instance.appContext.mixins;
	    if (!globalMixins.length && !mixins && !extendsOptions)
	        return raw;
	    const options = {};
	    globalMixins.forEach(m => mergeOptions(options, m, instance));
	    mergeOptions(options, raw, instance);
	    return (raw.__merged = options);
	}
	function mergeOptions(to, from, instance) {
	    const strats = instance.appContext.config.optionMergeStrategies;
	    const { mixins, extends: extendsOptions } = from;
	    extendsOptions && mergeOptions(to, extendsOptions, instance);
	    mixins &&
	        mixins.forEach((m) => mergeOptions(to, m, instance));
	    for (const key in from) {
	        if (strats && hasOwn(strats, key)) {
	            to[key] = strats[key](to[key], from[key], instance.proxy, key);
	        }
	        else {
	            to[key] = from[key];
	        }
	    }
	}

	/**
	 * #2437 In Vue 3, functional components do not have a public instance proxy but
	 * they exist in the internal parent chain. For code that relies on traversing
	 * public $parent chains, skip functional ones and go to the parent instead.
	 */
	const getPublicInstance = (i) => i && (i.proxy ? i.proxy : getPublicInstance(i.parent));
	const publicPropertiesMap = extend(Object.create(null), {
	    $: i => i,
	    $el: i => i.vnode.el,
	    $data: i => i.data,
	    $props: i => ( shallowReadonly(i.props) ),
	    $attrs: i => ( shallowReadonly(i.attrs) ),
	    $slots: i => ( shallowReadonly(i.slots) ),
	    $refs: i => ( shallowReadonly(i.refs) ),
	    $parent: i => getPublicInstance(i.parent),
	    $root: i => i.root && i.root.proxy,
	    $emit: i => i.emit,
	    $options: i => ( resolveMergedOptions(i) ),
	    $forceUpdate: i => () => queueJob(i.update),
	    $nextTick: i => nextTick.bind(i.proxy),
	    $watch: i => ( instanceWatch.bind(i) )
	});
	const PublicInstanceProxyHandlers = {
	    get({ _: instance }, key) {
	        const { ctx, setupState, data, props, accessCache, type, appContext } = instance;
	        // let @vue/reactivity know it should never observe Vue public instances.
	        if (key === "__v_skip" /* SKIP */) {
	            return true;
	        }
	        // for internal formatters to know that this is a Vue instance
	        if ( key === '__isVue') {
	            return true;
	        }
	        // data / props / ctx
	        // This getter gets called for every property access on the render context
	        // during render and is a major hotspot. The most expensive part of this
	        // is the multiple hasOwn() calls. It's much faster to do a simple property
	        // access on a plain object, so we use an accessCache object (with null
	        // prototype) to memoize what access type a key corresponds to.
	        let normalizedProps;
	        if (key[0] !== '$') {
	            const n = accessCache[key];
	            if (n !== undefined) {
	                switch (n) {
	                    case 0 /* SETUP */:
	                        return setupState[key];
	                    case 1 /* DATA */:
	                        return data[key];
	                    case 3 /* CONTEXT */:
	                        return ctx[key];
	                    case 2 /* PROPS */:
	                        return props[key];
	                    // default: just fallthrough
	                }
	            }
	            else if (setupState !== EMPTY_OBJ && hasOwn(setupState, key)) {
	                accessCache[key] = 0 /* SETUP */;
	                return setupState[key];
	            }
	            else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
	                accessCache[key] = 1 /* DATA */;
	                return data[key];
	            }
	            else if (
	            // only cache other properties when instance has declared (thus stable)
	            // props
	            (normalizedProps = instance.propsOptions[0]) &&
	                hasOwn(normalizedProps, key)) {
	                accessCache[key] = 2 /* PROPS */;
	                return props[key];
	            }
	            else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
	                accessCache[key] = 3 /* CONTEXT */;
	                return ctx[key];
	            }
	            else if ( !isInBeforeCreate) {
	                accessCache[key] = 4 /* OTHER */;
	            }
	        }
	        const publicGetter = publicPropertiesMap[key];
	        let cssModule, globalProperties;
	        // public $xxx properties
	        if (publicGetter) {
	            if (key === '$attrs') {
	                track(instance, "get" /* GET */, key);
	                 markAttrsAccessed();
	            }
	            return publicGetter(instance);
	        }
	        else if (
	        // css module (injected by vue-loader)
	        (cssModule = type.__cssModules) &&
	            (cssModule = cssModule[key])) {
	            return cssModule;
	        }
	        else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
	            // user may set custom properties to `this` that start with `$`
	            accessCache[key] = 3 /* CONTEXT */;
	            return ctx[key];
	        }
	        else if (
	        // global properties
	        ((globalProperties = appContext.config.globalProperties),
	            hasOwn(globalProperties, key))) {
	            return globalProperties[key];
	        }
	        else if (
	            currentRenderingInstance &&
	            (!isString(key) ||
	                // #1091 avoid internal isRef/isVNode checks on component instance leading
	                // to infinite warning loop
	                key.indexOf('__v') !== 0)) {
	            if (data !== EMPTY_OBJ &&
	                (key[0] === '$' || key[0] === '_') &&
	                hasOwn(data, key)) {
	                warn(`Property ${JSON.stringify(key)} must be accessed via $data because it starts with a reserved ` +
	                    `character ("$" or "_") and is not proxied on the render context.`);
	            }
	            else {
	                warn(`Property ${JSON.stringify(key)} was accessed during render ` +
	                    `but is not defined on instance.`);
	            }
	        }
	    },
	    set({ _: instance }, key, value) {
	        const { data, setupState, ctx } = instance;
	        if (setupState !== EMPTY_OBJ && hasOwn(setupState, key)) {
	            setupState[key] = value;
	        }
	        else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
	            data[key] = value;
	        }
	        else if (key in instance.props) {
	            
	                warn(`Attempting to mutate prop "${key}". Props are readonly.`, instance);
	            return false;
	        }
	        if (key[0] === '$' && key.slice(1) in instance) {
	            
	                warn(`Attempting to mutate public property "${key}". ` +
	                    `Properties starting with $ are reserved and readonly.`, instance);
	            return false;
	        }
	        else {
	            if ( key in instance.appContext.config.globalProperties) {
	                Object.defineProperty(ctx, key, {
	                    enumerable: true,
	                    configurable: true,
	                    value
	                });
	            }
	            else {
	                ctx[key] = value;
	            }
	        }
	        return true;
	    },
	    has({ _: { data, setupState, accessCache, ctx, appContext, propsOptions } }, key) {
	        let normalizedProps;
	        return (accessCache[key] !== undefined ||
	            (data !== EMPTY_OBJ && hasOwn(data, key)) ||
	            (setupState !== EMPTY_OBJ && hasOwn(setupState, key)) ||
	            ((normalizedProps = propsOptions[0]) && hasOwn(normalizedProps, key)) ||
	            hasOwn(ctx, key) ||
	            hasOwn(publicPropertiesMap, key) ||
	            hasOwn(appContext.config.globalProperties, key));
	    }
	};
	{
	    PublicInstanceProxyHandlers.ownKeys = (target) => {
	        warn(`Avoid app logic that relies on enumerating keys on a component instance. ` +
	            `The keys will be empty in production mode to avoid performance overhead.`);
	        return Reflect.ownKeys(target);
	    };
	}
	const RuntimeCompiledPublicInstanceProxyHandlers = extend({}, PublicInstanceProxyHandlers, {
	    get(target, key) {
	        // fast path for unscopables when using `with` block
	        if (key === Symbol.unscopables) {
	            return;
	        }
	        return PublicInstanceProxyHandlers.get(target, key, target);
	    },
	    has(_, key) {
	        const has = key[0] !== '_' && !isGloballyWhitelisted(key);
	        if ( !has && PublicInstanceProxyHandlers.has(_, key)) {
	            warn(`Property ${JSON.stringify(key)} should not start with _ which is a reserved prefix for Vue internals.`);
	        }
	        return has;
	    }
	});
	// In dev mode, the proxy target exposes the same properties as seen on `this`
	// for easier console inspection. In prod mode it will be an empty object so
	// these properties definitions can be skipped.
	function createRenderContext(instance) {
	    const target = {};
	    // expose internal instance for proxy handlers
	    Object.defineProperty(target, `_`, {
	        configurable: true,
	        enumerable: false,
	        get: () => instance
	    });
	    // expose public properties
	    Object.keys(publicPropertiesMap).forEach(key => {
	        Object.defineProperty(target, key, {
	            configurable: true,
	            enumerable: false,
	            get: () => publicPropertiesMap[key](instance),
	            // intercepted by the proxy so no need for implementation,
	            // but needed to prevent set errors
	            set: NOOP
	        });
	    });
	    // expose global properties
	    const { globalProperties } = instance.appContext.config;
	    Object.keys(globalProperties).forEach(key => {
	        Object.defineProperty(target, key, {
	            configurable: true,
	            enumerable: false,
	            get: () => globalProperties[key],
	            set: NOOP
	        });
	    });
	    return target;
	}
	// dev only
	function exposePropsOnRenderContext(instance) {
	    const { ctx, propsOptions: [propsOptions] } = instance;
	    if (propsOptions) {
	        Object.keys(propsOptions).forEach(key => {
	            Object.defineProperty(ctx, key, {
	                enumerable: true,
	                configurable: true,
	                get: () => instance.props[key],
	                set: NOOP
	            });
	        });
	    }
	}
	// dev only
	function exposeSetupStateOnRenderContext(instance) {
	    const { ctx, setupState } = instance;
	    Object.keys(toRaw(setupState)).forEach(key => {
	        if (key[0] === '$' || key[0] === '_') {
	            warn(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" ` +
	                `which are reserved prefixes for Vue internals.`);
	            return;
	        }
	        Object.defineProperty(ctx, key, {
	            enumerable: true,
	            configurable: true,
	            get: () => setupState[key],
	            set: NOOP
	        });
	    });
	}

	const emptyAppContext = createAppContext();
	let uid$1$1 = 0;
	function createComponentInstance(vnode, parent, suspense) {
	    const type = vnode.type;
	    // inherit parent app context - or - if root, adopt from root vnode
	    const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
	    const instance = {
	        uid: uid$1$1++,
	        vnode,
	        type,
	        parent,
	        appContext,
	        root: null,
	        next: null,
	        subTree: null,
	        update: null,
	        render: null,
	        proxy: null,
	        exposed: null,
	        withProxy: null,
	        effects: null,
	        provides: parent ? parent.provides : Object.create(appContext.provides),
	        accessCache: null,
	        renderCache: [],
	        // local resovled assets
	        components: null,
	        directives: null,
	        // resolved props and emits options
	        propsOptions: normalizePropsOptions(type, appContext),
	        emitsOptions: normalizeEmitsOptions(type, appContext),
	        // emit
	        emit: null,
	        emitted: null,
	        // state
	        ctx: EMPTY_OBJ,
	        data: EMPTY_OBJ,
	        props: EMPTY_OBJ,
	        attrs: EMPTY_OBJ,
	        slots: EMPTY_OBJ,
	        refs: EMPTY_OBJ,
	        setupState: EMPTY_OBJ,
	        setupContext: null,
	        // suspense related
	        suspense,
	        suspenseId: suspense ? suspense.pendingId : 0,
	        asyncDep: null,
	        asyncResolved: false,
	        // lifecycle hooks
	        // not using enums here because it results in computed properties
	        isMounted: false,
	        isUnmounted: false,
	        isDeactivated: false,
	        bc: null,
	        c: null,
	        bm: null,
	        m: null,
	        bu: null,
	        u: null,
	        um: null,
	        bum: null,
	        da: null,
	        a: null,
	        rtg: null,
	        rtc: null,
	        ec: null
	    };
	    {
	        instance.ctx = createRenderContext(instance);
	    }
	    instance.root = parent ? parent.root : instance;
	    instance.emit = emit.bind(null, instance);
	    {
	        devtoolsComponentAdded(instance);
	    }
	    return instance;
	}
	let currentInstance = null;
	const getCurrentInstance = () => currentInstance || currentRenderingInstance;
	const setCurrentInstance = (instance) => {
	    currentInstance = instance;
	};
	const isBuiltInTag = /*#__PURE__*/ makeMap('slot,component');
	function validateComponentName(name, config) {
	    const appIsNativeTag = config.isNativeTag || NO;
	    if (isBuiltInTag(name) || appIsNativeTag(name)) {
	        warn('Do not use built-in or reserved HTML elements as component id: ' + name);
	    }
	}
	let isInSSRComponentSetup = false;
	function setupComponent(instance, isSSR = false) {
	    isInSSRComponentSetup = isSSR;
	    const { props, children, shapeFlag } = instance.vnode;
	    const isStateful = shapeFlag & 4 /* STATEFUL_COMPONENT */;
	    initProps(instance, props, isStateful, isSSR);
	    initSlots(instance, children);
	    const setupResult = isStateful
	        ? setupStatefulComponent(instance, isSSR)
	        : undefined;
	    isInSSRComponentSetup = false;
	    return setupResult;
	}
	function setupStatefulComponent(instance, isSSR) {
	    const Component = instance.type;
	    {
	        if (Component.name) {
	            validateComponentName(Component.name, instance.appContext.config);
	        }
	        if (Component.components) {
	            const names = Object.keys(Component.components);
	            for (let i = 0; i < names.length; i++) {
	                validateComponentName(names[i], instance.appContext.config);
	            }
	        }
	        if (Component.directives) {
	            const names = Object.keys(Component.directives);
	            for (let i = 0; i < names.length; i++) {
	                validateDirectiveName(names[i]);
	            }
	        }
	    }
	    // 0. create render proxy property access cache
	    instance.accessCache = Object.create(null);
	    // 1. create public instance / render proxy
	    // also mark it raw so it's never observed
	    instance.proxy = new Proxy(instance.ctx, PublicInstanceProxyHandlers);
	    {
	        exposePropsOnRenderContext(instance);
	    }
	    // 2. call setup()
	    const { setup } = Component;
	    if (setup) {
	        const setupContext = (instance.setupContext =
	            setup.length > 1 ? createSetupContext(instance) : null);
	        currentInstance = instance;
	        pauseTracking();
	        const setupResult = callWithErrorHandling(setup, instance, 0 /* SETUP_FUNCTION */, [ shallowReadonly(instance.props) , setupContext]);
	        resetTracking();
	        currentInstance = null;
	        if (isPromise(setupResult)) {
	            if (isSSR) {
	                // return the promise so server-renderer can wait on it
	                return setupResult.then((resolvedResult) => {
	                    handleSetupResult(instance, resolvedResult);
	                });
	            }
	            else {
	                // async setup returned Promise.
	                // bail here and wait for re-entry.
	                instance.asyncDep = setupResult;
	            }
	        }
	        else {
	            handleSetupResult(instance, setupResult);
	        }
	    }
	    else {
	        finishComponentSetup(instance);
	    }
	}
	function handleSetupResult(instance, setupResult, isSSR) {
	    if (isFunction(setupResult)) {
	        // setup returned an inline render function
	        {
	            instance.render = setupResult;
	        }
	    }
	    else if (isObject(setupResult)) {
	        if ( isVNode(setupResult)) {
	            warn(`setup() should not return VNodes directly - ` +
	                `return a render function instead.`);
	        }
	        // setup returned bindings.
	        // assuming a render function compiled from template is present.
	        {
	            instance.devtoolsRawSetupState = setupResult;
	        }
	        instance.setupState = proxyRefs(setupResult);
	        {
	            exposeSetupStateOnRenderContext(instance);
	        }
	    }
	    else if ( setupResult !== undefined) {
	        warn(`setup() should return an object. Received: ${setupResult === null ? 'null' : typeof setupResult}`);
	    }
	    finishComponentSetup(instance);
	}
	let compile;
	/**
	 * For runtime-dom to register the compiler.
	 * Note the exported method uses any to avoid d.ts relying on the compiler types.
	 */
	function registerRuntimeCompiler(_compile) {
	    compile = _compile;
	}
	function finishComponentSetup(instance, isSSR) {
	    const Component = instance.type;
	    // template / render function normalization
	    if (!instance.render) {
	        // could be set from setup()
	        if (compile && Component.template && !Component.render) {
	            {
	                startMeasure(instance, `compile`);
	            }
	            Component.render = compile(Component.template, {
	                isCustomElement: instance.appContext.config.isCustomElement,
	                delimiters: Component.delimiters
	            });
	            {
	                endMeasure(instance, `compile`);
	            }
	        }
	        instance.render = (Component.render || NOOP);
	        // for runtime-compiled render functions using `with` blocks, the render
	        // proxy used needs a different `has` handler which is more performant and
	        // also only allows a whitelist of globals to fallthrough.
	        if (instance.render._rc) {
	            instance.withProxy = new Proxy(instance.ctx, RuntimeCompiledPublicInstanceProxyHandlers);
	        }
	    }
	    // support for 2.x options
	    {
	        currentInstance = instance;
	        pauseTracking();
	        applyOptions(instance, Component);
	        resetTracking();
	        currentInstance = null;
	    }
	    // warn missing template/render
	    if ( !Component.render && instance.render === NOOP) {
	        /* istanbul ignore if */
	        if (!compile && Component.template) {
	            warn(`Component provided template option but ` +
	                `runtime compilation is not supported in this build of Vue.` +
	                ( ` Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".`
	                    ) /* should not happen */);
	        }
	        else {
	            warn(`Component is missing template or render function.`);
	        }
	    }
	}
	const attrHandlers = {
	    get: (target, key) => {
	        {
	            markAttrsAccessed();
	        }
	        return target[key];
	    },
	    set: () => {
	        warn(`setupContext.attrs is readonly.`);
	        return false;
	    },
	    deleteProperty: () => {
	        warn(`setupContext.attrs is readonly.`);
	        return false;
	    }
	};
	function createSetupContext(instance) {
	    const expose = exposed => {
	        if ( instance.exposed) {
	            warn(`expose() should be called only once per setup().`);
	        }
	        instance.exposed = proxyRefs(exposed);
	    };
	    {
	        // We use getters in dev in case libs like test-utils overwrite instance
	        // properties (overwrites should not be done in prod)
	        return Object.freeze({
	            get props() {
	                return instance.props;
	            },
	            get attrs() {
	                return new Proxy(instance.attrs, attrHandlers);
	            },
	            get slots() {
	                return shallowReadonly(instance.slots);
	            },
	            get emit() {
	                return (event, ...args) => instance.emit(event, ...args);
	            },
	            expose
	        });
	    }
	}
	// record effects created during a component's setup() so that they can be
	// stopped when the component unmounts
	function recordInstanceBoundEffect(effect, instance = currentInstance) {
	    if (instance) {
	        (instance.effects || (instance.effects = [])).push(effect);
	    }
	}
	const classifyRE = /(?:^|[-_])(\w)/g;
	const classify = (str) => str.replace(classifyRE, c => c.toUpperCase()).replace(/[-_]/g, '');
	function getComponentName(Component) {
	    return isFunction(Component)
	        ? Component.displayName || Component.name
	        : Component.name;
	}
	/* istanbul ignore next */
	function formatComponentName(instance, Component, isRoot = false) {
	    let name = getComponentName(Component);
	    if (!name && Component.__file) {
	        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
	        if (match) {
	            name = match[1];
	        }
	    }
	    if (!name && instance && instance.parent) {
	        // try to infer the name based on reverse resolution
	        const inferFromRegistry = (registry) => {
	            for (const key in registry) {
	                if (registry[key] === Component) {
	                    return key;
	                }
	            }
	        };
	        name =
	            inferFromRegistry(instance.components ||
	                instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
	    }
	    return name ? classify(name) : isRoot ? `App` : `Anonymous`;
	}
	function isClassComponent(value) {
	    return isFunction(value) && '__vccOpts' in value;
	}

	function computed$1(getterOrOptions) {
	    const c = computed(getterOrOptions);
	    recordInstanceBoundEffect(c.effect);
	    return c;
	}

	// implementation
	function defineProps() {
	    {
	        warn(`defineProps() is a compiler-hint helper that is only usable inside ` +
	            `<script setup> of a single file component. Its arguments should be ` +
	            `compiled away and passing it at runtime has no effect.`);
	    }
	    return null;
	}
	// implementation
	function defineEmit() {
	    {
	        warn(`defineEmit() is a compiler-hint helper that is only usable inside ` +
	            `<script setup> of a single file component. Its arguments should be ` +
	            `compiled away and passing it at runtime has no effect.`);
	    }
	    return null;
	}
	function useContext() {
	    const i = getCurrentInstance();
	    if ( !i) {
	        warn(`useContext() called without active instance.`);
	    }
	    return i.setupContext || (i.setupContext = createSetupContext(i));
	}

	// Actual implementation
	function h(type, propsOrChildren, children) {
	    const l = arguments.length;
	    if (l === 2) {
	        if (isObject(propsOrChildren) && !isArray(propsOrChildren)) {
	            // single vnode without props
	            if (isVNode(propsOrChildren)) {
	                return createVNode(type, null, [propsOrChildren]);
	            }
	            // props without children
	            return createVNode(type, propsOrChildren);
	        }
	        else {
	            // omit props
	            return createVNode(type, null, propsOrChildren);
	        }
	    }
	    else {
	        if (l > 3) {
	            children = Array.prototype.slice.call(arguments, 2);
	        }
	        else if (l === 3 && isVNode(children)) {
	            children = [children];
	        }
	        return createVNode(type, propsOrChildren, children);
	    }
	}

	const ssrContextKey = Symbol( `ssrContext` );
	const useSSRContext = () => {
	    {
	        const ctx = inject(ssrContextKey);
	        if (!ctx) {
	            warn(`Server rendering context not provided. Make sure to only call ` +
	                `useSsrContext() conditionally in the server build.`);
	        }
	        return ctx;
	    }
	};

	function initCustomFormatter() {
	    /* eslint-disable no-restricted-globals */
	    if ( typeof window === 'undefined') {
	        return;
	    }
	    const vueStyle = { style: 'color:#3ba776' };
	    const numberStyle = { style: 'color:#0b1bc9' };
	    const stringStyle = { style: 'color:#b62e24' };
	    const keywordStyle = { style: 'color:#9d288c' };
	    // custom formatter for Chrome
	    // https://www.mattzeunert.com/2016/02/19/custom-chrome-devtools-object-formatters.html
	    const formatter = {
	        header(obj) {
	            // TODO also format ComponentPublicInstance & ctx.slots/attrs in setup
	            if (!isObject(obj)) {
	                return null;
	            }
	            if (obj.__isVue) {
	                return ['div', vueStyle, `VueInstance`];
	            }
	            else if (isRef(obj)) {
	                return [
	                    'div',
	                    {},
	                    ['span', vueStyle, genRefFlag(obj)],
	                    '<',
	                    formatValue(obj.value),
	                    `>`
	                ];
	            }
	            else if (isReactive(obj)) {
	                return [
	                    'div',
	                    {},
	                    ['span', vueStyle, 'Reactive'],
	                    '<',
	                    formatValue(obj),
	                    `>${isReadonly(obj) ? ` (readonly)` : ``}`
	                ];
	            }
	            else if (isReadonly(obj)) {
	                return [
	                    'div',
	                    {},
	                    ['span', vueStyle, 'Readonly'],
	                    '<',
	                    formatValue(obj),
	                    '>'
	                ];
	            }
	            return null;
	        },
	        hasBody(obj) {
	            return obj && obj.__isVue;
	        },
	        body(obj) {
	            if (obj && obj.__isVue) {
	                return [
	                    'div',
	                    {},
	                    ...formatInstance(obj.$)
	                ];
	            }
	        }
	    };
	    function formatInstance(instance) {
	        const blocks = [];
	        if (instance.type.props && instance.props) {
	            blocks.push(createInstanceBlock('props', toRaw(instance.props)));
	        }
	        if (instance.setupState !== EMPTY_OBJ) {
	            blocks.push(createInstanceBlock('setup', instance.setupState));
	        }
	        if (instance.data !== EMPTY_OBJ) {
	            blocks.push(createInstanceBlock('data', toRaw(instance.data)));
	        }
	        const computed = extractKeys(instance, 'computed');
	        if (computed) {
	            blocks.push(createInstanceBlock('computed', computed));
	        }
	        const injected = extractKeys(instance, 'inject');
	        if (injected) {
	            blocks.push(createInstanceBlock('injected', injected));
	        }
	        blocks.push([
	            'div',
	            {},
	            [
	                'span',
	                {
	                    style: keywordStyle.style + ';opacity:0.66'
	                },
	                '$ (internal): '
	            ],
	            ['object', { object: instance }]
	        ]);
	        return blocks;
	    }
	    function createInstanceBlock(type, target) {
	        target = extend({}, target);
	        if (!Object.keys(target).length) {
	            return ['span', {}];
	        }
	        return [
	            'div',
	            { style: 'line-height:1.25em;margin-bottom:0.6em' },
	            [
	                'div',
	                {
	                    style: 'color:#476582'
	                },
	                type
	            ],
	            [
	                'div',
	                {
	                    style: 'padding-left:1.25em'
	                },
	                ...Object.keys(target).map(key => {
	                    return [
	                        'div',
	                        {},
	                        ['span', keywordStyle, key + ': '],
	                        formatValue(target[key], false)
	                    ];
	                })
	            ]
	        ];
	    }
	    function formatValue(v, asRaw = true) {
	        if (typeof v === 'number') {
	            return ['span', numberStyle, v];
	        }
	        else if (typeof v === 'string') {
	            return ['span', stringStyle, JSON.stringify(v)];
	        }
	        else if (typeof v === 'boolean') {
	            return ['span', keywordStyle, v];
	        }
	        else if (isObject(v)) {
	            return ['object', { object: asRaw ? toRaw(v) : v }];
	        }
	        else {
	            return ['span', stringStyle, String(v)];
	        }
	    }
	    function extractKeys(instance, type) {
	        const Comp = instance.type;
	        if (isFunction(Comp)) {
	            return;
	        }
	        const extracted = {};
	        for (const key in instance.ctx) {
	            if (isKeyOfType(Comp, key, type)) {
	                extracted[key] = instance.ctx[key];
	            }
	        }
	        return extracted;
	    }
	    function isKeyOfType(Comp, key, type) {
	        const opts = Comp[type];
	        if ((isArray(opts) && opts.includes(key)) ||
	            (isObject(opts) && key in opts)) {
	            return true;
	        }
	        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) {
	            return true;
	        }
	        if (Comp.mixins && Comp.mixins.some(m => isKeyOfType(m, key, type))) {
	            return true;
	        }
	    }
	    function genRefFlag(v) {
	        if (v._shallow) {
	            return `ShallowRef`;
	        }
	        if (v.effect) {
	            return `ComputedRef`;
	        }
	        return `Ref`;
	    }
	    if (window.devtoolsFormatters) {
	        window.devtoolsFormatters.push(formatter);
	    }
	    else {
	        window.devtoolsFormatters = [formatter];
	    }
	}

	/**
	 * Actual implementation
	 */
	function renderList(source, renderItem) {
	    let ret;
	    if (isArray(source) || isString(source)) {
	        ret = new Array(source.length);
	        for (let i = 0, l = source.length; i < l; i++) {
	            ret[i] = renderItem(source[i], i);
	        }
	    }
	    else if (typeof source === 'number') {
	        if ( !Number.isInteger(source)) {
	            warn(`The v-for range expect an integer value but got ${source}.`);
	            return [];
	        }
	        ret = new Array(source);
	        for (let i = 0; i < source; i++) {
	            ret[i] = renderItem(i + 1, i);
	        }
	    }
	    else if (isObject(source)) {
	        if (source[Symbol.iterator]) {
	            ret = Array.from(source, renderItem);
	        }
	        else {
	            const keys = Object.keys(source);
	            ret = new Array(keys.length);
	            for (let i = 0, l = keys.length; i < l; i++) {
	                const key = keys[i];
	                ret[i] = renderItem(source[key], key, i);
	            }
	        }
	    }
	    else {
	        ret = [];
	    }
	    return ret;
	}

	/**
	 * For prefixing keys in v-on="obj" with "on"
	 * @private
	 */
	function toHandlers(obj) {
	    const ret = {};
	    if ( !isObject(obj)) {
	        warn(`v-on with no argument expects an object value.`);
	        return ret;
	    }
	    for (const key in obj) {
	        ret[toHandlerKey(key)] = obj[key];
	    }
	    return ret;
	}

	/**
	 * Compiler runtime helper for creating dynamic slots object
	 * @private
	 */
	function createSlots(slots, dynamicSlots) {
	    for (let i = 0; i < dynamicSlots.length; i++) {
	        const slot = dynamicSlots[i];
	        // array of dynamic slot generated by <template v-for="..." #[...]>
	        if (isArray(slot)) {
	            for (let j = 0; j < slot.length; j++) {
	                slots[slot[j].name] = slot[j].fn;
	            }
	        }
	        else if (slot) {
	            // conditional single slot generated by <template v-if="..." #foo>
	            slots[slot.name] = slot.fn;
	        }
	    }
	    return slots;
	}

	// Core API ------------------------------------------------------------------
	const version = "3.0.5";
	/**
	 * SSR utils for \@vue/server-renderer. Only exposed in cjs builds.
	 * @internal
	 */
	const ssrUtils = ( null);

	const svgNS = 'http://www.w3.org/2000/svg';
	const doc = (typeof document !== 'undefined' ? document : null);
	let tempContainer;
	let tempSVGContainer;
	const nodeOps = {
	    insert: (child, parent, anchor) => {
	        parent.insertBefore(child, anchor || null);
	    },
	    remove: child => {
	        const parent = child.parentNode;
	        if (parent) {
	            parent.removeChild(child);
	        }
	    },
	    createElement: (tag, isSVG, is) => isSVG
	        ? doc.createElementNS(svgNS, tag)
	        : doc.createElement(tag, is ? { is } : undefined),
	    createText: text => doc.createTextNode(text),
	    createComment: text => doc.createComment(text),
	    setText: (node, text) => {
	        node.nodeValue = text;
	    },
	    setElementText: (el, text) => {
	        el.textContent = text;
	    },
	    parentNode: node => node.parentNode,
	    nextSibling: node => node.nextSibling,
	    querySelector: selector => doc.querySelector(selector),
	    setScopeId(el, id) {
	        el.setAttribute(id, '');
	    },
	    cloneNode(el) {
	        return el.cloneNode(true);
	    },
	    // __UNSAFE__
	    // Reason: innerHTML.
	    // Static content here can only come from compiled templates.
	    // As long as the user only uses trusted templates, this is safe.
	    insertStaticContent(content, parent, anchor, isSVG) {
	        const temp = isSVG
	            ? tempSVGContainer ||
	                (tempSVGContainer = doc.createElementNS(svgNS, 'svg'))
	            : tempContainer || (tempContainer = doc.createElement('div'));
	        temp.innerHTML = content;
	        const first = temp.firstChild;
	        let node = first;
	        let last = node;
	        while (node) {
	            last = node;
	            nodeOps.insert(node, parent, anchor);
	            node = temp.firstChild;
	        }
	        return [first, last];
	    }
	};

	// compiler should normalize class + :class bindings on the same element
	// into a single binding ['staticClass', dynamic]
	function patchClass(el, value, isSVG) {
	    if (value == null) {
	        value = '';
	    }
	    if (isSVG) {
	        el.setAttribute('class', value);
	    }
	    else {
	        // directly setting className should be faster than setAttribute in theory
	        // if this is an element during a transition, take the temporary transition
	        // classes into account.
	        const transitionClasses = el._vtc;
	        if (transitionClasses) {
	            value = (value
	                ? [value, ...transitionClasses]
	                : [...transitionClasses]).join(' ');
	        }
	        el.className = value;
	    }
	}

	function patchStyle(el, prev, next) {
	    const style = el.style;
	    if (!next) {
	        el.removeAttribute('style');
	    }
	    else if (isString(next)) {
	        if (prev !== next) {
	            style.cssText = next;
	        }
	    }
	    else {
	        for (const key in next) {
	            setStyle(style, key, next[key]);
	        }
	        if (prev && !isString(prev)) {
	            for (const key in prev) {
	                if (next[key] == null) {
	                    setStyle(style, key, '');
	                }
	            }
	        }
	    }
	}
	const importantRE = /\s*!important$/;
	function setStyle(style, name, val) {
	    if (isArray(val)) {
	        val.forEach(v => setStyle(style, name, v));
	    }
	    else {
	        if (name.startsWith('--')) {
	            // custom property definition
	            style.setProperty(name, val);
	        }
	        else {
	            const prefixed = autoPrefix(style, name);
	            if (importantRE.test(val)) {
	                // !important
	                style.setProperty(hyphenate(prefixed), val.replace(importantRE, ''), 'important');
	            }
	            else {
	                style[prefixed] = val;
	            }
	        }
	    }
	}
	const prefixes = ['Webkit', 'Moz', 'ms'];
	const prefixCache = {};
	function autoPrefix(style, rawName) {
	    const cached = prefixCache[rawName];
	    if (cached) {
	        return cached;
	    }
	    let name = camelize(rawName);
	    if (name !== 'filter' && name in style) {
	        return (prefixCache[rawName] = name);
	    }
	    name = capitalize(name);
	    for (let i = 0; i < prefixes.length; i++) {
	        const prefixed = prefixes[i] + name;
	        if (prefixed in style) {
	            return (prefixCache[rawName] = prefixed);
	        }
	    }
	    return rawName;
	}

	const xlinkNS = 'http://www.w3.org/1999/xlink';
	function patchAttr(el, key, value, isSVG) {
	    if (isSVG && key.startsWith('xlink:')) {
	        if (value == null) {
	            el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
	        }
	        else {
	            el.setAttributeNS(xlinkNS, key, value);
	        }
	    }
	    else {
	        // note we are only checking boolean attributes that don't have a
	        // corresponding dom prop of the same name here.
	        const isBoolean = isSpecialBooleanAttr(key);
	        if (value == null || (isBoolean && value === false)) {
	            el.removeAttribute(key);
	        }
	        else {
	            el.setAttribute(key, isBoolean ? '' : value);
	        }
	    }
	}

	// __UNSAFE__
	// functions. The user is responsible for using them with only trusted content.
	function patchDOMProp(el, key, value, 
	// the following args are passed only due to potential innerHTML/textContent
	// overriding existing VNodes, in which case the old tree must be properly
	// unmounted.
	prevChildren, parentComponent, parentSuspense, unmountChildren) {
	    if (key === 'innerHTML' || key === 'textContent') {
	        if (prevChildren) {
	            unmountChildren(prevChildren, parentComponent, parentSuspense);
	        }
	        el[key] = value == null ? '' : value;
	        return;
	    }
	    if (key === 'value' && el.tagName !== 'PROGRESS') {
	        // store value as _value as well since
	        // non-string values will be stringified.
	        el._value = value;
	        const newValue = value == null ? '' : value;
	        if (el.value !== newValue) {
	            el.value = newValue;
	        }
	        return;
	    }
	    if (value === '' || value == null) {
	        const type = typeof el[key];
	        if (value === '' && type === 'boolean') {
	            // e.g. <select multiple> compiles to { multiple: '' }
	            el[key] = true;
	            return;
	        }
	        else if (value == null && type === 'string') {
	            // e.g. <div :id="null">
	            el[key] = '';
	            el.removeAttribute(key);
	            return;
	        }
	        else if (type === 'number') {
	            // e.g. <img :width="null">
	            el[key] = 0;
	            el.removeAttribute(key);
	            return;
	        }
	    }
	    // some properties perform value validation and throw
	    try {
	        el[key] = value;
	    }
	    catch (e) {
	        {
	            warn(`Failed setting prop "${key}" on <${el.tagName.toLowerCase()}>: ` +
	                `value ${value} is invalid.`, e);
	        }
	    }
	}

	// Async edge case fix requires storing an event listener's attach timestamp.
	let _getNow = Date.now;
	// Determine what event timestamp the browser is using. Annoyingly, the
	// timestamp can either be hi-res (relative to page load) or low-res
	// (relative to UNIX epoch), so in order to compare time we have to use the
	// same timestamp type when saving the flush timestamp.
	if (typeof document !== 'undefined' &&
	    _getNow() > document.createEvent('Event').timeStamp) {
	    // if the low-res timestamp which is bigger than the event timestamp
	    // (which is evaluated AFTER) it means the event is using a hi-res timestamp,
	    // and we need to use the hi-res version for event listeners as well.
	    _getNow = () => performance.now();
	}
	// To avoid the overhead of repeatedly calling performance.now(), we cache
	// and use the same timestamp for all event listeners attached in the same tick.
	let cachedNow = 0;
	const p = Promise.resolve();
	const reset = () => {
	    cachedNow = 0;
	};
	const getNow = () => cachedNow || (p.then(reset), (cachedNow = _getNow()));
	function addEventListener(el, event, handler, options) {
	    el.addEventListener(event, handler, options);
	}
	function removeEventListener(el, event, handler, options) {
	    el.removeEventListener(event, handler, options);
	}
	function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
	    // vei = vue event invokers
	    const invokers = el._vei || (el._vei = {});
	    const existingInvoker = invokers[rawName];
	    if (nextValue && existingInvoker) {
	        // patch
	        existingInvoker.value = nextValue;
	    }
	    else {
	        const [name, options] = parseName(rawName);
	        if (nextValue) {
	            // add
	            const invoker = (invokers[rawName] = createInvoker(nextValue, instance));
	            addEventListener(el, name, invoker, options);
	        }
	        else if (existingInvoker) {
	            // remove
	            removeEventListener(el, name, existingInvoker, options);
	            invokers[rawName] = undefined;
	        }
	    }
	}
	const optionsModifierRE = /(?:Once|Passive|Capture)$/;
	function parseName(name) {
	    let options;
	    if (optionsModifierRE.test(name)) {
	        options = {};
	        let m;
	        while ((m = name.match(optionsModifierRE))) {
	            name = name.slice(0, name.length - m[0].length);
	            options[m[0].toLowerCase()] = true;
	        }
	    }
	    return [name.slice(2).toLowerCase(), options];
	}
	function createInvoker(initialValue, instance) {
	    const invoker = (e) => {
	        // async edge case #6566: inner click event triggers patch, event handler
	        // attached to outer element during patch, and triggered again. This
	        // happens because browsers fire microtask ticks between event propagation.
	        // the solution is simple: we save the timestamp when a handler is attached,
	        // and the handler would only fire if the event passed to it was fired
	        // AFTER it was attached.
	        const timeStamp = e.timeStamp || _getNow();
	        if (timeStamp >= invoker.attached - 1) {
	            callWithAsyncErrorHandling(patchStopImmediatePropagation(e, invoker.value), instance, 5 /* NATIVE_EVENT_HANDLER */, [e]);
	        }
	    };
	    invoker.value = initialValue;
	    invoker.attached = getNow();
	    return invoker;
	}
	function patchStopImmediatePropagation(e, value) {
	    if (isArray(value)) {
	        const originalStop = e.stopImmediatePropagation;
	        e.stopImmediatePropagation = () => {
	            originalStop.call(e);
	            e._stopped = true;
	        };
	        return value.map(fn => (e) => !e._stopped && fn(e));
	    }
	    else {
	        return value;
	    }
	}

	const nativeOnRE = /^on[a-z]/;
	const forcePatchProp = (_, key) => key === 'value';
	const patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren) => {
	    switch (key) {
	        // special
	        case 'class':
	            patchClass(el, nextValue, isSVG);
	            break;
	        case 'style':
	            patchStyle(el, prevValue, nextValue);
	            break;
	        default:
	            if (isOn(key)) {
	                // ignore v-model listeners
	                if (!isModelListener(key)) {
	                    patchEvent(el, key, prevValue, nextValue, parentComponent);
	                }
	            }
	            else if (shouldSetAsProp(el, key, nextValue, isSVG)) {
	                patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
	            }
	            else {
	                // special case for <input v-model type="checkbox"> with
	                // :true-value & :false-value
	                // store value as dom properties since non-string values will be
	                // stringified.
	                if (key === 'true-value') {
	                    el._trueValue = nextValue;
	                }
	                else if (key === 'false-value') {
	                    el._falseValue = nextValue;
	                }
	                patchAttr(el, key, nextValue, isSVG);
	            }
	            break;
	    }
	};
	function shouldSetAsProp(el, key, value, isSVG) {
	    if (isSVG) {
	        // most keys must be set as attribute on svg elements to work
	        // ...except innerHTML
	        if (key === 'innerHTML') {
	            return true;
	        }
	        // or native onclick with function values
	        if (key in el && nativeOnRE.test(key) && isFunction(value)) {
	            return true;
	        }
	        return false;
	    }
	    // spellcheck and draggable are numerated attrs, however their
	    // corresponding DOM properties are actually booleans - this leads to
	    // setting it with a string "false" value leading it to be coerced to
	    // `true`, so we need to always treat them as attributes.
	    // Note that `contentEditable` doesn't have this problem: its DOM
	    // property is also enumerated string values.
	    if (key === 'spellcheck' || key === 'draggable') {
	        return false;
	    }
	    // #1787 form as an attribute must be a string, while it accepts an Element as
	    // a prop
	    if (key === 'form' && typeof value === 'string') {
	        return false;
	    }
	    // #1526 <input list> must be set as attribute
	    if (key === 'list' && el.tagName === 'INPUT') {
	        return false;
	    }
	    // native onclick with string value, must be set as attribute
	    if (nativeOnRE.test(key) && isString(value)) {
	        return false;
	    }
	    return key in el;
	}

	function useCssModule(name = '$style') {
	    /* istanbul ignore else */
	    {
	        const instance = getCurrentInstance();
	        if (!instance) {
	             warn(`useCssModule must be called inside setup()`);
	            return EMPTY_OBJ;
	        }
	        const modules = instance.type.__cssModules;
	        if (!modules) {
	             warn(`Current instance does not have CSS modules injected.`);
	            return EMPTY_OBJ;
	        }
	        const mod = modules[name];
	        if (!mod) {
	            
	                warn(`Current instance does not have CSS module named "${name}".`);
	            return EMPTY_OBJ;
	        }
	        return mod;
	    }
	}

	/**
	 * Runtime helper for SFC's CSS variable injection feature.
	 * @private
	 */
	function useCssVars(getter) {
	    const instance = getCurrentInstance();
	    /* istanbul ignore next */
	    if (!instance) {
	        
	            warn(`useCssVars is called without current active component instance.`);
	        return;
	    }
	    const setVars = () => setVarsOnVNode(instance.subTree, getter(instance.proxy));
	    onMounted(() => watchEffect(setVars, { flush: 'post' }));
	    onUpdated(setVars);
	}
	function setVarsOnVNode(vnode, vars) {
	    if ( vnode.shapeFlag & 128 /* SUSPENSE */) {
	        const suspense = vnode.suspense;
	        vnode = suspense.activeBranch;
	        if (suspense.pendingBranch && !suspense.isHydrating) {
	            suspense.effects.push(() => {
	                setVarsOnVNode(suspense.activeBranch, vars);
	            });
	        }
	    }
	    // drill down HOCs until it's a non-component vnode
	    while (vnode.component) {
	        vnode = vnode.component.subTree;
	    }
	    if (vnode.shapeFlag & 1 /* ELEMENT */ && vnode.el) {
	        const style = vnode.el.style;
	        for (const key in vars) {
	            style.setProperty(`--${key}`, vars[key]);
	        }
	    }
	    else if (vnode.type === Fragment) {
	        vnode.children.forEach(c => setVarsOnVNode(c, vars));
	    }
	}

	const TRANSITION = 'transition';
	const ANIMATION = 'animation';
	// DOM Transition is a higher-order-component based on the platform-agnostic
	// base Transition component, with DOM-specific logic.
	const Transition = (props, { slots }) => h(BaseTransition, resolveTransitionProps(props), slots);
	Transition.displayName = 'Transition';
	const DOMTransitionPropsValidators = {
	    name: String,
	    type: String,
	    css: {
	        type: Boolean,
	        default: true
	    },
	    duration: [String, Number, Object],
	    enterFromClass: String,
	    enterActiveClass: String,
	    enterToClass: String,
	    appearFromClass: String,
	    appearActiveClass: String,
	    appearToClass: String,
	    leaveFromClass: String,
	    leaveActiveClass: String,
	    leaveToClass: String
	};
	const TransitionPropsValidators = (Transition.props = /*#__PURE__*/ extend({}, BaseTransition.props, DOMTransitionPropsValidators));
	function resolveTransitionProps(rawProps) {
	    let { name = 'v', type, css = true, duration, enterFromClass = `${name}-enter-from`, enterActiveClass = `${name}-enter-active`, enterToClass = `${name}-enter-to`, appearFromClass = enterFromClass, appearActiveClass = enterActiveClass, appearToClass = enterToClass, leaveFromClass = `${name}-leave-from`, leaveActiveClass = `${name}-leave-active`, leaveToClass = `${name}-leave-to` } = rawProps;
	    const baseProps = {};
	    for (const key in rawProps) {
	        if (!(key in DOMTransitionPropsValidators)) {
	            baseProps[key] = rawProps[key];
	        }
	    }
	    if (!css) {
	        return baseProps;
	    }
	    const durations = normalizeDuration(duration);
	    const enterDuration = durations && durations[0];
	    const leaveDuration = durations && durations[1];
	    const { onBeforeEnter, onEnter, onEnterCancelled, onLeave, onLeaveCancelled, onBeforeAppear = onBeforeEnter, onAppear = onEnter, onAppearCancelled = onEnterCancelled } = baseProps;
	    const finishEnter = (el, isAppear, done) => {
	        removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
	        removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
	        done && done();
	    };
	    const finishLeave = (el, done) => {
	        removeTransitionClass(el, leaveToClass);
	        removeTransitionClass(el, leaveActiveClass);
	        done && done();
	    };
	    const makeEnterHook = (isAppear) => {
	        return (el, done) => {
	            const hook = isAppear ? onAppear : onEnter;
	            const resolve = () => finishEnter(el, isAppear, done);
	            hook && hook(el, resolve);
	            nextFrame(() => {
	                removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
	                addTransitionClass(el, isAppear ? appearToClass : enterToClass);
	                if (!(hook && hook.length > 1)) {
	                    whenTransitionEnds(el, type, enterDuration, resolve);
	                }
	            });
	        };
	    };
	    return extend(baseProps, {
	        onBeforeEnter(el) {
	            onBeforeEnter && onBeforeEnter(el);
	            addTransitionClass(el, enterFromClass);
	            addTransitionClass(el, enterActiveClass);
	        },
	        onBeforeAppear(el) {
	            onBeforeAppear && onBeforeAppear(el);
	            addTransitionClass(el, appearFromClass);
	            addTransitionClass(el, appearActiveClass);
	        },
	        onEnter: makeEnterHook(false),
	        onAppear: makeEnterHook(true),
	        onLeave(el, done) {
	            const resolve = () => finishLeave(el, done);
	            addTransitionClass(el, leaveFromClass);
	            // force reflow so *-leave-from classes immediately take effect (#2593)
	            forceReflow();
	            addTransitionClass(el, leaveActiveClass);
	            nextFrame(() => {
	                removeTransitionClass(el, leaveFromClass);
	                addTransitionClass(el, leaveToClass);
	                if (!(onLeave && onLeave.length > 1)) {
	                    whenTransitionEnds(el, type, leaveDuration, resolve);
	                }
	            });
	            onLeave && onLeave(el, resolve);
	        },
	        onEnterCancelled(el) {
	            finishEnter(el, false);
	            onEnterCancelled && onEnterCancelled(el);
	        },
	        onAppearCancelled(el) {
	            finishEnter(el, true);
	            onAppearCancelled && onAppearCancelled(el);
	        },
	        onLeaveCancelled(el) {
	            finishLeave(el);
	            onLeaveCancelled && onLeaveCancelled(el);
	        }
	    });
	}
	function normalizeDuration(duration) {
	    if (duration == null) {
	        return null;
	    }
	    else if (isObject(duration)) {
	        return [NumberOf(duration.enter), NumberOf(duration.leave)];
	    }
	    else {
	        const n = NumberOf(duration);
	        return [n, n];
	    }
	}
	function NumberOf(val) {
	    const res = toNumber(val);
	    validateDuration(res);
	    return res;
	}
	function validateDuration(val) {
	    if (typeof val !== 'number') {
	        warn(`<transition> explicit duration is not a valid number - ` +
	            `got ${JSON.stringify(val)}.`);
	    }
	    else if (isNaN(val)) {
	        warn(`<transition> explicit duration is NaN - ` +
	            'the duration expression might be incorrect.');
	    }
	}
	function addTransitionClass(el, cls) {
	    cls.split(/\s+/).forEach(c => c && el.classList.add(c));
	    (el._vtc ||
	        (el._vtc = new Set())).add(cls);
	}
	function removeTransitionClass(el, cls) {
	    cls.split(/\s+/).forEach(c => c && el.classList.remove(c));
	    const { _vtc } = el;
	    if (_vtc) {
	        _vtc.delete(cls);
	        if (!_vtc.size) {
	            el._vtc = undefined;
	        }
	    }
	}
	function nextFrame(cb) {
	    requestAnimationFrame(() => {
	        requestAnimationFrame(cb);
	    });
	}
	let endId = 0;
	function whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
	    const id = (el._endId = ++endId);
	    const resolveIfNotStale = () => {
	        if (id === el._endId) {
	            resolve();
	        }
	    };
	    if (explicitTimeout) {
	        return setTimeout(resolveIfNotStale, explicitTimeout);
	    }
	    const { type, timeout, propCount } = getTransitionInfo(el, expectedType);
	    if (!type) {
	        return resolve();
	    }
	    const endEvent = type + 'end';
	    let ended = 0;
	    const end = () => {
	        el.removeEventListener(endEvent, onEnd);
	        resolveIfNotStale();
	    };
	    const onEnd = (e) => {
	        if (e.target === el && ++ended >= propCount) {
	            end();
	        }
	    };
	    setTimeout(() => {
	        if (ended < propCount) {
	            end();
	        }
	    }, timeout + 1);
	    el.addEventListener(endEvent, onEnd);
	}
	function getTransitionInfo(el, expectedType) {
	    const styles = window.getComputedStyle(el);
	    // JSDOM may return undefined for transition properties
	    const getStyleProperties = (key) => (styles[key] || '').split(', ');
	    const transitionDelays = getStyleProperties(TRANSITION + 'Delay');
	    const transitionDurations = getStyleProperties(TRANSITION + 'Duration');
	    const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
	    const animationDelays = getStyleProperties(ANIMATION + 'Delay');
	    const animationDurations = getStyleProperties(ANIMATION + 'Duration');
	    const animationTimeout = getTimeout(animationDelays, animationDurations);
	    let type = null;
	    let timeout = 0;
	    let propCount = 0;
	    /* istanbul ignore if */
	    if (expectedType === TRANSITION) {
	        if (transitionTimeout > 0) {
	            type = TRANSITION;
	            timeout = transitionTimeout;
	            propCount = transitionDurations.length;
	        }
	    }
	    else if (expectedType === ANIMATION) {
	        if (animationTimeout > 0) {
	            type = ANIMATION;
	            timeout = animationTimeout;
	            propCount = animationDurations.length;
	        }
	    }
	    else {
	        timeout = Math.max(transitionTimeout, animationTimeout);
	        type =
	            timeout > 0
	                ? transitionTimeout > animationTimeout
	                    ? TRANSITION
	                    : ANIMATION
	                : null;
	        propCount = type
	            ? type === TRANSITION
	                ? transitionDurations.length
	                : animationDurations.length
	            : 0;
	    }
	    const hasTransform = type === TRANSITION &&
	        /\b(transform|all)(,|$)/.test(styles[TRANSITION + 'Property']);
	    return {
	        type,
	        timeout,
	        propCount,
	        hasTransform
	    };
	}
	function getTimeout(delays, durations) {
	    while (delays.length < durations.length) {
	        delays = delays.concat(delays);
	    }
	    return Math.max(...durations.map((d, i) => toMs(d) + toMs(delays[i])));
	}
	// Old versions of Chromium (below 61.0.3163.100) formats floating pointer
	// numbers in a locale-dependent way, using a comma instead of a dot.
	// If comma is not replaced with a dot, the input will be rounded down
	// (i.e. acting as a floor function) causing unexpected behaviors
	function toMs(s) {
	    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
	}
	// synchronously force layout to put elements into a certain state
	function forceReflow() {
	    return document.body.offsetHeight;
	}

	const positionMap = new WeakMap();
	const newPositionMap = new WeakMap();
	const TransitionGroupImpl = {
	    name: 'TransitionGroup',
	    props: /*#__PURE__*/ extend({}, TransitionPropsValidators, {
	        tag: String,
	        moveClass: String
	    }),
	    setup(props, { slots }) {
	        const instance = getCurrentInstance();
	        const state = useTransitionState();
	        let prevChildren;
	        let children;
	        onUpdated(() => {
	            // children is guaranteed to exist after initial render
	            if (!prevChildren.length) {
	                return;
	            }
	            const moveClass = props.moveClass || `${props.name || 'v'}-move`;
	            if (!hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
	                return;
	            }
	            // we divide the work into three loops to avoid mixing DOM reads and writes
	            // in each iteration - which helps prevent layout thrashing.
	            prevChildren.forEach(callPendingCbs);
	            prevChildren.forEach(recordPosition);
	            const movedChildren = prevChildren.filter(applyTranslation);
	            // force reflow to put everything in position
	            forceReflow();
	            movedChildren.forEach(c => {
	                const el = c.el;
	                const style = el.style;
	                addTransitionClass(el, moveClass);
	                style.transform = style.webkitTransform = style.transitionDuration = '';
	                const cb = (el._moveCb = (e) => {
	                    if (e && e.target !== el) {
	                        return;
	                    }
	                    if (!e || /transform$/.test(e.propertyName)) {
	                        el.removeEventListener('transitionend', cb);
	                        el._moveCb = null;
	                        removeTransitionClass(el, moveClass);
	                    }
	                });
	                el.addEventListener('transitionend', cb);
	            });
	        });
	        return () => {
	            const rawProps = toRaw(props);
	            const cssTransitionProps = resolveTransitionProps(rawProps);
	            const tag = rawProps.tag || Fragment;
	            prevChildren = children;
	            children = slots.default ? getTransitionRawChildren(slots.default()) : [];
	            for (let i = 0; i < children.length; i++) {
	                const child = children[i];
	                if (child.key != null) {
	                    setTransitionHooks(child, resolveTransitionHooks(child, cssTransitionProps, state, instance));
	                }
	                else {
	                    warn(`<TransitionGroup> children must be keyed.`);
	                }
	            }
	            if (prevChildren) {
	                for (let i = 0; i < prevChildren.length; i++) {
	                    const child = prevChildren[i];
	                    setTransitionHooks(child, resolveTransitionHooks(child, cssTransitionProps, state, instance));
	                    positionMap.set(child, child.el.getBoundingClientRect());
	                }
	            }
	            return createVNode(tag, null, children);
	        };
	    }
	};
	const TransitionGroup = TransitionGroupImpl;
	function callPendingCbs(c) {
	    const el = c.el;
	    if (el._moveCb) {
	        el._moveCb();
	    }
	    if (el._enterCb) {
	        el._enterCb();
	    }
	}
	function recordPosition(c) {
	    newPositionMap.set(c, c.el.getBoundingClientRect());
	}
	function applyTranslation(c) {
	    const oldPos = positionMap.get(c);
	    const newPos = newPositionMap.get(c);
	    const dx = oldPos.left - newPos.left;
	    const dy = oldPos.top - newPos.top;
	    if (dx || dy) {
	        const s = c.el.style;
	        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
	        s.transitionDuration = '0s';
	        return c;
	    }
	}
	function hasCSSTransform(el, root, moveClass) {
	    // Detect whether an element with the move class applied has
	    // CSS transitions. Since the element may be inside an entering
	    // transition at this very moment, we make a clone of it and remove
	    // all other transition classes applied to ensure only the move class
	    // is applied.
	    const clone = el.cloneNode();
	    if (el._vtc) {
	        el._vtc.forEach(cls => {
	            cls.split(/\s+/).forEach(c => c && clone.classList.remove(c));
	        });
	    }
	    moveClass.split(/\s+/).forEach(c => c && clone.classList.add(c));
	    clone.style.display = 'none';
	    const container = (root.nodeType === 1
	        ? root
	        : root.parentNode);
	    container.appendChild(clone);
	    const { hasTransform } = getTransitionInfo(clone);
	    container.removeChild(clone);
	    return hasTransform;
	}

	const getModelAssigner = (vnode) => {
	    const fn = vnode.props['onUpdate:modelValue'];
	    return isArray(fn) ? value => invokeArrayFns(fn, value) : fn;
	};
	function onCompositionStart(e) {
	    e.target.composing = true;
	}
	function onCompositionEnd(e) {
	    const target = e.target;
	    if (target.composing) {
	        target.composing = false;
	        trigger$1(target, 'input');
	    }
	}
	function trigger$1(el, type) {
	    const e = document.createEvent('HTMLEvents');
	    e.initEvent(type, true, true);
	    el.dispatchEvent(e);
	}
	// We are exporting the v-model runtime directly as vnode hooks so that it can
	// be tree-shaken in case v-model is never used.
	const vModelText = {
	    created(el, { modifiers: { lazy, trim, number } }, vnode) {
	        el._assign = getModelAssigner(vnode);
	        const castToNumber = number || el.type === 'number';
	        addEventListener(el, lazy ? 'change' : 'input', e => {
	            if (e.target.composing)
	                return;
	            let domValue = el.value;
	            if (trim) {
	                domValue = domValue.trim();
	            }
	            else if (castToNumber) {
	                domValue = toNumber(domValue);
	            }
	            el._assign(domValue);
	        });
	        if (trim) {
	            addEventListener(el, 'change', () => {
	                el.value = el.value.trim();
	            });
	        }
	        if (!lazy) {
	            addEventListener(el, 'compositionstart', onCompositionStart);
	            addEventListener(el, 'compositionend', onCompositionEnd);
	            // Safari < 10.2 & UIWebView doesn't fire compositionend when
	            // switching focus before confirming composition choice
	            // this also fixes the issue where some browsers e.g. iOS Chrome
	            // fires "change" instead of "input" on autocomplete.
	            addEventListener(el, 'change', onCompositionEnd);
	        }
	    },
	    // set value on mounted so it's after min/max for type="range"
	    mounted(el, { value }) {
	        el.value = value == null ? '' : value;
	    },
	    beforeUpdate(el, { value, modifiers: { trim, number } }, vnode) {
	        el._assign = getModelAssigner(vnode);
	        // avoid clearing unresolved text. #2302
	        if (el.composing)
	            return;
	        if (document.activeElement === el) {
	            if (trim && el.value.trim() === value) {
	                return;
	            }
	            if ((number || el.type === 'number') && toNumber(el.value) === value) {
	                return;
	            }
	        }
	        const newValue = value == null ? '' : value;
	        if (el.value !== newValue) {
	            el.value = newValue;
	        }
	    }
	};
	const vModelCheckbox = {
	    created(el, _, vnode) {
	        el._assign = getModelAssigner(vnode);
	        addEventListener(el, 'change', () => {
	            const modelValue = el._modelValue;
	            const elementValue = getValue(el);
	            const checked = el.checked;
	            const assign = el._assign;
	            if (isArray(modelValue)) {
	                const index = looseIndexOf(modelValue, elementValue);
	                const found = index !== -1;
	                if (checked && !found) {
	                    assign(modelValue.concat(elementValue));
	                }
	                else if (!checked && found) {
	                    const filtered = [...modelValue];
	                    filtered.splice(index, 1);
	                    assign(filtered);
	                }
	            }
	            else if (isSet(modelValue)) {
	                const cloned = new Set(modelValue);
	                if (checked) {
	                    cloned.add(elementValue);
	                }
	                else {
	                    cloned.delete(elementValue);
	                }
	                assign(cloned);
	            }
	            else {
	                assign(getCheckboxValue(el, checked));
	            }
	        });
	    },
	    // set initial checked on mount to wait for true-value/false-value
	    mounted: setChecked,
	    beforeUpdate(el, binding, vnode) {
	        el._assign = getModelAssigner(vnode);
	        setChecked(el, binding, vnode);
	    }
	};
	function setChecked(el, { value, oldValue }, vnode) {
	    el._modelValue = value;
	    if (isArray(value)) {
	        el.checked = looseIndexOf(value, vnode.props.value) > -1;
	    }
	    else if (isSet(value)) {
	        el.checked = value.has(vnode.props.value);
	    }
	    else if (value !== oldValue) {
	        el.checked = looseEqual(value, getCheckboxValue(el, true));
	    }
	}
	const vModelRadio = {
	    created(el, { value }, vnode) {
	        el.checked = looseEqual(value, vnode.props.value);
	        el._assign = getModelAssigner(vnode);
	        addEventListener(el, 'change', () => {
	            el._assign(getValue(el));
	        });
	    },
	    beforeUpdate(el, { value, oldValue }, vnode) {
	        el._assign = getModelAssigner(vnode);
	        if (value !== oldValue) {
	            el.checked = looseEqual(value, vnode.props.value);
	        }
	    }
	};
	const vModelSelect = {
	    created(el, { value, modifiers: { number } }, vnode) {
	        const isSetModel = isSet(value);
	        addEventListener(el, 'change', () => {
	            const selectedVal = Array.prototype.filter
	                .call(el.options, (o) => o.selected)
	                .map((o) => number ? toNumber(getValue(o)) : getValue(o));
	            el._assign(el.multiple
	                ? isSetModel
	                    ? new Set(selectedVal)
	                    : selectedVal
	                : selectedVal[0]);
	        });
	        el._assign = getModelAssigner(vnode);
	    },
	    // set value in mounted & updated because <select> relies on its children
	    // <option>s.
	    mounted(el, { value }) {
	        setSelected(el, value);
	    },
	    beforeUpdate(el, _binding, vnode) {
	        el._assign = getModelAssigner(vnode);
	    },
	    updated(el, { value }) {
	        setSelected(el, value);
	    }
	};
	function setSelected(el, value) {
	    const isMultiple = el.multiple;
	    if (isMultiple && !isArray(value) && !isSet(value)) {
	        
	            warn(`<select multiple v-model> expects an Array or Set value for its binding, ` +
	                `but got ${Object.prototype.toString.call(value).slice(8, -1)}.`);
	        return;
	    }
	    for (let i = 0, l = el.options.length; i < l; i++) {
	        const option = el.options[i];
	        const optionValue = getValue(option);
	        if (isMultiple) {
	            if (isArray(value)) {
	                option.selected = looseIndexOf(value, optionValue) > -1;
	            }
	            else {
	                option.selected = value.has(optionValue);
	            }
	        }
	        else {
	            if (looseEqual(getValue(option), value)) {
	                el.selectedIndex = i;
	                return;
	            }
	        }
	    }
	    if (!isMultiple) {
	        el.selectedIndex = -1;
	    }
	}
	// retrieve raw value set via :value bindings
	function getValue(el) {
	    return '_value' in el ? el._value : el.value;
	}
	// retrieve raw value for true-value and false-value set via :true-value or :false-value bindings
	function getCheckboxValue(el, checked) {
	    const key = checked ? '_trueValue' : '_falseValue';
	    return key in el ? el[key] : checked;
	}
	const vModelDynamic = {
	    created(el, binding, vnode) {
	        callModelHook(el, binding, vnode, null, 'created');
	    },
	    mounted(el, binding, vnode) {
	        callModelHook(el, binding, vnode, null, 'mounted');
	    },
	    beforeUpdate(el, binding, vnode, prevVNode) {
	        callModelHook(el, binding, vnode, prevVNode, 'beforeUpdate');
	    },
	    updated(el, binding, vnode, prevVNode) {
	        callModelHook(el, binding, vnode, prevVNode, 'updated');
	    }
	};
	function callModelHook(el, binding, vnode, prevVNode, hook) {
	    let modelToUse;
	    switch (el.tagName) {
	        case 'SELECT':
	            modelToUse = vModelSelect;
	            break;
	        case 'TEXTAREA':
	            modelToUse = vModelText;
	            break;
	        default:
	            switch (vnode.props && vnode.props.type) {
	                case 'checkbox':
	                    modelToUse = vModelCheckbox;
	                    break;
	                case 'radio':
	                    modelToUse = vModelRadio;
	                    break;
	                default:
	                    modelToUse = vModelText;
	            }
	    }
	    const fn = modelToUse[hook];
	    fn && fn(el, binding, vnode, prevVNode);
	}

	const systemModifiers = ['ctrl', 'shift', 'alt', 'meta'];
	const modifierGuards = {
	    stop: e => e.stopPropagation(),
	    prevent: e => e.preventDefault(),
	    self: e => e.target !== e.currentTarget,
	    ctrl: e => !e.ctrlKey,
	    shift: e => !e.shiftKey,
	    alt: e => !e.altKey,
	    meta: e => !e.metaKey,
	    left: e => 'button' in e && e.button !== 0,
	    middle: e => 'button' in e && e.button !== 1,
	    right: e => 'button' in e && e.button !== 2,
	    exact: (e, modifiers) => systemModifiers.some(m => e[`${m}Key`] && !modifiers.includes(m))
	};
	/**
	 * @private
	 */
	const withModifiers = (fn, modifiers) => {
	    return (event, ...args) => {
	        for (let i = 0; i < modifiers.length; i++) {
	            const guard = modifierGuards[modifiers[i]];
	            if (guard && guard(event, modifiers))
	                return;
	        }
	        return fn(event, ...args);
	    };
	};
	// Kept for 2.x compat.
	// Note: IE11 compat for `spacebar` and `del` is removed for now.
	const keyNames = {
	    esc: 'escape',
	    space: ' ',
	    up: 'arrow-up',
	    left: 'arrow-left',
	    right: 'arrow-right',
	    down: 'arrow-down',
	    delete: 'backspace'
	};
	/**
	 * @private
	 */
	const withKeys = (fn, modifiers) => {
	    return (event) => {
	        if (!('key' in event))
	            return;
	        const eventKey = hyphenate(event.key);
	        if (
	        // None of the provided key modifiers match the current event key
	        !modifiers.some(k => k === eventKey || keyNames[k] === eventKey)) {
	            return;
	        }
	        return fn(event);
	    };
	};

	const vShow = {
	    beforeMount(el, { value }, { transition }) {
	        el._vod = el.style.display === 'none' ? '' : el.style.display;
	        if (transition && value) {
	            transition.beforeEnter(el);
	        }
	        else {
	            setDisplay(el, value);
	        }
	    },
	    mounted(el, { value }, { transition }) {
	        if (transition && value) {
	            transition.enter(el);
	        }
	    },
	    updated(el, { value, oldValue }, { transition }) {
	        if (transition && value !== oldValue) {
	            if (value) {
	                transition.beforeEnter(el);
	                setDisplay(el, true);
	                transition.enter(el);
	            }
	            else {
	                transition.leave(el, () => {
	                    setDisplay(el, false);
	                });
	            }
	        }
	        else {
	            setDisplay(el, value);
	        }
	    },
	    beforeUnmount(el, { value }) {
	        setDisplay(el, value);
	    }
	};
	function setDisplay(el, value) {
	    el.style.display = value ? el._vod : 'none';
	}

	const rendererOptions = extend({ patchProp, forcePatchProp }, nodeOps);
	// lazy create the renderer - this makes core renderer logic tree-shakable
	// in case the user only imports reactivity utilities from Vue.
	let renderer;
	let enabledHydration = false;
	function ensureRenderer() {
	    return renderer || (renderer = createRenderer(rendererOptions));
	}
	function ensureHydrationRenderer() {
	    renderer = enabledHydration
	        ? renderer
	        : createHydrationRenderer(rendererOptions);
	    enabledHydration = true;
	    return renderer;
	}
	// use explicit type casts here to avoid import() calls in rolled-up d.ts
	const render = ((...args) => {
	    ensureRenderer().render(...args);
	});
	const hydrate = ((...args) => {
	    ensureHydrationRenderer().hydrate(...args);
	});
	const createApp = ((...args) => {
	    const app = ensureRenderer().createApp(...args);
	    {
	        injectNativeTagCheck(app);
	    }
	    const { mount } = app;
	    app.mount = (containerOrSelector) => {
	        const container = normalizeContainer(containerOrSelector);
	        if (!container)
	            return;
	        const component = app._component;
	        if (!isFunction(component) && !component.render && !component.template) {
	            component.template = container.innerHTML;
	        }
	        // clear content before mounting
	        container.innerHTML = '';
	        const proxy = mount(container);
	        if (container instanceof Element) {
	            container.removeAttribute('v-cloak');
	            container.setAttribute('data-v-app', '');
	        }
	        return proxy;
	    };
	    return app;
	});
	const createSSRApp = ((...args) => {
	    const app = ensureHydrationRenderer().createApp(...args);
	    {
	        injectNativeTagCheck(app);
	    }
	    const { mount } = app;
	    app.mount = (containerOrSelector) => {
	        const container = normalizeContainer(containerOrSelector);
	        if (container) {
	            return mount(container, true);
	        }
	    };
	    return app;
	});
	function injectNativeTagCheck(app) {
	    // Inject `isNativeTag`
	    // this is used for component name validation (dev only)
	    Object.defineProperty(app.config, 'isNativeTag', {
	        value: (tag) => isHTMLTag(tag) || isSVGTag(tag),
	        writable: false
	    });
	}
	function normalizeContainer(container) {
	    if (isString(container)) {
	        const res = document.querySelector(container);
	        if ( !res) {
	            warn(`Failed to mount app: mount target selector "${container}" returned null.`);
	        }
	        return res;
	    }
	    if (
	        container instanceof ShadowRoot &&
	        container.mode === 'closed') {
	        warn(`mounting on a ShadowRoot with \`{mode: "closed"}\` may lead to unpredictable bugs`);
	    }
	    return container;
	}

	var runtimeDom = /*#__PURE__*/Object.freeze({
		__proto__: null,
		Transition: Transition,
		TransitionGroup: TransitionGroup,
		createApp: createApp,
		createSSRApp: createSSRApp,
		hydrate: hydrate,
		render: render,
		useCssModule: useCssModule,
		useCssVars: useCssVars,
		vModelCheckbox: vModelCheckbox,
		vModelDynamic: vModelDynamic,
		vModelRadio: vModelRadio,
		vModelSelect: vModelSelect,
		vModelText: vModelText,
		vShow: vShow,
		withKeys: withKeys,
		withModifiers: withModifiers,
		customRef: customRef,
		isProxy: isProxy,
		isReactive: isReactive,
		isReadonly: isReadonly,
		isRef: isRef,
		markRaw: markRaw,
		proxyRefs: proxyRefs,
		reactive: reactive,
		readonly: readonly,
		ref: ref,
		shallowReactive: shallowReactive,
		shallowReadonly: shallowReadonly,
		shallowRef: shallowRef,
		toRaw: toRaw,
		toRef: toRef,
		toRefs: toRefs,
		triggerRef: triggerRef,
		unref: unref,
		camelize: camelize,
		capitalize: capitalize,
		toDisplayString: toDisplayString,
		toHandlerKey: toHandlerKey,
		BaseTransition: BaseTransition,
		Comment: Comment,
		Fragment: Fragment,
		KeepAlive: KeepAlive,
		Static: Static,
		Suspense: Suspense,
		Teleport: Teleport,
		Text: Text,
		callWithAsyncErrorHandling: callWithAsyncErrorHandling,
		callWithErrorHandling: callWithErrorHandling,
		cloneVNode: cloneVNode,
		computed: computed$1,
		createBlock: createBlock,
		createCommentVNode: createCommentVNode,
		createHydrationRenderer: createHydrationRenderer,
		createRenderer: createRenderer,
		createSlots: createSlots,
		createStaticVNode: createStaticVNode,
		createTextVNode: createTextVNode,
		createVNode: createVNode,
		defineAsyncComponent: defineAsyncComponent,
		defineComponent: defineComponent,
		defineEmit: defineEmit,
		defineProps: defineProps,
		get devtools () { return devtools; },
		getCurrentInstance: getCurrentInstance,
		getTransitionRawChildren: getTransitionRawChildren,
		h: h,
		handleError: handleError,
		initCustomFormatter: initCustomFormatter,
		inject: inject,
		isVNode: isVNode,
		mergeProps: mergeProps,
		nextTick: nextTick,
		onActivated: onActivated,
		onBeforeMount: onBeforeMount,
		onBeforeUnmount: onBeforeUnmount,
		onBeforeUpdate: onBeforeUpdate,
		onDeactivated: onDeactivated,
		onErrorCaptured: onErrorCaptured,
		onMounted: onMounted,
		onRenderTracked: onRenderTracked,
		onRenderTriggered: onRenderTriggered,
		onUnmounted: onUnmounted,
		onUpdated: onUpdated,
		openBlock: openBlock,
		popScopeId: popScopeId,
		provide: provide,
		pushScopeId: pushScopeId,
		queuePostFlushCb: queuePostFlushCb,
		registerRuntimeCompiler: registerRuntimeCompiler,
		renderList: renderList,
		renderSlot: renderSlot,
		resolveComponent: resolveComponent,
		resolveDirective: resolveDirective,
		resolveDynamicComponent: resolveDynamicComponent,
		resolveTransitionHooks: resolveTransitionHooks,
		setBlockTracking: setBlockTracking,
		setDevtoolsHook: setDevtoolsHook,
		setTransitionHooks: setTransitionHooks,
		ssrContextKey: ssrContextKey,
		ssrUtils: ssrUtils,
		toHandlers: toHandlers,
		transformVNodeArgs: transformVNodeArgs,
		useContext: useContext,
		useSSRContext: useSSRContext,
		useTransitionState: useTransitionState,
		version: version,
		warn: warn,
		watch: watch,
		watchEffect: watchEffect,
		withCtx: withCtx,
		withDirectives: withDirectives,
		withScopeId: withScopeId
	});

	function defaultOnError(error) {
	    throw error;
	}
	function createCompilerError(code, loc, messages, additionalMessage) {
	    const msg =  (messages || errorMessages)[code] + (additionalMessage || ``)
	        ;
	    const error = new SyntaxError(String(msg));
	    error.code = code;
	    error.loc = loc;
	    return error;
	}
	const errorMessages = {
	    // parse errors
	    [0 /* ABRUPT_CLOSING_OF_EMPTY_COMMENT */]: 'Illegal comment.',
	    [1 /* CDATA_IN_HTML_CONTENT */]: 'CDATA section is allowed only in XML context.',
	    [2 /* DUPLICATE_ATTRIBUTE */]: 'Duplicate attribute.',
	    [3 /* END_TAG_WITH_ATTRIBUTES */]: 'End tag cannot have attributes.',
	    [4 /* END_TAG_WITH_TRAILING_SOLIDUS */]: "Illegal '/' in tags.",
	    [5 /* EOF_BEFORE_TAG_NAME */]: 'Unexpected EOF in tag.',
	    [6 /* EOF_IN_CDATA */]: 'Unexpected EOF in CDATA section.',
	    [7 /* EOF_IN_COMMENT */]: 'Unexpected EOF in comment.',
	    [8 /* EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT */]: 'Unexpected EOF in script.',
	    [9 /* EOF_IN_TAG */]: 'Unexpected EOF in tag.',
	    [10 /* INCORRECTLY_CLOSED_COMMENT */]: 'Incorrectly closed comment.',
	    [11 /* INCORRECTLY_OPENED_COMMENT */]: 'Incorrectly opened comment.',
	    [12 /* INVALID_FIRST_CHARACTER_OF_TAG_NAME */]: "Illegal tag name. Use '&lt;' to print '<'.",
	    [13 /* MISSING_ATTRIBUTE_VALUE */]: 'Attribute value was expected.',
	    [14 /* MISSING_END_TAG_NAME */]: 'End tag name was expected.',
	    [15 /* MISSING_WHITESPACE_BETWEEN_ATTRIBUTES */]: 'Whitespace was expected.',
	    [16 /* NESTED_COMMENT */]: "Unexpected '<!--' in comment.",
	    [17 /* UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME */]: 'Attribute name cannot contain U+0022 ("), U+0027 (\'), and U+003C (<).',
	    [18 /* UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE */]: 'Unquoted attribute value cannot contain U+0022 ("), U+0027 (\'), U+003C (<), U+003D (=), and U+0060 (`).',
	    [19 /* UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME */]: "Attribute name cannot start with '='.",
	    [21 /* UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME */]: "'<?' is allowed only in XML context.",
	    [22 /* UNEXPECTED_SOLIDUS_IN_TAG */]: "Illegal '/' in tags.",
	    // Vue-specific parse errors
	    [23 /* X_INVALID_END_TAG */]: 'Invalid end tag.',
	    [24 /* X_MISSING_END_TAG */]: 'Element is missing end tag.',
	    [25 /* X_MISSING_INTERPOLATION_END */]: 'Interpolation end sign was not found.',
	    [26 /* X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END */]: 'End bracket for dynamic directive argument was not found. ' +
	        'Note that dynamic directive argument cannot contain spaces.',
	    // transform errors
	    [27 /* X_V_IF_NO_EXPRESSION */]: `v-if/v-else-if is missing expression.`,
	    [28 /* X_V_IF_SAME_KEY */]: `v-if/else branches must use unique keys.`,
	    [29 /* X_V_ELSE_NO_ADJACENT_IF */]: `v-else/v-else-if has no adjacent v-if.`,
	    [30 /* X_V_FOR_NO_EXPRESSION */]: `v-for is missing expression.`,
	    [31 /* X_V_FOR_MALFORMED_EXPRESSION */]: `v-for has invalid expression.`,
	    [32 /* X_V_FOR_TEMPLATE_KEY_PLACEMENT */]: `<template v-for> key should be placed on the <template> tag.`,
	    [33 /* X_V_BIND_NO_EXPRESSION */]: `v-bind is missing expression.`,
	    [34 /* X_V_ON_NO_EXPRESSION */]: `v-on is missing expression.`,
	    [35 /* X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET */]: `Unexpected custom directive on <slot> outlet.`,
	    [36 /* X_V_SLOT_MIXED_SLOT_USAGE */]: `Mixed v-slot usage on both the component and nested <template>.` +
	        `When there are multiple named slots, all slots should use <template> ` +
	        `syntax to avoid scope ambiguity.`,
	    [37 /* X_V_SLOT_DUPLICATE_SLOT_NAMES */]: `Duplicate slot names found. `,
	    [38 /* X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN */]: `Extraneous children found when component already has explicitly named ` +
	        `default slot. These children will be ignored.`,
	    [39 /* X_V_SLOT_MISPLACED */]: `v-slot can only be used on components or <template> tags.`,
	    [40 /* X_V_MODEL_NO_EXPRESSION */]: `v-model is missing expression.`,
	    [41 /* X_V_MODEL_MALFORMED_EXPRESSION */]: `v-model value must be a valid JavaScript member expression.`,
	    [42 /* X_V_MODEL_ON_SCOPE_VARIABLE */]: `v-model cannot be used on v-for or v-slot scope variables because they are not writable.`,
	    [43 /* X_INVALID_EXPRESSION */]: `Error parsing JavaScript expression: `,
	    [44 /* X_KEEP_ALIVE_INVALID_CHILDREN */]: `<KeepAlive> expects exactly one child component.`,
	    // generic errors
	    [45 /* X_PREFIX_ID_NOT_SUPPORTED */]: `"prefixIdentifiers" option is not supported in this build of compiler.`,
	    [46 /* X_MODULE_MODE_NOT_SUPPORTED */]: `ES module mode is not supported in this build of compiler.`,
	    [47 /* X_CACHE_HANDLER_NOT_SUPPORTED */]: `"cacheHandlers" option is only supported when the "prefixIdentifiers" option is enabled.`,
	    [48 /* X_SCOPE_ID_NOT_SUPPORTED */]: `"scopeId" option is only supported in module mode.`
	};

	const FRAGMENT = Symbol( `Fragment` );
	const TELEPORT = Symbol( `Teleport` );
	const SUSPENSE = Symbol( `Suspense` );
	const KEEP_ALIVE = Symbol( `KeepAlive` );
	const BASE_TRANSITION = Symbol( `BaseTransition` );
	const OPEN_BLOCK = Symbol( `openBlock` );
	const CREATE_BLOCK = Symbol( `createBlock` );
	const CREATE_VNODE = Symbol( `createVNode` );
	const CREATE_COMMENT = Symbol( `createCommentVNode` );
	const CREATE_TEXT = Symbol( `createTextVNode` );
	const CREATE_STATIC = Symbol( `createStaticVNode` );
	const RESOLVE_COMPONENT = Symbol( `resolveComponent` );
	const RESOLVE_DYNAMIC_COMPONENT = Symbol( `resolveDynamicComponent` );
	const RESOLVE_DIRECTIVE = Symbol( `resolveDirective` );
	const WITH_DIRECTIVES = Symbol( `withDirectives` );
	const RENDER_LIST = Symbol( `renderList` );
	const RENDER_SLOT = Symbol( `renderSlot` );
	const CREATE_SLOTS = Symbol( `createSlots` );
	const TO_DISPLAY_STRING = Symbol( `toDisplayString` );
	const MERGE_PROPS = Symbol( `mergeProps` );
	const TO_HANDLERS = Symbol( `toHandlers` );
	const CAMELIZE = Symbol( `camelize` );
	const CAPITALIZE = Symbol( `capitalize` );
	const TO_HANDLER_KEY = Symbol( `toHandlerKey` );
	const SET_BLOCK_TRACKING = Symbol( `setBlockTracking` );
	const PUSH_SCOPE_ID = Symbol( `pushScopeId` );
	const POP_SCOPE_ID = Symbol( `popScopeId` );
	const WITH_SCOPE_ID = Symbol( `withScopeId` );
	const WITH_CTX = Symbol( `withCtx` );
	const UNREF = Symbol( `unref` );
	const IS_REF = Symbol( `isRef` );
	// Name mapping for runtime helpers that need to be imported from 'vue' in
	// generated code. Make sure these are correctly exported in the runtime!
	// Using `any` here because TS doesn't allow symbols as index type.
	const helperNameMap = {
	    [FRAGMENT]: `Fragment`,
	    [TELEPORT]: `Teleport`,
	    [SUSPENSE]: `Suspense`,
	    [KEEP_ALIVE]: `KeepAlive`,
	    [BASE_TRANSITION]: `BaseTransition`,
	    [OPEN_BLOCK]: `openBlock`,
	    [CREATE_BLOCK]: `createBlock`,
	    [CREATE_VNODE]: `createVNode`,
	    [CREATE_COMMENT]: `createCommentVNode`,
	    [CREATE_TEXT]: `createTextVNode`,
	    [CREATE_STATIC]: `createStaticVNode`,
	    [RESOLVE_COMPONENT]: `resolveComponent`,
	    [RESOLVE_DYNAMIC_COMPONENT]: `resolveDynamicComponent`,
	    [RESOLVE_DIRECTIVE]: `resolveDirective`,
	    [WITH_DIRECTIVES]: `withDirectives`,
	    [RENDER_LIST]: `renderList`,
	    [RENDER_SLOT]: `renderSlot`,
	    [CREATE_SLOTS]: `createSlots`,
	    [TO_DISPLAY_STRING]: `toDisplayString`,
	    [MERGE_PROPS]: `mergeProps`,
	    [TO_HANDLERS]: `toHandlers`,
	    [CAMELIZE]: `camelize`,
	    [CAPITALIZE]: `capitalize`,
	    [TO_HANDLER_KEY]: `toHandlerKey`,
	    [SET_BLOCK_TRACKING]: `setBlockTracking`,
	    [PUSH_SCOPE_ID]: `pushScopeId`,
	    [POP_SCOPE_ID]: `popScopeId`,
	    [WITH_SCOPE_ID]: `withScopeId`,
	    [WITH_CTX]: `withCtx`,
	    [UNREF]: `unref`,
	    [IS_REF]: `isRef`
	};
	function registerRuntimeHelpers(helpers) {
	    Object.getOwnPropertySymbols(helpers).forEach(s => {
	        helperNameMap[s] = helpers[s];
	    });
	}

	// AST Utilities ---------------------------------------------------------------
	// Some expressions, e.g. sequence and conditional expressions, are never
	// associated with template nodes, so their source locations are just a stub.
	// Container types like CompoundExpression also don't need a real location.
	const locStub = {
	    source: '',
	    start: { line: 1, column: 1, offset: 0 },
	    end: { line: 1, column: 1, offset: 0 }
	};
	function createRoot(children, loc = locStub) {
	    return {
	        type: 0 /* ROOT */,
	        children,
	        helpers: [],
	        components: [],
	        directives: [],
	        hoists: [],
	        imports: [],
	        cached: 0,
	        temps: 0,
	        codegenNode: undefined,
	        loc
	    };
	}
	function createVNodeCall(context, tag, props, children, patchFlag, dynamicProps, directives, isBlock = false, disableTracking = false, loc = locStub) {
	    if (context) {
	        if (isBlock) {
	            context.helper(OPEN_BLOCK);
	            context.helper(CREATE_BLOCK);
	        }
	        else {
	            context.helper(CREATE_VNODE);
	        }
	        if (directives) {
	            context.helper(WITH_DIRECTIVES);
	        }
	    }
	    return {
	        type: 13 /* VNODE_CALL */,
	        tag,
	        props,
	        children,
	        patchFlag,
	        dynamicProps,
	        directives,
	        isBlock,
	        disableTracking,
	        loc
	    };
	}
	function createArrayExpression(elements, loc = locStub) {
	    return {
	        type: 17 /* JS_ARRAY_EXPRESSION */,
	        loc,
	        elements
	    };
	}
	function createObjectExpression(properties, loc = locStub) {
	    return {
	        type: 15 /* JS_OBJECT_EXPRESSION */,
	        loc,
	        properties
	    };
	}
	function createObjectProperty(key, value) {
	    return {
	        type: 16 /* JS_PROPERTY */,
	        loc: locStub,
	        key: isString(key) ? createSimpleExpression(key, true) : key,
	        value
	    };
	}
	function createSimpleExpression(content, isStatic, loc = locStub, constType = 0 /* NOT_CONSTANT */) {
	    return {
	        type: 4 /* SIMPLE_EXPRESSION */,
	        loc,
	        content,
	        isStatic,
	        constType: isStatic ? 3 /* CAN_STRINGIFY */ : constType
	    };
	}
	function createCompoundExpression(children, loc = locStub) {
	    return {
	        type: 8 /* COMPOUND_EXPRESSION */,
	        loc,
	        children
	    };
	}
	function createCallExpression(callee, args = [], loc = locStub) {
	    return {
	        type: 14 /* JS_CALL_EXPRESSION */,
	        loc,
	        callee,
	        arguments: args
	    };
	}
	function createFunctionExpression(params, returns = undefined, newline = false, isSlot = false, loc = locStub) {
	    return {
	        type: 18 /* JS_FUNCTION_EXPRESSION */,
	        params,
	        returns,
	        newline,
	        isSlot,
	        loc
	    };
	}
	function createConditionalExpression(test, consequent, alternate, newline = true) {
	    return {
	        type: 19 /* JS_CONDITIONAL_EXPRESSION */,
	        test,
	        consequent,
	        alternate,
	        newline,
	        loc: locStub
	    };
	}
	function createCacheExpression(index, value, isVNode = false) {
	    return {
	        type: 20 /* JS_CACHE_EXPRESSION */,
	        index,
	        value,
	        isVNode,
	        loc: locStub
	    };
	}

	const isStaticExp = (p) => p.type === 4 /* SIMPLE_EXPRESSION */ && p.isStatic;
	const isBuiltInType = (tag, expected) => tag === expected || tag === hyphenate(expected);
	function isCoreComponent(tag) {
	    if (isBuiltInType(tag, 'Teleport')) {
	        return TELEPORT;
	    }
	    else if (isBuiltInType(tag, 'Suspense')) {
	        return SUSPENSE;
	    }
	    else if (isBuiltInType(tag, 'KeepAlive')) {
	        return KEEP_ALIVE;
	    }
	    else if (isBuiltInType(tag, 'BaseTransition')) {
	        return BASE_TRANSITION;
	    }
	}
	const nonIdentifierRE = /^\d|[^\$\w]/;
	const isSimpleIdentifier = (name) => !nonIdentifierRE.test(name);
	const memberExpRE = /^[A-Za-z_$][\w$]*(?:\s*\.\s*[A-Za-z_$][\w$]*|\[[^\]]+\])*$/;
	const isMemberExpression = (path) => {
	    if (!path)
	        return false;
	    return memberExpRE.test(path.trim());
	};
	function getInnerRange(loc, offset, length) {
	    const source = loc.source.substr(offset, length);
	    const newLoc = {
	        source,
	        start: advancePositionWithClone(loc.start, loc.source, offset),
	        end: loc.end
	    };
	    if (length != null) {
	        newLoc.end = advancePositionWithClone(loc.start, loc.source, offset + length);
	    }
	    return newLoc;
	}
	function advancePositionWithClone(pos, source, numberOfCharacters = source.length) {
	    return advancePositionWithMutation(extend({}, pos), source, numberOfCharacters);
	}
	// advance by mutation without cloning (for performance reasons), since this
	// gets called a lot in the parser
	function advancePositionWithMutation(pos, source, numberOfCharacters = source.length) {
	    let linesCount = 0;
	    let lastNewLinePos = -1;
	    for (let i = 0; i < numberOfCharacters; i++) {
	        if (source.charCodeAt(i) === 10 /* newline char code */) {
	            linesCount++;
	            lastNewLinePos = i;
	        }
	    }
	    pos.offset += numberOfCharacters;
	    pos.line += linesCount;
	    pos.column =
	        lastNewLinePos === -1
	            ? pos.column + numberOfCharacters
	            : numberOfCharacters - lastNewLinePos;
	    return pos;
	}
	function assert(condition, msg) {
	    /* istanbul ignore if */
	    if (!condition) {
	        throw new Error(msg || `unexpected compiler condition`);
	    }
	}
	function findDir(node, name, allowEmpty = false) {
	    for (let i = 0; i < node.props.length; i++) {
	        const p = node.props[i];
	        if (p.type === 7 /* DIRECTIVE */ &&
	            (allowEmpty || p.exp) &&
	            (isString(name) ? p.name === name : name.test(p.name))) {
	            return p;
	        }
	    }
	}
	function findProp(node, name, dynamicOnly = false, allowEmpty = false) {
	    for (let i = 0; i < node.props.length; i++) {
	        const p = node.props[i];
	        if (p.type === 6 /* ATTRIBUTE */) {
	            if (dynamicOnly)
	                continue;
	            if (p.name === name && (p.value || allowEmpty)) {
	                return p;
	            }
	        }
	        else if (p.name === 'bind' &&
	            (p.exp || allowEmpty) &&
	            isBindKey(p.arg, name)) {
	            return p;
	        }
	    }
	}
	function isBindKey(arg, name) {
	    return !!(arg && isStaticExp(arg) && arg.content === name);
	}
	function hasDynamicKeyVBind(node) {
	    return node.props.some(p => p.type === 7 /* DIRECTIVE */ &&
	        p.name === 'bind' &&
	        (!p.arg || // v-bind="obj"
	            p.arg.type !== 4 /* SIMPLE_EXPRESSION */ || // v-bind:[_ctx.foo]
	            !p.arg.isStatic) // v-bind:[foo]
	    );
	}
	function isText(node) {
	    return node.type === 5 /* INTERPOLATION */ || node.type === 2 /* TEXT */;
	}
	function isVSlot(p) {
	    return p.type === 7 /* DIRECTIVE */ && p.name === 'slot';
	}
	function isTemplateNode(node) {
	    return (node.type === 1 /* ELEMENT */ && node.tagType === 3 /* TEMPLATE */);
	}
	function isSlotOutlet(node) {
	    return node.type === 1 /* ELEMENT */ && node.tagType === 2 /* SLOT */;
	}
	function injectProp(node, prop, context) {
	    let propsWithInjection;
	    const props = node.type === 13 /* VNODE_CALL */ ? node.props : node.arguments[2];
	    if (props == null || isString(props)) {
	        propsWithInjection = createObjectExpression([prop]);
	    }
	    else if (props.type === 14 /* JS_CALL_EXPRESSION */) {
	        // merged props... add ours
	        // only inject key to object literal if it's the first argument so that
	        // if doesn't override user provided keys
	        const first = props.arguments[0];
	        if (!isString(first) && first.type === 15 /* JS_OBJECT_EXPRESSION */) {
	            first.properties.unshift(prop);
	        }
	        else {
	            if (props.callee === TO_HANDLERS) {
	                // #2366
	                propsWithInjection = createCallExpression(context.helper(MERGE_PROPS), [
	                    createObjectExpression([prop]),
	                    props
	                ]);
	            }
	            else {
	                props.arguments.unshift(createObjectExpression([prop]));
	            }
	        }
	        !propsWithInjection && (propsWithInjection = props);
	    }
	    else if (props.type === 15 /* JS_OBJECT_EXPRESSION */) {
	        let alreadyExists = false;
	        // check existing key to avoid overriding user provided keys
	        if (prop.key.type === 4 /* SIMPLE_EXPRESSION */) {
	            const propKeyName = prop.key.content;
	            alreadyExists = props.properties.some(p => p.key.type === 4 /* SIMPLE_EXPRESSION */ &&
	                p.key.content === propKeyName);
	        }
	        if (!alreadyExists) {
	            props.properties.unshift(prop);
	        }
	        propsWithInjection = props;
	    }
	    else {
	        // single v-bind with expression, return a merged replacement
	        propsWithInjection = createCallExpression(context.helper(MERGE_PROPS), [
	            createObjectExpression([prop]),
	            props
	        ]);
	    }
	    if (node.type === 13 /* VNODE_CALL */) {
	        node.props = propsWithInjection;
	    }
	    else {
	        node.arguments[2] = propsWithInjection;
	    }
	}
	function toValidAssetId(name, type) {
	    return `_${type}_${name.replace(/[^\w]/g, '_')}`;
	}

	// The default decoder only provides escapes for characters reserved as part of
	// the template syntax, and is only used if the custom renderer did not provide
	// a platform-specific decoder.
	const decodeRE = /&(gt|lt|amp|apos|quot);/g;
	const decodeMap = {
	    gt: '>',
	    lt: '<',
	    amp: '&',
	    apos: "'",
	    quot: '"'
	};
	const defaultParserOptions = {
	    delimiters: [`{{`, `}}`],
	    getNamespace: () => 0 /* HTML */,
	    getTextMode: () => 0 /* DATA */,
	    isVoidTag: NO,
	    isPreTag: NO,
	    isCustomElement: NO,
	    decodeEntities: (rawText) => rawText.replace(decodeRE, (_, p1) => decodeMap[p1]),
	    onError: defaultOnError,
	    comments: false
	};
	function baseParse(content, options = {}) {
	    const context = createParserContext(content, options);
	    const start = getCursor(context);
	    return createRoot(parseChildren(context, 0 /* DATA */, []), getSelection(context, start));
	}
	function createParserContext(content, rawOptions) {
	    const options = extend({}, defaultParserOptions);
	    for (const key in rawOptions) {
	        // @ts-ignore
	        options[key] = rawOptions[key] || defaultParserOptions[key];
	    }
	    return {
	        options,
	        column: 1,
	        line: 1,
	        offset: 0,
	        originalSource: content,
	        source: content,
	        inPre: false,
	        inVPre: false
	    };
	}
	function parseChildren(context, mode, ancestors) {
	    const parent = last(ancestors);
	    const ns = parent ? parent.ns : 0 /* HTML */;
	    const nodes = [];
	    while (!isEnd(context, mode, ancestors)) {
	        const s = context.source;
	        let node = undefined;
	        if (mode === 0 /* DATA */ || mode === 1 /* RCDATA */) {
	            if (!context.inVPre && startsWith(s, context.options.delimiters[0])) {
	                // '{{'
	                node = parseInterpolation(context, mode);
	            }
	            else if (mode === 0 /* DATA */ && s[0] === '<') {
	                // https://html.spec.whatwg.org/multipage/parsing.html#tag-open-state
	                if (s.length === 1) {
	                    emitError(context, 5 /* EOF_BEFORE_TAG_NAME */, 1);
	                }
	                else if (s[1] === '!') {
	                    // https://html.spec.whatwg.org/multipage/parsing.html#markup-declaration-open-state
	                    if (startsWith(s, '<!--')) {
	                        node = parseComment(context);
	                    }
	                    else if (startsWith(s, '<!DOCTYPE')) {
	                        // Ignore DOCTYPE by a limitation.
	                        node = parseBogusComment(context);
	                    }
	                    else if (startsWith(s, '<![CDATA[')) {
	                        if (ns !== 0 /* HTML */) {
	                            node = parseCDATA(context, ancestors);
	                        }
	                        else {
	                            emitError(context, 1 /* CDATA_IN_HTML_CONTENT */);
	                            node = parseBogusComment(context);
	                        }
	                    }
	                    else {
	                        emitError(context, 11 /* INCORRECTLY_OPENED_COMMENT */);
	                        node = parseBogusComment(context);
	                    }
	                }
	                else if (s[1] === '/') {
	                    // https://html.spec.whatwg.org/multipage/parsing.html#end-tag-open-state
	                    if (s.length === 2) {
	                        emitError(context, 5 /* EOF_BEFORE_TAG_NAME */, 2);
	                    }
	                    else if (s[2] === '>') {
	                        emitError(context, 14 /* MISSING_END_TAG_NAME */, 2);
	                        advanceBy(context, 3);
	                        continue;
	                    }
	                    else if (/[a-z]/i.test(s[2])) {
	                        emitError(context, 23 /* X_INVALID_END_TAG */);
	                        parseTag(context, 1 /* End */, parent);
	                        continue;
	                    }
	                    else {
	                        emitError(context, 12 /* INVALID_FIRST_CHARACTER_OF_TAG_NAME */, 2);
	                        node = parseBogusComment(context);
	                    }
	                }
	                else if (/[a-z]/i.test(s[1])) {
	                    node = parseElement(context, ancestors);
	                }
	                else if (s[1] === '?') {
	                    emitError(context, 21 /* UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME */, 1);
	                    node = parseBogusComment(context);
	                }
	                else {
	                    emitError(context, 12 /* INVALID_FIRST_CHARACTER_OF_TAG_NAME */, 1);
	                }
	            }
	        }
	        if (!node) {
	            node = parseText(context, mode);
	        }
	        if (isArray(node)) {
	            for (let i = 0; i < node.length; i++) {
	                pushNode(nodes, node[i]);
	            }
	        }
	        else {
	            pushNode(nodes, node);
	        }
	    }
	    // Whitespace management for more efficient output
	    // (same as v2 whitespace: 'condense')
	    let removedWhitespace = false;
	    if (mode !== 2 /* RAWTEXT */) {
	        for (let i = 0; i < nodes.length; i++) {
	            const node = nodes[i];
	            if (!context.inPre && node.type === 2 /* TEXT */) {
	                if (!/[^\t\r\n\f ]/.test(node.content)) {
	                    const prev = nodes[i - 1];
	                    const next = nodes[i + 1];
	                    // If:
	                    // - the whitespace is the first or last node, or:
	                    // - the whitespace is adjacent to a comment, or:
	                    // - the whitespace is between two elements AND contains newline
	                    // Then the whitespace is ignored.
	                    if (!prev ||
	                        !next ||
	                        prev.type === 3 /* COMMENT */ ||
	                        next.type === 3 /* COMMENT */ ||
	                        (prev.type === 1 /* ELEMENT */ &&
	                            next.type === 1 /* ELEMENT */ &&
	                            /[\r\n]/.test(node.content))) {
	                        removedWhitespace = true;
	                        nodes[i] = null;
	                    }
	                    else {
	                        // Otherwise, condensed consecutive whitespace inside the text
	                        // down to a single space
	                        node.content = ' ';
	                    }
	                }
	                else {
	                    node.content = node.content.replace(/[\t\r\n\f ]+/g, ' ');
	                }
	            }
	        }
	        if (context.inPre && parent && context.options.isPreTag(parent.tag)) {
	            // remove leading newline per html spec
	            // https://html.spec.whatwg.org/multipage/grouping-content.html#the-pre-element
	            const first = nodes[0];
	            if (first && first.type === 2 /* TEXT */) {
	                first.content = first.content.replace(/^\r?\n/, '');
	            }
	        }
	    }
	    return removedWhitespace ? nodes.filter(Boolean) : nodes;
	}
	function pushNode(nodes, node) {
	    if (node.type === 2 /* TEXT */) {
	        const prev = last(nodes);
	        // Merge if both this and the previous node are text and those are
	        // consecutive. This happens for cases like "a < b".
	        if (prev &&
	            prev.type === 2 /* TEXT */ &&
	            prev.loc.end.offset === node.loc.start.offset) {
	            prev.content += node.content;
	            prev.loc.end = node.loc.end;
	            prev.loc.source += node.loc.source;
	            return;
	        }
	    }
	    nodes.push(node);
	}
	function parseCDATA(context, ancestors) {
	    advanceBy(context, 9);
	    const nodes = parseChildren(context, 3 /* CDATA */, ancestors);
	    if (context.source.length === 0) {
	        emitError(context, 6 /* EOF_IN_CDATA */);
	    }
	    else {
	        advanceBy(context, 3);
	    }
	    return nodes;
	}
	function parseComment(context) {
	    const start = getCursor(context);
	    let content;
	    // Regular comment.
	    const match = /--(\!)?>/.exec(context.source);
	    if (!match) {
	        content = context.source.slice(4);
	        advanceBy(context, context.source.length);
	        emitError(context, 7 /* EOF_IN_COMMENT */);
	    }
	    else {
	        if (match.index <= 3) {
	            emitError(context, 0 /* ABRUPT_CLOSING_OF_EMPTY_COMMENT */);
	        }
	        if (match[1]) {
	            emitError(context, 10 /* INCORRECTLY_CLOSED_COMMENT */);
	        }
	        content = context.source.slice(4, match.index);
	        // Advancing with reporting nested comments.
	        const s = context.source.slice(0, match.index);
	        let prevIndex = 1, nestedIndex = 0;
	        while ((nestedIndex = s.indexOf('<!--', prevIndex)) !== -1) {
	            advanceBy(context, nestedIndex - prevIndex + 1);
	            if (nestedIndex + 4 < s.length) {
	                emitError(context, 16 /* NESTED_COMMENT */);
	            }
	            prevIndex = nestedIndex + 1;
	        }
	        advanceBy(context, match.index + match[0].length - prevIndex + 1);
	    }
	    return {
	        type: 3 /* COMMENT */,
	        content,
	        loc: getSelection(context, start)
	    };
	}
	function parseBogusComment(context) {
	    const start = getCursor(context);
	    const contentStart = context.source[1] === '?' ? 1 : 2;
	    let content;
	    const closeIndex = context.source.indexOf('>');
	    if (closeIndex === -1) {
	        content = context.source.slice(contentStart);
	        advanceBy(context, context.source.length);
	    }
	    else {
	        content = context.source.slice(contentStart, closeIndex);
	        advanceBy(context, closeIndex + 1);
	    }
	    return {
	        type: 3 /* COMMENT */,
	        content,
	        loc: getSelection(context, start)
	    };
	}
	function parseElement(context, ancestors) {
	    // Start tag.
	    const wasInPre = context.inPre;
	    const wasInVPre = context.inVPre;
	    const parent = last(ancestors);
	    const element = parseTag(context, 0 /* Start */, parent);
	    const isPreBoundary = context.inPre && !wasInPre;
	    const isVPreBoundary = context.inVPre && !wasInVPre;
	    if (element.isSelfClosing || context.options.isVoidTag(element.tag)) {
	        return element;
	    }
	    // Children.
	    ancestors.push(element);
	    const mode = context.options.getTextMode(element, parent);
	    const children = parseChildren(context, mode, ancestors);
	    ancestors.pop();
	    element.children = children;
	    // End tag.
	    if (startsWithEndTagOpen(context.source, element.tag)) {
	        parseTag(context, 1 /* End */, parent);
	    }
	    else {
	        emitError(context, 24 /* X_MISSING_END_TAG */, 0, element.loc.start);
	        if (context.source.length === 0 && element.tag.toLowerCase() === 'script') {
	            const first = children[0];
	            if (first && startsWith(first.loc.source, '<!--')) {
	                emitError(context, 8 /* EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT */);
	            }
	        }
	    }
	    element.loc = getSelection(context, element.loc.start);
	    if (isPreBoundary) {
	        context.inPre = false;
	    }
	    if (isVPreBoundary) {
	        context.inVPre = false;
	    }
	    return element;
	}
	const isSpecialTemplateDirective = /*#__PURE__*/ makeMap(`if,else,else-if,for,slot`);
	/**
	 * Parse a tag (E.g. `<div id=a>`) with that type (start tag or end tag).
	 */
	function parseTag(context, type, parent) {
	    // Tag open.
	    const start = getCursor(context);
	    const match = /^<\/?([a-z][^\t\r\n\f />]*)/i.exec(context.source);
	    const tag = match[1];
	    const ns = context.options.getNamespace(tag, parent);
	    advanceBy(context, match[0].length);
	    advanceSpaces(context);
	    // save current state in case we need to re-parse attributes with v-pre
	    const cursor = getCursor(context);
	    const currentSource = context.source;
	    // Attributes.
	    let props = parseAttributes(context, type);
	    // check <pre> tag
	    if (context.options.isPreTag(tag)) {
	        context.inPre = true;
	    }
	    // check v-pre
	    if (!context.inVPre &&
	        props.some(p => p.type === 7 /* DIRECTIVE */ && p.name === 'pre')) {
	        context.inVPre = true;
	        // reset context
	        extend(context, cursor);
	        context.source = currentSource;
	        // re-parse attrs and filter out v-pre itself
	        props = parseAttributes(context, type).filter(p => p.name !== 'v-pre');
	    }
	    // Tag close.
	    let isSelfClosing = false;
	    if (context.source.length === 0) {
	        emitError(context, 9 /* EOF_IN_TAG */);
	    }
	    else {
	        isSelfClosing = startsWith(context.source, '/>');
	        if (type === 1 /* End */ && isSelfClosing) {
	            emitError(context, 4 /* END_TAG_WITH_TRAILING_SOLIDUS */);
	        }
	        advanceBy(context, isSelfClosing ? 2 : 1);
	    }
	    let tagType = 0 /* ELEMENT */;
	    const options = context.options;
	    if (!context.inVPre && !options.isCustomElement(tag)) {
	        const hasVIs = props.some(p => p.type === 7 /* DIRECTIVE */ && p.name === 'is');
	        if (options.isNativeTag && !hasVIs) {
	            if (!options.isNativeTag(tag))
	                tagType = 1 /* COMPONENT */;
	        }
	        else if (hasVIs ||
	            isCoreComponent(tag) ||
	            (options.isBuiltInComponent && options.isBuiltInComponent(tag)) ||
	            /^[A-Z]/.test(tag) ||
	            tag === 'component') {
	            tagType = 1 /* COMPONENT */;
	        }
	        if (tag === 'slot') {
	            tagType = 2 /* SLOT */;
	        }
	        else if (tag === 'template' &&
	            props.some(p => {
	                return (p.type === 7 /* DIRECTIVE */ && isSpecialTemplateDirective(p.name));
	            })) {
	            tagType = 3 /* TEMPLATE */;
	        }
	    }
	    return {
	        type: 1 /* ELEMENT */,
	        ns,
	        tag,
	        tagType,
	        props,
	        isSelfClosing,
	        children: [],
	        loc: getSelection(context, start),
	        codegenNode: undefined // to be created during transform phase
	    };
	}
	function parseAttributes(context, type) {
	    const props = [];
	    const attributeNames = new Set();
	    while (context.source.length > 0 &&
	        !startsWith(context.source, '>') &&
	        !startsWith(context.source, '/>')) {
	        if (startsWith(context.source, '/')) {
	            emitError(context, 22 /* UNEXPECTED_SOLIDUS_IN_TAG */);
	            advanceBy(context, 1);
	            advanceSpaces(context);
	            continue;
	        }
	        if (type === 1 /* End */) {
	            emitError(context, 3 /* END_TAG_WITH_ATTRIBUTES */);
	        }
	        const attr = parseAttribute(context, attributeNames);
	        if (type === 0 /* Start */) {
	            props.push(attr);
	        }
	        if (/^[^\t\r\n\f />]/.test(context.source)) {
	            emitError(context, 15 /* MISSING_WHITESPACE_BETWEEN_ATTRIBUTES */);
	        }
	        advanceSpaces(context);
	    }
	    return props;
	}
	function parseAttribute(context, nameSet) {
	    // Name.
	    const start = getCursor(context);
	    const match = /^[^\t\r\n\f />][^\t\r\n\f />=]*/.exec(context.source);
	    const name = match[0];
	    if (nameSet.has(name)) {
	        emitError(context, 2 /* DUPLICATE_ATTRIBUTE */);
	    }
	    nameSet.add(name);
	    if (name[0] === '=') {
	        emitError(context, 19 /* UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME */);
	    }
	    {
	        const pattern = /["'<]/g;
	        let m;
	        while ((m = pattern.exec(name))) {
	            emitError(context, 17 /* UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME */, m.index);
	        }
	    }
	    advanceBy(context, name.length);
	    // Value
	    let value = undefined;
	    if (/^[\t\r\n\f ]*=/.test(context.source)) {
	        advanceSpaces(context);
	        advanceBy(context, 1);
	        advanceSpaces(context);
	        value = parseAttributeValue(context);
	        if (!value) {
	            emitError(context, 13 /* MISSING_ATTRIBUTE_VALUE */);
	        }
	    }
	    const loc = getSelection(context, start);
	    if (!context.inVPre && /^(v-|:|@|#)/.test(name)) {
	        const match = /(?:^v-([a-z0-9-]+))?(?:(?::|^@|^#)(\[[^\]]+\]|[^\.]+))?(.+)?$/i.exec(name);
	        const dirName = match[1] ||
	            (startsWith(name, ':') ? 'bind' : startsWith(name, '@') ? 'on' : 'slot');
	        let arg;
	        if (match[2]) {
	            const isSlot = dirName === 'slot';
	            const startOffset = name.indexOf(match[2]);
	            const loc = getSelection(context, getNewPosition(context, start, startOffset), getNewPosition(context, start, startOffset + match[2].length + ((isSlot && match[3]) || '').length));
	            let content = match[2];
	            let isStatic = true;
	            if (content.startsWith('[')) {
	                isStatic = false;
	                if (!content.endsWith(']')) {
	                    emitError(context, 26 /* X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END */);
	                }
	                content = content.substr(1, content.length - 2);
	            }
	            else if (isSlot) {
	                // #1241 special case for v-slot: vuetify relies extensively on slot
	                // names containing dots. v-slot doesn't have any modifiers and Vue 2.x
	                // supports such usage so we are keeping it consistent with 2.x.
	                content += match[3] || '';
	            }
	            arg = {
	                type: 4 /* SIMPLE_EXPRESSION */,
	                content,
	                isStatic,
	                constType: isStatic
	                    ? 3 /* CAN_STRINGIFY */
	                    : 0 /* NOT_CONSTANT */,
	                loc
	            };
	        }
	        if (value && value.isQuoted) {
	            const valueLoc = value.loc;
	            valueLoc.start.offset++;
	            valueLoc.start.column++;
	            valueLoc.end = advancePositionWithClone(valueLoc.start, value.content);
	            valueLoc.source = valueLoc.source.slice(1, -1);
	        }
	        return {
	            type: 7 /* DIRECTIVE */,
	            name: dirName,
	            exp: value && {
	                type: 4 /* SIMPLE_EXPRESSION */,
	                content: value.content,
	                isStatic: false,
	                // Treat as non-constant by default. This can be potentially set to
	                // other values by `transformExpression` to make it eligible for hoisting.
	                constType: 0 /* NOT_CONSTANT */,
	                loc: value.loc
	            },
	            arg,
	            modifiers: match[3] ? match[3].substr(1).split('.') : [],
	            loc
	        };
	    }
	    return {
	        type: 6 /* ATTRIBUTE */,
	        name,
	        value: value && {
	            type: 2 /* TEXT */,
	            content: value.content,
	            loc: value.loc
	        },
	        loc
	    };
	}
	function parseAttributeValue(context) {
	    const start = getCursor(context);
	    let content;
	    const quote = context.source[0];
	    const isQuoted = quote === `"` || quote === `'`;
	    if (isQuoted) {
	        // Quoted value.
	        advanceBy(context, 1);
	        const endIndex = context.source.indexOf(quote);
	        if (endIndex === -1) {
	            content = parseTextData(context, context.source.length, 4 /* ATTRIBUTE_VALUE */);
	        }
	        else {
	            content = parseTextData(context, endIndex, 4 /* ATTRIBUTE_VALUE */);
	            advanceBy(context, 1);
	        }
	    }
	    else {
	        // Unquoted
	        const match = /^[^\t\r\n\f >]+/.exec(context.source);
	        if (!match) {
	            return undefined;
	        }
	        const unexpectedChars = /["'<=`]/g;
	        let m;
	        while ((m = unexpectedChars.exec(match[0]))) {
	            emitError(context, 18 /* UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE */, m.index);
	        }
	        content = parseTextData(context, match[0].length, 4 /* ATTRIBUTE_VALUE */);
	    }
	    return { content, isQuoted, loc: getSelection(context, start) };
	}
	function parseInterpolation(context, mode) {
	    const [open, close] = context.options.delimiters;
	    const closeIndex = context.source.indexOf(close, open.length);
	    if (closeIndex === -1) {
	        emitError(context, 25 /* X_MISSING_INTERPOLATION_END */);
	        return undefined;
	    }
	    const start = getCursor(context);
	    advanceBy(context, open.length);
	    const innerStart = getCursor(context);
	    const innerEnd = getCursor(context);
	    const rawContentLength = closeIndex - open.length;
	    const rawContent = context.source.slice(0, rawContentLength);
	    const preTrimContent = parseTextData(context, rawContentLength, mode);
	    const content = preTrimContent.trim();
	    const startOffset = preTrimContent.indexOf(content);
	    if (startOffset > 0) {
	        advancePositionWithMutation(innerStart, rawContent, startOffset);
	    }
	    const endOffset = rawContentLength - (preTrimContent.length - content.length - startOffset);
	    advancePositionWithMutation(innerEnd, rawContent, endOffset);
	    advanceBy(context, close.length);
	    return {
	        type: 5 /* INTERPOLATION */,
	        content: {
	            type: 4 /* SIMPLE_EXPRESSION */,
	            isStatic: false,
	            // Set `isConstant` to false by default and will decide in transformExpression
	            constType: 0 /* NOT_CONSTANT */,
	            content,
	            loc: getSelection(context, innerStart, innerEnd)
	        },
	        loc: getSelection(context, start)
	    };
	}
	function parseText(context, mode) {
	    const endTokens = ['<', context.options.delimiters[0]];
	    if (mode === 3 /* CDATA */) {
	        endTokens.push(']]>');
	    }
	    let endIndex = context.source.length;
	    for (let i = 0; i < endTokens.length; i++) {
	        const index = context.source.indexOf(endTokens[i], 1);
	        if (index !== -1 && endIndex > index) {
	            endIndex = index;
	        }
	    }
	    const start = getCursor(context);
	    const content = parseTextData(context, endIndex, mode);
	    return {
	        type: 2 /* TEXT */,
	        content,
	        loc: getSelection(context, start)
	    };
	}
	/**
	 * Get text data with a given length from the current location.
	 * This translates HTML entities in the text data.
	 */
	function parseTextData(context, length, mode) {
	    const rawText = context.source.slice(0, length);
	    advanceBy(context, length);
	    if (mode === 2 /* RAWTEXT */ ||
	        mode === 3 /* CDATA */ ||
	        rawText.indexOf('&') === -1) {
	        return rawText;
	    }
	    else {
	        // DATA or RCDATA containing "&"". Entity decoding required.
	        return context.options.decodeEntities(rawText, mode === 4 /* ATTRIBUTE_VALUE */);
	    }
	}
	function getCursor(context) {
	    const { column, line, offset } = context;
	    return { column, line, offset };
	}
	function getSelection(context, start, end) {
	    end = end || getCursor(context);
	    return {
	        start,
	        end,
	        source: context.originalSource.slice(start.offset, end.offset)
	    };
	}
	function last(xs) {
	    return xs[xs.length - 1];
	}
	function startsWith(source, searchString) {
	    return source.startsWith(searchString);
	}
	function advanceBy(context, numberOfCharacters) {
	    const { source } = context;
	    advancePositionWithMutation(context, source, numberOfCharacters);
	    context.source = source.slice(numberOfCharacters);
	}
	function advanceSpaces(context) {
	    const match = /^[\t\r\n\f ]+/.exec(context.source);
	    if (match) {
	        advanceBy(context, match[0].length);
	    }
	}
	function getNewPosition(context, start, numberOfCharacters) {
	    return advancePositionWithClone(start, context.originalSource.slice(start.offset, numberOfCharacters), numberOfCharacters);
	}
	function emitError(context, code, offset, loc = getCursor(context)) {
	    if (offset) {
	        loc.offset += offset;
	        loc.column += offset;
	    }
	    context.options.onError(createCompilerError(code, {
	        start: loc,
	        end: loc,
	        source: ''
	    }));
	}
	function isEnd(context, mode, ancestors) {
	    const s = context.source;
	    switch (mode) {
	        case 0 /* DATA */:
	            if (startsWith(s, '</')) {
	                //TODO: probably bad performance
	                for (let i = ancestors.length - 1; i >= 0; --i) {
	                    if (startsWithEndTagOpen(s, ancestors[i].tag)) {
	                        return true;
	                    }
	                }
	            }
	            break;
	        case 1 /* RCDATA */:
	        case 2 /* RAWTEXT */: {
	            const parent = last(ancestors);
	            if (parent && startsWithEndTagOpen(s, parent.tag)) {
	                return true;
	            }
	            break;
	        }
	        case 3 /* CDATA */:
	            if (startsWith(s, ']]>')) {
	                return true;
	            }
	            break;
	    }
	    return !s;
	}
	function startsWithEndTagOpen(source, tag) {
	    return (startsWith(source, '</') &&
	        source.substr(2, tag.length).toLowerCase() === tag.toLowerCase() &&
	        /[\t\r\n\f />]/.test(source[2 + tag.length] || '>'));
	}

	function hoistStatic(root, context) {
	    walk(root, context, 
	    // Root node is unfortunately non-hoistable due to potential parent
	    // fallthrough attributes.
	    isSingleElementRoot(root, root.children[0]));
	}
	function isSingleElementRoot(root, child) {
	    const { children } = root;
	    return (children.length === 1 &&
	        child.type === 1 /* ELEMENT */ &&
	        !isSlotOutlet(child));
	}
	function walk(node, context, doNotHoistNode = false) {
	    let hasHoistedNode = false;
	    // Some transforms, e.g. transformAssetUrls from @vue/compiler-sfc, replaces
	    // static bindings with expressions. These expressions are guaranteed to be
	    // constant so they are still eligible for hoisting, but they are only
	    // available at runtime and therefore cannot be evaluated ahead of time.
	    // This is only a concern for pre-stringification (via transformHoist by
	    // @vue/compiler-dom), but doing it here allows us to perform only one full
	    // walk of the AST and allow `stringifyStatic` to stop walking as soon as its
	    // stringficiation threshold is met.
	    let canStringify = true;
	    const { children } = node;
	    for (let i = 0; i < children.length; i++) {
	        const child = children[i];
	        // only plain elements & text calls are eligible for hoisting.
	        if (child.type === 1 /* ELEMENT */ &&
	            child.tagType === 0 /* ELEMENT */) {
	            const constantType = doNotHoistNode
	                ? 0 /* NOT_CONSTANT */
	                : getConstantType(child, context);
	            if (constantType > 0 /* NOT_CONSTANT */) {
	                if (constantType < 3 /* CAN_STRINGIFY */) {
	                    canStringify = false;
	                }
	                if (constantType >= 2 /* CAN_HOIST */) {
	                    child.codegenNode.patchFlag =
	                        -1 /* HOISTED */ + ( ` /* HOISTED */` );
	                    child.codegenNode = context.hoist(child.codegenNode);
	                    hasHoistedNode = true;
	                    continue;
	                }
	            }
	            else {
	                // node may contain dynamic children, but its props may be eligible for
	                // hoisting.
	                const codegenNode = child.codegenNode;
	                if (codegenNode.type === 13 /* VNODE_CALL */) {
	                    const flag = getPatchFlag(codegenNode);
	                    if ((!flag ||
	                        flag === 512 /* NEED_PATCH */ ||
	                        flag === 1 /* TEXT */) &&
	                        getGeneratedPropsConstantType(child, context) >=
	                            2 /* CAN_HOIST */) {
	                        const props = getNodeProps(child);
	                        if (props) {
	                            codegenNode.props = context.hoist(props);
	                        }
	                    }
	                }
	            }
	        }
	        else if (child.type === 12 /* TEXT_CALL */) {
	            const contentType = getConstantType(child.content, context);
	            if (contentType > 0) {
	                if (contentType < 3 /* CAN_STRINGIFY */) {
	                    canStringify = false;
	                }
	                if (contentType >= 2 /* CAN_HOIST */) {
	                    child.codegenNode = context.hoist(child.codegenNode);
	                    hasHoistedNode = true;
	                }
	            }
	        }
	        // walk further
	        if (child.type === 1 /* ELEMENT */) {
	            walk(child, context);
	        }
	        else if (child.type === 11 /* FOR */) {
	            // Do not hoist v-for single child because it has to be a block
	            walk(child, context, child.children.length === 1);
	        }
	        else if (child.type === 9 /* IF */) {
	            for (let i = 0; i < child.branches.length; i++) {
	                // Do not hoist v-if single child because it has to be a block
	                walk(child.branches[i], context, child.branches[i].children.length === 1);
	            }
	        }
	    }
	    if (canStringify && hasHoistedNode && context.transformHoist) {
	        context.transformHoist(children, context, node);
	    }
	}
	function getConstantType(node, context) {
	    const { constantCache } = context;
	    switch (node.type) {
	        case 1 /* ELEMENT */:
	            if (node.tagType !== 0 /* ELEMENT */) {
	                return 0 /* NOT_CONSTANT */;
	            }
	            const cached = constantCache.get(node);
	            if (cached !== undefined) {
	                return cached;
	            }
	            const codegenNode = node.codegenNode;
	            if (codegenNode.type !== 13 /* VNODE_CALL */) {
	                return 0 /* NOT_CONSTANT */;
	            }
	            const flag = getPatchFlag(codegenNode);
	            if (!flag) {
	                let returnType = 3 /* CAN_STRINGIFY */;
	                // Element itself has no patch flag. However we still need to check:
	                // 1. Even for a node with no patch flag, it is possible for it to contain
	                // non-hoistable expressions that refers to scope variables, e.g. compiler
	                // injected keys or cached event handlers. Therefore we need to always
	                // check the codegenNode's props to be sure.
	                const generatedPropsType = getGeneratedPropsConstantType(node, context);
	                if (generatedPropsType === 0 /* NOT_CONSTANT */) {
	                    constantCache.set(node, 0 /* NOT_CONSTANT */);
	                    return 0 /* NOT_CONSTANT */;
	                }
	                if (generatedPropsType < returnType) {
	                    returnType = generatedPropsType;
	                }
	                // 2. its children.
	                for (let i = 0; i < node.children.length; i++) {
	                    const childType = getConstantType(node.children[i], context);
	                    if (childType === 0 /* NOT_CONSTANT */) {
	                        constantCache.set(node, 0 /* NOT_CONSTANT */);
	                        return 0 /* NOT_CONSTANT */;
	                    }
	                    if (childType < returnType) {
	                        returnType = childType;
	                    }
	                }
	                // 3. if the type is not already CAN_SKIP_PATCH which is the lowest non-0
	                // type, check if any of the props can cause the type to be lowered
	                // we can skip can_patch because it's guaranteed by the absence of a
	                // patchFlag.
	                if (returnType > 1 /* CAN_SKIP_PATCH */) {
	                    for (let i = 0; i < node.props.length; i++) {
	                        const p = node.props[i];
	                        if (p.type === 7 /* DIRECTIVE */ && p.name === 'bind' && p.exp) {
	                            const expType = getConstantType(p.exp, context);
	                            if (expType === 0 /* NOT_CONSTANT */) {
	                                constantCache.set(node, 0 /* NOT_CONSTANT */);
	                                return 0 /* NOT_CONSTANT */;
	                            }
	                            if (expType < returnType) {
	                                returnType = expType;
	                            }
	                        }
	                    }
	                }
	                // only svg/foreignObject could be block here, however if they are
	                // static then they don't need to be blocks since there will be no
	                // nested updates.
	                if (codegenNode.isBlock) {
	                    codegenNode.isBlock = false;
	                    context.helper(CREATE_VNODE);
	                }
	                constantCache.set(node, returnType);
	                return returnType;
	            }
	            else {
	                constantCache.set(node, 0 /* NOT_CONSTANT */);
	                return 0 /* NOT_CONSTANT */;
	            }
	        case 2 /* TEXT */:
	        case 3 /* COMMENT */:
	            return 3 /* CAN_STRINGIFY */;
	        case 9 /* IF */:
	        case 11 /* FOR */:
	        case 10 /* IF_BRANCH */:
	            return 0 /* NOT_CONSTANT */;
	        case 5 /* INTERPOLATION */:
	        case 12 /* TEXT_CALL */:
	            return getConstantType(node.content, context);
	        case 4 /* SIMPLE_EXPRESSION */:
	            return node.constType;
	        case 8 /* COMPOUND_EXPRESSION */:
	            let returnType = 3 /* CAN_STRINGIFY */;
	            for (let i = 0; i < node.children.length; i++) {
	                const child = node.children[i];
	                if (isString(child) || isSymbol(child)) {
	                    continue;
	                }
	                const childType = getConstantType(child, context);
	                if (childType === 0 /* NOT_CONSTANT */) {
	                    return 0 /* NOT_CONSTANT */;
	                }
	                else if (childType < returnType) {
	                    returnType = childType;
	                }
	            }
	            return returnType;
	        default:
	            return 0 /* NOT_CONSTANT */;
	    }
	}
	function getGeneratedPropsConstantType(node, context) {
	    let returnType = 3 /* CAN_STRINGIFY */;
	    const props = getNodeProps(node);
	    if (props && props.type === 15 /* JS_OBJECT_EXPRESSION */) {
	        const { properties } = props;
	        for (let i = 0; i < properties.length; i++) {
	            const { key, value } = properties[i];
	            const keyType = getConstantType(key, context);
	            if (keyType === 0 /* NOT_CONSTANT */) {
	                return keyType;
	            }
	            if (keyType < returnType) {
	                returnType = keyType;
	            }
	            if (value.type !== 4 /* SIMPLE_EXPRESSION */) {
	                return 0 /* NOT_CONSTANT */;
	            }
	            const valueType = getConstantType(value, context);
	            if (valueType === 0 /* NOT_CONSTANT */) {
	                return valueType;
	            }
	            if (valueType < returnType) {
	                returnType = valueType;
	            }
	        }
	    }
	    return returnType;
	}
	function getNodeProps(node) {
	    const codegenNode = node.codegenNode;
	    if (codegenNode.type === 13 /* VNODE_CALL */) {
	        return codegenNode.props;
	    }
	}
	function getPatchFlag(node) {
	    const flag = node.patchFlag;
	    return flag ? parseInt(flag, 10) : undefined;
	}

	function createTransformContext(root, { filename = '', prefixIdentifiers = false, hoistStatic = false, cacheHandlers = false, nodeTransforms = [], directiveTransforms = {}, transformHoist = null, isBuiltInComponent = NOOP, isCustomElement = NOOP, expressionPlugins = [], scopeId = null, ssr = false, ssrCssVars = ``, bindingMetadata = EMPTY_OBJ, inline = false, isTS = false, onError = defaultOnError }) {
	    const nameMatch = filename.replace(/\?.*$/, '').match(/([^/\\]+)\.\w+$/);
	    const context = {
	        // options
	        selfName: nameMatch && capitalize(camelize(nameMatch[1])),
	        prefixIdentifiers,
	        hoistStatic,
	        cacheHandlers,
	        nodeTransforms,
	        directiveTransforms,
	        transformHoist,
	        isBuiltInComponent,
	        isCustomElement,
	        expressionPlugins,
	        scopeId,
	        ssr,
	        ssrCssVars,
	        bindingMetadata,
	        inline,
	        isTS,
	        onError,
	        // state
	        root,
	        helpers: new Set(),
	        components: new Set(),
	        directives: new Set(),
	        hoists: [],
	        imports: new Set(),
	        constantCache: new Map(),
	        temps: 0,
	        cached: 0,
	        identifiers: Object.create(null),
	        scopes: {
	            vFor: 0,
	            vSlot: 0,
	            vPre: 0,
	            vOnce: 0
	        },
	        parent: null,
	        currentNode: root,
	        childIndex: 0,
	        // methods
	        helper(name) {
	            context.helpers.add(name);
	            return name;
	        },
	        helperString(name) {
	            return `_${helperNameMap[context.helper(name)]}`;
	        },
	        replaceNode(node) {
	            /* istanbul ignore if */
	            {
	                if (!context.currentNode) {
	                    throw new Error(`Node being replaced is already removed.`);
	                }
	                if (!context.parent) {
	                    throw new Error(`Cannot replace root node.`);
	                }
	            }
	            context.parent.children[context.childIndex] = context.currentNode = node;
	        },
	        removeNode(node) {
	            if ( !context.parent) {
	                throw new Error(`Cannot remove root node.`);
	            }
	            const list = context.parent.children;
	            const removalIndex = node
	                ? list.indexOf(node)
	                : context.currentNode
	                    ? context.childIndex
	                    : -1;
	            /* istanbul ignore if */
	            if ( removalIndex < 0) {
	                throw new Error(`node being removed is not a child of current parent`);
	            }
	            if (!node || node === context.currentNode) {
	                // current node removed
	                context.currentNode = null;
	                context.onNodeRemoved();
	            }
	            else {
	                // sibling node removed
	                if (context.childIndex > removalIndex) {
	                    context.childIndex--;
	                    context.onNodeRemoved();
	                }
	            }
	            context.parent.children.splice(removalIndex, 1);
	        },
	        onNodeRemoved: () => { },
	        addIdentifiers(exp) {
	        },
	        removeIdentifiers(exp) {
	        },
	        hoist(exp) {
	            context.hoists.push(exp);
	            const identifier = createSimpleExpression(`_hoisted_${context.hoists.length}`, false, exp.loc, 2 /* CAN_HOIST */);
	            identifier.hoisted = exp;
	            return identifier;
	        },
	        cache(exp, isVNode = false) {
	            return createCacheExpression(++context.cached, exp, isVNode);
	        }
	    };
	    return context;
	}
	function transform(root, options) {
	    const context = createTransformContext(root, options);
	    traverseNode(root, context);
	    if (options.hoistStatic) {
	        hoistStatic(root, context);
	    }
	    if (!options.ssr) {
	        createRootCodegen(root, context);
	    }
	    // finalize meta information
	    root.helpers = [...context.helpers];
	    root.components = [...context.components];
	    root.directives = [...context.directives];
	    root.imports = [...context.imports];
	    root.hoists = context.hoists;
	    root.temps = context.temps;
	    root.cached = context.cached;
	}
	function createRootCodegen(root, context) {
	    const { helper } = context;
	    const { children } = root;
	    if (children.length === 1) {
	        const child = children[0];
	        // if the single child is an element, turn it into a block.
	        if (isSingleElementRoot(root, child) && child.codegenNode) {
	            // single element root is never hoisted so codegenNode will never be
	            // SimpleExpressionNode
	            const codegenNode = child.codegenNode;
	            if (codegenNode.type === 13 /* VNODE_CALL */) {
	                codegenNode.isBlock = true;
	                helper(OPEN_BLOCK);
	                helper(CREATE_BLOCK);
	            }
	            root.codegenNode = codegenNode;
	        }
	        else {
	            // - single <slot/>, IfNode, ForNode: already blocks.
	            // - single text node: always patched.
	            // root codegen falls through via genNode()
	            root.codegenNode = child;
	        }
	    }
	    else if (children.length > 1) {
	        // root has multiple nodes - return a fragment block.
	        let patchFlag = 64 /* STABLE_FRAGMENT */;
	        let patchFlagText = PatchFlagNames[64 /* STABLE_FRAGMENT */];
	        // check if the fragment actually contains a single valid child with
	        // the rest being comments
	        if (
	            children.filter(c => c.type !== 3 /* COMMENT */).length === 1) {
	            patchFlag |= 2048 /* DEV_ROOT_FRAGMENT */;
	            patchFlagText += `, ${PatchFlagNames[2048 /* DEV_ROOT_FRAGMENT */]}`;
	        }
	        root.codegenNode = createVNodeCall(context, helper(FRAGMENT), undefined, root.children, patchFlag + ( ` /* ${patchFlagText} */` ), undefined, undefined, true);
	    }
	    else ;
	}
	function traverseChildren(parent, context) {
	    let i = 0;
	    const nodeRemoved = () => {
	        i--;
	    };
	    for (; i < parent.children.length; i++) {
	        const child = parent.children[i];
	        if (isString(child))
	            continue;
	        context.parent = parent;
	        context.childIndex = i;
	        context.onNodeRemoved = nodeRemoved;
	        traverseNode(child, context);
	    }
	}
	function traverseNode(node, context) {
	    context.currentNode = node;
	    // apply transform plugins
	    const { nodeTransforms } = context;
	    const exitFns = [];
	    for (let i = 0; i < nodeTransforms.length; i++) {
	        const onExit = nodeTransforms[i](node, context);
	        if (onExit) {
	            if (isArray(onExit)) {
	                exitFns.push(...onExit);
	            }
	            else {
	                exitFns.push(onExit);
	            }
	        }
	        if (!context.currentNode) {
	            // node was removed
	            return;
	        }
	        else {
	            // node may have been replaced
	            node = context.currentNode;
	        }
	    }
	    switch (node.type) {
	        case 3 /* COMMENT */:
	            if (!context.ssr) {
	                // inject import for the Comment symbol, which is needed for creating
	                // comment nodes with `createVNode`
	                context.helper(CREATE_COMMENT);
	            }
	            break;
	        case 5 /* INTERPOLATION */:
	            // no need to traverse, but we need to inject toString helper
	            if (!context.ssr) {
	                context.helper(TO_DISPLAY_STRING);
	            }
	            break;
	        // for container types, further traverse downwards
	        case 9 /* IF */:
	            for (let i = 0; i < node.branches.length; i++) {
	                traverseNode(node.branches[i], context);
	            }
	            break;
	        case 10 /* IF_BRANCH */:
	        case 11 /* FOR */:
	        case 1 /* ELEMENT */:
	        case 0 /* ROOT */:
	            traverseChildren(node, context);
	            break;
	    }
	    // exit transforms
	    context.currentNode = node;
	    let i = exitFns.length;
	    while (i--) {
	        exitFns[i]();
	    }
	}
	function createStructuralDirectiveTransform(name, fn) {
	    const matches = isString(name)
	        ? (n) => n === name
	        : (n) => name.test(n);
	    return (node, context) => {
	        if (node.type === 1 /* ELEMENT */) {
	            const { props } = node;
	            // structural directive transforms are not concerned with slots
	            // as they are handled separately in vSlot.ts
	            if (node.tagType === 3 /* TEMPLATE */ && props.some(isVSlot)) {
	                return;
	            }
	            const exitFns = [];
	            for (let i = 0; i < props.length; i++) {
	                const prop = props[i];
	                if (prop.type === 7 /* DIRECTIVE */ && matches(prop.name)) {
	                    // structural directives are removed to avoid infinite recursion
	                    // also we remove them *before* applying so that it can further
	                    // traverse itself in case it moves the node around
	                    props.splice(i, 1);
	                    i--;
	                    const onExit = fn(node, prop, context);
	                    if (onExit)
	                        exitFns.push(onExit);
	                }
	            }
	            return exitFns;
	        }
	    };
	}

	const PURE_ANNOTATION = `/*#__PURE__*/`;
	function createCodegenContext(ast, { mode = 'function', prefixIdentifiers = mode === 'module', sourceMap = false, filename = `template.vue.html`, scopeId = null, optimizeImports = false, runtimeGlobalName = `Vue`, runtimeModuleName = `vue`, ssr = false }) {
	    const context = {
	        mode,
	        prefixIdentifiers,
	        sourceMap,
	        filename,
	        scopeId,
	        optimizeImports,
	        runtimeGlobalName,
	        runtimeModuleName,
	        ssr,
	        source: ast.loc.source,
	        code: ``,
	        column: 1,
	        line: 1,
	        offset: 0,
	        indentLevel: 0,
	        pure: false,
	        map: undefined,
	        helper(key) {
	            return `_${helperNameMap[key]}`;
	        },
	        push(code, node) {
	            context.code += code;
	        },
	        indent() {
	            newline(++context.indentLevel);
	        },
	        deindent(withoutNewLine = false) {
	            if (withoutNewLine) {
	                --context.indentLevel;
	            }
	            else {
	                newline(--context.indentLevel);
	            }
	        },
	        newline() {
	            newline(context.indentLevel);
	        }
	    };
	    function newline(n) {
	        context.push('\n' + `  `.repeat(n));
	    }
	    return context;
	}
	function generate(ast, options = {}) {
	    const context = createCodegenContext(ast, options);
	    if (options.onContextCreated)
	        options.onContextCreated(context);
	    const { mode, push, prefixIdentifiers, indent, deindent, newline, scopeId, ssr } = context;
	    const hasHelpers = ast.helpers.length > 0;
	    const useWithBlock = !prefixIdentifiers && mode !== 'module';
	    // preambles
	    // in setup() inline mode, the preamble is generated in a sub context
	    // and returned separately.
	    const preambleContext =  context;
	    {
	        genFunctionPreamble(ast, preambleContext);
	    }
	    // enter render function
	    const functionName = ssr ? `ssrRender` : `render`;
	    const args = ssr ? ['_ctx', '_push', '_parent', '_attrs'] : ['_ctx', '_cache'];
	    const signature =  args.join(', ');
	    {
	        push(`function ${functionName}(${signature}) {`);
	    }
	    indent();
	    if (useWithBlock) {
	        push(`with (_ctx) {`);
	        indent();
	        // function mode const declarations should be inside with block
	        // also they should be renamed to avoid collision with user properties
	        if (hasHelpers) {
	            push(`const { ${ast.helpers
                .map(s => `${helperNameMap[s]}: _${helperNameMap[s]}`)
                .join(', ')} } = _Vue`);
	            push(`\n`);
	            newline();
	        }
	    }
	    // generate asset resolution statements
	    if (ast.components.length) {
	        genAssets(ast.components, 'component', context);
	        if (ast.directives.length || ast.temps > 0) {
	            newline();
	        }
	    }
	    if (ast.directives.length) {
	        genAssets(ast.directives, 'directive', context);
	        if (ast.temps > 0) {
	            newline();
	        }
	    }
	    if (ast.temps > 0) {
	        push(`let `);
	        for (let i = 0; i < ast.temps; i++) {
	            push(`${i > 0 ? `, ` : ``}_temp${i}`);
	        }
	    }
	    if (ast.components.length || ast.directives.length || ast.temps) {
	        push(`\n`);
	        newline();
	    }
	    // generate the VNode tree expression
	    if (!ssr) {
	        push(`return `);
	    }
	    if (ast.codegenNode) {
	        genNode(ast.codegenNode, context);
	    }
	    else {
	        push(`null`);
	    }
	    if (useWithBlock) {
	        deindent();
	        push(`}`);
	    }
	    deindent();
	    push(`}`);
	    return {
	        ast,
	        code: context.code,
	        preamble:  ``,
	        // SourceMapGenerator does have toJSON() method but it's not in the types
	        map: context.map ? context.map.toJSON() : undefined
	    };
	}
	function genFunctionPreamble(ast, context) {
	    const { ssr, prefixIdentifiers, push, newline, runtimeModuleName, runtimeGlobalName } = context;
	    const VueBinding =  runtimeGlobalName;
	    const aliasHelper = (s) => `${helperNameMap[s]}: _${helperNameMap[s]}`;
	    // Generate const declaration for helpers
	    // In prefix mode, we place the const declaration at top so it's done
	    // only once; But if we not prefixing, we place the declaration inside the
	    // with block so it doesn't incur the `in` check cost for every helper access.
	    if (ast.helpers.length > 0) {
	        {
	            // "with" mode.
	            // save Vue in a separate variable to avoid collision
	            push(`const _Vue = ${VueBinding}\n`);
	            // in "with" mode, helpers are declared inside the with block to avoid
	            // has check cost, but hoists are lifted out of the function - we need
	            // to provide the helper here.
	            if (ast.hoists.length) {
	                const staticHelpers = [
	                    CREATE_VNODE,
	                    CREATE_COMMENT,
	                    CREATE_TEXT,
	                    CREATE_STATIC
	                ]
	                    .filter(helper => ast.helpers.includes(helper))
	                    .map(aliasHelper)
	                    .join(', ');
	                push(`const { ${staticHelpers} } = _Vue\n`);
	            }
	        }
	    }
	    genHoists(ast.hoists, context);
	    newline();
	    push(`return `);
	}
	function genAssets(assets, type, { helper, push, newline }) {
	    const resolver = helper(type === 'component' ? RESOLVE_COMPONENT : RESOLVE_DIRECTIVE);
	    for (let i = 0; i < assets.length; i++) {
	        const id = assets[i];
	        push(`const ${toValidAssetId(id, type)} = ${resolver}(${JSON.stringify(id)})`);
	        if (i < assets.length - 1) {
	            newline();
	        }
	    }
	}
	function genHoists(hoists, context) {
	    if (!hoists.length) {
	        return;
	    }
	    context.pure = true;
	    const { push, newline, helper, scopeId, mode } = context;
	    newline();
	    hoists.forEach((exp, i) => {
	        if (exp) {
	            push(`const _hoisted_${i + 1} = `);
	            genNode(exp, context);
	            newline();
	        }
	    });
	    context.pure = false;
	}
	function isText$1(n) {
	    return (isString(n) ||
	        n.type === 4 /* SIMPLE_EXPRESSION */ ||
	        n.type === 2 /* TEXT */ ||
	        n.type === 5 /* INTERPOLATION */ ||
	        n.type === 8 /* COMPOUND_EXPRESSION */);
	}
	function genNodeListAsArray(nodes, context) {
	    const multilines = nodes.length > 3 ||
	        ( nodes.some(n => isArray(n) || !isText$1(n)));
	    context.push(`[`);
	    multilines && context.indent();
	    genNodeList(nodes, context, multilines);
	    multilines && context.deindent();
	    context.push(`]`);
	}
	function genNodeList(nodes, context, multilines = false, comma = true) {
	    const { push, newline } = context;
	    for (let i = 0; i < nodes.length; i++) {
	        const node = nodes[i];
	        if (isString(node)) {
	            push(node);
	        }
	        else if (isArray(node)) {
	            genNodeListAsArray(node, context);
	        }
	        else {
	            genNode(node, context);
	        }
	        if (i < nodes.length - 1) {
	            if (multilines) {
	                comma && push(',');
	                newline();
	            }
	            else {
	                comma && push(', ');
	            }
	        }
	    }
	}
	function genNode(node, context) {
	    if (isString(node)) {
	        context.push(node);
	        return;
	    }
	    if (isSymbol(node)) {
	        context.push(context.helper(node));
	        return;
	    }
	    switch (node.type) {
	        case 1 /* ELEMENT */:
	        case 9 /* IF */:
	        case 11 /* FOR */:
	            
	                assert(node.codegenNode != null, `Codegen node is missing for element/if/for node. ` +
	                    `Apply appropriate transforms first.`);
	            genNode(node.codegenNode, context);
	            break;
	        case 2 /* TEXT */:
	            genText(node, context);
	            break;
	        case 4 /* SIMPLE_EXPRESSION */:
	            genExpression(node, context);
	            break;
	        case 5 /* INTERPOLATION */:
	            genInterpolation(node, context);
	            break;
	        case 12 /* TEXT_CALL */:
	            genNode(node.codegenNode, context);
	            break;
	        case 8 /* COMPOUND_EXPRESSION */:
	            genCompoundExpression(node, context);
	            break;
	        case 3 /* COMMENT */:
	            genComment(node, context);
	            break;
	        case 13 /* VNODE_CALL */:
	            genVNodeCall(node, context);
	            break;
	        case 14 /* JS_CALL_EXPRESSION */:
	            genCallExpression(node, context);
	            break;
	        case 15 /* JS_OBJECT_EXPRESSION */:
	            genObjectExpression(node, context);
	            break;
	        case 17 /* JS_ARRAY_EXPRESSION */:
	            genArrayExpression(node, context);
	            break;
	        case 18 /* JS_FUNCTION_EXPRESSION */:
	            genFunctionExpression(node, context);
	            break;
	        case 19 /* JS_CONDITIONAL_EXPRESSION */:
	            genConditionalExpression(node, context);
	            break;
	        case 20 /* JS_CACHE_EXPRESSION */:
	            genCacheExpression(node, context);
	            break;
	        // SSR only types
	        case 21 /* JS_BLOCK_STATEMENT */:
	            break;
	        case 22 /* JS_TEMPLATE_LITERAL */:
	            break;
	        case 23 /* JS_IF_STATEMENT */:
	            break;
	        case 24 /* JS_ASSIGNMENT_EXPRESSION */:
	            break;
	        case 25 /* JS_SEQUENCE_EXPRESSION */:
	            break;
	        case 26 /* JS_RETURN_STATEMENT */:
	            break;
	        /* istanbul ignore next */
	        case 10 /* IF_BRANCH */:
	            // noop
	            break;
	        default:
	            {
	                assert(false, `unhandled codegen node type: ${node.type}`);
	                // make sure we exhaust all possible types
	                const exhaustiveCheck = node;
	                return exhaustiveCheck;
	            }
	    }
	}
	function genText(node, context) {
	    context.push(JSON.stringify(node.content), node);
	}
	function genExpression(node, context) {
	    const { content, isStatic } = node;
	    context.push(isStatic ? JSON.stringify(content) : content, node);
	}
	function genInterpolation(node, context) {
	    const { push, helper, pure } = context;
	    if (pure)
	        push(PURE_ANNOTATION);
	    push(`${helper(TO_DISPLAY_STRING)}(`);
	    genNode(node.content, context);
	    push(`)`);
	}
	function genCompoundExpression(node, context) {
	    for (let i = 0; i < node.children.length; i++) {
	        const child = node.children[i];
	        if (isString(child)) {
	            context.push(child);
	        }
	        else {
	            genNode(child, context);
	        }
	    }
	}
	function genExpressionAsPropertyKey(node, context) {
	    const { push } = context;
	    if (node.type === 8 /* COMPOUND_EXPRESSION */) {
	        push(`[`);
	        genCompoundExpression(node, context);
	        push(`]`);
	    }
	    else if (node.isStatic) {
	        // only quote keys if necessary
	        const text = isSimpleIdentifier(node.content)
	            ? node.content
	            : JSON.stringify(node.content);
	        push(text, node);
	    }
	    else {
	        push(`[${node.content}]`, node);
	    }
	}
	function genComment(node, context) {
	    {
	        const { push, helper, pure } = context;
	        if (pure) {
	            push(PURE_ANNOTATION);
	        }
	        push(`${helper(CREATE_COMMENT)}(${JSON.stringify(node.content)})`, node);
	    }
	}
	function genVNodeCall(node, context) {
	    const { push, helper, pure } = context;
	    const { tag, props, children, patchFlag, dynamicProps, directives, isBlock, disableTracking } = node;
	    if (directives) {
	        push(helper(WITH_DIRECTIVES) + `(`);
	    }
	    if (isBlock) {
	        push(`(${helper(OPEN_BLOCK)}(${disableTracking ? `true` : ``}), `);
	    }
	    if (pure) {
	        push(PURE_ANNOTATION);
	    }
	    push(helper(isBlock ? CREATE_BLOCK : CREATE_VNODE) + `(`, node);
	    genNodeList(genNullableArgs([tag, props, children, patchFlag, dynamicProps]), context);
	    push(`)`);
	    if (isBlock) {
	        push(`)`);
	    }
	    if (directives) {
	        push(`, `);
	        genNode(directives, context);
	        push(`)`);
	    }
	}
	function genNullableArgs(args) {
	    let i = args.length;
	    while (i--) {
	        if (args[i] != null)
	            break;
	    }
	    return args.slice(0, i + 1).map(arg => arg || `null`);
	}
	// JavaScript
	function genCallExpression(node, context) {
	    const { push, helper, pure } = context;
	    const callee = isString(node.callee) ? node.callee : helper(node.callee);
	    if (pure) {
	        push(PURE_ANNOTATION);
	    }
	    push(callee + `(`, node);
	    genNodeList(node.arguments, context);
	    push(`)`);
	}
	function genObjectExpression(node, context) {
	    const { push, indent, deindent, newline } = context;
	    const { properties } = node;
	    if (!properties.length) {
	        push(`{}`, node);
	        return;
	    }
	    const multilines = properties.length > 1 ||
	        (
	            properties.some(p => p.value.type !== 4 /* SIMPLE_EXPRESSION */));
	    push(multilines ? `{` : `{ `);
	    multilines && indent();
	    for (let i = 0; i < properties.length; i++) {
	        const { key, value } = properties[i];
	        // key
	        genExpressionAsPropertyKey(key, context);
	        push(`: `);
	        // value
	        genNode(value, context);
	        if (i < properties.length - 1) {
	            // will only reach this if it's multilines
	            push(`,`);
	            newline();
	        }
	    }
	    multilines && deindent();
	    push(multilines ? `}` : ` }`);
	}
	function genArrayExpression(node, context) {
	    genNodeListAsArray(node.elements, context);
	}
	function genFunctionExpression(node, context) {
	    const { push, indent, deindent, scopeId, mode } = context;
	    const { params, returns, body, newline, isSlot } = node;
	    if (isSlot) {
	        push(`_${helperNameMap[WITH_CTX]}(`);
	    }
	    push(`(`, node);
	    if (isArray(params)) {
	        genNodeList(params, context);
	    }
	    else if (params) {
	        genNode(params, context);
	    }
	    push(`) => `);
	    if (newline || body) {
	        push(`{`);
	        indent();
	    }
	    if (returns) {
	        if (newline) {
	            push(`return `);
	        }
	        if (isArray(returns)) {
	            genNodeListAsArray(returns, context);
	        }
	        else {
	            genNode(returns, context);
	        }
	    }
	    else if (body) {
	        genNode(body, context);
	    }
	    if (newline || body) {
	        deindent();
	        push(`}`);
	    }
	    if ( isSlot) {
	        push(`)`);
	    }
	}
	function genConditionalExpression(node, context) {
	    const { test, consequent, alternate, newline: needNewline } = node;
	    const { push, indent, deindent, newline } = context;
	    if (test.type === 4 /* SIMPLE_EXPRESSION */) {
	        const needsParens = !isSimpleIdentifier(test.content);
	        needsParens && push(`(`);
	        genExpression(test, context);
	        needsParens && push(`)`);
	    }
	    else {
	        push(`(`);
	        genNode(test, context);
	        push(`)`);
	    }
	    needNewline && indent();
	    context.indentLevel++;
	    needNewline || push(` `);
	    push(`? `);
	    genNode(consequent, context);
	    context.indentLevel--;
	    needNewline && newline();
	    needNewline || push(` `);
	    push(`: `);
	    const isNested = alternate.type === 19 /* JS_CONDITIONAL_EXPRESSION */;
	    if (!isNested) {
	        context.indentLevel++;
	    }
	    genNode(alternate, context);
	    if (!isNested) {
	        context.indentLevel--;
	    }
	    needNewline && deindent(true /* without newline */);
	}
	function genCacheExpression(node, context) {
	    const { push, helper, indent, deindent, newline } = context;
	    push(`_cache[${node.index}] || (`);
	    if (node.isVNode) {
	        indent();
	        push(`${helper(SET_BLOCK_TRACKING)}(-1),`);
	        newline();
	    }
	    push(`_cache[${node.index}] = `);
	    genNode(node.value, context);
	    if (node.isVNode) {
	        push(`,`);
	        newline();
	        push(`${helper(SET_BLOCK_TRACKING)}(1),`);
	        newline();
	        push(`_cache[${node.index}]`);
	        deindent();
	    }
	    push(`)`);
	}

	// these keywords should not appear inside expressions, but operators like
	// typeof, instanceof and in are allowed
	const prohibitedKeywordRE = new RegExp('\\b' +
	    ('do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
	        'super,throw,while,yield,delete,export,import,return,switch,default,' +
	        'extends,finally,continue,debugger,function,arguments,typeof,void')
	        .split(',')
	        .join('\\b|\\b') +
	    '\\b');
	// strip strings in expressions
	const stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
	/**
	 * Validate a non-prefixed expression.
	 * This is only called when using the in-browser runtime compiler since it
	 * doesn't prefix expressions.
	 */
	function validateBrowserExpression(node, context, asParams = false, asRawStatements = false) {
	    const exp = node.content;
	    // empty expressions are validated per-directive since some directives
	    // do allow empty expressions.
	    if (!exp.trim()) {
	        return;
	    }
	    try {
	        new Function(asRawStatements
	            ? ` ${exp} `
	            : `return ${asParams ? `(${exp}) => {}` : `(${exp})`}`);
	    }
	    catch (e) {
	        let message = e.message;
	        const keywordMatch = exp
	            .replace(stripStringRE, '')
	            .match(prohibitedKeywordRE);
	        if (keywordMatch) {
	            message = `avoid using JavaScript keyword as property name: "${keywordMatch[0]}"`;
	        }
	        context.onError(createCompilerError(43 /* X_INVALID_EXPRESSION */, node.loc, undefined, message));
	    }
	}

	const transformExpression = (node, context) => {
	    if (node.type === 5 /* INTERPOLATION */) {
	        node.content = processExpression(node.content, context);
	    }
	    else if (node.type === 1 /* ELEMENT */) {
	        // handle directives on element
	        for (let i = 0; i < node.props.length; i++) {
	            const dir = node.props[i];
	            // do not process for v-on & v-for since they are special handled
	            if (dir.type === 7 /* DIRECTIVE */ && dir.name !== 'for') {
	                const exp = dir.exp;
	                const arg = dir.arg;
	                // do not process exp if this is v-on:arg - we need special handling
	                // for wrapping inline statements.
	                if (exp &&
	                    exp.type === 4 /* SIMPLE_EXPRESSION */ &&
	                    !(dir.name === 'on' && arg)) {
	                    dir.exp = processExpression(exp, context, 
	                    // slot args must be processed as function params
	                    dir.name === 'slot');
	                }
	                if (arg && arg.type === 4 /* SIMPLE_EXPRESSION */ && !arg.isStatic) {
	                    dir.arg = processExpression(arg, context);
	                }
	            }
	        }
	    }
	};
	// Important: since this function uses Node.js only dependencies, it should
	// always be used with a leading !true check so that it can be
	// tree-shaken from the browser build.
	function processExpression(node, context, 
	// some expressions like v-slot props & v-for aliases should be parsed as
	// function params
	asParams = false, 
	// v-on handler values may contain multiple statements
	asRawStatements = false) {
	    {
	        {
	            // simple in-browser validation (same logic in 2.x)
	            validateBrowserExpression(node, context, asParams, asRawStatements);
	        }
	        return node;
	    }
	}

	const transformIf = createStructuralDirectiveTransform(/^(if|else|else-if)$/, (node, dir, context) => {
	    return processIf(node, dir, context, (ifNode, branch, isRoot) => {
	        // #1587: We need to dynamically increment the key based on the current
	        // node's sibling nodes, since chained v-if/else branches are
	        // rendered at the same depth
	        const siblings = context.parent.children;
	        let i = siblings.indexOf(ifNode);
	        let key = 0;
	        while (i-- >= 0) {
	            const sibling = siblings[i];
	            if (sibling && sibling.type === 9 /* IF */) {
	                key += sibling.branches.length;
	            }
	        }
	        // Exit callback. Complete the codegenNode when all children have been
	        // transformed.
	        return () => {
	            if (isRoot) {
	                ifNode.codegenNode = createCodegenNodeForBranch(branch, key, context);
	            }
	            else {
	                // attach this branch's codegen node to the v-if root.
	                const parentCondition = getParentCondition(ifNode.codegenNode);
	                parentCondition.alternate = createCodegenNodeForBranch(branch, key + ifNode.branches.length - 1, context);
	            }
	        };
	    });
	});
	// target-agnostic transform used for both Client and SSR
	function processIf(node, dir, context, processCodegen) {
	    if (dir.name !== 'else' &&
	        (!dir.exp || !dir.exp.content.trim())) {
	        const loc = dir.exp ? dir.exp.loc : node.loc;
	        context.onError(createCompilerError(27 /* X_V_IF_NO_EXPRESSION */, dir.loc));
	        dir.exp = createSimpleExpression(`true`, false, loc);
	    }
	    if ( dir.exp) {
	        validateBrowserExpression(dir.exp, context);
	    }
	    if (dir.name === 'if') {
	        const branch = createIfBranch(node, dir);
	        const ifNode = {
	            type: 9 /* IF */,
	            loc: node.loc,
	            branches: [branch]
	        };
	        context.replaceNode(ifNode);
	        if (processCodegen) {
	            return processCodegen(ifNode, branch, true);
	        }
	    }
	    else {
	        // locate the adjacent v-if
	        const siblings = context.parent.children;
	        const comments = [];
	        let i = siblings.indexOf(node);
	        while (i-- >= -1) {
	            const sibling = siblings[i];
	            if ( sibling && sibling.type === 3 /* COMMENT */) {
	                context.removeNode(sibling);
	                comments.unshift(sibling);
	                continue;
	            }
	            if (sibling &&
	                sibling.type === 2 /* TEXT */ &&
	                !sibling.content.trim().length) {
	                context.removeNode(sibling);
	                continue;
	            }
	            if (sibling && sibling.type === 9 /* IF */) {
	                // move the node to the if node's branches
	                context.removeNode();
	                const branch = createIfBranch(node, dir);
	                if ( comments.length) {
	                    branch.children = [...comments, ...branch.children];
	                }
	                // check if user is forcing same key on different branches
	                {
	                    const key = branch.userKey;
	                    if (key) {
	                        sibling.branches.forEach(({ userKey }) => {
	                            if (isSameKey(userKey, key)) {
	                                context.onError(createCompilerError(28 /* X_V_IF_SAME_KEY */, branch.userKey.loc));
	                            }
	                        });
	                    }
	                }
	                sibling.branches.push(branch);
	                const onExit = processCodegen && processCodegen(sibling, branch, false);
	                // since the branch was removed, it will not be traversed.
	                // make sure to traverse here.
	                traverseNode(branch, context);
	                // call on exit
	                if (onExit)
	                    onExit();
	                // make sure to reset currentNode after traversal to indicate this
	                // node has been removed.
	                context.currentNode = null;
	            }
	            else {
	                context.onError(createCompilerError(29 /* X_V_ELSE_NO_ADJACENT_IF */, node.loc));
	            }
	            break;
	        }
	    }
	}
	function createIfBranch(node, dir) {
	    return {
	        type: 10 /* IF_BRANCH */,
	        loc: node.loc,
	        condition: dir.name === 'else' ? undefined : dir.exp,
	        children: node.tagType === 3 /* TEMPLATE */ && !findDir(node, 'for')
	            ? node.children
	            : [node],
	        userKey: findProp(node, `key`)
	    };
	}
	function createCodegenNodeForBranch(branch, keyIndex, context) {
	    if (branch.condition) {
	        return createConditionalExpression(branch.condition, createChildrenCodegenNode(branch, keyIndex, context), 
	        // make sure to pass in asBlock: true so that the comment node call
	        // closes the current block.
	        createCallExpression(context.helper(CREATE_COMMENT), [
	             '"v-if"' ,
	            'true'
	        ]));
	    }
	    else {
	        return createChildrenCodegenNode(branch, keyIndex, context);
	    }
	}
	function createChildrenCodegenNode(branch, keyIndex, context) {
	    const { helper } = context;
	    const keyProperty = createObjectProperty(`key`, createSimpleExpression(`${keyIndex}`, false, locStub, 2 /* CAN_HOIST */));
	    const { children } = branch;
	    const firstChild = children[0];
	    const needFragmentWrapper = children.length !== 1 || firstChild.type !== 1 /* ELEMENT */;
	    if (needFragmentWrapper) {
	        if (children.length === 1 && firstChild.type === 11 /* FOR */) {
	            // optimize away nested fragments when child is a ForNode
	            const vnodeCall = firstChild.codegenNode;
	            injectProp(vnodeCall, keyProperty, context);
	            return vnodeCall;
	        }
	        else {
	            return createVNodeCall(context, helper(FRAGMENT), createObjectExpression([keyProperty]), children, 64 /* STABLE_FRAGMENT */ +
	                ( ` /* ${PatchFlagNames[64 /* STABLE_FRAGMENT */]} */`
	                    ), undefined, undefined, true, false, branch.loc);
	        }
	    }
	    else {
	        const vnodeCall = firstChild
	            .codegenNode;
	        // Change createVNode to createBlock.
	        if (vnodeCall.type === 13 /* VNODE_CALL */) {
	            vnodeCall.isBlock = true;
	            helper(OPEN_BLOCK);
	            helper(CREATE_BLOCK);
	        }
	        // inject branch key
	        injectProp(vnodeCall, keyProperty, context);
	        return vnodeCall;
	    }
	}
	function isSameKey(a, b) {
	    if (!a || a.type !== b.type) {
	        return false;
	    }
	    if (a.type === 6 /* ATTRIBUTE */) {
	        if (a.value.content !== b.value.content) {
	            return false;
	        }
	    }
	    else {
	        // directive
	        const exp = a.exp;
	        const branchExp = b.exp;
	        if (exp.type !== branchExp.type) {
	            return false;
	        }
	        if (exp.type !== 4 /* SIMPLE_EXPRESSION */ ||
	            (exp.isStatic !== branchExp.isStatic ||
	                exp.content !== branchExp.content)) {
	            return false;
	        }
	    }
	    return true;
	}
	function getParentCondition(node) {
	    while (true) {
	        if (node.type === 19 /* JS_CONDITIONAL_EXPRESSION */) {
	            if (node.alternate.type === 19 /* JS_CONDITIONAL_EXPRESSION */) {
	                node = node.alternate;
	            }
	            else {
	                return node;
	            }
	        }
	        else if (node.type === 20 /* JS_CACHE_EXPRESSION */) {
	            node = node.value;
	        }
	    }
	}

	const transformFor = createStructuralDirectiveTransform('for', (node, dir, context) => {
	    const { helper } = context;
	    return processFor(node, dir, context, forNode => {
	        // create the loop render function expression now, and add the
	        // iterator on exit after all children have been traversed
	        const renderExp = createCallExpression(helper(RENDER_LIST), [
	            forNode.source
	        ]);
	        const keyProp = findProp(node, `key`);
	        const keyProperty = keyProp
	            ? createObjectProperty(`key`, keyProp.type === 6 /* ATTRIBUTE */
	                ? createSimpleExpression(keyProp.value.content, true)
	                : keyProp.exp)
	            : null;
	        const isStableFragment = forNode.source.type === 4 /* SIMPLE_EXPRESSION */ &&
	            forNode.source.constType > 0;
	        const fragmentFlag = isStableFragment
	            ? 64 /* STABLE_FRAGMENT */
	            : keyProp
	                ? 128 /* KEYED_FRAGMENT */
	                : 256 /* UNKEYED_FRAGMENT */;
	        forNode.codegenNode = createVNodeCall(context, helper(FRAGMENT), undefined, renderExp, fragmentFlag +
	            ( ` /* ${PatchFlagNames[fragmentFlag]} */` ), undefined, undefined, true /* isBlock */, !isStableFragment /* disableTracking */, node.loc);
	        return () => {
	            // finish the codegen now that all children have been traversed
	            let childBlock;
	            const isTemplate = isTemplateNode(node);
	            const { children } = forNode;
	            // check <template v-for> key placement
	            if ( isTemplate) {
	                node.children.some(c => {
	                    if (c.type === 1 /* ELEMENT */) {
	                        const key = findProp(c, 'key');
	                        if (key) {
	                            context.onError(createCompilerError(32 /* X_V_FOR_TEMPLATE_KEY_PLACEMENT */, key.loc));
	                            return true;
	                        }
	                    }
	                });
	            }
	            const needFragmentWrapper = children.length !== 1 || children[0].type !== 1 /* ELEMENT */;
	            const slotOutlet = isSlotOutlet(node)
	                ? node
	                : isTemplate &&
	                    node.children.length === 1 &&
	                    isSlotOutlet(node.children[0])
	                    ? node.children[0] // api-extractor somehow fails to infer this
	                    : null;
	            if (slotOutlet) {
	                // <slot v-for="..."> or <template v-for="..."><slot/></template>
	                childBlock = slotOutlet.codegenNode;
	                if (isTemplate && keyProperty) {
	                    // <template v-for="..." :key="..."><slot/></template>
	                    // we need to inject the key to the renderSlot() call.
	                    // the props for renderSlot is passed as the 3rd argument.
	                    injectProp(childBlock, keyProperty, context);
	                }
	            }
	            else if (needFragmentWrapper) {
	                // <template v-for="..."> with text or multi-elements
	                // should generate a fragment block for each loop
	                childBlock = createVNodeCall(context, helper(FRAGMENT), keyProperty ? createObjectExpression([keyProperty]) : undefined, node.children, 64 /* STABLE_FRAGMENT */ +
	                    ( ` /* ${PatchFlagNames[64 /* STABLE_FRAGMENT */]} */`
	                        ), undefined, undefined, true);
	            }
	            else {
	                // Normal element v-for. Directly use the child's codegenNode
	                // but mark it as a block.
	                childBlock = children[0]
	                    .codegenNode;
	                if (isTemplate && keyProperty) {
	                    injectProp(childBlock, keyProperty, context);
	                }
	                childBlock.isBlock = !isStableFragment;
	                if (childBlock.isBlock) {
	                    helper(OPEN_BLOCK);
	                    helper(CREATE_BLOCK);
	                }
	                else {
	                    helper(CREATE_VNODE);
	                }
	            }
	            renderExp.arguments.push(createFunctionExpression(createForLoopParams(forNode.parseResult), childBlock, true /* force newline */));
	        };
	    });
	});
	// target-agnostic transform used for both Client and SSR
	function processFor(node, dir, context, processCodegen) {
	    if (!dir.exp) {
	        context.onError(createCompilerError(30 /* X_V_FOR_NO_EXPRESSION */, dir.loc));
	        return;
	    }
	    const parseResult = parseForExpression(
	    // can only be simple expression because vFor transform is applied
	    // before expression transform.
	    dir.exp, context);
	    if (!parseResult) {
	        context.onError(createCompilerError(31 /* X_V_FOR_MALFORMED_EXPRESSION */, dir.loc));
	        return;
	    }
	    const { addIdentifiers, removeIdentifiers, scopes } = context;
	    const { source, value, key, index } = parseResult;
	    const forNode = {
	        type: 11 /* FOR */,
	        loc: dir.loc,
	        source,
	        valueAlias: value,
	        keyAlias: key,
	        objectIndexAlias: index,
	        parseResult,
	        children: isTemplateNode(node) ? node.children : [node]
	    };
	    context.replaceNode(forNode);
	    // bookkeeping
	    scopes.vFor++;
	    const onExit = processCodegen && processCodegen(forNode);
	    return () => {
	        scopes.vFor--;
	        if (onExit)
	            onExit();
	    };
	}
	const forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
	// This regex doesn't cover the case if key or index aliases have destructuring,
	// but those do not make sense in the first place, so this works in practice.
	const forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
	const stripParensRE = /^\(|\)$/g;
	function parseForExpression(input, context) {
	    const loc = input.loc;
	    const exp = input.content;
	    const inMatch = exp.match(forAliasRE);
	    if (!inMatch)
	        return;
	    const [, LHS, RHS] = inMatch;
	    const result = {
	        source: createAliasExpression(loc, RHS.trim(), exp.indexOf(RHS, LHS.length)),
	        value: undefined,
	        key: undefined,
	        index: undefined
	    };
	    {
	        validateBrowserExpression(result.source, context);
	    }
	    let valueContent = LHS.trim()
	        .replace(stripParensRE, '')
	        .trim();
	    const trimmedOffset = LHS.indexOf(valueContent);
	    const iteratorMatch = valueContent.match(forIteratorRE);
	    if (iteratorMatch) {
	        valueContent = valueContent.replace(forIteratorRE, '').trim();
	        const keyContent = iteratorMatch[1].trim();
	        let keyOffset;
	        if (keyContent) {
	            keyOffset = exp.indexOf(keyContent, trimmedOffset + valueContent.length);
	            result.key = createAliasExpression(loc, keyContent, keyOffset);
	            {
	                validateBrowserExpression(result.key, context, true);
	            }
	        }
	        if (iteratorMatch[2]) {
	            const indexContent = iteratorMatch[2].trim();
	            if (indexContent) {
	                result.index = createAliasExpression(loc, indexContent, exp.indexOf(indexContent, result.key
	                    ? keyOffset + keyContent.length
	                    : trimmedOffset + valueContent.length));
	                {
	                    validateBrowserExpression(result.index, context, true);
	                }
	            }
	        }
	    }
	    if (valueContent) {
	        result.value = createAliasExpression(loc, valueContent, trimmedOffset);
	        {
	            validateBrowserExpression(result.value, context, true);
	        }
	    }
	    return result;
	}
	function createAliasExpression(range, content, offset) {
	    return createSimpleExpression(content, false, getInnerRange(range, offset, content.length));
	}
	function createForLoopParams({ value, key, index }) {
	    const params = [];
	    if (value) {
	        params.push(value);
	    }
	    if (key) {
	        if (!value) {
	            params.push(createSimpleExpression(`_`, false));
	        }
	        params.push(key);
	    }
	    if (index) {
	        if (!key) {
	            if (!value) {
	                params.push(createSimpleExpression(`_`, false));
	            }
	            params.push(createSimpleExpression(`__`, false));
	        }
	        params.push(index);
	    }
	    return params;
	}

	const defaultFallback = createSimpleExpression(`undefined`, false);
	// A NodeTransform that:
	// 1. Tracks scope identifiers for scoped slots so that they don't get prefixed
	//    by transformExpression. This is only applied in non-browser builds with
	//    { prefixIdentifiers: true }.
	// 2. Track v-slot depths so that we know a slot is inside another slot.
	//    Note the exit callback is executed before buildSlots() on the same node,
	//    so only nested slots see positive numbers.
	const trackSlotScopes = (node, context) => {
	    if (node.type === 1 /* ELEMENT */ &&
	        (node.tagType === 1 /* COMPONENT */ ||
	            node.tagType === 3 /* TEMPLATE */)) {
	        // We are only checking non-empty v-slot here
	        // since we only care about slots that introduce scope variables.
	        const vSlot = findDir(node, 'slot');
	        if (vSlot) {
	            const slotProps = vSlot.exp;
	            context.scopes.vSlot++;
	            return () => {
	                context.scopes.vSlot--;
	            };
	        }
	    }
	};
	const buildClientSlotFn = (props, children, loc) => createFunctionExpression(props, children, false /* newline */, true /* isSlot */, children.length ? children[0].loc : loc);
	// Instead of being a DirectiveTransform, v-slot processing is called during
	// transformElement to build the slots object for a component.
	function buildSlots(node, context, buildSlotFn = buildClientSlotFn) {
	    context.helper(WITH_CTX);
	    const { children, loc } = node;
	    const slotsProperties = [];
	    const dynamicSlots = [];
	    const buildDefaultSlotProperty = (props, children) => createObjectProperty(`default`, buildSlotFn(props, children, loc));
	    // If the slot is inside a v-for or another v-slot, force it to be dynamic
	    // since it likely uses a scope variable.
	    let hasDynamicSlots = context.scopes.vSlot > 0 || context.scopes.vFor > 0;
	    // 1. Check for slot with slotProps on component itself.
	    //    <Comp v-slot="{ prop }"/>
	    const onComponentSlot = findDir(node, 'slot', true);
	    if (onComponentSlot) {
	        const { arg, exp } = onComponentSlot;
	        if (arg && !isStaticExp(arg)) {
	            hasDynamicSlots = true;
	        }
	        slotsProperties.push(createObjectProperty(arg || createSimpleExpression('default', true), buildSlotFn(exp, children, loc)));
	    }
	    // 2. Iterate through children and check for template slots
	    //    <template v-slot:foo="{ prop }">
	    let hasTemplateSlots = false;
	    let hasNamedDefaultSlot = false;
	    const implicitDefaultChildren = [];
	    const seenSlotNames = new Set();
	    for (let i = 0; i < children.length; i++) {
	        const slotElement = children[i];
	        let slotDir;
	        if (!isTemplateNode(slotElement) ||
	            !(slotDir = findDir(slotElement, 'slot', true))) {
	            // not a <template v-slot>, skip.
	            if (slotElement.type !== 3 /* COMMENT */) {
	                implicitDefaultChildren.push(slotElement);
	            }
	            continue;
	        }
	        if (onComponentSlot) {
	            // already has on-component slot - this is incorrect usage.
	            context.onError(createCompilerError(36 /* X_V_SLOT_MIXED_SLOT_USAGE */, slotDir.loc));
	            break;
	        }
	        hasTemplateSlots = true;
	        const { children: slotChildren, loc: slotLoc } = slotElement;
	        const { arg: slotName = createSimpleExpression(`default`, true), exp: slotProps, loc: dirLoc } = slotDir;
	        // check if name is dynamic.
	        let staticSlotName;
	        if (isStaticExp(slotName)) {
	            staticSlotName = slotName ? slotName.content : `default`;
	        }
	        else {
	            hasDynamicSlots = true;
	        }
	        const slotFunction = buildSlotFn(slotProps, slotChildren, slotLoc);
	        // check if this slot is conditional (v-if/v-for)
	        let vIf;
	        let vElse;
	        let vFor;
	        if ((vIf = findDir(slotElement, 'if'))) {
	            hasDynamicSlots = true;
	            dynamicSlots.push(createConditionalExpression(vIf.exp, buildDynamicSlot(slotName, slotFunction), defaultFallback));
	        }
	        else if ((vElse = findDir(slotElement, /^else(-if)?$/, true /* allowEmpty */))) {
	            // find adjacent v-if
	            let j = i;
	            let prev;
	            while (j--) {
	                prev = children[j];
	                if (prev.type !== 3 /* COMMENT */) {
	                    break;
	                }
	            }
	            if (prev && isTemplateNode(prev) && findDir(prev, 'if')) {
	                // remove node
	                children.splice(i, 1);
	                i--;
	                // attach this slot to previous conditional
	                let conditional = dynamicSlots[dynamicSlots.length - 1];
	                while (conditional.alternate.type === 19 /* JS_CONDITIONAL_EXPRESSION */) {
	                    conditional = conditional.alternate;
	                }
	                conditional.alternate = vElse.exp
	                    ? createConditionalExpression(vElse.exp, buildDynamicSlot(slotName, slotFunction), defaultFallback)
	                    : buildDynamicSlot(slotName, slotFunction);
	            }
	            else {
	                context.onError(createCompilerError(29 /* X_V_ELSE_NO_ADJACENT_IF */, vElse.loc));
	            }
	        }
	        else if ((vFor = findDir(slotElement, 'for'))) {
	            hasDynamicSlots = true;
	            const parseResult = vFor.parseResult ||
	                parseForExpression(vFor.exp, context);
	            if (parseResult) {
	                // Render the dynamic slots as an array and add it to the createSlot()
	                // args. The runtime knows how to handle it appropriately.
	                dynamicSlots.push(createCallExpression(context.helper(RENDER_LIST), [
	                    parseResult.source,
	                    createFunctionExpression(createForLoopParams(parseResult), buildDynamicSlot(slotName, slotFunction), true /* force newline */)
	                ]));
	            }
	            else {
	                context.onError(createCompilerError(31 /* X_V_FOR_MALFORMED_EXPRESSION */, vFor.loc));
	            }
	        }
	        else {
	            // check duplicate static names
	            if (staticSlotName) {
	                if (seenSlotNames.has(staticSlotName)) {
	                    context.onError(createCompilerError(37 /* X_V_SLOT_DUPLICATE_SLOT_NAMES */, dirLoc));
	                    continue;
	                }
	                seenSlotNames.add(staticSlotName);
	                if (staticSlotName === 'default') {
	                    hasNamedDefaultSlot = true;
	                }
	            }
	            slotsProperties.push(createObjectProperty(slotName, slotFunction));
	        }
	    }
	    if (!onComponentSlot) {
	        if (!hasTemplateSlots) {
	            // implicit default slot (on component)
	            slotsProperties.push(buildDefaultSlotProperty(undefined, children));
	        }
	        else if (implicitDefaultChildren.length) {
	            // implicit default slot (mixed with named slots)
	            if (hasNamedDefaultSlot) {
	                context.onError(createCompilerError(38 /* X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN */, implicitDefaultChildren[0].loc));
	            }
	            else {
	                slotsProperties.push(buildDefaultSlotProperty(undefined, implicitDefaultChildren));
	            }
	        }
	    }
	    const slotFlag = hasDynamicSlots
	        ? 2 /* DYNAMIC */
	        : hasForwardedSlots(node.children)
	            ? 3 /* FORWARDED */
	            : 1 /* STABLE */;
	    let slots = createObjectExpression(slotsProperties.concat(createObjectProperty(`_`, 
	    // 2 = compiled but dynamic = can skip normalization, but must run diff
	    // 1 = compiled and static = can skip normalization AND diff as optimized
	    createSimpleExpression(slotFlag + ( ` /* ${slotFlagsText[slotFlag]} */` ), false))), loc);
	    if (dynamicSlots.length) {
	        slots = createCallExpression(context.helper(CREATE_SLOTS), [
	            slots,
	            createArrayExpression(dynamicSlots)
	        ]);
	    }
	    return {
	        slots,
	        hasDynamicSlots
	    };
	}
	function buildDynamicSlot(name, fn) {
	    return createObjectExpression([
	        createObjectProperty(`name`, name),
	        createObjectProperty(`fn`, fn)
	    ]);
	}
	function hasForwardedSlots(children) {
	    for (let i = 0; i < children.length; i++) {
	        const child = children[i];
	        if (child.type === 1 /* ELEMENT */) {
	            if (child.tagType === 2 /* SLOT */ ||
	                (child.tagType === 0 /* ELEMENT */ &&
	                    hasForwardedSlots(child.children))) {
	                return true;
	            }
	        }
	    }
	    return false;
	}

	// some directive transforms (e.g. v-model) may return a symbol for runtime
	// import, which should be used instead of a resolveDirective call.
	const directiveImportMap = new WeakMap();
	// generate a JavaScript AST for this element's codegen
	const transformElement = (node, context) => {
	    if (!(node.type === 1 /* ELEMENT */ &&
	        (node.tagType === 0 /* ELEMENT */ ||
	            node.tagType === 1 /* COMPONENT */))) {
	        return;
	    }
	    // perform the work on exit, after all child expressions have been
	    // processed and merged.
	    return function postTransformElement() {
	        const { tag, props } = node;
	        const isComponent = node.tagType === 1 /* COMPONENT */;
	        // The goal of the transform is to create a codegenNode implementing the
	        // VNodeCall interface.
	        const vnodeTag = isComponent
	            ? resolveComponentType(node, context)
	            : `"${tag}"`;
	        const isDynamicComponent = isObject(vnodeTag) && vnodeTag.callee === RESOLVE_DYNAMIC_COMPONENT;
	        let vnodeProps;
	        let vnodeChildren;
	        let vnodePatchFlag;
	        let patchFlag = 0;
	        let vnodeDynamicProps;
	        let dynamicPropNames;
	        let vnodeDirectives;
	        let shouldUseBlock = 
	        // dynamic component may resolve to plain elements
	        isDynamicComponent ||
	            vnodeTag === TELEPORT ||
	            vnodeTag === SUSPENSE ||
	            (!isComponent &&
	                // <svg> and <foreignObject> must be forced into blocks so that block
	                // updates inside get proper isSVG flag at runtime. (#639, #643)
	                // This is technically web-specific, but splitting the logic out of core
	                // leads to too much unnecessary complexity.
	                (tag === 'svg' ||
	                    tag === 'foreignObject' ||
	                    // #938: elements with dynamic keys should be forced into blocks
	                    findProp(node, 'key', true)));
	        // props
	        if (props.length > 0) {
	            const propsBuildResult = buildProps(node, context);
	            vnodeProps = propsBuildResult.props;
	            patchFlag = propsBuildResult.patchFlag;
	            dynamicPropNames = propsBuildResult.dynamicPropNames;
	            const directives = propsBuildResult.directives;
	            vnodeDirectives =
	                directives && directives.length
	                    ? createArrayExpression(directives.map(dir => buildDirectiveArgs(dir, context)))
	                    : undefined;
	        }
	        // children
	        if (node.children.length > 0) {
	            if (vnodeTag === KEEP_ALIVE) {
	                // Although a built-in component, we compile KeepAlive with raw children
	                // instead of slot functions so that it can be used inside Transition
	                // or other Transition-wrapping HOCs.
	                // To ensure correct updates with block optimizations, we need to:
	                // 1. Force keep-alive into a block. This avoids its children being
	                //    collected by a parent block.
	                shouldUseBlock = true;
	                // 2. Force keep-alive to always be updated, since it uses raw children.
	                patchFlag |= 1024 /* DYNAMIC_SLOTS */;
	                if ( node.children.length > 1) {
	                    context.onError(createCompilerError(44 /* X_KEEP_ALIVE_INVALID_CHILDREN */, {
	                        start: node.children[0].loc.start,
	                        end: node.children[node.children.length - 1].loc.end,
	                        source: ''
	                    }));
	                }
	            }
	            const shouldBuildAsSlots = isComponent &&
	                // Teleport is not a real component and has dedicated runtime handling
	                vnodeTag !== TELEPORT &&
	                // explained above.
	                vnodeTag !== KEEP_ALIVE;
	            if (shouldBuildAsSlots) {
	                const { slots, hasDynamicSlots } = buildSlots(node, context);
	                vnodeChildren = slots;
	                if (hasDynamicSlots) {
	                    patchFlag |= 1024 /* DYNAMIC_SLOTS */;
	                }
	            }
	            else if (node.children.length === 1 && vnodeTag !== TELEPORT) {
	                const child = node.children[0];
	                const type = child.type;
	                // check for dynamic text children
	                const hasDynamicTextChild = type === 5 /* INTERPOLATION */ ||
	                    type === 8 /* COMPOUND_EXPRESSION */;
	                if (hasDynamicTextChild &&
	                    getConstantType(child, context) === 0 /* NOT_CONSTANT */) {
	                    patchFlag |= 1 /* TEXT */;
	                }
	                // pass directly if the only child is a text node
	                // (plain / interpolation / expression)
	                if (hasDynamicTextChild || type === 2 /* TEXT */) {
	                    vnodeChildren = child;
	                }
	                else {
	                    vnodeChildren = node.children;
	                }
	            }
	            else {
	                vnodeChildren = node.children;
	            }
	        }
	        // patchFlag & dynamicPropNames
	        if (patchFlag !== 0) {
	            {
	                if (patchFlag < 0) {
	                    // special flags (negative and mutually exclusive)
	                    vnodePatchFlag = patchFlag + ` /* ${PatchFlagNames[patchFlag]} */`;
	                }
	                else {
	                    // bitwise flags
	                    const flagNames = Object.keys(PatchFlagNames)
	                        .map(Number)
	                        .filter(n => n > 0 && patchFlag & n)
	                        .map(n => PatchFlagNames[n])
	                        .join(`, `);
	                    vnodePatchFlag = patchFlag + ` /* ${flagNames} */`;
	                }
	            }
	            if (dynamicPropNames && dynamicPropNames.length) {
	                vnodeDynamicProps = stringifyDynamicPropNames(dynamicPropNames);
	            }
	        }
	        node.codegenNode = createVNodeCall(context, vnodeTag, vnodeProps, vnodeChildren, vnodePatchFlag, vnodeDynamicProps, vnodeDirectives, !!shouldUseBlock, false /* disableTracking */, node.loc);
	    };
	};
	function resolveComponentType(node, context, ssr = false) {
	    const { tag } = node;
	    // 1. dynamic component
	    const isProp = node.tag === 'component' ? findProp(node, 'is') : findDir(node, 'is');
	    if (isProp) {
	        const exp = isProp.type === 6 /* ATTRIBUTE */
	            ? isProp.value && createSimpleExpression(isProp.value.content, true)
	            : isProp.exp;
	        if (exp) {
	            return createCallExpression(context.helper(RESOLVE_DYNAMIC_COMPONENT), [
	                exp
	            ]);
	        }
	    }
	    // 2. built-in components (Teleport, Transition, KeepAlive, Suspense...)
	    const builtIn = isCoreComponent(tag) || context.isBuiltInComponent(tag);
	    if (builtIn) {
	        // built-ins are simply fallthroughs / have special handling during ssr
	        // so we don't need to import their runtime equivalents
	        if (!ssr)
	            context.helper(builtIn);
	        return builtIn;
	    }
	    // 5. user component (resolve)
	    context.helper(RESOLVE_COMPONENT);
	    context.components.add(tag);
	    return toValidAssetId(tag, `component`);
	}
	function buildProps(node, context, props = node.props, ssr = false) {
	    const { tag, loc: elementLoc } = node;
	    const isComponent = node.tagType === 1 /* COMPONENT */;
	    let properties = [];
	    const mergeArgs = [];
	    const runtimeDirectives = [];
	    // patchFlag analysis
	    let patchFlag = 0;
	    let hasRef = false;
	    let hasClassBinding = false;
	    let hasStyleBinding = false;
	    let hasHydrationEventBinding = false;
	    let hasDynamicKeys = false;
	    let hasVnodeHook = false;
	    const dynamicPropNames = [];
	    const analyzePatchFlag = ({ key, value }) => {
	        if (isStaticExp(key)) {
	            const name = key.content;
	            const isEventHandler = isOn(name);
	            if (!isComponent &&
	                isEventHandler &&
	                // omit the flag for click handlers because hydration gives click
	                // dedicated fast path.
	                name.toLowerCase() !== 'onclick' &&
	                // omit v-model handlers
	                name !== 'onUpdate:modelValue' &&
	                // omit onVnodeXXX hooks
	                !isReservedProp(name)) {
	                hasHydrationEventBinding = true;
	            }
	            if (isEventHandler && isReservedProp(name)) {
	                hasVnodeHook = true;
	            }
	            if (value.type === 20 /* JS_CACHE_EXPRESSION */ ||
	                ((value.type === 4 /* SIMPLE_EXPRESSION */ ||
	                    value.type === 8 /* COMPOUND_EXPRESSION */) &&
	                    getConstantType(value, context) > 0)) {
	                // skip if the prop is a cached handler or has constant value
	                return;
	            }
	            if (name === 'ref') {
	                hasRef = true;
	            }
	            else if (name === 'class' && !isComponent) {
	                hasClassBinding = true;
	            }
	            else if (name === 'style' && !isComponent) {
	                hasStyleBinding = true;
	            }
	            else if (name !== 'key' && !dynamicPropNames.includes(name)) {
	                dynamicPropNames.push(name);
	            }
	        }
	        else {
	            hasDynamicKeys = true;
	        }
	    };
	    for (let i = 0; i < props.length; i++) {
	        // static attribute
	        const prop = props[i];
	        if (prop.type === 6 /* ATTRIBUTE */) {
	            const { loc, name, value } = prop;
	            let isStatic = true;
	            if (name === 'ref') {
	                hasRef = true;
	            }
	            // skip :is on <component>
	            if (name === 'is' && tag === 'component') {
	                continue;
	            }
	            properties.push(createObjectProperty(createSimpleExpression(name, true, getInnerRange(loc, 0, name.length)), createSimpleExpression(value ? value.content : '', isStatic, value ? value.loc : loc)));
	        }
	        else {
	            // directives
	            const { name, arg, exp, loc } = prop;
	            const isBind = name === 'bind';
	            const isOn = name === 'on';
	            // skip v-slot - it is handled by its dedicated transform.
	            if (name === 'slot') {
	                if (!isComponent) {
	                    context.onError(createCompilerError(39 /* X_V_SLOT_MISPLACED */, loc));
	                }
	                continue;
	            }
	            // skip v-once - it is handled by its dedicated transform.
	            if (name === 'once') {
	                continue;
	            }
	            // skip v-is and :is on <component>
	            if (name === 'is' ||
	                (isBind && tag === 'component' && isBindKey(arg, 'is'))) {
	                continue;
	            }
	            // skip v-on in SSR compilation
	            if (isOn && ssr) {
	                continue;
	            }
	            // special case for v-bind and v-on with no argument
	            if (!arg && (isBind || isOn)) {
	                hasDynamicKeys = true;
	                if (exp) {
	                    if (properties.length) {
	                        mergeArgs.push(createObjectExpression(dedupeProperties(properties), elementLoc));
	                        properties = [];
	                    }
	                    if (isBind) {
	                        mergeArgs.push(exp);
	                    }
	                    else {
	                        // v-on="obj" -> toHandlers(obj)
	                        mergeArgs.push({
	                            type: 14 /* JS_CALL_EXPRESSION */,
	                            loc,
	                            callee: context.helper(TO_HANDLERS),
	                            arguments: [exp]
	                        });
	                    }
	                }
	                else {
	                    context.onError(createCompilerError(isBind
	                        ? 33 /* X_V_BIND_NO_EXPRESSION */
	                        : 34 /* X_V_ON_NO_EXPRESSION */, loc));
	                }
	                continue;
	            }
	            const directiveTransform = context.directiveTransforms[name];
	            if (directiveTransform) {
	                // has built-in directive transform.
	                const { props, needRuntime } = directiveTransform(prop, node, context);
	                !ssr && props.forEach(analyzePatchFlag);
	                properties.push(...props);
	                if (needRuntime) {
	                    runtimeDirectives.push(prop);
	                    if (isSymbol(needRuntime)) {
	                        directiveImportMap.set(prop, needRuntime);
	                    }
	                }
	            }
	            else {
	                // no built-in transform, this is a user custom directive.
	                runtimeDirectives.push(prop);
	            }
	        }
	    }
	    let propsExpression = undefined;
	    // has v-bind="object" or v-on="object", wrap with mergeProps
	    if (mergeArgs.length) {
	        if (properties.length) {
	            mergeArgs.push(createObjectExpression(dedupeProperties(properties), elementLoc));
	        }
	        if (mergeArgs.length > 1) {
	            propsExpression = createCallExpression(context.helper(MERGE_PROPS), mergeArgs, elementLoc);
	        }
	        else {
	            // single v-bind with nothing else - no need for a mergeProps call
	            propsExpression = mergeArgs[0];
	        }
	    }
	    else if (properties.length) {
	        propsExpression = createObjectExpression(dedupeProperties(properties), elementLoc);
	    }
	    // patchFlag analysis
	    if (hasDynamicKeys) {
	        patchFlag |= 16 /* FULL_PROPS */;
	    }
	    else {
	        if (hasClassBinding) {
	            patchFlag |= 2 /* CLASS */;
	        }
	        if (hasStyleBinding) {
	            patchFlag |= 4 /* STYLE */;
	        }
	        if (dynamicPropNames.length) {
	            patchFlag |= 8 /* PROPS */;
	        }
	        if (hasHydrationEventBinding) {
	            patchFlag |= 32 /* HYDRATE_EVENTS */;
	        }
	    }
	    if ((patchFlag === 0 || patchFlag === 32 /* HYDRATE_EVENTS */) &&
	        (hasRef || hasVnodeHook || runtimeDirectives.length > 0)) {
	        patchFlag |= 512 /* NEED_PATCH */;
	    }
	    return {
	        props: propsExpression,
	        directives: runtimeDirectives,
	        patchFlag,
	        dynamicPropNames
	    };
	}
	// Dedupe props in an object literal.
	// Literal duplicated attributes would have been warned during the parse phase,
	// however, it's possible to encounter duplicated `onXXX` handlers with different
	// modifiers. We also need to merge static and dynamic class / style attributes.
	// - onXXX handlers / style: merge into array
	// - class: merge into single expression with concatenation
	function dedupeProperties(properties) {
	    const knownProps = new Map();
	    const deduped = [];
	    for (let i = 0; i < properties.length; i++) {
	        const prop = properties[i];
	        // dynamic keys are always allowed
	        if (prop.key.type === 8 /* COMPOUND_EXPRESSION */ || !prop.key.isStatic) {
	            deduped.push(prop);
	            continue;
	        }
	        const name = prop.key.content;
	        const existing = knownProps.get(name);
	        if (existing) {
	            if (name === 'style' || name === 'class' || name.startsWith('on')) {
	                mergeAsArray(existing, prop);
	            }
	            // unexpected duplicate, should have emitted error during parse
	        }
	        else {
	            knownProps.set(name, prop);
	            deduped.push(prop);
	        }
	    }
	    return deduped;
	}
	function mergeAsArray(existing, incoming) {
	    if (existing.value.type === 17 /* JS_ARRAY_EXPRESSION */) {
	        existing.value.elements.push(incoming.value);
	    }
	    else {
	        existing.value = createArrayExpression([existing.value, incoming.value], existing.loc);
	    }
	}
	function buildDirectiveArgs(dir, context) {
	    const dirArgs = [];
	    const runtime = directiveImportMap.get(dir);
	    if (runtime) {
	        // built-in directive with runtime
	        dirArgs.push(context.helperString(runtime));
	    }
	    else {
	        {
	            // inject statement for resolving directive
	            context.helper(RESOLVE_DIRECTIVE);
	            context.directives.add(dir.name);
	            dirArgs.push(toValidAssetId(dir.name, `directive`));
	        }
	    }
	    const { loc } = dir;
	    if (dir.exp)
	        dirArgs.push(dir.exp);
	    if (dir.arg) {
	        if (!dir.exp) {
	            dirArgs.push(`void 0`);
	        }
	        dirArgs.push(dir.arg);
	    }
	    if (Object.keys(dir.modifiers).length) {
	        if (!dir.arg) {
	            if (!dir.exp) {
	                dirArgs.push(`void 0`);
	            }
	            dirArgs.push(`void 0`);
	        }
	        const trueExpression = createSimpleExpression(`true`, false, loc);
	        dirArgs.push(createObjectExpression(dir.modifiers.map(modifier => createObjectProperty(modifier, trueExpression)), loc));
	    }
	    return createArrayExpression(dirArgs, dir.loc);
	}
	function stringifyDynamicPropNames(props) {
	    let propsNamesString = `[`;
	    for (let i = 0, l = props.length; i < l; i++) {
	        propsNamesString += JSON.stringify(props[i]);
	        if (i < l - 1)
	            propsNamesString += ', ';
	    }
	    return propsNamesString + `]`;
	}

	const EMPTY_OBJ$1 =  Object.freeze({})
	    ;
	const EMPTY_ARR$1 =  Object.freeze([]) ;
	const cacheStringFunction$1 = (fn) => {
	    const cache = Object.create(null);
	    return ((str) => {
	        const hit = cache[str];
	        return hit || (cache[str] = fn(str));
	    });
	};
	const camelizeRE$1 = /-(\w)/g;
	/**
	 * @private
	 */
	const camelize$1 = cacheStringFunction$1((str) => {
	    return str.replace(camelizeRE$1, (_, c) => (c ? c.toUpperCase() : ''));
	});

	const transformSlotOutlet = (node, context) => {
	    if (isSlotOutlet(node)) {
	        const { children, loc } = node;
	        const { slotName, slotProps } = processSlotOutlet(node, context);
	        const slotArgs = [
	            context.prefixIdentifiers ? `_ctx.$slots` : `$slots`,
	            slotName
	        ];
	        if (slotProps) {
	            slotArgs.push(slotProps);
	        }
	        if (children.length) {
	            if (!slotProps) {
	                slotArgs.push(`{}`);
	            }
	            slotArgs.push(createFunctionExpression([], children, false, false, loc));
	        }
	        node.codegenNode = createCallExpression(context.helper(RENDER_SLOT), slotArgs, loc);
	    }
	};
	function processSlotOutlet(node, context) {
	    let slotName = `"default"`;
	    let slotProps = undefined;
	    const nonNameProps = [];
	    for (let i = 0; i < node.props.length; i++) {
	        const p = node.props[i];
	        if (p.type === 6 /* ATTRIBUTE */) {
	            if (p.value) {
	                if (p.name === 'name') {
	                    slotName = JSON.stringify(p.value.content);
	                }
	                else {
	                    p.name = camelize$1(p.name);
	                    nonNameProps.push(p);
	                }
	            }
	        }
	        else {
	            if (p.name === 'bind' && isBindKey(p.arg, 'name')) {
	                if (p.exp)
	                    slotName = p.exp;
	            }
	            else {
	                if (p.name === 'bind' && p.arg && isStaticExp(p.arg)) {
	                    p.arg.content = camelize$1(p.arg.content);
	                }
	                nonNameProps.push(p);
	            }
	        }
	    }
	    if (nonNameProps.length > 0) {
	        const { props, directives } = buildProps(node, context, nonNameProps);
	        slotProps = props;
	        if (directives.length) {
	            context.onError(createCompilerError(35 /* X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET */, directives[0].loc));
	        }
	    }
	    return {
	        slotName,
	        slotProps
	    };
	}

	const fnExpRE = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^\s*function(?:\s+[\w$]+)?\s*\(/;
	const transformOn = (dir, node, context, augmentor) => {
	    const { loc, modifiers, arg } = dir;
	    if (!dir.exp && !modifiers.length) {
	        context.onError(createCompilerError(34 /* X_V_ON_NO_EXPRESSION */, loc));
	    }
	    let eventName;
	    if (arg.type === 4 /* SIMPLE_EXPRESSION */) {
	        if (arg.isStatic) {
	            const rawName = arg.content;
	            // for all event listeners, auto convert it to camelCase. See issue #2249
	            eventName = createSimpleExpression(toHandlerKey(camelize(rawName)), true, arg.loc);
	        }
	        else {
	            // #2388
	            eventName = createCompoundExpression([
	                `${context.helperString(TO_HANDLER_KEY)}(`,
	                arg,
	                `)`
	            ]);
	        }
	    }
	    else {
	        // already a compound expression.
	        eventName = arg;
	        eventName.children.unshift(`${context.helperString(TO_HANDLER_KEY)}(`);
	        eventName.children.push(`)`);
	    }
	    // handler processing
	    let exp = dir.exp;
	    if (exp && !exp.content.trim()) {
	        exp = undefined;
	    }
	    let shouldCache = context.cacheHandlers && !exp;
	    if (exp) {
	        const isMemberExp = isMemberExpression(exp.content);
	        const isInlineStatement = !(isMemberExp || fnExpRE.test(exp.content));
	        const hasMultipleStatements = exp.content.includes(`;`);
	        {
	            validateBrowserExpression(exp, context, false, hasMultipleStatements);
	        }
	        if (isInlineStatement || (shouldCache && isMemberExp)) {
	            // wrap inline statement in a function expression
	            exp = createCompoundExpression([
	                `${isInlineStatement
                    ?  `$event`
                    : `${ ``}(...args)`} => ${hasMultipleStatements ? `{` : `(`}`,
	                exp,
	                hasMultipleStatements ? `}` : `)`
	            ]);
	        }
	    }
	    let ret = {
	        props: [
	            createObjectProperty(eventName, exp || createSimpleExpression(`() => {}`, false, loc))
	        ]
	    };
	    // apply extended compiler augmentor
	    if (augmentor) {
	        ret = augmentor(ret);
	    }
	    if (shouldCache) {
	        // cache handlers so that it's always the same handler being passed down.
	        // this avoids unnecessary re-renders when users use inline handlers on
	        // components.
	        ret.props[0].value = context.cache(ret.props[0].value);
	    }
	    return ret;
	};

	// v-bind without arg is handled directly in ./transformElements.ts due to it affecting
	// codegen for the entire props object. This transform here is only for v-bind
	// *with* args.
	const transformBind = (dir, node, context) => {
	    const { exp, modifiers, loc } = dir;
	    const arg = dir.arg;
	    if (arg.type !== 4 /* SIMPLE_EXPRESSION */) {
	        arg.children.unshift(`(`);
	        arg.children.push(`) || ""`);
	    }
	    else if (!arg.isStatic) {
	        arg.content = `${arg.content} || ""`;
	    }
	    // .prop is no longer necessary due to new patch behavior
	    // .sync is replaced by v-model:arg
	    if (modifiers.includes('camel')) {
	        if (arg.type === 4 /* SIMPLE_EXPRESSION */) {
	            if (arg.isStatic) {
	                arg.content = camelize(arg.content);
	            }
	            else {
	                arg.content = `${context.helperString(CAMELIZE)}(${arg.content})`;
	            }
	        }
	        else {
	            arg.children.unshift(`${context.helperString(CAMELIZE)}(`);
	            arg.children.push(`)`);
	        }
	    }
	    if (!exp ||
	        (exp.type === 4 /* SIMPLE_EXPRESSION */ && !exp.content.trim())) {
	        context.onError(createCompilerError(33 /* X_V_BIND_NO_EXPRESSION */, loc));
	        return {
	            props: [createObjectProperty(arg, createSimpleExpression('', true, loc))]
	        };
	    }
	    return {
	        props: [createObjectProperty(arg, exp)]
	    };
	};

	// Merge adjacent text nodes and expressions into a single expression
	// e.g. <div>abc {{ d }} {{ e }}</div> should have a single expression node as child.
	const transformText = (node, context) => {
	    if (node.type === 0 /* ROOT */ ||
	        node.type === 1 /* ELEMENT */ ||
	        node.type === 11 /* FOR */ ||
	        node.type === 10 /* IF_BRANCH */) {
	        // perform the transform on node exit so that all expressions have already
	        // been processed.
	        return () => {
	            const children = node.children;
	            let currentContainer = undefined;
	            let hasText = false;
	            for (let i = 0; i < children.length; i++) {
	                const child = children[i];
	                if (isText(child)) {
	                    hasText = true;
	                    for (let j = i + 1; j < children.length; j++) {
	                        const next = children[j];
	                        if (isText(next)) {
	                            if (!currentContainer) {
	                                currentContainer = children[i] = {
	                                    type: 8 /* COMPOUND_EXPRESSION */,
	                                    loc: child.loc,
	                                    children: [child]
	                                };
	                            }
	                            // merge adjacent text node into current
	                            currentContainer.children.push(` + `, next);
	                            children.splice(j, 1);
	                            j--;
	                        }
	                        else {
	                            currentContainer = undefined;
	                            break;
	                        }
	                    }
	                }
	            }
	            if (!hasText ||
	                // if this is a plain element with a single text child, leave it
	                // as-is since the runtime has dedicated fast path for this by directly
	                // setting textContent of the element.
	                // for component root it's always normalized anyway.
	                (children.length === 1 &&
	                    (node.type === 0 /* ROOT */ ||
	                        (node.type === 1 /* ELEMENT */ &&
	                            node.tagType === 0 /* ELEMENT */)))) {
	                return;
	            }
	            // pre-convert text nodes into createTextVNode(text) calls to avoid
	            // runtime normalization.
	            for (let i = 0; i < children.length; i++) {
	                const child = children[i];
	                if (isText(child) || child.type === 8 /* COMPOUND_EXPRESSION */) {
	                    const callArgs = [];
	                    // createTextVNode defaults to single whitespace, so if it is a
	                    // single space the code could be an empty call to save bytes.
	                    if (child.type !== 2 /* TEXT */ || child.content !== ' ') {
	                        callArgs.push(child);
	                    }
	                    // mark dynamic text with flag so it gets patched inside a block
	                    if (!context.ssr &&
	                        getConstantType(child, context) === 0 /* NOT_CONSTANT */) {
	                        callArgs.push(1 /* TEXT */ +
	                            ( ` /* ${PatchFlagNames[1 /* TEXT */]} */` ));
	                    }
	                    children[i] = {
	                        type: 12 /* TEXT_CALL */,
	                        content: child,
	                        loc: child.loc,
	                        codegenNode: createCallExpression(context.helper(CREATE_TEXT), callArgs)
	                    };
	                }
	            }
	        };
	    }
	};

	const seen = new WeakSet();
	const transformOnce = (node, context) => {
	    if (node.type === 1 /* ELEMENT */ && findDir(node, 'once', true)) {
	        if (seen.has(node)) {
	            return;
	        }
	        seen.add(node);
	        context.helper(SET_BLOCK_TRACKING);
	        return () => {
	            const cur = context.currentNode;
	            if (cur.codegenNode) {
	                cur.codegenNode = context.cache(cur.codegenNode, true /* isVNode */);
	            }
	        };
	    }
	};

	const transformModel = (dir, node, context) => {
	    const { exp, arg } = dir;
	    if (!exp) {
	        context.onError(createCompilerError(40 /* X_V_MODEL_NO_EXPRESSION */, dir.loc));
	        return createTransformProps();
	    }
	    const rawExp = exp.loc.source;
	    const expString = exp.type === 4 /* SIMPLE_EXPRESSION */ ? exp.content : rawExp;
	    // im SFC <script setup> inline mode, the exp may have been transformed into
	    // _unref(exp)
	    const bindingType = context.bindingMetadata[rawExp];
	    const maybeRef = !true    /* SETUP_CONST */;
	    if (!isMemberExpression(expString) && !maybeRef) {
	        context.onError(createCompilerError(41 /* X_V_MODEL_MALFORMED_EXPRESSION */, exp.loc));
	        return createTransformProps();
	    }
	    const propName = arg ? arg : createSimpleExpression('modelValue', true);
	    const eventName = arg
	        ? isStaticExp(arg)
	            ? `onUpdate:${arg.content}`
	            : createCompoundExpression(['"onUpdate:" + ', arg])
	        : `onUpdate:modelValue`;
	    let assignmentExp;
	    const eventArg = context.isTS ? `($event: any)` : `$event`;
	    {
	        assignmentExp = createCompoundExpression([
	            `${eventArg} => (`,
	            exp,
	            ` = $event)`
	        ]);
	    }
	    const props = [
	        // modelValue: foo
	        createObjectProperty(propName, dir.exp),
	        // "onUpdate:modelValue": $event => (foo = $event)
	        createObjectProperty(eventName, assignmentExp)
	    ];
	    // modelModifiers: { foo: true, "bar-baz": true }
	    if (dir.modifiers.length && node.tagType === 1 /* COMPONENT */) {
	        const modifiers = dir.modifiers
	            .map(m => (isSimpleIdentifier(m) ? m : JSON.stringify(m)) + `: true`)
	            .join(`, `);
	        const modifiersKey = arg
	            ? isStaticExp(arg)
	                ? `${arg.content}Modifiers`
	                : createCompoundExpression([arg, ' + "Modifiers"'])
	            : `modelModifiers`;
	        props.push(createObjectProperty(modifiersKey, createSimpleExpression(`{ ${modifiers} }`, false, dir.loc, 2 /* CAN_HOIST */)));
	    }
	    return createTransformProps(props);
	};
	function createTransformProps(props = []) {
	    return { props };
	}

	function getBaseTransformPreset(prefixIdentifiers) {
	    return [
	        [
	            transformOnce,
	            transformIf,
	            transformFor,
	            ...(   [transformExpression]
	                    ),
	            transformSlotOutlet,
	            transformElement,
	            trackSlotScopes,
	            transformText
	        ],
	        {
	            on: transformOn,
	            bind: transformBind,
	            model: transformModel
	        }
	    ];
	}
	// we name it `baseCompile` so that higher order compilers like
	// @vue/compiler-dom can export `compile` while re-exporting everything else.
	function baseCompile(template, options = {}) {
	    const onError = options.onError || defaultOnError;
	    const isModuleMode = options.mode === 'module';
	    /* istanbul ignore if */
	    {
	        if (options.prefixIdentifiers === true) {
	            onError(createCompilerError(45 /* X_PREFIX_ID_NOT_SUPPORTED */));
	        }
	        else if (isModuleMode) {
	            onError(createCompilerError(46 /* X_MODULE_MODE_NOT_SUPPORTED */));
	        }
	    }
	    const prefixIdentifiers = !true ;
	    if ( options.cacheHandlers) {
	        onError(createCompilerError(47 /* X_CACHE_HANDLER_NOT_SUPPORTED */));
	    }
	    if (options.scopeId && !isModuleMode) {
	        onError(createCompilerError(48 /* X_SCOPE_ID_NOT_SUPPORTED */));
	    }
	    const ast = isString(template) ? baseParse(template, options) : template;
	    const [nodeTransforms, directiveTransforms] = getBaseTransformPreset();
	    transform(ast, extend({}, options, {
	        prefixIdentifiers,
	        nodeTransforms: [
	            ...nodeTransforms,
	            ...(options.nodeTransforms || []) // user transforms
	        ],
	        directiveTransforms: extend({}, directiveTransforms, options.directiveTransforms || {} // user transforms
	        )
	    }));
	    return generate(ast, extend({}, options, {
	        prefixIdentifiers
	    }));
	}

	const noopDirectiveTransform = () => ({ props: [] });

	const V_MODEL_RADIO = Symbol( `vModelRadio` );
	const V_MODEL_CHECKBOX = Symbol( `vModelCheckbox` );
	const V_MODEL_TEXT = Symbol( `vModelText` );
	const V_MODEL_SELECT = Symbol( `vModelSelect` );
	const V_MODEL_DYNAMIC = Symbol( `vModelDynamic` );
	const V_ON_WITH_MODIFIERS = Symbol( `vOnModifiersGuard` );
	const V_ON_WITH_KEYS = Symbol( `vOnKeysGuard` );
	const V_SHOW = Symbol( `vShow` );
	const TRANSITION$1 = Symbol( `Transition` );
	const TRANSITION_GROUP = Symbol( `TransitionGroup` );
	registerRuntimeHelpers({
	    [V_MODEL_RADIO]: `vModelRadio`,
	    [V_MODEL_CHECKBOX]: `vModelCheckbox`,
	    [V_MODEL_TEXT]: `vModelText`,
	    [V_MODEL_SELECT]: `vModelSelect`,
	    [V_MODEL_DYNAMIC]: `vModelDynamic`,
	    [V_ON_WITH_MODIFIERS]: `withModifiers`,
	    [V_ON_WITH_KEYS]: `withKeys`,
	    [V_SHOW]: `vShow`,
	    [TRANSITION$1]: `Transition`,
	    [TRANSITION_GROUP]: `TransitionGroup`
	});

	/* eslint-disable no-restricted-globals */
	let decoder;
	function decodeHtmlBrowser(raw) {
	    (decoder || (decoder = document.createElement('div'))).innerHTML = raw;
	    return decoder.textContent;
	}

	const isRawTextContainer = /*#__PURE__*/ makeMap('style,iframe,script,noscript', true);
	const parserOptions = {
	    isVoidTag,
	    isNativeTag: tag => isHTMLTag(tag) || isSVGTag(tag),
	    isPreTag: tag => tag === 'pre',
	    decodeEntities:  decodeHtmlBrowser ,
	    isBuiltInComponent: (tag) => {
	        if (isBuiltInType(tag, `Transition`)) {
	            return TRANSITION$1;
	        }
	        else if (isBuiltInType(tag, `TransitionGroup`)) {
	            return TRANSITION_GROUP;
	        }
	    },
	    // https://html.spec.whatwg.org/multipage/parsing.html#tree-construction-dispatcher
	    getNamespace(tag, parent) {
	        let ns = parent ? parent.ns : 0 /* HTML */;
	        if (parent && ns === 2 /* MATH_ML */) {
	            if (parent.tag === 'annotation-xml') {
	                if (tag === 'svg') {
	                    return 1 /* SVG */;
	                }
	                if (parent.props.some(a => a.type === 6 /* ATTRIBUTE */ &&
	                    a.name === 'encoding' &&
	                    a.value != null &&
	                    (a.value.content === 'text/html' ||
	                        a.value.content === 'application/xhtml+xml'))) {
	                    ns = 0 /* HTML */;
	                }
	            }
	            else if (/^m(?:[ions]|text)$/.test(parent.tag) &&
	                tag !== 'mglyph' &&
	                tag !== 'malignmark') {
	                ns = 0 /* HTML */;
	            }
	        }
	        else if (parent && ns === 1 /* SVG */) {
	            if (parent.tag === 'foreignObject' ||
	                parent.tag === 'desc' ||
	                parent.tag === 'title') {
	                ns = 0 /* HTML */;
	            }
	        }
	        if (ns === 0 /* HTML */) {
	            if (tag === 'svg') {
	                return 1 /* SVG */;
	            }
	            if (tag === 'math') {
	                return 2 /* MATH_ML */;
	            }
	        }
	        return ns;
	    },
	    // https://html.spec.whatwg.org/multipage/parsing.html#parsing-html-fragments
	    getTextMode({ tag, ns }) {
	        if (ns === 0 /* HTML */) {
	            if (tag === 'textarea' || tag === 'title') {
	                return 1 /* RCDATA */;
	            }
	            if (isRawTextContainer(tag)) {
	                return 2 /* RAWTEXT */;
	            }
	        }
	        return 0 /* DATA */;
	    }
	};

	// Parse inline CSS strings for static style attributes into an object.
	// This is a NodeTransform since it works on the static `style` attribute and
	// converts it into a dynamic equivalent:
	// style="color: red" -> :style='{ "color": "red" }'
	// It is then processed by `transformElement` and included in the generated
	// props.
	const transformStyle = node => {
	    if (node.type === 1 /* ELEMENT */) {
	        node.props.forEach((p, i) => {
	            if (p.type === 6 /* ATTRIBUTE */ && p.name === 'style' && p.value) {
	                // replace p with an expression node
	                node.props[i] = {
	                    type: 7 /* DIRECTIVE */,
	                    name: `bind`,
	                    arg: createSimpleExpression(`style`, true, p.loc),
	                    exp: parseInlineCSS(p.value.content, p.loc),
	                    modifiers: [],
	                    loc: p.loc
	                };
	            }
	        });
	    }
	};
	const parseInlineCSS = (cssText, loc) => {
	    const normalized = parseStringStyle(cssText);
	    return createSimpleExpression(JSON.stringify(normalized), false, loc, 3 /* CAN_STRINGIFY */);
	};

	function createDOMCompilerError(code, loc) {
	    return createCompilerError(code, loc,  DOMErrorMessages );
	}
	const DOMErrorMessages = {
	    [49 /* X_V_HTML_NO_EXPRESSION */]: `v-html is missing expression.`,
	    [50 /* X_V_HTML_WITH_CHILDREN */]: `v-html will override element children.`,
	    [51 /* X_V_TEXT_NO_EXPRESSION */]: `v-text is missing expression.`,
	    [52 /* X_V_TEXT_WITH_CHILDREN */]: `v-text will override element children.`,
	    [53 /* X_V_MODEL_ON_INVALID_ELEMENT */]: `v-model can only be used on <input>, <textarea> and <select> elements.`,
	    [54 /* X_V_MODEL_ARG_ON_ELEMENT */]: `v-model argument is not supported on plain elements.`,
	    [55 /* X_V_MODEL_ON_FILE_INPUT_ELEMENT */]: `v-model cannot be used on file inputs since they are read-only. Use a v-on:change listener instead.`,
	    [56 /* X_V_MODEL_UNNECESSARY_VALUE */]: `Unnecessary value binding used alongside v-model. It will interfere with v-model's behavior.`,
	    [57 /* X_V_SHOW_NO_EXPRESSION */]: `v-show is missing expression.`,
	    [58 /* X_TRANSITION_INVALID_CHILDREN */]: `<Transition> expects exactly one child element or component.`,
	    [59 /* X_IGNORED_SIDE_EFFECT_TAG */]: `Tags with side effect (<script> and <style>) are ignored in client component templates.`
	};

	const transformVHtml = (dir, node, context) => {
	    const { exp, loc } = dir;
	    if (!exp) {
	        context.onError(createDOMCompilerError(49 /* X_V_HTML_NO_EXPRESSION */, loc));
	    }
	    if (node.children.length) {
	        context.onError(createDOMCompilerError(50 /* X_V_HTML_WITH_CHILDREN */, loc));
	        node.children.length = 0;
	    }
	    return {
	        props: [
	            createObjectProperty(createSimpleExpression(`innerHTML`, true, loc), exp || createSimpleExpression('', true))
	        ]
	    };
	};

	const transformVText = (dir, node, context) => {
	    const { exp, loc } = dir;
	    if (!exp) {
	        context.onError(createDOMCompilerError(51 /* X_V_TEXT_NO_EXPRESSION */, loc));
	    }
	    if (node.children.length) {
	        context.onError(createDOMCompilerError(52 /* X_V_TEXT_WITH_CHILDREN */, loc));
	        node.children.length = 0;
	    }
	    return {
	        props: [
	            createObjectProperty(createSimpleExpression(`textContent`, true), exp
	                ? createCallExpression(context.helperString(TO_DISPLAY_STRING), [exp], loc)
	                : createSimpleExpression('', true))
	        ]
	    };
	};

	const transformModel$1 = (dir, node, context) => {
	    const baseResult = transformModel(dir, node, context);
	    // base transform has errors OR component v-model (only need props)
	    if (!baseResult.props.length || node.tagType === 1 /* COMPONENT */) {
	        return baseResult;
	    }
	    if (dir.arg) {
	        context.onError(createDOMCompilerError(54 /* X_V_MODEL_ARG_ON_ELEMENT */, dir.arg.loc));
	    }
	    function checkDuplicatedValue() {
	        const value = findProp(node, 'value');
	        if (value) {
	            context.onError(createDOMCompilerError(56 /* X_V_MODEL_UNNECESSARY_VALUE */, value.loc));
	        }
	    }
	    const { tag } = node;
	    const isCustomElement = context.isCustomElement(tag);
	    if (tag === 'input' ||
	        tag === 'textarea' ||
	        tag === 'select' ||
	        isCustomElement) {
	        let directiveToUse = V_MODEL_TEXT;
	        let isInvalidType = false;
	        if (tag === 'input' || isCustomElement) {
	            const type = findProp(node, `type`);
	            if (type) {
	                if (type.type === 7 /* DIRECTIVE */) {
	                    // :type="foo"
	                    directiveToUse = V_MODEL_DYNAMIC;
	                }
	                else if (type.value) {
	                    switch (type.value.content) {
	                        case 'radio':
	                            directiveToUse = V_MODEL_RADIO;
	                            break;
	                        case 'checkbox':
	                            directiveToUse = V_MODEL_CHECKBOX;
	                            break;
	                        case 'file':
	                            isInvalidType = true;
	                            context.onError(createDOMCompilerError(55 /* X_V_MODEL_ON_FILE_INPUT_ELEMENT */, dir.loc));
	                            break;
	                        default:
	                            // text type
	                             checkDuplicatedValue();
	                            break;
	                    }
	                }
	            }
	            else if (hasDynamicKeyVBind(node)) {
	                // element has bindings with dynamic keys, which can possibly contain
	                // "type".
	                directiveToUse = V_MODEL_DYNAMIC;
	            }
	            else {
	                // text type
	                 checkDuplicatedValue();
	            }
	        }
	        else if (tag === 'select') {
	            directiveToUse = V_MODEL_SELECT;
	        }
	        else {
	            // textarea
	             checkDuplicatedValue();
	        }
	        // inject runtime directive
	        // by returning the helper symbol via needRuntime
	        // the import will replaced a resolveDirective call.
	        if (!isInvalidType) {
	            baseResult.needRuntime = context.helper(directiveToUse);
	        }
	    }
	    else {
	        context.onError(createDOMCompilerError(53 /* X_V_MODEL_ON_INVALID_ELEMENT */, dir.loc));
	    }
	    // native vmodel doesn't need the `modelValue` props since they are also
	    // passed to the runtime as `binding.value`. removing it reduces code size.
	    baseResult.props = baseResult.props.filter(p => !(p.key.type === 4 /* SIMPLE_EXPRESSION */ &&
	        p.key.content === 'modelValue'));
	    return baseResult;
	};

	const isEventOptionModifier = /*#__PURE__*/ makeMap(`passive,once,capture`);
	const isNonKeyModifier = /*#__PURE__*/ makeMap(
	// event propagation management
`stop,prevent,self,`	 +
	    // system modifiers + exact
	    `ctrl,shift,alt,meta,exact,` +
	    // mouse
	    `middle`);
	// left & right could be mouse or key modifiers based on event type
	const maybeKeyModifier = /*#__PURE__*/ makeMap('left,right');
	const isKeyboardEvent = /*#__PURE__*/ makeMap(`onkeyup,onkeydown,onkeypress`, true);
	const resolveModifiers = (key, modifiers) => {
	    const keyModifiers = [];
	    const nonKeyModifiers = [];
	    const eventOptionModifiers = [];
	    for (let i = 0; i < modifiers.length; i++) {
	        const modifier = modifiers[i];
	        if (isEventOptionModifier(modifier)) {
	            // eventOptionModifiers: modifiers for addEventListener() options,
	            // e.g. .passive & .capture
	            eventOptionModifiers.push(modifier);
	        }
	        else {
	            // runtimeModifiers: modifiers that needs runtime guards
	            if (maybeKeyModifier(modifier)) {
	                if (isStaticExp(key)) {
	                    if (isKeyboardEvent(key.content)) {
	                        keyModifiers.push(modifier);
	                    }
	                    else {
	                        nonKeyModifiers.push(modifier);
	                    }
	                }
	                else {
	                    keyModifiers.push(modifier);
	                    nonKeyModifiers.push(modifier);
	                }
	            }
	            else {
	                if (isNonKeyModifier(modifier)) {
	                    nonKeyModifiers.push(modifier);
	                }
	                else {
	                    keyModifiers.push(modifier);
	                }
	            }
	        }
	    }
	    return {
	        keyModifiers,
	        nonKeyModifiers,
	        eventOptionModifiers
	    };
	};
	const transformClick = (key, event) => {
	    const isStaticClick = isStaticExp(key) && key.content.toLowerCase() === 'onclick';
	    return isStaticClick
	        ? createSimpleExpression(event, true)
	        : key.type !== 4 /* SIMPLE_EXPRESSION */
	            ? createCompoundExpression([
	                `(`,
	                key,
	                `) === "onClick" ? "${event}" : (`,
	                key,
	                `)`
	            ])
	            : key;
	};
	const transformOn$1 = (dir, node, context) => {
	    return transformOn(dir, node, context, baseResult => {
	        const { modifiers } = dir;
	        if (!modifiers.length)
	            return baseResult;
	        let { key, value: handlerExp } = baseResult.props[0];
	        const { keyModifiers, nonKeyModifiers, eventOptionModifiers } = resolveModifiers(key, modifiers);
	        // normalize click.right and click.middle since they don't actually fire
	        if (nonKeyModifiers.includes('right')) {
	            key = transformClick(key, `onContextmenu`);
	        }
	        if (nonKeyModifiers.includes('middle')) {
	            key = transformClick(key, `onMouseup`);
	        }
	        if (nonKeyModifiers.length) {
	            handlerExp = createCallExpression(context.helper(V_ON_WITH_MODIFIERS), [
	                handlerExp,
	                JSON.stringify(nonKeyModifiers)
	            ]);
	        }
	        if (keyModifiers.length &&
	            // if event name is dynamic, always wrap with keys guard
	            (!isStaticExp(key) || isKeyboardEvent(key.content))) {
	            handlerExp = createCallExpression(context.helper(V_ON_WITH_KEYS), [
	                handlerExp,
	                JSON.stringify(keyModifiers)
	            ]);
	        }
	        if (eventOptionModifiers.length) {
	            const modifierPostfix = eventOptionModifiers.map(capitalize).join('');
	            key = isStaticExp(key)
	                ? createSimpleExpression(`${key.content}${modifierPostfix}`, true)
	                : createCompoundExpression([`(`, key, `) + "${modifierPostfix}"`]);
	        }
	        return {
	            props: [createObjectProperty(key, handlerExp)]
	        };
	    });
	};

	const transformShow = (dir, node, context) => {
	    const { exp, loc } = dir;
	    if (!exp) {
	        context.onError(createDOMCompilerError(57 /* X_V_SHOW_NO_EXPRESSION */, loc));
	    }
	    return {
	        props: [],
	        needRuntime: context.helper(V_SHOW)
	    };
	};

	const warnTransitionChildren = (node, context) => {
	    if (node.type === 1 /* ELEMENT */ &&
	        node.tagType === 1 /* COMPONENT */) {
	        const component = context.isBuiltInComponent(node.tag);
	        if (component === TRANSITION$1) {
	            return () => {
	                if (node.children.length && hasMultipleChildren(node)) {
	                    context.onError(createDOMCompilerError(58 /* X_TRANSITION_INVALID_CHILDREN */, {
	                        start: node.children[0].loc.start,
	                        end: node.children[node.children.length - 1].loc.end,
	                        source: ''
	                    }));
	                }
	            };
	        }
	    }
	};
	function hasMultipleChildren(node) {
	    // #1352 filter out potential comment nodes.
	    const children = (node.children = node.children.filter(c => c.type !== 3 /* COMMENT */));
	    const child = children[0];
	    return (children.length !== 1 ||
	        child.type === 11 /* FOR */ ||
	        (child.type === 9 /* IF */ && child.branches.some(hasMultipleChildren)));
	}

	const ignoreSideEffectTags = (node, context) => {
	    if (node.type === 1 /* ELEMENT */ &&
	        node.tagType === 0 /* ELEMENT */ &&
	        (node.tag === 'script' || node.tag === 'style')) {
	        context.onError(createDOMCompilerError(59 /* X_IGNORED_SIDE_EFFECT_TAG */, node.loc));
	        context.removeNode();
	    }
	};

	const DOMNodeTransforms = [
	    transformStyle,
	    ...( [warnTransitionChildren] )
	];
	const DOMDirectiveTransforms = {
	    cloak: noopDirectiveTransform,
	    html: transformVHtml,
	    text: transformVText,
	    model: transformModel$1,
	    on: transformOn$1,
	    show: transformShow
	};
	function compile$1(template, options = {}) {
	    return baseCompile(template, extend({}, parserOptions, options, {
	        nodeTransforms: [
	            // ignore <script> and <tag>
	            // this is not put inside DOMNodeTransforms because that list is used
	            // by compiler-ssr to generate vnode fallback branches
	            ignoreSideEffectTags,
	            ...DOMNodeTransforms,
	            ...(options.nodeTransforms || [])
	        ],
	        directiveTransforms: extend({}, DOMDirectiveTransforms, options.directiveTransforms || {}),
	        transformHoist:  null 
	    }));
	}

	function initDev() {
	    const target = getGlobalThis();
	    target.__VUE__ = true;
	    setDevtoolsHook(target.__VUE_DEVTOOLS_GLOBAL_HOOK__);
	    {
	        initCustomFormatter();
	    }
	}

	// This entry is the "full-build" that includes both the runtime
	 initDev();
	const compileCache = Object.create(null);
	function compileToFunction(template, options) {
	    if (!isString(template)) {
	        if (template.nodeType) {
	            template = template.innerHTML;
	        }
	        else {
	             warn(`invalid template option: `, template);
	            return NOOP;
	        }
	    }
	    const key = template;
	    const cached = compileCache[key];
	    if (cached) {
	        return cached;
	    }
	    if (template[0] === '#') {
	        const el = document.querySelector(template);
	        if ( !el) {
	            warn(`Template element not found or is empty: ${template}`);
	        }
	        // __UNSAFE__
	        // Reason: potential execution of JS expressions in in-DOM template.
	        // The user must make sure the in-DOM template is trusted. If it's rendered
	        // by the server, the template should not contain any user data.
	        template = el ? el.innerHTML : ``;
	    }
	    const { code } = compile$1(template, extend({
	        hoistStatic: true,
	        onError(err) {
	            {
	                const message = `Template compilation error: ${err.message}`;
	                const codeFrame = err.loc &&
	                    generateCodeFrame(template, err.loc.start.offset, err.loc.end.offset);
	                warn(codeFrame ? `${message}\n${codeFrame}` : message);
	            }
	        }
	    }, options));
	    // The wildcard import results in a huge object with every export
	    // with keys that cannot be mangled, and can be quite heavy size-wise.
	    // In the global build we know `Vue` is available globally so we can avoid
	    // the wildcard object.
	    const render = ( new Function('Vue', code)(runtimeDom));
	    render._rc = true;
	    return (compileCache[key] = render);
	}
	registerRuntimeCompiler(compileToFunction);

	var vue_esmBundler = /*#__PURE__*/Object.freeze({
		__proto__: null,
		compile: compileToFunction,
		customRef: customRef,
		isProxy: isProxy,
		isReactive: isReactive,
		isReadonly: isReadonly,
		isRef: isRef,
		markRaw: markRaw,
		proxyRefs: proxyRefs,
		reactive: reactive,
		readonly: readonly,
		ref: ref,
		shallowReactive: shallowReactive,
		shallowReadonly: shallowReadonly,
		shallowRef: shallowRef,
		toRaw: toRaw,
		toRef: toRef,
		toRefs: toRefs,
		triggerRef: triggerRef,
		unref: unref,
		camelize: camelize,
		capitalize: capitalize,
		toDisplayString: toDisplayString,
		toHandlerKey: toHandlerKey,
		BaseTransition: BaseTransition,
		Comment: Comment,
		Fragment: Fragment,
		KeepAlive: KeepAlive,
		Static: Static,
		Suspense: Suspense,
		Teleport: Teleport,
		Text: Text,
		callWithAsyncErrorHandling: callWithAsyncErrorHandling,
		callWithErrorHandling: callWithErrorHandling,
		cloneVNode: cloneVNode,
		computed: computed$1,
		createBlock: createBlock,
		createCommentVNode: createCommentVNode,
		createHydrationRenderer: createHydrationRenderer,
		createRenderer: createRenderer,
		createSlots: createSlots,
		createStaticVNode: createStaticVNode,
		createTextVNode: createTextVNode,
		createVNode: createVNode,
		defineAsyncComponent: defineAsyncComponent,
		defineComponent: defineComponent,
		defineEmit: defineEmit,
		defineProps: defineProps,
		get devtools () { return devtools; },
		getCurrentInstance: getCurrentInstance,
		getTransitionRawChildren: getTransitionRawChildren,
		h: h,
		handleError: handleError,
		initCustomFormatter: initCustomFormatter,
		inject: inject,
		isVNode: isVNode,
		mergeProps: mergeProps,
		nextTick: nextTick,
		onActivated: onActivated,
		onBeforeMount: onBeforeMount,
		onBeforeUnmount: onBeforeUnmount,
		onBeforeUpdate: onBeforeUpdate,
		onDeactivated: onDeactivated,
		onErrorCaptured: onErrorCaptured,
		onMounted: onMounted,
		onRenderTracked: onRenderTracked,
		onRenderTriggered: onRenderTriggered,
		onUnmounted: onUnmounted,
		onUpdated: onUpdated,
		openBlock: openBlock,
		popScopeId: popScopeId,
		provide: provide,
		pushScopeId: pushScopeId,
		queuePostFlushCb: queuePostFlushCb,
		registerRuntimeCompiler: registerRuntimeCompiler,
		renderList: renderList,
		renderSlot: renderSlot,
		resolveComponent: resolveComponent,
		resolveDirective: resolveDirective,
		resolveDynamicComponent: resolveDynamicComponent,
		resolveTransitionHooks: resolveTransitionHooks,
		setBlockTracking: setBlockTracking,
		setDevtoolsHook: setDevtoolsHook,
		setTransitionHooks: setTransitionHooks,
		ssrContextKey: ssrContextKey,
		ssrUtils: ssrUtils,
		toHandlers: toHandlers,
		transformVNodeArgs: transformVNodeArgs,
		useContext: useContext,
		useSSRContext: useSSRContext,
		useTransitionState: useTransitionState,
		version: version,
		warn: warn,
		watch: watch,
		watchEffect: watchEffect,
		withCtx: withCtx,
		withDirectives: withDirectives,
		withScopeId: withScopeId,
		Transition: Transition,
		TransitionGroup: TransitionGroup,
		createApp: createApp,
		createSSRApp: createSSRApp,
		hydrate: hydrate,
		render: render,
		useCssModule: useCssModule,
		useCssVars: useCssVars,
		vModelCheckbox: vModelCheckbox,
		vModelDynamic: vModelDynamic,
		vModelRadio: vModelRadio,
		vModelSelect: vModelSelect,
		vModelText: vModelText,
		vShow: vShow,
		withKeys: withKeys,
		withModifiers: withModifiers
	});

	var vue = /*@__PURE__*/getAugmentedNamespace(vue_esmBundler);

	/*!
	 * vuex v4.0.0-rc.2
	 * (c) 2020 Evan You
	 * @license MIT
	 */



	var storeKey = 'store';

	function useStore (key) {
	  if ( key === void 0 ) key = null;

	  return vue.inject(key !== null ? key : storeKey)
	}

	var target = typeof window !== 'undefined'
	  ? window
	  : typeof commonjsGlobal !== 'undefined'
	    ? commonjsGlobal
	    : {};
	var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

	function devtoolPlugin (store) {
	  if (!devtoolHook) { return }

	  store._devtoolHook = devtoolHook;

	  devtoolHook.emit('vuex:init', store);

	  devtoolHook.on('vuex:travel-to-state', function (targetState) {
	    store.replaceState(targetState);
	  });

	  store.subscribe(function (mutation, state) {
	    devtoolHook.emit('vuex:mutation', mutation, state);
	  }, { prepend: true });

	  store.subscribeAction(function (action, state) {
	    devtoolHook.emit('vuex:action', action, state);
	  }, { prepend: true });
	}

	/**
	 * Get the first item that pass the test
	 * by second argument function
	 *
	 * @param {Array} list
	 * @param {Function} f
	 * @return {*}
	 */
	function find (list, f) {
	  return list.filter(f)[0]
	}

	/**
	 * Deep copy the given object considering circular structure.
	 * This function caches all nested objects and its copies.
	 * If it detects circular structure, use cached copy to avoid infinite loop.
	 *
	 * @param {*} obj
	 * @param {Array<Object>} cache
	 * @return {*}
	 */
	function deepCopy (obj, cache) {
	  if ( cache === void 0 ) cache = [];

	  // just return if obj is immutable value
	  if (obj === null || typeof obj !== 'object') {
	    return obj
	  }

	  // if obj is hit, it is in circular structure
	  var hit = find(cache, function (c) { return c.original === obj; });
	  if (hit) {
	    return hit.copy
	  }

	  var copy = Array.isArray(obj) ? [] : {};
	  // put the copy into cache at first
	  // because we want to refer it in recursive deepCopy
	  cache.push({
	    original: obj,
	    copy: copy
	  });

	  Object.keys(obj).forEach(function (key) {
	    copy[key] = deepCopy(obj[key], cache);
	  });

	  return copy
	}

	/**
	 * forEach for object
	 */
	function forEachValue (obj, fn) {
	  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
	}

	function isObject$1 (obj) {
	  return obj !== null && typeof obj === 'object'
	}

	function isPromise$1 (val) {
	  return val && typeof val.then === 'function'
	}

	function assert$1 (condition, msg) {
	  if (!condition) { throw new Error(("[vuex] " + msg)) }
	}

	function partial (fn, arg) {
	  return function () {
	    return fn(arg)
	  }
	}

	// Base data struct for store's module, package with some attribute and method
	var Module = function Module (rawModule, runtime) {
	  this.runtime = runtime;
	  // Store some children item
	  this._children = Object.create(null);
	  // Store the origin module object which passed by programmer
	  this._rawModule = rawModule;
	  var rawState = rawModule.state;

	  // Store the origin module's state
	  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
	};

	var prototypeAccessors = { namespaced: { configurable: true } };

	prototypeAccessors.namespaced.get = function () {
	  return !!this._rawModule.namespaced
	};

	Module.prototype.addChild = function addChild (key, module) {
	  this._children[key] = module;
	};

	Module.prototype.removeChild = function removeChild (key) {
	  delete this._children[key];
	};

	Module.prototype.getChild = function getChild (key) {
	  return this._children[key]
	};

	Module.prototype.hasChild = function hasChild (key) {
	  return key in this._children
	};

	Module.prototype.update = function update (rawModule) {
	  this._rawModule.namespaced = rawModule.namespaced;
	  if (rawModule.actions) {
	    this._rawModule.actions = rawModule.actions;
	  }
	  if (rawModule.mutations) {
	    this._rawModule.mutations = rawModule.mutations;
	  }
	  if (rawModule.getters) {
	    this._rawModule.getters = rawModule.getters;
	  }
	};

	Module.prototype.forEachChild = function forEachChild (fn) {
	  forEachValue(this._children, fn);
	};

	Module.prototype.forEachGetter = function forEachGetter (fn) {
	  if (this._rawModule.getters) {
	    forEachValue(this._rawModule.getters, fn);
	  }
	};

	Module.prototype.forEachAction = function forEachAction (fn) {
	  if (this._rawModule.actions) {
	    forEachValue(this._rawModule.actions, fn);
	  }
	};

	Module.prototype.forEachMutation = function forEachMutation (fn) {
	  if (this._rawModule.mutations) {
	    forEachValue(this._rawModule.mutations, fn);
	  }
	};

	Object.defineProperties( Module.prototype, prototypeAccessors );

	var ModuleCollection = function ModuleCollection (rawRootModule) {
	  // register root module (Vuex.Store options)
	  this.register([], rawRootModule, false);
	};

	ModuleCollection.prototype.get = function get (path) {
	  return path.reduce(function (module, key) {
	    return module.getChild(key)
	  }, this.root)
	};

	ModuleCollection.prototype.getNamespace = function getNamespace (path) {
	  var module = this.root;
	  return path.reduce(function (namespace, key) {
	    module = module.getChild(key);
	    return namespace + (module.namespaced ? key + '/' : '')
	  }, '')
	};

	ModuleCollection.prototype.update = function update$1 (rawRootModule) {
	  update([], this.root, rawRootModule);
	};

	ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
	    var this$1 = this;
	    if ( runtime === void 0 ) runtime = true;

	  {
	    assertRawModule(path, rawModule);
	  }

	  var newModule = new Module(rawModule, runtime);
	  if (path.length === 0) {
	    this.root = newModule;
	  } else {
	    var parent = this.get(path.slice(0, -1));
	    parent.addChild(path[path.length - 1], newModule);
	  }

	  // register nested modules
	  if (rawModule.modules) {
	    forEachValue(rawModule.modules, function (rawChildModule, key) {
	      this$1.register(path.concat(key), rawChildModule, runtime);
	    });
	  }
	};

	ModuleCollection.prototype.unregister = function unregister (path) {
	  var parent = this.get(path.slice(0, -1));
	  var key = path[path.length - 1];
	  var child = parent.getChild(key);

	  if (!child) {
	    {
	      console.warn(
	        "[vuex] trying to unregister module '" + key + "', which is " +
	        "not registered"
	      );
	    }
	    return
	  }

	  if (!child.runtime) {
	    return
	  }

	  parent.removeChild(key);
	};

	ModuleCollection.prototype.isRegistered = function isRegistered (path) {
	  var parent = this.get(path.slice(0, -1));
	  var key = path[path.length - 1];

	  if (parent) {
	    return parent.hasChild(key)
	  }

	  return false
	};

	function update (path, targetModule, newModule) {
	  {
	    assertRawModule(path, newModule);
	  }

	  // update target module
	  targetModule.update(newModule);

	  // update nested modules
	  if (newModule.modules) {
	    for (var key in newModule.modules) {
	      if (!targetModule.getChild(key)) {
	        {
	          console.warn(
	            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
	            'manual reload is needed'
	          );
	        }
	        return
	      }
	      update(
	        path.concat(key),
	        targetModule.getChild(key),
	        newModule.modules[key]
	      );
	    }
	  }
	}

	var functionAssert = {
	  assert: function (value) { return typeof value === 'function'; },
	  expected: 'function'
	};

	var objectAssert = {
	  assert: function (value) { return typeof value === 'function' ||
	    (typeof value === 'object' && typeof value.handler === 'function'); },
	  expected: 'function or object with "handler" function'
	};

	var assertTypes = {
	  getters: functionAssert,
	  mutations: functionAssert,
	  actions: objectAssert
	};

	function assertRawModule (path, rawModule) {
	  Object.keys(assertTypes).forEach(function (key) {
	    if (!rawModule[key]) { return }

	    var assertOptions = assertTypes[key];

	    forEachValue(rawModule[key], function (value, type) {
	      assert$1(
	        assertOptions.assert(value),
	        makeAssertionMessage(path, key, type, value, assertOptions.expected)
	      );
	    });
	  });
	}

	function makeAssertionMessage (path, key, type, value, expected) {
	  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
	  if (path.length > 0) {
	    buf += " in module \"" + (path.join('.')) + "\"";
	  }
	  buf += " is " + (JSON.stringify(value)) + ".";
	  return buf
	}

	function createStore (options) {
	  return new Store(options)
	}

	var Store = function Store (options) {
	  var this$1 = this;
	  if ( options === void 0 ) options = {};

	  {
	    assert$1(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
	    assert$1(this instanceof Store, "store must be called with the new operator.");
	  }

	  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
	  var strict = options.strict; if ( strict === void 0 ) strict = false;

	  // store internal state
	  this._committing = false;
	  this._actions = Object.create(null);
	  this._actionSubscribers = [];
	  this._mutations = Object.create(null);
	  this._wrappedGetters = Object.create(null);
	  this._modules = new ModuleCollection(options);
	  this._modulesNamespaceMap = Object.create(null);
	  this._subscribers = [];
	  this._makeLocalGettersCache = Object.create(null);

	  // bind commit and dispatch to self
	  var store = this;
	  var ref = this;
	  var dispatch = ref.dispatch;
	  var commit = ref.commit;
	  this.dispatch = function boundDispatch (type, payload) {
	    return dispatch.call(store, type, payload)
	  };
	  this.commit = function boundCommit (type, payload, options) {
	    return commit.call(store, type, payload, options)
	  };

	  // strict mode
	  this.strict = strict;

	  var state = this._modules.root.state;

	  // init root module.
	  // this also recursively registers all sub-modules
	  // and collects all module getters inside this._wrappedGetters
	  installModule(this, state, [], this._modules.root);

	  // initialize the store state, which is responsible for the reactivity
	  // (also registers _wrappedGetters as computed properties)
	  resetStoreState(this, state);

	  // apply plugins
	  plugins.forEach(function (plugin) { return plugin(this$1); });

	  var useDevtools = options.devtools !== undefined ? options.devtools : /* Vue.config.devtools */ true;
	  if (useDevtools) {
	    devtoolPlugin(this);
	  }
	};

	var prototypeAccessors$1 = { state: { configurable: true } };

	Store.prototype.install = function install (app, injectKey) {
	  app.provide(injectKey || storeKey, this);
	  app.config.globalProperties.$store = this;
	};

	prototypeAccessors$1.state.get = function () {
	  return this._state.data
	};

	prototypeAccessors$1.state.set = function (v) {
	  {
	    assert$1(false, "use store.replaceState() to explicit replace store state.");
	  }
	};

	Store.prototype.commit = function commit (_type, _payload, _options) {
	    var this$1 = this;

	  // check object-style commit
	  var ref = unifyObjectStyle(_type, _payload, _options);
	    var type = ref.type;
	    var payload = ref.payload;
	    var options = ref.options;

	  var mutation = { type: type, payload: payload };
	  var entry = this._mutations[type];
	  if (!entry) {
	    {
	      console.error(("[vuex] unknown mutation type: " + type));
	    }
	    return
	  }
	  this._withCommit(function () {
	    entry.forEach(function commitIterator (handler) {
	      handler(payload);
	    });
	  });

	  this._subscribers
	    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
	    .forEach(function (sub) { return sub(mutation, this$1.state); });

	  if (
	    
	    options && options.silent
	  ) {
	    console.warn(
	      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
	      'Use the filter functionality in the vue-devtools'
	    );
	  }
	};

	Store.prototype.dispatch = function dispatch (_type, _payload) {
	    var this$1 = this;

	  // check object-style dispatch
	  var ref = unifyObjectStyle(_type, _payload);
	    var type = ref.type;
	    var payload = ref.payload;

	  var action = { type: type, payload: payload };
	  var entry = this._actions[type];
	  if (!entry) {
	    {
	      console.error(("[vuex] unknown action type: " + type));
	    }
	    return
	  }

	  try {
	    this._actionSubscribers
	      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
	      .filter(function (sub) { return sub.before; })
	      .forEach(function (sub) { return sub.before(action, this$1.state); });
	  } catch (e) {
	    {
	      console.warn("[vuex] error in before action subscribers: ");
	      console.error(e);
	    }
	  }

	  var result = entry.length > 1
	    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
	    : entry[0](payload);

	  return new Promise(function (resolve, reject) {
	    result.then(function (res) {
	      try {
	        this$1._actionSubscribers
	          .filter(function (sub) { return sub.after; })
	          .forEach(function (sub) { return sub.after(action, this$1.state); });
	      } catch (e) {
	        {
	          console.warn("[vuex] error in after action subscribers: ");
	          console.error(e);
	        }
	      }
	      resolve(res);
	    }, function (error) {
	      try {
	        this$1._actionSubscribers
	          .filter(function (sub) { return sub.error; })
	          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
	      } catch (e) {
	        {
	          console.warn("[vuex] error in error action subscribers: ");
	          console.error(e);
	        }
	      }
	      reject(error);
	    });
	  })
	};

	Store.prototype.subscribe = function subscribe (fn, options) {
	  return genericSubscribe(fn, this._subscribers, options)
	};

	Store.prototype.subscribeAction = function subscribeAction (fn, options) {
	  var subs = typeof fn === 'function' ? { before: fn } : fn;
	  return genericSubscribe(subs, this._actionSubscribers, options)
	};

	Store.prototype.watch = function watch$1 (getter, cb, options) {
	    var this$1 = this;

	  {
	    assert$1(typeof getter === 'function', "store.watch only accepts a function.");
	  }
	  return vue.watch(function () { return getter(this$1.state, this$1.getters); }, cb, Object.assign({}, options))
	};

	Store.prototype.replaceState = function replaceState (state) {
	    var this$1 = this;

	  this._withCommit(function () {
	    this$1._state.data = state;
	  });
	};

	Store.prototype.registerModule = function registerModule (path, rawModule, options) {
	    if ( options === void 0 ) options = {};

	  if (typeof path === 'string') { path = [path]; }

	  {
	    assert$1(Array.isArray(path), "module path must be a string or an Array.");
	    assert$1(path.length > 0, 'cannot register the root module by using registerModule.');
	  }

	  this._modules.register(path, rawModule);
	  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
	  // reset store to update getters...
	  resetStoreState(this, this.state);
	};

	Store.prototype.unregisterModule = function unregisterModule (path) {
	    var this$1 = this;

	  if (typeof path === 'string') { path = [path]; }

	  {
	    assert$1(Array.isArray(path), "module path must be a string or an Array.");
	  }

	  this._modules.unregister(path);
	  this._withCommit(function () {
	    var parentState = getNestedState(this$1.state, path.slice(0, -1));
	    delete parentState[path[path.length - 1]];
	  });
	  resetStore(this);
	};

	Store.prototype.hasModule = function hasModule (path) {
	  if (typeof path === 'string') { path = [path]; }

	  {
	    assert$1(Array.isArray(path), "module path must be a string or an Array.");
	  }

	  return this._modules.isRegistered(path)
	};

	Store.prototype.hotUpdate = function hotUpdate (newOptions) {
	  this._modules.update(newOptions);
	  resetStore(this, true);
	};

	Store.prototype._withCommit = function _withCommit (fn) {
	  var committing = this._committing;
	  this._committing = true;
	  fn();
	  this._committing = committing;
	};

	Object.defineProperties( Store.prototype, prototypeAccessors$1 );

	function genericSubscribe (fn, subs, options) {
	  if (subs.indexOf(fn) < 0) {
	    options && options.prepend
	      ? subs.unshift(fn)
	      : subs.push(fn);
	  }
	  return function () {
	    var i = subs.indexOf(fn);
	    if (i > -1) {
	      subs.splice(i, 1);
	    }
	  }
	}

	function resetStore (store, hot) {
	  store._actions = Object.create(null);
	  store._mutations = Object.create(null);
	  store._wrappedGetters = Object.create(null);
	  store._modulesNamespaceMap = Object.create(null);
	  var state = store.state;
	  // init all modules
	  installModule(store, state, [], store._modules.root, true);
	  // reset state
	  resetStoreState(store, state, hot);
	}

	function resetStoreState (store, state, hot) {
	  var oldState = store._state;

	  // bind store public getters
	  store.getters = {};
	  // reset local getters cache
	  store._makeLocalGettersCache = Object.create(null);
	  var wrappedGetters = store._wrappedGetters;
	  var computedObj = {};
	  forEachValue(wrappedGetters, function (fn, key) {
	    // use computed to leverage its lazy-caching mechanism
	    // direct inline function use will lead to closure preserving oldState.
	    // using partial to return function with only arguments preserved in closure environment.
	    computedObj[key] = partial(fn, store);
	    Object.defineProperty(store.getters, key, {
	      // TODO: use `computed` when it's possible. at the moment we can't due to
	      // https://github.com/vuejs/vuex/pull/1883
	      get: function () { return computedObj[key](); },
	      enumerable: true // for local getters
	    });
	  });

	  store._state = vue.reactive({
	    data: state
	  });

	  // enable strict mode for new state
	  if (store.strict) {
	    enableStrictMode(store);
	  }

	  if (oldState) {
	    if (hot) {
	      // dispatch changes in all subscribed watchers
	      // to force getter re-evaluation for hot reloading.
	      store._withCommit(function () {
	        oldState.data = null;
	      });
	    }
	  }
	}

	function installModule (store, rootState, path, module, hot) {
	  var isRoot = !path.length;
	  var namespace = store._modules.getNamespace(path);

	  // register in namespace map
	  if (module.namespaced) {
	    if (store._modulesNamespaceMap[namespace] && ("development" !== 'production')) {
	      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
	    }
	    store._modulesNamespaceMap[namespace] = module;
	  }

	  // set state
	  if (!isRoot && !hot) {
	    var parentState = getNestedState(rootState, path.slice(0, -1));
	    var moduleName = path[path.length - 1];
	    store._withCommit(function () {
	      {
	        if (moduleName in parentState) {
	          console.warn(
	            ("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + (path.join('.')) + "\"")
	          );
	        }
	      }
	      parentState[moduleName] = module.state;
	    });
	  }

	  var local = module.context = makeLocalContext(store, namespace, path);

	  module.forEachMutation(function (mutation, key) {
	    var namespacedType = namespace + key;
	    registerMutation(store, namespacedType, mutation, local);
	  });

	  module.forEachAction(function (action, key) {
	    var type = action.root ? key : namespace + key;
	    var handler = action.handler || action;
	    registerAction(store, type, handler, local);
	  });

	  module.forEachGetter(function (getter, key) {
	    var namespacedType = namespace + key;
	    registerGetter(store, namespacedType, getter, local);
	  });

	  module.forEachChild(function (child, key) {
	    installModule(store, rootState, path.concat(key), child, hot);
	  });
	}

	/**
	 * make localized dispatch, commit, getters and state
	 * if there is no namespace, just use root ones
	 */
	function makeLocalContext (store, namespace, path) {
	  var noNamespace = namespace === '';

	  var local = {
	    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;

	      if (!options || !options.root) {
	        type = namespace + type;
	        if ( !store._actions[type]) {
	          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }

	      return store.dispatch(type, payload)
	    },

	    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;

	      if (!options || !options.root) {
	        type = namespace + type;
	        if ( !store._mutations[type]) {
	          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }

	      store.commit(type, payload, options);
	    }
	  };

	  // getters and state object must be gotten lazily
	  // because they will be changed by state update
	  Object.defineProperties(local, {
	    getters: {
	      get: noNamespace
	        ? function () { return store.getters; }
	        : function () { return makeLocalGetters(store, namespace); }
	    },
	    state: {
	      get: function () { return getNestedState(store.state, path); }
	    }
	  });

	  return local
	}

	function makeLocalGetters (store, namespace) {
	  if (!store._makeLocalGettersCache[namespace]) {
	    var gettersProxy = {};
	    var splitPos = namespace.length;
	    Object.keys(store.getters).forEach(function (type) {
	      // skip if the target getter is not match this namespace
	      if (type.slice(0, splitPos) !== namespace) { return }

	      // extract local getter type
	      var localType = type.slice(splitPos);

	      // Add a port to the getters proxy.
	      // Define as getter property because
	      // we do not want to evaluate the getters in this time.
	      Object.defineProperty(gettersProxy, localType, {
	        get: function () { return store.getters[type]; },
	        enumerable: true
	      });
	    });
	    store._makeLocalGettersCache[namespace] = gettersProxy;
	  }

	  return store._makeLocalGettersCache[namespace]
	}

	function registerMutation (store, type, handler, local) {
	  var entry = store._mutations[type] || (store._mutations[type] = []);
	  entry.push(function wrappedMutationHandler (payload) {
	    handler.call(store, local.state, payload);
	  });
	}

	function registerAction (store, type, handler, local) {
	  var entry = store._actions[type] || (store._actions[type] = []);
	  entry.push(function wrappedActionHandler (payload) {
	    var res = handler.call(store, {
	      dispatch: local.dispatch,
	      commit: local.commit,
	      getters: local.getters,
	      state: local.state,
	      rootGetters: store.getters,
	      rootState: store.state
	    }, payload);
	    if (!isPromise$1(res)) {
	      res = Promise.resolve(res);
	    }
	    if (store._devtoolHook) {
	      return res.catch(function (err) {
	        store._devtoolHook.emit('vuex:error', err);
	        throw err
	      })
	    } else {
	      return res
	    }
	  });
	}

	function registerGetter (store, type, rawGetter, local) {
	  if (store._wrappedGetters[type]) {
	    {
	      console.error(("[vuex] duplicate getter key: " + type));
	    }
	    return
	  }
	  store._wrappedGetters[type] = function wrappedGetter (store) {
	    return rawGetter(
	      local.state, // local state
	      local.getters, // local getters
	      store.state, // root state
	      store.getters // root getters
	    )
	  };
	}

	function enableStrictMode (store) {
	  vue.watch(function () { return store._state.data; }, function () {
	    {
	      assert$1(store._committing, "do not mutate vuex store state outside mutation handlers.");
	    }
	  }, { deep: true, flush: 'sync' });
	}

	function getNestedState (state, path) {
	  return path.reduce(function (state, key) { return state[key]; }, state)
	}

	function unifyObjectStyle (type, payload, options) {
	  if (isObject$1(type) && type.type) {
	    options = payload;
	    payload = type;
	    type = type.type;
	  }

	  {
	    assert$1(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
	  }

	  return { type: type, payload: payload, options: options }
	}

	/**
	 * Reduce the code which written in Vue.js for getting the state.
	 * @param {String} [namespace] - Module's namespace
	 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
	 * @param {Object}
	 */
	var mapState = normalizeNamespace(function (namespace, states) {
	  var res = {};
	  if ( !isValidMap(states)) {
	    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
	  }
	  normalizeMap(states).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;

	    res[key] = function mappedState () {
	      var state = this.$store.state;
	      var getters = this.$store.getters;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
	        if (!module) {
	          return
	        }
	        state = module.context.state;
	        getters = module.context.getters;
	      }
	      return typeof val === 'function'
	        ? val.call(this, state, getters)
	        : state[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});

	/**
	 * Reduce the code which written in Vue.js for committing the mutation
	 * @param {String} [namespace] - Module's namespace
	 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept anthor params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
	 * @return {Object}
	 */
	var mapMutations = normalizeNamespace(function (namespace, mutations) {
	  var res = {};
	  if ( !isValidMap(mutations)) {
	    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
	  }
	  normalizeMap(mutations).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;

	    res[key] = function mappedMutation () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];

	      // Get the commit method from store
	      var commit = this.$store.commit;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
	        if (!module) {
	          return
	        }
	        commit = module.context.commit;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [commit].concat(args))
	        : commit.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});

	/**
	 * Reduce the code which written in Vue.js for getting the getters
	 * @param {String} [namespace] - Module's namespace
	 * @param {Object|Array} getters
	 * @return {Object}
	 */
	var mapGetters = normalizeNamespace(function (namespace, getters) {
	  var res = {};
	  if ( !isValidMap(getters)) {
	    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
	  }
	  normalizeMap(getters).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;

	    // The namespace has been mutated by normalizeNamespace
	    val = namespace + val;
	    res[key] = function mappedGetter () {
	      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
	        return
	      }
	      if ( !(val in this.$store.getters)) {
	        console.error(("[vuex] unknown getter: " + val));
	        return
	      }
	      return this.$store.getters[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});

	/**
	 * Reduce the code which written in Vue.js for dispatch the action
	 * @param {String} [namespace] - Module's namespace
	 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
	 * @return {Object}
	 */
	var mapActions = normalizeNamespace(function (namespace, actions) {
	  var res = {};
	  if ( !isValidMap(actions)) {
	    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
	  }
	  normalizeMap(actions).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;

	    res[key] = function mappedAction () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];

	      // get dispatch function from store
	      var dispatch = this.$store.dispatch;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
	        if (!module) {
	          return
	        }
	        dispatch = module.context.dispatch;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [dispatch].concat(args))
	        : dispatch.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});

	/**
	 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
	 * @param {String} namespace
	 * @return {Object}
	 */
	var createNamespacedHelpers = function (namespace) { return ({
	  mapState: mapState.bind(null, namespace),
	  mapGetters: mapGetters.bind(null, namespace),
	  mapMutations: mapMutations.bind(null, namespace),
	  mapActions: mapActions.bind(null, namespace)
	}); };

	/**
	 * Normalize the map
	 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
	 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
	 * @param {Array|Object} map
	 * @return {Object}
	 */
	function normalizeMap (map) {
	  if (!isValidMap(map)) {
	    return []
	  }
	  return Array.isArray(map)
	    ? map.map(function (key) { return ({ key: key, val: key }); })
	    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
	}

	/**
	 * Validate whether given map is valid or not
	 * @param {*} map
	 * @return {Boolean}
	 */
	function isValidMap (map) {
	  return Array.isArray(map) || isObject$1(map)
	}

	/**
	 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
	 * @param {Function} fn
	 * @return {Function}
	 */
	function normalizeNamespace (fn) {
	  return function (namespace, map) {
	    if (typeof namespace !== 'string') {
	      map = namespace;
	      namespace = '';
	    } else if (namespace.charAt(namespace.length - 1) !== '/') {
	      namespace += '/';
	    }
	    return fn(namespace, map)
	  }
	}

	/**
	 * Search a special module from store by namespace. if module not exist, print error message.
	 * @param {Object} store
	 * @param {String} helper
	 * @param {String} namespace
	 * @return {Object}
	 */
	function getModuleByNamespace (store, helper, namespace) {
	  var module = store._modulesNamespaceMap[namespace];
	  if ( !module) {
	    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
	  }
	  return module
	}

	// Credits: borrowed code from fcomb/redux-logger

	function createLogger (ref) {
	  if ( ref === void 0 ) ref = {};
	  var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
	  var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
	  var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
	  var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
	  var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
	  var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
	  var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
	  var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
	  var logger = ref.logger; if ( logger === void 0 ) logger = console;

	  return function (store) {
	    var prevState = deepCopy(store.state);

	    if (typeof logger === 'undefined') {
	      return
	    }

	    if (logMutations) {
	      store.subscribe(function (mutation, state) {
	        var nextState = deepCopy(state);

	        if (filter(mutation, prevState, nextState)) {
	          var formattedTime = getFormattedTime();
	          var formattedMutation = mutationTransformer(mutation);
	          var message = "mutation " + (mutation.type) + formattedTime;

	          startMessage(logger, message, collapsed);
	          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
	          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
	          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
	          endMessage(logger);
	        }

	        prevState = nextState;
	      });
	    }

	    if (logActions) {
	      store.subscribeAction(function (action, state) {
	        if (actionFilter(action, state)) {
	          var formattedTime = getFormattedTime();
	          var formattedAction = actionTransformer(action);
	          var message = "action " + (action.type) + formattedTime;

	          startMessage(logger, message, collapsed);
	          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
	          endMessage(logger);
	        }
	      });
	    }
	  }
	}

	function startMessage (logger, message, collapsed) {
	  var startMessage = collapsed
	    ? logger.groupCollapsed
	    : logger.group;

	  // render
	  try {
	    startMessage.call(logger, message);
	  } catch (e) {
	    logger.log(message);
	  }
	}

	function endMessage (logger) {
	  try {
	    logger.groupEnd();
	  } catch (e) {
	    logger.log('—— log end ——');
	  }
	}

	function getFormattedTime () {
	  var time = new Date();
	  return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
	}

	function repeat (str, times) {
	  return (new Array(times + 1)).join(str)
	}

	function pad (num, maxLength) {
	  return repeat('0', maxLength - num.toString().length) + num
	}

	var index_cjs = {
	  version: '4.0.0-rc.2',
	  createStore: createStore,
	  Store: Store,
	  useStore: useStore,
	  mapState: mapState,
	  mapMutations: mapMutations,
	  mapGetters: mapGetters,
	  mapActions: mapActions,
	  createNamespacedHelpers: createNamespacedHelpers,
	  createLogger: createLogger
	};

	var vuex_cjs = index_cjs;

	const {
	  version: version$1,
	  createStore: createStore$1,
	  Store: Store$1,
	  install,
	  useStore: useStore$1,
	  mapState: mapState$1,
	  mapMutations: mapMutations$1,
	  mapGetters: mapGetters$1,
	  mapActions: mapActions$1,
	  createNamespacedHelpers: createNamespacedHelpers$1,
	  createLogger: createLogger$1
	} = vuex_cjs;

	var basket = {
		namespaced: true,

		state: {
			bxajaxid: null,
			remote: null,
			link: null,
			items: [],
			loading: false
		},

		getters: {
			basketPrice(state) {
				if (state.items && state.items.length) {
					let value = state.items.reduce((summ, item) => {
						try {
							return summ + item.price.current.value;
						} catch (e) {
							return summ;
						}
					}, 0);

					let currency;

					try {
						currency = state.items[0].price.current.currency;
					} catch (e) {
						currency = null;
					}

					return {
						current: {
							value,
							currency
						}
					};
				} else {
					return null;
				}
			},

			basketEmpty(state) {
				return !state.items || !state.items.length;
			},

			basketCount(state) {
				return state.items ? state.items.length : 0;
			},

			basketCountByItem(state) {
				return (id) => {
					let result = state.items.find(item => item.id === id);
					return result ? result?.count?.value : 0;
				};
			},

			showSuccessModal(state) {
				return state.items.find(item => item.showSuccessModal);
			}
		},

		mutations: {
			set(state, data) {
				state.bxajaxid = data.bxajaxid;
				state.remote = data.remote;
				state.link = data.link;
				state.items = data.items;
			},

			setLoading(state, value) {
				state.loading = value;
			}
		},

		actions: {
			async request(context, options) {
				context.commit('setLoading', true);

				const response = await fetch(context.state.remote, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						...options,
						bxajaxid: context.state.bxajaxid
					})
				});

				if (!response.ok) {
					console.warn('[vuex] basket: AJAX request failed', response);
				} else {
					const data = await response.json();
					console.log('[vuex] basket: loaded', data);
					context.commit('set', data);
				}

				context.commit('setLoading', false);
			},

			async add(context, options) {
				return context.dispatch('request', {
					action: 'add',
					items: options.id,
					count: options.count,
					setValue: options.setValue || 0
				});
			},

			async remove(context, options) {
				return context.dispatch('request', {
					action: 'remove',
					items: options.id
				});
			}
		}
	};

	var favorite = {
		namespaced: true,

		state: {
			bxajaxid: null,
			remote: null,
			link: null,
			items: [],
			loading: false
		},

		getters: {
			favoriteEmpty(state) {
				return !state.items || !state.items.length;
			},

			favoriteCount(state) {
				return state.items ? state.items.length : 0;
			},

			favoriteList(state) {
				return state.items;
			}
		},

		mutations: {
			set(state, data) {
				state.bxajaxid = data.bxajaxid;
				state.remote = data.remote;
				state.link = data.link;
				state.items = data.items;
			},

			setLoading(state, value) {
				state.loading = value;
			}
		},

		actions: {
			async request(context, options) {
				context.commit('setLoading', true);

				const response = await fetch(context.state.remote, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						...options,
						bxajaxid: context.state.bxajaxid
					})
				});

				if (!response.ok) {
					console.warn('[vuex] favorite: AJAX request failed', response);
				} else {
					const data = await response.json();
					console.log('[vuex] favorite: loaded', data);
					context.commit('set', data);
				}

				context.commit('setLoading', false);
			},

			async add(context, options) {
				return context.dispatch('request', {
					action: 'add',
					id: options.id
				});
			},

			async remove(context, options) {
				return context.dispatch('request', {
					action: 'remove',
					id: options.id
				});
			}
		}
	};

	var user = {
		namespaced: true,

		state: {
			bxajaxid: null,
			remote: null,
			authorized: null,
			linkProfile: null,
			id: null,
			name: null,
			email: null,
			loading: false,
		},

		getters: {
			userEmail: state => {
				return state.email;
			},
			userAuthorized: state => {
				return state.authorized
			}
		},

		mutations: {
			set(state, data) {
				state.bxajaxid = data.bxajaxid;
				state.remote = data.remote;
				state.authorized = data.authorized;
				state.linkProfile = data.linkProfile;
				state.id = data.id;
				state.name = data.name;
				state.email = data.email;
			},

			setLoading(state, value) {
				state.loading = value;
			}
		},

		actions: {
			async request(context, options) {
				context.commit('setLoading', true);

				const response = await fetch(context.state.remote, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						...options,
						bxajaxid: context.state.bxajaxid
					})
				});

				if (!response.ok) {
					console.warn('[vuex] user: AJAX request failed', response);
				} else {
					const data = await response.json();
					console.log('[vuex] user: loaded', data);
					context.commit('set', data);
				}

				context.commit('setLoading', false);
			},

			async add(context, options) {
				context.dispatch('request', {
					action: 'add',
					id: options.id,
					count: options.count
				});
			},

			async remove(context, options) {
				context.dispatch('request', {
					action: 'remove',
					id: options.id
				});
			}
		}
	};

	const store = createStore$1({
		modules: {
			basket,
			favorite,
			user
		}
	});

	var script = {
		render() {
			return this.$slots.default({});
		}
	};

	const render$1 = () => {};


	script.render = render$1;
	script.__file = "local/assets/source/components/helpers/v-scope.vue";

	var script$1 = {
		props: {
			dataSource: {
				type: [Object, String],
				default: null
			},

			bxajaxid: {
				type: String,
				default: null
			}
		},

		render() {
			return null;
		}
	};

	const render$2 = () => {};


	script$1.render = render$2;
	script$1.__file = "local/assets/source/components/helpers/v-source.vue";

	var scrollLock = createCommonjsModule(function (module, exports) {
	(function webpackUniversalModuleDefinition(root, factory) {
		module.exports = factory();
	})(commonjsGlobal, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	__webpack_require__.r(__webpack_exports__);

	// CONCATENATED MODULE: ./src/tools.js
	var argumentAsArray = function argumentAsArray(argument) {
	  return Array.isArray(argument) ? argument : [argument];
	};
	var isElement = function isElement(target) {
	  return target instanceof Node;
	};
	var isElementList = function isElementList(nodeList) {
	  return nodeList instanceof NodeList;
	};
	var eachNode = function eachNode(nodeList, callback) {
	  if (nodeList && callback) {
	    nodeList = isElementList(nodeList) ? nodeList : [nodeList];

	    for (var i = 0; i < nodeList.length; i++) {
	      if (callback(nodeList[i], i, nodeList.length) === true) {
	        break;
	      }
	    }
	  }
	};
	var throwError = function throwError(message) {
	  return console.error("[scroll-lock] ".concat(message));
	};
	var arrayAsSelector = function arrayAsSelector(array) {
	  if (Array.isArray(array)) {
	    var selector = array.join(', ');
	    return selector;
	  }
	};
	var nodeListAsArray = function nodeListAsArray(nodeList) {
	  var nodes = [];
	  eachNode(nodeList, function (node) {
	    return nodes.push(node);
	  });
	  return nodes;
	};
	var findParentBySelector = function findParentBySelector($el, selector) {
	  var self = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var $root = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : document;

	  if (self && nodeListAsArray($root.querySelectorAll(selector)).indexOf($el) !== -1) {
	    return $el;
	  }

	  while (($el = $el.parentElement) && nodeListAsArray($root.querySelectorAll(selector)).indexOf($el) === -1) {
	  }

	  return $el;
	};
	var elementHasSelector = function elementHasSelector($el, selector) {
	  var $root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
	  var has = nodeListAsArray($root.querySelectorAll(selector)).indexOf($el) !== -1;
	  return has;
	};
	var elementHasOverflowHidden = function elementHasOverflowHidden($el) {
	  if ($el) {
	    var computedStyle = getComputedStyle($el);
	    var overflowIsHidden = computedStyle.overflow === 'hidden';
	    return overflowIsHidden;
	  }
	};
	var elementScrollTopOnStart = function elementScrollTopOnStart($el) {
	  if ($el) {
	    if (elementHasOverflowHidden($el)) {
	      return true;
	    }

	    var scrollTop = $el.scrollTop;
	    return scrollTop <= 0;
	  }
	};
	var elementScrollTopOnEnd = function elementScrollTopOnEnd($el) {
	  if ($el) {
	    if (elementHasOverflowHidden($el)) {
	      return true;
	    }

	    var scrollTop = $el.scrollTop;
	    var scrollHeight = $el.scrollHeight;
	    var scrollTopWithHeight = scrollTop + $el.offsetHeight;
	    return scrollTopWithHeight >= scrollHeight;
	  }
	};
	var elementScrollLeftOnStart = function elementScrollLeftOnStart($el) {
	  if ($el) {
	    if (elementHasOverflowHidden($el)) {
	      return true;
	    }

	    var scrollLeft = $el.scrollLeft;
	    return scrollLeft <= 0;
	  }
	};
	var elementScrollLeftOnEnd = function elementScrollLeftOnEnd($el) {
	  if ($el) {
	    if (elementHasOverflowHidden($el)) {
	      return true;
	    }

	    var scrollLeft = $el.scrollLeft;
	    var scrollWidth = $el.scrollWidth;
	    var scrollLeftWithWidth = scrollLeft + $el.offsetWidth;
	    return scrollLeftWithWidth >= scrollWidth;
	  }
	};
	var elementIsScrollableField = function elementIsScrollableField($el) {
	  var selector = 'textarea, [contenteditable="true"]';
	  return elementHasSelector($el, selector);
	};
	var elementIsInputRange = function elementIsInputRange($el) {
	  var selector = 'input[type="range"]';
	  return elementHasSelector($el, selector);
	};
	// CONCATENATED MODULE: ./src/scroll-lock.js
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disablePageScroll", function() { return disablePageScroll; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enablePageScroll", function() { return enablePageScroll; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getScrollState", function() { return getScrollState; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearQueueScrollLocks", function() { return clearQueueScrollLocks; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTargetScrollBarWidth", function() { return scroll_lock_getTargetScrollBarWidth; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentTargetScrollBarWidth", function() { return scroll_lock_getCurrentTargetScrollBarWidth; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPageScrollBarWidth", function() { return getPageScrollBarWidth; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentPageScrollBarWidth", function() { return getCurrentPageScrollBarWidth; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addScrollableTarget", function() { return scroll_lock_addScrollableTarget; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeScrollableTarget", function() { return scroll_lock_removeScrollableTarget; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addScrollableSelector", function() { return scroll_lock_addScrollableSelector; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeScrollableSelector", function() { return scroll_lock_removeScrollableSelector; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLockableTarget", function() { return scroll_lock_addLockableTarget; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLockableSelector", function() { return scroll_lock_addLockableSelector; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFillGapMethod", function() { return scroll_lock_setFillGapMethod; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addFillGapTarget", function() { return scroll_lock_addFillGapTarget; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeFillGapTarget", function() { return scroll_lock_removeFillGapTarget; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addFillGapSelector", function() { return scroll_lock_addFillGapSelector; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeFillGapSelector", function() { return scroll_lock_removeFillGapSelector; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "refillGaps", function() { return refillGaps; });
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


	var FILL_GAP_AVAILABLE_METHODS = ['padding', 'margin', 'width', 'max-width', 'none'];
	var TOUCH_DIRECTION_DETECT_OFFSET = 3;
	var state = {
	  scroll: true,
	  queue: 0,
	  scrollableSelectors: ['[data-scroll-lock-scrollable]'],
	  lockableSelectors: ['body', '[data-scroll-lock-lockable]'],
	  fillGapSelectors: ['body', '[data-scroll-lock-fill-gap]', '[data-scroll-lock-lockable]'],
	  fillGapMethod: FILL_GAP_AVAILABLE_METHODS[0],
	  //
	  startTouchY: 0,
	  startTouchX: 0
	};
	var disablePageScroll = function disablePageScroll(target) {
	  if (state.queue <= 0) {
	    state.scroll = false;
	    scroll_lock_hideLockableOverflow();
	    fillGaps();
	  }

	  scroll_lock_addScrollableTarget(target);
	  state.queue++;
	};
	var enablePageScroll = function enablePageScroll(target) {
	  state.queue > 0 && state.queue--;

	  if (state.queue <= 0) {
	    state.scroll = true;
	    scroll_lock_showLockableOverflow();
	    unfillGaps();
	  }

	  scroll_lock_removeScrollableTarget(target);
	};
	var getScrollState = function getScrollState() {
	  return state.scroll;
	};
	var clearQueueScrollLocks = function clearQueueScrollLocks() {
	  state.queue = 0;
	};
	var scroll_lock_getTargetScrollBarWidth = function getTargetScrollBarWidth($target) {
	  var onlyExists = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	  if (isElement($target)) {
	    var currentOverflowYProperty = $target.style.overflowY;

	    if (onlyExists) {
	      if (!getScrollState()) {
	        $target.style.overflowY = $target.getAttribute('data-scroll-lock-saved-overflow-y-property');
	      }
	    } else {
	      $target.style.overflowY = 'scroll';
	    }

	    var width = scroll_lock_getCurrentTargetScrollBarWidth($target);
	    $target.style.overflowY = currentOverflowYProperty;
	    return width;
	  } else {
	    return 0;
	  }
	};
	var scroll_lock_getCurrentTargetScrollBarWidth = function getCurrentTargetScrollBarWidth($target) {
	  if (isElement($target)) {
	    if ($target === document.body) {
	      var documentWidth = document.documentElement.clientWidth;
	      var windowWidth = window.innerWidth;
	      var currentWidth = windowWidth - documentWidth;
	      return currentWidth;
	    } else {
	      var borderLeftWidthCurrentProperty = $target.style.borderLeftWidth;
	      var borderRightWidthCurrentProperty = $target.style.borderRightWidth;
	      $target.style.borderLeftWidth = '0px';
	      $target.style.borderRightWidth = '0px';

	      var _currentWidth = $target.offsetWidth - $target.clientWidth;

	      $target.style.borderLeftWidth = borderLeftWidthCurrentProperty;
	      $target.style.borderRightWidth = borderRightWidthCurrentProperty;
	      return _currentWidth;
	    }
	  } else {
	    return 0;
	  }
	};
	var getPageScrollBarWidth = function getPageScrollBarWidth() {
	  var onlyExists = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  return scroll_lock_getTargetScrollBarWidth(document.body, onlyExists);
	};
	var getCurrentPageScrollBarWidth = function getCurrentPageScrollBarWidth() {
	  return scroll_lock_getCurrentTargetScrollBarWidth(document.body);
	};
	var scroll_lock_addScrollableTarget = function addScrollableTarget(target) {
	  if (target) {
	    var targets = argumentAsArray(target);
	    targets.map(function ($targets) {
	      eachNode($targets, function ($target) {
	        if (isElement($target)) {
	          $target.setAttribute('data-scroll-lock-scrollable', '');
	        } else {
	          throwError("\"".concat($target, "\" is not a Element."));
	        }
	      });
	    });
	  }
	};
	var scroll_lock_removeScrollableTarget = function removeScrollableTarget(target) {
	  if (target) {
	    var targets = argumentAsArray(target);
	    targets.map(function ($targets) {
	      eachNode($targets, function ($target) {
	        if (isElement($target)) {
	          $target.removeAttribute('data-scroll-lock-scrollable');
	        } else {
	          throwError("\"".concat($target, "\" is not a Element."));
	        }
	      });
	    });
	  }
	};
	var scroll_lock_addScrollableSelector = function addScrollableSelector(selector) {
	  if (selector) {
	    var selectors = argumentAsArray(selector);
	    selectors.map(function (selector) {
	      state.scrollableSelectors.push(selector);
	    });
	  }
	};
	var scroll_lock_removeScrollableSelector = function removeScrollableSelector(selector) {
	  if (selector) {
	    var selectors = argumentAsArray(selector);
	    selectors.map(function (selector) {
	      state.scrollableSelectors = state.scrollableSelectors.filter(function (sSelector) {
	        return sSelector !== selector;
	      });
	    });
	  }
	};
	var scroll_lock_addLockableTarget = function addLockableTarget(target) {
	  if (target) {
	    var targets = argumentAsArray(target);
	    targets.map(function ($targets) {
	      eachNode($targets, function ($target) {
	        if (isElement($target)) {
	          $target.setAttribute('data-scroll-lock-lockable', '');
	        } else {
	          throwError("\"".concat($target, "\" is not a Element."));
	        }
	      });
	    });

	    if (!getScrollState()) {
	      scroll_lock_hideLockableOverflow();
	    }
	  }
	};
	var scroll_lock_addLockableSelector = function addLockableSelector(selector) {
	  if (selector) {
	    var selectors = argumentAsArray(selector);
	    selectors.map(function (selector) {
	      state.lockableSelectors.push(selector);
	    });

	    if (!getScrollState()) {
	      scroll_lock_hideLockableOverflow();
	    }

	    scroll_lock_addFillGapSelector(selector);
	  }
	};
	var scroll_lock_setFillGapMethod = function setFillGapMethod(method) {
	  if (method) {
	    if (FILL_GAP_AVAILABLE_METHODS.indexOf(method) !== -1) {
	      state.fillGapMethod = method;
	      refillGaps();
	    } else {
	      var methods = FILL_GAP_AVAILABLE_METHODS.join(', ');
	      throwError("\"".concat(method, "\" method is not available!\nAvailable fill gap methods: ").concat(methods, "."));
	    }
	  }
	};
	var scroll_lock_addFillGapTarget = function addFillGapTarget(target) {
	  if (target) {
	    var targets = argumentAsArray(target);
	    targets.map(function ($targets) {
	      eachNode($targets, function ($target) {
	        if (isElement($target)) {
	          $target.setAttribute('data-scroll-lock-fill-gap', '');

	          if (!state.scroll) {
	            scroll_lock_fillGapTarget($target);
	          }
	        } else {
	          throwError("\"".concat($target, "\" is not a Element."));
	        }
	      });
	    });
	  }
	};
	var scroll_lock_removeFillGapTarget = function removeFillGapTarget(target) {
	  if (target) {
	    var targets = argumentAsArray(target);
	    targets.map(function ($targets) {
	      eachNode($targets, function ($target) {
	        if (isElement($target)) {
	          $target.removeAttribute('data-scroll-lock-fill-gap');

	          if (!state.scroll) {
	            scroll_lock_unfillGapTarget($target);
	          }
	        } else {
	          throwError("\"".concat($target, "\" is not a Element."));
	        }
	      });
	    });
	  }
	};
	var scroll_lock_addFillGapSelector = function addFillGapSelector(selector) {
	  if (selector) {
	    var selectors = argumentAsArray(selector);
	    selectors.map(function (selector) {
	      if (state.fillGapSelectors.indexOf(selector) === -1) {
	        state.fillGapSelectors.push(selector);

	        if (!state.scroll) {
	          scroll_lock_fillGapSelector(selector);
	        }
	      }
	    });
	  }
	};
	var scroll_lock_removeFillGapSelector = function removeFillGapSelector(selector) {
	  if (selector) {
	    var selectors = argumentAsArray(selector);
	    selectors.map(function (selector) {
	      state.fillGapSelectors = state.fillGapSelectors.filter(function (fSelector) {
	        return fSelector !== selector;
	      });

	      if (!state.scroll) {
	        scroll_lock_unfillGapSelector(selector);
	      }
	    });
	  }
	};
	var refillGaps = function refillGaps() {
	  if (!state.scroll) {
	    fillGaps();
	  }
	};

	var scroll_lock_hideLockableOverflow = function hideLockableOverflow() {
	  var selector = arrayAsSelector(state.lockableSelectors);
	  scroll_lock_hideLockableOverflowSelector(selector);
	};

	var scroll_lock_showLockableOverflow = function showLockableOverflow() {
	  var selector = arrayAsSelector(state.lockableSelectors);
	  scroll_lock_showLockableOverflowSelector(selector);
	};

	var scroll_lock_hideLockableOverflowSelector = function hideLockableOverflowSelector(selector) {
	  var $targets = document.querySelectorAll(selector);
	  eachNode($targets, function ($target) {
	    scroll_lock_hideLockableOverflowTarget($target);
	  });
	};

	var scroll_lock_showLockableOverflowSelector = function showLockableOverflowSelector(selector) {
	  var $targets = document.querySelectorAll(selector);
	  eachNode($targets, function ($target) {
	    scroll_lock_showLockableOverflowTarget($target);
	  });
	};

	var scroll_lock_hideLockableOverflowTarget = function hideLockableOverflowTarget($target) {
	  if (isElement($target) && $target.getAttribute('data-scroll-lock-locked') !== 'true') {
	    var computedStyle = window.getComputedStyle($target);
	    $target.setAttribute('data-scroll-lock-saved-overflow-y-property', computedStyle.overflowY);
	    $target.setAttribute('data-scroll-lock-saved-inline-overflow-property', $target.style.overflow);
	    $target.setAttribute('data-scroll-lock-saved-inline-overflow-y-property', $target.style.overflowY);
	    $target.style.overflow = 'hidden';
	    $target.setAttribute('data-scroll-lock-locked', 'true');
	  }
	};

	var scroll_lock_showLockableOverflowTarget = function showLockableOverflowTarget($target) {
	  if (isElement($target) && $target.getAttribute('data-scroll-lock-locked') === 'true') {
	    $target.style.overflow = $target.getAttribute('data-scroll-lock-saved-inline-overflow-property');
	    $target.style.overflowY = $target.getAttribute('data-scroll-lock-saved-inline-overflow-y-property');
	    $target.removeAttribute('data-scroll-lock-saved-overflow-property');
	    $target.removeAttribute('data-scroll-lock-saved-inline-overflow-property');
	    $target.removeAttribute('data-scroll-lock-saved-inline-overflow-y-property');
	    $target.removeAttribute('data-scroll-lock-locked');
	  }
	};

	var fillGaps = function fillGaps() {
	  state.fillGapSelectors.map(function (selector) {
	    scroll_lock_fillGapSelector(selector);
	  });
	};

	var unfillGaps = function unfillGaps() {
	  state.fillGapSelectors.map(function (selector) {
	    scroll_lock_unfillGapSelector(selector);
	  });
	};

	var scroll_lock_fillGapSelector = function fillGapSelector(selector) {
	  var $targets = document.querySelectorAll(selector);
	  var isLockable = state.lockableSelectors.indexOf(selector) !== -1;
	  eachNode($targets, function ($target) {
	    scroll_lock_fillGapTarget($target, isLockable);
	  });
	};

	var scroll_lock_fillGapTarget = function fillGapTarget($target) {
	  var isLockable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	  if (isElement($target)) {
	    var scrollBarWidth;

	    if ($target.getAttribute('data-scroll-lock-lockable') === '' || isLockable) {
	      scrollBarWidth = scroll_lock_getTargetScrollBarWidth($target, true);
	    } else {
	      var $lockableParent = findParentBySelector($target, arrayAsSelector(state.lockableSelectors));
	      scrollBarWidth = scroll_lock_getTargetScrollBarWidth($lockableParent, true);
	    }

	    if ($target.getAttribute('data-scroll-lock-filled-gap') === 'true') {
	      scroll_lock_unfillGapTarget($target);
	    }

	    var computedStyle = window.getComputedStyle($target);
	    $target.setAttribute('data-scroll-lock-filled-gap', 'true');
	    $target.setAttribute('data-scroll-lock-current-fill-gap-method', state.fillGapMethod);

	    if (state.fillGapMethod === 'margin') {
	      var currentMargin = parseFloat(computedStyle.marginRight);
	      $target.style.marginRight = "".concat(currentMargin + scrollBarWidth, "px");
	    } else if (state.fillGapMethod === 'width') {
	      $target.style.width = "calc(100% - ".concat(scrollBarWidth, "px)");
	    } else if (state.fillGapMethod === 'max-width') {
	      $target.style.maxWidth = "calc(100% - ".concat(scrollBarWidth, "px)");
	    } else if (state.fillGapMethod === 'padding') {
	      var currentPadding = parseFloat(computedStyle.paddingRight);
	      $target.style.paddingRight = "".concat(currentPadding + scrollBarWidth, "px");
	    }
	  }
	};

	var scroll_lock_unfillGapSelector = function unfillGapSelector(selector) {
	  var $targets = document.querySelectorAll(selector);
	  eachNode($targets, function ($target) {
	    scroll_lock_unfillGapTarget($target);
	  });
	};

	var scroll_lock_unfillGapTarget = function unfillGapTarget($target) {
	  if (isElement($target)) {
	    if ($target.getAttribute('data-scroll-lock-filled-gap') === 'true') {
	      var currentFillGapMethod = $target.getAttribute('data-scroll-lock-current-fill-gap-method');
	      $target.removeAttribute('data-scroll-lock-filled-gap');
	      $target.removeAttribute('data-scroll-lock-current-fill-gap-method');

	      if (currentFillGapMethod === 'margin') {
	        $target.style.marginRight = "";
	      } else if (currentFillGapMethod === 'width') {
	        $target.style.width = "";
	      } else if (currentFillGapMethod === 'max-width') {
	        $target.style.maxWidth = "";
	      } else if (currentFillGapMethod === 'padding') {
	        $target.style.paddingRight = "";
	      }
	    }
	  }
	};

	var onResize = function onResize(e) {
	  refillGaps();
	};

	var onTouchStart = function onTouchStart(e) {
	  if (!state.scroll) {
	    state.startTouchY = e.touches[0].clientY;
	    state.startTouchX = e.touches[0].clientX;
	  }
	};

	var scroll_lock_onTouchMove = function onTouchMove(e) {
	  if (!state.scroll) {
	    var startTouchY = state.startTouchY,
	        startTouchX = state.startTouchX;
	    var currentClientY = e.touches[0].clientY;
	    var currentClientX = e.touches[0].clientX;

	    if (e.touches.length < 2) {
	      var selector = arrayAsSelector(state.scrollableSelectors);
	      var direction = {
	        up: startTouchY < currentClientY,
	        down: startTouchY > currentClientY,
	        left: startTouchX < currentClientX,
	        right: startTouchX > currentClientX
	      };
	      var directionWithOffset = {
	        up: startTouchY + TOUCH_DIRECTION_DETECT_OFFSET < currentClientY,
	        down: startTouchY - TOUCH_DIRECTION_DETECT_OFFSET > currentClientY,
	        left: startTouchX + TOUCH_DIRECTION_DETECT_OFFSET < currentClientX,
	        right: startTouchX - TOUCH_DIRECTION_DETECT_OFFSET > currentClientX
	      };

	      var handle = function handle($el) {
	        var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	        if ($el) {
	          var parentScrollableEl = findParentBySelector($el, selector, false);

	          if (elementIsInputRange($el)) {
	            return false;
	          }

	          if (skip || elementIsScrollableField($el) && findParentBySelector($el, selector) || elementHasSelector($el, selector)) {
	            var prevent = false;

	            if (elementScrollLeftOnStart($el) && elementScrollLeftOnEnd($el)) {
	              if (direction.up && elementScrollTopOnStart($el) || direction.down && elementScrollTopOnEnd($el)) {
	                prevent = true;
	              }
	            } else if (elementScrollTopOnStart($el) && elementScrollTopOnEnd($el)) {
	              if (direction.left && elementScrollLeftOnStart($el) || direction.right && elementScrollLeftOnEnd($el)) {
	                prevent = true;
	              }
	            } else if (directionWithOffset.up && elementScrollTopOnStart($el) || directionWithOffset.down && elementScrollTopOnEnd($el) || directionWithOffset.left && elementScrollLeftOnStart($el) || directionWithOffset.right && elementScrollLeftOnEnd($el)) {
	              prevent = true;
	            }

	            if (prevent) {
	              if (parentScrollableEl) {
	                handle(parentScrollableEl, true);
	              } else {
	                e.preventDefault();
	              }
	            }
	          } else {
	            handle(parentScrollableEl);
	          }
	        } else {
	          e.preventDefault();
	        }
	      };

	      handle(e.target);
	    }
	  }
	};

	var onTouchEnd = function onTouchEnd(e) {
	  if (!state.scroll) {
	    state.startTouchY = 0;
	    state.startTouchX = 0;
	  }
	};

	if (typeof window !== 'undefined') {
	  window.addEventListener('resize', onResize);
	}

	if (typeof document !== 'undefined') {
	  document.addEventListener('touchstart', onTouchStart);
	  document.addEventListener('touchmove', scroll_lock_onTouchMove, {
	    passive: false
	  });
	  document.addEventListener('touchend', onTouchEnd);
	}

	var deprecatedMethods = {
	  hide: function hide(target) {
	    throwError('"hide" is deprecated! Use "disablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget');
	    disablePageScroll(target);
	  },
	  show: function show(target) {
	    throwError('"show" is deprecated! Use "enablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget');
	    enablePageScroll(target);
	  },
	  toggle: function toggle(target) {
	    throwError('"toggle" is deprecated! Do not use it.');

	    if (getScrollState()) {
	      disablePageScroll();
	    } else {
	      enablePageScroll(target);
	    }
	  },
	  getState: function getState() {
	    throwError('"getState" is deprecated! Use "getScrollState" instead. \n https://github.com/FL3NKEY/scroll-lock#getscrollstate');
	    return getScrollState();
	  },
	  getWidth: function getWidth() {
	    throwError('"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth');
	    return getPageScrollBarWidth();
	  },
	  getCurrentWidth: function getCurrentWidth() {
	    throwError('"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth');
	    return getCurrentPageScrollBarWidth();
	  },
	  setScrollableTargets: function setScrollableTargets(target) {
	    throwError('"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget');
	    scroll_lock_addScrollableTarget(target);
	  },
	  setFillGapSelectors: function setFillGapSelectors(selector) {
	    throwError('"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector');
	    scroll_lock_addFillGapSelector(selector);
	  },
	  setFillGapTargets: function setFillGapTargets(target) {
	    throwError('"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget');
	    scroll_lock_addFillGapTarget(target);
	  },
	  clearQueue: function clearQueue() {
	    throwError('"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. \n https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks');
	    clearQueueScrollLocks();
	  }
	};

	var scrollLock = _objectSpread({
	  disablePageScroll: disablePageScroll,
	  enablePageScroll: enablePageScroll,
	  getScrollState: getScrollState,
	  clearQueueScrollLocks: clearQueueScrollLocks,
	  getTargetScrollBarWidth: scroll_lock_getTargetScrollBarWidth,
	  getCurrentTargetScrollBarWidth: scroll_lock_getCurrentTargetScrollBarWidth,
	  getPageScrollBarWidth: getPageScrollBarWidth,
	  getCurrentPageScrollBarWidth: getCurrentPageScrollBarWidth,
	  addScrollableSelector: scroll_lock_addScrollableSelector,
	  removeScrollableSelector: scroll_lock_removeScrollableSelector,
	  addScrollableTarget: scroll_lock_addScrollableTarget,
	  removeScrollableTarget: scroll_lock_removeScrollableTarget,
	  addLockableSelector: scroll_lock_addLockableSelector,
	  addLockableTarget: scroll_lock_addLockableTarget,
	  addFillGapSelector: scroll_lock_addFillGapSelector,
	  removeFillGapSelector: scroll_lock_removeFillGapSelector,
	  addFillGapTarget: scroll_lock_addFillGapTarget,
	  removeFillGapTarget: scroll_lock_removeFillGapTarget,
	  setFillGapMethod: scroll_lock_setFillGapMethod,
	  refillGaps: refillGaps,
	  _state: state
	}, deprecatedMethods);

	/* harmony default export */ var scroll_lock = __webpack_exports__["default"] = (scrollLock);

	/***/ })
	/******/ ])["default"];
	});
	});

	var scrollLock$1 = /*@__PURE__*/getDefaultExportFromCjs(scrollLock);

	// accordion native js
	function toggleAccordionNative(scope) {
		var accordionAll = scope.querySelectorAll('.js-accordion');

		Array.from(accordionAll).forEach(function (accordion) {
			if (!accordion.classList.contains('init-accordion')) {
				var content = accordion.querySelector('.js-accordion__content');
				var toggler = accordion.querySelector('.js-accordion__toggler');

				// инициализация начального состояния
				accordion.classList.add('init-accordion');
				if (content && !accordion.classList.contains('open-accordion')) {
					slideUp(content);
				}

				if (content && toggler) {
					// переключение аккордиона
					toggler.addEventListener('click', function (e) {

						e.preventDefault();

						if (accordion.classList.contains('open-accordion')) {
							accordion.classList.remove('open-accordion');
							toggler.classList.remove('open-accordion');
							slideUp(content);
						} else {
							toggler.classList.add('open-accordion');
							accordion.classList.add('open-accordion');
							slideDown(content);
						}
					});

					window.dataStorage.set(accordion, 'open', open);


					// очистка высоты после завершения анимации открытия
					content.addEventListener('transitionend', function () {
						if (accordion.classList.contains('open-accordion')) {
							content.style.height = null;
						}
					});
				}
			}
		});

		/* SLIDE UP */
		function slideUp(target, duration = 300) {
			if (target) {
				target.style.transitionProperty = 'height, margin, padding';
				target.style.transitionDuration = duration + 'ms';
				target.style.boxSizing = 'border-box';
				target.style.height = target.offsetHeight + 'px';
				target.offsetHeight;
				target.style.overflow = 'hidden';
				target.style.height = 0;
				target.style.paddingTop = 0;
				target.style.paddingBottom = 0;
				target.style.marginTop = 0;
				target.style.marginBottom = 0;
				window.setTimeout(() => {
					target.style.display = 'none';
					target.style.removeProperty('height');
					target.style.removeProperty('padding-top');
					target.style.removeProperty('padding-bottom');
					target.style.removeProperty('margin-top');
					target.style.removeProperty('margin-bottom');
					target.style.removeProperty('overflow');
					target.style.removeProperty('transition-duration');
					target.style.removeProperty('transition-property');
					//alert("!");
				}, duration);
			}
		}

		/* SLIDE DOWN */
		function slideDown(target, duration = 300) {

			target.style.removeProperty('display');
			let display = window.getComputedStyle(target).display;
			if (display === 'none') {
				display = 'block';
			}
			target.style.display = display;
			let height = target.offsetHeight;
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
			target.offsetHeight;
			target.style.boxSizing = 'border-box';
			target.style.transitionProperty = 'height, margin, padding';
			target.style.transitionDuration = duration + 'ms';
			target.style.height = height + 'px';
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			window.setTimeout(() => {
				target.style.removeProperty('height');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
			}, duration);
		}
	}

	// accordion native js
	function toggleAccordionNative$1(scope) {
		var accordionAll = scope.querySelectorAll('.js-accordion--adaptive');

		toggleAccordionNative$1.toggleAccordionNative = function () {
			Array.from(accordionAll).forEach(function (accordion) {
				var content = accordion.querySelector('.js-accordion__content');
				var toggler = accordion.querySelector('.js-accordion__toggler');
				var maxWidth = parseInt(accordion.getAttribute('data-max-width'));
				var toggleAccordion = null;

				if (window.innerWidth <= maxWidth) {
					if (!accordion.classList.contains('init-accordion')) {
						function closeContent() {
							content.style.height = '0';
						}

						// инициализация начального состояния
						accordion.classList.remove('destroy-accordion');
						accordion.classList.add('init-accordion');
						if (content && !accordion.classList.contains('open-accordion')) {
							closeContent();
						}

						if (content && toggler) {
							toggleAccordion = function (e) {
								e.preventDefault();

								if (accordion.classList.contains('open-accordion')) {
									accordion.classList.remove('open-accordion');
									toggler.classList.remove('open-accordion');
									content.style.height = content.scrollHeight + 'px';
									// нужно для перерендеринга высоты контента
									content.scrollHeight;
									if (requestAnimationFrame) {
										requestAnimationFrame(closeContent);
									} else {
										setTimeout(closeContent);
									}
								} else {
									open();
								}
							};

							function open() {
								content.style.height = content.scrollHeight + 'px';
								toggler.classList.add('open-accordion');
								setTimeout(() => {
									accordion.classList.add('open-accordion');
								}, 300);
							}

							// очистка высоты после завершения анимации открытия
							content.addEventListener('transitionend', function () {
								if (accordion.classList.contains('open-accordion')) {
									content.style.height = null;
								}
							});

							// переключение аккордиона
							toggler.off('click.toggleAccordion', toggleAccordion);
							toggler.on('click.toggleAccordion', toggleAccordion);

							window.dataStorage.set(accordion, 'open', open);
						}
					}
				} else {
					// accordion destroy
					accordion.classList.remove('init-accordion');
					accordion.classList.remove('open-accordion');
					accordion.classList.add('destroy-accordion');
					if (content) {
						content.style.height = null;
					}

					if (toggler) {
						toggler.off('click.toggleAccordion', toggleAccordion);
					}
				}
			});
		};

		toggleAccordionNative$1.toggleAccordionNative();
		window.removeEventListener('resize', toggleAccordionNative$1.toggleAccordionNative);
		window.addEventListener('resize', toggleAccordionNative$1.toggleAccordionNative);
	}

	// отслеживание свайпа на мобилке для галереи

	function detectSwipe(scope) {
		let touchstartX = 0;
		let touchstartY = 0;
		let touchendX = 0;
		let touchendY = 0;
		var deg = 0;

		detectSwipe.handlerTouchStart = function (event) {
			touchstartX = event.changedTouches[0].screenX;
			touchstartY = event.changedTouches[0].screenY;
		};

		detectSwipe.handlerTouchEnd = function (event) {
			touchendX = event.changedTouches[0].screenX;
			touchendY = event.changedTouches[0].screenY;
			handleGesture(event.target.closest('.js-detect-swipe'));
		};

		scope.querySelectorAll('.js-detect-swipe').forEach(function (element) {
			element.removeEventListener('touchstart', detectSwipe.handlerTouchStart, false);
			element.addEventListener('touchstart', detectSwipe.handlerTouchStart, false);
			element.removeEventListener('touchend', detectSwipe.handlerTouchEnd, false);
			element.addEventListener('touchend', detectSwipe.handlerTouchEnd, false);
		});

		// расчет угла свайпа
		function calcDeg() {
			var rads = Math.atan((touchstartY - touchendY) / (touchstartX - touchendX));
			deg = rads * (180 / 3.14);
		}

		// расчет направления свайпа
		function handleGesture(element) {
			if (touchendX < touchstartX) {
				calcDeg();
				if (deg > -35 && deg < 35) {
					var swipedLeftEvent = document.createEvent('Event');
					swipedLeftEvent.initEvent('swipedLeft', true, true);
					element.dispatchEvent(swipedLeftEvent);
					console.log('Swiped left');
				}
			}

			if (touchendX > touchstartX) {
				calcDeg();
				if (deg > -35 && deg < 35) {
					var swipedRightEvent = document.createEvent('Event');
					swipedRightEvent.initEvent('swipedRight', true, true);
					element.dispatchEvent(swipedRightEvent);
					console.log('Swiped right');
				}
			}

			if (touchendY < touchstartY) {
				calcDeg();
				if (deg < -65 || deg > 65) {
					var swipedUpEvent = document.createEvent('Event');
					swipedUpEvent.initEvent('swipedUp', true, true);
					element.dispatchEvent(swipedUpEvent);
					console.log('Swiped up');
				}
			}

			if (touchendY > touchstartY) {
				calcDeg();
				if (deg < -65 || deg > 65) {
					var swipedDownEvent = document.createEvent('Event');
					swipedDownEvent.initEvent('swipedDown', true, true);
					element.dispatchEvent(swipedDownEvent);
					console.log('Swiped down');
					controller.closeAll();
				}
			}

			if (touchendY === touchstartY) {
				console.log('Tap');
			}
		}
	}

	// показ зафиксированного блока при скролле страницы вверх
	function fixedBlockIfScrollingUpVanilla(scope) {
		[].slice.apply(scope.querySelectorAll('.js-fixed')).forEach(function (block) {
			var content = block.querySelector('.js-fixed__content');
			var blockHeight = content.offsetHeight;
			var blockStart = block.getBoundingClientRect().top + pageYOffset;
			var winWidth = document.documentElement.clientWidth;
			var newDocScroll = 0;
			var index = new Date().getTime();

			block.classList.add('init-fixed');
			block.style.paddingTop = blockHeight + 'px';

			console.log('blockHeight', content.offsetHeight);
			console.log('blockHeight', content.clientHeight);

			function fixedBlockIfScrollingUp() {
				newDocScroll = pageYOffset;

				// показ блока если сделан скролл страницы наверх
				if (blockStart < newDocScroll) {
					block.classList.add('active-fixed');
					block.style.paddingTop = blockHeight + 'px';
				} else if (block.classList.contains('active-fixed') && blockStart >= newDocScroll) {
					// скрытие блока
					block.classList.remove('active-fixed');
				}

			}

			// инициализаци с индексом на случай множественных блоков для фиксации
			window.off('resize.fixedBlockIfScrollingUp' + index);
			window.on('resize.fixedBlockIfScrollingUp' + index, function () {
				if (winWidth != document.documentElement.clientWidth) {
					winWidth = document.documentElement.clientWidth;
					blockHeight = content.offsetHeight;
					blockStart = block.getBoundingClientRect().top + pageYOffset;
					block.style.paddingTop = blockHeight + 'px';

					if (requestAnimationFrame) {
						requestAnimationFrame(fixedBlockIfScrollingUp);
					} else {
						fixedBlockIfScrollingUp();
					}
				}
			});

			// инициализаци с индексом на случай множественных блоков для фиксации
			document.off('scroll.fixedBlockIfScrollingUp' + index);
			document.on('scroll.fixedBlockIfScrollingUp' + index, function () {
				if (requestAnimationFrame) {
					requestAnimationFrame(fixedBlockIfScrollingUp);
				} else {
					fixedBlockIfScrollingUp();
				}
			});
			fixedBlockIfScrollingUp();
		});
	}

	// показ зафиксированного блока при скролле страницы вверх
	function fixedBlockIfScrollingUpVanilla$1(scope) {
		[].slice.apply(scope.querySelectorAll('.js-fixed--up:not(.init-fixed)')).forEach(function (block) {
			var content = block.querySelector('.js-fixed__content');
			var blockHeight = content.offsetHeight;
			var blockStart = block.getBoundingClientRect().top + pageYOffset;
			var blockEnd = blockStart + blockHeight;
			var winWidth = document.documentElement.clientWidth;
			var oldDocScroll = 0;
			var newDocScroll = 0;
			var index = new Date().getTime();

			block.classList.add('init-fixed');
			block.style.paddingTop = blockHeight + 'px';

			function fixedBlockIfScrollingUp() {
				newDocScroll = pageYOffset;

				// показ блока если сделан скролл страницы наверх
				if (blockEnd < newDocScroll && oldDocScroll > newDocScroll) {
					block.classList.add('active-fixed');
					block.style.paddingTop = blockHeight + 'px';
				} else if (block.classList.contains('active-fixed') && blockStart >= newDocScroll || oldDocScroll < newDocScroll) {
					// скрытие блока
					block.classList.remove('active-fixed');
				}

				oldDocScroll = pageYOffset;
			}

			// инициализаци с индексом на случай множественных блоков для фиксации
			window.off('resize.fixedBlockIfScrollingUp' + index);
			window.on('resize.fixedBlockIfScrollingUp' + index, function () {
				if (winWidth != document.documentElement.clientWidth) {
					winWidth = document.documentElement.clientWidth;
					blockHeight = content.offsetHeight;
					blockStart = block.getBoundingClientRect().top + pageYOffset;
					block.style.paddingTop = blockHeight + 'px';

					if (requestAnimationFrame) {
						requestAnimationFrame(fixedBlockIfScrollingUp);
					} else {
						fixedBlockIfScrollingUp();
					}
				}
			});

			// инициализаци с индексом на случай множественных блоков для фиксации
			document.off('scroll.fixedBlockIfScrollingUp' + index);
			document.on('scroll.fixedBlockIfScrollingUp' + index, function () {
				if (requestAnimationFrame) {
					requestAnimationFrame(fixedBlockIfScrollingUp);
				} else {
					fixedBlockIfScrollingUp();
				}
			});
			fixedBlockIfScrollingUp();
		});
	}

	// проверка скролла на начальное и конечное положение
	function scrollShadowEdgeNative(scope) {
		scope.querySelectorAll('.js-scroll-shadow-edge').forEach(function (parent) {
			var content = parent.querySelector('.js-scroll-shadow-edge__content');
			var pos = parent.getAttribute('data-position');
			var prop = (pos === 'Left') ? 'Width' : 'Height';
			var endClassName = (pos.toLowerCase()) + '-end';
			var beginClassName = (pos.toLowerCase()) + '-begin';

			function toggleClass() {
				if ((content['scroll' + prop] - content['client' + prop]) >= 0) {
					parent.classList.toggle(endClassName, content['scroll' + pos] >= (content['scroll' + prop] - content['client' + prop]));
					parent.classList.toggle(beginClassName, content['scroll' + pos] <= 0);
				} else {
					parent.classList.add(beginClassName);
					parent.classList.add(endClassName);
				}
			}

			toggleClass();

			content.removeEventListener('scroll', toggleClass);
			content.addEventListener('scroll', toggleClass);
			window.removeEventListener('resize', toggleClass);
			window.addEventListener('resize', toggleClass);
		});
	}

	function scrollTop(scope) {
		const toggles = scope.querySelectorAll('.js-scroll-top');

		if (toggles.length) {
			window.addEventListener('load', () => {
				toggles.forEach((toggle) => {
					toggle.addEventListener('click', () => {
						controller.scrollTop();
					});
				});

				window.addEventListener('scroll', toggleShow);
				toggleShow();
			});
		}

		function toggleShow() {
			if (document.documentElement.scrollTop > document.documentElement.clientHeight / 2) {
				toggles.forEach((toggle) => {
					toggle.classList.add('scroll-top--show');
				});
			} else {
				toggles.forEach((toggle) => {
					toggle.classList.remove('scroll-top--show');
				});
			}
		}
	}

	// переключение скрытого блока нативный
	function toggleFadeNative(scope) {
		const allParents = scope.querySelectorAll('.js-fade:not(.init-fade)');

		allParents.forEach(function (parent) {
			parent.classList.add('init-fade');

			if ('ontouchstart' in document.documentElement) {
				var toggles = parent.querySelectorAll('.js-fade__toggle');
				var classElem = parent.getAttribute('data-class');

				toggles.forEach(function (toggle) {
					toggle.removeEventListener('click', toggleDropdown);
					toggle.addEventListener('click', toggleDropdown);
				});

				function toggleDropdown() {
					// переключение состояния
					if (!parent.classList.contains('open-fade')) {
						openDropdown();
					} else {
						closeDropdown();
					}
				}

				// открыть
				function openDropdown() {
					document.documentElement.classList.add(classElem);
					parent.classList.add('open-fade');
					window.tooltipPosition.calcPosition();
				}

				// закрыть
				function closeDropdown() {
					document.documentElement.classList.remove(classElem);
					parent.classList.remove('open-fade');
				}

				document.addEventListener('click', function (e) {
					if (!e.target.closest('.js-fade')) {
						closeDropdown();
					}
				});
			} else {
				var timeout = null;

				parent.removeEventListener('mouseover', openDropdown);
				parent.addEventListener('mouseover', openDropdown);
				parent.removeEventListener('mouseout', closeDropdown);
				parent.addEventListener('mouseout', closeDropdown);

				// открыть
				function openDropdown() {
					clearTimeout(timeout);
					document.documentElement.classList.add(classElem);
					parent.classList.add('open-fade');
					window.tooltipPosition.calcPosition();
				}

				// закрыть
				function closeDropdown() {
					clearTimeout(timeout);
					timeout = setTimeout(function () {
						parent.classList.remove('open-fade');
						document.documentElement.classList.remove(classElem);
					}, 200);
				}
			}
		});

		toggleFadeNative.closeAll = function () {
			document.querySelectorAll('.js-fade').forEach((parent) => {
				var classElem = parent.getAttribute('data-class');

				document.documentElement.classList.remove(classElem);
				parent.classList.remove('open-fade');
			});
		};
	}

	// переключение по кнопке класса корневого html страницы
	function toggleClassPageNative(scope) {
		scope.querySelectorAll('.js-toggle-class-page:not(.init)').forEach(function (element) {
			var elemetClass = element.getAttribute('data-class');

			element.classList.add('init');

			element.removeEventListener('click', toggleClass);
			element.addEventListener('click', toggleClass);

			function toggleClass(e) {
				e.preventDefault();

				if (document.documentElement.classList.contains(elemetClass)) {
					document.documentElement.classList.remove(elemetClass);
				} else {
					document.documentElement.classList.add(elemetClass);
				}
			}
		});
	}

	var locals = /*#__PURE__*/Object.freeze({
		__proto__: null,
		accordion: toggleAccordionNative,
		accordionOnlyAdaptive: toggleAccordionNative$1,
		detectSwipe: detectSwipe,
		fixedBlockIfScrolling: fixedBlockIfScrollingUpVanilla,
		fixedBlockIfScrollingUp: fixedBlockIfScrollingUpVanilla$1,
		scrollShadowEdge: scrollShadowEdgeNative,
		scrollTop: scrollTop,
		toggleBlock: toggleFadeNative,
		togglePageClass: toggleClassPageNative
	});

	// css property animation
	function cssAnimation() {
		if (CSS.registerProperty) {
			CSS.registerProperty({
				name: '--color-stop-1',
				syntax: '<percentage>',
				initialValue: '60%',
				inherits: false
			});
			CSS.registerProperty({
				name: '--color-stop-2',
				syntax: '<percentage>',
				initialValue: '60%',
				inherits: false
			});
			CSS.registerProperty({
				name: '--color-stop-3',
				syntax: '<percentage>',
				initialValue: '60%',
				inherits: false
			});
		}
	}

	const focus = () => {
		document.addEventListener('keydown', (e) => {
			// key "Tab"
			if (e.keyCode == 9) {
				document.body.classList.add('state--focus-enabled');
			}
		});

		document.addEventListener('mousedown', () => {
			document.body.classList.remove('state--focus-enabled');
		});
	};

	// обработка событий на элементах
	function detectSwipe$1() {
		// оверлеи для мобильных попапов
		document.querySelectorAll('.js-overlay').forEach(function (element) {
			element.addEventListener('swipedDown', function () {
				// document.documentElement.classList.remove('open-site-menu', 'open-catalog-menu');
			});
		});
	}

	// задание переменной 1vh для css
	function setVhVariable() {
		function setVhVariable() {
			let vh = (window.innerHeight * 0.01).toFixed(4) + 'px';
			document.documentElement.style.setProperty('--vh', vh);
		}

		setVhVariable();

		window.addEventListener('resize', setVhVariable);
	}

	// задание переменной 1vh для css
	function setVhVariable$1() {
		function setVhVariable() {
			let vh = (document.documentElement.clientWidth * 0.01).toFixed(4) + 'px';
			document.documentElement.style.setProperty('--vw', vh);
		}

		setVhVariable();

		window.addEventListener('resize', setVhVariable);
	}

	// инициализация позиционирования, не выходящего за контентную область
	function tooltipPosition() {
		var delta;
		var containerPadding;
		var timeout = null;

		// ширина скроллбара
		tooltipPosition.scrollBarWidth = (function () {
			var outer = document.createElement('div');
			outer.style.visibility = 'hidden';
			outer.style.width = '100px';
			outer.style.msOverflowStyle = 'scrollbar';

			document.body.appendChild(outer);

			var widthNoScroll = outer.offsetWidth;
			// force scrollbars
			outer.style.overflow = 'scroll';

			// add innerdiv
			var inner = document.createElement('div');
			inner.style.width = '100%';
			outer.appendChild(inner);

			var widthWithScroll = inner.offsetWidth;

			// remove divs
			outer.parentNode.removeChild(outer);

			return widthNoScroll - widthWithScroll;
		})();

		// breakpoints
		tooltipPosition.breakpoints = {
			'md-max': 1249,
			'sm-max': 1023,
			'xs-max': 767,
		};

		// вычисление положения
		tooltipPosition.calcPosition = function () {
			// ширина паддинга контейнера страницы
			containerPadding = document.documentElement.clientWidth > tooltipPosition.breakpoints['xs-max'] ? 15 : 15;
			containerPadding = document.documentElement.clientWidth > tooltipPosition.breakpoints['sm-max'] ? 30 : containerPadding;

			document.querySelectorAll('.js-tooltip-position').forEach(function (tooltip) {
				tooltip.style.marginLeft = '';

				var leftCoord = tooltip.getBoundingClientRect().left;
				// насколько выступает правый край выпадашки за границы контейнера страницы
				delta = leftCoord + tooltip.offsetWidth -
					Math.min((document.documentElement.clientWidth - tooltipPosition.scrollBarWidth - containerPadding), (document.documentElement.clientWidth - tooltipPosition.scrollBarWidth) / 2 + 650);

				// если вылезает с левой стороны экрана
				if (leftCoord < 0) {
					tooltip.style.marginLeft = -tooltip.getBoundingClientRect().left + containerPadding + 'px';
				}
				// если вылезает с правой стороны экрана
				if (delta > 0) {
					tooltip.style.marginLeft = ((parseInt(tooltip.style.marginLeft) || 0) - delta) + 'px';
				}
			});
		};

		function resizeInit() {
			clearTimeout(timeout);
			timeout = setTimeout(tooltipPosition.calcPosition, 100);
		}

		resizeInit();

		window.removeEventListener('resize', resizeInit);
		window.addEventListener('resize', resizeInit);
	}

	window.tooltipPosition = tooltipPosition;

	var globals = /*#__PURE__*/Object.freeze({
		__proto__: null,
		cssAnimation: cssAnimation,
		handlerEvent: detectSwipe$1,
		setVhVariable: setVhVariable,
		setVwVariable: setVhVariable$1,
		tooltipPosition: tooltipPosition,
		focus: focus
	});

	window.view = {
		isIOS: parseInt(('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ''])[1]).replace('undefined', '3_2').replace('_', '.').replace('_', '')) || false
	};

	var View = {
		initAllGlobal() {
			if (globals) {
				window.view.globals = globals;
				for (let fn in globals) {
					if (typeof globals[fn] === 'function') {
						globals[fn]();
					}
				}
			}
		},

		initAllLocal(scope) {
			if (locals) {
				console.log('initAllLocal');
				window.view.locals = locals;
				for (let fn in locals) {
					if (typeof locals[fn] === 'function') {
						locals[fn](scope);
					}
				}
			}
		}
	};

	function mitt(n){return {all:n=n||new Map,on:function(t,e){var i=n.get(t);i&&i.push(e)||n.set(t,[e]);},off:function(t,e){var i=n.get(t);i&&i.splice(i.indexOf(e)>>>0,1);},emit:function(t,e){(n.get(t)||[]).slice().map(function(n){n(e);}),(n.get("*")||[]).slice().map(function(n){n(t,e);});}}}

	window.dataStorage = {
		_storage: new WeakMap(),
		set: function (element, key, obj) {
			if (!this._storage.has(element)) {
				this._storage.set(element, new Map());
			}
			this._storage.get(element).set(key, obj);
		},
		get: function (element, key) {
			if (!this._storage.get(element)) {
				return;
			}
			return this._storage.get(element).get(key);
		},
		has: function (element, key) {
			return this._storage.has(element) && this._storage.get(element).has(key);
		},
		remove: function (element, key) {
			var ret = this._storage.get(element).delete(key);
			if (!this._storage.get(element).size === 0) {
				this._storage.delete(element);
			}
			return ret;
		}
	};

	// поиск родителей по селектору
	Element.prototype.parents = function (selector) {
		var elements = [];
		var elem = this;
		var ishaveselector = selector !== undefined;

		while ((elem = elem.parentElement) !== null) {
			if (elem.nodeType !== Node.ELEMENT_NODE) {
				continue;
			}

			if (!ishaveselector || elem.matches(selector)) {
				elements.push(elem);
			}
		}

		return elements;
	};

	// полифил методотов on off аналогов jquery
	var events = {
		on(event, cb, opts) {
			// save the namespaces on the DOM element itself
			if (!this.namespaces) {
				this.namespaces = {};
			}

			this.namespaces[event] = cb;
			var options = opts || false;

			this.addEventListener(event.split('.')[0], cb, options);
			return this;
		},
		off(event) {
			if (this?.namespaces?.[event]) {
				this.removeEventListener(event.split('.')[0], this.namespaces[event]);
				delete this.namespaces[event];
				return this;
			}
		}
	};
	// Extend the DOM with these above custom methods
	window.on = document.on = Element.prototype.on = events.on;
	window.off = document.off = Element.prototype.off = events.off;

	class Controller {
		constructor() {
			this.events = mitt();

			this.touch = 'ontouchstart' in document.documentElement;

			this.passiveEventsSupported = (() => {
				// passive event listeners support test from MDN
				let result = false;
				try {
					window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
						get: () => result = true
					}));
				} catch (err) {
				}
				return result;
			})();

			// добавление на страницу отложенной загрузки внешнего скрипта
			this.loadedDelayScripts = [];

			document.addEventListener('keydown', (e) => {
				if (e.keyCode == 27) {
					this.closeAll();
				}
			});

			document.querySelectorAll('.js-overlay').forEach((overlay) => {
				overlay.addEventListener('click', () => {
					this.closeAll();
				});
			});

			document.querySelectorAll('.js-close-all').forEach((toggle) => {
				toggle.addEventListener('click', () => {
					this.closeAll();
				});
			});

			this.events.on('close-all', () => {
				this.closeAll();
			});

			View.initAllGlobal();
			View.initAllLocal(document.body);
		}

		loadDelayScript(url, callback = () => true) {
			if (!~this.loadedDelayScripts.indexOf(url)) {
				this.loadedDelayScripts.push(url);
				var script = document.createElement('script');
				script.setAttribute('src', url);
				script.setAttribute('type', 'text/javascript');
				document.body.appendChild(script);
				script.off('load.loadDelayScript');
				script.on('load.loadDelayScript', callback);
			} else {
				callback();
			}
		}

		animate({timing, draw, duration}) {
			let start = performance.now();

			requestAnimationFrame(function animate(time) {
				// timeFraction изменяется от 0 до 1
				let timeFraction = (time - start) / duration;
				if (timeFraction > 1) {
					timeFraction = 1;
				}

				// вычисление текущего состояния анимации
				let progress = timing(timeFraction);

				draw(progress); // отрисовать её

				if (timeFraction < 1) {
					requestAnimationFrame(animate);
				}
			});
		}

		scrollTop() {
			const docScroll = document.documentElement.scrollTop;

			this.animate({
				duration: 400,
				timing: function (timeFraction) {
					return timeFraction;
				},            // линейная функция значит, что анимация идёт с одной и той же скоростью
				draw: function (progress) {
					document.documentElement.scrollTop = docScroll - Math.round((docScroll) * progress);
				}
			});
		}

		scrollTo(block, offset = 0) {
			if (block) {
				const positionBlock = block.getBoundingClientRect().top - offset;
				const docScroll = document.documentElement.scrollTop;

				this.animate({
					duration: 400,
					timing: function (timeFraction) {
						return timeFraction;
					},            // линейная функция значит, что анимация идёт с одной и той же скоростью
					draw: function (progress) {
						document.documentElement.scrollTop = docScroll + Math.round((positionBlock) * progress);
					}
				});
			}
		}

		scrollWheelLock(element) {
			if (Array.isArray(element)) {
				element.forEach((element) => {
					element.addEventListener('DOMMouseScroll', this.scrollLock, true);
					element.addEventListener('touchmove', this.scrollLock, true);
					element.addEventListener('mousewheel', this.scrollLock, true);
				});
			} else {
				if (element) {
					element.addEventListener('DOMMouseScroll', this.scrollLock, true);
					element.addEventListener('touchmove', this.scrollLock, true);
					element.addEventListener('mousewheel', this.scrollLock, true);
				}
			}
		}

		scrollWheelUnlock(element) {
			if (Array.isArray(element)) {
				element.forEach((element) => {
					element.removeEventListener('DOMMouseScroll', this.scrollLock, true);
					element.removeEventListener('touchmove', this.scrollLock, true);
					element.removeEventListener('mousewheel', this.scrollLock, true);
				});
			} else {
				if (element) {
					element.removeEventListener('DOMMouseScroll', this.scrollLock, true);
					element.removeEventListener('touchmove', this.scrollLock, true);
					element.removeEventListener('mousewheel', this.scrollLock, true);
				}
			}
		}

		scrollLock(ev) {
			var scrollTop = this.scrollTop,
				scrollHeight = this.scrollHeight,
				height = this.clientHeight,
				delta = ev.wheelDelta;
			var up = delta > 0;

			var prevent = function () {
				ev.stopPropagation();
				ev.preventDefault();
				ev.returnValue = false;
				return false;
			};

			if (!up && -delta > scrollHeight - height - scrollTop) {
				// Scrolling down, but this will take us past the bottom.
				this.scrollTop = scrollHeight;
				return prevent();
			} else if (up && delta > scrollTop) {
				// Scrolling up, but this will take us past the top.
				this.scrollTop = 0;
				return prevent();
			}
		}

		lockScrolling(unlockElement) {
			scrollLock$1.disablePageScroll(unlockElement);
			this.scrollWheelLock(unlockElement);
		}

		unlockScrolling(unlockElement) {
			scrollLock$1.enablePageScroll(unlockElement);
			this.scrollWheelUnlock(unlockElement);
		}

		openMobileNav() {
			this.events.emit('mobile-nav-open');
		}

		closeMobileNav() {
			this.events.emit('mobile-nav-close');
		}

		emitCustomEvent(eventname, response) {
			this.events.emit(eventname, response);
		}

		navigationUpdated(data) {
			this.navigationData = data;
			this.events.emit('navigation-updated');
		}

		menuUpdated(data) {
			this.menuData = data;
			this.events.emit('menu-updated');
		}

		openSearchSmall() {
			this.events.emit('search-small-open');
		}

		closeSearchSmall() {
			this.events.emit('search-small-close');
		}

		updateModelSource() {
			this.events.emit('update-model-source');
		}

		closeSiteMenu() {
			document.documentElement.classList.remove('open-site-menu');
		}

		closeCatalogMenu() {
			document.documentElement.classList.remove('open-catalog-menu');
		}

		closeFilter() {
			document.documentElement.classList.remove('open-filter');
		}

		closeSort() {
			document.documentElement.classList.remove('open-sort');
		}

		closeBasketResume() {
			document.documentElement.classList.remove('open-basket-resume');
		}

		closeHamburgerMenu() {
			this.events.emit('close-hamburger-menu');
		}

		closeFadeBlocks() {
			Array.from(document.querySelectorAll('.js-fade')).forEach((block) => {
				document.documentElement.classList.remove(block.getAttribute('data-class'));
				block.classList.remove('open-fade');
			});
		}

		openModalFromUrl(url) {
			this.openModal({
				className: 'modal--sm',
				url: url,
			});
		}

		// открыть модальное окно
		openModal(options) {
			if (window.modalController) {
				window.modalController.open(options);
			}
		}

		// открыть сообщение в правом верхнем углу
		openMessage(options) {
			if (window.messageController) {
				window.messageController.open(options);
			}
		}

		openAddReview() {
			this.events.emit('open-add-review');
		}

		toggleClassPage(elementClass) {
			if (document.documentElement.classList.contains(elementClass)) {
				document.documentElement.classList.remove(elementClass);
			} else {
				document.documentElement.classList.add(elementClass);
			}
		}

		removeFavorite(productId) {
			this.events.emit('remove-favorite', productId);
		}

		deleteBasketItem(productId) {
			this.events.emit('remove-basket-item', productId);
		}

		cleanBasket() {
			this.events.emit('clean-basket');
		}

		updateOrder() {
			this.events.emit('update-order');
		}

		updateMyData() {
			this.events.emit('update-my-data');
		}

		cancelOrder() {
			this.events.emit('cancel-order');
		}

		slideUp(target, duration = 500) {
			if (target) {
				target.style.transitionProperty = 'height, margin, padding';
				target.style.transitionDuration = duration + 'ms';
				target.style.boxSizing = 'border-box';
				target.style.height = target.offsetHeight + 'px';
				target.offsetHeight;
				target.style.overflow = 'hidden';
				target.style.height = 0;
				target.style.paddingTop = 0;
				target.style.paddingBottom = 0;
				target.style.marginTop = 0;
				target.style.marginBottom = 0;
				window.setTimeout(() => {
					target.style.display = 'none';
					target.style.removeProperty('height');
					target.style.removeProperty('padding-top');
					target.style.removeProperty('padding-bottom');
					target.style.removeProperty('margin-top');
					target.style.removeProperty('margin-bottom');
					target.style.removeProperty('overflow');
					target.style.removeProperty('transition-duration');
					target.style.removeProperty('transition-property');
					//alert("!");
				}, duration);
			}
		}

		slideDown(target, duration = 500) {
			target.style.removeProperty('display');
			let display = window.getComputedStyle(target).display;
			if (display === 'none') {
				display = 'block';
			}
			target.style.display = display;
			let height = target.offsetHeight;
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
			target.offsetHeight;
			target.style.boxSizing = 'border-box';
			target.style.transitionProperty = 'height, margin, padding';
			target.style.transitionDuration = duration + 'ms';
			target.style.height = height + 'px';
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			window.setTimeout(() => {
				target.style.removeProperty('height');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
			}, duration);
		}

		closeModal() {
			if (window.modalController) {
				window.modalController.close();
			}
		}

		closeAllModals() {
			if (window.modalController) {
				window.modalController.closeAll();
			}
		}

		closeAllModules() {
			Object.values(window.view.globals).forEach((module) => {
				if (module.closeAll) {
					module.closeAll();
				}
			});
			Object.values(window.view.locals).forEach((module) => {
				if (module.closeAll) {
					module.closeAll();
				}
			});
		}

		closeAll() {
			this.closeMobileNav();
			this.closeMobileNav();
			this.closeSearchSmall();
			this.closeAllModals();
			this.closeSiteMenu();
			this.closeCatalogMenu();
			this.closeHamburgerMenu();
			this.closeFilter();
			this.closeSort();
			this.closeBasketResume();
			this.closeAllModules();
			this.closeFadeBlocks();
			console.log('closeAll');
		}
	}

	var controller = new Controller();

	var script$2 = {
		props: {
			// link to load data from (String)
			// or data object itself (Object)
			dataSource: {
				type: [Object, String],
				default: undefined
			},

			// Bitrix component id
			// required by Bitrix to determine component instance for AJAX requests
			// (dataSource link often simpty refers to page containing multiple components)
			bxajaxid: {
				type: String,
				default: undefined
			},

			// immediately load data on "created" hook
			// if dataSource is a link
			loadOnInit: {
				type: Boolean,
				default: true
			}
		},

		data() {
			return {
				// bxajaxid which is finally computed after processing props and slots
				localBxajaxid: null,

				// loading state
				loading: false
			};
		},

		computed: {
			componentName() {
				let path = this.$options.__file;
				if (path) {
					return path.slice(path.lastIndexOf('/') + 1, path.lastIndexOf('.'));
				}
				return null;
			}
		},

		watch: {
			dataSource() {
				// try to load using props
				this.init(this.bxajaxid, this.dataSource);
			}
		},

		created() {
			// try to load using props
			this.init(this.bxajaxid, this.dataSource);

			const readSlot = (item) => {

				if ((typeof (item.props) == 'undefined') || item.props == null) {
					item.props = {};
				}

				if ((typeof (item.props['bxajaxid']) == 'undefined')) {
					item.props['bxajaxid'] = undefined;
				}

				if ((typeof (item.props['data-source']) == 'undefined')) {
					item.props['data-source'] = undefined;
				}


				const bxajaxid = item.props['bxajaxid'];
				const dataSource = item.props['data-source'];


				if (dataSource) {
					this.init(bxajaxid, dataSource);
				}

			};

			// try to load using slots
			if (this.$slots && this.$slots.source) {
				this.$slots.source().forEach((item) => {
					readSlot(item);
					if (item.children && Array.isArray(item.children)) {
						item.children.forEach(readSlot);
					}
				});
			}
		},

		methods: {
			dataSet(data, options) {
				console.info(`${this.componentName}: warning: v-source-mixin is used but sourceSet is not implemented in your component`, data, options);
			},

			async dataLoad(options = {}, dataSetOptions) {
				// use this.loading to set preloaders if needed
				this.loading = true;

				// check arguments
				if (!options || typeof options !== 'object' || !options.url) {
					console.warn(`${this.componentName}: warning: dataLoad options arg is wrong`, options);
				}

				// convert any options.data to transfer as FormData
				let formattedData = new FormData();

				if (options.data instanceof FormData) {
					formattedData = options.data;
				} else if (options.data) {
					let makeFormData = (data, parentKey) => {
						if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
							Object.keys(data).forEach((key) => {
								makeFormData(data[key], parentKey ? `${parentKey}[${key}]` : key);
							});
						} else {
							formattedData.append(parentKey, data == null ? '' : data);
						}
					};

					makeFormData(options.data);
				}

				// set bxajaxid if present
				if (this.localBxajaxid) {
					formattedData.set('bxajaxid', this.localBxajaxid);
				}

				// set min delay to ensure preloader fadein/fadeout plays fine (<transition name="fade"> speed is 250ms)
				let delayPromise = new Promise((resolve) => {
					options.delay ? setTimeout(resolve, 250) : resolve();
				});

				try {
					// create request
					let requestPromise = fetch(options.url, {
						method: 'POST',
						/*headers: {
						 //'Content-Type': 'application/json',
						 'Content-Type': 'application/x-www-form-urlencoded',
						 },*/
						body: formattedData
					});

					// wait for both promises
					let [response] = await Promise.all([requestPromise, delayPromise]);

					// handle response
					if (!response.ok) {
						console.warn(`${this.componentName}: AJAX request failed`, response);
					} else {
						let data = await response.json();
						if ((typeof (data.encoded) !== 'undefined')) {
							data = JSON.parse(atob(data.encoded));
						}

						console.log(`${this.componentName}: AJAX request completed`, data, this.$options);

						if (data.modalTimeout && data.redirect) {
							setTimeout(function () {
								window.modalController.closeAll();
								window.location.href = data.redirect;
							}, data.modalTimeout);
						} else if (data.redirect) {
							window.modalController.closeAll();
							window.location.href = data.redirect;
							return;
						}

						if (data.modalTimeout && data.reload) {
							setTimeout(function () {
								window.modalController.closeAll();
								window.location.reload(true);
							}, data.modalTimeout);
						} else if (data.reload) {
							window.modalController.closeAll();
							window.location.reload(true);
							return;
						}

						if (data.success && data.closeModal) {
							if (typeof modalController !== 'undefined') {
								controller.closeModal();
							}
						}
						if (data.modalMessage) {
							controller.openMessage({content: data.modalMessage});
						}


						if (data.emit_event) {
							controller.emitCustomEvent(data.emit_event, data);
						}

	                                        if (data.success && data.openModal && data.openModal.url) {
	                                            let timeOut = data.openModal.timeOut ? data.openModal.timeOut: 0;

	                                            window.setTimeout(function() {
	                                                controller.closeModal();

	                                                controller.openModal({
	                                                    'url': data.openModal.url, 
	                                                    'className': 'modal--sm'
	                                                });
	                                            }, timeOut);
	                                        }

					 if (data.success && data.modal && data.message) {
							this.loading = false;
							controller.closeModal();
							controller.openModal({
								className: 'modal--sm',
								content: data.message
							});

							data.form = null;
							return
						}

						console.log(`${this.componentName}: AJAX request completed`, data);
						this.dataSet(data, dataSetOptions);
					}
				} catch (e) {
					console.warn(`${this.componentName}: AJAX request failed`, e);
				}

				this.loading = false;
			},

			init(bxajaxid, dataSource) {
				if (typeof bxajaxid !== 'undefined') {
					this.localBxajaxid = bxajaxid;
				}

				if (typeof dataSource === 'string') {
					if (this.loadOnInit) {
						this.dataLoad({url: dataSource});
					}
				} else if (typeof dataSource !== 'undefined') {
					if ((typeof (dataSource.encoded) !== 'undefined')) {
						dataSource = JSON.parse(atob(dataSource.encoded));
					}
					this.dataSet(dataSource);
				}
			}
		}
	};

	const render$3 = () => {};


	script$2.render = render$3;
	script$2.__file = "local/assets/source/components/mixins/v-mixin-source.vue";

	var script$3 = {
		mixins: [
			script$2
		],

		data() {
			return {
				catalog: null
			};
		},

		methods: {
			dataSet(data) {
				if (data.type === 'basket') {
					this.$store.commit('basket/set', data);
				}

				if (data.type === 'favorite') {
					this.$store.commit('favorite/set', data);
				}

				if (data.type === 'user') {
					this.$store.commit('user/set', data);
				}
			}
		},

		render() {
			return '';
		}
	};

	const render$4 = () => {};


	script$3.render = render$4;
	script$3.__file = "local/assets/source/components/helpers/v-model-source.vue";

	var script$4 = {
		props: {
			loading: {
				type: Boolean,
				default: false
			}
		}
	};

	const _hoisted_1 = { class: "loader__container" };
	const _hoisted_2 = {
	  key: 0,
	  class: "loader__icon"
	};
	const _hoisted_3 = /*#__PURE__*/createVNode("img", {
	  src: "/local/assets/images/loader.svg",
	  loading: "lazy",
	  decoding: "async",
	  alt: "",
	  title: ""
	}, null, -1 /* HOISTED */);

	function render$5(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", {
	    class: ["v-loader loader", {'loader--active': $props.loading}]
	  }, [
	    createVNode("div", _hoisted_1, [
	      createVNode(Transition, { name: "fade" }, {
	        default: withCtx(() => [
	          ($props.loading)
	            ? (openBlock(), createBlock("div", _hoisted_2, [
	                _hoisted_3
	              ]))
	            : createCommentVNode("v-if", true)
	        ]),
	        _: 1 /* STABLE */
	      })
	    ])
	  ], 2 /* CLASS */))
	}

	script$4.render = render$5;
	script$4.__file = "local/assets/source/components/helpers/v-loader.vue";

	var script$5 = {
		props: {
			loading: {
				type: String,
				default: 'lazy'
			},

			src: {
				type: String,
				default: null
			},

			sources: {
				type: Object,
				default: null
			},

			alt: {
				type: String,
				default: ''
			},

			width: {
				type: [String, Number],
				default: null
			},

			height: {
				type: [String, Number],
				default: null
			},

			type: {
				type: String
			},
		},

		emits: [
			'load'
		],

		data() {
			return {
				loaded: false
			};
		},

		computed: {
			computedBig() {
				let result = '';
				if (this.sources?.big) {
					result += this.sources.big;
					result += this.sources['big_2x'] ? ', ' + this.sources['big_2x'] + ' 2x' : '';
					return result
				} else {
					return null
				}
			},
			computedMiddle() {
				let result = '';
				if (this.sources?.middle) {
					result += this.sources.middle;
					result += this.sources['middle_2x'] ? ', ' + this.sources['middle_2x'] + ' 2x' : '';
					return result
				} else {
					return null
				}
			},
			computedSmall() {
				let result = '';
				if (this.sources?.small) {
					result += this.sources.small;
					result += this.sources['small_2x'] ? ', ' + this.sources['small_2x'] + ' 2x' : '';
					return result
				} else {
					return null
				}
			},
			computedSrcset() {
				if (!this.sources || !this.sources.length) {
					return this.src;
				} else {
					return this.sources.map((item) => `${item.src} ${item.size}`).join(', ');
				}
			}
		},

		mounted() {
			if (this.$el.complete) {
				this.handleLoad();
			} else {
				this.$el.addEventListener('load', this.handleLoad);
			}
		},

		methods: {
			handleLoad() {
				this.loaded = true;
				this.$emit('load');
			}
		}
	};

	const _hoisted_1$1 = { class: "v-picture picture" };

	function render$6(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("picture", _hoisted_1$1, [
	    ($props.type)
	      ? (openBlock(), createBlock("img", {
	          key: 0,
	          class: ["v-image image", {'image--loading': !$data.loaded}],
	          src: $props.sources[$props.type],
	          srcset: $props.sources[$props.type + '_2x'] + ' 2x',
	          alt: $props.alt,
	          loading: $props.loading,
	          width: $props.width,
	          height: $props.height
	        }, null, 10 /* CLASS, PROPS */, ["src", "srcset", "alt", "loading", "width", "height"]))
	      : (openBlock(), createBlock(Fragment, { key: 1 }, [
	          ($options.computedSmall)
	            ? (openBlock(), createBlock("source", {
	                key: 0,
	                srcset: $options.computedSmall,
	                media: "(max-width: 640px)"
	              }, null, 8 /* PROPS */, ["srcset"]))
	            : createCommentVNode("v-if", true),
	          ($options.computedMiddle)
	            ? (openBlock(), createBlock("source", {
	                key: 1,
	                srcset: $options.computedMiddle,
	                media: "(max-width: 1023px)"
	              }, null, 8 /* PROPS */, ["srcset"]))
	            : createCommentVNode("v-if", true),
	          ($options.computedSmall)
	            ? (openBlock(), createBlock("source", {
	                key: 2,
	                srcset: $options.computedBig,
	                media: "(min-width: 1024px)"
	              }, null, 8 /* PROPS */, ["srcset"]))
	            : createCommentVNode("v-if", true),
	          createVNode("img", {
	            class: ["v-image image", {'image--loading': !$data.loaded}],
	            src: $props.sources.orig,
	            alt: $props.alt,
	            loading: $props.loading,
	            width: $props.width,
	            height: $props.height
	          }, null, 10 /* CLASS, PROPS */, ["src", "alt", "loading", "width", "height"])
	        ], 64 /* STABLE_FRAGMENT */))
	  ]))
	}

	script$5.render = render$6;
	script$5.__file = "local/assets/source/components/helpers/v-picture.vue";

	var script$6 = {
		props: {
			loading: {
				type: String,
				default: 'lazy'
			},

			src: {
				type: String,
				default: null
			},

			sources: {
				type: Array,
				default: null
			},

			alt: {
				type: String,
				default: ''
			}
		},

		emits: [
			'load'
		],

		data() {
			return {
				loaded: false
			};
		},

		computed: {
			computedSrcset() {
				if (!this.sources || !this.sources.length) {
					return this.src;
				} else {
					return this.sources.map((item) => `${item.src} ${item.size}`).join(', ');
				}
			}
		},

		mounted() {
			if (this.$el.complete) {
				this.handleLoad();
			} else {
				this.$el.addEventListener('load', this.handleLoad);
			}
		},

		methods: {
			handleLoad() {
				this.loaded = true;
				this.$emit('load');
			}
		}
	};

	function render$7(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("img", {
	    class: ["v-image image", {'image--loading': !$data.loaded}],
	    src: $props.src,
	    srcset: $options.computedSrcset,
	    alt: $props.alt,
	    loading: $props.loading
	  }, null, 10 /* CLASS, PROPS */, ["src", "srcset", "alt", "loading"]))
	}

	script$6.render = render$7;
	script$6.__file = "local/assets/source/components/helpers/v-image.vue";

	var script$7 = {
		props: {
			src: {
				type: String,
				default: null
			},

			poster: {
				type: String,
				default: null
			},

			type: {
				type: String,
				default: 'video/mp4'
			}
		},

		methods: {
			pauseVideo() {
				this.$el.pause();
			}
		}
	};

	function render$8(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("video", {
	    class: "v-video video",
	    controls: "controls",
	    poster: $props.poster
	  }, [
	    createVNode("source", {
	      class: "video__source",
	      src: $props.src,
	      type: $props.type
	    }, null, 8 /* PROPS */, ["src", "type"])
	  ], 8 /* PROPS */, ["poster"]))
	}

	script$7.render = render$8;
	script$7.__file = "local/assets/source/components/helpers/v-video.vue";

	function uniqueId(prefix = '') {
		return prefix + Date.now().toString() + Math.round(Math.random() * 100000);
	}

	var script$8 = {
		data() {
			return {
				lazyComponent: null
			};
		},

		mounted() {
			try {
				let componentName = uniqueId('lazy-');
				getCurrentInstance().appContext.app.component(componentName, {
					template: this.$refs['lazy-template'].innerHTML
				});
				this.lazyComponent = componentName;
			} catch (error) {
				console.warn('v-lazy-component: child component initialization error', error);
			}
		},

		beforeUnmount() {
			delete getCurrentInstance().appContext.components[this.lazyComponent];
			this.$forceUpdate();
		}
	};

	const _hoisted_1$2 = { class: "v-lazy-component lazy-component" };
	const _hoisted_2$1 = {
	  key: 1,
	  class: "lazy-component__template",
	  ref: "lazy-template"
	};

	function render$9(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$2, [
	    ($data.lazyComponent)
	      ? (openBlock(), createBlock(resolveDynamicComponent($data.lazyComponent), { key: 0 }))
	      : createCommentVNode("v-if", true),
	    (!$data.lazyComponent)
	      ? (openBlock(), createBlock("div", _hoisted_2$1, [
	          renderSlot(_ctx.$slots, "default")
	        ], 512 /* NEED_PATCH */))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$8.render = render$9;
	script$8.__file = "local/assets/source/components/helpers/v-lazy-component.vue";

	var top = 'top';
	var bottom = 'bottom';
	var right = 'right';
	var left = 'left';
	var auto = 'auto';
	var basePlacements = [top, bottom, right, left];
	var start = 'start';
	var end = 'end';
	var clippingParents = 'clippingParents';
	var viewport = 'viewport';
	var popper = 'popper';
	var reference = 'reference';
	var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
	  return acc.concat([placement + "-" + start, placement + "-" + end]);
	}, []);
	var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
	  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
	}, []); // modifiers that need to read the DOM

	var beforeRead = 'beforeRead';
	var read = 'read';
	var afterRead = 'afterRead'; // pure-logic modifiers

	var beforeMain = 'beforeMain';
	var main = 'main';
	var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

	var beforeWrite = 'beforeWrite';
	var write = 'write';
	var afterWrite = 'afterWrite';
	var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

	function getNodeName(element) {
	  return element ? (element.nodeName || '').toLowerCase() : null;
	}

	function getWindow(node) {
	  if (node == null) {
	    return window;
	  }

	  if (node.toString() !== '[object Window]') {
	    var ownerDocument = node.ownerDocument;
	    return ownerDocument ? ownerDocument.defaultView || window : window;
	  }

	  return node;
	}

	function isElement(node) {
	  var OwnElement = getWindow(node).Element;
	  return node instanceof OwnElement || node instanceof Element;
	}

	function isHTMLElement(node) {
	  var OwnElement = getWindow(node).HTMLElement;
	  return node instanceof OwnElement || node instanceof HTMLElement;
	}

	function isShadowRoot(node) {
	  // IE 11 has no ShadowRoot
	  if (typeof ShadowRoot === 'undefined') {
	    return false;
	  }

	  var OwnElement = getWindow(node).ShadowRoot;
	  return node instanceof OwnElement || node instanceof ShadowRoot;
	}

	// and applies them to the HTMLElements such as popper and arrow

	function applyStyles(_ref) {
	  var state = _ref.state;
	  Object.keys(state.elements).forEach(function (name) {
	    var style = state.styles[name] || {};
	    var attributes = state.attributes[name] || {};
	    var element = state.elements[name]; // arrow is optional + virtual elements

	    if (!isHTMLElement(element) || !getNodeName(element)) {
	      return;
	    } // Flow doesn't support to extend this property, but it's the most
	    // effective way to apply styles to an HTMLElement
	    // $FlowFixMe[cannot-write]


	    Object.assign(element.style, style);
	    Object.keys(attributes).forEach(function (name) {
	      var value = attributes[name];

	      if (value === false) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, value === true ? '' : value);
	      }
	    });
	  });
	}

	function effect$1(_ref2) {
	  var state = _ref2.state;
	  var initialStyles = {
	    popper: {
	      position: state.options.strategy,
	      left: '0',
	      top: '0',
	      margin: '0'
	    },
	    arrow: {
	      position: 'absolute'
	    },
	    reference: {}
	  };
	  Object.assign(state.elements.popper.style, initialStyles.popper);
	  state.styles = initialStyles;

	  if (state.elements.arrow) {
	    Object.assign(state.elements.arrow.style, initialStyles.arrow);
	  }

	  return function () {
	    Object.keys(state.elements).forEach(function (name) {
	      var element = state.elements[name];
	      var attributes = state.attributes[name] || {};
	      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

	      var style = styleProperties.reduce(function (style, property) {
	        style[property] = '';
	        return style;
	      }, {}); // arrow is optional + virtual elements

	      if (!isHTMLElement(element) || !getNodeName(element)) {
	        return;
	      }

	      Object.assign(element.style, style);
	      Object.keys(attributes).forEach(function (attribute) {
	        element.removeAttribute(attribute);
	      });
	    });
	  };
	} // eslint-disable-next-line import/no-unused-modules


	var applyStyles$1 = {
	  name: 'applyStyles',
	  enabled: true,
	  phase: 'write',
	  fn: applyStyles,
	  effect: effect$1,
	  requires: ['computeStyles']
	};

	function getBasePlacement(placement) {
	  return placement.split('-')[0];
	}

	function getBoundingClientRect(element) {
	  var rect = element.getBoundingClientRect();
	  return {
	    width: rect.width,
	    height: rect.height,
	    top: rect.top,
	    right: rect.right,
	    bottom: rect.bottom,
	    left: rect.left,
	    x: rect.left,
	    y: rect.top
	  };
	}

	// means it doesn't take into account transforms.

	function getLayoutRect(element) {
	  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
	  // Fixes https://github.com/popperjs/popper-core/issues/1223

	  var width = element.offsetWidth;
	  var height = element.offsetHeight;

	  if (Math.abs(clientRect.width - width) <= 1) {
	    width = clientRect.width;
	  }

	  if (Math.abs(clientRect.height - height) <= 1) {
	    height = clientRect.height;
	  }

	  return {
	    x: element.offsetLeft,
	    y: element.offsetTop,
	    width: width,
	    height: height
	  };
	}

	function contains(parent, child) {
	  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

	  if (parent.contains(child)) {
	    return true;
	  } // then fallback to custom implementation with Shadow DOM support
	  else if (rootNode && isShadowRoot(rootNode)) {
	      var next = child;

	      do {
	        if (next && parent.isSameNode(next)) {
	          return true;
	        } // $FlowFixMe[prop-missing]: need a better way to handle this...


	        next = next.parentNode || next.host;
	      } while (next);
	    } // Give up, the result is false


	  return false;
	}

	function getComputedStyle$1(element) {
	  return getWindow(element).getComputedStyle(element);
	}

	function isTableElement(element) {
	  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
	}

	function getDocumentElement(element) {
	  // $FlowFixMe[incompatible-return]: assume body is always available
	  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
	  element.document) || window.document).documentElement;
	}

	function getParentNode(element) {
	  if (getNodeName(element) === 'html') {
	    return element;
	  }

	  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
	    // $FlowFixMe[incompatible-return]
	    // $FlowFixMe[prop-missing]
	    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
	    element.parentNode || ( // DOM Element detected
	    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
	    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
	    getDocumentElement(element) // fallback

	  );
	}

	function getTrueOffsetParent(element) {
	  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
	  getComputedStyle$1(element).position === 'fixed') {
	    return null;
	  }

	  return element.offsetParent;
	} // `.offsetParent` reports `null` for fixed elements, while absolute elements
	// return the containing block


	function getContainingBlock(element) {
	  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
	  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

	  if (isIE && isHTMLElement(element)) {
	    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
	    var elementCss = getComputedStyle$1(element);

	    if (elementCss.position === 'fixed') {
	      return null;
	    }
	  }

	  var currentNode = getParentNode(element);

	  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
	    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
	    // create a containing block.
	    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

	    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
	      return currentNode;
	    } else {
	      currentNode = currentNode.parentNode;
	    }
	  }

	  return null;
	} // Gets the closest ancestor positioned element. Handles some edge cases,
	// such as table ancestors and cross browser bugs.


	function getOffsetParent(element) {
	  var window = getWindow(element);
	  var offsetParent = getTrueOffsetParent(element);

	  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
	    offsetParent = getTrueOffsetParent(offsetParent);
	  }

	  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
	    return window;
	  }

	  return offsetParent || getContainingBlock(element) || window;
	}

	function getMainAxisFromPlacement(placement) {
	  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
	}

	var max = Math.max;
	var min = Math.min;
	var round = Math.round;

	function within(min$1, value, max$1) {
	  return max(min$1, min(value, max$1));
	}

	function getFreshSideObject() {
	  return {
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	  };
	}

	function mergePaddingObject(paddingObject) {
	  return Object.assign({}, getFreshSideObject(), paddingObject);
	}

	function expandToHashMap(value, keys) {
	  return keys.reduce(function (hashMap, key) {
	    hashMap[key] = value;
	    return hashMap;
	  }, {});
	}

	var toPaddingObject = function toPaddingObject(padding, state) {
	  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
	    placement: state.placement
	  })) : padding;
	  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
	};

	function arrow(_ref) {
	  var _state$modifiersData$;

	  var state = _ref.state,
	      name = _ref.name,
	      options = _ref.options;
	  var arrowElement = state.elements.arrow;
	  var popperOffsets = state.modifiersData.popperOffsets;
	  var basePlacement = getBasePlacement(state.placement);
	  var axis = getMainAxisFromPlacement(basePlacement);
	  var isVertical = [left, right].indexOf(basePlacement) >= 0;
	  var len = isVertical ? 'height' : 'width';

	  if (!arrowElement || !popperOffsets) {
	    return;
	  }

	  var paddingObject = toPaddingObject(options.padding, state);
	  var arrowRect = getLayoutRect(arrowElement);
	  var minProp = axis === 'y' ? top : left;
	  var maxProp = axis === 'y' ? bottom : right;
	  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
	  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
	  var arrowOffsetParent = getOffsetParent(arrowElement);
	  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
	  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
	  // outside of the popper bounds

	  var min = paddingObject[minProp];
	  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
	  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
	  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

	  var axisProp = axis;
	  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
	}

	function effect$2(_ref2) {
	  var state = _ref2.state,
	      options = _ref2.options;
	  var _options$element = options.element,
	      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

	  if (arrowElement == null) {
	    return;
	  } // CSS selector


	  if (typeof arrowElement === 'string') {
	    arrowElement = state.elements.popper.querySelector(arrowElement);

	    if (!arrowElement) {
	      return;
	    }
	  }

	  {
	    if (!isHTMLElement(arrowElement)) {
	      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
	    }
	  }

	  if (!contains(state.elements.popper, arrowElement)) {
	    {
	      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
	    }

	    return;
	  }

	  state.elements.arrow = arrowElement;
	} // eslint-disable-next-line import/no-unused-modules


	var arrow$1 = {
	  name: 'arrow',
	  enabled: true,
	  phase: 'main',
	  fn: arrow,
	  effect: effect$2,
	  requires: ['popperOffsets'],
	  requiresIfExists: ['preventOverflow']
	};

	var unsetSides = {
	  top: 'auto',
	  right: 'auto',
	  bottom: 'auto',
	  left: 'auto'
	}; // Round the offsets to the nearest suitable subpixel based on the DPR.
	// Zooming can change the DPR, but it seems to report a value that will
	// cleanly divide the values into the appropriate subpixels.

	function roundOffsetsByDPR(_ref) {
	  var x = _ref.x,
	      y = _ref.y;
	  var win = window;
	  var dpr = win.devicePixelRatio || 1;
	  return {
	    x: round(round(x * dpr) / dpr) || 0,
	    y: round(round(y * dpr) / dpr) || 0
	  };
	}

	function mapToStyles(_ref2) {
	  var _Object$assign2;

	  var popper = _ref2.popper,
	      popperRect = _ref2.popperRect,
	      placement = _ref2.placement,
	      offsets = _ref2.offsets,
	      position = _ref2.position,
	      gpuAcceleration = _ref2.gpuAcceleration,
	      adaptive = _ref2.adaptive,
	      roundOffsets = _ref2.roundOffsets;

	  var _ref3 = roundOffsets === true ? roundOffsetsByDPR(offsets) : typeof roundOffsets === 'function' ? roundOffsets(offsets) : offsets,
	      _ref3$x = _ref3.x,
	      x = _ref3$x === void 0 ? 0 : _ref3$x,
	      _ref3$y = _ref3.y,
	      y = _ref3$y === void 0 ? 0 : _ref3$y;

	  var hasX = offsets.hasOwnProperty('x');
	  var hasY = offsets.hasOwnProperty('y');
	  var sideX = left;
	  var sideY = top;
	  var win = window;

	  if (adaptive) {
	    var offsetParent = getOffsetParent(popper);
	    var heightProp = 'clientHeight';
	    var widthProp = 'clientWidth';

	    if (offsetParent === getWindow(popper)) {
	      offsetParent = getDocumentElement(popper);

	      if (getComputedStyle$1(offsetParent).position !== 'static') {
	        heightProp = 'scrollHeight';
	        widthProp = 'scrollWidth';
	      }
	    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


	    offsetParent = offsetParent;

	    if (placement === top) {
	      sideY = bottom; // $FlowFixMe[prop-missing]

	      y -= offsetParent[heightProp] - popperRect.height;
	      y *= gpuAcceleration ? 1 : -1;
	    }

	    if (placement === left) {
	      sideX = right; // $FlowFixMe[prop-missing]

	      x -= offsetParent[widthProp] - popperRect.width;
	      x *= gpuAcceleration ? 1 : -1;
	    }
	  }

	  var commonStyles = Object.assign({
	    position: position
	  }, adaptive && unsetSides);

	  if (gpuAcceleration) {
	    var _Object$assign;

	    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
	  }

	  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
	}

	function computeStyles(_ref4) {
	  var state = _ref4.state,
	      options = _ref4.options;
	  var _options$gpuAccelerat = options.gpuAcceleration,
	      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
	      _options$adaptive = options.adaptive,
	      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
	      _options$roundOffsets = options.roundOffsets,
	      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

	  {
	    var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || '';

	    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
	      return transitionProperty.indexOf(property) >= 0;
	    })) {
	      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
	    }
	  }

	  var commonStyles = {
	    placement: getBasePlacement(state.placement),
	    popper: state.elements.popper,
	    popperRect: state.rects.popper,
	    gpuAcceleration: gpuAcceleration
	  };

	  if (state.modifiersData.popperOffsets != null) {
	    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
	      offsets: state.modifiersData.popperOffsets,
	      position: state.options.strategy,
	      adaptive: adaptive,
	      roundOffsets: roundOffsets
	    })));
	  }

	  if (state.modifiersData.arrow != null) {
	    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
	      offsets: state.modifiersData.arrow,
	      position: 'absolute',
	      adaptive: false,
	      roundOffsets: roundOffsets
	    })));
	  }

	  state.attributes.popper = Object.assign({}, state.attributes.popper, {
	    'data-popper-placement': state.placement
	  });
	} // eslint-disable-next-line import/no-unused-modules


	var computeStyles$1 = {
	  name: 'computeStyles',
	  enabled: true,
	  phase: 'beforeWrite',
	  fn: computeStyles,
	  data: {}
	};

	var passive = {
	  passive: true
	};

	function effect$3(_ref) {
	  var state = _ref.state,
	      instance = _ref.instance,
	      options = _ref.options;
	  var _options$scroll = options.scroll,
	      scroll = _options$scroll === void 0 ? true : _options$scroll,
	      _options$resize = options.resize,
	      resize = _options$resize === void 0 ? true : _options$resize;
	  var window = getWindow(state.elements.popper);
	  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

	  if (scroll) {
	    scrollParents.forEach(function (scrollParent) {
	      scrollParent.addEventListener('scroll', instance.update, passive);
	    });
	  }

	  if (resize) {
	    window.addEventListener('resize', instance.update, passive);
	  }

	  return function () {
	    if (scroll) {
	      scrollParents.forEach(function (scrollParent) {
	        scrollParent.removeEventListener('scroll', instance.update, passive);
	      });
	    }

	    if (resize) {
	      window.removeEventListener('resize', instance.update, passive);
	    }
	  };
	} // eslint-disable-next-line import/no-unused-modules


	var eventListeners = {
	  name: 'eventListeners',
	  enabled: true,
	  phase: 'write',
	  fn: function fn() {},
	  effect: effect$3,
	  data: {}
	};

	var hash = {
	  left: 'right',
	  right: 'left',
	  bottom: 'top',
	  top: 'bottom'
	};
	function getOppositePlacement(placement) {
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}

	var hash$1 = {
	  start: 'end',
	  end: 'start'
	};
	function getOppositeVariationPlacement(placement) {
	  return placement.replace(/start|end/g, function (matched) {
	    return hash$1[matched];
	  });
	}

	function getWindowScroll(node) {
	  var win = getWindow(node);
	  var scrollLeft = win.pageXOffset;
	  var scrollTop = win.pageYOffset;
	  return {
	    scrollLeft: scrollLeft,
	    scrollTop: scrollTop
	  };
	}

	function getWindowScrollBarX(element) {
	  // If <html> has a CSS width greater than the viewport, then this will be
	  // incorrect for RTL.
	  // Popper 1 is broken in this case and never had a bug report so let's assume
	  // it's not an issue. I don't think anyone ever specifies width on <html>
	  // anyway.
	  // Browsers where the left scrollbar doesn't cause an issue report `0` for
	  // this (e.g. Edge 2019, IE11, Safari)
	  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
	}

	function getViewportRect(element) {
	  var win = getWindow(element);
	  var html = getDocumentElement(element);
	  var visualViewport = win.visualViewport;
	  var width = html.clientWidth;
	  var height = html.clientHeight;
	  var x = 0;
	  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
	  // can be obscured underneath it.
	  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
	  // if it isn't open, so if this isn't available, the popper will be detected
	  // to overflow the bottom of the screen too early.

	  if (visualViewport) {
	    width = visualViewport.width;
	    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
	    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
	    // errors due to floating point numbers, so we need to check precision.
	    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
	    // Feature detection fails in mobile emulation mode in Chrome.
	    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
	    // 0.001
	    // Fallback here: "Not Safari" userAgent

	    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
	      x = visualViewport.offsetLeft;
	      y = visualViewport.offsetTop;
	    }
	  }

	  return {
	    width: width,
	    height: height,
	    x: x + getWindowScrollBarX(element),
	    y: y
	  };
	}

	// of the `<html>` and `<body>` rect bounds if horizontally scrollable

	function getDocumentRect(element) {
	  var _element$ownerDocumen;

	  var html = getDocumentElement(element);
	  var winScroll = getWindowScroll(element);
	  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
	  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
	  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
	  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
	  var y = -winScroll.scrollTop;

	  if (getComputedStyle$1(body || html).direction === 'rtl') {
	    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
	  }

	  return {
	    width: width,
	    height: height,
	    x: x,
	    y: y
	  };
	}

	function isScrollParent(element) {
	  // Firefox wants us to check `-x` and `-y` variations as well
	  var _getComputedStyle = getComputedStyle$1(element),
	      overflow = _getComputedStyle.overflow,
	      overflowX = _getComputedStyle.overflowX,
	      overflowY = _getComputedStyle.overflowY;

	  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
	}

	function getScrollParent(node) {
	  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
	    // $FlowFixMe[incompatible-return]: assume body is always available
	    return node.ownerDocument.body;
	  }

	  if (isHTMLElement(node) && isScrollParent(node)) {
	    return node;
	  }

	  return getScrollParent(getParentNode(node));
	}

	/*
	given a DOM element, return the list of all scroll parents, up the list of ancesors
	until we get to the top window object. This list is what we attach scroll listeners
	to, because if any of these parent elements scroll, we'll need to re-calculate the
	reference element's position.
	*/

	function listScrollParents(element, list) {
	  var _element$ownerDocumen;

	  if (list === void 0) {
	    list = [];
	  }

	  var scrollParent = getScrollParent(element);
	  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
	  var win = getWindow(scrollParent);
	  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
	  var updatedList = list.concat(target);
	  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
	  updatedList.concat(listScrollParents(getParentNode(target)));
	}

	function rectToClientRect(rect) {
	  return Object.assign({}, rect, {
	    left: rect.x,
	    top: rect.y,
	    right: rect.x + rect.width,
	    bottom: rect.y + rect.height
	  });
	}

	function getInnerBoundingClientRect(element) {
	  var rect = getBoundingClientRect(element);
	  rect.top = rect.top + element.clientTop;
	  rect.left = rect.left + element.clientLeft;
	  rect.bottom = rect.top + element.clientHeight;
	  rect.right = rect.left + element.clientWidth;
	  rect.width = element.clientWidth;
	  rect.height = element.clientHeight;
	  rect.x = rect.left;
	  rect.y = rect.top;
	  return rect;
	}

	function getClientRectFromMixedType(element, clippingParent) {
	  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isHTMLElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
	} // A "clipping parent" is an overflowable container with the characteristic of
	// clipping (or hiding) overflowing elements with a position different from
	// `initial`


	function getClippingParents(element) {
	  var clippingParents = listScrollParents(getParentNode(element));
	  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
	  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

	  if (!isElement(clipperElement)) {
	    return [];
	  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


	  return clippingParents.filter(function (clippingParent) {
	    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
	  });
	} // Gets the maximum area that the element is visible in due to any number of
	// clipping parents


	function getClippingRect(element, boundary, rootBoundary) {
	  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
	  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
	  var firstClippingParent = clippingParents[0];
	  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
	    var rect = getClientRectFromMixedType(element, clippingParent);
	    accRect.top = max(rect.top, accRect.top);
	    accRect.right = min(rect.right, accRect.right);
	    accRect.bottom = min(rect.bottom, accRect.bottom);
	    accRect.left = max(rect.left, accRect.left);
	    return accRect;
	  }, getClientRectFromMixedType(element, firstClippingParent));
	  clippingRect.width = clippingRect.right - clippingRect.left;
	  clippingRect.height = clippingRect.bottom - clippingRect.top;
	  clippingRect.x = clippingRect.left;
	  clippingRect.y = clippingRect.top;
	  return clippingRect;
	}

	function getVariation(placement) {
	  return placement.split('-')[1];
	}

	function computeOffsets(_ref) {
	  var reference = _ref.reference,
	      element = _ref.element,
	      placement = _ref.placement;
	  var basePlacement = placement ? getBasePlacement(placement) : null;
	  var variation = placement ? getVariation(placement) : null;
	  var commonX = reference.x + reference.width / 2 - element.width / 2;
	  var commonY = reference.y + reference.height / 2 - element.height / 2;
	  var offsets;

	  switch (basePlacement) {
	    case top:
	      offsets = {
	        x: commonX,
	        y: reference.y - element.height
	      };
	      break;

	    case bottom:
	      offsets = {
	        x: commonX,
	        y: reference.y + reference.height
	      };
	      break;

	    case right:
	      offsets = {
	        x: reference.x + reference.width,
	        y: commonY
	      };
	      break;

	    case left:
	      offsets = {
	        x: reference.x - element.width,
	        y: commonY
	      };
	      break;

	    default:
	      offsets = {
	        x: reference.x,
	        y: reference.y
	      };
	  }

	  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

	  if (mainAxis != null) {
	    var len = mainAxis === 'y' ? 'height' : 'width';

	    switch (variation) {
	      case start:
	        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
	        break;

	      case end:
	        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
	        break;
	    }
	  }

	  return offsets;
	}

	function detectOverflow(state, options) {
	  if (options === void 0) {
	    options = {};
	  }

	  var _options = options,
	      _options$placement = _options.placement,
	      placement = _options$placement === void 0 ? state.placement : _options$placement,
	      _options$boundary = _options.boundary,
	      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
	      _options$rootBoundary = _options.rootBoundary,
	      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
	      _options$elementConte = _options.elementContext,
	      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
	      _options$altBoundary = _options.altBoundary,
	      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
	      _options$padding = _options.padding,
	      padding = _options$padding === void 0 ? 0 : _options$padding;
	  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
	  var altContext = elementContext === popper ? reference : popper;
	  var referenceElement = state.elements.reference;
	  var popperRect = state.rects.popper;
	  var element = state.elements[altBoundary ? altContext : elementContext];
	  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
	  var referenceClientRect = getBoundingClientRect(referenceElement);
	  var popperOffsets = computeOffsets({
	    reference: referenceClientRect,
	    element: popperRect,
	    strategy: 'absolute',
	    placement: placement
	  });
	  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
	  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
	  // 0 or negative = within the clipping rect

	  var overflowOffsets = {
	    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
	    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
	    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
	    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
	  };
	  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

	  if (elementContext === popper && offsetData) {
	    var offset = offsetData[placement];
	    Object.keys(overflowOffsets).forEach(function (key) {
	      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
	      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
	      overflowOffsets[key] += offset[axis] * multiply;
	    });
	  }

	  return overflowOffsets;
	}

	function computeAutoPlacement(state, options) {
	  if (options === void 0) {
	    options = {};
	  }

	  var _options = options,
	      placement = _options.placement,
	      boundary = _options.boundary,
	      rootBoundary = _options.rootBoundary,
	      padding = _options.padding,
	      flipVariations = _options.flipVariations,
	      _options$allowedAutoP = _options.allowedAutoPlacements,
	      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
	  var variation = getVariation(placement);
	  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
	    return getVariation(placement) === variation;
	  }) : basePlacements;
	  var allowedPlacements = placements$1.filter(function (placement) {
	    return allowedAutoPlacements.indexOf(placement) >= 0;
	  });

	  if (allowedPlacements.length === 0) {
	    allowedPlacements = placements$1;

	    {
	      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
	    }
	  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


	  var overflows = allowedPlacements.reduce(function (acc, placement) {
	    acc[placement] = detectOverflow(state, {
	      placement: placement,
	      boundary: boundary,
	      rootBoundary: rootBoundary,
	      padding: padding
	    })[getBasePlacement(placement)];
	    return acc;
	  }, {});
	  return Object.keys(overflows).sort(function (a, b) {
	    return overflows[a] - overflows[b];
	  });
	}

	function getExpandedFallbackPlacements(placement) {
	  if (getBasePlacement(placement) === auto) {
	    return [];
	  }

	  var oppositePlacement = getOppositePlacement(placement);
	  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
	}

	function flip(_ref) {
	  var state = _ref.state,
	      options = _ref.options,
	      name = _ref.name;

	  if (state.modifiersData[name]._skip) {
	    return;
	  }

	  var _options$mainAxis = options.mainAxis,
	      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
	      _options$altAxis = options.altAxis,
	      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
	      specifiedFallbackPlacements = options.fallbackPlacements,
	      padding = options.padding,
	      boundary = options.boundary,
	      rootBoundary = options.rootBoundary,
	      altBoundary = options.altBoundary,
	      _options$flipVariatio = options.flipVariations,
	      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
	      allowedAutoPlacements = options.allowedAutoPlacements;
	  var preferredPlacement = state.options.placement;
	  var basePlacement = getBasePlacement(preferredPlacement);
	  var isBasePlacement = basePlacement === preferredPlacement;
	  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
	  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
	    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
	      placement: placement,
	      boundary: boundary,
	      rootBoundary: rootBoundary,
	      padding: padding,
	      flipVariations: flipVariations,
	      allowedAutoPlacements: allowedAutoPlacements
	    }) : placement);
	  }, []);
	  var referenceRect = state.rects.reference;
	  var popperRect = state.rects.popper;
	  var checksMap = new Map();
	  var makeFallbackChecks = true;
	  var firstFittingPlacement = placements[0];

	  for (var i = 0; i < placements.length; i++) {
	    var placement = placements[i];

	    var _basePlacement = getBasePlacement(placement);

	    var isStartVariation = getVariation(placement) === start;
	    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
	    var len = isVertical ? 'width' : 'height';
	    var overflow = detectOverflow(state, {
	      placement: placement,
	      boundary: boundary,
	      rootBoundary: rootBoundary,
	      altBoundary: altBoundary,
	      padding: padding
	    });
	    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

	    if (referenceRect[len] > popperRect[len]) {
	      mainVariationSide = getOppositePlacement(mainVariationSide);
	    }

	    var altVariationSide = getOppositePlacement(mainVariationSide);
	    var checks = [];

	    if (checkMainAxis) {
	      checks.push(overflow[_basePlacement] <= 0);
	    }

	    if (checkAltAxis) {
	      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
	    }

	    if (checks.every(function (check) {
	      return check;
	    })) {
	      firstFittingPlacement = placement;
	      makeFallbackChecks = false;
	      break;
	    }

	    checksMap.set(placement, checks);
	  }

	  if (makeFallbackChecks) {
	    // `2` may be desired in some cases – research later
	    var numberOfChecks = flipVariations ? 3 : 1;

	    var _loop = function _loop(_i) {
	      var fittingPlacement = placements.find(function (placement) {
	        var checks = checksMap.get(placement);

	        if (checks) {
	          return checks.slice(0, _i).every(function (check) {
	            return check;
	          });
	        }
	      });

	      if (fittingPlacement) {
	        firstFittingPlacement = fittingPlacement;
	        return "break";
	      }
	    };

	    for (var _i = numberOfChecks; _i > 0; _i--) {
	      var _ret = _loop(_i);

	      if (_ret === "break") break;
	    }
	  }

	  if (state.placement !== firstFittingPlacement) {
	    state.modifiersData[name]._skip = true;
	    state.placement = firstFittingPlacement;
	    state.reset = true;
	  }
	} // eslint-disable-next-line import/no-unused-modules


	var flip$1 = {
	  name: 'flip',
	  enabled: true,
	  phase: 'main',
	  fn: flip,
	  requiresIfExists: ['offset'],
	  data: {
	    _skip: false
	  }
	};

	function getSideOffsets(overflow, rect, preventedOffsets) {
	  if (preventedOffsets === void 0) {
	    preventedOffsets = {
	      x: 0,
	      y: 0
	    };
	  }

	  return {
	    top: overflow.top - rect.height - preventedOffsets.y,
	    right: overflow.right - rect.width + preventedOffsets.x,
	    bottom: overflow.bottom - rect.height + preventedOffsets.y,
	    left: overflow.left - rect.width - preventedOffsets.x
	  };
	}

	function isAnySideFullyClipped(overflow) {
	  return [top, right, bottom, left].some(function (side) {
	    return overflow[side] >= 0;
	  });
	}

	function hide(_ref) {
	  var state = _ref.state,
	      name = _ref.name;
	  var referenceRect = state.rects.reference;
	  var popperRect = state.rects.popper;
	  var preventedOffsets = state.modifiersData.preventOverflow;
	  var referenceOverflow = detectOverflow(state, {
	    elementContext: 'reference'
	  });
	  var popperAltOverflow = detectOverflow(state, {
	    altBoundary: true
	  });
	  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
	  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
	  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
	  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
	  state.modifiersData[name] = {
	    referenceClippingOffsets: referenceClippingOffsets,
	    popperEscapeOffsets: popperEscapeOffsets,
	    isReferenceHidden: isReferenceHidden,
	    hasPopperEscaped: hasPopperEscaped
	  };
	  state.attributes.popper = Object.assign({}, state.attributes.popper, {
	    'data-popper-reference-hidden': isReferenceHidden,
	    'data-popper-escaped': hasPopperEscaped
	  });
	} // eslint-disable-next-line import/no-unused-modules


	var hide$1 = {
	  name: 'hide',
	  enabled: true,
	  phase: 'main',
	  requiresIfExists: ['preventOverflow'],
	  fn: hide
	};

	function distanceAndSkiddingToXY(placement, rects, offset) {
	  var basePlacement = getBasePlacement(placement);
	  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

	  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
	    placement: placement
	  })) : offset,
	      skidding = _ref[0],
	      distance = _ref[1];

	  skidding = skidding || 0;
	  distance = (distance || 0) * invertDistance;
	  return [left, right].indexOf(basePlacement) >= 0 ? {
	    x: distance,
	    y: skidding
	  } : {
	    x: skidding,
	    y: distance
	  };
	}

	function offset(_ref2) {
	  var state = _ref2.state,
	      options = _ref2.options,
	      name = _ref2.name;
	  var _options$offset = options.offset,
	      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
	  var data = placements.reduce(function (acc, placement) {
	    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
	    return acc;
	  }, {});
	  var _data$state$placement = data[state.placement],
	      x = _data$state$placement.x,
	      y = _data$state$placement.y;

	  if (state.modifiersData.popperOffsets != null) {
	    state.modifiersData.popperOffsets.x += x;
	    state.modifiersData.popperOffsets.y += y;
	  }

	  state.modifiersData[name] = data;
	} // eslint-disable-next-line import/no-unused-modules


	var offset$1 = {
	  name: 'offset',
	  enabled: true,
	  phase: 'main',
	  requires: ['popperOffsets'],
	  fn: offset
	};

	function popperOffsets(_ref) {
	  var state = _ref.state,
	      name = _ref.name;
	  // Offsets are the actual position the popper needs to have to be
	  // properly positioned near its reference element
	  // This is the most basic placement, and will be adjusted by
	  // the modifiers in the next step
	  state.modifiersData[name] = computeOffsets({
	    reference: state.rects.reference,
	    element: state.rects.popper,
	    strategy: 'absolute',
	    placement: state.placement
	  });
	} // eslint-disable-next-line import/no-unused-modules


	var popperOffsets$1 = {
	  name: 'popperOffsets',
	  enabled: true,
	  phase: 'read',
	  fn: popperOffsets,
	  data: {}
	};

	function getAltAxis(axis) {
	  return axis === 'x' ? 'y' : 'x';
	}

	function preventOverflow(_ref) {
	  var state = _ref.state,
	      options = _ref.options,
	      name = _ref.name;
	  var _options$mainAxis = options.mainAxis,
	      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
	      _options$altAxis = options.altAxis,
	      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
	      boundary = options.boundary,
	      rootBoundary = options.rootBoundary,
	      altBoundary = options.altBoundary,
	      padding = options.padding,
	      _options$tether = options.tether,
	      tether = _options$tether === void 0 ? true : _options$tether,
	      _options$tetherOffset = options.tetherOffset,
	      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
	  var overflow = detectOverflow(state, {
	    boundary: boundary,
	    rootBoundary: rootBoundary,
	    padding: padding,
	    altBoundary: altBoundary
	  });
	  var basePlacement = getBasePlacement(state.placement);
	  var variation = getVariation(state.placement);
	  var isBasePlacement = !variation;
	  var mainAxis = getMainAxisFromPlacement(basePlacement);
	  var altAxis = getAltAxis(mainAxis);
	  var popperOffsets = state.modifiersData.popperOffsets;
	  var referenceRect = state.rects.reference;
	  var popperRect = state.rects.popper;
	  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
	    placement: state.placement
	  })) : tetherOffset;
	  var data = {
	    x: 0,
	    y: 0
	  };

	  if (!popperOffsets) {
	    return;
	  }

	  if (checkMainAxis || checkAltAxis) {
	    var mainSide = mainAxis === 'y' ? top : left;
	    var altSide = mainAxis === 'y' ? bottom : right;
	    var len = mainAxis === 'y' ? 'height' : 'width';
	    var offset = popperOffsets[mainAxis];
	    var min$1 = popperOffsets[mainAxis] + overflow[mainSide];
	    var max$1 = popperOffsets[mainAxis] - overflow[altSide];
	    var additive = tether ? -popperRect[len] / 2 : 0;
	    var minLen = variation === start ? referenceRect[len] : popperRect[len];
	    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
	    // outside the reference bounds

	    var arrowElement = state.elements.arrow;
	    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
	      width: 0,
	      height: 0
	    };
	    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
	    var arrowPaddingMin = arrowPaddingObject[mainSide];
	    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
	    // to include its full size in the calculation. If the reference is small
	    // and near the edge of a boundary, the popper can overflow even if the
	    // reference is not overflowing as well (e.g. virtual elements with no
	    // width or height)

	    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
	    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
	    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
	    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
	    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
	    var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
	    var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
	    var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;

	    if (checkMainAxis) {
	      var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
	      popperOffsets[mainAxis] = preventedOffset;
	      data[mainAxis] = preventedOffset - offset;
	    }

	    if (checkAltAxis) {
	      var _mainSide = mainAxis === 'x' ? top : left;

	      var _altSide = mainAxis === 'x' ? bottom : right;

	      var _offset = popperOffsets[altAxis];

	      var _min = _offset + overflow[_mainSide];

	      var _max = _offset - overflow[_altSide];

	      var _preventedOffset = within(tether ? min(_min, tetherMin) : _min, _offset, tether ? max(_max, tetherMax) : _max);

	      popperOffsets[altAxis] = _preventedOffset;
	      data[altAxis] = _preventedOffset - _offset;
	    }
	  }

	  state.modifiersData[name] = data;
	} // eslint-disable-next-line import/no-unused-modules


	var preventOverflow$1 = {
	  name: 'preventOverflow',
	  enabled: true,
	  phase: 'main',
	  fn: preventOverflow,
	  requiresIfExists: ['offset']
	};

	function getHTMLElementScroll(element) {
	  return {
	    scrollLeft: element.scrollLeft,
	    scrollTop: element.scrollTop
	  };
	}

	function getNodeScroll(node) {
	  if (node === getWindow(node) || !isHTMLElement(node)) {
	    return getWindowScroll(node);
	  } else {
	    return getHTMLElementScroll(node);
	  }
	}

	// Composite means it takes into account transforms as well as layout.

	function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
	  if (isFixed === void 0) {
	    isFixed = false;
	  }

	  var documentElement = getDocumentElement(offsetParent);
	  var rect = getBoundingClientRect(elementOrVirtualElement);
	  var isOffsetParentAnElement = isHTMLElement(offsetParent);
	  var scroll = {
	    scrollLeft: 0,
	    scrollTop: 0
	  };
	  var offsets = {
	    x: 0,
	    y: 0
	  };

	  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
	    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
	    isScrollParent(documentElement)) {
	      scroll = getNodeScroll(offsetParent);
	    }

	    if (isHTMLElement(offsetParent)) {
	      offsets = getBoundingClientRect(offsetParent);
	      offsets.x += offsetParent.clientLeft;
	      offsets.y += offsetParent.clientTop;
	    } else if (documentElement) {
	      offsets.x = getWindowScrollBarX(documentElement);
	    }
	  }

	  return {
	    x: rect.left + scroll.scrollLeft - offsets.x,
	    y: rect.top + scroll.scrollTop - offsets.y,
	    width: rect.width,
	    height: rect.height
	  };
	}

	function order(modifiers) {
	  var map = new Map();
	  var visited = new Set();
	  var result = [];
	  modifiers.forEach(function (modifier) {
	    map.set(modifier.name, modifier);
	  }); // On visiting object, check for its dependencies and visit them recursively

	  function sort(modifier) {
	    visited.add(modifier.name);
	    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
	    requires.forEach(function (dep) {
	      if (!visited.has(dep)) {
	        var depModifier = map.get(dep);

	        if (depModifier) {
	          sort(depModifier);
	        }
	      }
	    });
	    result.push(modifier);
	  }

	  modifiers.forEach(function (modifier) {
	    if (!visited.has(modifier.name)) {
	      // check for visited object
	      sort(modifier);
	    }
	  });
	  return result;
	}

	function orderModifiers(modifiers) {
	  // order based on dependencies
	  var orderedModifiers = order(modifiers); // order based on phase

	  return modifierPhases.reduce(function (acc, phase) {
	    return acc.concat(orderedModifiers.filter(function (modifier) {
	      return modifier.phase === phase;
	    }));
	  }, []);
	}

	function debounce(fn) {
	  var pending;
	  return function () {
	    if (!pending) {
	      pending = new Promise(function (resolve) {
	        Promise.resolve().then(function () {
	          pending = undefined;
	          resolve(fn());
	        });
	      });
	    }

	    return pending;
	  };
	}

	function format(str) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }

	  return [].concat(args).reduce(function (p, c) {
	    return p.replace(/%s/, c);
	  }, str);
	}

	var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
	var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
	var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
	function validateModifiers(modifiers) {
	  modifiers.forEach(function (modifier) {
	    Object.keys(modifier).forEach(function (key) {
	      switch (key) {
	        case 'name':
	          if (typeof modifier.name !== 'string') {
	            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
	          }

	          break;

	        case 'enabled':
	          if (typeof modifier.enabled !== 'boolean') {
	            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
	          }

	        case 'phase':
	          if (modifierPhases.indexOf(modifier.phase) < 0) {
	            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
	          }

	          break;

	        case 'fn':
	          if (typeof modifier.fn !== 'function') {
	            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
	          }

	          break;

	        case 'effect':
	          if (typeof modifier.effect !== 'function') {
	            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
	          }

	          break;

	        case 'requires':
	          if (!Array.isArray(modifier.requires)) {
	            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
	          }

	          break;

	        case 'requiresIfExists':
	          if (!Array.isArray(modifier.requiresIfExists)) {
	            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
	          }

	          break;

	        case 'options':
	        case 'data':
	          break;

	        default:
	          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
	            return "\"" + s + "\"";
	          }).join(', ') + "; but \"" + key + "\" was provided.");
	      }

	      modifier.requires && modifier.requires.forEach(function (requirement) {
	        if (modifiers.find(function (mod) {
	          return mod.name === requirement;
	        }) == null) {
	          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
	        }
	      });
	    });
	  });
	}

	function uniqueBy(arr, fn) {
	  var identifiers = new Set();
	  return arr.filter(function (item) {
	    var identifier = fn(item);

	    if (!identifiers.has(identifier)) {
	      identifiers.add(identifier);
	      return true;
	    }
	  });
	}

	function mergeByName(modifiers) {
	  var merged = modifiers.reduce(function (merged, current) {
	    var existing = merged[current.name];
	    merged[current.name] = existing ? Object.assign({}, existing, current, {
	      options: Object.assign({}, existing.options, current.options),
	      data: Object.assign({}, existing.data, current.data)
	    }) : current;
	    return merged;
	  }, {}); // IE11 does not support Object.values

	  return Object.keys(merged).map(function (key) {
	    return merged[key];
	  });
	}

	var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
	var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
	var DEFAULT_OPTIONS = {
	  placement: 'bottom',
	  modifiers: [],
	  strategy: 'absolute'
	};

	function areValidElements() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }

	  return !args.some(function (element) {
	    return !(element && typeof element.getBoundingClientRect === 'function');
	  });
	}

	function popperGenerator(generatorOptions) {
	  if (generatorOptions === void 0) {
	    generatorOptions = {};
	  }

	  var _generatorOptions = generatorOptions,
	      _generatorOptions$def = _generatorOptions.defaultModifiers,
	      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
	      _generatorOptions$def2 = _generatorOptions.defaultOptions,
	      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
	  return function createPopper(reference, popper, options) {
	    if (options === void 0) {
	      options = defaultOptions;
	    }

	    var state = {
	      placement: 'bottom',
	      orderedModifiers: [],
	      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
	      modifiersData: {},
	      elements: {
	        reference: reference,
	        popper: popper
	      },
	      attributes: {},
	      styles: {}
	    };
	    var effectCleanupFns = [];
	    var isDestroyed = false;
	    var instance = {
	      state: state,
	      setOptions: function setOptions(options) {
	        cleanupModifierEffects();
	        state.options = Object.assign({}, defaultOptions, state.options, options);
	        state.scrollParents = {
	          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
	          popper: listScrollParents(popper)
	        }; // Orders the modifiers based on their dependencies and `phase`
	        // properties

	        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

	        state.orderedModifiers = orderedModifiers.filter(function (m) {
	          return m.enabled;
	        }); // Validate the provided modifiers so that the consumer will get warned
	        // if one of the modifiers is invalid for any reason

	        {
	          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
	            var name = _ref.name;
	            return name;
	          });
	          validateModifiers(modifiers);

	          if (getBasePlacement(state.options.placement) === auto) {
	            var flipModifier = state.orderedModifiers.find(function (_ref2) {
	              var name = _ref2.name;
	              return name === 'flip';
	            });

	            if (!flipModifier) {
	              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
	            }
	          }

	          var _getComputedStyle = getComputedStyle$1(popper),
	              marginTop = _getComputedStyle.marginTop,
	              marginRight = _getComputedStyle.marginRight,
	              marginBottom = _getComputedStyle.marginBottom,
	              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
	          // cause bugs with positioning, so we'll warn the consumer


	          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
	            return parseFloat(margin);
	          })) {
	            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
	          }
	        }

	        runModifierEffects();
	        return instance.update();
	      },
	      // Sync update – it will always be executed, even if not necessary. This
	      // is useful for low frequency updates where sync behavior simplifies the
	      // logic.
	      // For high frequency updates (e.g. `resize` and `scroll` events), always
	      // prefer the async Popper#update method
	      forceUpdate: function forceUpdate() {
	        if (isDestroyed) {
	          return;
	        }

	        var _state$elements = state.elements,
	            reference = _state$elements.reference,
	            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
	        // anymore

	        if (!areValidElements(reference, popper)) {
	          {
	            console.error(INVALID_ELEMENT_ERROR);
	          }

	          return;
	        } // Store the reference and popper rects to be read by modifiers


	        state.rects = {
	          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
	          popper: getLayoutRect(popper)
	        }; // Modifiers have the ability to reset the current update cycle. The
	        // most common use case for this is the `flip` modifier changing the
	        // placement, which then needs to re-run all the modifiers, because the
	        // logic was previously ran for the previous placement and is therefore
	        // stale/incorrect

	        state.reset = false;
	        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
	        // is filled with the initial data specified by the modifier. This means
	        // it doesn't persist and is fresh on each update.
	        // To ensure persistent data, use `${name}#persistent`

	        state.orderedModifiers.forEach(function (modifier) {
	          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
	        });
	        var __debug_loops__ = 0;

	        for (var index = 0; index < state.orderedModifiers.length; index++) {
	          {
	            __debug_loops__ += 1;

	            if (__debug_loops__ > 100) {
	              console.error(INFINITE_LOOP_ERROR);
	              break;
	            }
	          }

	          if (state.reset === true) {
	            state.reset = false;
	            index = -1;
	            continue;
	          }

	          var _state$orderedModifie = state.orderedModifiers[index],
	              fn = _state$orderedModifie.fn,
	              _state$orderedModifie2 = _state$orderedModifie.options,
	              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
	              name = _state$orderedModifie.name;

	          if (typeof fn === 'function') {
	            state = fn({
	              state: state,
	              options: _options,
	              name: name,
	              instance: instance
	            }) || state;
	          }
	        }
	      },
	      // Async and optimistically optimized update – it will not be executed if
	      // not necessary (debounced to run at most once-per-tick)
	      update: debounce(function () {
	        return new Promise(function (resolve) {
	          instance.forceUpdate();
	          resolve(state);
	        });
	      }),
	      destroy: function destroy() {
	        cleanupModifierEffects();
	        isDestroyed = true;
	      }
	    };

	    if (!areValidElements(reference, popper)) {
	      {
	        console.error(INVALID_ELEMENT_ERROR);
	      }

	      return instance;
	    }

	    instance.setOptions(options).then(function (state) {
	      if (!isDestroyed && options.onFirstUpdate) {
	        options.onFirstUpdate(state);
	      }
	    }); // Modifiers have the ability to execute arbitrary code before the first
	    // update cycle runs. They will be executed in the same order as the update
	    // cycle. This is useful when a modifier adds some persistent data that
	    // other modifiers need to use, but the modifier is run after the dependent
	    // one.

	    function runModifierEffects() {
	      state.orderedModifiers.forEach(function (_ref3) {
	        var name = _ref3.name,
	            _ref3$options = _ref3.options,
	            options = _ref3$options === void 0 ? {} : _ref3$options,
	            effect = _ref3.effect;

	        if (typeof effect === 'function') {
	          var cleanupFn = effect({
	            state: state,
	            name: name,
	            instance: instance,
	            options: options
	          });

	          var noopFn = function noopFn() {};

	          effectCleanupFns.push(cleanupFn || noopFn);
	        }
	      });
	    }

	    function cleanupModifierEffects() {
	      effectCleanupFns.forEach(function (fn) {
	        return fn();
	      });
	      effectCleanupFns = [];
	    }

	    return instance;
	  };
	}

	var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
	var createPopper = /*#__PURE__*/popperGenerator({
	  defaultModifiers: defaultModifiers
	}); // eslint-disable-next-line import/no-unused-modules

	/**!
	* tippy.js v6.3.1
	* (c) 2017-2021 atomiks
	* MIT License
	*/
	var BOX_CLASS = "tippy-box";
	var CONTENT_CLASS = "tippy-content";
	var BACKDROP_CLASS = "tippy-backdrop";
	var ARROW_CLASS = "tippy-arrow";
	var SVG_ARROW_CLASS = "tippy-svg-arrow";
	var TOUCH_OPTIONS = {
	  passive: true,
	  capture: true
	};

	function hasOwnProperty$1(obj, key) {
	  return {}.hasOwnProperty.call(obj, key);
	}
	function getValueAtIndexOrReturn(value, index, defaultValue) {
	  if (Array.isArray(value)) {
	    var v = value[index];
	    return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
	  }

	  return value;
	}
	function isType(value, type) {
	  var str = {}.toString.call(value);
	  return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
	}
	function invokeWithArgsOrReturn(value, args) {
	  return typeof value === 'function' ? value.apply(void 0, args) : value;
	}
	function debounce$1(fn, ms) {
	  // Avoid wrapping in `setTimeout` if ms is 0 anyway
	  if (ms === 0) {
	    return fn;
	  }

	  var timeout;
	  return function (arg) {
	    clearTimeout(timeout);
	    timeout = setTimeout(function () {
	      fn(arg);
	    }, ms);
	  };
	}
	function removeProperties(obj, keys) {
	  var clone = Object.assign({}, obj);
	  keys.forEach(function (key) {
	    delete clone[key];
	  });
	  return clone;
	}
	function splitBySpaces(value) {
	  return value.split(/\s+/).filter(Boolean);
	}
	function normalizeToArray(value) {
	  return [].concat(value);
	}
	function pushIfUnique(arr, value) {
	  if (arr.indexOf(value) === -1) {
	    arr.push(value);
	  }
	}
	function unique(arr) {
	  return arr.filter(function (item, index) {
	    return arr.indexOf(item) === index;
	  });
	}
	function getBasePlacement$1(placement) {
	  return placement.split('-')[0];
	}
	function arrayFrom(value) {
	  return [].slice.call(value);
	}
	function removeUndefinedProps(obj) {
	  return Object.keys(obj).reduce(function (acc, key) {
	    if (obj[key] !== undefined) {
	      acc[key] = obj[key];
	    }

	    return acc;
	  }, {});
	}

	function div() {
	  return document.createElement('div');
	}
	function isElement$1(value) {
	  return ['Element', 'Fragment'].some(function (type) {
	    return isType(value, type);
	  });
	}
	function isNodeList(value) {
	  return isType(value, 'NodeList');
	}
	function isMouseEvent(value) {
	  return isType(value, 'MouseEvent');
	}
	function isReferenceElement(value) {
	  return !!(value && value._tippy && value._tippy.reference === value);
	}
	function getArrayOfElements(value) {
	  if (isElement$1(value)) {
	    return [value];
	  }

	  if (isNodeList(value)) {
	    return arrayFrom(value);
	  }

	  if (Array.isArray(value)) {
	    return value;
	  }

	  return arrayFrom(document.querySelectorAll(value));
	}
	function setTransitionDuration(els, value) {
	  els.forEach(function (el) {
	    if (el) {
	      el.style.transitionDuration = value + "ms";
	    }
	  });
	}
	function setVisibilityState(els, state) {
	  els.forEach(function (el) {
	    if (el) {
	      el.setAttribute('data-state', state);
	    }
	  });
	}
	function getOwnerDocument(elementOrElements) {
	  var _element$ownerDocumen;

	  var _normalizeToArray = normalizeToArray(elementOrElements),
	      element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


	  return (element == null ? void 0 : (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body) ? element.ownerDocument : document;
	}
	function isCursorOutsideInteractiveBorder(popperTreeData, event) {
	  var clientX = event.clientX,
	      clientY = event.clientY;
	  return popperTreeData.every(function (_ref) {
	    var popperRect = _ref.popperRect,
	        popperState = _ref.popperState,
	        props = _ref.props;
	    var interactiveBorder = props.interactiveBorder;
	    var basePlacement = getBasePlacement$1(popperState.placement);
	    var offsetData = popperState.modifiersData.offset;

	    if (!offsetData) {
	      return true;
	    }

	    var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
	    var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
	    var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
	    var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
	    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
	    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
	    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
	    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
	    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
	  });
	}
	function updateTransitionEndListener(box, action, listener) {
	  var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
	  // `webkitTransitionEnd`...

	  ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
	    box[method](event, listener);
	  });
	}

	var currentInput = {
	  isTouch: false
	};
	var lastMouseMoveTime = 0;
	/**
	 * When a `touchstart` event is fired, it's assumed the user is using touch
	 * input. We'll bind a `mousemove` event listener to listen for mouse input in
	 * the future. This way, the `isTouch` property is fully dynamic and will handle
	 * hybrid devices that use a mix of touch + mouse input.
	 */

	function onDocumentTouchStart() {
	  if (currentInput.isTouch) {
	    return;
	  }

	  currentInput.isTouch = true;

	  if (window.performance) {
	    document.addEventListener('mousemove', onDocumentMouseMove);
	  }
	}
	/**
	 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
	 * the user is using mouse input again. `mousemove` can fire on touch devices as
	 * well, but very rarely that quickly.
	 */

	function onDocumentMouseMove() {
	  var now = performance.now();

	  if (now - lastMouseMoveTime < 20) {
	    currentInput.isTouch = false;
	    document.removeEventListener('mousemove', onDocumentMouseMove);
	  }

	  lastMouseMoveTime = now;
	}
	/**
	 * When an element is in focus and has a tippy, leaving the tab/window and
	 * returning causes it to show again. For mouse users this is unexpected, but
	 * for keyboard use it makes sense.
	 * TODO: find a better technique to solve this problem
	 */

	function onWindowBlur() {
	  var activeElement = document.activeElement;

	  if (isReferenceElement(activeElement)) {
	    var instance = activeElement._tippy;

	    if (activeElement.blur && !instance.state.isVisible) {
	      activeElement.blur();
	    }
	  }
	}
	function bindGlobalEventListeners() {
	  document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
	  window.addEventListener('blur', onWindowBlur);
	}

	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	var ua = isBrowser ? navigator.userAgent : '';
	var isIE = /MSIE |Trident\//.test(ua);

	function createMemoryLeakWarning(method) {
	  var txt = method === 'destroy' ? 'n already-' : ' ';
	  return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
	}
	function clean(value) {
	  var spacesAndTabs = /[ \t]{2,}/g;
	  var lineStartWithSpaces = /^[ \t]*/gm;
	  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
	}

	function getDevMessage(message) {
	  return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
	}

	function getFormattedMessage(message) {
	  return [getDevMessage(message), // title
	  'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
	  'line-height: 1.5', // footer
	  'color: #a6a095;'];
	} // Assume warnings and errors never have the same message

	var visitedMessages;

	{
	  resetVisitedMessages();
	}

	function resetVisitedMessages() {
	  visitedMessages = new Set();
	}
	function warnWhen(condition, message) {
	  if (condition && !visitedMessages.has(message)) {
	    var _console;

	    visitedMessages.add(message);

	    (_console = console).warn.apply(_console, getFormattedMessage(message));
	  }
	}
	function errorWhen(condition, message) {
	  if (condition && !visitedMessages.has(message)) {
	    var _console2;

	    visitedMessages.add(message);

	    (_console2 = console).error.apply(_console2, getFormattedMessage(message));
	  }
	}
	function validateTargets(targets) {
	  var didPassFalsyValue = !targets;
	  var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
	  errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
	  errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
	}

	var pluginProps = {
	  animateFill: false,
	  followCursor: false,
	  inlinePositioning: false,
	  sticky: false
	};
	var renderProps = {
	  allowHTML: false,
	  animation: 'fade',
	  arrow: true,
	  content: '',
	  inertia: false,
	  maxWidth: 350,
	  role: 'tooltip',
	  theme: '',
	  zIndex: 9999
	};
	var defaultProps = Object.assign({
	  appendTo: function appendTo() {
	    return document.body;
	  },
	  aria: {
	    content: 'auto',
	    expanded: 'auto'
	  },
	  delay: 0,
	  duration: [300, 250],
	  getReferenceClientRect: null,
	  hideOnClick: true,
	  ignoreAttributes: false,
	  interactive: false,
	  interactiveBorder: 2,
	  interactiveDebounce: 0,
	  moveTransition: '',
	  offset: [0, 10],
	  onAfterUpdate: function onAfterUpdate() {},
	  onBeforeUpdate: function onBeforeUpdate() {},
	  onCreate: function onCreate() {},
	  onDestroy: function onDestroy() {},
	  onHidden: function onHidden() {},
	  onHide: function onHide() {},
	  onMount: function onMount() {},
	  onShow: function onShow() {},
	  onShown: function onShown() {},
	  onTrigger: function onTrigger() {},
	  onUntrigger: function onUntrigger() {},
	  onClickOutside: function onClickOutside() {},
	  placement: 'top',
	  plugins: [],
	  popperOptions: {},
	  render: null,
	  showOnCreate: false,
	  touch: true,
	  trigger: 'mouseenter focus',
	  triggerTarget: null
	}, pluginProps, {}, renderProps);
	var defaultKeys = Object.keys(defaultProps);
	var setDefaultProps = function setDefaultProps(partialProps) {
	  /* istanbul ignore else */
	  {
	    validateProps$1(partialProps, []);
	  }

	  var keys = Object.keys(partialProps);
	  keys.forEach(function (key) {
	    defaultProps[key] = partialProps[key];
	  });
	};
	function getExtendedPassedProps(passedProps) {
	  var plugins = passedProps.plugins || [];
	  var pluginProps = plugins.reduce(function (acc, plugin) {
	    var name = plugin.name,
	        defaultValue = plugin.defaultValue;

	    if (name) {
	      acc[name] = passedProps[name] !== undefined ? passedProps[name] : defaultValue;
	    }

	    return acc;
	  }, {});
	  return Object.assign({}, passedProps, {}, pluginProps);
	}
	function getDataAttributeProps(reference, plugins) {
	  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
	    plugins: plugins
	  }))) : defaultKeys;
	  var props = propKeys.reduce(function (acc, key) {
	    var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

	    if (!valueAsString) {
	      return acc;
	    }

	    if (key === 'content') {
	      acc[key] = valueAsString;
	    } else {
	      try {
	        acc[key] = JSON.parse(valueAsString);
	      } catch (e) {
	        acc[key] = valueAsString;
	      }
	    }

	    return acc;
	  }, {});
	  return props;
	}
	function evaluateProps(reference, props) {
	  var out = Object.assign({}, props, {
	    content: invokeWithArgsOrReturn(props.content, [reference])
	  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
	  out.aria = Object.assign({}, defaultProps.aria, {}, out.aria);
	  out.aria = {
	    expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
	    content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
	  };
	  return out;
	}
	function validateProps$1(partialProps, plugins) {
	  if (partialProps === void 0) {
	    partialProps = {};
	  }

	  if (plugins === void 0) {
	    plugins = [];
	  }

	  var keys = Object.keys(partialProps);
	  keys.forEach(function (prop) {
	    var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
	    var didPassUnknownProp = !hasOwnProperty$1(nonPluginProps, prop); // Check if the prop exists in `plugins`

	    if (didPassUnknownProp) {
	      didPassUnknownProp = plugins.filter(function (plugin) {
	        return plugin.name === prop;
	      }).length === 0;
	    }

	    warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
	  });
	}

	var innerHTML = function innerHTML() {
	  return 'innerHTML';
	};

	function dangerouslySetInnerHTML(element, html) {
	  element[innerHTML()] = html;
	}

	function createArrowElement(value) {
	  var arrow = div();

	  if (value === true) {
	    arrow.className = ARROW_CLASS;
	  } else {
	    arrow.className = SVG_ARROW_CLASS;

	    if (isElement$1(value)) {
	      arrow.appendChild(value);
	    } else {
	      dangerouslySetInnerHTML(arrow, value);
	    }
	  }

	  return arrow;
	}

	function setContent(content, props) {
	  if (isElement$1(props.content)) {
	    dangerouslySetInnerHTML(content, '');
	    content.appendChild(props.content);
	  } else if (typeof props.content !== 'function') {
	    if (props.allowHTML) {
	      dangerouslySetInnerHTML(content, props.content);
	    } else {
	      content.textContent = props.content;
	    }
	  }
	}
	function getChildren(popper) {
	  var box = popper.firstElementChild;
	  var boxChildren = arrayFrom(box.children);
	  return {
	    box: box,
	    content: boxChildren.find(function (node) {
	      return node.classList.contains(CONTENT_CLASS);
	    }),
	    arrow: boxChildren.find(function (node) {
	      return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
	    }),
	    backdrop: boxChildren.find(function (node) {
	      return node.classList.contains(BACKDROP_CLASS);
	    })
	  };
	}
	function render$a(instance) {
	  var popper = div();
	  var box = div();
	  box.className = BOX_CLASS;
	  box.setAttribute('data-state', 'hidden');
	  box.setAttribute('tabindex', '-1');
	  var content = div();
	  content.className = CONTENT_CLASS;
	  content.setAttribute('data-state', 'hidden');
	  setContent(content, instance.props);
	  popper.appendChild(box);
	  box.appendChild(content);
	  onUpdate(instance.props, instance.props);

	  function onUpdate(prevProps, nextProps) {
	    var _getChildren = getChildren(popper),
	        box = _getChildren.box,
	        content = _getChildren.content,
	        arrow = _getChildren.arrow;

	    if (nextProps.theme) {
	      box.setAttribute('data-theme', nextProps.theme);
	    } else {
	      box.removeAttribute('data-theme');
	    }

	    if (typeof nextProps.animation === 'string') {
	      box.setAttribute('data-animation', nextProps.animation);
	    } else {
	      box.removeAttribute('data-animation');
	    }

	    if (nextProps.inertia) {
	      box.setAttribute('data-inertia', '');
	    } else {
	      box.removeAttribute('data-inertia');
	    }

	    box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

	    if (nextProps.role) {
	      box.setAttribute('role', nextProps.role);
	    } else {
	      box.removeAttribute('role');
	    }

	    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
	      setContent(content, instance.props);
	    }

	    if (nextProps.arrow) {
	      if (!arrow) {
	        box.appendChild(createArrowElement(nextProps.arrow));
	      } else if (prevProps.arrow !== nextProps.arrow) {
	        box.removeChild(arrow);
	        box.appendChild(createArrowElement(nextProps.arrow));
	      }
	    } else if (arrow) {
	      box.removeChild(arrow);
	    }
	  }

	  return {
	    popper: popper,
	    onUpdate: onUpdate
	  };
	} // Runtime check to identify if the render function is the default one; this
	// way we can apply default CSS transitions logic and it can be tree-shaken away

	render$a.$$tippy = true;

	var idCounter = 1;
	var mouseMoveListeners = []; // Used by `hideAll()`

	var mountedInstances = [];
	function createTippy(reference, passedProps) {
	  var props = evaluateProps(reference, Object.assign({}, defaultProps, {}, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
	  // 🔒 Private members
	  // ===========================================================================

	  var showTimeout;
	  var hideTimeout;
	  var scheduleHideAnimationFrame;
	  var isVisibleFromClick = false;
	  var didHideDueToDocumentMouseDown = false;
	  var didTouchMove = false;
	  var ignoreOnFirstUpdate = false;
	  var lastTriggerEvent;
	  var currentTransitionEndListener;
	  var onFirstUpdate;
	  var listeners = [];
	  var debouncedOnMouseMove = debounce$1(onMouseMove, props.interactiveDebounce);
	  var currentTarget; // ===========================================================================
	  // 🔑 Public members
	  // ===========================================================================

	  var id = idCounter++;
	  var popperInstance = null;
	  var plugins = unique(props.plugins);
	  var state = {
	    // Is the instance currently enabled?
	    isEnabled: true,
	    // Is the tippy currently showing and not transitioning out?
	    isVisible: false,
	    // Has the instance been destroyed?
	    isDestroyed: false,
	    // Is the tippy currently mounted to the DOM?
	    isMounted: false,
	    // Has the tippy finished transitioning in?
	    isShown: false
	  };
	  var instance = {
	    // properties
	    id: id,
	    reference: reference,
	    popper: div(),
	    popperInstance: popperInstance,
	    props: props,
	    state: state,
	    plugins: plugins,
	    // methods
	    clearDelayTimeouts: clearDelayTimeouts,
	    setProps: setProps,
	    setContent: setContent,
	    show: show,
	    hide: hide,
	    hideWithInteractivity: hideWithInteractivity,
	    enable: enable,
	    disable: disable,
	    unmount: unmount,
	    destroy: destroy
	  }; // TODO: Investigate why this early return causes a TDZ error in the tests —
	  // it doesn't seem to happen in the browser

	  /* istanbul ignore if */

	  if (!props.render) {
	    {
	      errorWhen(true, 'render() function has not been supplied.');
	    }

	    return instance;
	  } // ===========================================================================
	  // Initial mutations
	  // ===========================================================================


	  var _props$render = props.render(instance),
	      popper = _props$render.popper,
	      onUpdate = _props$render.onUpdate;

	  popper.setAttribute('data-tippy-root', '');
	  popper.id = "tippy-" + instance.id;
	  instance.popper = popper;
	  reference._tippy = instance;
	  popper._tippy = instance;
	  var pluginsHooks = plugins.map(function (plugin) {
	    return plugin.fn(instance);
	  });
	  var hasAriaExpanded = reference.hasAttribute('aria-expanded');
	  addListeners();
	  handleAriaExpandedAttribute();
	  handleStyles();
	  invokeHook('onCreate', [instance]);

	  if (props.showOnCreate) {
	    scheduleShow();
	  } // Prevent a tippy with a delay from hiding if the cursor left then returned
	  // before it started hiding


	  popper.addEventListener('mouseenter', function () {
	    if (instance.props.interactive && instance.state.isVisible) {
	      instance.clearDelayTimeouts();
	    }
	  });
	  popper.addEventListener('mouseleave', function (event) {
	    if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
	      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
	      debouncedOnMouseMove(event);
	    }
	  });
	  return instance; // ===========================================================================
	  // 🔒 Private methods
	  // ===========================================================================

	  function getNormalizedTouchSettings() {
	    var touch = instance.props.touch;
	    return Array.isArray(touch) ? touch : [touch, 0];
	  }

	  function getIsCustomTouchBehavior() {
	    return getNormalizedTouchSettings()[0] === 'hold';
	  }

	  function getIsDefaultRenderFn() {
	    var _instance$props$rende;

	    // @ts-ignore
	    return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
	  }

	  function getCurrentTarget() {
	    return currentTarget || reference;
	  }

	  function getDocument() {
	    var parent = getCurrentTarget().parentNode;
	    return parent ? getOwnerDocument(parent) : document;
	  }

	  function getDefaultTemplateChildren() {
	    return getChildren(popper);
	  }

	  function getDelay(isShow) {
	    // For touch or keyboard input, force `0` delay for UX reasons
	    // Also if the instance is mounted but not visible (transitioning out),
	    // ignore delay
	    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
	      return 0;
	    }

	    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
	  }

	  function handleStyles() {
	    popper.style.pointerEvents = instance.props.interactive && instance.state.isVisible ? '' : 'none';
	    popper.style.zIndex = "" + instance.props.zIndex;
	  }

	  function invokeHook(hook, args, shouldInvokePropsHook) {
	    if (shouldInvokePropsHook === void 0) {
	      shouldInvokePropsHook = true;
	    }

	    pluginsHooks.forEach(function (pluginHooks) {
	      if (pluginHooks[hook]) {
	        pluginHooks[hook].apply(void 0, args);
	      }
	    });

	    if (shouldInvokePropsHook) {
	      var _instance$props;

	      (_instance$props = instance.props)[hook].apply(_instance$props, args);
	    }
	  }

	  function handleAriaContentAttribute() {
	    var aria = instance.props.aria;

	    if (!aria.content) {
	      return;
	    }

	    var attr = "aria-" + aria.content;
	    var id = popper.id;
	    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
	    nodes.forEach(function (node) {
	      var currentValue = node.getAttribute(attr);

	      if (instance.state.isVisible) {
	        node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
	      } else {
	        var nextValue = currentValue && currentValue.replace(id, '').trim();

	        if (nextValue) {
	          node.setAttribute(attr, nextValue);
	        } else {
	          node.removeAttribute(attr);
	        }
	      }
	    });
	  }

	  function handleAriaExpandedAttribute() {
	    if (hasAriaExpanded || !instance.props.aria.expanded) {
	      return;
	    }

	    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
	    nodes.forEach(function (node) {
	      if (instance.props.interactive) {
	        node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
	      } else {
	        node.removeAttribute('aria-expanded');
	      }
	    });
	  }

	  function cleanupInteractiveMouseListeners() {
	    getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
	    mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
	      return listener !== debouncedOnMouseMove;
	    });
	  }

	  function onDocumentPress(event) {
	    // Moved finger to scroll instead of an intentional tap outside
	    if (currentInput.isTouch) {
	      if (didTouchMove || event.type === 'mousedown') {
	        return;
	      }
	    } // Clicked on interactive popper


	    if (instance.props.interactive && popper.contains(event.target)) {
	      return;
	    } // Clicked on the event listeners target


	    if (getCurrentTarget().contains(event.target)) {
	      if (currentInput.isTouch) {
	        return;
	      }

	      if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
	        return;
	      }
	    } else {
	      invokeHook('onClickOutside', [instance, event]);
	    }

	    if (instance.props.hideOnClick === true) {
	      instance.clearDelayTimeouts();
	      instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
	      // currentTarget. This lets a tippy with `focus` trigger know that it
	      // should not show

	      didHideDueToDocumentMouseDown = true;
	      setTimeout(function () {
	        didHideDueToDocumentMouseDown = false;
	      }); // The listener gets added in `scheduleShow()`, but this may be hiding it
	      // before it shows, and hide()'s early bail-out behavior can prevent it
	      // from being cleaned up

	      if (!instance.state.isMounted) {
	        removeDocumentPress();
	      }
	    }
	  }

	  function onTouchMove() {
	    didTouchMove = true;
	  }

	  function onTouchStart() {
	    didTouchMove = false;
	  }

	  function addDocumentPress() {
	    var doc = getDocument();
	    doc.addEventListener('mousedown', onDocumentPress, true);
	    doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
	    doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
	    doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
	  }

	  function removeDocumentPress() {
	    var doc = getDocument();
	    doc.removeEventListener('mousedown', onDocumentPress, true);
	    doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
	    doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
	    doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
	  }

	  function onTransitionedOut(duration, callback) {
	    onTransitionEnd(duration, function () {
	      if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
	        callback();
	      }
	    });
	  }

	  function onTransitionedIn(duration, callback) {
	    onTransitionEnd(duration, callback);
	  }

	  function onTransitionEnd(duration, callback) {
	    var box = getDefaultTemplateChildren().box;

	    function listener(event) {
	      if (event.target === box) {
	        updateTransitionEndListener(box, 'remove', listener);
	        callback();
	      }
	    } // Make callback synchronous if duration is 0
	    // `transitionend` won't fire otherwise


	    if (duration === 0) {
	      return callback();
	    }

	    updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
	    updateTransitionEndListener(box, 'add', listener);
	    currentTransitionEndListener = listener;
	  }

	  function on(eventType, handler, options) {
	    if (options === void 0) {
	      options = false;
	    }

	    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
	    nodes.forEach(function (node) {
	      node.addEventListener(eventType, handler, options);
	      listeners.push({
	        node: node,
	        eventType: eventType,
	        handler: handler,
	        options: options
	      });
	    });
	  }

	  function addListeners() {
	    if (getIsCustomTouchBehavior()) {
	      on('touchstart', onTrigger, {
	        passive: true
	      });
	      on('touchend', onMouseLeave, {
	        passive: true
	      });
	    }

	    splitBySpaces(instance.props.trigger).forEach(function (eventType) {
	      if (eventType === 'manual') {
	        return;
	      }

	      on(eventType, onTrigger);

	      switch (eventType) {
	        case 'mouseenter':
	          on('mouseleave', onMouseLeave);
	          break;

	        case 'focus':
	          on(isIE ? 'focusout' : 'blur', onBlurOrFocusOut);
	          break;

	        case 'focusin':
	          on('focusout', onBlurOrFocusOut);
	          break;
	      }
	    });
	  }

	  function removeListeners() {
	    listeners.forEach(function (_ref) {
	      var node = _ref.node,
	          eventType = _ref.eventType,
	          handler = _ref.handler,
	          options = _ref.options;
	      node.removeEventListener(eventType, handler, options);
	    });
	    listeners = [];
	  }

	  function onTrigger(event) {
	    var _lastTriggerEvent;

	    var shouldScheduleClickHide = false;

	    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
	      return;
	    }

	    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
	    lastTriggerEvent = event;
	    currentTarget = event.currentTarget;
	    handleAriaExpandedAttribute();

	    if (!instance.state.isVisible && isMouseEvent(event)) {
	      // If scrolling, `mouseenter` events can be fired if the cursor lands
	      // over a new target, but `mousemove` events don't get fired. This
	      // causes interactive tooltips to get stuck open until the cursor is
	      // moved
	      mouseMoveListeners.forEach(function (listener) {
	        return listener(event);
	      });
	    } // Toggle show/hide when clicking click-triggered tooltips


	    if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
	      shouldScheduleClickHide = true;
	    } else {
	      scheduleShow(event);
	    }

	    if (event.type === 'click') {
	      isVisibleFromClick = !shouldScheduleClickHide;
	    }

	    if (shouldScheduleClickHide && !wasFocused) {
	      scheduleHide(event);
	    }
	  }

	  function onMouseMove(event) {
	    var target = event.target;
	    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

	    if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
	      return;
	    }

	    var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
	      var _instance$popperInsta;

	      var instance = popper._tippy;
	      var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

	      if (state) {
	        return {
	          popperRect: popper.getBoundingClientRect(),
	          popperState: state,
	          props: props
	        };
	      }

	      return null;
	    }).filter(Boolean);

	    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
	      cleanupInteractiveMouseListeners();
	      scheduleHide(event);
	    }
	  }

	  function onMouseLeave(event) {
	    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

	    if (shouldBail) {
	      return;
	    }

	    if (instance.props.interactive) {
	      instance.hideWithInteractivity(event);
	      return;
	    }

	    scheduleHide(event);
	  }

	  function onBlurOrFocusOut(event) {
	    if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
	      return;
	    } // If focus was moved to within the popper


	    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
	      return;
	    }

	    scheduleHide(event);
	  }

	  function isEventListenerStopped(event) {
	    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
	  }

	  function createPopperInstance() {
	    destroyPopperInstance();
	    var _instance$props2 = instance.props,
	        popperOptions = _instance$props2.popperOptions,
	        placement = _instance$props2.placement,
	        offset = _instance$props2.offset,
	        getReferenceClientRect = _instance$props2.getReferenceClientRect,
	        moveTransition = _instance$props2.moveTransition;
	    var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
	    var computedReference = getReferenceClientRect ? {
	      getBoundingClientRect: getReferenceClientRect,
	      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
	    } : reference;
	    var tippyModifier = {
	      name: '$$tippy',
	      enabled: true,
	      phase: 'beforeWrite',
	      requires: ['computeStyles'],
	      fn: function fn(_ref2) {
	        var state = _ref2.state;

	        if (getIsDefaultRenderFn()) {
	          var _getDefaultTemplateCh = getDefaultTemplateChildren(),
	              box = _getDefaultTemplateCh.box;

	          ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
	            if (attr === 'placement') {
	              box.setAttribute('data-placement', state.placement);
	            } else {
	              if (state.attributes.popper["data-popper-" + attr]) {
	                box.setAttribute("data-" + attr, '');
	              } else {
	                box.removeAttribute("data-" + attr);
	              }
	            }
	          });
	          state.attributes.popper = {};
	        }
	      }
	    };
	    var modifiers = [{
	      name: 'offset',
	      options: {
	        offset: offset
	      }
	    }, {
	      name: 'preventOverflow',
	      options: {
	        padding: {
	          top: 2,
	          bottom: 2,
	          left: 5,
	          right: 5
	        }
	      }
	    }, {
	      name: 'flip',
	      options: {
	        padding: 5
	      }
	    }, {
	      name: 'computeStyles',
	      options: {
	        adaptive: !moveTransition
	      }
	    }, tippyModifier];

	    if (getIsDefaultRenderFn() && arrow) {
	      modifiers.push({
	        name: 'arrow',
	        options: {
	          element: arrow,
	          padding: 3
	        }
	      });
	    }

	    modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
	    instance.popperInstance = createPopper(computedReference, popper, Object.assign({}, popperOptions, {
	      placement: placement,
	      onFirstUpdate: onFirstUpdate,
	      modifiers: modifiers
	    }));
	  }

	  function destroyPopperInstance() {
	    if (instance.popperInstance) {
	      instance.popperInstance.destroy();
	      instance.popperInstance = null;
	    }
	  }

	  function mount() {
	    var appendTo = instance.props.appendTo;
	    var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
	    // it's directly after the reference element so the elements inside the
	    // tippy can be tabbed to
	    // If there are clipping issues, the user can specify a different appendTo
	    // and ensure focus management is handled correctly manually

	    var node = getCurrentTarget();

	    if (instance.props.interactive && appendTo === defaultProps.appendTo || appendTo === 'parent') {
	      parentNode = node.parentNode;
	    } else {
	      parentNode = invokeWithArgsOrReturn(appendTo, [node]);
	    } // The popper element needs to exist on the DOM before its position can be
	    // updated as Popper needs to read its dimensions


	    if (!parentNode.contains(popper)) {
	      parentNode.appendChild(popper);
	    }

	    createPopperInstance();
	    /* istanbul ignore else */

	    {
	      // Accessibility check
	      warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, ['Interactive tippy element may not be accessible via keyboard', 'navigation because it is not directly after the reference element', 'in the DOM source order.', '\n\n', 'Using a wrapper <div> or <span> tag around the reference element', 'solves this by creating a new parentNode context.', '\n\n', 'Specifying `appendTo: document.body` silences this warning, but it', 'assumes you are using a focus management solution to handle', 'keyboard navigation.', '\n\n', 'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'].join(' '));
	    }
	  }

	  function getNestedPopperTree() {
	    return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
	  }

	  function scheduleShow(event) {
	    instance.clearDelayTimeouts();

	    if (event) {
	      invokeHook('onTrigger', [instance, event]);
	    }

	    addDocumentPress();
	    var delay = getDelay(true);

	    var _getNormalizedTouchSe = getNormalizedTouchSettings(),
	        touchValue = _getNormalizedTouchSe[0],
	        touchDelay = _getNormalizedTouchSe[1];

	    if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
	      delay = touchDelay;
	    }

	    if (delay) {
	      showTimeout = setTimeout(function () {
	        instance.show();
	      }, delay);
	    } else {
	      instance.show();
	    }
	  }

	  function scheduleHide(event) {
	    instance.clearDelayTimeouts();
	    invokeHook('onUntrigger', [instance, event]);

	    if (!instance.state.isVisible) {
	      removeDocumentPress();
	      return;
	    } // For interactive tippies, scheduleHide is added to a document.body handler
	    // from onMouseLeave so must intercept scheduled hides from mousemove/leave
	    // events when trigger contains mouseenter and click, and the tip is
	    // currently shown as a result of a click.


	    if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
	      return;
	    }

	    var delay = getDelay(false);

	    if (delay) {
	      hideTimeout = setTimeout(function () {
	        if (instance.state.isVisible) {
	          instance.hide();
	        }
	      }, delay);
	    } else {
	      // Fixes a `transitionend` problem when it fires 1 frame too
	      // late sometimes, we don't want hide() to be called.
	      scheduleHideAnimationFrame = requestAnimationFrame(function () {
	        instance.hide();
	      });
	    }
	  } // ===========================================================================
	  // 🔑 Public methods
	  // ===========================================================================


	  function enable() {
	    instance.state.isEnabled = true;
	  }

	  function disable() {
	    // Disabling the instance should also hide it
	    // https://github.com/atomiks/tippy.js-react/issues/106
	    instance.hide();
	    instance.state.isEnabled = false;
	  }

	  function clearDelayTimeouts() {
	    clearTimeout(showTimeout);
	    clearTimeout(hideTimeout);
	    cancelAnimationFrame(scheduleHideAnimationFrame);
	  }

	  function setProps(partialProps) {
	    /* istanbul ignore else */
	    {
	      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
	    }

	    if (instance.state.isDestroyed) {
	      return;
	    }

	    invokeHook('onBeforeUpdate', [instance, partialProps]);
	    removeListeners();
	    var prevProps = instance.props;
	    var nextProps = evaluateProps(reference, Object.assign({}, instance.props, {}, partialProps, {
	      ignoreAttributes: true
	    }));
	    instance.props = nextProps;
	    addListeners();

	    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
	      cleanupInteractiveMouseListeners();
	      debouncedOnMouseMove = debounce$1(onMouseMove, nextProps.interactiveDebounce);
	    } // Ensure stale aria-expanded attributes are removed


	    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
	      normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
	        node.removeAttribute('aria-expanded');
	      });
	    } else if (nextProps.triggerTarget) {
	      reference.removeAttribute('aria-expanded');
	    }

	    handleAriaExpandedAttribute();
	    handleStyles();

	    if (onUpdate) {
	      onUpdate(prevProps, nextProps);
	    }

	    if (instance.popperInstance) {
	      createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
	      // and the nested ones get re-rendered first.
	      // https://github.com/atomiks/tippyjs-react/issues/177
	      // TODO: find a cleaner / more efficient solution(!)

	      getNestedPopperTree().forEach(function (nestedPopper) {
	        // React (and other UI libs likely) requires a rAF wrapper as it flushes
	        // its work in one
	        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
	      });
	    }

	    invokeHook('onAfterUpdate', [instance, partialProps]);
	  }

	  function setContent(content) {
	    instance.setProps({
	      content: content
	    });
	  }

	  function show() {
	    /* istanbul ignore else */
	    {
	      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
	    } // Early bail-out


	    var isAlreadyVisible = instance.state.isVisible;
	    var isDestroyed = instance.state.isDestroyed;
	    var isDisabled = !instance.state.isEnabled;
	    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
	    var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

	    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
	      return;
	    } // Normalize `disabled` behavior across browsers.
	    // Firefox allows events on disabled elements, but Chrome doesn't.
	    // Using a wrapper element (i.e. <span>) is recommended.


	    if (getCurrentTarget().hasAttribute('disabled')) {
	      return;
	    }

	    invokeHook('onShow', [instance], false);

	    if (instance.props.onShow(instance) === false) {
	      return;
	    }

	    instance.state.isVisible = true;

	    if (getIsDefaultRenderFn()) {
	      popper.style.visibility = 'visible';
	    }

	    handleStyles();
	    addDocumentPress();

	    if (!instance.state.isMounted) {
	      popper.style.transition = 'none';
	    } // If flipping to the opposite side after hiding at least once, the
	    // animation will use the wrong placement without resetting the duration


	    if (getIsDefaultRenderFn()) {
	      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
	          box = _getDefaultTemplateCh2.box,
	          content = _getDefaultTemplateCh2.content;

	      setTransitionDuration([box, content], 0);
	    }

	    onFirstUpdate = function onFirstUpdate() {
	      var _instance$popperInsta2;

	      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
	        return;
	      }

	      ignoreOnFirstUpdate = true; // reflow

	      void popper.offsetHeight;
	      popper.style.transition = instance.props.moveTransition;

	      if (getIsDefaultRenderFn() && instance.props.animation) {
	        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
	            _box = _getDefaultTemplateCh3.box,
	            _content = _getDefaultTemplateCh3.content;

	        setTransitionDuration([_box, _content], duration);
	        setVisibilityState([_box, _content], 'visible');
	      }

	      handleAriaContentAttribute();
	      handleAriaExpandedAttribute();
	      pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
	      // popper has been positioned for the first time

	      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
	      instance.state.isMounted = true;
	      invokeHook('onMount', [instance]);

	      if (instance.props.animation && getIsDefaultRenderFn()) {
	        onTransitionedIn(duration, function () {
	          instance.state.isShown = true;
	          invokeHook('onShown', [instance]);
	        });
	      }
	    };

	    mount();
	  }

	  function hide() {
	    /* istanbul ignore else */
	    {
	      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
	    } // Early bail-out


	    var isAlreadyHidden = !instance.state.isVisible;
	    var isDestroyed = instance.state.isDestroyed;
	    var isDisabled = !instance.state.isEnabled;
	    var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

	    if (isAlreadyHidden || isDestroyed || isDisabled) {
	      return;
	    }

	    invokeHook('onHide', [instance], false);

	    if (instance.props.onHide(instance) === false) {
	      return;
	    }

	    instance.state.isVisible = false;
	    instance.state.isShown = false;
	    ignoreOnFirstUpdate = false;
	    isVisibleFromClick = false;

	    if (getIsDefaultRenderFn()) {
	      popper.style.visibility = 'hidden';
	    }

	    cleanupInteractiveMouseListeners();
	    removeDocumentPress();
	    handleStyles();

	    if (getIsDefaultRenderFn()) {
	      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
	          box = _getDefaultTemplateCh4.box,
	          content = _getDefaultTemplateCh4.content;

	      if (instance.props.animation) {
	        setTransitionDuration([box, content], duration);
	        setVisibilityState([box, content], 'hidden');
	      }
	    }

	    handleAriaContentAttribute();
	    handleAriaExpandedAttribute();

	    if (instance.props.animation) {
	      if (getIsDefaultRenderFn()) {
	        onTransitionedOut(duration, instance.unmount);
	      }
	    } else {
	      instance.unmount();
	    }
	  }

	  function hideWithInteractivity(event) {
	    /* istanbul ignore else */
	    {
	      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
	    }

	    getDocument().addEventListener('mousemove', debouncedOnMouseMove);
	    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
	    debouncedOnMouseMove(event);
	  }

	  function unmount() {
	    /* istanbul ignore else */
	    {
	      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
	    }

	    if (instance.state.isVisible) {
	      instance.hide();
	    }

	    if (!instance.state.isMounted) {
	      return;
	    }

	    destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
	    // tree by default. This seems mainly for interactive tippies, but we should
	    // find a workaround if possible

	    getNestedPopperTree().forEach(function (nestedPopper) {
	      nestedPopper._tippy.unmount();
	    });

	    if (popper.parentNode) {
	      popper.parentNode.removeChild(popper);
	    }

	    mountedInstances = mountedInstances.filter(function (i) {
	      return i !== instance;
	    });
	    instance.state.isMounted = false;
	    invokeHook('onHidden', [instance]);
	  }

	  function destroy() {
	    /* istanbul ignore else */
	    {
	      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
	    }

	    if (instance.state.isDestroyed) {
	      return;
	    }

	    instance.clearDelayTimeouts();
	    instance.unmount();
	    removeListeners();
	    delete reference._tippy;
	    instance.state.isDestroyed = true;
	    invokeHook('onDestroy', [instance]);
	  }
	}

	function tippy(targets, optionalProps) {
	  if (optionalProps === void 0) {
	    optionalProps = {};
	  }

	  var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
	  /* istanbul ignore else */

	  {
	    validateTargets(targets);
	    validateProps$1(optionalProps, plugins);
	  }

	  bindGlobalEventListeners();
	  var passedProps = Object.assign({}, optionalProps, {
	    plugins: plugins
	  });
	  var elements = getArrayOfElements(targets);
	  /* istanbul ignore else */

	  {
	    var isSingleContentElement = isElement$1(passedProps.content);
	    var isMoreThanOneReferenceElement = elements.length > 1;
	    warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, ['tippy() was passed an Element as the `content` prop, but more than', 'one tippy instance was created by this invocation. This means the', 'content element will only be appended to the last tippy instance.', '\n\n', 'Instead, pass the .innerHTML of the element, or use a function that', 'returns a cloned version of the element instead.', '\n\n', '1) content: element.innerHTML\n', '2) content: () => element.cloneNode(true)'].join(' '));
	  }

	  var instances = elements.reduce(function (acc, reference) {
	    var instance = reference && createTippy(reference, passedProps);

	    if (instance) {
	      acc.push(instance);
	    }

	    return acc;
	  }, []);
	  return isElement$1(targets) ? instances[0] : instances;
	}

	tippy.defaultProps = defaultProps;
	tippy.setDefaultProps = setDefaultProps;
	tippy.currentInput = currentInput;

	// every time the popper is destroyed (i.e. a new target), removing the styles
	// and causing transitions to break for singletons when the console is open, but
	// most notably for non-transform styles being used, `gpuAcceleration: false`.

	var applyStylesModifier = Object.assign({}, applyStyles$1, {
	  effect: function effect(_ref) {
	    var state = _ref.state;
	    var initialStyles = {
	      popper: {
	        position: state.options.strategy,
	        left: '0',
	        top: '0',
	        margin: '0'
	      },
	      arrow: {
	        position: 'absolute'
	      },
	      reference: {}
	    };
	    Object.assign(state.elements.popper.style, initialStyles.popper);
	    state.styles = initialStyles;

	    if (state.elements.arrow) {
	      Object.assign(state.elements.arrow.style, initialStyles.arrow);
	    } // intentionally return no cleanup function
	    // return () => { ... }

	  }
	});

	tippy.setDefaultProps({
	  render: render$a
	});

	var script$9 = {
		props: {
			tooltip: {
				type: String,
				default: null
			},
			options: {
				type: Object,
				default: null
			}
		},

		emits: ['show'],

		data() {
			return {
				instance: null
			}
		},

		computed: {
			computedTooltip() {
				return '<div class="tooltip__content">' + this.tooltip + '</div>'
			},

			computedOptions() {
				var result = {
					content: this.computedTooltip,
					allowHTML: true,
					trigger: 'mouseenter click',
					interactive: true,
					theme: 'light',
					animation: 'shift-away',
					maxWidth: 310,
					offset: [10, 10],
					placement: 'bottom',
					onClickOutside(instance, event) {
						instance.hide();
					},
				};

				// переопределение параметров слайдера переданных в атрибуте компонента
				if (this.options) {
					Object.keys(this.options).forEach((key) => {
						if (typeof this.options[key] !== 'undefined') {
							result[key] = this.options[key];
						}
					});
				}

				return result
			},
		},

		mounted() {
			this.$nextTick(() => {
				const vm = this;

				this.instance = tippy(this.$el, this.computedOptions);

				this.instance.setProps({
					onShow(instance) {
						vm.$emit('show', instance.popper);
					},
				});
			});
		},
	};

	const _hoisted_1$3 = { class: "v-tooltip tooltip" };
	const _hoisted_2$2 = /*#__PURE__*/createVNode("button", { class: "tooltip__icon" }, null, -1 /* HOISTED */);

	function render$b(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$3, [
	    _hoisted_2$2
	  ]))
	}

	script$9.render = render$b;
	script$9.__file = "local/assets/source/components/helpers/v-tooltip.vue";

	var script$a = {

		mixins: [
			script$2
		],

		props: {
			mode: {
				type: String,
				default: null
			},

			submitCallback: {
				type: String,
				default: null
			},

			altFooter: {
				type: Boolean,
				default: false
			},

			deliveryAddressId: {
				type: [String, Number],
				default: null
			}
		},

		emits: ['submit'],

		data() {
			return {
				form: null,
				localFormData: new FormData(),
				open: true,
				confirmValue: [],
				confirmed: false,
				savedFileKeys: [],
				timeout: null
			};
		},

		computed: {
			computedConfirmField() {
				return {
					type: 'check-list',
					value: [],
					label: null,
					options: [
						{
							'value': '1',
							'text': this.form.requireConfirmText
						}
					]
				}
			}
		},

		methods: {
			getFieldError(field) {
				if (this.form.errors && this.form.errors.fields) {
					let filteredErrors = this.form.errors.fields.filter((item) => item.name === field.name);
					return filteredErrors.length ? filteredErrors : null;
				} else {
					return null;
				}
			},

			callControllerMethods() {
				if (this.submitCallback) {
					controller.emitCustomEvent(this.submitCallback, this.deliveryAddressId);
				}
			},

			scrollToFirstError() {
				if (!this) {
					return;
				}

				if (document.body.classList.contains('state--modal-open')) {
					return;
				}

				const $errorFields = this.$el.querySelectorAll('.form-error');
				if ($errorFields.length > 0) {
					const $firstErrorField = $errorFields[0];
					const yOffset = -60;
					const coordY = $firstErrorField.getBoundingClientRect().top + window.pageYOffset + yOffset;
					window.scrollTo({top: coordY, behavior: 'smooth'});
				} else {
					window.scrollTo({top: 0, behavior: 'smooth'});
				}
			},

			submitHandler() {
				this.callControllerMethods();
				this.scrollToFirstError();
			},

			proxyFieldName(name) {
				return `state[form][${name}]`;
			},

			dataSet(data) {
				if (data.success && data.closeModal) {
					if (typeof modalController !== 'undefined') {

						if (typeof (data.modalTimeout) !== 'undefined' && data.modalTimeout > 0) {
							setTimeout(() => {
								controller.closeModal();
							}, data.modalTimeout);
						} else {
							controller.closeModal();
						}
					}
					return;
				}

				this.form = data;

				// проброс ошибок в данные поля
				if (this.form?.fields?.length) {
					this.form.fields.forEach((field) => {
						field.errors = this.getFieldError(field);
					});
				}
			},

			submit(options = {}) {

				if (this.form.success) {
					return false;
				}

				let namesOfCurrentIteration = [];
				if (this.form && this.form.fields) {

					this.form.fields.forEach(field => {
						let key = this.proxyFieldName(field.name);

						if (field.multiple) {
							key = this.proxyFieldName(field.name.replace('[]', '')) + '[]';
						}

						if (!field.value) {
							field.value = '';
						}

						if (field.type === 'file') {
							// очистка полей для файлов от старых значений
							for (let item of this.localFormData.entries()) {
								let isfoundInSavedFileKeys = false;
								for (let j = 0; j < this.savedFileKeys.length; j++) {
									if (item[0].indexOf(this.savedFileKeys[j]) > -1) {
										isfoundInSavedFileKeys = true;
										break;
									}
								}
								if (item[0].indexOf(key) === 0 && !isfoundInSavedFileKeys) {
									this.localFormData.delete(item[0]);
								}
							}
						}

						if (namesOfCurrentIteration.indexOf(key) < 0) {
							this.localFormData.delete(key);
							namesOfCurrentIteration.push(key);
						}

						if (field.type === 'file') ; else {
							// для отправки файлов придется держать в памяти неизменный localFormData
							// перед отправкой нужно удалить старые значения из localFormData
							// т.к. localFormData.append добавляет новые значения к существующим
							// а localFormData.set не позволила бы работать с массивами типа NAME[]
							// if (namesOfCurrentIteration.indexOf(key) < 0) {
							// 	this.localFormData.delete(key);
							// 	namesOfCurrentIteration.push(key);
							// }

							// если есть дочерние поля проходим по ним
							if (field.children) {
								field.children.forEach((child) => {
									this.localFormData.append(this.proxyFieldName(child.name), child.value);
								});
							}

							if (Array.isArray(field.value)) {
								field.value.forEach(val => {
									this.localFormData.append(key, val);
								});
							} else {
								this.localFormData.append(key, field.value);
							}
						}
					});
				}

				this.localFormData.set('state[action]', options.action || 'submit');
				this.localFormData.set('bxajaxid', this.bxajaxid);

				if (this.confirmed) {
					this.localFormData.append('confirmed', 1);
				} else {
					this.localFormData.delete('confirmed');
				}

				this.dataLoad({
					url: this.form.remote,
					data: this.localFormData,
					delay: true
				}, null).then(() => {
					this.submitHandler();
				});
			},

			fieldChanged(field) {
				if (field.autosubmit) {
					this.submit({action: 'autosubmit'});
				}
			},

			fileInput(field, e) {
				this.savedFileKeys = [];
				for (let i = 0; i < e.target.files.length; i++) {
					this.savedFileKeys.push(e.key);
					this.localFormData.append(this.proxyFieldName(field.name) + '[' + e.key + ']', e.target.files[i].path || e.target.files[i]);
				}

				if (field.autosubmit && !e.nosubmit) {
					this.submit({action: 'autosubmit'});
				}
			},

			fileRemove(field, e) {
				this.localFormData.delete(this.proxyFieldName(field.name) + '[' + e.key + ']');

				if (field.autosubmit && !e.nosubmit) {
					this.submit({action: 'autosubmit'});
				}
			},

			valueRemove(field, e) {
				// remove error of removed value
				if (field.errors && field.errors.length) {
					field.errors.splice(e, 1);
				}
			},

		}
	};

	const _hoisted_1$4 = {
	  key: 1,
	  class: "form__form-errors"
	};
	const _hoisted_2$3 = { class: "form__wrap" };
	const _hoisted_3$1 = {
	  key: 0,
	  class: "form__tabs"
	};
	const _hoisted_4 = { class: "form__main flc fcc" };
	const _hoisted_5 = { class: "form__groups" };
	const _hoisted_6 = {
	  key: 0,
	  class: "form__group-title flc"
	};
	const _hoisted_7 = { class: "form__group-body flc" };
	const _hoisted_8 = { class: "form__fields" };
	const _hoisted_9 = { class: "form__pre-action" };
	const _hoisted_10 = {
	  key: 0,
	  class: "form__group form__group--alt"
	};
	const _hoisted_11 = { class: "form__group-body flc" };
	const _hoisted_12 = { class: "form__fields" };
	const _hoisted_13 = { class: "form__field form__field--flex" };
	const _hoisted_14 = { class: "form__actions" };
	const _hoisted_15 = {
	  key: 0,
	  class: "sign-up__delimiter"
	};
	const _hoisted_16 = {
	  key: 1,
	  class: "svg-icon"
	};

	function render$c(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_field = resolveComponent("v-field");

	  return ($data.form)
	    ? (openBlock(), createBlock("form", {
	        key: 0,
	        class: ["v-form form", {'form--card': $props.mode === 'card', 'form--collapse': $props.mode === 'collapse'}],
	        onSubmit: _cache[3] || (_cache[3] = withModifiers((...args) => ($options.submit && $options.submit(...args)), ["prevent"])),
	        novalidate: "novalidate",
	        autocomplete: "off"
	      }, [
	        createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	        ($data.form && $data.form.success && $data.form.message)
	          ? (openBlock(), createBlock("div", {
	              key: 0,
	              class: "form__success-message",
	              innerHTML: $data.form.message
	            }, null, 8 /* PROPS */, ["innerHTML"]))
	          : createCommentVNode("v-if", true),
	        ($data.form && $data.form.errors && $data.form.errors.form && $data.form.errors.form.length)
	          ? (openBlock(), createBlock("div", _hoisted_1$4, [
	              (Array.isArray($data.form.errors.form) && $data.form.errors.form.length)
	                ? (openBlock(true), createBlock(Fragment, { key: 0 }, renderList($data.form.errors.form, (error) => {
	                    return (openBlock(), createBlock("div", {
	                      class: "form__form-error flc",
	                      innerHTML: error
	                    }, null, 8 /* PROPS */, ["innerHTML"]))
	                  }), 256 /* UNKEYED_FRAGMENT */))
	                : (openBlock(), createBlock("div", {
	                    key: 1,
	                    class: "form__form-error flc",
	                    innerHTML: $data.form.errors.form
	                  }, null, 8 /* PROPS */, ["innerHTML"]))
	            ]))
	          : createCommentVNode("v-if", true),
	        ($data.form && (!$data.form.success || !$data.form.hideFormOnSuccess))
	          ? (openBlock(), createBlock(Fragment, { key: 2 }, [
	              createVNode("div", _hoisted_2$3, [
	                (_ctx.$slots['tabs'])
	                  ? (openBlock(), createBlock("div", _hoisted_3$1, [
	                      renderSlot(_ctx.$slots, "tabs")
	                    ]))
	                  : createCommentVNode("v-if", true),
	                createVNode("div", _hoisted_4, [
	                  createVNode("div", _hoisted_5, [
	                    (openBlock(true), createBlock(Fragment, null, renderList($data.form.groups, (group) => {
	                      return (openBlock(), createBlock("div", {
	                        class: ["form__group", {'form__group--disabled': group.disabled}],
	                        style: {width: group.width || null},
	                        key: group.id
	                      }, [
	                        (group.title)
	                          ? (openBlock(), createBlock("h3", _hoisted_6, toDisplayString(group.title), 1 /* TEXT */))
	                          : createCommentVNode("v-if", true),
	                        (group.note)
	                          ? (openBlock(), createBlock("div", {
	                              key: 1,
	                              class: "form__group-note flc",
	                              innerHTML: group.note
	                            }, null, 8 /* PROPS */, ["innerHTML"]))
	                          : createCommentVNode("v-if", true),
	                        createVNode("div", _hoisted_7, [
	                          createVNode("div", _hoisted_8, [
	                            (openBlock(true), createBlock(Fragment, null, renderList($data.form.fields, (field, index) => {
	                              return (openBlock(), createBlock(Fragment, null, [
	                                (field.groupId === group.id)
	                                  ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	                                      (field.type === 'spacer')
	                                        ? (openBlock(), createBlock("div", {
	                                            class: "form__field form__field--spacer",
	                                            style: {width: field.width || null},
	                                            key: "spacer"
	                                          }, null, 4 /* STYLE */))
	                                        : (openBlock(), createBlock("div", {
	                                            class: ["form__field", {'form__field--hidden': field.type === 'hidden'}],
	                                            style: {width: field.width || null},
	                                            key: field.id
	                                          }, [
	                                            createVNode(_component_v_field, {
	                                              field: {...field, errors: $options.getFieldError(field)},
	                                              modelValue: field.value,
	                                              "onUpdate:modelValue": [$event => (field.value = $event), $event => ($options.fieldChanged(field, $event))],
	                                              onFileinput: $event => ($options.fileInput(field, $event)),
	                                              onFileremove: $event => ($options.fileRemove(field, $event)),
	                                              onRemove: $event => ($options.valueRemove(field, $event)),
	                                              "onUpdate:childValue": $event => ($options.fieldChanged(field, $event))
	                                            }, null, 8 /* PROPS */, ["field", "modelValue", "onUpdate:modelValue", "onFileinput", "onFileremove", "onRemove", "onUpdate:childValue"])
	                                          ], 6 /* CLASS, STYLE */))
	                                    ], 64 /* STABLE_FRAGMENT */))
	                                  : createCommentVNode("v-if", true)
	                              ], 64 /* STABLE_FRAGMENT */))
	                            }), 256 /* UNKEYED_FRAGMENT */))
	                          ])
	                        ])
	                      ], 6 /* CLASS, STYLE */))
	                    }), 128 /* KEYED_FRAGMENT */))
	                  ])
	                ])
	              ]),
	              createVNode("div", _hoisted_9, [
	                renderSlot(_ctx.$slots, "preAction"),
	                renderSlot(_ctx.$slots, "preaction")
	              ]),
	              ($data.form.requireConfirm && $data.form.requireConfirmText)
	                ? (openBlock(), createBlock("div", _hoisted_10, [
	                    createVNode("div", _hoisted_11, [
	                      createVNode("div", _hoisted_12, [
	                        createVNode("div", _hoisted_13, [
	                          createVNode(_component_v_field, {
	                            class: "field--big-checkbox",
	                            field: $options.computedConfirmField,
	                            modelValue: $data.confirmValue,
	                            "onUpdate:modelValue": [
	                              _cache[1] || (_cache[1] = $event => ($data.confirmValue = $event)),
	                              _cache[2] || (_cache[2] = $event => ($data.confirmed = !$data.confirmed))
	                            ]
	                          }, null, 8 /* PROPS */, ["field", "modelValue"])
	                        ])
	                      ])
	                    ])
	                  ]))
	                : createCommentVNode("v-if", true),
	              ($data.form.buttons && $data.form.buttons.length)
	                ? (openBlock(), createBlock("div", {
	                    key: 1,
	                    class: ["form__footer flc", {'form__footer--alt': $props.altFooter}]
	                  }, [
	                    createVNode("div", _hoisted_14, [
	                      (openBlock(true), createBlock(Fragment, null, renderList($data.form.buttons, (button, index) => {
	                        return (openBlock(), createBlock("div", {
	                          class: "form__action",
	                          key: index
	                        }, [
	                          (button.type == 'delimiter')
	                            ? (openBlock(), createBlock("div", _hoisted_15, [
	                                createVNode("span", null, toDisplayString(button.text), 1 /* TEXT */)
	                              ]))
	                            : (button.link)
	                              ? (openBlock(), createBlock("a", {
	                                  key: 1,
	                                  class: button.className || 'btn btn--primary',
	                                  href: button.link,
	                                  disabled: !$data.confirmed || button.disabled
	                                }, [
	                                  (button.img)
	                                    ? (openBlock(), createBlock("img", {
	                                        key: 0,
	                                        src: button.img,
	                                        loading: "lazy",
	                                        decoding: "async",
	                                        alt: "button.text",
	                                        title: "button.text"
	                                      }, null, 8 /* PROPS */, ["src"]))
	                                    : createCommentVNode("v-if", true),
	                                  (button.icon)
	                                    ? (openBlock(), createBlock("svg", _hoisted_16, [
	                                        createVNode("use", {
	                                          "xlink:href": '/local/assets/dist/icons/sprite.svg#svg-icon-' + button.icon
	                                        }, null, 8 /* PROPS */, ["xlink:href"])
	                                      ]))
	                                    : createCommentVNode("v-if", true),
	                                  createVNode("span", null, toDisplayString(button.text), 1 /* TEXT */)
	                                ], 10 /* CLASS, PROPS */, ["href", "disabled"]))
	                              : (openBlock(), createBlock("button", {
	                                  key: 2,
	                                  type: button.type || 'submit',
	                                  class: button.className || 'btn btn--primary',
	                                  "data-modal-url": button.modalUrl,
	                                  "data-modal-data": button.modalData,
	                                  disabled: $data.form.requireConfirm ? !$data.confirmed : null
	                                }, toDisplayString(button.text), 11 /* TEXT, CLASS, PROPS */, ["type", "data-modal-url", "data-modal-data", "disabled"]))
	                        ]))
	                      }), 128 /* KEYED_FRAGMENT */))
	                    ]),
	                    renderSlot(_ctx.$slots, "additional")
	                  ], 2 /* CLASS */))
	                : createCommentVNode("v-if", true)
	            ], 64 /* STABLE_FRAGMENT */))
	          : createCommentVNode("v-if", true)
	      ], 34 /* CLASS, HYDRATE_EVENTS */))
	    : createCommentVNode("v-if", true)
	}

	script$a.render = render$c;
	script$a.__file = "local/assets/source/components/v-form.vue";

	var script$b = {
		mixins: [
			script$2
		],

		props: {
			mode: {
				type: String,
				default: null
			}
		},

		data() {
			return {
				form: null,
				localFormData: new FormData()
			};
		},

		methods: {
			dataSet(data) {
				this.form = data;
			},

			getFieldError(field) {
				if (this.form.errors && this.form.errors.fields) {
					let filteredErrors = this.form.errors.fields.filter((item) => item.name === field.name);
					return filteredErrors.length ? filteredErrors : null;
				} else {
					return null;
				}
			},

			submit() {
				if (this.form && this.form.fields) {

					this.form.fields.forEach(field => {
						let key = this.proxyFieldName(field.name);

						if (!field.value) {
							field.value = '';
						}

						this.localFormData.append(key, field.value);
					});
				}

				this.localFormData.set('state[action]', 'submit');
				this.localFormData.set('bxajaxid', this.bxajaxid);

				this.dataLoad({
					url: this.form.remote,
					delay: true,
					data: this.localFormData
				});
			},

			proxyFieldName(name) {
				return `state[form][${name}]`;
			},
		}
	};

	const _hoisted_1$5 = { class: "subscription-form__field" };
	const _hoisted_2$4 = {
	  key: 0,
	  class: "subscription-form__btn",
	  type: "submit",
	  "aria-label": "Отправить"
	};
	const _hoisted_3$2 = /*#__PURE__*/createVNode("span", { class: "hidden-lg hidden-md" }, "Подписаться", -1 /* HOISTED */);
	const _hoisted_4$1 = /*#__PURE__*/createVNode("svg", { class: "svg-icon hidden-sm hidden-xs" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-text" })
	], -1 /* HOISTED */);

	function render$d(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_field = resolveComponent("v-field");

	  return (openBlock(), createBlock("form", {
	    class: "v-subscription-form subscription-form",
	    onSubmit: _cache[1] || (_cache[1] = withModifiers((...args) => ($options.submit && $options.submit(...args)), ["prevent"])),
	    novalidate: "novalidate",
	    autocomplete: "off"
	  }, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.form)
	      ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	          ($data.form && $data.form.success && $data.form.message)
	            ? (openBlock(), createBlock("div", {
	                key: 0,
	                class: "subscription-form__success-message flc",
	                innerHTML: $data.form.message
	              }, null, 8 /* PROPS */, ["innerHTML"]))
	            : createCommentVNode("v-if", true),
	          ($data.form &&  !$data.form.success)
	            ? (openBlock(), createBlock(Fragment, { key: 1 }, [
	                (openBlock(true), createBlock(Fragment, null, renderList($data.form.fields, (field) => {
	                  return (openBlock(), createBlock("div", _hoisted_1$5, [
	                    createVNode(_component_v_field, {
	                      field: {...field, errors: $options.getFieldError(field)},
	                      modelValue: field.value,
	                      "onUpdate:modelValue": $event => (field.value = $event)
	                    }, null, 8 /* PROPS */, ["field", "modelValue", "onUpdate:modelValue"])
	                  ]))
	                }), 256 /* UNKEYED_FRAGMENT */)),
	                ($data.form?.fields?.length)
	                  ? (openBlock(), createBlock("button", _hoisted_2$4, [
	                      _hoisted_3$2,
	                      _hoisted_4$1
	                    ]))
	                  : createCommentVNode("v-if", true)
	              ], 64 /* STABLE_FRAGMENT */))
	            : createCommentVNode("v-if", true)
	        ], 64 /* STABLE_FRAGMENT */))
	      : createCommentVNode("v-if", true)
	  ], 32 /* HYDRATE_EVENTS */))
	}

	script$b.render = render$d;
	script$b.__file = "local/assets/source/components/v-subscription-form.vue";

	var script$c = {
		props: {
			field: {
				type: Object,
				default: null,
				required: true
			},

			modelValue: {
				type: [Object, String, Number, Boolean, Date],
				default: null
			},

			fieldsErrors: {
				type: Array,
				default: null
			}
		},

		emits: [
			'fileinput',
			'fileremove',
			'update:modelValue',
			'update:childValue',
			'fieldfocus',
			'remove',
			'focus',
			'blur'
		],

		data() {
			return {
				localValue: null,
				localErrors: null
			};
		},

		computed: {
			multipleLimitMin() {
				let limit = this.field && this.field.multipleLimitMin;
				return isNaN(limit) ? 1 : limit;
			}
		},

		watch: {
			modelValue: {
				immediate: true,
				handler() {
					this.updateLocalValue();
				}
			},

			field: {
				immediate: true,
				handler() {
					this.localErrors = this.field.errors;
				}
			}
		},

		methods: {
			emitFieldfocus() {
				this.$emit('fieldfocus');
			},

			fileInput(e) {
				this.$emit('fileinput', e);
			},

			fileRemove(e) {
				this.$emit('fileremove', e);
			},

			updateLocalValue() {
				this.localValue = this.modelValue;
			},

			multipleAdd() {
				if (!Array.isArray(this.localValue)) {
					this.localValue = [];
				}

				if (this.localValue.length < this.field.multipleLimit) {
					this.localValue.push(null);
				}
			},

			multipleRemove(index) {
				this.localValue.splice(index, 1);

				if (Array.isArray(this.localErrors)) {
					this.localErrors.splice(index, 1);
				}
			},

			handleInput(value) {
				this.localValue = value;
				this.$emit('update:modelValue', this.localValue);

				if (!this.localValue?.length) {
					this.$emit('remove', this.localValue);
				}
			},

			handleInputChild(field) {
				this.$emit('update:childValue', this.field);
			},

			inputFocus() {
				this.$emit('focus');
			},

			inputBlur() {
				this.$emit('blur');
			},
		}
	};

	const _hoisted_1$6 = {
	  key: 0,
	  class: "field__multiple-list"
	};
	const _hoisted_2$5 = { class: "field__multiple-list-grid" };
	const _hoisted_3$3 = { class: "field__multiple-list-item" };
	const _hoisted_4$2 = { class: "field__errors flc" };

	function render$e(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component__self = resolveComponent("_self");
	  const _component_v_field_rating = resolveComponent("v-field-rating");
	  const _component_v_field_select = resolveComponent("v-field-select");
	  const _component_v_field_tumbler = resolveComponent("v-field-tumbler");
	  const _component_v_field_check_list = resolveComponent("v-field-check-list");
	  const _component_v_field_switch = resolveComponent("v-field-switch");
	  const _component_v_field_radio_buttons = resolveComponent("v-field-radio-buttons");
	  const _component_v_field_toggles = resolveComponent("v-field-toggles");
	  const _component_v_field_colors = resolveComponent("v-field-colors");
	  const _component_v_field_count = resolveComponent("v-field-count");
	  const _component_v_field_number_range = resolveComponent("v-field-number-range");
	  const _component_v_field_range = resolveComponent("v-field-range");
	  const _component_v_field_range_slider = resolveComponent("v-field-range-slider");
	  const _component_v_field_file = resolveComponent("v-field-file");
	  const _component_v_field_view_picker = resolveComponent("v-field-view-picker");
	  const _component_v_field_tooltip = resolveComponent("v-field-tooltip");
	  const _component_v_field_text = resolveComponent("v-field-text");

	  return (openBlock(), createBlock("div", {
	    class: ["v-field field", {'form-error': $props.field && $data.localErrors && $data.localErrors.length && !$props.field.multiple, 'field--rating': $props.field.type == 'rating'}]
	  }, [
	    ($props.field.multiple && $props.field.type !== 'file')
	      ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	          (Array.isArray($data.localValue) && $data.localValue.length)
	            ? (openBlock(), createBlock("div", _hoisted_1$6, [
	                createVNode("div", _hoisted_2$5, [
	                  (openBlock(true), createBlock(Fragment, null, renderList($data.localValue, (item, index) => {
	                    return (openBlock(), createBlock("div", _hoisted_3$3, [
	                      createVNode(_component__self, {
	                        field: {...$props.field, multiple: false, label: $props.field.label, errors: $data.localErrors ? $data.localErrors[index] : null},
	                        modelValue: $data.localValue[index],
	                        "onUpdate:modelValue": $event => ($data.localValue[index] = $event)
	                      }, null, 8 /* PROPS */, ["field", "modelValue", "onUpdate:modelValue"]),
	                      ($data.localValue.length > $options.multipleLimitMin)
	                        ? (openBlock(), createBlock("button", {
	                            key: 0,
	                            class: "field__multiple-list-remove link",
	                            type: "button",
	                            onClick: $event => ($options.multipleRemove(index))
	                          }, "Удалить", 8 /* PROPS */, ["onClick"]))
	                        : createCommentVNode("v-if", true)
	                    ]))
	                  }), 256 /* UNKEYED_FRAGMENT */))
	                ])
	              ]))
	            : createCommentVNode("v-if", true),
	          createVNode(Transition, { name: "fade" }, {
	            default: withCtx(() => [
	              (!$data.localValue || $data.localValue.length < $props.field.multipleLimit)
	                ? (openBlock(), createBlock("button", {
	                    key: 0,
	                    class: "field__multiple-list-add link",
	                    type: "button",
	                    onClick: _cache[1] || (_cache[1] = (...args) => ($options.multipleAdd && $options.multipleAdd(...args)))
	                  }, "Добавить"))
	                : createCommentVNode("v-if", true)
	            ]),
	            _: 1 /* STABLE */
	          })
	        ], 64 /* STABLE_FRAGMENT */))
	      : (openBlock(), createBlock(Fragment, { key: 1 }, [
	          ($props.field.type == 'rating')
	            ? (openBlock(), createBlock(_component_v_field_rating, {
	                key: 0,
	                field: $props.field,
	                "model-value": $data.localValue,
	                "onUpdate:modelValue": $options.handleInput
	              }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue"]))
	            : ($props.field.type == 'select')
	              ? (openBlock(), createBlock(_component_v_field_select, {
	                  key: 1,
	                  field: $props.field,
	                  "model-value": $data.localValue,
	                  "onUpdate:modelValue": $options.handleInput
	                }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue"]))
	              : ($props.field.type == 'tumbler')
	                ? (openBlock(), createBlock(_component_v_field_tumbler, {
	                    key: 2,
	                    field: $props.field,
	                    "model-value": $data.localValue,
	                    "onUpdate:modelValue": $options.handleInput
	                  }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue"]))
	                : ($props.field.type == 'check-list')
	                  ? (openBlock(), createBlock(_component_v_field_check_list, {
	                      key: 3,
	                      field: $props.field,
	                      "model-value": $data.localValue,
	                      "onUpdate:modelValue": $options.handleInput
	                    }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue"]))
	                  : ($props.field.type == 'switch')
	                    ? (openBlock(), createBlock(_component_v_field_switch, {
	                        key: 4,
	                        field: $props.field,
	                        "model-value": $data.localValue,
	                        "onUpdate:modelValue": $options.handleInput
	                      }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue"]))
	                    : ($props.field.type == 'radio-list')
	                      ? (openBlock(), createBlock(_component_v_field_check_list, {
	                          key: 5,
	                          field: $props.field,
	                          radio: "radio",
	                          "model-value": $data.localValue,
	                          "onUpdate:modelValue": $options.handleInput
	                        }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue"]))
	                      : ($props.field.type == 'radio-buttons')
	                        ? (openBlock(), createBlock(_component_v_field_radio_buttons, {
	                            key: 6,
	                            field: $props.field,
	                            radio: "radio",
	                            "model-value": $data.localValue,
	                            "onUpdate:modelValue": $options.handleInput,
	                            "onUpdate:childValue": $options.handleInputChild,
	                            fieldsErrors: $props.fieldsErrors
	                          }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue", "onUpdate:childValue", "fieldsErrors"]))
	                        : ($props.field.type == 'toggles')
	                          ? (openBlock(), createBlock(_component_v_field_toggles, {
	                              key: 7,
	                              field: $props.field,
	                              radio: "radio",
	                              "model-value": $data.localValue,
	                              "onUpdate:modelValue": $options.handleInput
	                            }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue"]))
	                          : ($props.field.type == 'colors')
	                            ? (openBlock(), createBlock(_component_v_field_colors, {
	                                key: 8,
	                                field: $props.field,
	                                radio: "radio",
	                                "model-value": $data.localValue,
	                                "onUpdate:modelValue": $options.handleInput
	                              }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue"]))
	                            : ($props.field.type == 'count')
	                              ? (openBlock(), createBlock(_component_v_field_count, {
	                                  key: 9,
	                                  field: $props.field,
	                                  "model-value": $data.localValue,
	                                  "onUpdate:modelValue": $options.handleInput,
	                                  onFieldfocus: $options.emitFieldfocus
	                                }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue", "onFieldfocus"]))
	                              : ($props.field.type == 'number-range')
	                                ? (openBlock(), createBlock(_component_v_field_number_range, {
	                                    key: 10,
	                                    field: $props.field,
	                                    "model-value": $data.localValue,
	                                    "onUpdate:modelValue": $options.handleInput
	                                  }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue"]))
	                                : ($props.field.type == 'range')
	                                  ? (openBlock(), createBlock(_component_v_field_range, {
	                                      key: 11,
	                                      field: $props.field,
	                                      "model-value": $data.localValue,
	                                      "onUpdate:modelValue": $options.handleInput
	                                    }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue"]))
	                                  : ($props.field.type == 'range-slider')
	                                    ? (openBlock(), createBlock(_component_v_field_range_slider, {
	                                        key: 12,
	                                        field: $props.field,
	                                        "model-value": $data.localValue,
	                                        "onUpdate:modelValue": $options.handleInput
	                                      }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue"]))
	                                    : ($props.field.type == 'file')
	                                      ? (openBlock(), createBlock(_component_v_field_file, {
	                                          key: 13,
	                                          field: $props.field,
	                                          onFileinput: $options.fileInput,
	                                          onFileremove: $options.fileRemove
	                                        }, null, 8 /* PROPS */, ["field", "onFileinput", "onFileremove"]))
	                                      : ($props.field.type == 'view-picker')
	                                        ? (openBlock(), createBlock(_component_v_field_view_picker, {
	                                            key: 14,
	                                            field: $props.field,
	                                            "model-value": $data.localValue,
	                                            "onUpdate:modelValue": $options.handleInput,
	                                            disabled: $props.field.disabled
	                                          }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue", "disabled"]))
	                                        : ($props.field.type == 'tooltip')
	                                          ? (openBlock(), createBlock(_component_v_field_tooltip, {
	                                              key: 15,
	                                              field: $props.field,
	                                              "model-value": $data.localValue,
	                                              "onUpdate:modelValue": $options.handleInput,
	                                              disabled: $props.field.disabled
	                                            }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue", "disabled"]))
	                                          : (openBlock(), createBlock(_component_v_field_text, {
	                                              key: 16,
	                                              field: $props.field,
	                                              "model-value": $data.localValue,
	                                              disabled: $props.field.disabled,
	                                              "onUpdate:modelValue": $options.handleInput,
	                                              onFocus: $options.inputFocus,
	                                              onBlur: $options.inputBlur
	                                            }, {
	                                              default: withCtx(() => [
	                                                ($props.field.note)
	                                                  ? (openBlock(), createBlock("div", {
	                                                      key: 0,
	                                                      class: "field__note",
	                                                      innerHTML: $props.field.note
	                                                    }, null, 8 /* PROPS */, ["innerHTML"]))
	                                                  : createCommentVNode("v-if", true)
	                                              ]),
	                                              _: 1 /* STABLE */
	                                            }, 8 /* PROPS */, ["field", "model-value", "disabled", "onUpdate:modelValue", "onFocus", "onBlur"])),
	          (Array.isArray($data.localErrors) && $data.localErrors && $data.localErrors.length)
	            ? (openBlock(true), createBlock(Fragment, { key: 17 }, renderList($data.localErrors, (error) => {
	                return (openBlock(), createBlock("div", _hoisted_4$2, [
	                  (Array.isArray(error.message) && error.message.length)
	                    ? (openBlock(true), createBlock(Fragment, { key: 0 }, renderList(error.message, (errorItem) => {
	                        return (openBlock(), createBlock("div", {
	                          class: "field__error flc",
	                          innerHTML: errorItem
	                        }, null, 8 /* PROPS */, ["innerHTML"]))
	                      }), 256 /* UNKEYED_FRAGMENT */))
	                    : (openBlock(), createBlock("div", {
	                        key: 1,
	                        class: "field__error flc",
	                        innerHTML: error.message
	                      }, null, 8 /* PROPS */, ["innerHTML"]))
	                ]))
	              }), 256 /* UNKEYED_FRAGMENT */))
	            : createCommentVNode("v-if", true)
	        ], 64 /* STABLE_FRAGMENT */))
	  ], 2 /* CLASS */))
	}

	script$c.render = render$e;
	script$c.__file = "local/assets/source/components/v-field.vue";

	var script$d = {
		props: {
			field: {
				type: Object,
				default: null,
				required: true
			},

			modelValue: {
				type: [String, Number],
				default: null
			}
		},

		emits: [
			'update:modelValue',
			'focus',
			'blur'
		],

		data() {
			return {
				localValue: null,
				savedValue: null,
				uniqueId: uniqueId('field-text_'),
				hasFocus: false,
				openPassword: false
			};
		},

		computed: {
			computedType() {
				if (!this.field.type || this.field.type == 'number') {
					return 'text';
				}
				return this.field.type;
			},

			isFieldNumeric() {
				return !!(this.field.type === 'number' || this.field.inputmode === 'numeric' || this.field.inputmode === 'decimal');
			}
		},

		watch: {
			modelValue: {
				immediate: true,
				handler() {
					if (this.isFieldNumeric && this.modelValue) {
						this.localValue = this.savedValue = this.modelValue.toString().replace('.', ',');
					} else {
						this.localValue = this.savedValue = this.modelValue;
					}
				}
			},

			hasFocus() {
				this.$forceUpdate();
			}
		},

		methods: {
			checkPlaceholderState() {
				let valueToTest = this.localValue;
				return !this.hasFocus && (valueToTest === null || valueToTest === '' || valueToTest.length === 0);
			},

			inputFocus() {
				this.hasFocus = true;
				if (!this.localValue?.length && this.field.type === 'tel') {
					this.localValue = '+375';
				}
				this.$emit('focus');
			},

			inputBlur() {
				this.hasFocus = false;
				this.$emit('blur');
			},

			handleKeyup() {
				if (this.isFieldNumeric && this.savedValue) {
					this.localValue = String(this.savedValue).replace('.', ',');
				}
			},

			handleKeyPress(e) {
				if (this.isFieldNumeric) {
					if (!/[\d\,\.]/.test(e.key)) {
						e.preventDefault();
					}
				}
			},

			handleInput() {
				if (this.isFieldNumeric) {
					if (!this.localValue || /^-?(?:\d+)(?:(\.|,)(\d+)?)?$/.test(this.localValue)) {
						this.savedValue = this.localValue;
					} else {
						this.localValue = this.savedValue;
					}
					if (this.field.min && this.field.max) {
						this.localValue = this.savedValue = Math.min(Math.max(this.localValue, this.field.min), this.field.max);
					} else {
						this.localValue = this.savedValue;
					}
					this.$emit('update:modelValue', this.localValue ? parseFloat(this.localValue.toString().replace(',', '.')) : this.localValue);
				} else {
					this.$emit('update:modelValue', this.localValue);
				}
			},

			handleChange(event) {
				setTimeout(() => {
					if (event.target.matches(':-webkit-autofill')) {
						// event.target.focus()
						this.handleInput();
					}
				});
			},
		}
	};

	const _hoisted_1$7 = {
	  key: 0,
	  class: "field-text__wrap"
	};
	const _hoisted_2$6 = {
	  key: 0,
	  class: "svg-icon field-text__success"
	};
	const _hoisted_3$4 = /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-success" }, null, -1 /* HOISTED */);
	const _hoisted_4$3 = {
	  key: 0,
	  class: "field-text__star"
	};
	const _hoisted_5$1 = { class: "field-text__wrap" };
	const _hoisted_6$1 = {
	  key: 0,
	  class: "svg-icon field-text__success"
	};
	const _hoisted_7$1 = /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-success" }, null, -1 /* HOISTED */);
	const _hoisted_8$1 = {
	  key: 0,
	  class: "field-text__star"
	};
	const _hoisted_9$1 = {
	  key: 0,
	  class: "svg-icon field-text__btn-eye-icon"
	};
	const _hoisted_10$1 = /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-eye" }, null, -1 /* HOISTED */);
	const _hoisted_11$1 = {
	  key: 1,
	  class: "svg-icon field-text__btn-eye-icon"
	};
	const _hoisted_12$1 = /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-eye-closed" }, null, -1 /* HOISTED */);
	const _hoisted_13$1 = {
	  key: 2,
	  class: "field-text__wrap"
	};
	const _hoisted_14$1 = {
	  key: 1,
	  class: "svg-icon field-text__icon"
	};
	const _hoisted_15$1 = {
	  key: 2,
	  class: "svg-icon field-text__success"
	};
	const _hoisted_16$1 = /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-success" }, null, -1 /* HOISTED */);
	const _hoisted_17 = {
	  key: 0,
	  class: "field-text__star"
	};
	const _hoisted_18 = {
	  key: 3,
	  class: "field-text__wrap"
	};
	const _hoisted_19 = {
	  key: 1,
	  class: "svg-icon field-text__icon"
	};
	const _hoisted_20 = {
	  key: 2,
	  class: "svg-icon field-text__success"
	};
	const _hoisted_21 = /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-success" }, null, -1 /* HOISTED */);
	const _hoisted_22 = {
	  key: 0,
	  class: "field-text__star"
	};
	const _hoisted_23 = {
	  key: 4,
	  class: "field-text__letter-counter"
	};

	function render$f(_ctx, _cache, $props, $setup, $data, $options) {
	  const _directive_maska = resolveDirective("maska");

	  return (openBlock(), createBlock("div", {
	    class: ["v-field-text field-text", {'field-text--icon': $props.field.icon, 'field-text--w-placeholder': $props.field.placeholder, 'field-text--placeholder-state': $props.field.placeholder && $options.checkPlaceholderState(), 'field-text--label': $props.field.label}]
	  }, [
	    ($props.field.type === 'textarea')
	      ? (openBlock(), createBlock("div", _hoisted_1$7, [
	          ($props.field.success)
	            ? (openBlock(), createBlock("svg", _hoisted_2$6, [
	                _hoisted_3$4
	              ]))
	            : createCommentVNode("v-if", true),
	          withDirectives(createVNode("textarea", {
	            class: ["field-input", {'field-input--sm': $props.field.size === 'sm', ['field-input--' + $props.field.type]: $props.field.type}],
	            inputmode: $props.field.inputmode,
	            disabled: $props.field.disabled,
	            placeholder: $props.field.placeholder,
	            maxlength: $props.field.maxlength,
	            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ($data.localValue = $event)),
	            onInput: _cache[2] || (_cache[2] = (...args) => ($options.handleInput && $options.handleInput(...args))),
	            onChange: _cache[3] || (_cache[3] = (...args) => ($options.handleChange && $options.handleChange(...args))),
	            onFocus: _cache[4] || (_cache[4] = (...args) => ($options.inputFocus && $options.inputFocus(...args))),
	            onBlur: _cache[5] || (_cache[5] = (...args) => ($options.inputBlur && $options.inputBlur(...args))),
	            id: $data.uniqueId
	          }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, ["inputmode", "disabled", "placeholder", "maxlength", "id"]), [
	            [vModelText, $data.localValue]
	          ]),
	          ($props.field.label)
	            ? (openBlock(), createBlock("label", {
	                key: 1,
	                class: "field-text__int-label",
	                for: $data.uniqueId
	              }, [
	                createTextVNode(toDisplayString($props.field.label), 1 /* TEXT */),
	                ($props.field.required)
	                  ? (openBlock(), createBlock("span", _hoisted_4$3, " *"))
	                  : createCommentVNode("v-if", true)
	              ], 8 /* PROPS */, ["for"]))
	            : createCommentVNode("v-if", true)
	        ]))
	      : ($props.field.type === 'password')
	        ? (openBlock(), createBlock(Fragment, { key: 1 }, [
	            createVNode("div", _hoisted_5$1, [
	              ($props.field.success)
	                ? (openBlock(), createBlock("svg", _hoisted_6$1, [
	                    _hoisted_7$1
	                  ]))
	                : createCommentVNode("v-if", true),
	              withDirectives(createVNode("input", {
	                class: ["field-input", {'field-input--sm': $props.field.size === 'sm', ['field-input--' + $props.field.type]: $props.field.type}],
	                ref: "input",
	                type: $data.openPassword ? 'text': 'password',
	                inputmode: $props.field.inputmode,
	                disabled: $props.field.disabled,
	                placeholder: $props.field.placeholder,
	                maxlength: $props.field.maxlength,
	                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ($data.localValue = $event)),
	                onInput: _cache[7] || (_cache[7] = (...args) => ($options.handleInput && $options.handleInput(...args))),
	                onChange: _cache[8] || (_cache[8] = (...args) => ($options.handleChange && $options.handleChange(...args))),
	                onKeyup: _cache[9] || (_cache[9] = (...args) => ($options.handleKeyup && $options.handleKeyup(...args))),
	                onFocus: _cache[10] || (_cache[10] = (...args) => ($options.inputFocus && $options.inputFocus(...args))),
	                onBlur: _cache[11] || (_cache[11] = (...args) => ($options.inputBlur && $options.inputBlur(...args))),
	                id: $data.uniqueId
	              }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, ["type", "inputmode", "disabled", "placeholder", "maxlength", "id"]), [
	                [vModelDynamic, $data.localValue]
	              ]),
	              ($props.field.label)
	                ? (openBlock(), createBlock("label", {
	                    key: 1,
	                    class: "field-text__int-label",
	                    for: $data.uniqueId
	                  }, [
	                    createTextVNode(toDisplayString($props.field.label), 1 /* TEXT */),
	                    ($props.field.required)
	                      ? (openBlock(), createBlock("span", _hoisted_8$1, " *"))
	                      : createCommentVNode("v-if", true)
	                  ], 8 /* PROPS */, ["for"]))
	                : createCommentVNode("v-if", true)
	            ]),
	            createVNode("button", {
	              class: "field-text__btn-eye",
	              type: "button",
	              onClick: _cache[12] || (_cache[12] = $event => ($data.openPassword = !$data.openPassword))
	            }, [
	              ($data.openPassword)
	                ? (openBlock(), createBlock("svg", _hoisted_9$1, [
	                    _hoisted_10$1
	                  ]))
	                : createCommentVNode("v-if", true),
	              (!$data.openPassword)
	                ? (openBlock(), createBlock("svg", _hoisted_11$1, [
	                    _hoisted_12$1
	                  ]))
	                : createCommentVNode("v-if", true)
	            ])
	          ], 64 /* STABLE_FRAGMENT */))
	        : (this.field.mask)
	          ? (openBlock(), createBlock("div", _hoisted_13$1, [
	              ($props.field.img)
	                ? (openBlock(), createBlock("img", {
	                    key: 0,
	                    class: "field-text__img",
	                    src: $props.field.img,
	                    loading: "lazy",
	                    decoding: "async",
	                    alt: "",
	                    title: ""
	                  }, null, 8 /* PROPS */, ["src"]))
	                : createCommentVNode("v-if", true),
	              ($props.field.icon)
	                ? (openBlock(), createBlock("svg", _hoisted_14$1, [
	                    createVNode("use", {
	                      "xlink:href": '/local/assets/dist/icons/sprite.svg#svg-icon-' + $props.field.icon
	                    }, null, 8 /* PROPS */, ["xlink:href"])
	                  ]))
	                : createCommentVNode("v-if", true),
	              ($props.field.success)
	                ? (openBlock(), createBlock("svg", _hoisted_15$1, [
	                    _hoisted_16$1
	                  ]))
	                : createCommentVNode("v-if", true),
	              withDirectives(createVNode("input", {
	                class: ["field-input", {'field-input--sm': $props.field.size === 'sm', ['field-input--' + $props.field.type]: $props.field.type}],
	                ref: "input",
	                type: $options.computedType,
	                inputmode: $props.field.inputmode,
	                disabled: $props.field.disabled,
	                placeholder: $props.field.placeholder,
	                maxlength: $props.field.maxlength,
	                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ($data.localValue = $event)),
	                onInput: _cache[14] || (_cache[14] = (...args) => ($options.handleInput && $options.handleInput(...args))),
	                onChange: _cache[15] || (_cache[15] = (...args) => ($options.handleChange && $options.handleChange(...args))),
	                onKeyup: _cache[16] || (_cache[16] = (...args) => ($options.handleKeyup && $options.handleKeyup(...args))),
	                onFocus: _cache[17] || (_cache[17] = (...args) => ($options.inputFocus && $options.inputFocus(...args))),
	                onBlur: _cache[18] || (_cache[18] = (...args) => ($options.inputBlur && $options.inputBlur(...args))),
	                id: $data.uniqueId
	              }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, ["type", "inputmode", "disabled", "placeholder", "maxlength", "id"]), [
	                [vModelDynamic, $data.localValue],
	                [_directive_maska, $props.field.mask.mask]
	              ]),
	              ($props.field.label)
	                ? (openBlock(), createBlock("label", {
	                    key: 3,
	                    class: "field-text__int-label",
	                    for: $data.uniqueId
	                  }, [
	                    createTextVNode(toDisplayString($props.field.label), 1 /* TEXT */),
	                    ($props.field.required)
	                      ? (openBlock(), createBlock("span", _hoisted_17, " *"))
	                      : createCommentVNode("v-if", true)
	                  ], 8 /* PROPS */, ["for"]))
	                : createCommentVNode("v-if", true)
	            ]))
	          : (openBlock(), createBlock("div", _hoisted_18, [
	              ($props.field.img)
	                ? (openBlock(), createBlock("img", {
	                    key: 0,
	                    class: "field-text__img",
	                    src: $props.field.img,
	                    loading: "lazy",
	                    decoding: "async",
	                    alt: "",
	                    title: ""
	                  }, null, 8 /* PROPS */, ["src"]))
	                : createCommentVNode("v-if", true),
	              ($props.field.icon)
	                ? (openBlock(), createBlock("svg", _hoisted_19, [
	                    createVNode("use", {
	                      "xlink:href": '/local/assets/dist/icons/sprite.svg#svg-icon-' + $props.field.icon
	                    }, null, 8 /* PROPS */, ["xlink:href"])
	                  ]))
	                : createCommentVNode("v-if", true),
	              ($props.field.success)
	                ? (openBlock(), createBlock("svg", _hoisted_20, [
	                    _hoisted_21
	                  ]))
	                : createCommentVNode("v-if", true),
	              withDirectives(createVNode("input", {
	                class: ["field-input", {'field-input--sm': $props.field.size === 'sm', ['field-input--' + $props.field.type]: $props.field.type}],
	                ref: "input",
	                type: $options.computedType,
	                inputmode: $props.field.inputmode,
	                disabled: $props.field.disabled,
	                placeholder: $props.field.placeholder,
	                maxlength: $props.field.maxlength,
	                max: $props.field.type === 'date' ? '2999-12-31' : false,
	                "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => ($data.localValue = $event)),
	                onInput: _cache[20] || (_cache[20] = (...args) => ($options.handleInput && $options.handleInput(...args))),
	                onChange: _cache[21] || (_cache[21] = (...args) => ($options.handleChange && $options.handleChange(...args))),
	                onKeyup: _cache[22] || (_cache[22] = (...args) => ($options.handleKeyup && $options.handleKeyup(...args))),
	                onKeypress: _cache[23] || (_cache[23] = (...args) => ($options.handleKeyPress && $options.handleKeyPress(...args))),
	                onFocus: _cache[24] || (_cache[24] = (...args) => ($options.inputFocus && $options.inputFocus(...args))),
	                onBlur: _cache[25] || (_cache[25] = (...args) => ($options.inputBlur && $options.inputBlur(...args))),
	                id: $data.uniqueId
	              }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, ["type", "inputmode", "disabled", "placeholder", "maxlength", "max", "id"]), [
	                [vModelDynamic, $data.localValue]
	              ]),
	              ($props.field.label)
	                ? (openBlock(), createBlock("label", {
	                    key: 3,
	                    class: "field-text__int-label",
	                    for: $data.uniqueId
	                  }, [
	                    createTextVNode(toDisplayString($props.field.label), 1 /* TEXT */),
	                    ($props.field.required)
	                      ? (openBlock(), createBlock("span", _hoisted_22, " *"))
	                      : createCommentVNode("v-if", true)
	                  ], 8 /* PROPS */, ["for"]))
	                : createCommentVNode("v-if", true)
	            ])),
	    ($props.field.letterCounter)
	      ? (openBlock(), createBlock("div", _hoisted_23, toDisplayString($data.localValue?.length ?? 0) + " / " + toDisplayString($props.field.maxlength), 1 /* TEXT */))
	      : createCommentVNode("v-if", true),
	    renderSlot(_ctx.$slots, "default")
	  ], 2 /* CLASS */))
	}

	script$d.render = render$f;
	script$d.__file = "local/assets/source/components/v-field-text.vue";

	var script$e = {

		props: {
			field: {
				type: Object,
				default: null,
				required: true
			},

			modelValue: {
				type: [Object, String, Number, Boolean, Symbol, Date],
				default: null
			}
		},

		emits: [
			'update:modelValue'
		],

		data() {
			return {
				localValue: null,
				open: false,
				uniqueId: uniqueId('field-select_'),
				hasFocus: false,
				selectValueText: '',
				isSelectValueFound: false,
				isPlaceholderState: null,
				isPlaceholderState2: null
			};
		},

		computed: {
			activeOption() {
				if (this.field && this.field.options && this.field.options.length) {
					let result = this.field.options.find(option => option.value === this.localValue);
					return result;
				}
				return null;
			}
		},

		watch: {
			modelValue() {
				this.updateLocalValue();
			},

			hasFocus() {
				this.checkPlaceholderState2();
			}
		},

		created() {
			this.updateLocalValue();
			if (this.field.searchable && this.localValue) {
				this.selectValueText = this.activeOption ? this.activeOption.text || this.activeOption.value : '';
			}
			this.checkPlaceholderState();
			this.checkPlaceholderState2();
			document.addEventListener('click', this.handleClickOutside);
			document.addEventListener('keydown', this.handleEsc);
		},

		unmounted() {
			document.removeEventListener('click', this.handleClickOutside);
			document.removeEventListener('keydown', this.handleEsc);
		},

		methods: {
			handleClickSearchable(e, option) {
				this.localValue = option.value;
				this.handleInput();
				this.checkPlaceholderState2();
				this.open = false;
				this.selectValueText = option.text;
			},

			cleanField() {
				if (this.foundSelectValue() !== this.selectValueText) {
					this.selectValueText = '';
					this.localValue = '';
				}
			},

			toggleOpen() {
				if (this.field.disabled) {
					return false;
				}
				this.open = !this.open;
				this.selectValueText = '';
			},

			foundSelectValue() {
				let result = false;
				if (this.field && this.field.options && this.field.options.length) {
					for (let i = 0; i < this.field.options.length; i++) {
						if (this.isFoundSelectText(this.field.options[i].text)) {
							result = this.field.options[i].text;
							this.isSelectValueFound = true;
							break;
						}
					}
					if (result) {
						this.isSelectValueFound = true;
					} else {
						this.isSelectValueFound = false;
					}
				}
				return result;
			},

			isFoundSelectText(text = '') {
				let vm = this;
				let result = false;
				let selectValueText = vm.selectValueText;
				if (!selectValueText) {
					selectValueText = '';
				}
				if (text.toLowerCase().indexOf(selectValueText.toLowerCase()) !== -1) {
					result = true;
				} else {
					result = false;
				}
				return result;
			},

			inputFocus() {
				this.hasFocus = true;
			},

			inputBlur() {
				this.hasFocus = false;
			},

			checkPlaceholderState() {
				let valueToTest = this.localValue;
				this.isPlaceholderState = !this.activeOption && (valueToTest === null || valueToTest === undefined || valueToTest === '' || valueToTest.length === 0);
			},

			checkPlaceholderState2() {
				let valueToTest = this.localValue;
				this.isPlaceholderState2 = !this.hasFocus && (valueToTest === null || valueToTest === undefined || valueToTest === '' || valueToTest.length === 0);
			},

			updateLocalValue() {
				this.localValue = this.modelValue;
				if (this.field.searchable) {
					this.selectValueText = this.activeOption ? this.activeOption.text || this.activeOption.value : '';
				}
				this.checkPlaceholderState();
				this.checkPlaceholderState2();
			},

			handleInput() {
				this.$emit('update:modelValue', this.localValue);
			},

			handleClickOutside(e) {
				if (!this.$el.contains(e.target)) {
					this.open = false;
					if (this.field.type === 'select' && this.field.searchable) {
						this.cleanField();
					}
					this.checkPlaceholderState();
					this.checkPlaceholderState2();
					if (!this.activeOption) {
						this.selectValueText = '';
					}
				}
			},

			handleEsc(e) {
				if (e.keyCode == 27 && this.open) {
					e.stopPropagation();
					this.open = false;
					this.checkPlaceholderState2();
					if (this.field.type === 'select' && this.field.searchable) {
						this.cleanField();
					}
				}
			}
		}
	};

	const _hoisted_1$8 = {
	  key: 0,
	  class: "field-text__star"
	};
	const _hoisted_2$7 = /*#__PURE__*/createVNode("svg", { class: "svg-icon field-select__btn-arrow" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-chevron-down-sm" })
	], -1 /* HOISTED */);
	const _hoisted_3$5 = { class: "field-select__list-container scrollbar" };
	const _hoisted_4$4 = {
	  key: 0,
	  class: "svg-icon field-select__check-icon"
	};
	const _hoisted_5$2 = /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-select-check" }, null, -1 /* HOISTED */);
	const _hoisted_6$2 = {
	  key: 0,
	  class: "field-select__list-item field-select__list-item--message"
	};
	const _hoisted_7$2 = {
	  key: 0,
	  class: "field-text__star"
	};
	const _hoisted_8$2 = {
	  class: "field-select__btn-text",
	  key: "text"
	};
	const _hoisted_9$2 = /*#__PURE__*/createVNode("svg", { class: "svg-icon field-select__btn-arrow" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-chevron-down-sm" })
	], -1 /* HOISTED */);
	const _hoisted_10$2 = {
	  key: 0,
	  class: "field-select__list-container"
	};
	const _hoisted_11$2 = {
	  key: 0,
	  class: "svg-icon field-select__check-icon"
	};
	const _hoisted_12$2 = /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-select-check" }, null, -1 /* HOISTED */);

	function render$g(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", {
	    class: ["v-field-select field-select", {'field-select--open': $data.open, 'field-select--sm': $props.field.size === 'sm', 'field-select--w-placeholder': $props.field.placeholder, 'field-select--placeholder-state': $props.field.placeholder && $options.checkPlaceholderState(), 'field-select--disabled': $props.field.disabled}]
	  }, [
	    ($props.field.searchable)
	      ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	          createVNode("div", {
	            class: ["field-select__field-text field-text", {'field-text--label': $props.field.label, 'field-text--w-placeholder': $props.field.placeholder, 'field-text--placeholder-state': $props.field.placeholder && $options.checkPlaceholderState2()}]
	          }, [
	            withDirectives(createVNode("input", {
	              class: "field-select__field-text-input field-input",
	              ref: "input",
	              type: "text",
	              autocomplete: "new-password",
	              disabled: $props.field.disabled,
	              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ($data.selectValueText = $event)),
	              onInput: _cache[2] || (_cache[2] = $event => ($data.open = true)),
	              onFocus: _cache[3] || (_cache[3] = (...args) => ($options.inputFocus && $options.inputFocus(...args))),
	              onBlur: _cache[4] || (_cache[4] = (...args) => ($options.inputBlur && $options.inputBlur(...args))),
	              id: $data.uniqueId,
	              placeholder: $props.field.placeholder,
	              onKeyup: _cache[5] || (_cache[5] = (...args) => ($options.foundSelectValue && $options.foundSelectValue(...args)))
	            }, null, 40 /* PROPS, HYDRATE_EVENTS */, ["disabled", "id", "placeholder"]), [
	              [vModelText, $data.selectValueText]
	            ]),
	            ($props.field.label)
	              ? (openBlock(), createBlock("label", {
	                  key: 0,
	                  class: "field-text__int-label",
	                  for: $data.uniqueId
	                }, [
	                  createTextVNode(toDisplayString($props.field.label), 1 /* TEXT */),
	                  ($props.field.required)
	                    ? (openBlock(), createBlock("span", _hoisted_1$8, " *"))
	                    : createCommentVNode("v-if", true)
	                ], 8 /* PROPS */, ["for"]))
	              : createCommentVNode("v-if", true),
	            createVNode("button", {
	              class: "field-select__shevron",
	              type: "button",
	              onClick: _cache[6] || (_cache[6] = (...args) => ($options.toggleOpen && $options.toggleOpen(...args))),
	              disabled: $props.field.disabled
	            }, [
	              _hoisted_2$7
	            ], 8 /* PROPS */, ["disabled"])
	          ], 2 /* CLASS */),
	          createVNode(Transition, { name: "dropdown" }, {
	            default: withCtx(() => [
	              withDirectives(createVNode("div", {
	                class: "field-select__list",
	                onClick: _cache[7] || (_cache[7] = $event => {$data.open = false;})
	              }, [
	                createVNode(Transition, { name: "dropdown-inner" }, {
	                  default: withCtx(() => [
	                    withDirectives(createVNode("div", _hoisted_3$5, [
	                      (openBlock(true), createBlock(Fragment, null, renderList($props.field.options, (option) => {
	                        return (openBlock(), createBlock(Fragment, null, [
	                          ($options.isFoundSelectText(option.text))
	                            ? (openBlock(), createBlock("button", {
	                                key: 0,
	                                class: "field-select__list-item",
	                                type: "button",
	                                onClick: withModifiers($event => ($options.handleClickSearchable($event, option)), ["stop"]),
	                                disabled: $props.field.disable
	                              }, [
	                                (option.value === $data.localValue)
	                                  ? (openBlock(), createBlock("svg", _hoisted_4$4, [
	                                      _hoisted_5$2
	                                    ]))
	                                  : createCommentVNode("v-if", true),
	                                createVNode("span", null, toDisplayString(option.text), 1 /* TEXT */)
	                              ], 8 /* PROPS */, ["onClick", "disabled"]))
	                            : createCommentVNode("v-if", true)
	                        ], 64 /* STABLE_FRAGMENT */))
	                      }), 256 /* UNKEYED_FRAGMENT */)),
	                      ($data.selectValueText && $data.selectValueText.length > 0 && !$data.isSelectValueFound)
	                        ? (openBlock(), createBlock("div", _hoisted_6$2, "Ничего не найдено"))
	                        : createCommentVNode("v-if", true)
	                    ], 512 /* NEED_PATCH */), [
	                      [vShow, $data.open]
	                    ])
	                  ]),
	                  _: 1 /* STABLE */
	                })
	              ], 512 /* NEED_PATCH */), [
	                [vShow, $props.field && $data.open]
	              ])
	            ]),
	            _: 1 /* STABLE */
	          })
	        ], 64 /* STABLE_FRAGMENT */))
	      : (openBlock(), createBlock(Fragment, { key: 1 }, [
	          ($props.field.label)
	            ? (openBlock(), createBlock("label", {
	                key: 0,
	                class: "field-select__label",
	                for: $data.uniqueId
	              }, [
	                createTextVNode(toDisplayString($props.field.label), 1 /* TEXT */),
	                ($props.field.required)
	                  ? (openBlock(), createBlock("span", _hoisted_7$2, " *"))
	                  : createCommentVNode("v-if", true)
	              ], 8 /* PROPS */, ["for"]))
	            : createCommentVNode("v-if", true),
	          createVNode("button", {
	            class: ["field-select__btn", {'field-select__btn--placeholder': $props.field.placeholder}],
	            type: "button",
	            onClick: _cache[8] || (_cache[8] = $event => ($data.open = !$data.open)),
	            id: $data.uniqueId,
	            disabled: $props.field.disabled
	          }, [
	            ($options.activeOption || $props.field.placeholder)
	              ? (openBlock(), createBlock("span", _hoisted_8$2, toDisplayString($options.activeOption?.text || $props.field.placeholder), 1 /* TEXT */))
	              : createCommentVNode("v-if", true),
	            _hoisted_9$2
	          ], 10 /* CLASS, PROPS */, ["id", "disabled"]),
	          createVNode(Transition, { name: "dropdown" }, {
	            default: withCtx(() => [
	              ($props.field && $data.open)
	                ? (openBlock(), createBlock("div", {
	                    key: 0,
	                    class: "field-select__list",
	                    onClick: _cache[9] || (_cache[9] = $event => {$data.open = false;})
	                  }, [
	                    createVNode(Transition, { name: "dropdown-inner" }, {
	                      default: withCtx(() => [
	                        ($data.open)
	                          ? (openBlock(), createBlock("div", _hoisted_10$2, [
	                              (openBlock(true), createBlock(Fragment, null, renderList($props.field.options, (option) => {
	                                return (openBlock(), createBlock("button", {
	                                  class: "field-select__list-item",
	                                  type: "button",
	                                  onClick: $event => {$data.localValue = option.value; $options.handleInput();},
	                                  disabled: $props.field.disabled
	                                }, [
	                                  (option.value === $data.localValue)
	                                    ? (openBlock(), createBlock("svg", _hoisted_11$2, [
	                                        _hoisted_12$2
	                                      ]))
	                                    : createCommentVNode("v-if", true),
	                                  createVNode("span", null, toDisplayString(option.text), 1 /* TEXT */)
	                                ], 8 /* PROPS */, ["onClick", "disabled"]))
	                              }), 256 /* UNKEYED_FRAGMENT */))
	                            ]))
	                          : createCommentVNode("v-if", true)
	                      ]),
	                      _: 1 /* STABLE */
	                    })
	                  ]))
	                : createCommentVNode("v-if", true)
	            ]),
	            _: 1 /* STABLE */
	          })
	        ], 64 /* STABLE_FRAGMENT */))
	  ], 2 /* CLASS */))
	}

	script$e.render = render$g;
	script$e.__file = "local/assets/source/components/v-field-select.vue";

	var script$f = {
		props: {
			radio: {
				type: Boolean,
				default: false
			},

			text: {
				type: [String, Number],
				default: null
			},
			color: 
			{
					type: [String, Number],
					default: null
			},
			edit: {
					type: [String, Number],
					default: null
			},
			note: {
				type: [String, Number],
				default: null
			},

			count: {
				type: [String, Number],
				default: null
			},

			price: {
				type: [String, Number],
				default: null
			},

			modelValue: {
				type: [Object, String, Number, Boolean],
				default: null
			},

			trueValue: {
				type: [Object, String, Number, Boolean],
				default: null
			},

			img: {
				type: [String, Boolean],
				default: false
			},

			icon: {
				type: [String, Boolean],
				default: false
			},

			view: {
				type: [String, Boolean],
				default: null
			},

			disabled: {
				type: Boolean,
				default: false
			},

			labelId: {
				type: String,
				default: null
			},
		},

		emits: [
			'update:modelValue'
		],

		data() {
			return {
				localValue: null,
				open: false,
				uniqueId: uniqueId('field-')
			};
		},

		watch: {
			modelValue() {
				this.updateLocalValue();
			}
		},

		created() {
			this.updateLocalValue();
		},

		methods: {
			updateLocalValue() {
				this.localValue = this.modelValue;
			},

			handleInput() {
				this.$emit('update:modelValue', this.localValue);
			}
		}
	};

	const _hoisted_1$9 = /*#__PURE__*/createVNode("span", { class: "field-checkbox__visual" }, [
	  /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	    /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-checkbox-active" })
	  ])
	], -1 /* HOISTED */);
	const _hoisted_2$8 = {
	  key: 0,
	  class: "field-checkbox__img"
	};
	const _hoisted_3$6 = {
	  key: 1,
	  class: "field-checkbox__img"
	};
	const _hoisted_4$5 = {
	  key: 2,
	  class: "field-checkbox__icon"
	};
	const _hoisted_5$3 = { class: "svg-icon" };
	const _hoisted_6$3 = /*#__PURE__*/createVNode("span", { class: "field-checkbox__frame" }, null, -1 /* HOISTED */);
	const _hoisted_7$3 = {
	  key: 3,
	  class: "field-checkbox__text"
	};
	const _hoisted_8$3 = {
	  key: 4,
	  class: "field-checkbox__price"
	};
	const _hoisted_9$3 = {
	  key: 5,
	  class: "field-checkbox__count"
	};

	function render$h(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("label", {
	    class: ["v-field-checkbox field-checkbox", {'field-checkbox--radio': $props.radio, ['field-checkbox--' + $props.view]: $props.view, 'disabled': $props.disabled}]
	  }, [
	    withDirectives(createVNode("input", {
	      class: "field-checkbox__input",
	      type: $props.radio ? 'radio' : 'checkbox',
	      value: $props.trueValue,
	      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ($data.localValue = $event)),
	      onChange: _cache[2] || (_cache[2] = (...args) => ($options.handleInput && $options.handleInput(...args))),
	      disabled: $props.disabled,
	      "aria-labelledby": ($props.labelId ? $props.labelId + ' ' + $data.uniqueId : null),
	      id: $data.uniqueId
	    }, null, 40 /* PROPS, HYDRATE_EVENTS */, ["type", "value", "disabled", "aria-labelledby", "id"]), [
	      [vModelDynamic, $data.localValue]
	    ]),
	    _hoisted_1$9,
	    ($props.img)
	      ? (openBlock(), createBlock("span", _hoisted_2$8, [
	          createVNode("img", {
	            src: $props.img,
	            loading: "lazy",
	            decoding: "async",
	            alt: $props.text
	          }, null, 8 /* PROPS */, ["src", "alt"])
	        ]))
	      : ($props.color)
	        ? (openBlock(), createBlock("span", _hoisted_3$6, [
	            createVNode("span", {
	              class: "field-radiocolor__visual",
	              style: {'background': $props.color}
	            }, null, 4 /* STYLE */)
	          ]))
	        : ($props.icon)
	          ? (openBlock(), createBlock("span", _hoisted_4$5, [
	              (openBlock(), createBlock("svg", _hoisted_5$3, [
	                createVNode("use", {
	                  "xlink:href": '/local/assets/dist/icons/sprite.svg#svg-icon-' + $props.icon
	                }, null, 8 /* PROPS */, ["xlink:href"])
	              ]))
	            ]))
	          : createCommentVNode("v-if", true),
	    _hoisted_6$3,
	    ($props.text || $props.note)
	      ? (openBlock(), createBlock("span", _hoisted_7$3, [
	          createVNode("span", {
	            class: "field-checkbox__text-content",
	            innerHTML: $props.text
	          }, null, 8 /* PROPS */, ["innerHTML"]),
	          ($props.note)
	            ? (openBlock(), createBlock("small", {
	                key: 0,
	                class: "field-checkbox__text-note",
	                innerHTML: $props.note
	              }, null, 8 /* PROPS */, ["innerHTML"]))
	            : createCommentVNode("v-if", true),
	          ($props.edit)
	            ? (openBlock(), createBlock("a", {
	                key: 1,
	                class: "field-checkbox__text-note js-open-modal",
	                "data-modal-data": "{\"className\": \"modal--sm\"}",
	                "data-modal-url": $props.edit,
	                href: "#"
	              }, "Изменить", 8 /* PROPS */, ["data-modal-url"]))
	            : createCommentVNode("v-if", true)
	        ]))
	      : createCommentVNode("v-if", true),
	    ($props.price)
	      ? (openBlock(), createBlock("span", _hoisted_8$3, toDisplayString($props.price), 1 /* TEXT */))
	      : createCommentVNode("v-if", true),
	    ($props.count)
	      ? (openBlock(), createBlock("span", _hoisted_9$3, toDisplayString($props.count), 1 /* TEXT */))
	      : createCommentVNode("v-if", true)
	  ], 2 /* CLASS */))
	}

	script$f.render = render$h;
	script$f.__file = "local/assets/source/components/v-field-checkbox.vue";

	var script$g = {
		props: {
			modelValue: {
				type: [Object, String, Number, Boolean],
				default: null
			},

			field: {
				type: Object,
				default: null
			},
		},

		emits: [
			'update:modelValue'
		],

		data() {
			return {
				localValue: null,
				open: false,
			};
		},

		watch: {
			modelValue() {
				this.updateLocalValue();
			}
		},

		created() {
			this.updateLocalValue();
		},

		methods: {
			updateLocalValue() {
				this.localValue = this.modelValue;
			},

			handleInput() {
				this.$emit('update:modelValue', this.localValue);
			}
		}
	};

	const _hoisted_1$a = /*#__PURE__*/createVNode("span", { class: "field-switch__visual" }, null, -1 /* HOISTED */);

	function render$i(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("label", {
	    class: ["v-field-switch field-switch", {'disabled': $props.field.disabled}]
	  }, [
	    withDirectives(createVNode("input", {
	      class: "field-switch__input",
	      type: "checkbox",
	      "true-value": $props.field.trueValue,
	      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ($data.localValue = $event)),
	      onChange: _cache[2] || (_cache[2] = (...args) => ($options.handleInput && $options.handleInput(...args))),
	      disabled: $props.field.disabled
	    }, null, 40 /* PROPS, HYDRATE_EVENTS */, ["true-value", "disabled"]), [
	      [vModelCheckbox, $data.localValue]
	    ]),
	    _hoisted_1$a,
	    ($props.field.label)
	      ? (openBlock(), createBlock("span", {
	          key: 0,
	          class: "field-switch__text",
	          innerHTML: $props.field.label
	        }, null, 8 /* PROPS */, ["innerHTML"]))
	      : createCommentVNode("v-if", true)
	  ], 2 /* CLASS */))
	}

	script$g.render = render$i;
	script$g.__file = "local/assets/source/components/v-field-switch.vue";

	var script$h = {
		props: {
			radio: {
				type: Boolean,
				default: false
			},

			field: {
				type: Object,
				required: true,
				default: null
			},

			modelValue: {
				type: [Object, String, Number, Boolean],
				default: null
			},

			view: {
				type: String,
				default: null
			}
		},

		emits: [
			'update:modelValue'
		],

		data() {
			return {
				localValue: null,
				open: false,
				uniqueId: uniqueId('field-'),
				localFilterValue: null,
			};
		},

		computed: {
			computedScrollAndAccordion() {
				return this.field.options?.length >= 2
			},

			computedFilteredList() {
				return this.field.options.filter((item) => {
					if (item.text.toLowerCase().includes(this.localFilterValue?.toLowerCase())) {
						return item
					}
				})
			},

			computedCountSelectedFilters() {
				return this.localValue instanceof Array && this.localValue.length ? `(${this.localValue.length})` : ''
			},
		},

		watch: {
			modelValue() {
				this.updateLocalValue();
			}
		},

		created() {
			this.updateLocalValue();
		},

		mounted() {
			View.initAllLocal(this.$el.parentElement);
		},

		updated() {
			View.initAllLocal(this.$el.parentElement);
		},

		methods: {
			updateLocalValue() {
				this.localValue = this.modelValue;
			},

			handleInput() {
				this.$emit('update:modelValue', this.localValue);
			},

			filterChanged(value) {
				this.localFilterValue = value.toLowerCase();
			},

			clearValue() {
				this.localValue = [];
				this.handleInput();
			},
		},
	};

	const _hoisted_1$b = {
	  key: 2,
	  class: "accordion__icon hidden-lg hidden-md"
	};
	const _hoisted_2$9 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-down" })
	], -1 /* HOISTED */);
	const _hoisted_3$7 = {
	  key: 0,
	  class: "field-check-list__filter"
	};
	const _hoisted_4$6 = { class: "field-check-list__list" };

	function render$j(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_field = resolveComponent("v-field");
	  const _component_v_field_checkbox = resolveComponent("v-field-checkbox");

	  return (openBlock(), createBlock("div", {
	    class: ["v-field-check-list field-check-list", {'field-check-list--scroll': $options.computedScrollAndAccordion, 'accordion accordion--native js-accordion--adaptive open-accordion': $options.computedScrollAndAccordion}],
	    "data-max-width": "1023"
	  }, [
	    ($props.field.label)
	      ? (openBlock(), createBlock("div", {
	          key: 0,
	          class: ["field-check-list__header", {'accordion__toggler js-accordion__toggler': $options.computedScrollAndAccordion}]
	        }, [
	          ($props.field.label)
	            ? (openBlock(), createBlock("label", {
	                key: 0,
	                class: "field-check-list__label",
	                id: $data.uniqueId
	              }, toDisplayString($props.field.label) + " " + toDisplayString($options.computedCountSelectedFilters), 9 /* TEXT, PROPS */, ["id"]))
	            : createCommentVNode("v-if", true),
	          ($data.localValue?.length)
	            ? (openBlock(), createBlock("button", {
	                key: 1,
	                class: "field-check-list__clear-btn",
	                type: "button",
	                onClick: _cache[1] || (_cache[1] = (...args) => ($options.clearValue && $options.clearValue(...args)))
	              }, "Очистить"))
	            : createCommentVNode("v-if", true),
	          ($options.computedScrollAndAccordion)
	            ? (openBlock(), createBlock("i", _hoisted_1$b, [
	                _hoisted_2$9
	              ]))
	            : createCommentVNode("v-if", true)
	        ], 2 /* CLASS */))
	      : createCommentVNode("v-if", true),
	    createVNode("div", {
	      class: ["field-check-list__body", {'accordion__content js-accordion__content': $options.computedScrollAndAccordion}]
	    }, [
	      ($props.field?.filter)
	        ? (openBlock(), createBlock("div", _hoisted_3$7, [
	            createVNode(_component_v_field, {
	              class: "field--input-round",
	              modelValue: $data.localFilterValue,
	              "onUpdate:modelValue": [
	                _cache[2] || (_cache[2] = $event => ($data.localFilterValue = $event)),
	                $options.filterChanged
	              ],
	              field: {...$props.field.filter}
	            }, null, 8 /* PROPS */, ["modelValue", "field", "onUpdate:modelValue"])
	          ]))
	        : createCommentVNode("v-if", true),
	      createVNode("div", _hoisted_4$6, [
	        (!$data.localFilterValue?.length)
	          ? (openBlock(true), createBlock(Fragment, { key: 0 }, renderList($props.field.options, (option, index) => {
	              return (openBlock(), createBlock("div", {
	                key: option.value + '-' + index,
	                class: "field-check-list__item flc"
	              }, [
	                createVNode(_component_v_field_checkbox, {
	                  "true-value": option.value,
	                  text: option.text,
	                  count: option.count,
	                  note: option.note,
	                  icon: option.icon,
	                  view: $props.field.view,
	                  edit: option.edit,
	                  disabled: option.disabled || $props.field.disabled,
	                  modelValue: $data.localValue,
	                  "onUpdate:modelValue": [
	                    _cache[3] || (_cache[3] = $event => ($data.localValue = $event)),
	                    $options.handleInput
	                  ],
	                  radio: $props.radio
	                }, null, 8 /* PROPS */, ["true-value", "text", "count", "note", "icon", "view", "edit", "disabled", "modelValue", "onUpdate:modelValue", "radio"])
	              ]))
	            }), 128 /* KEYED_FRAGMENT */))
	          : createCommentVNode("v-if", true),
	        ($options.computedFilteredList?.length)
	          ? (openBlock(true), createBlock(Fragment, { key: 1 }, renderList($options.computedFilteredList, (option, index) => {
	              return (openBlock(), createBlock("div", {
	                key: option.value + '-' + index,
	                class: "field-check-list__item flc"
	              }, [
	                createVNode(_component_v_field_checkbox, {
	                  "true-value": option.value,
	                  text: option.text,
	                  count: option.count,
	                  note: option.note,
	                  icon: option.icon,
	                  edit: option.edit,
	                  view: $props.field.view,
	                  disabled: option.disabled || $props.field.disabled,
	                  modelValue: $data.localValue,
	                  "onUpdate:modelValue": [
	                    _cache[4] || (_cache[4] = $event => ($data.localValue = $event)),
	                    $options.handleInput
	                  ],
	                  radio: $props.radio
	                }, null, 8 /* PROPS */, ["true-value", "text", "count", "note", "icon", "edit", "view", "disabled", "modelValue", "onUpdate:modelValue", "radio"])
	              ]))
	            }), 128 /* KEYED_FRAGMENT */))
	          : createCommentVNode("v-if", true)
	      ]),
	      ($props.field.note)
	        ? (openBlock(), createBlock("div", {
	            key: 1,
	            class: "field-check-list__note",
	            innerHTML: $props.field.note
	          }, null, 8 /* PROPS */, ["innerHTML"]))
	        : createCommentVNode("v-if", true)
	    ], 2 /* CLASS */)
	  ], 2 /* CLASS */))
	}

	script$h.render = render$j;
	script$h.__file = "local/assets/source/components/v-field-check-list.vue";

	var script$i = {
		props: {
			field: {
				type: Object,
				default: null
			},

			modelValue: {
				type: [Number, String],
				default: null
			}
		},

		emits: [
			'update:modelValue',
			'fieldfocus'
		],

		data() {
			return {
				localValue: '',
				uniqueId: uniqueId('field-'),
			};
		},

		computed: {
			validateNumber() {
				// это запрещает ввод "e" и "-" в инпут
				return 'return (function(element, event){if(event.keyCode == 69 || event.keyCode == 189 || event.keyCode == 109) {return false;}})(this, event)';
			}
		},

		watch: {
			modelValue() {
				this.updateLocalValue();
			}
		},

		created() {
			this.updateLocalValue();
		},

		methods: {
			btnSubHandler() {
				this.localValue = +this.localValue - this.field.multiplicity;
				this.handleInput();
			},

			btnAddHandler() {
				this.localValue = +this.localValue + this.field.multiplicity;
				this.handleInput();
			},

			emitFieldfocus() {
				this.$emit('fieldfocus');
			},

			validateInput() {
				if (typeof this.field.max == 'number' &&
					this.field.max !== Infinity &&
					isNaN(+(this.localValue.toString()))) {
					this.localValue = 1;
				}
				if (this.localValue > this.field.max) {
					this.localValue = this.field.max;
				}
				this.handleInput();
			},

			updateLocalValue() {
				if (this.modelValue === this.field.min) {
					if (this.field.min === 0) {
						this.localValue = '';
					} else {
						this.localValue = this.field.min;
					}
				} else {
					this.localValue = this.modelValue;
				}
			},

			handleInput() {
				this.localValue = parseFloat(this.localValue);

				if (!this.localValue) {
					this.localValue = 0;
				}

				if (this.field) {
					if (typeof this.field.max == 'number' && this.field.max !== Infinity) {
						this.localValue = Math.min(this.localValue, this.field.max);
					}
					if (typeof this.field.min == 'number' && this.field.max !== -Infinity) {
						this.localValue = Math.max(this.localValue, this.field.min);
					}
				}
				if (this.localValue === 0) {
					this.localValue = '';
				}
				this.$emit('update:modelValue', this.localValue);
			}
		},

	};

	const _hoisted_1$c = { class: "v-field-count field-count" };

	function render$k(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$c, [
	    createVNode("button", {
	      class: "field-count__btn field-count__btn--sub",
	      type: "button",
	      tabindex: "-1",
	      onClick: _cache[1] || (_cache[1] = (...args) => ($options.btnSubHandler && $options.btnSubHandler(...args))),
	      "aria-label": "уменьшить",
	      disabled: $data.localValue == $props.field.min
	    }, null, 8 /* PROPS */, ["disabled"]),
	    createVNode("label", {
	      class: "field-label",
	      "aria-label": $props.field.label,
	      for: $data.uniqueId
	    }, [
	      withDirectives(createVNode("input", {
	        class: ["field-count__input field-input", {'field-count__input--added-in-basket': $data.localValue}],
	        type: "number",
	        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ($data.localValue = $event)),
	        disabled: $props.field.disabled,
	        onBlur: _cache[3] || (_cache[3] = (...args) => ($options.handleInput && $options.handleInput(...args))),
	        id: $data.uniqueId,
	        onkeydown: $options.validateNumber,
	        onInput: _cache[4] || (_cache[4] = (...args) => ($options.validateInput && $options.validateInput(...args))),
	        onFocus: _cache[5] || (_cache[5] = (...args) => ($options.emitFieldfocus && $options.emitFieldfocus(...args)))
	      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, ["disabled", "id", "onkeydown"]), [
	        [vModelText, $data.localValue]
	      ])
	    ], 8 /* PROPS */, ["aria-label", "for"]),
	    createVNode("button", {
	      class: "field-count__btn field-count__btn--add",
	      type: "button",
	      tabindex: "-1",
	      onClick: _cache[6] || (_cache[6] = (...args) => ($options.btnAddHandler && $options.btnAddHandler(...args))),
	      "aria-label": "увеличить",
	      disabled: $data.localValue === $props.field.max
	    }, null, 8 /* PROPS */, ["disabled"])
	  ]))
	}

	script$i.render = render$k;
	script$i.__file = "local/assets/source/components/v-field-count.vue";

	var script$j = {
		props: {
			field: {
				type: Object,
				default: null,
				required: true
			},

			modelValue: {
				type: Object,
				default: null
			}
		},

		emits: [
			'update:modelValue'
		],

		data() {
			return {
				localValue: null,
				debounceTimeout: null
			};
		},

		watch: {
			modelValue() {
				this.updateLocalValue();
			}
		},

		created() {
			this.updateLocalValue();
		},

		methods: {
			updateLocalValue() {
				this.localValue = this.modelValue || {min: this.field.min || 0, max: this.field.max || 0};
			},

			handleInput() {
				clearTimeout(this.debounceTimeout);
				this.debounceTimeout = setTimeout(this.emitInput, 1000);
			},

			emitInput() {
				clearTimeout(this.debounceTimeout);

				if (this.field) {
					if (typeof this.field.max == 'number' && this.field.max !== Infinity) {
						this.localValue.max = Math.min(this.localValue.max, this.field.max);
					}
					if (typeof this.field.min == 'number' && this.field.max !== -Infinity) {
						this.localValue.min = Math.min(this.localValue.min, this.field.min);
					}

					if (this.localValue.min > this.localValue.max) {
						this.localValue.max = this.localValue.min;
					}
				}

				this.$emit('update:modelValue', this.localValue);
			}
		}
	};

	const _hoisted_1$d = { class: "field-range__cell" };
	const _hoisted_2$a = /*#__PURE__*/createVNode("div", { class: "field-range__prefix" }, "от", -1 /* HOISTED */);
	const _hoisted_3$8 = {
	  key: 0,
	  class: "field-range__postfix"
	};
	const _hoisted_4$7 = /*#__PURE__*/createVNode("div", { class: "field-range__spacer" }, "—", -1 /* HOISTED */);
	const _hoisted_5$4 = { class: "field-range__cell" };
	const _hoisted_6$4 = /*#__PURE__*/createVNode("div", { class: "field-range__prefix" }, "до", -1 /* HOISTED */);
	const _hoisted_7$4 = {
	  key: 0,
	  class: "field-range__postfix"
	};

	function render$l(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_field = resolveComponent("v-field");

	  return (openBlock(), createBlock("div", {
	    class: ["v-field-range field-range", {'field-range--sm': $props.field.size === 'sm'}]
	  }, [
	    createVNode("div", _hoisted_1$d, [
	      _hoisted_2$a,
	      createVNode(_component_v_field, {
	        class: "field-range__input",
	        field: {type: 'text', inputmode: 'decimal', disabled: $props.field.disabled, precision: $props.field.precision},
	        modelValue: $data.localValue.min,
	        "onUpdate:modelValue": [
	          _cache[1] || (_cache[1] = $event => ($data.localValue.min = $event)),
	          $options.handleInput
	        ],
	        onKeyup: withKeys($options.emitInput, ["native","enter"])
	      }, null, 8 /* PROPS */, ["field", "modelValue", "onUpdate:modelValue", "onKeyup"]),
	      ($props.field.postfixMin)
	        ? (openBlock(), createBlock("div", _hoisted_3$8, toDisplayString($props.field.postfixMin), 1 /* TEXT */))
	        : createCommentVNode("v-if", true)
	    ]),
	    _hoisted_4$7,
	    createVNode("div", _hoisted_5$4, [
	      _hoisted_6$4,
	      createVNode(_component_v_field, {
	        class: "field-range__input",
	        field: {type: 'text', inputmode: 'decimal', disabled: $props.field.disabled, precision: $props.field.precision},
	        modelValue: $data.localValue.max,
	        "onUpdate:modelValue": [
	          _cache[2] || (_cache[2] = $event => ($data.localValue.max = $event)),
	          $options.handleInput
	        ],
	        onKeyup: withKeys($options.emitInput, ["native","enter"])
	      }, null, 8 /* PROPS */, ["field", "modelValue", "onUpdate:modelValue", "onKeyup"])
	    ]),
	    ($props.field.postfixMax)
	      ? (openBlock(), createBlock("div", _hoisted_7$4, toDisplayString($props.field.postfixMax), 1 /* TEXT */))
	      : createCommentVNode("v-if", true)
	  ], 2 /* CLASS */))
	}

	script$j.render = render$l;
	script$j.__file = "local/assets/source/components/v-field-range.vue";

	var script$k = {
		props: {
			field: {
				type: Object,
				default: null,
				required: true,
			},

			modelValue: {
				type: Object,
				default: null
			}
		},

		emits: [
			'update:modelValue'
		],

		data() {
			return {
				localValue: null,
				rulerWidth: 0,
				drag: false,
				touch: controller.touch
			};
		},

		computed: {
			position() {
				return {
					min: (this.localValue.min - this.field.min) / (this.field.max - this.field.min) * 100 + '%',
					max: (this.localValue.max - this.field.min) / (this.field.max - this.field.min) * 100 + '%',
					maxReverse: 100 - (this.localValue.max - this.field.min) / (this.field.max - this.field.min) * 100 + '%',
				};
			},

			computedFilterChanged() {
				return this.localValue.max !== this.field.max || this.localValue.min !== this.field.min
			}
		},

		watch: {
			modelValue() {
				this.updateLocalValue();
			}
		},

		created() {
			this.updateLocalValue();
			this.updateRulerSize();
			window.addEventListener('resize', this.updateRulerSize);
			document.addEventListener('mouseup', this.mouseup);
			document.addEventListener('mousemove', this.mousemove);
			document.addEventListener('touchend', this.mouseup);
			document.addEventListener('touchmove', this.mousemove);
		},

		unmounted() {
			window.removeEventListener('resize', this.updateRulerSize);
			document.removeEventListener('mouseup', this.mouseup);
			document.removeEventListener('mousemove', this.mousemove);
			document.removeEventListener('touchend', this.mouseup);
			document.removeEventListener('touchmove', this.mousemove);
		},

		methods: {
			updateLocalValue() {
				this.localValue = this.modelValue || {min: this.field.min || 0, max: this.field.max || 0};
			},

			clearValue() {
				this.localValue = {min: this.field.min || 0, max: this.field.max || 0};
				this.$emit('update:modelValue', this.localValue);
			},

			updateRulerSize() {
				this.rulerWidth = this.$refs['ruler'] && this.$refs['ruler'].offsetWidth;
			},

			mousedown(handle) {
				this.drag = handle;
			},

			mouseup() {
				this.drag = false;
			},

			mousemove(e) {
				if (this.drag && !this.field.disabled) {
					let ruler = this.$refs['ruler'];
					let rect = ruler.getBoundingClientRect();
					let diff = ((e.pageX || e.touches[0].pageX) - rect.left) / rect.width;
					diff = Math.max(0, Math.min(1, diff));
					let val;
					let precision = this.field.precision || 1;
					let precisionString = precision.toString();
					let precisionPointLength = precisionString.split('.')[1];

					if (this.drag === 'min') {
						val = Math.min(this.localValue.max, (this.field.max - this.field.min) * diff + this.field.min);
						val = Math.round(val / precision) * precision;
						// fix JS round bugs
						if (precisionPointLength >= 0) {
							val = parseFloat(val.toFixed(precisionPointLength.length));
						}
						this.localValue.min = val;
					} else if (this.drag === 'max') {
						val = Math.max(this.localValue.min, (this.field.max - this.field.min) * diff + this.field.min);
						val = Math.round(val / precision) * precision;
						// fix JS round bugs
						if (precisionPointLength >= 0) {
							val = parseFloat(val.toFixed(precisionPointLength.length));
						}
						this.localValue.max = val;
					}

					this.$emit('update:modelValue', this.localValue);
				}
			},

			setPrecision(val) {
				let precision = this.field.precision || 1;
				let precisionString = precision.toString();
				let precisionPointLength = precisionString.split('.')[1];
				if (precisionPointLength >= 0) {
					return val.toFixed(precisionPointLength.length);
				} else {
					return val
				}
			},
		}
	};

	const _hoisted_1$e = {
	  key: 0,
	  class: "field-range-slider__header"
	};
	const _hoisted_2$b = {
	  key: 0,
	  class: "field-range-slider__title"
	};
	const _hoisted_3$9 = { class: "field-range-slider__labels" };
	const _hoisted_4$8 = { class: "field-range-slider__label field-range-slider__label--min" };
	const _hoisted_5$5 = { class: "field-range-slider__label field-range-slider__label--max" };
	const _hoisted_6$5 = { class: "field-range-slider__controls" };
	const _hoisted_7$5 = {
	  class: "field-range-slider__ruler",
	  ref: "ruler"
	};

	function render$m(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", {
	    class: ["v-field-range-slider field-range-slider", {'field-range-slider--disabled': $props.field.disabled}]
	  }, [
	    ($props.field.label || $props.field.clearBtn)
	      ? (openBlock(), createBlock("div", _hoisted_1$e, [
	          ($props.field.label)
	            ? (openBlock(), createBlock("div", _hoisted_2$b, toDisplayString($props.field.label), 1 /* TEXT */))
	            : createCommentVNode("v-if", true),
	          ($props.field.clearBtn && $options.computedFilterChanged)
	            ? (openBlock(), createBlock("button", {
	                key: 1,
	                class: "field-range-slider__clear-btn",
	                type: "button",
	                onClick: _cache[1] || (_cache[1] = (...args) => ($options.clearValue && $options.clearValue(...args)))
	              }, "Сбросить"))
	            : createCommentVNode("v-if", true)
	        ]))
	      : createCommentVNode("v-if", true),
	    createVNode("div", _hoisted_3$9, [
	      createVNode("div", _hoisted_4$8, toDisplayString($props.field.prefixMin) + " " + toDisplayString($options.setPrecision($data.localValue.min)) + " " + toDisplayString($props.field.postfixMin), 1 /* TEXT */),
	      createVNode("div", _hoisted_5$5, toDisplayString($props.field.prefixMax) + " " + toDisplayString($options.setPrecision($data.localValue.max)) + " " + toDisplayString($props.field.postfixMax), 1 /* TEXT */)
	    ]),
	    createVNode("div", _hoisted_6$5, [
	      createVNode("div", _hoisted_7$5, null, 512 /* NEED_PATCH */),
	      createVNode("div", {
	        class: "field-range-slider__active",
	        style: {'left': $options.position.min, 'right': $options.position.maxReverse}
	      }, null, 4 /* STYLE */),
	      createVNode("div", {
	        class: ["field-range-slider__handle", {'field-range-slider__handle--z-bump': parseInt($options.position.min) > 98}],
	        style: {'left': $options.position.min},
	        onMousedown: _cache[2] || (_cache[2] = $event => ($data.touch ? null : $options.mousedown('min'))),
	        onTouchstart: _cache[3] || (_cache[3] = $event => ($data.touch ? $options.mousedown('min') : null))
	      }, null, 38 /* CLASS, STYLE, HYDRATE_EVENTS */),
	      createVNode("div", {
	        class: "field-range-slider__handle",
	        style: {'left': $options.position.max},
	        onMousedown: _cache[4] || (_cache[4] = $event => ($data.touch ? null : $options.mousedown('max'))),
	        onTouchstart: _cache[5] || (_cache[5] = $event => ($data.touch ? $options.mousedown('max') : null))
	      }, null, 36 /* STYLE, HYDRATE_EVENTS */)
	    ])
	  ], 2 /* CLASS */))
	}

	script$k.render = render$m;
	script$k.__file = "local/assets/source/components/v-field-range-slider.vue";

	var script$l = {
		props: {
			note: {
				type: String,
				default: null
			},

			field: {
				type: Object,
				default: null
			}
		},

		emits: [
			'fileinput',
			'fileremove'
		],

		data() {
			return {
				localValue: null,
				localFiles: [],
				rerenderKey: 0,
				uniqueId: uniqueId('field-')
			};
		},

		watch: {
			value() {
				this.initLocalValueFromValue();
			}
		},

		created() {
			this.initLocalValueFromValue(true);
		},

		methods: {
			getKey() {
				return Date.now().toString() + Math.round(Math.random() * 100000);
			},

			fileInput(e) {
				let newKey = this.getKey();

				if (!this.field.multiple) {
					this.localFiles.forEach(this.remove);
				}

				// always 1 file per event! (no multiple <input>)
				if (e.target.files) {
					console.log('file input', e.target.files, e.target.files[0]);
					for (let i = 0; i < e.target.files.length; i++) {
						this.localFiles.push({
							name: e.target.files[i].name,
							size: e.target.files[i].size,
							key: newKey
						});
					}

					e.key = newKey;
					this.$emit('fileinput', e);
				}

				this.rerenderKey = this.getKey();
			},

			remove(file) {
				this.localFiles.splice(this.localFiles.indexOf(file), 1);
				this.$emit('fileremove', file);
			},

			initLocalValueFromValue(initial) {
				if (this.field.files && initial) {
					this.localFiles = [];

					this.field.files.forEach((file) => {
						let newKey = this.getKey();

						this.localFiles.push({
							name: file.name,
							size: file.size,
							key: newKey
						});

						this.$emit('fileinput', {
							key: newKey,
							target: {files: [file]}
						});
					});
				}
			}
		}
	};

	const _hoisted_1$f = { class: "field-file__main" };
	const _hoisted_2$c = { class: "field-file__cell-input" };
	const _hoisted_3$a = { class: "field-file__input-block" };
	const _hoisted_4$9 = /*#__PURE__*/createVNode("svg", { class: "svg-icon field-file__icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-clip" })
	], -1 /* HOISTED */);
	const _hoisted_5$6 = /*#__PURE__*/createVNode("span", null, "Прикрепить файл", -1 /* HOISTED */);
	const _hoisted_6$6 = {
	  key: 1,
	  class: "field-file__note"
	};
	const _hoisted_7$6 = { class: "field-file__item-start" };
	const _hoisted_8$4 = /*#__PURE__*/createVNode("div", { class: "field-file__item-sep" }, null, -1 /* HOISTED */);
	const _hoisted_9$4 = { class: "field-file__item-end" };

	function render$n(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", {
	    class: ["v-field-file field-file", {'disabled': $props.field.disabled}]
	  }, [
	    createVNode("div", _hoisted_1$f, [
	      createVNode("div", _hoisted_2$c, [
	        createVNode("div", _hoisted_3$a, [
	          ($props.field.label)
	            ? (openBlock(), createBlock("label", {
	                key: 0,
	                class: "field-label",
	                for: $data.uniqueId,
	                "aria-label": "Файл"
	              }, null, 8 /* PROPS */, ["for"]))
	            : createCommentVNode("v-if", true),
	          (openBlock(), createBlock("input", {
	            class: "field-file__input",
	            id: $data.uniqueId,
	            type: "file",
	            disabled: $props.field.disabled,
	            onChange: _cache[1] || (_cache[1] = (...args) => ($options.fileInput && $options.fileInput(...args))),
	            key: $data.rerenderKey,
	            ref: "input"
	          }, null, 40 /* PROPS, HYDRATE_EVENTS */, ["id", "disabled"])),
	          createVNode("button", {
	            class: "field-file__btn btn",
	            type: "button",
	            disabled: $props.field.disabled,
	            onClick: _cache[2] || (_cache[2] = $event => (_ctx.$refs['input'].click())),
	            onKeydown: _cache[3] || (_cache[3] = withKeys($event => (_ctx.$refs['input'].click()), ["enter"]))
	          }, [
	            _hoisted_4$9,
	            _hoisted_5$6
	          ], 40 /* PROPS, HYDRATE_EVENTS */, ["disabled"]),
	          ($props.field.note)
	            ? (openBlock(), createBlock("div", _hoisted_6$6, toDisplayString($props.field.note), 1 /* TEXT */))
	            : createCommentVNode("v-if", true)
	        ])
	      ])
	    ]),
	    createVNode(Transition, { name: "fade" }, {
	      default: withCtx(() => [
	        ($data.localFiles.length)
	          ? (openBlock(), createBlock(TransitionGroup, {
	              key: 0,
	              class: "field-file__list flc",
	              tag: "div",
	              name: "content-fade"
	            }, {
	              default: withCtx(() => [
	                (openBlock(true), createBlock(Fragment, null, renderList($data.localFiles, (file) => {
	                  return (openBlock(), createBlock("div", {
	                    class: "field-file__item",
	                    key: file.key
	                  }, [
	                    createVNode("div", _hoisted_7$6, toDisplayString(file.name), 1 /* TEXT */),
	                    _hoisted_8$4,
	                    createVNode("div", _hoisted_9$4, [
	                      createVNode("button", {
	                        class: "field-file__item-remove link",
	                        type: "button",
	                        disabled: $props.field.disabled,
	                        onClick: $event => ($options.remove(file))
	                      }, "Удалить", 8 /* PROPS */, ["disabled", "onClick"])
	                    ])
	                  ]))
	                }), 128 /* KEYED_FRAGMENT */))
	              ]),
	              _: 1 /* STABLE */
	            }))
	          : createCommentVNode("v-if", true)
	      ]),
	      _: 1 /* STABLE */
	    })
	  ], 2 /* CLASS */))
	}

	script$l.render = render$n;
	script$l.__file = "local/assets/source/components/v-field-file.vue";

	var script$m = {
		props: {
			field: {
				type: Object,
				default: null
			},

			modelValue: {
				type: [String, Number],
				default: null
			}
		}
	};

	const _hoisted_1$g = { class: "v-field-view-picker view-picker" };
	const _hoisted_2$d = { class: "view-picker__grid" };
	const _hoisted_3$b = { class: "svg-icon view-picker__icon" };

	function render$o(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$g, [
	    createVNode("div", _hoisted_2$d, [
	      (openBlock(true), createBlock(Fragment, null, renderList($props.field.options, (option, index) => {
	        return (openBlock(), createBlock("button", {
	          class: ["view-picker__item", {'view-picker__item--active': option.value === $props.modelValue}],
	          type: "button",
	          onClick: $event => (_ctx.$emit('update:modelValue', option.value)),
	          key: index
	        }, [
	          (openBlock(), createBlock("svg", _hoisted_3$b, [
	            createVNode("use", {
	              "xlink:href": '/local/assets/dist/icons/sprite.svg#svg-icon-view-' + option.value
	            }, null, 8 /* PROPS */, ["xlink:href"])
	          ]))
	        ], 10 /* CLASS, PROPS */, ["onClick"]))
	      }), 128 /* KEYED_FRAGMENT */))
	    ])
	  ]))
	}

	script$m.render = render$o;
	script$m.__file = "local/assets/source/components/v-field-view-picker.vue";

	var script$n = {
		props: {
			radio: {
				type: Boolean,
				default: false
			},

			field: {
				type: Object,
				required: true,
				default: null
			},

			modelValue: {
				type: [Object, String, Number, Boolean],
				default: null
			},
		},

		emits: [
			'update:modelValue'
		],

		data() {
			return {
				localValue: null,
				uniqueId: uniqueId('field-'),
			};
		},


		watch: {
			modelValue() {
				this.updateLocalValue();
			}
		},

		created() {
			this.updateLocalValue();
		},

		methods: {
			updateLocalValue() {
				this.localValue = this.modelValue;
			},

			handleInput() {
				this.$emit('update:modelValue', this.localValue);
			},
		},
	};

	const _hoisted_1$h = { class: "v-field-toggles field-toggles" };
	const _hoisted_2$e = { class: "field-toggles__list" };

	function render$p(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_field_checkbox = resolveComponent("v-field-checkbox");

	  return (openBlock(), createBlock("div", _hoisted_1$h, [
	    ($props.field.label)
	      ? (openBlock(), createBlock("label", {
	          key: 0,
	          class: "field-toggles__label",
	          id: $data.uniqueId
	        }, toDisplayString($props.field.label), 9 /* TEXT, PROPS */, ["id"]))
	      : createCommentVNode("v-if", true),
	    createVNode("div", _hoisted_2$e, [
	      (openBlock(true), createBlock(Fragment, null, renderList($props.field.options, (option, index) => {
	        return (openBlock(), createBlock("div", {
	          key: option.value + '-' + index,
	          class: "field-toggles__item"
	        }, [
	          createVNode(_component_v_field_checkbox, {
	            "true-value": option.value,
	            text: option.text,
	            disabled: option.disabled || $props.field.disabled,
	            modelValue: $data.localValue,
	            "onUpdate:modelValue": [
	              _cache[1] || (_cache[1] = $event => ($data.localValue = $event)),
	              $options.handleInput
	            ],
	            radio: $props.radio
	          }, null, 8 /* PROPS */, ["true-value", "text", "disabled", "modelValue", "onUpdate:modelValue", "radio"])
	        ]))
	      }), 128 /* KEYED_FRAGMENT */))
	    ])
	  ]))
	}

	script$n.render = render$p;
	script$n.__file = "local/assets/source/components/v-field-toggles.vue";

	var script$o = {
		props: {
			radio: {
				type: Boolean,
				default: false
			},

			field: {
				type: Object,
				required: true,
				default: null
			},

			modelValue: {
				type: [Object, String, Number, Boolean],
				default: null
			},
		},

		emits: [
			'update:modelValue'
		],

		data() {
			return {
				localValue: null,
				open: false,
				uniqueId: uniqueId('field-'),
			};
		},

		computed: {
			computedMaxVisible() {
				return this.field.maxVisible || 5;
			},

			computedSelectedItem() {
				
				if (this.field.hideValue){
					return '';
				}
				
				
				return this.field.options.filter((option) => option.value === this.localValue)[0]
			}
		},

		watch: {
			modelValue() {
				this.updateLocalValue();
			}
		},

		created() {
			this.updateLocalValue();
		},

		mounted() {
			View.initAllLocal(this.$el);

			this.field.options.forEach((option, index) => {
				if (option.value === this.field.value && index > this.field.maxVisible) {
					this.open = true;
				}
			});
		},

		updated() {
			View.initAllLocal(this.$el);
		},

		methods: {
			updateLocalValue() {
				this.localValue = this.modelValue;
			},

			handleInput() {
				this.$emit('update:modelValue', this.localValue);
			},
		},
	};

	const _hoisted_1$i = { class: "v-field-colors field-colors" };
	const _hoisted_2$f = {
	  key: 0,
	  class: "field-colors__header"
	};
	const _hoisted_3$c = {
	  key: 0,
	  class: "field-colors__selected"
	};
	const _hoisted_4$a = { class: "field-colors__body" };
	const _hoisted_5$7 = { class: "field-colors__list" };
	const _hoisted_6$7 = {
	  key: 0,
	  class: "field-colors__item"
	};
	const _hoisted_7$7 = {
	  key: 0,
	  class: "field-colors__item field-colors__item--toggle"
	};
	const _hoisted_8$5 = /*#__PURE__*/createVNode("span", null, "Еще", -1 /* HOISTED */);
	const _hoisted_9$5 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-down" })
	], -1 /* HOISTED */);

	function render$q(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_field_checkbox = resolveComponent("v-field-checkbox");

	  return (openBlock(), createBlock("div", _hoisted_1$i, [
	    ($props.field.label)
	      ? (openBlock(), createBlock("div", _hoisted_2$f, [
	          createVNode("label", {
	            class: "field-colors__label",
	            id: $data.uniqueId
	          }, [
	            createTextVNode(toDisplayString($props.field.label), 1 /* TEXT */),
	            ($options.computedSelectedItem)
	              ? (openBlock(), createBlock("span", _hoisted_3$c, toDisplayString($options.computedSelectedItem.text), 1 /* TEXT */))
	              : createCommentVNode("v-if", true)
	          ], 8 /* PROPS */, ["id"])
	        ]))
	      : createCommentVNode("v-if", true),
	    createVNode("div", _hoisted_4$a, [
	      createVNode("div", _hoisted_5$7, [
	        (openBlock(true), createBlock(Fragment, null, renderList($props.field.options, (option, index) => {
	          return (openBlock(), createBlock(Fragment, {
	            key: option.value + '-' + index
	          }, [
	            (index < $options.computedMaxVisible || $data.open)
	              ? (openBlock(), createBlock("div", _hoisted_6$7, [
	                  createVNode(_component_v_field_checkbox, {
	                    "true-value": option.value,
	                    text: option.text,
	                    count: option.count,
	                    unavailable: option.unavailable,
	                    img: option.img,
	                    color: option.color,
	                    disabled: option.disabled || $props.field.disabled,
	                    modelValue: $data.localValue,
	                    "onUpdate:modelValue": [
	                      _cache[1] || (_cache[1] = $event => ($data.localValue = $event)),
	                      $options.handleInput
	                    ],
	                    radio: $props.radio
	                  }, null, 8 /* PROPS */, ["true-value", "text", "count", "unavailable", "img", "color", "disabled", "modelValue", "onUpdate:modelValue", "radio"])
	                ]))
	              : createCommentVNode("v-if", true)
	          ], 64 /* STABLE_FRAGMENT */))
	        }), 128 /* KEYED_FRAGMENT */)),
	        ($props.field.options.length > $options.computedMaxVisible)
	          ? (openBlock(), createBlock("div", _hoisted_7$7, [
	              (!$data.open)
	                ? (openBlock(), createBlock("button", {
	                    key: 0,
	                    class: "field-colors__toggle",
	                    type: "button",
	                    onClick: _cache[2] || (_cache[2] = $event => ($data.open = !$data.open))
	                  }, [
	                    _hoisted_8$5,
	                    _hoisted_9$5
	                  ]))
	                : createCommentVNode("v-if", true)
	            ]))
	          : createCommentVNode("v-if", true)
	      ])
	    ])
	  ]))
	}

	script$o.render = render$q;
	script$o.__file = "local/assets/source/components/v-field-colors.vue";

	var script$p = {
		props: {
			radio: {
				type: Boolean,
				default: false
			},

			field: {
				type: Object,
				required: true,
				default: null
			},

			modelValue: {
				type: [Object, String, Number, Boolean],
				default: null
			},

			fieldsErrors: {
				type: Array,
				default: null
			}
		},

		emits: [
			'update:modelValue',
			'update:childValue'
		],

		data() {
			return {
				localValue: null,
				uniqueId: uniqueId('field-'),
			};
		},

		computed: {
			computedCurrentChildren() {
				if (this.field.children?.length) {
					let result = this.field.children.filter((child) => parseInt(child.parentValue) === parseInt(this.localValue))[0];
					if (result) {
						result.parentValue = parseInt(result.parentValue);
					}
					return result;
				} else {
					return null
				}
			}
		},


		watch: {
			modelValue() {
				this.updateLocalValue();
			}
		},

		created() {
			this.updateLocalValue();
		},

		methods: {
			updateLocalValue() {
				this.localValue = this.modelValue;
			},

			handleInput() {
				this.$emit('update:modelValue', this.localValue);
			},

			handleInputChild(value) {
				this.$emit('update:childValue', this.computedCurrentChildren);
			},

			getFieldError(field) {
				if (this.fieldsErrors) {
					let filteredErrors = this.fieldsErrors.filter((item) => {
						console.log('nnnnnnn', item.name);
						console.log('iiiiiiiiii', field.id);
						return item.name == field.id
					});
					return filteredErrors.length ? filteredErrors : null;
				} else {
					return null;
				}
			},
		},
	};

	const _hoisted_1$j = { class: "v-field-radio-buttons field-radio-buttons" };
	const _hoisted_2$g = { class: "field-radio-buttons__list" };
	const _hoisted_3$d = {
	  key: 0,
	  class: "field-radio-buttons__child"
	};

	function render$r(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_field_checkbox = resolveComponent("v-field-checkbox");
	  const _component_v_field = resolveComponent("v-field");

	  return (openBlock(), createBlock("div", _hoisted_1$j, [
	    ($props.field.label)
	      ? (openBlock(), createBlock("label", {
	          key: 0,
	          class: "field-radio-buttons__label",
	          id: $data.uniqueId
	        }, toDisplayString($props.field.label), 9 /* TEXT, PROPS */, ["id"]))
	      : createCommentVNode("v-if", true),
	    createVNode("div", _hoisted_2$g, [
	      (openBlock(true), createBlock(Fragment, null, renderList($props.field.options, (option, index) => {
	        return (openBlock(), createBlock("div", {
	          key: option.value + '-' + index,
	          class: ["field-radio-buttons__item", {'field-radio-buttons__item--active': $data.localValue === option.value}]
	        }, [
	          createVNode(_component_v_field_checkbox, {
	            "true-value": option.value,
	            text: option.text,
	            note: option.note,
	            edit: option.editLink,
	            price: option.price,
	            icon: option.icon,
	            view: $props.field.view,
	            img: option.img,
	            disabled: option.disabled || $props.field.disabled,
	            modelValue: $data.localValue,
	            "onUpdate:modelValue": [
	              _cache[1] || (_cache[1] = $event => ($data.localValue = $event)),
	              $options.handleInput
	            ],
	            radio: $props.radio
	          }, null, 8 /* PROPS */, ["true-value", "text", "note", "edit", "price", "icon", "view", "img", "disabled", "modelValue", "onUpdate:modelValue", "radio"]),
	          ($options.computedCurrentChildren?.parentValue  === parseInt(option.value))
	            ? (openBlock(), createBlock("div", _hoisted_3$d, [
	                createVNode(_component_v_field, {
	                  field: {...$options.computedCurrentChildren, errors: $options.getFieldError($options.computedCurrentChildren)},
	                  modelValue: $options.computedCurrentChildren.value,
	                  "onUpdate:modelValue": [
	                    _cache[2] || (_cache[2] = $event => ($options.computedCurrentChildren.value = $event)),
	                    $options.handleInputChild
	                  ]
	                }, null, 8 /* PROPS */, ["field", "modelValue", "onUpdate:modelValue"]),
	                ($options.computedCurrentChildren.view === 'address' && $options.computedCurrentChildren.addLink)
	                  ? (openBlock(), createBlock("button", {
	                      key: 0,
	                      class: "btn btn--primary-gray btn--full js-open-modal",
	                      type: "button",
	                      "aria-label": "Добавить адрес",
	                      title: "Добавить адрес",
	                      "data-modal-data": "{\"className\": \"modal--md\"}",
	                      "data-modal-url": $options.computedCurrentChildren.addLink
	                    }, "Добавить адрес", 8 /* PROPS */, ["data-modal-url"]))
	                  : createCommentVNode("v-if", true)
	              ]))
	            : createCommentVNode("v-if", true)
	        ], 2 /* CLASS */))
	      }), 128 /* KEYED_FRAGMENT */))
	    ])
	  ]))
	}

	script$p.render = render$r;
	script$p.__file = "local/assets/source/components/v-field-radio-buttons.vue";

	var script$q = {
		props: {
			field: {
				type: Object,
				default: null,
				required: true,
			},

			modelValue: {
				type: Object,
				default: null
			}
		},

		emits: [
			'update:modelValue'
		],

		data() {
			return {
				localValue: null,
				rulerWidth: 0,
				drag: false,
				touch: controller.touch,
				timeout: null,
			};
		},

		computed: {
			computedField() {
				return {
					label: this.field.label,
					value: this.localValue.max,
					type: 'number',
					inputmode: 'numeric',
					max: this.field.max,
					min: this.field.min,
					icon: 'diamond',
					img: '/local/assets/images/markup-images/diamond.svg'
				}
			},

			position() {
				return {
					max: (this.localValue.max - this.field.min) / (this.field.max - this.field.min) * 100 + '%',
					maxReverse: 100 - (this.localValue.max - this.field.min) / (this.field.max - this.field.min) * 100 + '%',
				};
			},
		},

		watch: {
			modelValue() {
				this.updateLocalValue();
			}
		},

		created() {
			this.updateLocalValue();
			this.updateRulerSize();
			window.addEventListener('resize', this.updateRulerSize);
			document.addEventListener('mouseup', this.mouseup);
			document.addEventListener('mousemove', this.mousemove);
			document.addEventListener('touchend', this.mouseup);
			document.addEventListener('touchmove', this.mousemove);
		},

		unmounted() {
			window.removeEventListener('resize', this.updateRulerSize);
			document.removeEventListener('mouseup', this.mouseup);
			document.removeEventListener('mousemove', this.mousemove);
			document.removeEventListener('touchend', this.mouseup);
			document.removeEventListener('touchmove', this.mousemove);
		},

		methods: {
			updateLocalValue() {
				this.localValue = this.modelValue || {min: this.field.min || 0, max: this.field.max || 0};
			},

			updateRulerSize() {
				this.rulerWidth = this.$refs['ruler'] && this.$refs['ruler'].offsetWidth;
			},

			mousedown(handle) {
				this.drag = handle;
			},

			mouseup() {
				this.drag = false;
			},

			mousemove(e) {
				if (this.drag && !this.field.disabled) {
					let ruler = this.$refs['ruler'];
					let rect = ruler.getBoundingClientRect();
					let diff = ((e.pageX || e.touches[0].pageX) - rect.left) / rect.width;
					diff = Math.max(0, Math.min(1, diff));
					let val;
					let precision = this.field.precision || 1;
					let precisionString = precision.toString();
					let precisionPointIndex = precisionString.indexOf('.');

					if (this.drag === 'max') {
						val = (this.field.max - this.field.min) * diff + this.field.min;
						val = Math.round(val / precision) * precision;
						// fix JS round bugs
						if (precisionPointIndex >= 0) {
							val = parseFloat(val.toFixed(precisionString.slice(precisionPointIndex).length));
						}
						this.localValue.max = val;
					}

					clearTimeout(this.timeout);
					this.timeout = setTimeout(() => {
						this.$emit('update:modelValue', this.localValue);
					}, 1000);
				}
			},

			handleInput(value) {
				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					this.localValue.max = value;
					this.$emit('update:modelValue', this.localValue);
				}, 1000);
			},
		}
	};

	const _hoisted_1$k = { class: "field-range-slider__field" };
	const _hoisted_2$h = { class: "field-range-slider__controls" };
	const _hoisted_3$e = {
	  class: "field-range-slider__ruler",
	  ref: "ruler"
	};

	function render$s(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_field_text = resolveComponent("v-field-text");

	  return (openBlock(), createBlock("div", {
	    class: ["v-field-range-slider field-range-slider--with-field", {'field-range-slider--disabled': $props.field.disabled}]
	  }, [
	    createVNode("div", _hoisted_1$k, [
	      createVNode(_component_v_field_text, {
	        field: $options.computedField,
	        "model-value": $data.localValue.max,
	        "onUpdate:modelValue": $options.handleInput
	      }, null, 8 /* PROPS */, ["field", "model-value", "onUpdate:modelValue"])
	    ]),
	    createVNode("div", _hoisted_2$h, [
	      createVNode("div", _hoisted_3$e, null, 512 /* NEED_PATCH */),
	      createVNode("div", {
	        class: "field-range-slider__active",
	        style: {'left': $options.position.min, 'right': $options.position.maxReverse}
	      }, null, 4 /* STYLE */),
	      createVNode("div", {
	        class: "field-range-slider__handle",
	        style: {'left': $options.position.max},
	        onMousedown: _cache[1] || (_cache[1] = $event => ($data.touch ? null : $options.mousedown('max'))),
	        onTouchstart: _cache[2] || (_cache[2] = $event => ($data.touch ? $options.mousedown('max') : null))
	      }, null, 36 /* STYLE, HYDRATE_EVENTS */)
	    ])
	  ], 2 /* CLASS */))
	}

	script$q.render = render$s;
	script$q.__file = "local/assets/source/components/v-field-number-range.vue";

	var script$r = {
		props: {
			field: {
				type: Object,
				default: null,
				required: true
			},

			modelValue: {
				type: [String, Number],
				default: null
			}
		},

		emits: [
			'input',
			'update:modelValue'
		],

		data() {
			return {
				localText: null,
				localValue: null,
				savedValue: null,
				options: [],
				open: false,
				timeoutRequest: null,
				uniqueId: uniqueId('field-text_'),
			};
		},

		computed: {
			computedType() {
				if (!this.field.type || this.field.type == 'number') {
					return 'text';
				}
				return this.field.type;
			},

			isFieldNumeric() {
				return !!(this.field.type === 'number' || this.field.inputmode === 'numeric' || this.field.inputmode === 'decimal');
			}
		},

		watch: {
			modelValue(newVal) {
				if (!newVal || newVal && !newVal.length) {
					this.localText = '';
				}
			},
		},

		created() {
			document.addEventListener('click', this.handleClickOutside);
			document.addEventListener('keydown', this.handleEsc);
		},

		unmounted() {
			document.removeEventListener('click', this.handleClickOutside);
			document.removeEventListener('keydown', this.handleEsc);
		},

		methods: {
			handleInput() {
				if (this.localValue) {
					this.localValue = '';
					this.options = [];
				}
			},

			sendRequest() {
				if (this.localText.length >= this.field.minStringForRequest) {
					clearTimeout(this.timeoutRequest);
					this.timeoutRequest = setTimeout(() => {
						const formData = new FormData();
						formData.set('field', this.field.name);
						formData.set('value', this.localText);

						let requestPromise = fetch(this.field.tooltip, {
							method: 'POST',
							body: formData
						});

						requestPromise.then((response) => {
							if (!response.ok) {
								console.warn(`${this.$options.name}: AJAX request failed`, response);
							} else {
								response.json().then((data) => {
									console.log(`${this.$options.name}: AJAX request completed`, data);
									this.options = data.options;

									// сортировка по алфавиту
									// if (this.options instanceof Array) {
									// 	this.options = this.options.sort((a, b) => {
									// 		if (a.text < b.text) {
									// 			return -1
									// 		} else if (a.text > b.text) {
									// 			return 1
									// 		} else {
									// 			return 0
									// 		}
									// 	})
									// }

									this.open = true;
								});
							}
						});
					}, 800);
				}
			},

			emitInput() {
				this.$emit('input', this.localValue);
			},

			handleClickOutside(e) {
				if (!this.$el.contains(e.target)) {
					this.open = false;
				}
			},

			handleEsc(e) {
				if (e.keyCode == 27) {
					this.open = false;
				}
			},

			selectOption(text, value) {
				this.localText = text;
				this.localValue = value;
				this.$emit('update:modelValue', this.localValue);
			}
		},
	};

	const _hoisted_1$l = {
	  key: 0,
	  class: "field-text__star"
	};
	const _hoisted_2$i = {
	  key: 0,
	  class: "field-tooltip__list-container"
	};

	function render$t(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", {
	    class: ["v-field-tooltip field-tooltip field-text", {'field-tooltip--open': $data.open, 'field-text--label': $props.field.label}]
	  }, [
	    withDirectives(createVNode("input", {
	      class: ["field-input field-tooltip__input", {'field-input--sm': $props.field.size === 'sm'}],
	      ref: "input",
	      type: $options.computedType,
	      inputmode: $props.field.inputmode,
	      disabled: $props.field.disabled,
	      placeholder: $props.field.placeholder,
	      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ($data.localText = $event)),
	      maxlength: $props.field.maxlength,
	      onInput: _cache[2] || (_cache[2] = $event => {$options.handleInput(); $options.sendRequest();}),
	      id: $data.uniqueId
	    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, ["type", "inputmode", "disabled", "placeholder", "maxlength", "id"]), [
	      [vModelDynamic, $data.localText]
	    ]),
	    ($props.field.label)
	      ? (openBlock(), createBlock("label", {
	          key: 0,
	          class: "field-text__int-label",
	          for: $data.uniqueId
	        }, [
	          createTextVNode(toDisplayString($props.field.label), 1 /* TEXT */),
	          ($props.field.required)
	            ? (openBlock(), createBlock("span", _hoisted_1$l, " *"))
	            : createCommentVNode("v-if", true)
	        ], 8 /* PROPS */, ["for"]))
	      : createCommentVNode("v-if", true),
	    createVNode(Transition, { name: "dropdown" }, {
	      default: withCtx(() => [
	        ($props.field && $data.open && $data.options.length)
	          ? (openBlock(), createBlock("div", {
	              key: 0,
	              class: "field-tooltip__list",
	              onClick: _cache[3] || (_cache[3] = $event => {$data.open = false;})
	            }, [
	              createVNode(Transition, { name: "dropdown-inner" }, {
	                default: withCtx(() => [
	                  ($data.open)
	                    ? (openBlock(), createBlock("div", _hoisted_2$i, [
	                        (openBlock(true), createBlock(Fragment, null, renderList($data.options, (option) => {
	                          return (openBlock(), createBlock("button", {
	                            class: ["field-tooltip__list-item", {'field-tooltip__list-item--active': option.value === $data.localValue}],
	                            type: "button",
	                            onClick: $event => ($options.selectOption(option.text, option.value)),
	                            innerHTML: option.text
	                          }, null, 10 /* CLASS, PROPS */, ["onClick", "innerHTML"]))
	                        }), 256 /* UNKEYED_FRAGMENT */))
	                      ]))
	                    : createCommentVNode("v-if", true)
	                ]),
	                _: 1 /* STABLE */
	              })
	            ]))
	          : createCommentVNode("v-if", true)
	      ]),
	      _: 1 /* STABLE */
	    })
	  ], 2 /* CLASS */))
	}

	script$r.render = render$t;
	script$r.__file = "local/assets/source/components/v-field-tooltip.vue";

	var script$s = {
		props: {
			field: {
				type: Object,
				default: null,
				required: true
			},

			modelValue: {
				type: [String, Number],
				default: null
			}
		},

		emits: [
			'update:modelValue',
		],

		data() {
			return {
				localValue: null,
			};
		},

		computed: {
			computedCountText() {
				if (this.field.count % 10 === 1 && this.field.count !== 11) {
					return 'отзыв'
				} else if (this.field.count % 10 > 1 && this.field.count % 10 < 5) {
					return 'отзыва'
				} else {
					return 'отзывов'
				}
			}
		},

		watch: {
			modelValue: {
				immediate: true,
				handler() {
					this.localValue = this.modelValue;
				}
			},
		},

		methods: {
			handleInput() {
				this.$emit('update:modelValue', this.localValue);
			}
		}
	};

	const _hoisted_1$m = { class: "v-field-rating rating-action rating-action--large" };
	const _hoisted_2$j = {
	  key: 0,
	  class: "rating-action__label"
	};
	const _hoisted_3$f = {
	  key: 1,
	  class: "rating-action__rating"
	};
	const _hoisted_4$b = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_5$8 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_6$8 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_7$8 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_8$6 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_9$6 = {
	  key: 2,
	  class: "rating-action__rating rating-action__rating--hover"
	};
	const _hoisted_10$3 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_11$3 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_12$3 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_13$2 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_14$2 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_15$2 = {
	  key: 3,
	  class: "rating-action__count"
	};

	function render$u(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$m, [
	    ($props.field.label)
	      ? (openBlock(), createBlock("div", _hoisted_2$j, toDisplayString($props.field.label), 1 /* TEXT */))
	      : createCommentVNode("v-if", true),
	    ($props.field.disabled)
	      ? (openBlock(), createBlock("div", _hoisted_3$f, [
	          createVNode("div", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue >= 1}]
	          }, [
	            _hoisted_4$b
	          ], 2 /* CLASS */),
	          createVNode("div", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue >= 2}]
	          }, [
	            _hoisted_5$8
	          ], 2 /* CLASS */),
	          createVNode("div", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue >= 3}]
	          }, [
	            _hoisted_6$8
	          ], 2 /* CLASS */),
	          createVNode("div", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue >= 4}]
	          }, [
	            _hoisted_7$8
	          ], 2 /* CLASS */),
	          createVNode("div", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue >= 5}]
	          }, [
	            _hoisted_8$6
	          ], 2 /* CLASS */)
	        ]))
	      : (openBlock(), createBlock("div", _hoisted_9$6, [
	          createVNode("button", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue >= 1}],
	            type: "button",
	            onClick: _cache[1] || (_cache[1] = $event => {$data.localValue = 1; $options.handleInput();})
	          }, [
	            _hoisted_10$3
	          ], 2 /* CLASS */),
	          createVNode("button", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue >= 2}],
	            type: "button",
	            onClick: _cache[2] || (_cache[2] = $event => {$data.localValue = 2; $options.handleInput();})
	          }, [
	            _hoisted_11$3
	          ], 2 /* CLASS */),
	          createVNode("button", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue >= 3}],
	            type: "button",
	            onClick: _cache[3] || (_cache[3] = $event => {$data.localValue = 3; $options.handleInput();})
	          }, [
	            _hoisted_12$3
	          ], 2 /* CLASS */),
	          createVNode("button", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue >= 4}],
	            type: "button",
	            onClick: _cache[4] || (_cache[4] = $event => {$data.localValue = 4; $options.handleInput();})
	          }, [
	            _hoisted_13$2
	          ], 2 /* CLASS */),
	          createVNode("button", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue >= 5}],
	            type: "button",
	            onClick: _cache[5] || (_cache[5] = $event => {$data.localValue = 5; $options.handleInput();})
	          }, [
	            _hoisted_14$2
	          ], 2 /* CLASS */)
	        ])),
	    ($props.field.count && $props.field.disabled)
	      ? (openBlock(), createBlock("div", _hoisted_15$2, toDisplayString($props.field.count) + " " + toDisplayString($options.computedCountText), 1 /* TEXT */))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$s.render = render$u;
	script$s.__file = "local/assets/source/components/v-field-rating.vue";

	var script$t = {
		props: {
			field: {
				type: Object,
				required: true,
				default: null
			},

			modelValue: {
				type: [Object, String, Number, Boolean],
				default: null
			},
		},

		emits: [
			'update:modelValue'
		],

		data() {
			return {
				localValue: null,
			};
		},

		watch: {
			modelValue() {
				this.updateLocalValue();
			}
		},

		created() {
			this.updateLocalValue();
		},

		methods: {
			updateLocalValue() {
				this.localValue = this.modelValue;
			},

			handleInput() {
				this.$emit('update:modelValue', this.localValue);
			},
		},
	};

	const _hoisted_1$n = { class: "v-field-tumbler field-tumbler" };

	function render$v(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_field_checkbox = resolveComponent("v-field-checkbox");

	  return (openBlock(), createBlock("div", _hoisted_1$n, [
	    (openBlock(true), createBlock(Fragment, null, renderList($props.field.options, (option, index) => {
	      return (openBlock(), createBlock("div", {
	        class: "field-tumbler__item",
	        key: option.value + '-' + index
	      }, [
	        createVNode(_component_v_field_checkbox, {
	          "true-value": option.value,
	          text: option.text,
	          modelValue: $data.localValue,
	          "onUpdate:modelValue": [
	            _cache[1] || (_cache[1] = $event => ($data.localValue = $event)),
	            $options.handleInput
	          ],
	          radio: true
	        }, null, 8 /* PROPS */, ["true-value", "text", "modelValue", "onUpdate:modelValue"])
	      ]))
	    }), 128 /* KEYED_FRAGMENT */))
	  ]))
	}

	script$t.render = render$v;
	script$t.__file = "local/assets/source/components/v-field-tumbler.vue";

	var script$u = {
		props: {
			promocode: {
				type: Object,
				default: null
			},
		},

		emits: [
			'add-promocode',
			'remove-promocode',
			'change-promocode',
		],

		data() {
			return {
				showForm: false,
				localValue: null,
			}
		},

		created() {
			this.checkErrors();
		},

		updated() {
			this.checkErrors();
		},

		methods: {
			setShowForm() {
				this.showForm = true;
			},
			checkErrors() {
				if (this.promocode.field?.errors?.length || this.promocode.field.value.length) {
					this.showForm = true;
				}
			},
			changePromocode(value) {
				this.localValue = value;
				this.$emit('change-promocode');
			},
			removePromocode() {
				this.$emit('remove-promocode');
			},
			submit() {
				if (this.localValue?.length) {
					this.showForm = false;
					this.$emit('add-promocode', this.localValue);
				} else {
					this.removePromocode();
				}
			}
		},
	};

	const _hoisted_1$o = { class: "v-promocode promocode" };
	const _hoisted_2$k = {
	  key: 0,
	  class: "promocode__wrapper"
	};
	const _hoisted_3$g = {
	  key: 2,
	  class: "promocode__submit",
	  "aria-label": "Подтвердить промокод",
	  title: "Подтвердить промокод"
	};
	const _hoisted_4$c = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-down" })
	], -1 /* HOISTED */);
	const _hoisted_5$9 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-promocode" })
	], -1 /* HOISTED */);
	const _hoisted_6$9 = /*#__PURE__*/createVNode("span", null, "Добавить промокод", -1 /* HOISTED */);

	function render$w(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_field = resolveComponent("v-field");

	  return (openBlock(), createBlock("div", _hoisted_1$o, [
	    ($props.promocode)
	      ? (openBlock(), createBlock("div", _hoisted_2$k, [
	          ($data.showForm)
	            ? (openBlock(), createBlock("form", {
	                key: 0,
	                class: "promocode__form",
	                onSubmit: _cache[3] || (_cache[3] = withModifiers((...args) => ($options.submit && $options.submit(...args)), ["prevent"]))
	              }, [
	                ($props.promocode.field)
	                  ? (openBlock(), createBlock(_component_v_field, {
	                      key: 0,
	                      modelValue: $props.promocode.field.value,
	                      "onUpdate:modelValue": [
	                        _cache[1] || (_cache[1] = $event => ($props.promocode.field.value = $event)),
	                        $options.changePromocode
	                      ],
	                      field: $props.promocode.field
	                    }, null, 8 /* PROPS */, ["modelValue", "field", "onUpdate:modelValue"]))
	                  : createCommentVNode("v-if", true),
	                ($props.promocode.field.success)
	                  ? (openBlock(), createBlock("button", {
	                      key: 1,
	                      class: "promocode__remove",
	                      type: "button",
	                      onClick: _cache[2] || (_cache[2] = (...args) => ($options.removePromocode && $options.removePromocode(...args))),
	                      "aria-label": "Удалить промокод",
	                      title: "Удалить промокод"
	                    }))
	                  : (openBlock(), createBlock("button", _hoisted_3$g, [
	                      _hoisted_4$c
	                    ]))
	              ], 32 /* HYDRATE_EVENTS */))
	            : (openBlock(), createBlock("button", {
	                key: 1,
	                class: "promocode__button btn btn--gray btn--full",
	                type: "button",
	                onClick: _cache[4] || (_cache[4] = (...args) => ($options.setShowForm && $options.setShowForm(...args))),
	                "aria-label": "Показать форму промокода",
	                title: "Показать форму промокода"
	              }, [
	                _hoisted_5$9,
	                _hoisted_6$9
	              ]))
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$u.render = render$w;
	script$u.__file = "local/assets/source/components/v-promocode.vue";

	var script$v = {
		props: {
			productId: {
				type: String,
				default: null
			},
		},

		methods: {
			closeModal() {
				controller.closeModal();
			},

			deleteBasketItem() {
				controller.closeModal();
				controller.deleteBasketItem(this.productId);
			}
		},
	};

	const _hoisted_1$p = { class: "v-delete-basket-item delete-basket-item" };
	const _hoisted_2$l = /*#__PURE__*/createVNode("div", { class: "delete-basket-item__text" }, "Хотите удалить товар из корзины навсегда?", -1 /* HOISTED */);
	const _hoisted_3$h = { class: "delete-basket-item__action" };

	function render$x(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$p, [
	    _hoisted_2$l,
	    createVNode("div", _hoisted_3$h, [
	      createVNode("button", {
	        class: "btn btn--primary-gray",
	        type: "button",
	        onClick: _cache[1] || (_cache[1] = (...args) => ($options.closeModal && $options.closeModal(...args))),
	        "aria-label": "Закрыть окно",
	        title: "Закрыть окно"
	      }, "Оставить"),
	      createVNode("button", {
	        class: "btn btn--primary",
	        type: "button",
	        onClick: _cache[2] || (_cache[2] = (...args) => ($options.deleteBasketItem && $options.deleteBasketItem(...args))),
	        "aria-label": "Удалить товар",
	        title: "Удалить товар"
	      }, "Удалить")
	    ])
	  ]))
	}

	script$v.render = render$x;
	script$v.__file = "local/assets/source/components/v-delete-basket-item.vue";

	var script$w = {
		methods: {
			closeModal() {
				controller.closeModal();
			},

			cleanBasket() {
				controller.closeModal();
				controller.cleanBasket();
			}
		},
	};

	const _hoisted_1$q = { class: "v-clean-basket clean-basket" };
	const _hoisted_2$m = /*#__PURE__*/createVNode("div", { class: "clean-basket__text" }, "Хотите удалить все товары из корзины навсегда?", -1 /* HOISTED */);
	const _hoisted_3$i = { class: "clean-basket__action" };

	function render$y(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$q, [
	    _hoisted_2$m,
	    createVNode("div", _hoisted_3$i, [
	      createVNode("button", {
	        class: "btn btn--primary-gray",
	        type: "button",
	        onClick: _cache[1] || (_cache[1] = (...args) => ($options.closeModal && $options.closeModal(...args))),
	        "aria-label": "Закрыть окно",
	        title: "Закрыть окно"
	      }, "Оставить"),
	      createVNode("button", {
	        class: "btn btn--primary",
	        type: "button",
	        onClick: _cache[2] || (_cache[2] = (...args) => ($options.cleanBasket && $options.cleanBasket(...args))),
	        "aria-label": "Удалить все товары",
	        title: "Удалить все товары"
	      }, "Удалить все")
	    ])
	  ]))
	}

	script$w.render = render$y;
	script$w.__file = "local/assets/source/components/v-clean-basket.vue";

	var script$x = {
		mixins: [
			script$2
		],

		data() {
			return {
				content: null
			}
		},

		methods: {
			dataSet(data) {
				this.content = data;
			},

			getLogin() {
				controller.closeModal();
				controller.openModalFromUrl(this.content.loginBtn.link);
			}
		},
	};

	const _hoisted_1$r = { class: "v-copy-bonuses copy-bonuses" };
	const _hoisted_2$n = {
	  key: 0,
	  class: "copy-bonuses__text"
	};
	const _hoisted_3$j = { class: "copy-bonuses__action" };
	const _hoisted_4$d = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-instagram" })
	], -1 /* HOISTED */);
	const _hoisted_5$a = {
	  key: 1,
	  class: "copy-bonuses__footer"
	};
	const _hoisted_6$a = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-long" })
	], -1 /* HOISTED */);

	function render$z(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$r, [
	    ($data.content.text)
	      ? (openBlock(), createBlock("div", _hoisted_2$n, toDisplayString($data.content.text), 1 /* TEXT */))
	      : createCommentVNode("v-if", true),
	    createVNode("div", _hoisted_3$j, [
	      ($data.content.instagramLink)
	        ? (openBlock(), createBlock("a", {
	            key: 0,
	            class: "copy-bonuses__instagram",
	            href: $data.content.instagramLink.link,
	            "aria-label": $data.content.instagramLink.text,
	            title: $data.content.instagramLink.text
	          }, [
	            _hoisted_4$d
	          ], 8 /* PROPS */, ["href", "aria-label", "title"]))
	        : createCommentVNode("v-if", true),
	      ($data.content.loginBtn)
	        ? (openBlock(), createBlock("button", {
	            key: 1,
	            class: "copy-bonuses__login",
	            type: "button",
	            "aria-label": $data.content.loginBtn.text,
	            title: $data.content.loginBtn.text,
	            onClick: _cache[1] || (_cache[1] = (...args) => ($options.getLogin && $options.getLogin(...args)))
	          }, toDisplayString($data.content.loginBtn.text), 9 /* TEXT, PROPS */, ["aria-label", "title"]))
	        : createCommentVNode("v-if", true)
	    ]),
	    ($data.content.orderLink)
	      ? (openBlock(), createBlock("div", _hoisted_5$a, [
	          createVNode("a", {
	            class: "btn btn--primary btn--full js-no-spa",
	            href: $data.content.orderLink.link
	          }, [
	            createVNode("span", null, toDisplayString($data.content.orderLink.text), 1 /* TEXT */),
	            _hoisted_6$a
	          ], 8 /* PROPS */, ["href"])
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$x.render = render$z;
	script$x.__file = "local/assets/source/components/v-copy-bonuses.vue";

	var script$y = {
		methods: {
			formatPrice(price) {
				if (!price && price !== 0 && price !== '0') {
					console.log('Ошибка цены', price);
					return ' - ';
				}
				// return parseFloat(price).toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
				return parseFloat(price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
			},

			formatInteger(price) {
				if (!price && price !== 0 && price !== '0') {
					console.log('Ошибка', price);
					return ' - ';
				}
				return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
			},

			formatDateShort(text) {
				if (!(/^\d+$/.test(text))) {
					return  text;
				}
				try {
					let date = new Date(text);
					let day = date.getDate();
					let month = date.getMonth();
					let year = date.getFullYear();
					return '' + day + ' ' + ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'][month] + ' ' + year;
				} catch (e) {
					return '';
				}
			},

			// wordEndings[0] - 1, wordEndings[1] - 2-4, wordEndings[2] - 0, 5-9
			pluralize(value, wordBase, wordEndings, approx) {
				// тыс. просмотрОВ, млн. просмотрОВ
				if (approx && value >= 1000) {
					return wordBase + wordEndings[2];
				}
				// *надцать (11-19) - всегда вариант 3
				if (value % 100 > 10 && value % 100 < 20) {
					return wordBase + wordEndings[2];
				}
				let ending = value % 10;
				if (ending == 0 || ending >= 5) {
					return wordBase + wordEndings[2];
				} else if (ending == 1){
					return wordBase + wordEndings[0];
				} else {
					return wordBase + wordEndings[1];
				}
			},

			getPriceCoins (value) {
				return this.formatPrice(String(value % 1)).slice(1);
			}
		},
	};

	const render$A = () => {};


	script$y.render = render$A;
	script$y.__file = "local/assets/source/components/mixins/v-mixin-formatting.vue";

	var breakpoints = {
		'xl-min': 1440,
		'lg-max': 1439,
		'lg-min': 1280,
		'md-max': 1279,
		'md-min': 1024,
		'sm-max': 1023,
		'sm-min': 768,
		'xs-max': 767,
		'xs-min': 640,
		'2xs-max': 639,
		'2xs-min': 480,
		'3xs-max': 479,
		'3xs-min': 380,
		'4xs-max': 379,
		'4xs-min': 300
	};

	var script$z = {
		mixins: [
			script$2,
			script$y
		],

		data() {
			return {
				redirect: null,
				order: null,
				adaptiveDevice: false,
				hideToolbar: false,
				currentStep: null,
				currentForm: null,
				localFormData: new FormData(),
			};
		},

		computed: {
			
		   	computedDiscountData(){
				return {
				 'discountList': this.order.discountList? this.order.discountList : null,
				 'items': this.order.items
				};
			},

			...mapGetters$1({
				userAuthorized: 'user/userAuthorized'
			}),
	 
	 
		},
	 

		created() {
			window.addEventListener('resize', this.getDevice);
			this.getDevice();


			controller.events.on('lk-edit-item', this.updateOrder);

			controller.events.on('update-order', this.updateOrder);

			document.addEventListener('click', this.goToBasket);
		},

		unmounted() {
			window.removeEventListener('resize', this.getDevice);
			window.removeEventListener('click', this.goToBasket);
		},

		methods: {

			matches(el, selector) {
				try {
					return (el.matches || el.matchesSelector || el.msMatchesSelector).call(el, selector);
				} catch (e) {
					return false;
				}
			},
			goToBasket(e) {
				let button = this.closestMatch(e.target, [
					'.js-submit-basket'
				]);

				if (!button) {
					return;
				}
				this.redirect = button.el.getAttribute('data-href');
				controller.closeModal();
				this.requestDataLoadNextStep(false, {action: 'autosubmit'});

			},

			closestMatch(el, selectors) {
				while (el) {
					for (let i = 0; i < selectors.length; i++) {
						if (this.matches(el, selectors[i])) {
							return {el: el, selector: selectors[i]};
						}
					}
					el = el.parentNode;
				}
				return null;
			},

			requestDataLoadNextStep(submit, options = {}) {
				const $self = this;
				if ($self.loading) {
					return;
				}
				let namesOfCurrentIteration = [];
				if ($self.order.forms) {
					Object.keys($self.order.steps).forEach(stepKey => {
						if ($self.order.forms[stepKey] && $self.order.forms[stepKey]['fields']) {

							$self.order.forms[stepKey]['fields'].forEach(field => {
								let key = $self.proxyFieldName(field.name);
								if (field.multiple) {
									key = this.proxyFieldName(field.name.replace('[]', '')) + '[]';
								}
								if (!field.value) {
									field.value = '';
								}
								if (field.type === 'file') {
									// очистка полей для файлов от старых значений
									for (let item of $self.localFormData.entries()) {
										let isfoundInSavedFileKeys = false;
										for (let j = 0; j < $self.savedFileKeys.length; j++) {
											if (item[0].indexOf($self.savedFileKeys[j]) > -1) {
												isfoundInSavedFileKeys = true;
												break;
											}
										}
										if (item[0].indexOf(key) === 0 && !isfoundInSavedFileKeys) {
											$self.localFormData.delete(item[0]);
										}
									}
								}
								if (namesOfCurrentIteration.indexOf(key) < 0) {
									$self.localFormData.delete(key);
									namesOfCurrentIteration.push(key);
								}
								if (field.type !== 'file') {
									// если есть дочерние поля проходим по ним
									if (field.children) {
										field.children.forEach((child) => {
											this.localFormData.append(this.proxyFieldName(child.name), child.value);
										});
									}

									if (Array.isArray(field.value)) {
										field.value.forEach(val => {
											$self.localFormData.append(key, val);
										});
									} else {
										$self.localFormData.append(key, field.value);
									}
								}
							});
						}
					});
				}

				$self.localFormData.set('action', options.action || 'submit');
				$self.localFormData.set('bxajaxid', $self.bxajaxid);
				$self.localFormData.delete('stepValue');
				if ($self.currentStep) {
					$self.localFormData.append('stepValue', (submit ? ($self.currentStep.number > 1 ? 4 : $self.currentStep.number + 1) : $self.order.step));
				}

				this.dataLoad({
					url: $self.order.remote,
					data: $self.localFormData,
					delay: true
				}, null).then(() => {
					this.chackHasFormsErrors();
					this.scrollToFirstError(); // подскролл к ошибке
				});
			},

			dataSet(data) {
				if (this.redirect) {
					window.location.href = this.redirect;
					return;
				}

				this.order = data.basket;
				let currentStep;
				Object.keys(data.basket.steps).forEach(key => {
					let item = data.basket.steps[key];
					if (item.number === data.basket.step) {
						currentStep = item;
					}
				});
				if (currentStep) {
					this.currentStep = currentStep;
					this.currentForm = data.basket.forms[currentStep.code];
				}
				this.chackHasFormsErrors();

				this.$nextTick(() => {
					View.initAllLocal(this.$el);
				});
			},

			updateOrder() {

				this.requestDataLoadNextStep(false, {action: 'autosubmit'});
			},

			submitOrder(formData) {
				this.requestDataLoadNextStep(true);
			},


			handler(nameMethod) {
				this[nameMethod]();
			},
	 

			getDevice() {
				this.adaptiveDevice = window.innerWidth < breakpoints['sm-max'];
			},


			getFieldError(field) {
				if (this.order.errors && this.order.errors.fields) {
					let filteredErrors = this.order.errors.fields.filter((item) => item.name == field.id);
					return filteredErrors.length ? filteredErrors : null;
				} else {
					return null;
				}
			},


			fieldChanged(field) {
				if (field.autosubmit) {
					this.requestDataLoadNextStep(false, {action: 'autosubmit'});
				}
			},

			proxyFieldName(name) {
				return `state[form][${name}]`;
			},

			fileInput(field, e) {
				this.savedFileKeys = [];
				for (let i = 0; i < e.target.files.length; i++) {
					this.savedFileKeys.push(e.key);
					this.localFormData.append(this.proxyFieldName(field.name) + '[' + e.key + ']', e.target.files[i].path || e.target.files[i]);
				}
			},

			fileRemove(field, e) {
				this.localFormData.delete(this.proxyFieldName(field.name) + '[' + e.key + ']');
			},

			chackHasFormsErrors() {
				let result = false;
				if (this.order.forms) {
					Object.keys(this.order.forms).forEach(form => {
						let currentForm = this.order.forms[form];
						if (currentForm.errors &&
							((currentForm.errors.form && currentForm.errors.form.length) ||
								(currentForm.errors.fields && Object.keys(currentForm.errors.fields).length))) {
							result = true;
						}
					});
				}
				this.isFormsHasErrors = result;
			},

			scrollToFirstError() {
				if (!this) {
					return;
				}
				let $errorFields = this.$el.querySelectorAll('.form-error, .form__form-errors');
				$errorFields = Array.from($errorFields).map((errorField) => {
					return errorField.closest('.v-field-radio-buttons') || errorField.closest('.v-field') || errorField.closest('.form__form-errors')
				});
				if ($errorFields.length > 0) {
					const $firstErrorField = $errorFields[0];
					let yOffset = -60;
					const coordY = $firstErrorField.getBoundingClientRect().top + window.pageYOffset + yOffset;
					window.scrollTo({top: coordY, behavior: 'smooth'});
				}
			},


		},
	};

	const _hoisted_1$s = { class: "v-order order" };
	const _hoisted_2$o = {
	  key: 0,
	  class: "container"
	};
	const _hoisted_3$k = { class: "order__header" };
	const _hoisted_4$e = {
	  key: 0,
	  class: "page-title"
	};
	const _hoisted_5$b = { class: "h3 page-title__value" };
	const _hoisted_6$b = { class: "order__layout" };
	const _hoisted_7$9 = { class: "order__main" };
	const _hoisted_8$7 = {
	  key: 1,
	  class: "form__form-errors"
	};
	const _hoisted_9$7 = {
	  key: 2,
	  class: "form"
	};
	const _hoisted_10$4 = { class: "form__wrap" };
	const _hoisted_11$4 = { class: "form__main flc fcc" };
	const _hoisted_12$4 = /*#__PURE__*/createVNode("h4", {
	  class: "form__group-title h4 flc",
	  style: {marginBottom: '0'}
	}, "Личные данные", -1 /* HOISTED */);
	const _hoisted_13$3 = {
	  class: "form",
	  novalidate: "novalidate",
	  autocomplete: "off"
	};
	const _hoisted_14$3 = { class: "form__wrap" };
	const _hoisted_15$3 = {
	  key: 0,
	  class: "form__group-title h4 flc"
	};
	const _hoisted_16$2 = { class: "form__main flc fcc" };
	const _hoisted_17$1 = { class: "form__groups" };
	const _hoisted_18$1 = {
	  key: 0,
	  class: "form__group-title flc"
	};
	const _hoisted_19$1 = { class: "form__group-body flc" };
	const _hoisted_20$1 = { class: "form__fields" };
	const _hoisted_21$1 = { class: "order__products" };
	const _hoisted_22$1 = /*#__PURE__*/createVNode("div", { class: "order__products-title" }, "Товары", -1 /* HOISTED */);
	const _hoisted_23$1 = { class: "order__list" };
	const _hoisted_24 = {
	  key: 0,
	  class: "order__aside"
	};
	const _hoisted_25 = { class: "order__resume" };
	const _hoisted_26 = { class: "order__resume-header" };
	const _hoisted_27 = {
	  key: 0,
	  class: "order__resume-title"
	};
	const _hoisted_28 = { class: "order__props" };
	const _hoisted_29 = {
	  key: 0,
	  class: "order__prop"
	};
	const _hoisted_30 = { class: "order__prop-entry" };
	const _hoisted_31 = { class: "order__prop-name" };
	const _hoisted_32 = { class: "order__prop-value" };
	const _hoisted_33 = { class: "order__prop-currency" };
	const _hoisted_34 = {
	  key: 1,
	  class: "order__prop order__prop--discount"
	};
	const _hoisted_35 = { class: "order__prop-entry accordion__toggler js-accordion__toggler" };
	const _hoisted_36 = { class: "order__prop-name" };
	const _hoisted_37 = { class: "order__prop-value" };
	const _hoisted_38 = { class: "order__prop-currency" };
	const _hoisted_39 = { class: "order__prop-entry accordion__toggler js-accordion__toggler" };
	const _hoisted_40 = { class: "order__prop-name" };
	const _hoisted_41 = { class: "order__prop-value" };
	const _hoisted_42 = { class: "order__prop-currency" };
	const _hoisted_43 = {
	  key: 0,
	  class: "accordion__icon"
	};
	const _hoisted_44 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-down" })
	], -1 /* HOISTED */);
	const _hoisted_45 = {
	  key: 0,
	  class: "order__prop-items accordion__content js-accordion__content"
	};
	const _hoisted_46 = { class: "accordion__content-wrap" };
	const _hoisted_47 = { class: "order__prop-entry" };
	const _hoisted_48 = { class: "order__prop-name" };
	const _hoisted_49 = { class: "order__prop-value" };
	const _hoisted_50 = { class: "order__prop-currency" };
	const _hoisted_51 = {
	  key: 3,
	  class: "order__prop order__prop--delivery"
	};
	const _hoisted_52 = { class: "order__prop-entry" };
	const _hoisted_53 = { class: "order__prop-name" };
	const _hoisted_54 = { class: "order__prop-value" };
	const _hoisted_55 = { class: "order__prop-currency" };
	const _hoisted_56 = {
	  key: 4,
	  class: "order__prop"
	};
	const _hoisted_57 = { class: "order__prop-entry" };
	const _hoisted_58 = { class: "order__prop-name" };
	const _hoisted_59 = { class: "order__prop-value" };
	const _hoisted_60 = { class: "order__prop-currency" };
	const _hoisted_61 = {
	  key: 5,
	  class: "order__prop order__prop--total"
	};
	const _hoisted_62 = { class: "order__prop-entry" };
	const _hoisted_63 = { class: "order__prop-name" };
	const _hoisted_64 = { class: "order__prop-value" };
	const _hoisted_65 = { class: "order__prop-currency" };
	const _hoisted_66 = {
	  key: 6,
	  class: "basket__discount-card"
	};
	const _hoisted_67 = { class: "order__action" };

	function render$B(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_form = resolveComponent("v-form");
	  const _component_v_field = resolveComponent("v-field");
	  const _component_v_order_item = resolveComponent("v-order-item");
	  const _component_v_discount_block = resolveComponent("v-discount-block");

	  return (openBlock(), createBlock("section", _hoisted_1$s, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.order)
	      ? (openBlock(), createBlock("div", _hoisted_2$o, [
	          ($data.order.items?.length)
	            ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	                createVNode("div", _hoisted_3$k, [
	                  ($data.order.title)
	                    ? (openBlock(), createBlock("div", _hoisted_4$e, [
	                        createVNode("h1", _hoisted_5$b, toDisplayString($data.order.title), 1 /* TEXT */)
	                      ]))
	                    : createCommentVNode("v-if", true)
	                ]),
	                createVNode("div", _hoisted_6$b, [
	                  createVNode("div", _hoisted_7$9, [
	                    ($data.order && $data.order.success && $data.order.message)
	                      ? (openBlock(), createBlock("div", {
	                          key: 0,
	                          class: "form__success-message",
	                          innerHTML: $data.order.message
	                        }, null, 8 /* PROPS */, ["innerHTML"]))
	                      : createCommentVNode("v-if", true),
	                    ($data.order && $data.order.errors && $data.order.errors.form && $data.order.errors.form.length)
	                      ? (openBlock(), createBlock("div", _hoisted_8$7, [
	                          (Array.isArray($data.order.errors.form) && $data.order.errors.form.length)
	                            ? (openBlock(true), createBlock(Fragment, { key: 0 }, renderList($data.order.errors.form, (error) => {
	                                return (openBlock(), createBlock("div", {
	                                  class: "form__form-error flc",
	                                  innerHTML: error
	                                }, null, 8 /* PROPS */, ["innerHTML"]))
	                              }), 256 /* UNKEYED_FRAGMENT */))
	                            : (openBlock(), createBlock("div", {
	                                key: 1,
	                                class: "form__form-error flc",
	                                innerHTML: $data.order.errors.form
	                              }, null, 8 /* PROPS */, ["innerHTML"]))
	                        ]))
	                      : createCommentVNode("v-if", true),
	                    (!$data.order.userAuthorized)
	                      ? (openBlock(), createBlock("div", _hoisted_9$7, [
	                          createVNode("div", _hoisted_10$4, [
	                            createVNode("div", _hoisted_11$4, [
	                              _hoisted_12$4,
	                              createVNode(_component_v_form, {
	                                "data-source": "/auth/register_basket.php",
	                                bxajaxid: "ajax-basket_register"
	                              })
	                            ])
	                          ])
	                        ]))
	                      : (openBlock(true), createBlock(Fragment, { key: 3 }, renderList($data.order.forms, (form, index) => {
	                          return (openBlock(), createBlock("form", _hoisted_13$3, [
	                            createVNode("div", _hoisted_14$3, [
	                              ($data.order.steps[index].title)
	                                ? (openBlock(), createBlock("h4", _hoisted_15$3, toDisplayString($data.order.steps[index].title), 1 /* TEXT */))
	                                : createCommentVNode("v-if", true),
	                              createVNode("div", _hoisted_16$2, [
	                                createVNode("div", _hoisted_17$1, [
	                                  (openBlock(true), createBlock(Fragment, null, renderList($data.order.steps[index].groups, (group) => {
	                                    return (openBlock(), createBlock("div", {
	                                      class: ["form__group", {'form__group--disabled': group.disabled, 'hidden': group.hidden}],
	                                      style: {width: group.width || null},
	                                      key: group.id
	                                    }, [
	                                      (group.title)
	                                        ? (openBlock(), createBlock("h3", _hoisted_18$1, toDisplayString(group.title), 1 /* TEXT */))
	                                        : createCommentVNode("v-if", true),
	                                      (group.note)
	                                        ? (openBlock(), createBlock("div", {
	                                            key: 1,
	                                            class: "form__group-note flc",
	                                            innerHTML: group.note
	                                          }, null, 8 /* PROPS */, ["innerHTML"]))
	                                        : createCommentVNode("v-if", true),
	                                      createVNode("div", _hoisted_19$1, [
	                                        createVNode("div", _hoisted_20$1, [
	                                          (openBlock(true), createBlock(Fragment, null, renderList(form.fields, (field, index) => {
	                                            return (openBlock(), createBlock(Fragment, null, [
	                                              (field.groupId === group.id)
	                                                ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	                                                    (field.type === 'spacer')
	                                                      ? (openBlock(), createBlock("div", {
	                                                          class: "form__field form__field--spacer",
	                                                          style: {width: field.width || null},
	                                                          key: "spacer"
	                                                        }, null, 4 /* STYLE */))
	                                                      : (openBlock(), createBlock("div", {
	                                                          class: ["form__field", {'form__field--hidden': field.type === 'hidden'}],
	                                                          style: {width: field.width || null},
	                                                          key: field.id
	                                                        }, [
	                                                          createVNode(_component_v_field, {
	                                                            field: {...field, errors: $options.getFieldError(field)},
	                                                            fieldsErrors: $data.order.errors.fields,
	                                                            modelValue: field.value,
	                                                            "onUpdate:modelValue": [$event => (field.value = $event), $event => ($options.fieldChanged(field, $event))],
	                                                            onFileinput: $event => ($options.fileInput(field, $event)),
	                                                            onFileremove: $event => ($options.fileRemove(field, $event)),
	                                                            "onUpdate:childValue": $event => ($options.fieldChanged(field, $event))
	                                                          }, null, 8 /* PROPS */, ["field", "fieldsErrors", "modelValue", "onUpdate:modelValue", "onFileinput", "onFileremove", "onUpdate:childValue"])
	                                                        ], 6 /* CLASS, STYLE */))
	                                                  ], 64 /* STABLE_FRAGMENT */))
	                                                : createCommentVNode("v-if", true)
	                                            ], 64 /* STABLE_FRAGMENT */))
	                                          }), 256 /* UNKEYED_FRAGMENT */))
	                                        ])
	                                      ])
	                                    ], 6 /* CLASS, STYLE */))
	                                  }), 128 /* KEYED_FRAGMENT */))
	                                ])
	                              ])
	                            ])
	                          ]))
	                        }), 256 /* UNKEYED_FRAGMENT */)),
	                    createVNode("div", _hoisted_21$1, [
	                      _hoisted_22$1,
	                      createVNode("div", _hoisted_23$1, [
	                        (openBlock(true), createBlock(Fragment, null, renderList($data.order.items, (item) => {
	                          return (openBlock(), createBlock(_component_v_order_item, {
	                            product: item,
	                            discount: $data.order.discountList,
	                            key: item.id
	                          }, null, 8 /* PROPS */, ["product", "discount"]))
	                        }), 128 /* KEYED_FRAGMENT */))
	                      ])
	                    ])
	                  ]),
	                  ($data.order.resume)
	                    ? (openBlock(), createBlock("div", _hoisted_24, [
	                        createVNode("div", _hoisted_25, [
	                          createVNode("div", _hoisted_26, [
	                            ($data.order.resume.title)
	                              ? (openBlock(), createBlock("div", _hoisted_27, toDisplayString($data.order.resume.title), 1 /* TEXT */))
	                              : createCommentVNode("v-if", true)
	                          ]),
	                          createVNode("div", _hoisted_28, [
	                            ($data.order.resume.productsPrice)
	                              ? (openBlock(), createBlock("div", _hoisted_29, [
	                                  createVNode("div", _hoisted_30, [
	                                    createVNode("div", _hoisted_31, toDisplayString($data.order.resume.productsPrice.name) + " (" + toDisplayString($data.order.items.length) + ")", 1 /* TEXT */),
	                                    createVNode("div", _hoisted_32, toDisplayString(_ctx.formatPrice($data.order.resume.productsPrice.value)), 1 /* TEXT */),
	                                    createVNode("div", _hoisted_33, toDisplayString($data.order.resume.productsPrice.currency), 1 /* TEXT */)
	                                  ])
	                                ]))
	                              : createCommentVNode("v-if", true),
	                            ($data.order.resume.sertif)
	                              ? (openBlock(), createBlock("div", _hoisted_34, [
	                                  createVNode("div", _hoisted_35, [
	                                    createVNode("div", _hoisted_36, toDisplayString($data.order.resume.sertif.name), 1 /* TEXT */),
	                                    createVNode("div", _hoisted_37, toDisplayString(_ctx.formatPrice($data.order.resume.sertif.value)), 1 /* TEXT */),
	                                    createVNode("div", _hoisted_38, toDisplayString($data.order.resume.sertif.currency), 1 /* TEXT */)
	                                  ])
	                                ]))
	                              : createCommentVNode("v-if", true),
	                            ($data.order.resume.discount)
	                              ? (openBlock(), createBlock("div", {
	                                  key: 2,
	                                  class: ["order__prop order__prop--discount", {'accordion  accordion--native  js-accordion': $data.order.resume.discount?.items?.length}]
	                                }, [
	                                  createVNode("div", _hoisted_39, [
	                                    createVNode("div", _hoisted_40, toDisplayString($data.order.resume.discount.name), 1 /* TEXT */),
	                                    createVNode("div", _hoisted_41, toDisplayString(_ctx.formatPrice($data.order.resume.discount.value)), 1 /* TEXT */),
	                                    createVNode("div", _hoisted_42, toDisplayString($data.order.resume.discount.currency), 1 /* TEXT */),
	                                    ($data.order.resume.discount?.items?.length)
	                                      ? (openBlock(), createBlock("i", _hoisted_43, [
	                                          _hoisted_44
	                                        ]))
	                                      : createCommentVNode("v-if", true)
	                                  ]),
	                                  ($data.order.resume.discount?.items?.length)
	                                    ? (openBlock(), createBlock("div", _hoisted_45, [
	                                        createVNode("div", _hoisted_46, [
	                                          (openBlock(true), createBlock(Fragment, null, renderList($data.order.resume.discount.items, (item) => {
	                                            return (openBlock(), createBlock("div", _hoisted_47, [
	                                              createVNode("div", _hoisted_48, toDisplayString(item.name), 1 /* TEXT */),
	                                              createVNode("div", _hoisted_49, toDisplayString(_ctx.formatPrice(item.price.current.value)), 1 /* TEXT */),
	                                              createVNode("div", _hoisted_50, toDisplayString(item.price.current.currency), 1 /* TEXT */)
	                                            ]))
	                                          }), 256 /* UNKEYED_FRAGMENT */))
	                                        ])
	                                      ]))
	                                    : createCommentVNode("v-if", true)
	                                ], 2 /* CLASS */))
	                              : createCommentVNode("v-if", true),
	                            ($data.order.resume.delivery)
	                              ? (openBlock(), createBlock("div", _hoisted_51, [
	                                  createVNode("div", _hoisted_52, [
	                                    createVNode("div", _hoisted_53, toDisplayString($data.order.resume.delivery.name), 1 /* TEXT */),
	                                    createVNode("div", _hoisted_54, toDisplayString(_ctx.formatPrice($data.order.resume.delivery.value)), 1 /* TEXT */),
	                                    createVNode("div", _hoisted_55, toDisplayString($data.order.resume.delivery.currency), 1 /* TEXT */)
	                                  ])
	                                ]))
	                              : createCommentVNode("v-if", true),
	                            ($data.order.resume.orderPrice)
	                              ? (openBlock(), createBlock("div", _hoisted_56, [
	                                  createVNode("div", _hoisted_57, [
	                                    createVNode("div", _hoisted_58, toDisplayString($data.order.resume.orderPrice.name), 1 /* TEXT */),
	                                    createVNode("div", _hoisted_59, toDisplayString(_ctx.formatPrice($data.order.resume.orderPrice.value)), 1 /* TEXT */),
	                                    createVNode("div", _hoisted_60, toDisplayString($data.order.resume.orderPrice.currency), 1 /* TEXT */)
	                                  ])
	                                ]))
	                              : createCommentVNode("v-if", true),
	                            ($data.order.resume.total)
	                              ? (openBlock(), createBlock("div", _hoisted_61, [
	                                  createVNode("div", _hoisted_62, [
	                                    createVNode("div", _hoisted_63, toDisplayString($data.order.resume.total.name), 1 /* TEXT */),
	                                    createVNode("div", _hoisted_64, toDisplayString(_ctx.formatPrice($data.order.resume.total.value)), 1 /* TEXT */),
	                                    createVNode("div", _hoisted_65, toDisplayString($data.order.resume.total.currency), 1 /* TEXT */)
	                                  ])
	                                ]))
	                              : createCommentVNode("v-if", true),
	                            ($data.order.discountList && $data.order.discountList.nextLevelId)
	                              ? (openBlock(), createBlock("div", _hoisted_66, [
	                                  createVNode(_component_v_discount_block, { "data-source": $options.computedDiscountData }, null, 8 /* PROPS */, ["data-source"])
	                                ]))
	                              : createCommentVNode("v-if", true)
	                          ]),
	                          createVNode("div", _hoisted_67, [
	                            ($data.order.resume.submit)
	                              ? (openBlock(), createBlock("button", {
	                                  key: 0,
	                                  class: ["order__order", [$data.order.resume.submit.className]],
	                                  type: "button",
	                                  onClick: _cache[1] || (_cache[1] = $event => ($options.handler($data.order.resume.submit.handler))),
	                                  disabled: $data.order.resume.submit.disabled || !$data.order.userAuthorized
	                                }, toDisplayString($data.order.resume.submit.text), 11 /* TEXT, CLASS, PROPS */, ["disabled"]))
	                              : createCommentVNode("v-if", true)
	                          ])
	                        ])
	                      ]))
	                    : createCommentVNode("v-if", true)
	                ])
	              ], 64 /* STABLE_FRAGMENT */))
	            : createCommentVNode("v-if", true)
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$z.render = render$B;
	script$z.__file = "local/assets/source/components/v-order.vue";

	var script$A = {
		mixins: [
			script$2,
		],

		data() {
			return {
				data: null,
				adaptiveDevice: false,
				hideToolbar: false,
				formData: new FormData(),
			};
		},

		created() {
			controller.events.on('lk-edit-personal-data', this.update);
		},

		methods: {
			dataSet(data, options = {}) {
				this.data = data;
				this.data.bxajaxid = this.bxajaxid;
			},

			update() {
				this.dataLoad({
					url: this.data.remote,
					delay: true,
					data: {
						bxajaxid: this.bxajaxid,
					}
				});
			},
	 
		},
	};

	const _hoisted_1$t = { class: "v-my-data my-data" };
	const _hoisted_2$p = {
	  key: 0,
	  class: "container"
	};
	const _hoisted_3$l = { class: "my-data__header" };
	const _hoisted_4$f = {
	  key: 0,
	  class: "page-title"
	};
	const _hoisted_5$c = { class: "h2 page-title__value" };
	const _hoisted_6$c = {
	  key: 1,
	  class: "my-data__text"
	};
	const _hoisted_7$a = { class: "my-data__body" };
	const _hoisted_8$8 = { class: "my-data__form" };
	const _hoisted_9$8 = {
	  key: 0,
	  class: "my-data__toggles"
	};
	const _hoisted_10$5 = { class: "my-data__toggle-icon" };
	const _hoisted_11$5 = { class: "svg-icon" };
	const _hoisted_12$5 = { class: "my-data__toggle-content" };
	const _hoisted_13$4 = {
	  key: 0,
	  class: "my-data__toggle-name"
	};
	const _hoisted_14$4 = {
	  key: 1,
	  class: "my-data__toggle-note"
	};
	const _hoisted_15$4 = {
	  key: 1,
	  class: "my-data__toggle-arrow hidden-lg hidden-md hidden-sm"
	};
	const _hoisted_16$3 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-text" })
	], -1 /* HOISTED */);

	function render$C(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_form = resolveComponent("v-form");

	  return (openBlock(), createBlock("div", _hoisted_1$t, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.data)
	      ? (openBlock(), createBlock("div", _hoisted_2$p, [
	          createVNode("div", _hoisted_3$l, [
	            ($data.data.title)
	              ? (openBlock(), createBlock("div", _hoisted_4$f, [
	                  createVNode("h1", _hoisted_5$c, toDisplayString($data.data.title), 1 /* TEXT */)
	                ]))
	              : createCommentVNode("v-if", true),
	            ($data.data.text)
	              ? (openBlock(), createBlock("div", _hoisted_6$c, toDisplayString($data.data.text), 1 /* TEXT */))
	              : createCommentVNode("v-if", true)
	          ]),
	          createVNode("div", _hoisted_7$a, [
	            createVNode("div", _hoisted_8$8, [
	              ($data.data.fields?.length)
	                ? (openBlock(), createBlock(_component_v_form, {
	                    key: 0,
	                    "data-source": $data.data,
	                    bxajaxid: _ctx.bxajaxid
	                  }, null, 8 /* PROPS */, ["data-source", "bxajaxid"]))
	                : createCommentVNode("v-if", true)
	            ]),
	            ($data.data.toggles?.length)
	              ? (openBlock(), createBlock("div", _hoisted_9$8, [
	                  (openBlock(true), createBlock(Fragment, null, renderList($data.data.toggles, (toggle) => {
	                    return (openBlock(), createBlock("div", {
	                      class: ["my-data__toggle js-open-modal", {'my-data__toggle--disabled': toggle.disabled}],
	                      "data-modal-data": "{\"className\": \"modal--sm\"}",
	                      "data-modal-url": toggle.link
	                    }, [
	                      createVNode("div", _hoisted_10$5, [
	                        (openBlock(), createBlock("svg", _hoisted_11$5, [
	                          createVNode("use", {
	                            "xlink:href": '/local/assets/dist/icons/sprite.svg#svg-icon-' + toggle.icon
	                          }, null, 8 /* PROPS */, ["xlink:href"])
	                        ]))
	                      ]),
	                      createVNode("div", _hoisted_12$5, [
	                        (toggle.name)
	                          ? (openBlock(), createBlock("div", _hoisted_13$4, toDisplayString(toggle.name), 1 /* TEXT */))
	                          : createCommentVNode("v-if", true),
	                        (toggle.note)
	                          ? (openBlock(), createBlock("div", _hoisted_14$4, toDisplayString(toggle.note), 1 /* TEXT */))
	                          : createCommentVNode("v-if", true)
	                      ]),
	                      (toggle.text)
	                        ? (openBlock(), createBlock("button", {
	                            key: 0,
	                            class: "my-data__toggle-button hidden-xs",
	                            type: "button",
	                            "aria-label": toggle.text,
	                            title: toggle.text
	                          }, toDisplayString(toggle.text), 9 /* TEXT, PROPS */, ["aria-label", "title"]))
	                        : createCommentVNode("v-if", true),
	                      (!toggle.disabled)
	                        ? (openBlock(), createBlock("div", _hoisted_15$4, [
	                            _hoisted_16$3
	                          ]))
	                        : createCommentVNode("v-if", true)
	                    ], 10 /* CLASS, PROPS */, ["data-modal-url"]))
	                  }), 256 /* UNKEYED_FRAGMENT */))
	                ]))
	              : createCommentVNode("v-if", true)
	          ])
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$A.render = render$C;
	script$A.__file = "local/assets/source/components/v-my-data.vue";

	var script$B = {
		mixins: [script$2],

		data() {
			return {
				section: null
			};
		},

		methods: {
			dataSet(data) {
				this.section = data;
			}
		}
	};

	const _hoisted_1$u = { class: "v-page-section page-section" };
	const _hoisted_2$q = { class: "container" };

	function render$D(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_page_section_header = resolveComponent("v-page-section-header");

	  return (openBlock(), createBlock("section", _hoisted_1$u, [
	    createVNode("div", _hoisted_2$q, [
	      createVNode(_component_v_page_section_header, { "data-source": $data.section }, null, 8 /* PROPS */, ["data-source"]),
	      renderSlot(_ctx.$slots, "default")
	    ])
	  ]))
	}

	script$B.render = render$D;
	script$B.__file = "local/assets/source/components/v-page-section.vue";

	var script$C = {
		mixins: [script$2],

		props: {
		 
			options: {
				type: [Object, String],
				default: null
			},
			slider:{
				type: String,
				default: ''
			}
		},

		data() {
			return {
				section: null
			};
		},

		methods: {
			dataSet(data) {
				this.section = data;
			}
		}
	};

	const _hoisted_1$v = {
	  key: 0,
	  class: "v-product-slider-section page-section"
	};
	const _hoisted_2$r = { class: "container" };
	const _hoisted_3$m = { class: "page-section__slot-wrap" };

	function render$E(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_page_section_header = resolveComponent("v-page-section-header");
	  const _component_v_product_slider = resolveComponent("v-product-slider");

	  return ($data.section && $data.section.items && $data.section.items.length)
	    ? (openBlock(), createBlock("section", _hoisted_1$v, [
	        createVNode("div", _hoisted_2$r, [
	          createVNode(_component_v_page_section_header, { "data-source": $data.section }, null, 8 /* PROPS */, ["data-source"]),
	          createVNode("div", _hoisted_3$m, [
	            createVNode(_component_v_product_slider, {
	              "data-source": $data.section,
	              class: $props.slider,
	              bxajaxid: _ctx.bxajaxid,
	              options: $props.options
	            }, null, 8 /* PROPS */, ["data-source", "class", "bxajaxid", "options"])
	          ])
	        ])
	      ]))
	    : createCommentVNode("v-if", true)
	}

	script$C.render = render$E;
	script$C.__file = "local/assets/source/components/v-product-slider-section.vue";

	var script$D = {
		mixins: [script$2],

		data() {
			return {
				contentPage: null,
				skipPushState: false,
			};
		},

		created() {

			let inst = this;

			 window.onpopstate = function(event) {

				let currentUrl  = document.location.pathname + document.location.search;

				inst.skipPushState = true;

				inst.requestDataLoad(currentUrl);

			 };

			controller.loadPage =  this.loadPage;

			// event delegation
			document.addEventListener('click', (e) => {
				let target = e.target.closest('a');
				if (!target || target.attributes['target']) {
					return;
				}
				if (e.target.closest('.js-replace-modal')
						|| e.target.closest('.js-no-spa')
						|| e.target.closest('.js-open-modal')
						|| e.target.closest('.js-close-modal')
						|| e.target.closest('.js-open-modal-gallery')
						|| e.target.closest('#bx-panel')
								){
					return;
				}
				let href;
				if (target && target.attributes['href']) {
					href = target.attributes['href'].value;
					if (href[0] !== '/') {
						return;
					}
				}
				if (!href || (href && href.indexOf('/bitrix/') >= 0)) {
					return;
				}

				const options = {
					notScrollTopPage: target.dataset.notScroll
				};

				controller.loadPage(href, e, options);
			});

		},
		methods: {
			loadPage(href, e, options) {
				if (e){
					e.preventDefault();
				}

			   window.modalController.closeAll();
				controller.closeSearchSmall();

				this.requestDataLoad(href, options);

				if (!options.notScrollTopPage) {
					controller.scrollTop();
				}




				return false;
			},
			dataSet(data, options = {}) {
				if (!this.contentPage || data.remote){
					if (!this.skipPushState){
						history.pushState(data.remote, data.title, data.remote);
						if (!options.notScrollTopPage) {
							controller.scrollTop();
						}
					}

					this.skipPushState = false;
					this.loading=false;
				}

				if (data){
					
					if (document.querySelector('.js-catalog-item__toolbar')) {
						document.querySelector('.js-catalog-item__toolbar').remove();
					}

					if (document.title != data.title) {
						document.title = data.title;
					}
					if (!document.querySelector('meta[name="description"]')) {
						let meta = document.createElement('meta');
						meta.name = 'description';
						document.getElementsByTagName('head')[0].appendChild(meta);
					}
					if (!document.querySelector('meta[name="keywords"]')) {
						let meta = document.createElement('meta');
						meta.name = 'keywords';
						document.getElementsByTagName('head')[0].appendChild(meta);
					}
					document.querySelector('meta[name="description"]').setAttribute('content', data.description);
					document.querySelector('meta[name="keywords"]').setAttribute('content', data.keywords);
					document.body.className = data.bodyClass;
				}
				if (document.querySelector('#mainContentArea')) {
					document.querySelector('#mainContentArea').remove();
				}
				if (document.querySelector('#bx-panel')) {
					document.querySelector('#bx-panel').remove();
				}
				if (data.content) {
					this.contentPage = data;
				}
			},

			requestDataLoad(remote, dataSetOptions) {
				this.dataLoad({
					url: remote,
					delay: false,
					data: {
						pageLoaderAction: 'Y'
					}
				}, dataSetOptions);
			}
		}
	};

	const _hoisted_1$w = { class: "v-page-loader" };

	function render$F(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_lazy_component = resolveComponent("v-lazy-component");

	  return (openBlock(), createBlock("div", _hoisted_1$w, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.contentPage)
	      ? withDirectives((openBlock(), createBlock(_component_v_lazy_component, {
	          key: $data.contentPage.remote+$data.contentPage.time
	        }, {
	          default: withCtx(() => [
	            createVNode("div", {
	              class: "page-loader__content-slot",
	              innerHTML: $data.contentPage.content
	            }, null, 8 /* PROPS */, ["innerHTML"])
	          ]),
	          _: 1 /* STABLE */
	        }, 512 /* NEED_PATCH */)), [
	          [vShow, 1]
	        ])
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$D.render = render$F;
	script$D.__file = "local/assets/source/components/v-page-loader.vue";

	var script$E = {
		mixins: [script$2],

		data() {
			return {
				section: null
			};
		},

		methods: {
			dataSet(data) {
				this.section = data;
			}
		}
	};

	const _hoisted_1$x = { class: "v-page-section-header page-section-header flc" };
	const _hoisted_2$s = {
	  key: 0,
	  class: "page-section-header__title"
	};
	const _hoisted_3$n = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-long" })
	], -1 /* HOISTED */);
	const _hoisted_4$g = { key: 1 };
	const _hoisted_5$d = {
	  key: 0,
	  class: "page-section-header__aside"
	};
	const _hoisted_6$d = { class: "page-section-header__aside-links" };
	const _hoisted_7$b = { class: "page-section-header__aside-links-item" };

	function render$G(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$x, [
	    createVNode("div", {
	      class: ["page-section-header__main", ['page-section-header__main--'+$data.section.title.position]]
	    }, [
	      ($data.section.title)
	        ? (openBlock(), createBlock("h5", _hoisted_2$s, [
	            ($data.section.title.link)
	              ? (openBlock(), createBlock("a", {
	                  key: 0,
	                  class: "page-section-header__title-link link",
	                  href: $data.section.title.link
	                }, [
	                  createTextVNode(toDisplayString($data.section.title.text), 1 /* TEXT */),
	                  _hoisted_3$n
	                ], 8 /* PROPS */, ["href"]))
	              : (openBlock(), createBlock("span", _hoisted_4$g, toDisplayString($data.section.title.text), 1 /* TEXT */))
	          ]))
	        : createCommentVNode("v-if", true)
	    ], 2 /* CLASS */),
	    ($data.section.links && $data.section.links.length)
	      ? (openBlock(), createBlock("div", _hoisted_5$d, [
	          createVNode("div", _hoisted_6$d, [
	            (openBlock(true), createBlock(Fragment, null, renderList($data.section.links, (link) => {
	              return (openBlock(), createBlock("div", _hoisted_7$b, [
	                createVNode("a", {
	                  class: "page-section-header__aside-link link",
	                  href: link.link
	                }, toDisplayString(link.text), 9 /* TEXT, PROPS */, ["href"])
	              ]))
	            }), 256 /* UNKEYED_FRAGMENT */))
	          ])
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$E.render = render$G;
	script$E.__file = "local/assets/source/components/v-page-section-header.vue";

	var script$F = {
		mixins: [
			script$2
		],
		data() {
			return {
				banner: {}
			}
		},
		methods: {
			dataSet(data) {
				this.banner = data;
			}
		},
	};

	const _hoisted_1$y = { class: "v-main-banner main-banner__list" };
	const _hoisted_2$t = { class: "main-banner__grid" };
	const _hoisted_3$o = { class: "main-banner__cell" };
	const _hoisted_4$h = { class: "main-banner__item" };
	const _hoisted_5$e = { class: "main-banner__item-content" };
	const _hoisted_6$e = {
	  key: 0,
	  class: "main-banner__item-name"
	};
	const _hoisted_7$c = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-text" })
	], -1 /* HOISTED */);

	function render$H(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_picture = resolveComponent("v-picture");

	  return (openBlock(), createBlock("div", _hoisted_1$y, [
	    createVNode("div", _hoisted_2$t, [
	      (openBlock(true), createBlock(Fragment, null, renderList($data.banner.items, (item) => {
	        return (openBlock(), createBlock("div", _hoisted_3$o, [
	          createVNode("div", _hoisted_4$h, [
	            (item.link)
	              ? (openBlock(), createBlock("a", {
	                  key: 0,
	                  class: "main-banner__item-link",
	                  href: item.link,
	                  title: item.name
	                }, null, 8 /* PROPS */, ["href", "title"]))
	              : createCommentVNode("v-if", true),
	            (item.imageSources)
	              ? (openBlock(), createBlock(_component_v_picture, {
	                  key: 1,
	                  sources: item.imageSources,
	                  alt: item.title,
	                  width: 202,
	                  height: 202
	                }, null, 8 /* PROPS */, ["sources", "alt"]))
	              : createCommentVNode("v-if", true),
	            createVNode("div", _hoisted_5$e, [
	              (item.title)
	                ? (openBlock(), createBlock("div", _hoisted_6$e, [
	                    createTextVNode(toDisplayString(item.title), 1 /* TEXT */),
	                    _hoisted_7$c
	                  ]))
	                : createCommentVNode("v-if", true)
	            ])
	          ])
	        ]))
	      }), 256 /* UNKEYED_FRAGMENT */))
	    ])
	  ]))
	}

	script$F.render = render$H;
	script$F.__file = "local/assets/source/components/v-main-banner.vue";

	var script$G = {
		mixins: [
			script$2
		],
		
		computed: {
			computedTitle() {}
		},

		data() {
			return {
				slide: null,
				isRetina: window.matchMedia('(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)').matches
			};
		},

		methods: {
			dataSet(data) {
				this.slide = data;
			}
		}
	};

	const _hoisted_1$z = {
	  key: 1,
	  class: "hero-block__actions flc"
	};
	const _hoisted_2$u = { class: "hero-block__actions-grid" };
	const _hoisted_3$p = { class: "hero-block__actions-cell" };
	const _hoisted_4$i = {
	  key: 2,
	  class: "hero-block__bg-layer"
	};
	const _hoisted_5$f = {
	  key: 0,
	  class: "hero-block__bg hero-block__bg--large"
	};
	const _hoisted_6$f = {
	  key: 1,
	  class: "hero-block__bg hero-block__bg--medium"
	};
	const _hoisted_7$d = {
	  key: 2,
	  class: "hero-block__bg hero-block__bg--small"
	};
	const _hoisted_8$9 = {
	  key: 0,
	  class: "hero-block__discount-bg"
	};
	const _hoisted_9$9 = { class: "hero-block__discount-value" };
	const _hoisted_10$6 = { class: "hero-block__discount-text" };
	const _hoisted_11$6 = {
	  key: 4,
	  class: "hero-block__fg-layer"
	};
	const _hoisted_12$6 = { class: "hero-block__container container" };
	const _hoisted_13$5 = { class: "hero-block__content" };
	const _hoisted_14$5 = {
	  key: 0,
	  class: "hero-block__title h1 flc"
	};
	const _hoisted_15$5 = { key: 0 };
	const _hoisted_16$4 = {
	  key: 1,
	  class: "hero-block__title-full"
	};
	const _hoisted_17$2 = {
	  key: 2,
	  class: "hero-block__title-short"
	};

	function render$I(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");

	  return (openBlock(), createBlock("div", {
	    class: ["v-hero-block hero-block", {'hero-block--dark': $data.slide && $data.slide.dark, 'hero-block--right': $data.slide && $data.slide.position == 'right'}]
	  }, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.slide)
	      ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	          ($data.slide.link)
	            ? (openBlock(), createBlock("a", {
	                key: 0,
	                class: "hero-block__link",
	                href: $data.slide.link,
	                "aria-label": $data.slide?.title?.full
	              }, null, 8 /* PROPS */, ["href", "aria-label"]))
	            : createCommentVNode("v-if", true),
	          ($data.slide.buttons && $data.slide.buttons.length)
	            ? (openBlock(), createBlock("div", _hoisted_1$z, [
	                createVNode("div", _hoisted_2$u, [
	                  (openBlock(true), createBlock(Fragment, null, renderList($data.slide.buttons, (button) => {
	                    return (openBlock(), createBlock("div", _hoisted_3$p, [
	                      (button.text)
	                        ? (openBlock(), createBlock("a", {
	                            key: 0,
	                            class: ["hero-block__action btn", {'btn--primary': !$data.slide.dark, 'btn--primary-white': $data.slide.dark}],
	                            href: button.link
	                          }, toDisplayString(button.text), 11 /* TEXT, CLASS, PROPS */, ["href"]))
	                        : createCommentVNode("v-if", true)
	                    ]))
	                  }), 256 /* UNKEYED_FRAGMENT */))
	                ])
	              ]))
	            : createCommentVNode("v-if", true),
	          ($data.slide.imageSources)
	            ? (openBlock(), createBlock("div", _hoisted_4$i, [
	                ($data.slide.imageSources.big && $data.slide.imageSources.big_2x)
	                  ? (openBlock(), createBlock("div", _hoisted_5$f, [
	                      createVNode("div", {
	                        class: "hero-block__bg-image",
	                        style: {'background-image': $data.isRetina ? 'url(' + $data.slide.imageSources.big_2x + ')' : 'url(' + $data.slide.imageSources.big + ')'}
	                      }, null, 4 /* STYLE */)
	                    ]))
	                  : createCommentVNode("v-if", true),
	                ($data.slide.imageSources.middle && $data.slide.imageSources.middle_2x)
	                  ? (openBlock(), createBlock("div", _hoisted_6$f, [
	                      createVNode("div", {
	                        class: "hero-block__bg-image",
	                        style: {'background-image': $data.isRetina ? 'url(' + $data.slide.imageSources.middle_2x + ')' : 'url(' + $data.slide.imageSources.middle + ')'}
	                      }, null, 4 /* STYLE */)
	                    ]))
	                  : createCommentVNode("v-if", true),
	                ($data.slide.imageSources.small && $data.slide.imageSources.small_2x)
	                  ? (openBlock(), createBlock("div", _hoisted_7$d, [
	                      createVNode("div", {
	                        class: "hero-block__bg-image",
	                        style: {'background-image': $data.isRetina ? 'url(' + $data.slide.imageSources.small_2x + ')' : 'url(' + $data.slide.imageSources.small + ')'}
	                      }, null, 4 /* STYLE */)
	                    ]))
	                  : createCommentVNode("v-if", true)
	              ]))
	            : createCommentVNode("v-if", true),
	          ($data.slide.discount)
	            ? (openBlock(), createBlock("div", {
	                key: 3,
	                class: "hero-block__discount",
	                style: {color: $data.slide.discount.color}
	              }, [
	                ($data.slide.discount.background)
	                  ? (openBlock(), createBlock("div", _hoisted_8$9, [
	                      createVNode("div", {
	                        class: "hero-block__discount-bg-item",
	                        style: {background: $data.slide.discount.background}
	                      }, null, 4 /* STYLE */),
	                      createVNode("div", {
	                        class: "hero-block__discount-bg-item",
	                        style: {background: $data.slide.discount.background}
	                      }, null, 4 /* STYLE */)
	                    ]))
	                  : createCommentVNode("v-if", true),
	                createVNode("div", _hoisted_9$9, toDisplayString($data.slide.discount.value), 1 /* TEXT */),
	                createVNode("div", _hoisted_10$6, toDisplayString($data.slide.discount.text), 1 /* TEXT */)
	              ], 4 /* STYLE */))
	            : createCommentVNode("v-if", true),
	          ($data.slide.text || ($data.slide.title && (typeof $data.slide?.title === 'string' || $data.slide?.title?.full || $data.slide?.title?.short ) ))
	            ? (openBlock(), createBlock("div", _hoisted_11$6, [
	                createVNode("div", _hoisted_12$6, [
	                  createVNode("div", _hoisted_13$5, [
	                    ($data.slide?.title)
	                      ? (openBlock(), createBlock("h2", _hoisted_14$5, [
	                          (typeof $data.slide?.title === 'string')
	                            ? (openBlock(), createBlock("span", _hoisted_15$5, toDisplayString($data.slide?.title), 1 /* TEXT */))
	                            : createCommentVNode("v-if", true),
	                          ($data.slide?.title?.full)
	                            ? (openBlock(), createBlock("div", _hoisted_16$4, toDisplayString($data.slide?.title?.full), 1 /* TEXT */))
	                            : createCommentVNode("v-if", true),
	                          ($data.slide?.title?.short)
	                            ? (openBlock(), createBlock("div", _hoisted_17$2, toDisplayString($data.slide?.title?.short), 1 /* TEXT */))
	                            : createCommentVNode("v-if", true)
	                        ]))
	                      : createCommentVNode("v-if", true),
	                    ($data.slide.text)
	                      ? (openBlock(), createBlock("div", {
	                          key: 1,
	                          class: "hero-block__text flc",
	                          innerHTML: $data.slide.text
	                        }, null, 8 /* PROPS */, ["innerHTML"]))
	                      : createCommentVNode("v-if", true)
	                  ])
	                ])
	              ]))
	            : createCommentVNode("v-if", true)
	        ], 64 /* STABLE_FRAGMENT */))
	      : createCommentVNode("v-if", true)
	  ], 2 /* CLASS */))
	}

	script$G.render = render$I;
	script$G.__file = "local/assets/source/components/v-hero-block.vue";

	/**
	 * SSR Window 3.0.0
	 * Better handling for window object in SSR environment
	 * https://github.com/nolimits4web/ssr-window
	 *
	 * Copyright 2020, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: November 9, 2020
	 */
	/* eslint-disable no-param-reassign */
	function isObject$2(obj) {
	    return (obj !== null &&
	        typeof obj === 'object' &&
	        'constructor' in obj &&
	        obj.constructor === Object);
	}
	function extend$1(target, src) {
	    if (target === void 0) { target = {}; }
	    if (src === void 0) { src = {}; }
	    Object.keys(src).forEach(function (key) {
	        if (typeof target[key] === 'undefined')
	            target[key] = src[key];
	        else if (isObject$2(src[key]) &&
	            isObject$2(target[key]) &&
	            Object.keys(src[key]).length > 0) {
	            extend$1(target[key], src[key]);
	        }
	    });
	}

	var ssrDocument = {
	    body: {},
	    addEventListener: function () { },
	    removeEventListener: function () { },
	    activeElement: {
	        blur: function () { },
	        nodeName: '',
	    },
	    querySelector: function () {
	        return null;
	    },
	    querySelectorAll: function () {
	        return [];
	    },
	    getElementById: function () {
	        return null;
	    },
	    createEvent: function () {
	        return {
	            initEvent: function () { },
	        };
	    },
	    createElement: function () {
	        return {
	            children: [],
	            childNodes: [],
	            style: {},
	            setAttribute: function () { },
	            getElementsByTagName: function () {
	                return [];
	            },
	        };
	    },
	    createElementNS: function () {
	        return {};
	    },
	    importNode: function () {
	        return null;
	    },
	    location: {
	        hash: '',
	        host: '',
	        hostname: '',
	        href: '',
	        origin: '',
	        pathname: '',
	        protocol: '',
	        search: '',
	    },
	};
	function getDocument() {
	    var doc = typeof document !== 'undefined' ? document : {};
	    extend$1(doc, ssrDocument);
	    return doc;
	}

	var ssrWindow = {
	    document: ssrDocument,
	    navigator: {
	        userAgent: '',
	    },
	    location: {
	        hash: '',
	        host: '',
	        hostname: '',
	        href: '',
	        origin: '',
	        pathname: '',
	        protocol: '',
	        search: '',
	    },
	    history: {
	        replaceState: function () { },
	        pushState: function () { },
	        go: function () { },
	        back: function () { },
	    },
	    CustomEvent: function CustomEvent() {
	        return this;
	    },
	    addEventListener: function () { },
	    removeEventListener: function () { },
	    getComputedStyle: function () {
	        return {
	            getPropertyValue: function () {
	                return '';
	            },
	        };
	    },
	    Image: function () { },
	    Date: function () { },
	    screen: {},
	    setTimeout: function () { },
	    clearTimeout: function () { },
	    matchMedia: function () {
	        return {};
	    },
	    requestAnimationFrame: function (callback) {
	        if (typeof setTimeout === 'undefined') {
	            callback();
	            return null;
	        }
	        return setTimeout(callback, 0);
	    },
	    cancelAnimationFrame: function (id) {
	        if (typeof setTimeout === 'undefined') {
	            return;
	        }
	        clearTimeout(id);
	    },
	};
	function getWindow$1() {
	    var win = typeof window !== 'undefined' ? window : {};
	    extend$1(win, ssrWindow);
	    return win;
	}

	/**
	 * Dom7 3.0.0
	 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
	 * https://framework7.io/docs/dom7.html
	 *
	 * Copyright 2020, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: November 9, 2020
	 */

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}

	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}

	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };

	  return _setPrototypeOf(o, p);
	}

	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;

	  try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}

	function _construct(Parent, args, Class) {
	  if (_isNativeReflectConstruct()) {
	    _construct = Reflect.construct;
	  } else {
	    _construct = function _construct(Parent, args, Class) {
	      var a = [null];
	      a.push.apply(a, args);
	      var Constructor = Function.bind.apply(Parent, a);
	      var instance = new Constructor();
	      if (Class) _setPrototypeOf(instance, Class.prototype);
	      return instance;
	    };
	  }

	  return _construct.apply(null, arguments);
	}

	function _isNativeFunction(fn) {
	  return Function.toString.call(fn).indexOf("[native code]") !== -1;
	}

	function _wrapNativeSuper(Class) {
	  var _cache = typeof Map === "function" ? new Map() : undefined;

	  _wrapNativeSuper = function _wrapNativeSuper(Class) {
	    if (Class === null || !_isNativeFunction(Class)) return Class;

	    if (typeof Class !== "function") {
	      throw new TypeError("Super expression must either be null or a function");
	    }

	    if (typeof _cache !== "undefined") {
	      if (_cache.has(Class)) return _cache.get(Class);

	      _cache.set(Class, Wrapper);
	    }

	    function Wrapper() {
	      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
	    }

	    Wrapper.prototype = Object.create(Class.prototype, {
	      constructor: {
	        value: Wrapper,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    return _setPrototypeOf(Wrapper, Class);
	  };

	  return _wrapNativeSuper(Class);
	}

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return self;
	}

	/* eslint-disable no-proto */
	function makeReactive(obj) {
	  var proto = obj.__proto__;
	  Object.defineProperty(obj, '__proto__', {
	    get: function get() {
	      return proto;
	    },
	    set: function set(value) {
	      proto.__proto__ = value;
	    }
	  });
	}

	var Dom7 = /*#__PURE__*/function (_Array) {
	  _inheritsLoose(Dom7, _Array);

	  function Dom7(items) {
	    var _this;

	    _this = _Array.call.apply(_Array, [this].concat(items)) || this;
	    makeReactive(_assertThisInitialized(_this));
	    return _this;
	  }

	  return Dom7;
	}( /*#__PURE__*/_wrapNativeSuper(Array));

	function arrayFlat(arr) {
	  if (arr === void 0) {
	    arr = [];
	  }

	  var res = [];
	  arr.forEach(function (el) {
	    if (Array.isArray(el)) {
	      res.push.apply(res, arrayFlat(el));
	    } else {
	      res.push(el);
	    }
	  });
	  return res;
	}
	function arrayFilter(arr, callback) {
	  return Array.prototype.filter.call(arr, callback);
	}
	function arrayUnique(arr) {
	  var uniqueArray = [];

	  for (var i = 0; i < arr.length; i += 1) {
	    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
	  }

	  return uniqueArray;
	}

	function qsa(selector, context) {
	  if (typeof selector !== 'string') {
	    return [selector];
	  }

	  var a = [];
	  var res = context.querySelectorAll(selector);

	  for (var i = 0; i < res.length; i += 1) {
	    a.push(res[i]);
	  }

	  return a;
	}

	function $(selector, context) {
	  var window = getWindow$1();
	  var document = getDocument();
	  var arr = [];

	  if (!context && selector instanceof Dom7) {
	    return selector;
	  }

	  if (!selector) {
	    return new Dom7(arr);
	  }

	  if (typeof selector === 'string') {
	    var html = selector.trim();

	    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	      var toCreate = 'div';
	      if (html.indexOf('<li') === 0) toCreate = 'ul';
	      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
	      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
	      if (html.indexOf('<tbody') === 0) toCreate = 'table';
	      if (html.indexOf('<option') === 0) toCreate = 'select';
	      var tempParent = document.createElement(toCreate);
	      tempParent.innerHTML = html;

	      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
	        arr.push(tempParent.childNodes[i]);
	      }
	    } else {
	      arr = qsa(selector.trim(), context || document);
	    } // arr = qsa(selector, document);

	  } else if (selector.nodeType || selector === window || selector === document) {
	    arr.push(selector);
	  } else if (Array.isArray(selector)) {
	    if (selector instanceof Dom7) return selector;
	    arr = selector;
	  }

	  return new Dom7(arrayUnique(arr));
	}

	$.fn = Dom7.prototype;

	function addClass() {
	  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
	    classes[_key] = arguments[_key];
	  }

	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  this.forEach(function (el) {
	    var _el$classList;

	    (_el$classList = el.classList).add.apply(_el$classList, classNames);
	  });
	  return this;
	}

	function removeClass() {
	  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    classes[_key2] = arguments[_key2];
	  }

	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  this.forEach(function (el) {
	    var _el$classList2;

	    (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
	  });
	  return this;
	}

	function toggleClass() {
	  for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    classes[_key3] = arguments[_key3];
	  }

	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  this.forEach(function (el) {
	    classNames.forEach(function (className) {
	      el.classList.toggle(className);
	    });
	  });
	}

	function hasClass() {
	  for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	    classes[_key4] = arguments[_key4];
	  }

	  var classNames = arrayFlat(classes.map(function (c) {
	    return c.split(' ');
	  }));
	  return arrayFilter(this, function (el) {
	    return classNames.filter(function (className) {
	      return el.classList.contains(className);
	    }).length > 0;
	  }).length > 0;
	}

	function attr(attrs, value) {
	  if (arguments.length === 1 && typeof attrs === 'string') {
	    // Get attr
	    if (this[0]) return this[0].getAttribute(attrs);
	    return undefined;
	  } // Set attrs


	  for (var i = 0; i < this.length; i += 1) {
	    if (arguments.length === 2) {
	      // String
	      this[i].setAttribute(attrs, value);
	    } else {
	      // Object
	      for (var attrName in attrs) {
	        this[i][attrName] = attrs[attrName];
	        this[i].setAttribute(attrName, attrs[attrName]);
	      }
	    }
	  }

	  return this;
	}

	function removeAttr(attr) {
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].removeAttribute(attr);
	  }

	  return this;
	}

	function transform$1(transform) {
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].style.transform = transform;
	  }

	  return this;
	}

	function transition(duration) {
	  for (var i = 0; i < this.length; i += 1) {
	    this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
	  }

	  return this;
	}

	function on() {
	  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	    args[_key5] = arguments[_key5];
	  }

	  var eventType = args[0],
	      targetSelector = args[1],
	      listener = args[2],
	      capture = args[3];

	  if (typeof args[1] === 'function') {
	    eventType = args[0];
	    listener = args[1];
	    capture = args[2];
	    targetSelector = undefined;
	  }

	  if (!capture) capture = false;

	  function handleLiveEvent(e) {
	    var target = e.target;
	    if (!target) return;
	    var eventData = e.target.dom7EventData || [];

	    if (eventData.indexOf(e) < 0) {
	      eventData.unshift(e);
	    }

	    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
	      var _parents = $(target).parents(); // eslint-disable-line


	      for (var k = 0; k < _parents.length; k += 1) {
	        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
	      }
	    }
	  }

	  function handleEvent(e) {
	    var eventData = e && e.target ? e.target.dom7EventData || [] : [];

	    if (eventData.indexOf(e) < 0) {
	      eventData.unshift(e);
	    }

	    listener.apply(this, eventData);
	  }

	  var events = eventType.split(' ');
	  var j;

	  for (var i = 0; i < this.length; i += 1) {
	    var el = this[i];

	    if (!targetSelector) {
	      for (j = 0; j < events.length; j += 1) {
	        var event = events[j];
	        if (!el.dom7Listeners) el.dom7Listeners = {};
	        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
	        el.dom7Listeners[event].push({
	          listener: listener,
	          proxyListener: handleEvent
	        });
	        el.addEventListener(event, handleEvent, capture);
	      }
	    } else {
	      // Live events
	      for (j = 0; j < events.length; j += 1) {
	        var _event = events[j];
	        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
	        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

	        el.dom7LiveListeners[_event].push({
	          listener: listener,
	          proxyListener: handleLiveEvent
	        });

	        el.addEventListener(_event, handleLiveEvent, capture);
	      }
	    }
	  }

	  return this;
	}

	function off() {
	  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	    args[_key6] = arguments[_key6];
	  }

	  var eventType = args[0],
	      targetSelector = args[1],
	      listener = args[2],
	      capture = args[3];

	  if (typeof args[1] === 'function') {
	    eventType = args[0];
	    listener = args[1];
	    capture = args[2];
	    targetSelector = undefined;
	  }

	  if (!capture) capture = false;
	  var events = eventType.split(' ');

	  for (var i = 0; i < events.length; i += 1) {
	    var event = events[i];

	    for (var j = 0; j < this.length; j += 1) {
	      var el = this[j];
	      var handlers = void 0;

	      if (!targetSelector && el.dom7Listeners) {
	        handlers = el.dom7Listeners[event];
	      } else if (targetSelector && el.dom7LiveListeners) {
	        handlers = el.dom7LiveListeners[event];
	      }

	      if (handlers && handlers.length) {
	        for (var k = handlers.length - 1; k >= 0; k -= 1) {
	          var handler = handlers[k];

	          if (listener && handler.listener === listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          } else if (!listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          }
	        }
	      }
	    }
	  }

	  return this;
	}

	function trigger$2() {
	  var window = getWindow$1();

	  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
	    args[_key9] = arguments[_key9];
	  }

	  var events = args[0].split(' ');
	  var eventData = args[1];

	  for (var i = 0; i < events.length; i += 1) {
	    var event = events[i];

	    for (var j = 0; j < this.length; j += 1) {
	      var el = this[j];

	      if (window.CustomEvent) {
	        var evt = new window.CustomEvent(event, {
	          detail: eventData,
	          bubbles: true,
	          cancelable: true
	        });
	        el.dom7EventData = args.filter(function (data, dataIndex) {
	          return dataIndex > 0;
	        });
	        el.dispatchEvent(evt);
	        el.dom7EventData = [];
	        delete el.dom7EventData;
	      }
	    }
	  }

	  return this;
	}

	function transitionEnd(callback) {
	  var dom = this;

	  function fireCallBack(e) {
	    if (e.target !== this) return;
	    callback.call(this, e);
	    dom.off('transitionend', fireCallBack);
	  }

	  if (callback) {
	    dom.on('transitionend', fireCallBack);
	  }

	  return this;
	}

	function outerWidth(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      var _styles = this.styles();

	      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
	    }

	    return this[0].offsetWidth;
	  }

	  return null;
	}

	function outerHeight(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      var _styles2 = this.styles();

	      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
	    }

	    return this[0].offsetHeight;
	  }

	  return null;
	}

	function offset$2() {
	  if (this.length > 0) {
	    var window = getWindow$1();
	    var document = getDocument();
	    var el = this[0];
	    var box = el.getBoundingClientRect();
	    var body = document.body;
	    var clientTop = el.clientTop || body.clientTop || 0;
	    var clientLeft = el.clientLeft || body.clientLeft || 0;
	    var scrollTop = el === window ? window.scrollY : el.scrollTop;
	    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
	    return {
	      top: box.top + scrollTop - clientTop,
	      left: box.left + scrollLeft - clientLeft
	    };
	  }

	  return null;
	}

	function styles() {
	  var window = getWindow$1();
	  if (this[0]) return window.getComputedStyle(this[0], null);
	  return {};
	}

	function css(props, value) {
	  var window = getWindow$1();
	  var i;

	  if (arguments.length === 1) {
	    if (typeof props === 'string') {
	      // .css('width')
	      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
	    } else {
	      // .css({ width: '100px' })
	      for (i = 0; i < this.length; i += 1) {
	        for (var _prop in props) {
	          this[i].style[_prop] = props[_prop];
	        }
	      }

	      return this;
	    }
	  }

	  if (arguments.length === 2 && typeof props === 'string') {
	    // .css('width', '100px')
	    for (i = 0; i < this.length; i += 1) {
	      this[i].style[props] = value;
	    }

	    return this;
	  }

	  return this;
	}

	function each(callback) {
	  if (!callback) return this;
	  this.forEach(function (el, index) {
	    callback.apply(el, [el, index]);
	  });
	  return this;
	}

	function filter(callback) {
	  var result = arrayFilter(this, callback);
	  return $(result);
	}

	function html(html) {
	  if (typeof html === 'undefined') {
	    return this[0] ? this[0].innerHTML : null;
	  }

	  for (var i = 0; i < this.length; i += 1) {
	    this[i].innerHTML = html;
	  }

	  return this;
	}

	function text(text) {
	  if (typeof text === 'undefined') {
	    return this[0] ? this[0].textContent.trim() : null;
	  }

	  for (var i = 0; i < this.length; i += 1) {
	    this[i].textContent = text;
	  }

	  return this;
	}

	function is(selector) {
	  var window = getWindow$1();
	  var document = getDocument();
	  var el = this[0];
	  var compareWith;
	  var i;
	  if (!el || typeof selector === 'undefined') return false;

	  if (typeof selector === 'string') {
	    if (el.matches) return el.matches(selector);
	    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
	    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
	    compareWith = $(selector);

	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) return true;
	    }

	    return false;
	  }

	  if (selector === document) {
	    return el === document;
	  }

	  if (selector === window) {
	    return el === window;
	  }

	  if (selector.nodeType || selector instanceof Dom7) {
	    compareWith = selector.nodeType ? [selector] : selector;

	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) return true;
	    }

	    return false;
	  }

	  return false;
	}

	function index() {
	  var child = this[0];
	  var i;

	  if (child) {
	    i = 0; // eslint-disable-next-line

	    while ((child = child.previousSibling) !== null) {
	      if (child.nodeType === 1) i += 1;
	    }

	    return i;
	  }

	  return undefined;
	}

	function eq(index) {
	  if (typeof index === 'undefined') return this;
	  var length = this.length;

	  if (index > length - 1) {
	    return $([]);
	  }

	  if (index < 0) {
	    var returnIndex = length + index;
	    if (returnIndex < 0) return $([]);
	    return $([this[returnIndex]]);
	  }

	  return $([this[index]]);
	}

	function append() {
	  var newChild;
	  var document = getDocument();

	  for (var k = 0; k < arguments.length; k += 1) {
	    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

	    for (var i = 0; i < this.length; i += 1) {
	      if (typeof newChild === 'string') {
	        var tempDiv = document.createElement('div');
	        tempDiv.innerHTML = newChild;

	        while (tempDiv.firstChild) {
	          this[i].appendChild(tempDiv.firstChild);
	        }
	      } else if (newChild instanceof Dom7) {
	        for (var j = 0; j < newChild.length; j += 1) {
	          this[i].appendChild(newChild[j]);
	        }
	      } else {
	        this[i].appendChild(newChild);
	      }
	    }
	  }

	  return this;
	}

	function prepend(newChild) {
	  var document = getDocument();
	  var i;
	  var j;

	  for (i = 0; i < this.length; i += 1) {
	    if (typeof newChild === 'string') {
	      var tempDiv = document.createElement('div');
	      tempDiv.innerHTML = newChild;

	      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
	        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
	      }
	    } else if (newChild instanceof Dom7) {
	      for (j = 0; j < newChild.length; j += 1) {
	        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
	      }
	    } else {
	      this[i].insertBefore(newChild, this[i].childNodes[0]);
	    }
	  }

	  return this;
	}

	function next(selector) {
	  if (this.length > 0) {
	    if (selector) {
	      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
	        return $([this[0].nextElementSibling]);
	      }

	      return $([]);
	    }

	    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
	    return $([]);
	  }

	  return $([]);
	}

	function nextAll(selector) {
	  var nextEls = [];
	  var el = this[0];
	  if (!el) return $([]);

	  while (el.nextElementSibling) {
	    var _next = el.nextElementSibling; // eslint-disable-line

	    if (selector) {
	      if ($(_next).is(selector)) nextEls.push(_next);
	    } else nextEls.push(_next);

	    el = _next;
	  }

	  return $(nextEls);
	}

	function prev(selector) {
	  if (this.length > 0) {
	    var el = this[0];

	    if (selector) {
	      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
	        return $([el.previousElementSibling]);
	      }

	      return $([]);
	    }

	    if (el.previousElementSibling) return $([el.previousElementSibling]);
	    return $([]);
	  }

	  return $([]);
	}

	function prevAll(selector) {
	  var prevEls = [];
	  var el = this[0];
	  if (!el) return $([]);

	  while (el.previousElementSibling) {
	    var _prev = el.previousElementSibling; // eslint-disable-line

	    if (selector) {
	      if ($(_prev).is(selector)) prevEls.push(_prev);
	    } else prevEls.push(_prev);

	    el = _prev;
	  }

	  return $(prevEls);
	}

	function parent(selector) {
	  var parents = []; // eslint-disable-line

	  for (var i = 0; i < this.length; i += 1) {
	    if (this[i].parentNode !== null) {
	      if (selector) {
	        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
	      } else {
	        parents.push(this[i].parentNode);
	      }
	    }
	  }

	  return $(parents);
	}

	function parents(selector) {
	  var parents = []; // eslint-disable-line

	  for (var i = 0; i < this.length; i += 1) {
	    var _parent = this[i].parentNode; // eslint-disable-line

	    while (_parent) {
	      if (selector) {
	        if ($(_parent).is(selector)) parents.push(_parent);
	      } else {
	        parents.push(_parent);
	      }

	      _parent = _parent.parentNode;
	    }
	  }

	  return $(parents);
	}

	function closest(selector) {
	  var closest = this; // eslint-disable-line

	  if (typeof selector === 'undefined') {
	    return $([]);
	  }

	  if (!closest.is(selector)) {
	    closest = closest.parents(selector).eq(0);
	  }

	  return closest;
	}

	function find$1(selector) {
	  var foundElements = [];

	  for (var i = 0; i < this.length; i += 1) {
	    var found = this[i].querySelectorAll(selector);

	    for (var j = 0; j < found.length; j += 1) {
	      foundElements.push(found[j]);
	    }
	  }

	  return $(foundElements);
	}

	function children(selector) {
	  var children = []; // eslint-disable-line

	  for (var i = 0; i < this.length; i += 1) {
	    var childNodes = this[i].children;

	    for (var j = 0; j < childNodes.length; j += 1) {
	      if (!selector || $(childNodes[j]).is(selector)) {
	        children.push(childNodes[j]);
	      }
	    }
	  }

	  return $(children);
	}

	function remove$1() {
	  for (var i = 0; i < this.length; i += 1) {
	    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
	  }

	  return this;
	}

	var Methods = {
	  addClass: addClass,
	  removeClass: removeClass,
	  hasClass: hasClass,
	  toggleClass: toggleClass,
	  attr: attr,
	  removeAttr: removeAttr,
	  transform: transform$1,
	  transition: transition,
	  on: on,
	  off: off,
	  trigger: trigger$2,
	  transitionEnd: transitionEnd,
	  outerWidth: outerWidth,
	  outerHeight: outerHeight,
	  styles: styles,
	  offset: offset$2,
	  css: css,
	  each: each,
	  html: html,
	  text: text,
	  is: is,
	  index: index,
	  eq: eq,
	  append: append,
	  prepend: prepend,
	  next: next,
	  nextAll: nextAll,
	  prev: prev,
	  prevAll: prevAll,
	  parent: parent,
	  parents: parents,
	  closest: closest,
	  find: find$1,
	  children: children,
	  filter: filter,
	  remove: remove$1
	};
	Object.keys(Methods).forEach(function (methodName) {
	  $.fn[methodName] = Methods[methodName];
	});

	function deleteProps(obj) {
	  var object = obj;
	  Object.keys(object).forEach(function (key) {
	    try {
	      object[key] = null;
	    } catch (e) {// no getter for object
	    }

	    try {
	      delete object[key];
	    } catch (e) {// something got wrong
	    }
	  });
	}

	function nextTick$1(callback, delay) {
	  if (delay === void 0) {
	    delay = 0;
	  }

	  return setTimeout(callback, delay);
	}

	function now() {
	  return Date.now();
	}

	function getTranslate(el, axis) {
	  if (axis === void 0) {
	    axis = 'x';
	  }

	  var window = getWindow$1();
	  var matrix;
	  var curTransform;
	  var transformMatrix;
	  var curStyle = window.getComputedStyle(el, null);

	  if (window.WebKitCSSMatrix) {
	    curTransform = curStyle.transform || curStyle.webkitTransform;

	    if (curTransform.split(',').length > 6) {
	      curTransform = curTransform.split(', ').map(function (a) {
	        return a.replace(',', '.');
	      }).join(', ');
	    } // Some old versions of Webkit choke when 'none' is passed; pass
	    // empty string instead in this case


	    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	  } else {
	    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	    matrix = transformMatrix.toString().split(',');
	  }

	  if (axis === 'x') {
	    // Latest Chrome and webkits Fix
	    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
	    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
	      else curTransform = parseFloat(matrix[4]);
	  }

	  if (axis === 'y') {
	    // Latest Chrome and webkits Fix
	    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
	    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
	      else curTransform = parseFloat(matrix[5]);
	  }

	  return curTransform || 0;
	}

	function isObject$3(o) {
	  return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
	}

	function extend$2() {
	  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);

	  for (var i = 1; i < arguments.length; i += 1) {
	    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

	    if (nextSource !== undefined && nextSource !== null) {
	      var keysArray = Object.keys(Object(nextSource));

	      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	        var nextKey = keysArray[nextIndex];
	        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

	        if (desc !== undefined && desc.enumerable) {
	          if (isObject$3(to[nextKey]) && isObject$3(nextSource[nextKey])) {
	            extend$2(to[nextKey], nextSource[nextKey]);
	          } else if (!isObject$3(to[nextKey]) && isObject$3(nextSource[nextKey])) {
	            to[nextKey] = {};
	            extend$2(to[nextKey], nextSource[nextKey]);
	          } else {
	            to[nextKey] = nextSource[nextKey];
	          }
	        }
	      }
	    }
	  }

	  return to;
	}

	function bindModuleMethods(instance, obj) {
	  Object.keys(obj).forEach(function (key) {
	    if (isObject$3(obj[key])) {
	      Object.keys(obj[key]).forEach(function (subKey) {
	        if (typeof obj[key][subKey] === 'function') {
	          obj[key][subKey] = obj[key][subKey].bind(instance);
	        }
	      });
	    }

	    instance[key] = obj[key];
	  });
	}

	var support;

	function calcSupport() {
	  var window = getWindow$1();
	  var document = getDocument();
	  return {
	    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
	    pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
	    observer: function checkObserver() {
	      return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
	    }(),
	    passiveListener: function checkPassiveListener() {
	      var supportsPassive = false;

	      try {
	        var opts = Object.defineProperty({}, 'passive', {
	          // eslint-disable-next-line
	          get: function get() {
	            supportsPassive = true;
	          }
	        });
	        window.addEventListener('testPassiveListener', null, opts);
	      } catch (e) {// No support
	      }

	      return supportsPassive;
	    }(),
	    gestures: function checkGestures() {
	      return 'ongesturestart' in window;
	    }()
	  };
	}

	function getSupport() {
	  if (!support) {
	    support = calcSupport();
	  }

	  return support;
	}

	var device;

	function calcDevice(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      userAgent = _ref.userAgent;

	  var support = getSupport();
	  var window = getWindow$1();
	  var platform = window.navigator.platform;
	  var ua = userAgent || window.navigator.userAgent;
	  var device = {
	    ios: false,
	    android: false
	  };
	  var screenWidth = window.screen.width;
	  var screenHeight = window.screen.height;
	  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

	  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	  var windows = platform === 'Win32';
	  var macos = platform === 'MacIntel'; // iPadOs 13 fix

	  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

	  if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
	    ipad = ua.match(/(Version)\/([\d.]+)/);
	    if (!ipad) ipad = [0, 1, '13_0_0'];
	    macos = false;
	  } // Android


	  if (android && !windows) {
	    device.os = 'android';
	    device.android = true;
	  }

	  if (ipad || iphone || ipod) {
	    device.os = 'ios';
	    device.ios = true;
	  } // Export object


	  return device;
	}

	function getDevice(overrides) {
	  if (overrides === void 0) {
	    overrides = {};
	  }

	  if (!device) {
	    device = calcDevice(overrides);
	  }

	  return device;
	}

	var browser;

	function calcBrowser() {
	  var window = getWindow$1();

	  function isSafari() {
	    var ua = window.navigator.userAgent.toLowerCase();
	    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
	  }

	  return {
	    isEdge: !!window.navigator.userAgent.match(/Edge/g),
	    isSafari: isSafari(),
	    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
	  };
	}

	function getBrowser() {
	  if (!browser) {
	    browser = calcBrowser();
	  }

	  return browser;
	}

	var Resize = {
	  name: 'resize',
	  create: function create() {
	    var swiper = this;
	    extend$2(swiper, {
	      resize: {
	        resizeHandler: function resizeHandler() {
	          if (!swiper || swiper.destroyed || !swiper.initialized) return;
	          swiper.emit('beforeResize');
	          swiper.emit('resize');
	        },
	        orientationChangeHandler: function orientationChangeHandler() {
	          if (!swiper || swiper.destroyed || !swiper.initialized) return;
	          swiper.emit('orientationchange');
	        }
	      }
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      var window = getWindow$1(); // Emit resize

	      window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

	      window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	    },
	    destroy: function destroy(swiper) {
	      var window = getWindow$1();
	      window.removeEventListener('resize', swiper.resize.resizeHandler);
	      window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	    }
	  }
	};

	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	var Observer = {
	  attach: function attach(target, options) {
	    if (options === void 0) {
	      options = {};
	    }

	    var window = getWindow$1();
	    var swiper = this;
	    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
	    var observer = new ObserverFunc(function (mutations) {
	      // The observerUpdate event should only be triggered
	      // once despite the number of mutations.  Additional
	      // triggers are redundant and are very costly
	      if (mutations.length === 1) {
	        swiper.emit('observerUpdate', mutations[0]);
	        return;
	      }

	      var observerUpdate = function observerUpdate() {
	        swiper.emit('observerUpdate', mutations[0]);
	      };

	      if (window.requestAnimationFrame) {
	        window.requestAnimationFrame(observerUpdate);
	      } else {
	        window.setTimeout(observerUpdate, 0);
	      }
	    });
	    observer.observe(target, {
	      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	      childList: typeof options.childList === 'undefined' ? true : options.childList,
	      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
	    });
	    swiper.observer.observers.push(observer);
	  },
	  init: function init() {
	    var swiper = this;
	    if (!swiper.support.observer || !swiper.params.observer) return;

	    if (swiper.params.observeParents) {
	      var containerParents = swiper.$el.parents();

	      for (var i = 0; i < containerParents.length; i += 1) {
	        swiper.observer.attach(containerParents[i]);
	      }
	    } // Observe container


	    swiper.observer.attach(swiper.$el[0], {
	      childList: swiper.params.observeSlideChildren
	    }); // Observe wrapper

	    swiper.observer.attach(swiper.$wrapperEl[0], {
	      attributes: false
	    });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    swiper.observer.observers.forEach(function (observer) {
	      observer.disconnect();
	    });
	    swiper.observer.observers = [];
	  }
	};
	var Observer$1 = {
	  name: 'observer',
	  params: {
	    observer: false,
	    observeParents: false,
	    observeSlideChildren: false
	  },
	  create: function create() {
	    var swiper = this;
	    bindModuleMethods(swiper, {
	      observer: _extends({}, Observer, {
	        observers: []
	      })
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      swiper.observer.init();
	    },
	    destroy: function destroy(swiper) {
	      swiper.observer.destroy();
	    }
	  }
	};

	var modular = {
	  useParams: function useParams(instanceParams) {
	    var instance = this;
	    if (!instance.modules) return;
	    Object.keys(instance.modules).forEach(function (moduleName) {
	      var module = instance.modules[moduleName]; // Extend params

	      if (module.params) {
	        extend$2(instanceParams, module.params);
	      }
	    });
	  },
	  useModules: function useModules(modulesParams) {
	    if (modulesParams === void 0) {
	      modulesParams = {};
	    }

	    var instance = this;
	    if (!instance.modules) return;
	    Object.keys(instance.modules).forEach(function (moduleName) {
	      var module = instance.modules[moduleName];
	      var moduleParams = modulesParams[moduleName] || {}; // Add event listeners

	      if (module.on && instance.on) {
	        Object.keys(module.on).forEach(function (moduleEventName) {
	          instance.on(moduleEventName, module.on[moduleEventName]);
	        });
	      } // Module create callback


	      if (module.create) {
	        module.create.bind(instance)(moduleParams);
	      }
	    });
	  }
	};

	/* eslint-disable no-underscore-dangle */
	var eventsEmitter = {
	  on: function on(events, handler, priority) {
	    var self = this;
	    if (typeof handler !== 'function') return self;
	    var method = priority ? 'unshift' : 'push';
	    events.split(' ').forEach(function (event) {
	      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
	      self.eventsListeners[event][method](handler);
	    });
	    return self;
	  },
	  once: function once(events, handler, priority) {
	    var self = this;
	    if (typeof handler !== 'function') return self;

	    function onceHandler() {
	      self.off(events, onceHandler);

	      if (onceHandler.__emitterProxy) {
	        delete onceHandler.__emitterProxy;
	      }

	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }

	      handler.apply(self, args);
	    }

	    onceHandler.__emitterProxy = handler;
	    return self.on(events, onceHandler, priority);
	  },
	  onAny: function onAny(handler, priority) {
	    var self = this;
	    if (typeof handler !== 'function') return self;
	    var method = priority ? 'unshift' : 'push';

	    if (self.eventsAnyListeners.indexOf(handler) < 0) {
	      self.eventsAnyListeners[method](handler);
	    }

	    return self;
	  },
	  offAny: function offAny(handler) {
	    var self = this;
	    if (!self.eventsAnyListeners) return self;
	    var index = self.eventsAnyListeners.indexOf(handler);

	    if (index >= 0) {
	      self.eventsAnyListeners.splice(index, 1);
	    }

	    return self;
	  },
	  off: function off(events, handler) {
	    var self = this;
	    if (!self.eventsListeners) return self;
	    events.split(' ').forEach(function (event) {
	      if (typeof handler === 'undefined') {
	        self.eventsListeners[event] = [];
	      } else if (self.eventsListeners[event]) {
	        self.eventsListeners[event].forEach(function (eventHandler, index) {
	          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
	            self.eventsListeners[event].splice(index, 1);
	          }
	        });
	      }
	    });
	    return self;
	  },
	  emit: function emit() {
	    var self = this;
	    if (!self.eventsListeners) return self;
	    var events;
	    var data;
	    var context;

	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }

	    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
	      events = args[0];
	      data = args.slice(1, args.length);
	      context = self;
	    } else {
	      events = args[0].events;
	      data = args[0].data;
	      context = args[0].context || self;
	    }

	    data.unshift(context);
	    var eventsArray = Array.isArray(events) ? events : events.split(' ');
	    eventsArray.forEach(function (event) {
	      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
	        self.eventsAnyListeners.forEach(function (eventHandler) {
	          eventHandler.apply(context, [event].concat(data));
	        });
	      }

	      if (self.eventsListeners && self.eventsListeners[event]) {
	        self.eventsListeners[event].forEach(function (eventHandler) {
	          eventHandler.apply(context, data);
	        });
	      }
	    });
	    return self;
	  }
	};

	function updateSize() {
	  var swiper = this;
	  var width;
	  var height;
	  var $el = swiper.$el;

	  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
	    width = swiper.params.width;
	  } else {
	    width = $el[0].clientWidth;
	  }

	  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
	    height = swiper.params.height;
	  } else {
	    height = $el[0].clientHeight;
	  }

	  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
	    return;
	  } // Subtract paddings


	  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
	  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
	  if (Number.isNaN(width)) width = 0;
	  if (Number.isNaN(height)) height = 0;
	  extend$2(swiper, {
	    width: width,
	    height: height,
	    size: swiper.isHorizontal() ? width : height
	  });
	}

	function updateSlides() {
	  var swiper = this;
	  var window = getWindow$1();
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl,
	      swiperSize = swiper.size,
	      rtl = swiper.rtlTranslate,
	      wrongRTL = swiper.wrongRTL;
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
	  var slides = $wrapperEl.children("." + swiper.params.slideClass);
	  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
	  var snapGrid = [];
	  var slidesGrid = [];
	  var slidesSizesGrid = [];

	  function slidesForMargin(slideEl, slideIndex) {
	    if (!params.cssMode) return true;

	    if (slideIndex === slides.length - 1) {
	      return false;
	    }

	    return true;
	  }

	  var offsetBefore = params.slidesOffsetBefore;

	  if (typeof offsetBefore === 'function') {
	    offsetBefore = params.slidesOffsetBefore.call(swiper);
	  }

	  var offsetAfter = params.slidesOffsetAfter;

	  if (typeof offsetAfter === 'function') {
	    offsetAfter = params.slidesOffsetAfter.call(swiper);
	  }

	  var previousSnapGridLength = swiper.snapGrid.length;
	  var previousSlidesGridLength = swiper.slidesGrid.length;
	  var spaceBetween = params.spaceBetween;
	  var slidePosition = -offsetBefore;
	  var prevSlideSize = 0;
	  var index = 0;

	  if (typeof swiperSize === 'undefined') {
	    return;
	  }

	  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
	  }

	  swiper.virtualSize = -spaceBetween; // reset margins

	  if (rtl) slides.css({
	    marginLeft: '',
	    marginTop: ''
	  });else slides.css({
	    marginRight: '',
	    marginBottom: ''
	  });
	  var slidesNumberEvenToRows;

	  if (params.slidesPerColumn > 1) {
	    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
	      slidesNumberEvenToRows = slidesLength;
	    } else {
	      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
	    }

	    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
	      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
	    }
	  } // Calc slides


	  var slideSize;
	  var slidesPerColumn = params.slidesPerColumn;
	  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
	  var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

	  for (var i = 0; i < slidesLength; i += 1) {
	    slideSize = 0;
	    var slide = slides.eq(i);

	    if (params.slidesPerColumn > 1) {
	      // Set slides order
	      var newSlideOrderIndex = void 0;
	      var column = void 0;
	      var row = void 0;

	      if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
	        var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
	        var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
	        var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
	        row = Math.floor(slideIndexInGroup / columnsInGroup);
	        column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
	        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
	        slide.css({
	          '-webkit-box-ordinal-group': newSlideOrderIndex,
	          '-moz-box-ordinal-group': newSlideOrderIndex,
	          '-ms-flex-order': newSlideOrderIndex,
	          '-webkit-order': newSlideOrderIndex,
	          order: newSlideOrderIndex
	        });
	      } else if (params.slidesPerColumnFill === 'column') {
	        column = Math.floor(i / slidesPerColumn);
	        row = i - column * slidesPerColumn;

	        if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
	          row += 1;

	          if (row >= slidesPerColumn) {
	            row = 0;
	            column += 1;
	          }
	        }
	      } else {
	        row = Math.floor(i / slidesPerRow);
	        column = i - row * slidesPerRow;
	      }

	      slide.css("margin-" + (swiper.isHorizontal() ? 'top' : 'left'), row !== 0 && params.spaceBetween && params.spaceBetween + "px");
	    }

	    if (slide.css('display') === 'none') continue; // eslint-disable-line

	    if (params.slidesPerView === 'auto') {
	      var slideStyles = window.getComputedStyle(slide[0], null);
	      var currentTransform = slide[0].style.transform;
	      var currentWebKitTransform = slide[0].style.webkitTransform;

	      if (currentTransform) {
	        slide[0].style.transform = 'none';
	      }

	      if (currentWebKitTransform) {
	        slide[0].style.webkitTransform = 'none';
	      }

	      if (params.roundLengths) {
	        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
	      } else {
	        // eslint-disable-next-line
	        if (swiper.isHorizontal()) {
	          var width = parseFloat(slideStyles.getPropertyValue('width') || 0);
	          var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left') || 0);
	          var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right') || 0);
	          var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left') || 0);
	          var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right') || 0);
	          var boxSizing = slideStyles.getPropertyValue('box-sizing');

	          if (boxSizing && boxSizing === 'border-box') {
	            slideSize = width + marginLeft + marginRight;
	          } else {
	            var _slide$ = slide[0],
	                clientWidth = _slide$.clientWidth,
	                offsetWidth = _slide$.offsetWidth;
	            slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
	          }
	        } else {
	          var height = parseFloat(slideStyles.getPropertyValue('height') || 0);
	          var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top') || 0);
	          var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom') || 0);
	          var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top') || 0);
	          var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom') || 0);

	          var _boxSizing = slideStyles.getPropertyValue('box-sizing');

	          if (_boxSizing && _boxSizing === 'border-box') {
	            slideSize = height + marginTop + marginBottom;
	          } else {
	            var _slide$2 = slide[0],
	                clientHeight = _slide$2.clientHeight,
	                offsetHeight = _slide$2.offsetHeight;
	            slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom + (offsetHeight - clientHeight);
	          }
	        }
	      }

	      if (currentTransform) {
	        slide[0].style.transform = currentTransform;
	      }

	      if (currentWebKitTransform) {
	        slide[0].style.webkitTransform = currentWebKitTransform;
	      }

	      if (params.roundLengths) slideSize = Math.floor(slideSize);
	    } else {
	      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
	      if (params.roundLengths) slideSize = Math.floor(slideSize);

	      if (slides[i]) {
	        if (swiper.isHorizontal()) {
	          slides[i].style.width = slideSize + "px";
	        } else {
	          slides[i].style.height = slideSize + "px";
	        }
	      }
	    }

	    if (slides[i]) {
	      slides[i].swiperSlideSize = slideSize;
	    }

	    slidesSizesGrid.push(slideSize);

	    if (params.centeredSlides) {
	      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
	      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
	      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
	      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
	      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
	      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
	      slidesGrid.push(slidePosition);
	    } else {
	      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
	      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
	      slidesGrid.push(slidePosition);
	      slidePosition = slidePosition + slideSize + spaceBetween;
	    }

	    swiper.virtualSize += slideSize + spaceBetween;
	    prevSlideSize = slideSize;
	    index += 1;
	  }

	  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
	  var newSlidesGrid;

	  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
	    $wrapperEl.css({
	      width: swiper.virtualSize + params.spaceBetween + "px"
	    });
	  }

	  if (params.setWrapperSize) {
	    if (swiper.isHorizontal()) $wrapperEl.css({
	      width: swiper.virtualSize + params.spaceBetween + "px"
	    });else $wrapperEl.css({
	      height: swiper.virtualSize + params.spaceBetween + "px"
	    });
	  }

	  if (params.slidesPerColumn > 1) {
	    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
	    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
	    if (swiper.isHorizontal()) $wrapperEl.css({
	      width: swiper.virtualSize + params.spaceBetween + "px"
	    });else $wrapperEl.css({
	      height: swiper.virtualSize + params.spaceBetween + "px"
	    });

	    if (params.centeredSlides) {
	      newSlidesGrid = [];

	      for (var _i = 0; _i < snapGrid.length; _i += 1) {
	        var slidesGridItem = snapGrid[_i];
	        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
	        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
	      }

	      snapGrid = newSlidesGrid;
	    }
	  } // Remove last grid elements depending on width


	  if (!params.centeredSlides) {
	    newSlidesGrid = [];

	    for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
	      var _slidesGridItem = snapGrid[_i2];
	      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);

	      if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
	        newSlidesGrid.push(_slidesGridItem);
	      }
	    }

	    snapGrid = newSlidesGrid;

	    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
	      snapGrid.push(swiper.virtualSize - swiperSize);
	    }
	  }

	  if (snapGrid.length === 0) snapGrid = [0];

	  if (params.spaceBetween !== 0) {
	    if (swiper.isHorizontal()) {
	      if (rtl) slides.filter(slidesForMargin).css({
	        marginLeft: spaceBetween + "px"
	      });else slides.filter(slidesForMargin).css({
	        marginRight: spaceBetween + "px"
	      });
	    } else slides.filter(slidesForMargin).css({
	      marginBottom: spaceBetween + "px"
	    });
	  }

	  if (params.centeredSlides && params.centeredSlidesBounds) {
	    var allSlidesSize = 0;
	    slidesSizesGrid.forEach(function (slideSizeValue) {
	      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
	    });
	    allSlidesSize -= params.spaceBetween;
	    var maxSnap = allSlidesSize - swiperSize;
	    snapGrid = snapGrid.map(function (snap) {
	      if (snap < 0) return -offsetBefore;
	      if (snap > maxSnap) return maxSnap + offsetAfter;
	      return snap;
	    });
	  }

	  if (params.centerInsufficientSlides) {
	    var _allSlidesSize = 0;
	    slidesSizesGrid.forEach(function (slideSizeValue) {
	      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
	    });
	    _allSlidesSize -= params.spaceBetween;

	    if (_allSlidesSize < swiperSize) {
	      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
	      snapGrid.forEach(function (snap, snapIndex) {
	        snapGrid[snapIndex] = snap - allSlidesOffset;
	      });
	      slidesGrid.forEach(function (snap, snapIndex) {
	        slidesGrid[snapIndex] = snap + allSlidesOffset;
	      });
	    }
	  }

	  extend$2(swiper, {
	    slides: slides,
	    snapGrid: snapGrid,
	    slidesGrid: slidesGrid,
	    slidesSizesGrid: slidesSizesGrid
	  });

	  if (slidesLength !== previousSlidesLength) {
	    swiper.emit('slidesLengthChange');
	  }

	  if (snapGrid.length !== previousSnapGridLength) {
	    if (swiper.params.watchOverflow) swiper.checkOverflow();
	    swiper.emit('snapGridLengthChange');
	  }

	  if (slidesGrid.length !== previousSlidesGridLength) {
	    swiper.emit('slidesGridLengthChange');
	  }

	  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
	    swiper.updateSlidesOffset();
	  }
	}

	function updateAutoHeight(speed) {
	  var swiper = this;
	  var activeSlides = [];
	  var newHeight = 0;
	  var i;

	  if (typeof speed === 'number') {
	    swiper.setTransition(speed);
	  } else if (speed === true) {
	    swiper.setTransition(swiper.params.speed);
	  } // Find slides currently in view


	  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
	    if (swiper.params.centeredSlides) {
	      swiper.visibleSlides.each(function (slide) {
	        activeSlides.push(slide);
	      });
	    } else {
	      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
	        var index = swiper.activeIndex + i;
	        if (index > swiper.slides.length) break;
	        activeSlides.push(swiper.slides.eq(index)[0]);
	      }
	    }
	  } else {
	    activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
	  } // Find new height from highest slide in view


	  for (i = 0; i < activeSlides.length; i += 1) {
	    if (typeof activeSlides[i] !== 'undefined') {
	      var height = activeSlides[i].offsetHeight;
	      newHeight = height > newHeight ? height : newHeight;
	    }
	  } // Update Height


	  if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
	}

	function updateSlidesOffset() {
	  var swiper = this;
	  var slides = swiper.slides;

	  for (var i = 0; i < slides.length; i += 1) {
	    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
	  }
	}

	function updateSlidesProgress(translate) {
	  if (translate === void 0) {
	    translate = this && this.translate || 0;
	  }

	  var swiper = this;
	  var params = swiper.params;
	  var slides = swiper.slides,
	      rtl = swiper.rtlTranslate;
	  if (slides.length === 0) return;
	  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
	  var offsetCenter = -translate;
	  if (rtl) offsetCenter = translate; // Visible Slides

	  slides.removeClass(params.slideVisibleClass);
	  swiper.visibleSlidesIndexes = [];
	  swiper.visibleSlides = [];

	  for (var i = 0; i < slides.length; i += 1) {
	    var slide = slides[i];
	    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);

	    if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
	      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
	      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
	      var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

	      if (isVisible) {
	        swiper.visibleSlides.push(slide);
	        swiper.visibleSlidesIndexes.push(i);
	        slides.eq(i).addClass(params.slideVisibleClass);
	      }
	    }

	    slide.progress = rtl ? -slideProgress : slideProgress;
	  }

	  swiper.visibleSlides = $(swiper.visibleSlides);
	}

	function updateProgress(translate) {
	  var swiper = this;

	  if (typeof translate === 'undefined') {
	    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

	    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
	  }

	  var params = swiper.params;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  var progress = swiper.progress,
	      isBeginning = swiper.isBeginning,
	      isEnd = swiper.isEnd;
	  var wasBeginning = isBeginning;
	  var wasEnd = isEnd;

	  if (translatesDiff === 0) {
	    progress = 0;
	    isBeginning = true;
	    isEnd = true;
	  } else {
	    progress = (translate - swiper.minTranslate()) / translatesDiff;
	    isBeginning = progress <= 0;
	    isEnd = progress >= 1;
	  }

	  extend$2(swiper, {
	    progress: progress,
	    isBeginning: isBeginning,
	    isEnd: isEnd
	  });
	  if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

	  if (isBeginning && !wasBeginning) {
	    swiper.emit('reachBeginning toEdge');
	  }

	  if (isEnd && !wasEnd) {
	    swiper.emit('reachEnd toEdge');
	  }

	  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
	    swiper.emit('fromEdge');
	  }

	  swiper.emit('progress', progress);
	}

	function updateSlidesClasses() {
	  var swiper = this;
	  var slides = swiper.slides,
	      params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl,
	      activeIndex = swiper.activeIndex,
	      realIndex = swiper.realIndex;
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	  slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
	  var activeSlide;

	  if (isVirtual) {
	    activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
	  } else {
	    activeSlide = slides.eq(activeIndex);
	  } // Active classes


	  activeSlide.addClass(params.slideActiveClass);

	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (activeSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
	    } else {
	      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
	    }
	  } // Next Slide


	  var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);

	  if (params.loop && nextSlide.length === 0) {
	    nextSlide = slides.eq(0);
	    nextSlide.addClass(params.slideNextClass);
	  } // Prev Slide


	  var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);

	  if (params.loop && prevSlide.length === 0) {
	    prevSlide = slides.eq(-1);
	    prevSlide.addClass(params.slidePrevClass);
	  }

	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (nextSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
	    } else {
	      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
	    }

	    if (prevSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
	    } else {
	      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
	    }
	  }

	  swiper.emitSlidesClasses();
	}

	function updateActiveIndex(newActiveIndex) {
	  var swiper = this;
	  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	  var slidesGrid = swiper.slidesGrid,
	      snapGrid = swiper.snapGrid,
	      params = swiper.params,
	      previousIndex = swiper.activeIndex,
	      previousRealIndex = swiper.realIndex,
	      previousSnapIndex = swiper.snapIndex;
	  var activeIndex = newActiveIndex;
	  var snapIndex;

	  if (typeof activeIndex === 'undefined') {
	    for (var i = 0; i < slidesGrid.length; i += 1) {
	      if (typeof slidesGrid[i + 1] !== 'undefined') {
	        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
	          activeIndex = i;
	        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
	          activeIndex = i + 1;
	        }
	      } else if (translate >= slidesGrid[i]) {
	        activeIndex = i;
	      }
	    } // Normalize slideIndex


	    if (params.normalizeSlideIndex) {
	      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
	    }
	  }

	  if (snapGrid.indexOf(translate) >= 0) {
	    snapIndex = snapGrid.indexOf(translate);
	  } else {
	    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
	    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
	  }

	  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

	  if (activeIndex === previousIndex) {
	    if (snapIndex !== previousSnapIndex) {
	      swiper.snapIndex = snapIndex;
	      swiper.emit('snapIndexChange');
	    }

	    return;
	  } // Get real index


	  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
	  extend$2(swiper, {
	    snapIndex: snapIndex,
	    realIndex: realIndex,
	    previousIndex: previousIndex,
	    activeIndex: activeIndex
	  });
	  swiper.emit('activeIndexChange');
	  swiper.emit('snapIndexChange');

	  if (previousRealIndex !== realIndex) {
	    swiper.emit('realIndexChange');
	  }

	  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
	    swiper.emit('slideChange');
	  }
	}

	function updateClickedSlide(e) {
	  var swiper = this;
	  var params = swiper.params;
	  var slide = $(e.target).closest("." + params.slideClass)[0];
	  var slideFound = false;

	  if (slide) {
	    for (var i = 0; i < swiper.slides.length; i += 1) {
	      if (swiper.slides[i] === slide) slideFound = true;
	    }
	  }

	  if (slide && slideFound) {
	    swiper.clickedSlide = slide;

	    if (swiper.virtual && swiper.params.virtual.enabled) {
	      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
	    } else {
	      swiper.clickedIndex = $(slide).index();
	    }
	  } else {
	    swiper.clickedSlide = undefined;
	    swiper.clickedIndex = undefined;
	    return;
	  }

	  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
	    swiper.slideToClickedSlide();
	  }
	}

	var update$1 = {
	  updateSize: updateSize,
	  updateSlides: updateSlides,
	  updateAutoHeight: updateAutoHeight,
	  updateSlidesOffset: updateSlidesOffset,
	  updateSlidesProgress: updateSlidesProgress,
	  updateProgress: updateProgress,
	  updateSlidesClasses: updateSlidesClasses,
	  updateActiveIndex: updateActiveIndex,
	  updateClickedSlide: updateClickedSlide
	};

	function getSwiperTranslate(axis) {
	  if (axis === void 0) {
	    axis = this.isHorizontal() ? 'x' : 'y';
	  }

	  var swiper = this;
	  var params = swiper.params,
	      rtl = swiper.rtlTranslate,
	      translate = swiper.translate,
	      $wrapperEl = swiper.$wrapperEl;

	  if (params.virtualTranslate) {
	    return rtl ? -translate : translate;
	  }

	  if (params.cssMode) {
	    return translate;
	  }

	  var currentTranslate = getTranslate($wrapperEl[0], axis);
	  if (rtl) currentTranslate = -currentTranslate;
	  return currentTranslate || 0;
	}

	function setTranslate(translate, byController) {
	  var swiper = this;
	  var rtl = swiper.rtlTranslate,
	      params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl,
	      wrapperEl = swiper.wrapperEl,
	      progress = swiper.progress;
	  var x = 0;
	  var y = 0;
	  var z = 0;

	  if (swiper.isHorizontal()) {
	    x = rtl ? -translate : translate;
	  } else {
	    y = translate;
	  }

	  if (params.roundLengths) {
	    x = Math.floor(x);
	    y = Math.floor(y);
	  }

	  if (params.cssMode) {
	    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
	  } else if (!params.virtualTranslate) {
	    $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
	  }

	  swiper.previousTranslate = swiper.translate;
	  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

	  var newProgress;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
	  }

	  if (newProgress !== progress) {
	    swiper.updateProgress(translate);
	  }

	  swiper.emit('setTranslate', swiper.translate, byController);
	}

	function minTranslate() {
	  return -this.snapGrid[0];
	}

	function maxTranslate() {
	  return -this.snapGrid[this.snapGrid.length - 1];
	}

	function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
	  if (translate === void 0) {
	    translate = 0;
	  }

	  if (speed === void 0) {
	    speed = this.params.speed;
	  }

	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  if (translateBounds === void 0) {
	    translateBounds = true;
	  }

	  var swiper = this;
	  var params = swiper.params,
	      wrapperEl = swiper.wrapperEl;

	  if (swiper.animating && params.preventInteractionOnTransition) {
	    return false;
	  }

	  var minTranslate = swiper.minTranslate();
	  var maxTranslate = swiper.maxTranslate();
	  var newTranslate;
	  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

	  swiper.updateProgress(newTranslate);

	  if (params.cssMode) {
	    var isH = swiper.isHorizontal();

	    if (speed === 0) {
	      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
	    } else {
	      // eslint-disable-next-line
	      if (wrapperEl.scrollTo) {
	        var _wrapperEl$scrollTo;

	        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
	      } else {
	        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
	      }
	    }

	    return true;
	  }

	  if (speed === 0) {
	    swiper.setTransition(0);
	    swiper.setTranslate(newTranslate);

	    if (runCallbacks) {
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.emit('transitionEnd');
	    }
	  } else {
	    swiper.setTransition(speed);
	    swiper.setTranslate(newTranslate);

	    if (runCallbacks) {
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.emit('transitionStart');
	    }

	    if (!swiper.animating) {
	      swiper.animating = true;

	      if (!swiper.onTranslateToWrapperTransitionEnd) {
	        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
	          if (!swiper || swiper.destroyed) return;
	          if (e.target !== this) return;
	          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
	          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
	          swiper.onTranslateToWrapperTransitionEnd = null;
	          delete swiper.onTranslateToWrapperTransitionEnd;

	          if (runCallbacks) {
	            swiper.emit('transitionEnd');
	          }
	        };
	      }

	      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
	      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
	    }
	  }

	  return true;
	}

	var translate = {
	  getTranslate: getSwiperTranslate,
	  setTranslate: setTranslate,
	  minTranslate: minTranslate,
	  maxTranslate: maxTranslate,
	  translateTo: translateTo
	};

	function setTransition(duration, byController) {
	  var swiper = this;

	  if (!swiper.params.cssMode) {
	    swiper.$wrapperEl.transition(duration);
	  }

	  swiper.emit('setTransition', duration, byController);
	}

	function transitionStart(runCallbacks, direction) {
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  var swiper = this;
	  var activeIndex = swiper.activeIndex,
	      params = swiper.params,
	      previousIndex = swiper.previousIndex;
	  if (params.cssMode) return;

	  if (params.autoHeight) {
	    swiper.updateAutoHeight();
	  }

	  var dir = direction;

	  if (!dir) {
	    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
	  }

	  swiper.emit('transitionStart');

	  if (runCallbacks && activeIndex !== previousIndex) {
	    if (dir === 'reset') {
	      swiper.emit('slideResetTransitionStart');
	      return;
	    }

	    swiper.emit('slideChangeTransitionStart');

	    if (dir === 'next') {
	      swiper.emit('slideNextTransitionStart');
	    } else {
	      swiper.emit('slidePrevTransitionStart');
	    }
	  }
	}

	function transitionEnd$1(runCallbacks, direction) {
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  var swiper = this;
	  var activeIndex = swiper.activeIndex,
	      previousIndex = swiper.previousIndex,
	      params = swiper.params;
	  swiper.animating = false;
	  if (params.cssMode) return;
	  swiper.setTransition(0);
	  var dir = direction;

	  if (!dir) {
	    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
	  }

	  swiper.emit('transitionEnd');

	  if (runCallbacks && activeIndex !== previousIndex) {
	    if (dir === 'reset') {
	      swiper.emit('slideResetTransitionEnd');
	      return;
	    }

	    swiper.emit('slideChangeTransitionEnd');

	    if (dir === 'next') {
	      swiper.emit('slideNextTransitionEnd');
	    } else {
	      swiper.emit('slidePrevTransitionEnd');
	    }
	  }
	}

	var transition$1 = {
	  setTransition: setTransition,
	  transitionStart: transitionStart,
	  transitionEnd: transitionEnd$1
	};

	function slideTo(index, speed, runCallbacks, internal) {
	  if (index === void 0) {
	    index = 0;
	  }

	  if (speed === void 0) {
	    speed = this.params.speed;
	  }

	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  if (typeof index !== 'number' && typeof index !== 'string') {
	    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
	  }

	  if (typeof index === 'string') {
	    /**
	     * The `index` argument converted from `string` to `number`.
	     * @type {number}
	     */
	    var indexAsNumber = parseInt(index, 10);
	    /**
	     * Determines whether the `index` argument is a valid `number`
	     * after being converted from the `string` type.
	     * @type {boolean}
	     */

	    var isValidNumber = isFinite(indexAsNumber);

	    if (!isValidNumber) {
	      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
	    } // Knowing that the converted `index` is a valid number,
	    // we can update the original argument's value.


	    index = indexAsNumber;
	  }

	  var swiper = this;
	  var slideIndex = index;
	  if (slideIndex < 0) slideIndex = 0;
	  var params = swiper.params,
	      snapGrid = swiper.snapGrid,
	      slidesGrid = swiper.slidesGrid,
	      previousIndex = swiper.previousIndex,
	      activeIndex = swiper.activeIndex,
	      rtl = swiper.rtlTranslate,
	      wrapperEl = swiper.wrapperEl;

	  if (swiper.animating && params.preventInteractionOnTransition) {
	    return false;
	  }

	  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
	  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
	  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

	  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
	    swiper.emit('beforeSlideChangeStart');
	  }

	  var translate = -snapGrid[snapIndex]; // Update progress

	  swiper.updateProgress(translate); // Normalize slideIndex

	  if (params.normalizeSlideIndex) {
	    for (var i = 0; i < slidesGrid.length; i += 1) {
	      if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
	        slideIndex = i;
	      }
	    }
	  } // Directions locks


	  if (swiper.initialized && slideIndex !== activeIndex) {
	    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
	      return false;
	    }

	    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
	      if ((activeIndex || 0) !== slideIndex) return false;
	    }
	  }

	  var direction;
	  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

	  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
	    swiper.updateActiveIndex(slideIndex); // Update Height

	    if (params.autoHeight) {
	      swiper.updateAutoHeight();
	    }

	    swiper.updateSlidesClasses();

	    if (params.effect !== 'slide') {
	      swiper.setTranslate(translate);
	    }

	    if (direction !== 'reset') {
	      swiper.transitionStart(runCallbacks, direction);
	      swiper.transitionEnd(runCallbacks, direction);
	    }

	    return false;
	  }

	  if (params.cssMode) {
	    var isH = swiper.isHorizontal();
	    var t = -translate;

	    if (rtl) {
	      t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
	    }

	    if (speed === 0) {
	      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
	    } else {
	      // eslint-disable-next-line
	      if (wrapperEl.scrollTo) {
	        var _wrapperEl$scrollTo;

	        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
	      } else {
	        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
	      }
	    }

	    return true;
	  }

	  if (speed === 0) {
	    swiper.setTransition(0);
	    swiper.setTranslate(translate);
	    swiper.updateActiveIndex(slideIndex);
	    swiper.updateSlidesClasses();
	    swiper.emit('beforeTransitionStart', speed, internal);
	    swiper.transitionStart(runCallbacks, direction);
	    swiper.transitionEnd(runCallbacks, direction);
	  } else {
	    swiper.setTransition(speed);
	    swiper.setTranslate(translate);
	    swiper.updateActiveIndex(slideIndex);
	    swiper.updateSlidesClasses();
	    swiper.emit('beforeTransitionStart', speed, internal);
	    swiper.transitionStart(runCallbacks, direction);

	    if (!swiper.animating) {
	      swiper.animating = true;

	      if (!swiper.onSlideToWrapperTransitionEnd) {
	        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
	          if (!swiper || swiper.destroyed) return;
	          if (e.target !== this) return;
	          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	          swiper.onSlideToWrapperTransitionEnd = null;
	          delete swiper.onSlideToWrapperTransitionEnd;
	          swiper.transitionEnd(runCallbacks, direction);
	        };
	      }

	      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	    }
	  }

	  return true;
	}

	function slideToLoop(index, speed, runCallbacks, internal) {
	  if (index === void 0) {
	    index = 0;
	  }

	  if (speed === void 0) {
	    speed = this.params.speed;
	  }

	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  var swiper = this;
	  var newIndex = index;

	  if (swiper.params.loop) {
	    newIndex += swiper.loopedSlides;
	  }

	  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideNext(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }

	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  var swiper = this;
	  var params = swiper.params,
	      animating = swiper.animating;
	  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;

	  if (params.loop) {
	    if (animating && params.loopPreventsSlide) return false;
	    swiper.loopFix(); // eslint-disable-next-line

	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	  }

	  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slidePrev(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }

	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  var swiper = this;
	  var params = swiper.params,
	      animating = swiper.animating,
	      snapGrid = swiper.snapGrid,
	      slidesGrid = swiper.slidesGrid,
	      rtlTranslate = swiper.rtlTranslate;

	  if (params.loop) {
	    if (animating && params.loopPreventsSlide) return false;
	    swiper.loopFix(); // eslint-disable-next-line

	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	  }

	  var translate = rtlTranslate ? swiper.translate : -swiper.translate;

	  function normalize(val) {
	    if (val < 0) return -Math.floor(Math.abs(val));
	    return Math.floor(val);
	  }

	  var normalizedTranslate = normalize(translate);
	  var normalizedSnapGrid = snapGrid.map(function (val) {
	    return normalize(val);
	  });
	  var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
	  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

	  if (typeof prevSnap === 'undefined' && params.cssMode) {
	    snapGrid.forEach(function (snap) {
	      if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
	    });
	  }

	  var prevIndex;

	  if (typeof prevSnap !== 'undefined') {
	    prevIndex = slidesGrid.indexOf(prevSnap);
	    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
	  }

	  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideReset(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }

	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  var swiper = this;
	  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideToClosest(speed, runCallbacks, internal, threshold) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }

	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  if (threshold === void 0) {
	    threshold = 0.5;
	  }

	  var swiper = this;
	  var index = swiper.activeIndex;
	  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
	  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
	  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

	  if (translate >= swiper.snapGrid[snapIndex]) {
	    // The current translate is on or after the current snap index, so the choice
	    // is between the current index and the one after it.
	    var currentSnap = swiper.snapGrid[snapIndex];
	    var nextSnap = swiper.snapGrid[snapIndex + 1];

	    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
	      index += swiper.params.slidesPerGroup;
	    }
	  } else {
	    // The current translate is before the current snap index, so the choice
	    // is between the current index and the one before it.
	    var prevSnap = swiper.snapGrid[snapIndex - 1];
	    var _currentSnap = swiper.snapGrid[snapIndex];

	    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
	      index -= swiper.params.slidesPerGroup;
	    }
	  }

	  index = Math.max(index, 0);
	  index = Math.min(index, swiper.slidesGrid.length - 1);
	  return swiper.slideTo(index, speed, runCallbacks, internal);
	}

	function slideToClickedSlide() {
	  var swiper = this;
	  var params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl;
	  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
	  var slideToIndex = swiper.clickedIndex;
	  var realIndex;

	  if (params.loop) {
	    if (swiper.animating) return;
	    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

	    if (params.centeredSlides) {
	      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
	        swiper.loopFix();
	        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
	        nextTick$1(function () {
	          swiper.slideTo(slideToIndex);
	        });
	      } else {
	        swiper.slideTo(slideToIndex);
	      }
	    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
	      swiper.loopFix();
	      slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
	      nextTick$1(function () {
	        swiper.slideTo(slideToIndex);
	      });
	    } else {
	      swiper.slideTo(slideToIndex);
	    }
	  } else {
	    swiper.slideTo(slideToIndex);
	  }
	}

	var slide = {
	  slideTo: slideTo,
	  slideToLoop: slideToLoop,
	  slideNext: slideNext,
	  slidePrev: slidePrev,
	  slideReset: slideReset,
	  slideToClosest: slideToClosest,
	  slideToClickedSlide: slideToClickedSlide
	};

	function loopCreate() {
	  var swiper = this;
	  var document = getDocument();
	  var params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

	  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
	  var slides = $wrapperEl.children("." + params.slideClass);

	  if (params.loopFillGroupWithBlank) {
	    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

	    if (blankSlidesNum !== params.slidesPerGroup) {
	      for (var i = 0; i < blankSlidesNum; i += 1) {
	        var blankNode = $(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
	        $wrapperEl.append(blankNode);
	      }

	      slides = $wrapperEl.children("." + params.slideClass);
	    }
	  }

	  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
	  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
	  swiper.loopedSlides += params.loopAdditionalSlides;

	  if (swiper.loopedSlides > slides.length) {
	    swiper.loopedSlides = slides.length;
	  }

	  var prependSlides = [];
	  var appendSlides = [];
	  slides.each(function (el, index) {
	    var slide = $(el);

	    if (index < swiper.loopedSlides) {
	      appendSlides.push(el);
	    }

	    if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
	      prependSlides.push(el);
	    }

	    slide.attr('data-swiper-slide-index', index);
	  });

	  for (var _i = 0; _i < appendSlides.length; _i += 1) {
	    $wrapperEl.append($(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }

	  for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
	    $wrapperEl.prepend($(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	}

	function loopFix() {
	  var swiper = this;
	  swiper.emit('beforeLoopFix');
	  var activeIndex = swiper.activeIndex,
	      slides = swiper.slides,
	      loopedSlides = swiper.loopedSlides,
	      allowSlidePrev = swiper.allowSlidePrev,
	      allowSlideNext = swiper.allowSlideNext,
	      snapGrid = swiper.snapGrid,
	      rtl = swiper.rtlTranslate;
	  var newIndex;
	  swiper.allowSlidePrev = true;
	  swiper.allowSlideNext = true;
	  var snapTranslate = -snapGrid[activeIndex];
	  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

	  if (activeIndex < loopedSlides) {
	    newIndex = slides.length - loopedSlides * 3 + activeIndex;
	    newIndex += loopedSlides;
	    var slideChanged = swiper.slideTo(newIndex, 0, false, true);

	    if (slideChanged && diff !== 0) {
	      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	    }
	  } else if (activeIndex >= slides.length - loopedSlides) {
	    // Fix For Positive Oversliding
	    newIndex = -slides.length + activeIndex + loopedSlides;
	    newIndex += loopedSlides;

	    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

	    if (_slideChanged && diff !== 0) {
	      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	    }
	  }

	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	  swiper.emit('loopFix');
	}

	function loopDestroy() {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl,
	      params = swiper.params,
	      slides = swiper.slides;
	  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
	  slides.removeAttr('data-swiper-slide-index');
	}

	var loop = {
	  loopCreate: loopCreate,
	  loopFix: loopFix,
	  loopDestroy: loopDestroy
	};

	function setGrabCursor(moving) {
	  var swiper = this;
	  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
	  var el = swiper.el;
	  el.style.cursor = 'move';
	  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
	  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
	  el.style.cursor = moving ? 'grabbing' : 'grab';
	}

	function unsetGrabCursor() {
	  var swiper = this;

	  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
	    return;
	  }

	  swiper.el.style.cursor = '';
	}

	var grabCursor = {
	  setGrabCursor: setGrabCursor,
	  unsetGrabCursor: unsetGrabCursor
	};

	function appendSlide(slides) {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl,
	      params = swiper.params;

	  if (params.loop) {
	    swiper.loopDestroy();
	  }

	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var i = 0; i < slides.length; i += 1) {
	      if (slides[i]) $wrapperEl.append(slides[i]);
	    }
	  } else {
	    $wrapperEl.append(slides);
	  }

	  if (params.loop) {
	    swiper.loopCreate();
	  }

	  if (!(params.observer && swiper.support.observer)) {
	    swiper.update();
	  }
	}

	function prependSlide(slides) {
	  var swiper = this;
	  var params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl,
	      activeIndex = swiper.activeIndex;

	  if (params.loop) {
	    swiper.loopDestroy();
	  }

	  var newActiveIndex = activeIndex + 1;

	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var i = 0; i < slides.length; i += 1) {
	      if (slides[i]) $wrapperEl.prepend(slides[i]);
	    }

	    newActiveIndex = activeIndex + slides.length;
	  } else {
	    $wrapperEl.prepend(slides);
	  }

	  if (params.loop) {
	    swiper.loopCreate();
	  }

	  if (!(params.observer && swiper.support.observer)) {
	    swiper.update();
	  }

	  swiper.slideTo(newActiveIndex, 0, false);
	}

	function addSlide(index, slides) {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl,
	      params = swiper.params,
	      activeIndex = swiper.activeIndex;
	  var activeIndexBuffer = activeIndex;

	  if (params.loop) {
	    activeIndexBuffer -= swiper.loopedSlides;
	    swiper.loopDestroy();
	    swiper.slides = $wrapperEl.children("." + params.slideClass);
	  }

	  var baseLength = swiper.slides.length;

	  if (index <= 0) {
	    swiper.prependSlide(slides);
	    return;
	  }

	  if (index >= baseLength) {
	    swiper.appendSlide(slides);
	    return;
	  }

	  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
	  var slidesBuffer = [];

	  for (var i = baseLength - 1; i >= index; i -= 1) {
	    var currentSlide = swiper.slides.eq(i);
	    currentSlide.remove();
	    slidesBuffer.unshift(currentSlide);
	  }

	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var _i = 0; _i < slides.length; _i += 1) {
	      if (slides[_i]) $wrapperEl.append(slides[_i]);
	    }

	    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
	  } else {
	    $wrapperEl.append(slides);
	  }

	  for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
	    $wrapperEl.append(slidesBuffer[_i2]);
	  }

	  if (params.loop) {
	    swiper.loopCreate();
	  }

	  if (!(params.observer && swiper.support.observer)) {
	    swiper.update();
	  }

	  if (params.loop) {
	    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	  } else {
	    swiper.slideTo(newActiveIndex, 0, false);
	  }
	}

	function removeSlide(slidesIndexes) {
	  var swiper = this;
	  var params = swiper.params,
	      $wrapperEl = swiper.$wrapperEl,
	      activeIndex = swiper.activeIndex;
	  var activeIndexBuffer = activeIndex;

	  if (params.loop) {
	    activeIndexBuffer -= swiper.loopedSlides;
	    swiper.loopDestroy();
	    swiper.slides = $wrapperEl.children("." + params.slideClass);
	  }

	  var newActiveIndex = activeIndexBuffer;
	  var indexToRemove;

	  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
	    for (var i = 0; i < slidesIndexes.length; i += 1) {
	      indexToRemove = slidesIndexes[i];
	      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
	      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
	    }

	    newActiveIndex = Math.max(newActiveIndex, 0);
	  } else {
	    indexToRemove = slidesIndexes;
	    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
	    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
	    newActiveIndex = Math.max(newActiveIndex, 0);
	  }

	  if (params.loop) {
	    swiper.loopCreate();
	  }

	  if (!(params.observer && swiper.support.observer)) {
	    swiper.update();
	  }

	  if (params.loop) {
	    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	  } else {
	    swiper.slideTo(newActiveIndex, 0, false);
	  }
	}

	function removeAllSlides() {
	  var swiper = this;
	  var slidesIndexes = [];

	  for (var i = 0; i < swiper.slides.length; i += 1) {
	    slidesIndexes.push(i);
	  }

	  swiper.removeSlide(slidesIndexes);
	}

	var manipulation = {
	  appendSlide: appendSlide,
	  prependSlide: prependSlide,
	  addSlide: addSlide,
	  removeSlide: removeSlide,
	  removeAllSlides: removeAllSlides
	};

	function onTouchStart(event) {
	  var swiper = this;
	  var document = getDocument();
	  var window = getWindow$1();
	  var data = swiper.touchEventsData;
	  var params = swiper.params,
	      touches = swiper.touches;

	  if (swiper.animating && params.preventInteractionOnTransition) {
	    return;
	  }

	  var e = event;
	  if (e.originalEvent) e = e.originalEvent;
	  var $targetEl = $(e.target);

	  if (params.touchEventsTarget === 'wrapper') {
	    if (!$targetEl.closest(swiper.wrapperEl).length) return;
	  }

	  data.isTouchEvent = e.type === 'touchstart';
	  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
	  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
	  if (data.isTouched && data.isMoved) return; // change target el for shadow root componenet

	  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

	  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
	    $targetEl = $(event.path[0]);
	  }

	  if (params.noSwiping && $targetEl.closest(params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass)[0]) {
	    swiper.allowClick = true;
	    return;
	  }

	  if (params.swipeHandler) {
	    if (!$targetEl.closest(params.swipeHandler)[0]) return;
	  }

	  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  var startX = touches.currentX;
	  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

	  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
	  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

	  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
	    return;
	  }

	  extend$2(data, {
	    isTouched: true,
	    isMoved: false,
	    allowTouchCallbacks: true,
	    isScrolling: undefined,
	    startMoving: undefined
	  });
	  touches.startX = startX;
	  touches.startY = startY;
	  data.touchStartTime = now();
	  swiper.allowClick = true;
	  swiper.updateSize();
	  swiper.swipeDirection = undefined;
	  if (params.threshold > 0) data.allowThresholdMove = false;

	  if (e.type !== 'touchstart') {
	    var preventDefault = true;
	    if ($targetEl.is(data.formElements)) preventDefault = false;

	    if (document.activeElement && $(document.activeElement).is(data.formElements) && document.activeElement !== $targetEl[0]) {
	      document.activeElement.blur();
	    }

	    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

	    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
	      e.preventDefault();
	    }
	  }

	  swiper.emit('touchStart', e);
	}

	function onTouchMove(event) {
	  var document = getDocument();
	  var swiper = this;
	  var data = swiper.touchEventsData;
	  var params = swiper.params,
	      touches = swiper.touches,
	      rtl = swiper.rtlTranslate;
	  var e = event;
	  if (e.originalEvent) e = e.originalEvent;

	  if (!data.isTouched) {
	    if (data.startMoving && data.isScrolling) {
	      swiper.emit('touchMoveOpposite', e);
	    }

	    return;
	  }

	  if (data.isTouchEvent && e.type !== 'touchmove') return;
	  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
	  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
	  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

	  if (e.preventedByNestedSwiper) {
	    touches.startX = pageX;
	    touches.startY = pageY;
	    return;
	  }

	  if (!swiper.allowTouchMove) {
	    // isMoved = true;
	    swiper.allowClick = false;

	    if (data.isTouched) {
	      extend$2(touches, {
	        startX: pageX,
	        startY: pageY,
	        currentX: pageX,
	        currentY: pageY
	      });
	      data.touchStartTime = now();
	    }

	    return;
	  }

	  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
	    if (swiper.isVertical()) {
	      // Vertical
	      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
	        data.isTouched = false;
	        data.isMoved = false;
	        return;
	      }
	    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
	      return;
	    }
	  }

	  if (data.isTouchEvent && document.activeElement) {
	    if (e.target === document.activeElement && $(e.target).is(data.formElements)) {
	      data.isMoved = true;
	      swiper.allowClick = false;
	      return;
	    }
	  }

	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchMove', e);
	  }

	  if (e.targetTouches && e.targetTouches.length > 1) return;
	  touches.currentX = pageX;
	  touches.currentY = pageY;
	  var diffX = touches.currentX - touches.startX;
	  var diffY = touches.currentY - touches.startY;
	  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

	  if (typeof data.isScrolling === 'undefined') {
	    var touchAngle;

	    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
	      data.isScrolling = false;
	    } else {
	      // eslint-disable-next-line
	      if (diffX * diffX + diffY * diffY >= 25) {
	        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
	        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
	      }
	    }
	  }

	  if (data.isScrolling) {
	    swiper.emit('touchMoveOpposite', e);
	  }

	  if (typeof data.startMoving === 'undefined') {
	    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
	      data.startMoving = true;
	    }
	  }

	  if (data.isScrolling) {
	    data.isTouched = false;
	    return;
	  }

	  if (!data.startMoving) {
	    return;
	  }

	  swiper.allowClick = false;

	  if (!params.cssMode && e.cancelable) {
	    e.preventDefault();
	  }

	  if (params.touchMoveStopPropagation && !params.nested) {
	    e.stopPropagation();
	  }

	  if (!data.isMoved) {
	    if (params.loop) {
	      swiper.loopFix();
	    }

	    data.startTranslate = swiper.getTranslate();
	    swiper.setTransition(0);

	    if (swiper.animating) {
	      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
	    }

	    data.allowMomentumBounce = false; // Grab Cursor

	    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	      swiper.setGrabCursor(true);
	    }

	    swiper.emit('sliderFirstMove', e);
	  }

	  swiper.emit('sliderMove', e);
	  data.isMoved = true;
	  var diff = swiper.isHorizontal() ? diffX : diffY;
	  touches.diff = diff;
	  diff *= params.touchRatio;
	  if (rtl) diff = -diff;
	  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
	  data.currentTranslate = diff + data.startTranslate;
	  var disableParentSwiper = true;
	  var resistanceRatio = params.resistanceRatio;

	  if (params.touchReleaseOnEdges) {
	    resistanceRatio = 0;
	  }

	  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
	    disableParentSwiper = false;
	    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
	  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
	    disableParentSwiper = false;
	    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
	  }

	  if (disableParentSwiper) {
	    e.preventedByNestedSwiper = true;
	  } // Directions locks


	  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }

	  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  } // Threshold


	  if (params.threshold > 0) {
	    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
	      if (!data.allowThresholdMove) {
	        data.allowThresholdMove = true;
	        touches.startX = touches.currentX;
	        touches.startY = touches.currentY;
	        data.currentTranslate = data.startTranslate;
	        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
	        return;
	      }
	    } else {
	      data.currentTranslate = data.startTranslate;
	      return;
	    }
	  }

	  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

	  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  }

	  if (params.freeMode) {
	    // Velocity
	    if (data.velocities.length === 0) {
	      data.velocities.push({
	        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
	        time: data.touchStartTime
	      });
	    }

	    data.velocities.push({
	      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
	      time: now()
	    });
	  } // Update progress


	  swiper.updateProgress(data.currentTranslate); // Update translate

	  swiper.setTranslate(data.currentTranslate);
	}

	function onTouchEnd(event) {
	  var swiper = this;
	  var data = swiper.touchEventsData;
	  var params = swiper.params,
	      touches = swiper.touches,
	      rtl = swiper.rtlTranslate,
	      $wrapperEl = swiper.$wrapperEl,
	      slidesGrid = swiper.slidesGrid,
	      snapGrid = swiper.snapGrid;
	  var e = event;
	  if (e.originalEvent) e = e.originalEvent;

	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchEnd', e);
	  }

	  data.allowTouchCallbacks = false;

	  if (!data.isTouched) {
	    if (data.isMoved && params.grabCursor) {
	      swiper.setGrabCursor(false);
	    }

	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  } // Return Grab Cursor


	  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	    swiper.setGrabCursor(false);
	  } // Time diff


	  var touchEndTime = now();
	  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

	  if (swiper.allowClick) {
	    swiper.updateClickedSlide(e);
	    swiper.emit('tap click', e);

	    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
	      swiper.emit('doubleTap doubleClick', e);
	    }
	  }

	  data.lastClickTime = now();
	  nextTick$1(function () {
	    if (!swiper.destroyed) swiper.allowClick = true;
	  });

	  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
	    data.isTouched = false;
	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  }

	  data.isTouched = false;
	  data.isMoved = false;
	  data.startMoving = false;
	  var currentPos;

	  if (params.followFinger) {
	    currentPos = rtl ? swiper.translate : -swiper.translate;
	  } else {
	    currentPos = -data.currentTranslate;
	  }

	  if (params.cssMode) {
	    return;
	  }

	  if (params.freeMode) {
	    if (currentPos < -swiper.minTranslate()) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }

	    if (currentPos > -swiper.maxTranslate()) {
	      if (swiper.slides.length < snapGrid.length) {
	        swiper.slideTo(snapGrid.length - 1);
	      } else {
	        swiper.slideTo(swiper.slides.length - 1);
	      }

	      return;
	    }

	    if (params.freeModeMomentum) {
	      if (data.velocities.length > 1) {
	        var lastMoveEvent = data.velocities.pop();
	        var velocityEvent = data.velocities.pop();
	        var distance = lastMoveEvent.position - velocityEvent.position;
	        var time = lastMoveEvent.time - velocityEvent.time;
	        swiper.velocity = distance / time;
	        swiper.velocity /= 2;

	        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
	          swiper.velocity = 0;
	        } // this implies that the user stopped moving a finger then released.
	        // There would be no events with distance zero, so the last event is stale.


	        if (time > 150 || now() - lastMoveEvent.time > 300) {
	          swiper.velocity = 0;
	        }
	      } else {
	        swiper.velocity = 0;
	      }

	      swiper.velocity *= params.freeModeMomentumVelocityRatio;
	      data.velocities.length = 0;
	      var momentumDuration = 1000 * params.freeModeMomentumRatio;
	      var momentumDistance = swiper.velocity * momentumDuration;
	      var newPosition = swiper.translate + momentumDistance;
	      if (rtl) newPosition = -newPosition;
	      var doBounce = false;
	      var afterBouncePosition;
	      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
	      var needsLoopFix;

	      if (newPosition < swiper.maxTranslate()) {
	        if (params.freeModeMomentumBounce) {
	          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
	            newPosition = swiper.maxTranslate() - bounceAmount;
	          }

	          afterBouncePosition = swiper.maxTranslate();
	          doBounce = true;
	          data.allowMomentumBounce = true;
	        } else {
	          newPosition = swiper.maxTranslate();
	        }

	        if (params.loop && params.centeredSlides) needsLoopFix = true;
	      } else if (newPosition > swiper.minTranslate()) {
	        if (params.freeModeMomentumBounce) {
	          if (newPosition - swiper.minTranslate() > bounceAmount) {
	            newPosition = swiper.minTranslate() + bounceAmount;
	          }

	          afterBouncePosition = swiper.minTranslate();
	          doBounce = true;
	          data.allowMomentumBounce = true;
	        } else {
	          newPosition = swiper.minTranslate();
	        }

	        if (params.loop && params.centeredSlides) needsLoopFix = true;
	      } else if (params.freeModeSticky) {
	        var nextSlide;

	        for (var j = 0; j < snapGrid.length; j += 1) {
	          if (snapGrid[j] > -newPosition) {
	            nextSlide = j;
	            break;
	          }
	        }

	        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
	          newPosition = snapGrid[nextSlide];
	        } else {
	          newPosition = snapGrid[nextSlide - 1];
	        }

	        newPosition = -newPosition;
	      }

	      if (needsLoopFix) {
	        swiper.once('transitionEnd', function () {
	          swiper.loopFix();
	        });
	      } // Fix duration


	      if (swiper.velocity !== 0) {
	        if (rtl) {
	          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
	        } else {
	          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
	        }

	        if (params.freeModeSticky) {
	          // If freeModeSticky is active and the user ends a swipe with a slow-velocity
	          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
	          // It's easy to see this when simulating touch with mouse events. To fix this,
	          // limit single-slide swipes to the default slide duration. This also has the
	          // nice side effect of matching slide speed if the user stopped moving before
	          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
	          // For faster swipes, also apply limits (albeit higher ones).
	          var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
	          var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

	          if (moveDistance < currentSlideSize) {
	            momentumDuration = params.speed;
	          } else if (moveDistance < 2 * currentSlideSize) {
	            momentumDuration = params.speed * 1.5;
	          } else {
	            momentumDuration = params.speed * 2.5;
	          }
	        }
	      } else if (params.freeModeSticky) {
	        swiper.slideToClosest();
	        return;
	      }

	      if (params.freeModeMomentumBounce && doBounce) {
	        swiper.updateProgress(afterBouncePosition);
	        swiper.setTransition(momentumDuration);
	        swiper.setTranslate(newPosition);
	        swiper.transitionStart(true, swiper.swipeDirection);
	        swiper.animating = true;
	        $wrapperEl.transitionEnd(function () {
	          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
	          swiper.emit('momentumBounce');
	          swiper.setTransition(params.speed);
	          setTimeout(function () {
	            swiper.setTranslate(afterBouncePosition);
	            $wrapperEl.transitionEnd(function () {
	              if (!swiper || swiper.destroyed) return;
	              swiper.transitionEnd();
	            });
	          }, 0);
	        });
	      } else if (swiper.velocity) {
	        swiper.updateProgress(newPosition);
	        swiper.setTransition(momentumDuration);
	        swiper.setTranslate(newPosition);
	        swiper.transitionStart(true, swiper.swipeDirection);

	        if (!swiper.animating) {
	          swiper.animating = true;
	          $wrapperEl.transitionEnd(function () {
	            if (!swiper || swiper.destroyed) return;
	            swiper.transitionEnd();
	          });
	        }
	      } else {
	        swiper.updateProgress(newPosition);
	      }

	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    } else if (params.freeModeSticky) {
	      swiper.slideToClosest();
	      return;
	    }

	    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
	      swiper.updateProgress();
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }

	    return;
	  } // Find current slide


	  var stopIndex = 0;
	  var groupSize = swiper.slidesSizesGrid[0];

	  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
	    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

	    if (typeof slidesGrid[i + _increment] !== 'undefined') {
	      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
	        stopIndex = i;
	        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
	      }
	    } else if (currentPos >= slidesGrid[i]) {
	      stopIndex = i;
	      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
	    }
	  } // Find current slide size


	  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
	  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

	  if (timeDiff > params.longSwipesMs) {
	    // Long touches
	    if (!params.longSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }

	    if (swiper.swipeDirection === 'next') {
	      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
	    }

	    if (swiper.swipeDirection === 'prev') {
	      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
	    }
	  } else {
	    // Short swipes
	    if (!params.shortSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }

	    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

	    if (!isNavButtonTarget) {
	      if (swiper.swipeDirection === 'next') {
	        swiper.slideTo(stopIndex + increment);
	      }

	      if (swiper.swipeDirection === 'prev') {
	        swiper.slideTo(stopIndex);
	      }
	    } else if (e.target === swiper.navigation.nextEl) {
	      swiper.slideTo(stopIndex + increment);
	    } else {
	      swiper.slideTo(stopIndex);
	    }
	  }
	}

	function onResize() {
	  var swiper = this;
	  var params = swiper.params,
	      el = swiper.el;
	  if (el && el.offsetWidth === 0) return; // Breakpoints

	  if (params.breakpoints) {
	    swiper.setBreakpoint();
	  } // Save locks


	  var allowSlideNext = swiper.allowSlideNext,
	      allowSlidePrev = swiper.allowSlidePrev,
	      snapGrid = swiper.snapGrid; // Disable locks on resize

	  swiper.allowSlideNext = true;
	  swiper.allowSlidePrev = true;
	  swiper.updateSize();
	  swiper.updateSlides();
	  swiper.updateSlidesClasses();

	  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
	    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	  } else {
	    swiper.slideTo(swiper.activeIndex, 0, false, true);
	  }

	  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
	    swiper.autoplay.run();
	  } // Return locks after resize


	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;

	  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
	    swiper.checkOverflow();
	  }
	}

	function onClick(e) {
	  var swiper = this;

	  if (!swiper.allowClick) {
	    if (swiper.params.preventClicks) e.preventDefault();

	    if (swiper.params.preventClicksPropagation && swiper.animating) {
	      e.stopPropagation();
	      e.stopImmediatePropagation();
	    }
	  }
	}

	function onScroll() {
	  var swiper = this;
	  var wrapperEl = swiper.wrapperEl,
	      rtlTranslate = swiper.rtlTranslate;
	  swiper.previousTranslate = swiper.translate;

	  if (swiper.isHorizontal()) {
	    if (rtlTranslate) {
	      swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
	    } else {
	      swiper.translate = -wrapperEl.scrollLeft;
	    }
	  } else {
	    swiper.translate = -wrapperEl.scrollTop;
	  } // eslint-disable-next-line


	  if (swiper.translate === -0) swiper.translate = 0;
	  swiper.updateActiveIndex();
	  swiper.updateSlidesClasses();
	  var newProgress;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
	  }

	  if (newProgress !== swiper.progress) {
	    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
	  }

	  swiper.emit('setTranslate', swiper.translate, false);
	}

	var dummyEventAttached = false;

	function dummyEventListener() {}

	function attachEvents() {
	  var swiper = this;
	  var document = getDocument();
	  var params = swiper.params,
	      touchEvents = swiper.touchEvents,
	      el = swiper.el,
	      wrapperEl = swiper.wrapperEl,
	      device = swiper.device,
	      support = swiper.support;
	  swiper.onTouchStart = onTouchStart.bind(swiper);
	  swiper.onTouchMove = onTouchMove.bind(swiper);
	  swiper.onTouchEnd = onTouchEnd.bind(swiper);

	  if (params.cssMode) {
	    swiper.onScroll = onScroll.bind(swiper);
	  }

	  swiper.onClick = onClick.bind(swiper);
	  var capture = !!params.nested; // Touch Events

	  if (!support.touch && support.pointerEvents) {
	    el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
	    document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
	    document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
	  } else {
	    if (support.touch) {
	      var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
	        passive: true,
	        capture: false
	      } : false;
	      el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	      el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
	        passive: false,
	        capture: capture
	      } : capture);
	      el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

	      if (touchEvents.cancel) {
	        el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
	      }

	      if (!dummyEventAttached) {
	        document.addEventListener('touchstart', dummyEventListener);
	        dummyEventAttached = true;
	      }
	    }

	    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
	      el.addEventListener('mousedown', swiper.onTouchStart, false);
	      document.addEventListener('mousemove', swiper.onTouchMove, capture);
	      document.addEventListener('mouseup', swiper.onTouchEnd, false);
	    }
	  } // Prevent Links Clicks


	  if (params.preventClicks || params.preventClicksPropagation) {
	    el.addEventListener('click', swiper.onClick, true);
	  }

	  if (params.cssMode) {
	    wrapperEl.addEventListener('scroll', swiper.onScroll);
	  } // Resize handler


	  if (params.updateOnWindowResize) {
	    swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
	  } else {
	    swiper.on('observerUpdate', onResize, true);
	  }
	}

	function detachEvents() {
	  var swiper = this;
	  var document = getDocument();
	  var params = swiper.params,
	      touchEvents = swiper.touchEvents,
	      el = swiper.el,
	      wrapperEl = swiper.wrapperEl,
	      device = swiper.device,
	      support = swiper.support;
	  var capture = !!params.nested; // Touch Events

	  if (!support.touch && support.pointerEvents) {
	    el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
	    document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	    document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
	  } else {
	    if (support.touch) {
	      var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
	        passive: true,
	        capture: false
	      } : false;
	      el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	      el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	      el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

	      if (touchEvents.cancel) {
	        el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
	      }
	    }

	    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
	      el.removeEventListener('mousedown', swiper.onTouchStart, false);
	      document.removeEventListener('mousemove', swiper.onTouchMove, capture);
	      document.removeEventListener('mouseup', swiper.onTouchEnd, false);
	    }
	  } // Prevent Links Clicks


	  if (params.preventClicks || params.preventClicksPropagation) {
	    el.removeEventListener('click', swiper.onClick, true);
	  }

	  if (params.cssMode) {
	    wrapperEl.removeEventListener('scroll', swiper.onScroll);
	  } // Resize handler


	  swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
	}

	var events$1 = {
	  attachEvents: attachEvents,
	  detachEvents: detachEvents
	};

	function setBreakpoint() {
	  var swiper = this;
	  var activeIndex = swiper.activeIndex,
	      initialized = swiper.initialized,
	      _swiper$loopedSlides = swiper.loopedSlides,
	      loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
	      params = swiper.params,
	      $el = swiper.$el;
	  var breakpoints = params.breakpoints;
	  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

	  var breakpoint = swiper.getBreakpoint(breakpoints);

	  if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
	    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

	    if (breakpointOnlyParams) {
	      ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
	        var paramValue = breakpointOnlyParams[param];
	        if (typeof paramValue === 'undefined') return;

	        if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
	          breakpointOnlyParams[param] = 'auto';
	        } else if (param === 'slidesPerView') {
	          breakpointOnlyParams[param] = parseFloat(paramValue);
	        } else {
	          breakpointOnlyParams[param] = parseInt(paramValue, 10);
	        }
	      });
	    }

	    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
	    var wasMultiRow = params.slidesPerColumn > 1;
	    var isMultiRow = breakpointParams.slidesPerColumn > 1;

	    if (wasMultiRow && !isMultiRow) {
	      $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
	      swiper.emitContainerClasses();
	    } else if (!wasMultiRow && isMultiRow) {
	      $el.addClass(params.containerModifierClass + "multirow");

	      if (breakpointParams.slidesPerColumnFill === 'column') {
	        $el.addClass(params.containerModifierClass + "multirow-column");
	      }

	      swiper.emitContainerClasses();
	    }

	    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
	    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

	    if (directionChanged && initialized) {
	      swiper.changeDirection();
	    }

	    extend$2(swiper.params, breakpointParams);
	    extend$2(swiper, {
	      allowTouchMove: swiper.params.allowTouchMove,
	      allowSlideNext: swiper.params.allowSlideNext,
	      allowSlidePrev: swiper.params.allowSlidePrev
	    });
	    swiper.currentBreakpoint = breakpoint;
	    swiper.emit('_beforeBreakpoint', breakpointParams);

	    if (needsReLoop && initialized) {
	      swiper.loopDestroy();
	      swiper.loopCreate();
	      swiper.updateSlides();
	      swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
	    }

	    swiper.emit('breakpoint', breakpointParams);
	  }
	}

	function getBreakpoints(breakpoints) {
	  var window = getWindow$1(); // Get breakpoint for window width

	  if (!breakpoints) return undefined;
	  var breakpoint = false;
	  var points = Object.keys(breakpoints).map(function (point) {
	    if (typeof point === 'string' && point.indexOf('@') === 0) {
	      var minRatio = parseFloat(point.substr(1));
	      var value = window.innerHeight * minRatio;
	      return {
	        value: value,
	        point: point
	      };
	    }

	    return {
	      value: point,
	      point: point
	    };
	  });
	  points.sort(function (a, b) {
	    return parseInt(a.value, 10) - parseInt(b.value, 10);
	  });

	  for (var i = 0; i < points.length; i += 1) {
	    var _points$i = points[i],
	        point = _points$i.point,
	        value = _points$i.value;

	    if (value <= window.innerWidth) {
	      breakpoint = point;
	    }
	  }

	  return breakpoint || 'max';
	}

	var breakpoints$1 = {
	  setBreakpoint: setBreakpoint,
	  getBreakpoint: getBreakpoints
	};

	function addClasses() {
	  var swiper = this;
	  var classNames = swiper.classNames,
	      params = swiper.params,
	      rtl = swiper.rtl,
	      $el = swiper.$el,
	      device = swiper.device;
	  var suffixes = [];
	  suffixes.push('initialized');
	  suffixes.push(params.direction);

	  if (params.freeMode) {
	    suffixes.push('free-mode');
	  }

	  if (params.autoHeight) {
	    suffixes.push('autoheight');
	  }

	  if (rtl) {
	    suffixes.push('rtl');
	  }

	  if (params.slidesPerColumn > 1) {
	    suffixes.push('multirow');

	    if (params.slidesPerColumnFill === 'column') {
	      suffixes.push('multirow-column');
	    }
	  }

	  if (device.android) {
	    suffixes.push('android');
	  }

	  if (device.ios) {
	    suffixes.push('ios');
	  }

	  if (params.cssMode) {
	    suffixes.push('css-mode');
	  }

	  suffixes.forEach(function (suffix) {
	    classNames.push(params.containerModifierClass + suffix);
	  });
	  $el.addClass(classNames.join(' '));
	  swiper.emitContainerClasses();
	}

	function removeClasses() {
	  var swiper = this;
	  var $el = swiper.$el,
	      classNames = swiper.classNames;
	  $el.removeClass(classNames.join(' '));
	  swiper.emitContainerClasses();
	}

	var classes = {
	  addClasses: addClasses,
	  removeClasses: removeClasses
	};

	function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
	  var window = getWindow$1();
	  var image;

	  function onReady() {
	    if (callback) callback();
	  }

	  var isPicture = $(imageEl).parent('picture')[0];

	  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
	    if (src) {
	      image = new window.Image();
	      image.onload = onReady;
	      image.onerror = onReady;

	      if (sizes) {
	        image.sizes = sizes;
	      }

	      if (srcset) {
	        image.srcset = srcset;
	      }

	      if (src) {
	        image.src = src;
	      }
	    } else {
	      onReady();
	    }
	  } else {
	    // image already loaded...
	    onReady();
	  }
	}

	function preloadImages() {
	  var swiper = this;
	  swiper.imagesToLoad = swiper.$el.find('img');

	  function onReady() {
	    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
	    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

	    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
	      if (swiper.params.updateOnImagesReady) swiper.update();
	      swiper.emit('imagesReady');
	    }
	  }

	  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
	    var imageEl = swiper.imagesToLoad[i];
	    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
	  }
	}

	var images = {
	  loadImage: loadImage,
	  preloadImages: preloadImages
	};

	function checkOverflow() {
	  var swiper = this;
	  var params = swiper.params;
	  var wasLocked = swiper.isLocked;
	  var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;

	  if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
	    swiper.isLocked = lastSlidePosition <= swiper.size;
	  } else {
	    swiper.isLocked = swiper.snapGrid.length === 1;
	  }

	  swiper.allowSlideNext = !swiper.isLocked;
	  swiper.allowSlidePrev = !swiper.isLocked; // events

	  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

	  if (wasLocked && wasLocked !== swiper.isLocked) {
	    swiper.isEnd = false;
	    if (swiper.navigation) swiper.navigation.update();
	  }
	}

	var checkOverflow$1 = {
	  checkOverflow: checkOverflow
	};

	var defaults = {
	  init: true,
	  direction: 'horizontal',
	  touchEventsTarget: 'container',
	  initialSlide: 0,
	  speed: 300,
	  cssMode: false,
	  updateOnWindowResize: true,
	  nested: false,
	  // Overrides
	  width: null,
	  height: null,
	  //
	  preventInteractionOnTransition: false,
	  // ssr
	  userAgent: null,
	  url: null,
	  // To support iOS's swipe-to-go-back gesture (when being used in-app).
	  edgeSwipeDetection: false,
	  edgeSwipeThreshold: 20,
	  // Free mode
	  freeMode: false,
	  freeModeMomentum: true,
	  freeModeMomentumRatio: 1,
	  freeModeMomentumBounce: true,
	  freeModeMomentumBounceRatio: 1,
	  freeModeMomentumVelocityRatio: 1,
	  freeModeSticky: false,
	  freeModeMinimumVelocity: 0.02,
	  // Autoheight
	  autoHeight: false,
	  // Set wrapper width
	  setWrapperSize: false,
	  // Virtual Translate
	  virtualTranslate: false,
	  // Effects
	  effect: 'slide',
	  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
	  // Breakpoints
	  breakpoints: undefined,
	  // Slides grid
	  spaceBetween: 0,
	  slidesPerView: 1,
	  slidesPerColumn: 1,
	  slidesPerColumnFill: 'column',
	  slidesPerGroup: 1,
	  slidesPerGroupSkip: 0,
	  centeredSlides: false,
	  centeredSlidesBounds: false,
	  slidesOffsetBefore: 0,
	  // in px
	  slidesOffsetAfter: 0,
	  // in px
	  normalizeSlideIndex: true,
	  centerInsufficientSlides: false,
	  // Disable swiper and hide navigation when container not overflow
	  watchOverflow: false,
	  // Round length
	  roundLengths: false,
	  // Touches
	  touchRatio: 1,
	  touchAngle: 45,
	  simulateTouch: true,
	  shortSwipes: true,
	  longSwipes: true,
	  longSwipesRatio: 0.5,
	  longSwipesMs: 300,
	  followFinger: true,
	  allowTouchMove: true,
	  threshold: 0,
	  touchMoveStopPropagation: false,
	  touchStartPreventDefault: true,
	  touchStartForcePreventDefault: false,
	  touchReleaseOnEdges: false,
	  // Unique Navigation Elements
	  uniqueNavElements: true,
	  // Resistance
	  resistance: true,
	  resistanceRatio: 0.85,
	  // Progress
	  watchSlidesProgress: false,
	  watchSlidesVisibility: false,
	  // Cursor
	  grabCursor: false,
	  // Clicks
	  preventClicks: true,
	  preventClicksPropagation: true,
	  slideToClickedSlide: false,
	  // Images
	  preloadImages: true,
	  updateOnImagesReady: true,
	  // loop
	  loop: false,
	  loopAdditionalSlides: 0,
	  loopedSlides: null,
	  loopFillGroupWithBlank: false,
	  loopPreventsSlide: true,
	  // Swiping/no swiping
	  allowSlidePrev: true,
	  allowSlideNext: true,
	  swipeHandler: null,
	  // '.swipe-handler',
	  noSwiping: true,
	  noSwipingClass: 'swiper-no-swiping',
	  noSwipingSelector: null,
	  // Passive Listeners
	  passiveListeners: true,
	  // NS
	  containerModifierClass: 'swiper-container-',
	  // NEW
	  slideClass: 'swiper-slide',
	  slideBlankClass: 'swiper-slide-invisible-blank',
	  slideActiveClass: 'swiper-slide-active',
	  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	  slideVisibleClass: 'swiper-slide-visible',
	  slideDuplicateClass: 'swiper-slide-duplicate',
	  slideNextClass: 'swiper-slide-next',
	  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	  slidePrevClass: 'swiper-slide-prev',
	  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	  wrapperClass: 'swiper-wrapper',
	  // Callbacks
	  runCallbacksOnInit: true,
	  // Internals
	  _emitClasses: false
	};

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	var prototypes = {
	  modular: modular,
	  eventsEmitter: eventsEmitter,
	  update: update$1,
	  translate: translate,
	  transition: transition$1,
	  slide: slide,
	  loop: loop,
	  grabCursor: grabCursor,
	  manipulation: manipulation,
	  events: events$1,
	  breakpoints: breakpoints$1,
	  checkOverflow: checkOverflow$1,
	  classes: classes,
	  images: images
	};
	var extendedDefaults = {};

	var Swiper = /*#__PURE__*/function () {
	  function Swiper() {
	    var el;
	    var params;

	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
	      params = args[0];
	    } else {
	      el = args[0];
	      params = args[1];
	    }

	    if (!params) params = {};
	    params = extend$2({}, params);
	    if (el && !params.el) params.el = el; // Swiper Instance

	    var swiper = this;
	    swiper.support = getSupport();
	    swiper.device = getDevice({
	      userAgent: params.userAgent
	    });
	    swiper.browser = getBrowser();
	    swiper.eventsListeners = {};
	    swiper.eventsAnyListeners = [];

	    if (typeof swiper.modules === 'undefined') {
	      swiper.modules = {};
	    }

	    Object.keys(swiper.modules).forEach(function (moduleName) {
	      var module = swiper.modules[moduleName];

	      if (module.params) {
	        var moduleParamName = Object.keys(module.params)[0];
	        var moduleParams = module.params[moduleParamName];
	        if (typeof moduleParams !== 'object' || moduleParams === null) return;
	        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;

	        if (params[moduleParamName] === true) {
	          params[moduleParamName] = {
	            enabled: true
	          };
	        }

	        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
	          params[moduleParamName].enabled = true;
	        }

	        if (!params[moduleParamName]) params[moduleParamName] = {
	          enabled: false
	        };
	      }
	    }); // Extend defaults with modules params

	    var swiperParams = extend$2({}, defaults);
	    swiper.useParams(swiperParams); // Extend defaults with passed params

	    swiper.params = extend$2({}, swiperParams, extendedDefaults, params);
	    swiper.originalParams = extend$2({}, swiper.params);
	    swiper.passedParams = extend$2({}, params); // add event listeners

	    if (swiper.params && swiper.params.on) {
	      Object.keys(swiper.params.on).forEach(function (eventName) {
	        swiper.on(eventName, swiper.params.on[eventName]);
	      });
	    }

	    if (swiper.params && swiper.params.onAny) {
	      swiper.onAny(swiper.params.onAny);
	    } // Save Dom lib


	    swiper.$ = $; // Find el

	    var $el = $(swiper.params.el);
	    el = $el[0];

	    if (!el) {
	      return undefined;
	    }

	    if ($el.length > 1) {
	      var swipers = [];
	      $el.each(function (containerEl) {
	        var newParams = extend$2({}, params, {
	          el: containerEl
	        });
	        swipers.push(new Swiper(newParams));
	      });
	      return swipers;
	    }

	    el.swiper = swiper; // Find Wrapper

	    var $wrapperEl;

	    if (el && el.shadowRoot && el.shadowRoot.querySelector) {
	      $wrapperEl = $(el.shadowRoot.querySelector("." + swiper.params.wrapperClass)); // Children needs to return slot items

	      $wrapperEl.children = function (options) {
	        return $el.children(options);
	      };
	    } else {
	      $wrapperEl = $el.children("." + swiper.params.wrapperClass);
	    } // Extend Swiper


	    extend$2(swiper, {
	      $el: $el,
	      el: el,
	      $wrapperEl: $wrapperEl,
	      wrapperEl: $wrapperEl[0],
	      // Classes
	      classNames: [],
	      // Slides
	      slides: $(),
	      slidesGrid: [],
	      snapGrid: [],
	      slidesSizesGrid: [],
	      // isDirection
	      isHorizontal: function isHorizontal() {
	        return swiper.params.direction === 'horizontal';
	      },
	      isVertical: function isVertical() {
	        return swiper.params.direction === 'vertical';
	      },
	      // RTL
	      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
	      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	      wrongRTL: $wrapperEl.css('display') === '-webkit-box',
	      // Indexes
	      activeIndex: 0,
	      realIndex: 0,
	      //
	      isBeginning: true,
	      isEnd: false,
	      // Props
	      translate: 0,
	      previousTranslate: 0,
	      progress: 0,
	      velocity: 0,
	      animating: false,
	      // Locks
	      allowSlideNext: swiper.params.allowSlideNext,
	      allowSlidePrev: swiper.params.allowSlidePrev,
	      // Touch Events
	      touchEvents: function touchEvents() {
	        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
	        var desktop = ['mousedown', 'mousemove', 'mouseup'];

	        if (swiper.support.pointerEvents) {
	          desktop = ['pointerdown', 'pointermove', 'pointerup'];
	        }

	        swiper.touchEventsTouch = {
	          start: touch[0],
	          move: touch[1],
	          end: touch[2],
	          cancel: touch[3]
	        };
	        swiper.touchEventsDesktop = {
	          start: desktop[0],
	          move: desktop[1],
	          end: desktop[2]
	        };
	        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
	      }(),
	      touchEventsData: {
	        isTouched: undefined,
	        isMoved: undefined,
	        allowTouchCallbacks: undefined,
	        touchStartTime: undefined,
	        isScrolling: undefined,
	        currentTranslate: undefined,
	        startTranslate: undefined,
	        allowThresholdMove: undefined,
	        // Form elements to match
	        formElements: 'input, select, option, textarea, button, video, label',
	        // Last click time
	        lastClickTime: now(),
	        clickTimeout: undefined,
	        // Velocities
	        velocities: [],
	        allowMomentumBounce: undefined,
	        isTouchEvent: undefined,
	        startMoving: undefined
	      },
	      // Clicks
	      allowClick: true,
	      // Touches
	      allowTouchMove: swiper.params.allowTouchMove,
	      touches: {
	        startX: 0,
	        startY: 0,
	        currentX: 0,
	        currentY: 0,
	        diff: 0
	      },
	      // Images
	      imagesToLoad: [],
	      imagesLoaded: 0
	    }); // Install Modules

	    swiper.useModules();
	    swiper.emit('_swiper'); // Init

	    if (swiper.params.init) {
	      swiper.init();
	    } // Return app instance


	    return swiper;
	  }

	  var _proto = Swiper.prototype;

	  _proto.emitContainerClasses = function emitContainerClasses() {
	    var swiper = this;
	    if (!swiper.params._emitClasses || !swiper.el) return;
	    var classes = swiper.el.className.split(' ').filter(function (className) {
	      return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
	    });
	    swiper.emit('_containerClasses', classes.join(' '));
	  };

	  _proto.getSlideClasses = function getSlideClasses(slideEl) {
	    var swiper = this;
	    return slideEl.className.split(' ').filter(function (className) {
	      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
	    }).join(' ');
	  };

	  _proto.emitSlidesClasses = function emitSlidesClasses() {
	    var swiper = this;
	    if (!swiper.params._emitClasses || !swiper.el) return;
	    swiper.slides.each(function (slideEl) {
	      var classNames = swiper.getSlideClasses(slideEl);
	      swiper.emit('_slideClass', slideEl, classNames);
	    });
	  };

	  _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
	    var swiper = this;
	    var params = swiper.params,
	        slides = swiper.slides,
	        slidesGrid = swiper.slidesGrid,
	        swiperSize = swiper.size,
	        activeIndex = swiper.activeIndex;
	    var spv = 1;

	    if (params.centeredSlides) {
	      var slideSize = slides[activeIndex].swiperSlideSize;
	      var breakLoop;

	      for (var i = activeIndex + 1; i < slides.length; i += 1) {
	        if (slides[i] && !breakLoop) {
	          slideSize += slides[i].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) breakLoop = true;
	        }
	      }

	      for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
	        if (slides[_i] && !breakLoop) {
	          slideSize += slides[_i].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) breakLoop = true;
	        }
	      }
	    } else {
	      for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
	        if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
	          spv += 1;
	        }
	      }
	    }

	    return spv;
	  };

	  _proto.update = function update() {
	    var swiper = this;
	    if (!swiper || swiper.destroyed) return;
	    var snapGrid = swiper.snapGrid,
	        params = swiper.params; // Breakpoints

	    if (params.breakpoints) {
	      swiper.setBreakpoint();
	    }

	    swiper.updateSize();
	    swiper.updateSlides();
	    swiper.updateProgress();
	    swiper.updateSlidesClasses();

	    function setTranslate() {
	      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
	      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
	      swiper.setTranslate(newTranslate);
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }

	    var translated;

	    if (swiper.params.freeMode) {
	      setTranslate();

	      if (swiper.params.autoHeight) {
	        swiper.updateAutoHeight();
	      }
	    } else {
	      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	      } else {
	        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
	      }

	      if (!translated) {
	        setTranslate();
	      }
	    }

	    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
	      swiper.checkOverflow();
	    }

	    swiper.emit('update');
	  };

	  _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
	    if (needUpdate === void 0) {
	      needUpdate = true;
	    }

	    var swiper = this;
	    var currentDirection = swiper.params.direction;

	    if (!newDirection) {
	      // eslint-disable-next-line
	      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
	    }

	    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
	      return swiper;
	    }

	    swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
	    swiper.emitContainerClasses();
	    swiper.params.direction = newDirection;
	    swiper.slides.each(function (slideEl) {
	      if (newDirection === 'vertical') {
	        slideEl.style.width = '';
	      } else {
	        slideEl.style.height = '';
	      }
	    });
	    swiper.emit('changeDirection');
	    if (needUpdate) swiper.update();
	    return swiper;
	  };

	  _proto.init = function init() {
	    var swiper = this;
	    if (swiper.initialized) return;
	    swiper.emit('beforeInit'); // Set breakpoint

	    if (swiper.params.breakpoints) {
	      swiper.setBreakpoint();
	    } // Add Classes


	    swiper.addClasses(); // Create loop

	    if (swiper.params.loop) {
	      swiper.loopCreate();
	    } // Update size


	    swiper.updateSize(); // Update slides

	    swiper.updateSlides();

	    if (swiper.params.watchOverflow) {
	      swiper.checkOverflow();
	    } // Set Grab Cursor


	    if (swiper.params.grabCursor) {
	      swiper.setGrabCursor();
	    }

	    if (swiper.params.preloadImages) {
	      swiper.preloadImages();
	    } // Slide To Initial Slide


	    if (swiper.params.loop) {
	      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
	    } else {
	      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
	    } // Attach events


	    swiper.attachEvents(); // Init Flag

	    swiper.initialized = true; // Emit

	    swiper.emit('init');
	    swiper.emit('afterInit');
	  };

	  _proto.destroy = function destroy(deleteInstance, cleanStyles) {
	    if (deleteInstance === void 0) {
	      deleteInstance = true;
	    }

	    if (cleanStyles === void 0) {
	      cleanStyles = true;
	    }

	    var swiper = this;
	    var params = swiper.params,
	        $el = swiper.$el,
	        $wrapperEl = swiper.$wrapperEl,
	        slides = swiper.slides;

	    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
	      return null;
	    }

	    swiper.emit('beforeDestroy'); // Init Flag

	    swiper.initialized = false; // Detach events

	    swiper.detachEvents(); // Destroy loop

	    if (params.loop) {
	      swiper.loopDestroy();
	    } // Cleanup styles


	    if (cleanStyles) {
	      swiper.removeClasses();
	      $el.removeAttr('style');
	      $wrapperEl.removeAttr('style');

	      if (slides && slides.length) {
	        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
	      }
	    }

	    swiper.emit('destroy'); // Detach emitter events

	    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
	      swiper.off(eventName);
	    });

	    if (deleteInstance !== false) {
	      swiper.$el[0].swiper = null;
	      deleteProps(swiper);
	    }

	    swiper.destroyed = true;
	    return null;
	  };

	  Swiper.extendDefaults = function extendDefaults(newDefaults) {
	    extend$2(extendedDefaults, newDefaults);
	  };

	  Swiper.installModule = function installModule(module) {
	    if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
	    var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + now();
	    Swiper.prototype.modules[name] = module;
	  };

	  Swiper.use = function use(module) {
	    if (Array.isArray(module)) {
	      module.forEach(function (m) {
	        return Swiper.installModule(m);
	      });
	      return Swiper;
	    }

	    Swiper.installModule(module);
	    return Swiper;
	  };

	  _createClass(Swiper, null, [{
	    key: "extendedDefaults",
	    get: function get() {
	      return extendedDefaults;
	    }
	  }, {
	    key: "defaults",
	    get: function get() {
	      return defaults;
	    }
	  }]);

	  return Swiper;
	}();

	Object.keys(prototypes).forEach(function (prototypeGroup) {
	  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
	    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
	  });
	});
	Swiper.use([Resize, Observer$1]);

	function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
	var Navigation = {
	  update: function update() {
	    // Update Navigation Buttons
	    var swiper = this;
	    var params = swiper.params.navigation;
	    if (swiper.params.loop) return;
	    var _swiper$navigation = swiper.navigation,
	        $nextEl = _swiper$navigation.$nextEl,
	        $prevEl = _swiper$navigation.$prevEl;

	    if ($prevEl && $prevEl.length > 0) {
	      if (swiper.isBeginning) {
	        $prevEl.addClass(params.disabledClass);
	      } else {
	        $prevEl.removeClass(params.disabledClass);
	      }

	      $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    }

	    if ($nextEl && $nextEl.length > 0) {
	      if (swiper.isEnd) {
	        $nextEl.addClass(params.disabledClass);
	      } else {
	        $nextEl.removeClass(params.disabledClass);
	      }

	      $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    }
	  },
	  onPrevClick: function onPrevClick(e) {
	    var swiper = this;
	    e.preventDefault();
	    if (swiper.isBeginning && !swiper.params.loop) return;
	    swiper.slidePrev();
	  },
	  onNextClick: function onNextClick(e) {
	    var swiper = this;
	    e.preventDefault();
	    if (swiper.isEnd && !swiper.params.loop) return;
	    swiper.slideNext();
	  },
	  init: function init() {
	    var swiper = this;
	    var params = swiper.params.navigation;
	    if (!(params.nextEl || params.prevEl)) return;
	    var $nextEl;
	    var $prevEl;

	    if (params.nextEl) {
	      $nextEl = $(params.nextEl);

	      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
	        $nextEl = swiper.$el.find(params.nextEl);
	      }
	    }

	    if (params.prevEl) {
	      $prevEl = $(params.prevEl);

	      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
	        $prevEl = swiper.$el.find(params.prevEl);
	      }
	    }

	    if ($nextEl && $nextEl.length > 0) {
	      $nextEl.on('click', swiper.navigation.onNextClick);
	    }

	    if ($prevEl && $prevEl.length > 0) {
	      $prevEl.on('click', swiper.navigation.onPrevClick);
	    }

	    extend$2(swiper.navigation, {
	      $nextEl: $nextEl,
	      nextEl: $nextEl && $nextEl[0],
	      $prevEl: $prevEl,
	      prevEl: $prevEl && $prevEl[0]
	    });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var _swiper$navigation2 = swiper.navigation,
	        $nextEl = _swiper$navigation2.$nextEl,
	        $prevEl = _swiper$navigation2.$prevEl;

	    if ($nextEl && $nextEl.length) {
	      $nextEl.off('click', swiper.navigation.onNextClick);
	      $nextEl.removeClass(swiper.params.navigation.disabledClass);
	    }

	    if ($prevEl && $prevEl.length) {
	      $prevEl.off('click', swiper.navigation.onPrevClick);
	      $prevEl.removeClass(swiper.params.navigation.disabledClass);
	    }
	  }
	};
	var Navigation$1 = {
	  name: 'navigation',
	  params: {
	    navigation: {
	      nextEl: null,
	      prevEl: null,
	      hideOnClick: false,
	      disabledClass: 'swiper-button-disabled',
	      hiddenClass: 'swiper-button-hidden',
	      lockClass: 'swiper-button-lock'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    bindModuleMethods(swiper, {
	      navigation: _extends$1({}, Navigation)
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      swiper.navigation.init();
	      swiper.navigation.update();
	    },
	    toEdge: function toEdge(swiper) {
	      swiper.navigation.update();
	    },
	    fromEdge: function fromEdge(swiper) {
	      swiper.navigation.update();
	    },
	    destroy: function destroy(swiper) {
	      swiper.navigation.destroy();
	    },
	    click: function click(swiper, e) {
	      var _swiper$navigation3 = swiper.navigation,
	          $nextEl = _swiper$navigation3.$nextEl,
	          $prevEl = _swiper$navigation3.$prevEl;

	      if (swiper.params.navigation.hideOnClick && !$(e.target).is($prevEl) && !$(e.target).is($nextEl)) {
	        var isHidden;

	        if ($nextEl) {
	          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
	        } else if ($prevEl) {
	          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
	        }

	        if (isHidden === true) {
	          swiper.emit('navigationShow');
	        } else {
	          swiper.emit('navigationHide');
	        }

	        if ($nextEl) {
	          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
	        }

	        if ($prevEl) {
	          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
	        }
	      }
	    }
	  }
	};

	function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
	var Pagination = {
	  update: function update() {
	    // Render || Update Pagination bullets/items
	    var swiper = this;
	    var rtl = swiper.rtl;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
	    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	    var $el = swiper.pagination.$el; // Current/Total

	    var current;
	    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

	    if (swiper.params.loop) {
	      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

	      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
	        current -= slidesLength - swiper.loopedSlides * 2;
	      }

	      if (current > total - 1) current -= total;
	      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
	    } else if (typeof swiper.snapIndex !== 'undefined') {
	      current = swiper.snapIndex;
	    } else {
	      current = swiper.activeIndex || 0;
	    } // Types


	    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
	      var bullets = swiper.pagination.bullets;
	      var firstIndex;
	      var lastIndex;
	      var midIndex;

	      if (params.dynamicBullets) {
	        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
	        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

	        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
	          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

	          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
	            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
	          } else if (swiper.pagination.dynamicBulletIndex < 0) {
	            swiper.pagination.dynamicBulletIndex = 0;
	          }
	        }

	        firstIndex = current - swiper.pagination.dynamicBulletIndex;
	        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
	        midIndex = (lastIndex + firstIndex) / 2;
	      }

	      bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

	      if ($el.length > 1) {
	        bullets.each(function (bullet) {
	          var $bullet = $(bullet);
	          var bulletIndex = $bullet.index();

	          if (bulletIndex === current) {
	            $bullet.addClass(params.bulletActiveClass);
	          }

	          if (params.dynamicBullets) {
	            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
	              $bullet.addClass(params.bulletActiveClass + "-main");
	            }

	            if (bulletIndex === firstIndex) {
	              $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
	            }

	            if (bulletIndex === lastIndex) {
	              $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
	            }
	          }
	        });
	      } else {
	        var $bullet = bullets.eq(current);
	        var bulletIndex = $bullet.index();
	        $bullet.addClass(params.bulletActiveClass);

	        if (params.dynamicBullets) {
	          var $firstDisplayedBullet = bullets.eq(firstIndex);
	          var $lastDisplayedBullet = bullets.eq(lastIndex);

	          for (var i = firstIndex; i <= lastIndex; i += 1) {
	            bullets.eq(i).addClass(params.bulletActiveClass + "-main");
	          }

	          if (swiper.params.loop) {
	            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
	              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
	                bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
	              }

	              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
	            } else {
	              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
	              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
	            }
	          } else {
	            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
	            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
	          }
	        }
	      }

	      if (params.dynamicBullets) {
	        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
	        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
	        var offsetProp = rtl ? 'right' : 'left';
	        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
	      }
	    }

	    if (params.type === 'fraction') {
	      $el.find("." + params.currentClass).text(params.formatFractionCurrent(current + 1));
	      $el.find("." + params.totalClass).text(params.formatFractionTotal(total));
	    }

	    if (params.type === 'progressbar') {
	      var progressbarDirection;

	      if (params.progressbarOpposite) {
	        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
	      } else {
	        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
	      }

	      var scale = (current + 1) / total;
	      var scaleX = 1;
	      var scaleY = 1;

	      if (progressbarDirection === 'horizontal') {
	        scaleX = scale;
	      } else {
	        scaleY = scale;
	      }

	      $el.find("." + params.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
	    }

	    if (params.type === 'custom' && params.renderCustom) {
	      $el.html(params.renderCustom(swiper, current + 1, total));
	      swiper.emit('paginationRender', $el[0]);
	    } else {
	      swiper.emit('paginationUpdate', $el[0]);
	    }

	    $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	  },
	  render: function render() {
	    // Render Container
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
	    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	    var $el = swiper.pagination.$el;
	    var paginationHTML = '';

	    if (params.type === 'bullets') {
	      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

	      for (var i = 0; i < numberOfBullets; i += 1) {
	        if (params.renderBullet) {
	          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
	        } else {
	          paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
	        }
	      }

	      $el.html(paginationHTML);
	      swiper.pagination.bullets = $el.find("." + params.bulletClass.replace(/ /g, '.'));
	    }

	    if (params.type === 'fraction') {
	      if (params.renderFraction) {
	        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
	      } else {
	        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
	      }

	      $el.html(paginationHTML);
	    }

	    if (params.type === 'progressbar') {
	      if (params.renderProgressbar) {
	        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
	      } else {
	        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
	      }

	      $el.html(paginationHTML);
	    }

	    if (params.type !== 'custom') {
	      swiper.emit('paginationRender', swiper.pagination.$el[0]);
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el) return;
	    var $el = $(params.el);
	    if ($el.length === 0) return;

	    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
	      $el = swiper.$el.find(params.el);
	    }

	    if (params.type === 'bullets' && params.clickable) {
	      $el.addClass(params.clickableClass);
	    }

	    $el.addClass(params.modifierClass + params.type);

	    if (params.type === 'bullets' && params.dynamicBullets) {
	      $el.addClass("" + params.modifierClass + params.type + "-dynamic");
	      swiper.pagination.dynamicBulletIndex = 0;

	      if (params.dynamicMainBullets < 1) {
	        params.dynamicMainBullets = 1;
	      }
	    }

	    if (params.type === 'progressbar' && params.progressbarOpposite) {
	      $el.addClass(params.progressbarOppositeClass);
	    }

	    if (params.clickable) {
	      $el.on('click', "." + params.bulletClass.replace(/ /g, '.'), function onClick(e) {
	        e.preventDefault();
	        var index = $(this).index() * swiper.params.slidesPerGroup;
	        if (swiper.params.loop) index += swiper.loopedSlides;
	        swiper.slideTo(index);
	      });
	    }

	    extend$2(swiper.pagination, {
	      $el: $el,
	      el: $el[0]
	    });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
	    var $el = swiper.pagination.$el;
	    $el.removeClass(params.hiddenClass);
	    $el.removeClass(params.modifierClass + params.type);
	    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

	    if (params.clickable) {
	      $el.off('click', "." + params.bulletClass.replace(/ /g, '.'));
	    }
	  }
	};
	var Pagination$1 = {
	  name: 'pagination',
	  params: {
	    pagination: {
	      el: null,
	      bulletElement: 'span',
	      clickable: false,
	      hideOnClick: false,
	      renderBullet: null,
	      renderProgressbar: null,
	      renderFraction: null,
	      renderCustom: null,
	      progressbarOpposite: false,
	      type: 'bullets',
	      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
	      dynamicBullets: false,
	      dynamicMainBullets: 1,
	      formatFractionCurrent: function formatFractionCurrent(number) {
	        return number;
	      },
	      formatFractionTotal: function formatFractionTotal(number) {
	        return number;
	      },
	      bulletClass: 'swiper-pagination-bullet',
	      bulletActiveClass: 'swiper-pagination-bullet-active',
	      modifierClass: 'swiper-pagination-',
	      // NEW
	      currentClass: 'swiper-pagination-current',
	      totalClass: 'swiper-pagination-total',
	      hiddenClass: 'swiper-pagination-hidden',
	      progressbarFillClass: 'swiper-pagination-progressbar-fill',
	      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
	      clickableClass: 'swiper-pagination-clickable',
	      // NEW
	      lockClass: 'swiper-pagination-lock'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    bindModuleMethods(swiper, {
	      pagination: _extends$2({
	        dynamicBulletIndex: 0
	      }, Pagination)
	    });
	  },
	  on: {
	    init: function init(swiper) {
	      swiper.pagination.init();
	      swiper.pagination.render();
	      swiper.pagination.update();
	    },
	    activeIndexChange: function activeIndexChange(swiper) {
	      if (swiper.params.loop) {
	        swiper.pagination.update();
	      } else if (typeof swiper.snapIndex === 'undefined') {
	        swiper.pagination.update();
	      }
	    },
	    snapIndexChange: function snapIndexChange(swiper) {
	      if (!swiper.params.loop) {
	        swiper.pagination.update();
	      }
	    },
	    slidesLengthChange: function slidesLengthChange(swiper) {
	      if (swiper.params.loop) {
	        swiper.pagination.render();
	        swiper.pagination.update();
	      }
	    },
	    snapGridLengthChange: function snapGridLengthChange(swiper) {
	      if (!swiper.params.loop) {
	        swiper.pagination.render();
	        swiper.pagination.update();
	      }
	    },
	    destroy: function destroy(swiper) {
	      swiper.pagination.destroy();
	    },
	    click: function click(swiper, e) {
	      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(e.target).hasClass(swiper.params.pagination.bulletClass)) {
	        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

	        if (isHidden === true) {
	          swiper.emit('paginationShow');
	        } else {
	          swiper.emit('paginationHide');
	        }

	        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
	      }
	    }
	  }
	};

	function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
	var Controller$1 = {
	  LinearSpline: function LinearSpline(x, y) {
	    var binarySearch = function search() {
	      var maxIndex;
	      var minIndex;
	      var guess;
	      return function (array, val) {
	        minIndex = -1;
	        maxIndex = array.length;

	        while (maxIndex - minIndex > 1) {
	          guess = maxIndex + minIndex >> 1;

	          if (array[guess] <= val) {
	            minIndex = guess;
	          } else {
	            maxIndex = guess;
	          }
	        }

	        return maxIndex;
	      };
	    }();

	    this.x = x;
	    this.y = y;
	    this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
	    // (x1,y1) is the known point before given value,
	    // (x3,y3) is the known point after given value.

	    var i1;
	    var i3;

	    this.interpolate = function interpolate(x2) {
	      if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

	      i3 = binarySearch(this.x, x2);
	      i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
	      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

	      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
	    };

	    return this;
	  },
	  // xxx: for now i will just save one spline function to to
	  getInterpolateFunction: function getInterpolateFunction(c) {
	    var swiper = this;

	    if (!swiper.controller.spline) {
	      swiper.controller.spline = swiper.params.loop ? new Controller$1.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller$1.LinearSpline(swiper.snapGrid, c.snapGrid);
	    }
	  },
	  setTranslate: function setTranslate(_setTranslate, byController) {
	    var swiper = this;
	    var controlled = swiper.controller.control;
	    var multiplier;
	    var controlledTranslate;
	    var Swiper = swiper.constructor;

	    function setControlledTranslate(c) {
	      // this will create an Interpolate function based on the snapGrids
	      // x is the Grid of the scrolled scroller and y will be the controlled scroller
	      // it makes sense to create this only once and recall it for the interpolation
	      // the function does a lot of value caching for performance
	      var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;

	      if (swiper.params.controller.by === 'slide') {
	        swiper.controller.getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
	        // but it did not work out

	        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
	      }

	      if (!controlledTranslate || swiper.params.controller.by === 'container') {
	        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
	        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
	      }

	      if (swiper.params.controller.inverse) {
	        controlledTranslate = c.maxTranslate() - controlledTranslate;
	      }

	      c.updateProgress(controlledTranslate);
	      c.setTranslate(controlledTranslate, swiper);
	      c.updateActiveIndex();
	      c.updateSlidesClasses();
	    }

	    if (Array.isArray(controlled)) {
	      for (var i = 0; i < controlled.length; i += 1) {
	        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	          setControlledTranslate(controlled[i]);
	        }
	      }
	    } else if (controlled instanceof Swiper && byController !== controlled) {
	      setControlledTranslate(controlled);
	    }
	  },
	  setTransition: function setTransition(duration, byController) {
	    var swiper = this;
	    var Swiper = swiper.constructor;
	    var controlled = swiper.controller.control;
	    var i;

	    function setControlledTransition(c) {
	      c.setTransition(duration, swiper);

	      if (duration !== 0) {
	        c.transitionStart();

	        if (c.params.autoHeight) {
	          nextTick$1(function () {
	            c.updateAutoHeight();
	          });
	        }

	        c.$wrapperEl.transitionEnd(function () {
	          if (!controlled) return;

	          if (c.params.loop && swiper.params.controller.by === 'slide') {
	            c.loopFix();
	          }

	          c.transitionEnd();
	        });
	      }
	    }

	    if (Array.isArray(controlled)) {
	      for (i = 0; i < controlled.length; i += 1) {
	        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	          setControlledTransition(controlled[i]);
	        }
	      }
	    } else if (controlled instanceof Swiper && byController !== controlled) {
	      setControlledTransition(controlled);
	    }
	  }
	};
	var Controller$2 = {
	  name: 'controller',
	  params: {
	    controller: {
	      control: undefined,
	      inverse: false,
	      by: 'slide' // or 'container'

	    }
	  },
	  create: function create() {
	    var swiper = this;
	    bindModuleMethods(swiper, {
	      controller: _extends$3({
	        control: swiper.params.controller.control
	      }, Controller$1)
	    });
	  },
	  on: {
	    update: function update(swiper) {
	      if (!swiper.controller.control) return;

	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    resize: function resize(swiper) {
	      if (!swiper.controller.control) return;

	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    observerUpdate: function observerUpdate(swiper) {
	      if (!swiper.controller.control) return;

	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    setTranslate: function setTranslate(swiper, translate, byController) {
	      if (!swiper.controller.control) return;
	      swiper.controller.setTranslate(translate, byController);
	    },
	    setTransition: function setTransition(swiper, duration, byController) {
	      if (!swiper.controller.control) return;
	      swiper.controller.setTransition(duration, byController);
	    }
	  }
	};

	function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
	var A11y = {
	  getRandomNumber: function getRandomNumber(size) {
	    if (size === void 0) {
	      size = 16;
	    }

	    var randomChar = function randomChar() {
	      return Math.round(16 * Math.random()).toString(16);
	    };

	    return 'x'.repeat(size).replace(/x/g, randomChar);
	  },
	  makeElFocusable: function makeElFocusable($el) {
	    $el.attr('tabIndex', '0');
	    return $el;
	  },
	  makeElNotFocusable: function makeElNotFocusable($el) {
	    $el.attr('tabIndex', '-1');
	    return $el;
	  },
	  addElRole: function addElRole($el, role) {
	    $el.attr('role', role);
	    return $el;
	  },
	  addElRoleDescription: function addElRoleDescription($el, description) {
	    $el.attr('aria-role-description', description);
	    return $el;
	  },
	  addElControls: function addElControls($el, controls) {
	    $el.attr('aria-controls', controls);
	    return $el;
	  },
	  addElLabel: function addElLabel($el, label) {
	    $el.attr('aria-label', label);
	    return $el;
	  },
	  addElId: function addElId($el, id) {
	    $el.attr('id', id);
	    return $el;
	  },
	  addElLive: function addElLive($el, live) {
	    $el.attr('aria-live', live);
	    return $el;
	  },
	  disableEl: function disableEl($el) {
	    $el.attr('aria-disabled', true);
	    return $el;
	  },
	  enableEl: function enableEl($el) {
	    $el.attr('aria-disabled', false);
	    return $el;
	  },
	  onEnterKey: function onEnterKey(e) {
	    var swiper = this;
	    var params = swiper.params.a11y;
	    if (e.keyCode !== 13) return;
	    var $targetEl = $(e.target);

	    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
	      if (!(swiper.isEnd && !swiper.params.loop)) {
	        swiper.slideNext();
	      }

	      if (swiper.isEnd) {
	        swiper.a11y.notify(params.lastSlideMessage);
	      } else {
	        swiper.a11y.notify(params.nextSlideMessage);
	      }
	    }

	    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
	      if (!(swiper.isBeginning && !swiper.params.loop)) {
	        swiper.slidePrev();
	      }

	      if (swiper.isBeginning) {
	        swiper.a11y.notify(params.firstSlideMessage);
	      } else {
	        swiper.a11y.notify(params.prevSlideMessage);
	      }
	    }

	    if (swiper.pagination && $targetEl.is("." + swiper.params.pagination.bulletClass.replace(/ /g, '.'))) {
	      $targetEl[0].click();
	    }
	  },
	  notify: function notify(message) {
	    var swiper = this;
	    var notification = swiper.a11y.liveRegion;
	    if (notification.length === 0) return;
	    notification.html('');
	    notification.html(message);
	  },
	  updateNavigation: function updateNavigation() {
	    var swiper = this;
	    if (swiper.params.loop || !swiper.navigation) return;
	    var _swiper$navigation = swiper.navigation,
	        $nextEl = _swiper$navigation.$nextEl,
	        $prevEl = _swiper$navigation.$prevEl;

	    if ($prevEl && $prevEl.length > 0) {
	      if (swiper.isBeginning) {
	        swiper.a11y.disableEl($prevEl);
	        swiper.a11y.makeElNotFocusable($prevEl);
	      } else {
	        swiper.a11y.enableEl($prevEl);
	        swiper.a11y.makeElFocusable($prevEl);
	      }
	    }

	    if ($nextEl && $nextEl.length > 0) {
	      if (swiper.isEnd) {
	        swiper.a11y.disableEl($nextEl);
	        swiper.a11y.makeElNotFocusable($nextEl);
	      } else {
	        swiper.a11y.enableEl($nextEl);
	        swiper.a11y.makeElFocusable($nextEl);
	      }
	    }
	  },
	  updatePagination: function updatePagination() {
	    var swiper = this;
	    var params = swiper.params.a11y;

	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.bullets.each(function (bulletEl) {
	        var $bulletEl = $(bulletEl);
	        swiper.a11y.makeElFocusable($bulletEl);

	        if (!swiper.params.pagination.renderBullet) {
	          swiper.a11y.addElRole($bulletEl, 'button');
	          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
	        }
	      });
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    var params = swiper.params.a11y;
	    swiper.$el.append(swiper.a11y.liveRegion); // Container

	    var $containerEl = swiper.$el;

	    if (params.containerRoleDescriptionMessage) {
	      swiper.a11y.addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
	    }

	    if (params.containerMessage) {
	      swiper.a11y.addElLabel($containerEl, params.containerMessage);
	    } // Wrapper


	    var $wrapperEl = swiper.$wrapperEl;
	    var wrapperId = $wrapperEl.attr('id') || "swiper-wrapper-" + swiper.a11y.getRandomNumber(16);
	    var live;
	    swiper.a11y.addElId($wrapperEl, wrapperId);

	    if (swiper.params.autoplay && swiper.params.autoplay.enabled) {
	      live = 'off';
	    } else {
	      live = 'polite';
	    }

	    swiper.a11y.addElLive($wrapperEl, live); // Slide

	    if (params.itemRoleDescriptionMessage) {
	      swiper.a11y.addElRoleDescription($(swiper.slides), params.itemRoleDescriptionMessage);
	    }

	    swiper.a11y.addElRole($(swiper.slides), 'group');
	    swiper.slides.each(function (slideEl) {
	      var $slideEl = $(slideEl);
	      swiper.a11y.addElLabel($slideEl, $slideEl.index() + 1 + " / " + swiper.slides.length);
	    }); // Navigation

	    var $nextEl;
	    var $prevEl;

	    if (swiper.navigation && swiper.navigation.$nextEl) {
	      $nextEl = swiper.navigation.$nextEl;
	    }

	    if (swiper.navigation && swiper.navigation.$prevEl) {
	      $prevEl = swiper.navigation.$prevEl;
	    }

	    if ($nextEl && $nextEl.length) {
	      swiper.a11y.makeElFocusable($nextEl);

	      if ($nextEl[0].tagName !== 'BUTTON') {
	        swiper.a11y.addElRole($nextEl, 'button');
	        $nextEl.on('keydown', swiper.a11y.onEnterKey);
	      }

	      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
	      swiper.a11y.addElControls($nextEl, wrapperId);
	    }

	    if ($prevEl && $prevEl.length) {
	      swiper.a11y.makeElFocusable($prevEl);

	      if ($prevEl[0].tagName !== 'BUTTON') {
	        swiper.a11y.addElRole($prevEl, 'button');
	        $prevEl.on('keydown', swiper.a11y.onEnterKey);
	      }

	      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
	      swiper.a11y.addElControls($prevEl, wrapperId);
	    } // Pagination


	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.$el.on('keydown', "." + swiper.params.pagination.bulletClass.replace(/ /g, '.'), swiper.a11y.onEnterKey);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
	    var $nextEl;
	    var $prevEl;

	    if (swiper.navigation && swiper.navigation.$nextEl) {
	      $nextEl = swiper.navigation.$nextEl;
	    }

	    if (swiper.navigation && swiper.navigation.$prevEl) {
	      $prevEl = swiper.navigation.$prevEl;
	    }

	    if ($nextEl) {
	      $nextEl.off('keydown', swiper.a11y.onEnterKey);
	    }

	    if ($prevEl) {
	      $prevEl.off('keydown', swiper.a11y.onEnterKey);
	    } // Pagination


	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.$el.off('keydown', "." + swiper.params.pagination.bulletClass.replace(/ /g, '.'), swiper.a11y.onEnterKey);
	    }
	  }
	};
	var A11y$1 = {
	  name: 'a11y',
	  params: {
	    a11y: {
	      enabled: true,
	      notificationClass: 'swiper-notification',
	      prevSlideMessage: 'Previous slide',
	      nextSlideMessage: 'Next slide',
	      firstSlideMessage: 'This is the first slide',
	      lastSlideMessage: 'This is the last slide',
	      paginationBulletMessage: 'Go to slide {{index}}',
	      containerMessage: null,
	      containerRoleDescriptionMessage: null,
	      itemRoleDescriptionMessage: null
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    bindModuleMethods(swiper, {
	      a11y: _extends$4({}, A11y, {
	        liveRegion: $("<span class=\"" + swiper.params.a11y.notificationClass + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")
	      })
	    });
	  },
	  on: {
	    afterInit: function afterInit(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.init();
	      swiper.a11y.updateNavigation();
	    },
	    toEdge: function toEdge(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.updateNavigation();
	    },
	    fromEdge: function fromEdge(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.updateNavigation();
	    },
	    paginationUpdate: function paginationUpdate(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.updatePagination();
	    },
	    destroy: function destroy(swiper) {
	      if (!swiper.params.a11y.enabled) return;
	      swiper.a11y.destroy();
	    }
	  }
	};

	function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
	var Thumbs = {
	  init: function init() {
	    var swiper = this;
	    var thumbsParams = swiper.params.thumbs;
	    if (swiper.thumbs.initialized) return false;
	    swiper.thumbs.initialized = true;
	    var SwiperClass = swiper.constructor;

	    if (thumbsParams.swiper instanceof SwiperClass) {
	      swiper.thumbs.swiper = thumbsParams.swiper;
	      extend$2(swiper.thumbs.swiper.originalParams, {
	        watchSlidesProgress: true,
	        slideToClickedSlide: false
	      });
	      extend$2(swiper.thumbs.swiper.params, {
	        watchSlidesProgress: true,
	        slideToClickedSlide: false
	      });
	    } else if (isObject$3(thumbsParams.swiper)) {
	      swiper.thumbs.swiper = new SwiperClass(extend$2({}, thumbsParams.swiper, {
	        watchSlidesVisibility: true,
	        watchSlidesProgress: true,
	        slideToClickedSlide: false
	      }));
	      swiper.thumbs.swiperCreated = true;
	    }

	    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
	    swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
	    return true;
	  },
	  onThumbClick: function onThumbClick() {
	    var swiper = this;
	    var thumbsSwiper = swiper.thumbs.swiper;
	    if (!thumbsSwiper) return;
	    var clickedIndex = thumbsSwiper.clickedIndex;
	    var clickedSlide = thumbsSwiper.clickedSlide;
	    if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
	    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
	    var slideToIndex;

	    if (thumbsSwiper.params.loop) {
	      slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	    } else {
	      slideToIndex = clickedIndex;
	    }

	    if (swiper.params.loop) {
	      var currentIndex = swiper.activeIndex;

	      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
	        swiper.loopFix(); // eslint-disable-next-line

	        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	        currentIndex = swiper.activeIndex;
	      }

	      var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
	      var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
	      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
	    }

	    swiper.slideTo(slideToIndex);
	  },
	  update: function update(initial) {
	    var swiper = this;
	    var thumbsSwiper = swiper.thumbs.swiper;
	    if (!thumbsSwiper) return;
	    var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
	    var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
	    var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;

	    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
	      var currentThumbsIndex = thumbsSwiper.activeIndex;
	      var newThumbsIndex;
	      var direction;

	      if (thumbsSwiper.params.loop) {
	        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
	          thumbsSwiper.loopFix(); // eslint-disable-next-line

	          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
	          currentThumbsIndex = thumbsSwiper.activeIndex;
	        } // Find actual thumbs index to slide to


	        var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
	        var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
	        if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = currentThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;else newThumbsIndex = prevThumbsIndex;
	        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
	      } else {
	        newThumbsIndex = swiper.realIndex;
	        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
	      }

	      if (useOffset) {
	        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
	      }

	      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
	        if (thumbsSwiper.params.centeredSlides) {
	          if (newThumbsIndex > currentThumbsIndex) {
	            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
	          } else {
	            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
	          }
	        } else if (newThumbsIndex > currentThumbsIndex) {
	          newThumbsIndex = newThumbsIndex - slidesPerView + 1;
	        }

	        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
	      }
	    } // Activate thumbs


	    var thumbsToActivate = 1;
	    var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

	    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
	      thumbsToActivate = swiper.params.slidesPerView;
	    }

	    if (!swiper.params.thumbs.multipleActiveThumbs) {
	      thumbsToActivate = 1;
	    }

	    thumbsToActivate = Math.floor(thumbsToActivate);
	    thumbsSwiper.slides.removeClass(thumbActiveClass);

	    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
	      for (var i = 0; i < thumbsToActivate; i += 1) {
	        thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]").addClass(thumbActiveClass);
	      }
	    } else {
	      for (var _i = 0; _i < thumbsToActivate; _i += 1) {
	        thumbsSwiper.slides.eq(swiper.realIndex + _i).addClass(thumbActiveClass);
	      }
	    }
	  }
	};
	var Thumbs$1 = {
	  name: 'thumbs',
	  params: {
	    thumbs: {
	      swiper: null,
	      multipleActiveThumbs: true,
	      autoScrollOffset: 0,
	      slideThumbActiveClass: 'swiper-slide-thumb-active',
	      thumbsContainerClass: 'swiper-container-thumbs'
	    }
	  },
	  create: function create() {
	    var swiper = this;
	    bindModuleMethods(swiper, {
	      thumbs: _extends$5({
	        swiper: null,
	        initialized: false
	      }, Thumbs)
	    });
	  },
	  on: {
	    beforeInit: function beforeInit(swiper) {
	      var thumbs = swiper.params.thumbs;
	      if (!thumbs || !thumbs.swiper) return;
	      swiper.thumbs.init();
	      swiper.thumbs.update(true);
	    },
	    slideChange: function slideChange(swiper) {
	      if (!swiper.thumbs.swiper) return;
	      swiper.thumbs.update();
	    },
	    update: function update(swiper) {
	      if (!swiper.thumbs.swiper) return;
	      swiper.thumbs.update();
	    },
	    resize: function resize(swiper) {
	      if (!swiper.thumbs.swiper) return;
	      swiper.thumbs.update();
	    },
	    observerUpdate: function observerUpdate(swiper) {
	      if (!swiper.thumbs.swiper) return;
	      swiper.thumbs.update();
	    },
	    setTransition: function setTransition(swiper, duration) {
	      var thumbsSwiper = swiper.thumbs.swiper;
	      if (!thumbsSwiper) return;
	      thumbsSwiper.setTransition(duration);
	    },
	    beforeDestroy: function beforeDestroy(swiper) {
	      var thumbsSwiper = swiper.thumbs.swiper;
	      if (!thumbsSwiper) return;

	      if (swiper.thumbs.swiperCreated && thumbsSwiper) {
	        thumbsSwiper.destroy();
	      }
	    }
	  }
	};

	function isObject$4(o) {
	  return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
	}

	function extend$3(target, src) {
	  Object.keys(src).forEach(function (key) {
	    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$4(src[key]) && isObject$4(target[key]) && Object.keys(src[key]).length > 0) {
	      extend$3(target[key], src[key]);
	    } else {
	      target[key] = src[key];
	    }
	  });
	}

	function needsNavigation(props) {
	  if (props === void 0) {
	    props = {};
	  }

	  return props.navigation && typeof props.navigation.nextEl === 'undefined' && typeof props.navigation.prevEl === 'undefined';
	}

	function needsPagination(props) {
	  if (props === void 0) {
	    props = {};
	  }

	  return props.pagination && typeof props.pagination.el === 'undefined';
	}

	function needsScrollbar(props) {
	  if (props === void 0) {
	    props = {};
	  }

	  return props.scrollbar && typeof props.scrollbar.el === 'undefined';
	}

	function uniqueClasses(classNames) {
	  if (classNames === void 0) {
	    classNames = '';
	  }

	  var classes = classNames.split(' ').map(function (c) {
	    return c.trim();
	  }).filter(function (c) {
	    return !!c;
	  });
	  var unique = [];
	  classes.forEach(function (c) {
	    if (unique.indexOf(c) < 0) unique.push(c);
	  });
	  return unique.join(' ');
	}

	/* underscore in name -> watch for changes */
	var paramsList = ['init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'nested', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_freeModeMomentum', '_freeModeMomentumRatio', '_freeModeMomentumBounce', '_freeModeMomentumBounceRatio', '_freeModeMomentumVelocityRatio', '_freeModeSticky', '_freeModeMinimumVelocity', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', '_slidesPerColumn', '_slidesPerColumnFill', '_slidesPerGroup', '_slidesPerGroupSkip', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_watchSlidesVisibility', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', // modules
	'a11y', 'autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];

	// eslint-disable-next-line

	function getParams(obj) {
	  if (obj === void 0) {
	    obj = {};
	  }

	  var params = {
	    on: {}
	  };
	  var passedParams = {};
	  extend$3(params, Swiper.defaults);
	  extend$3(params, Swiper.extendedDefaults);
	  params._emitClasses = true;
	  var rest = {};
	  var allowedParams = paramsList.map(function (key) {
	    return key.replace(/_/, '');
	  });
	  Object.keys(obj).forEach(function (key) {
	    if (typeof obj[key] === 'undefined') return;

	    if (allowedParams.indexOf(key) >= 0) {
	      if (isObject$4(obj[key])) {
	        params[key] = {};
	        passedParams[key] = {};
	        extend$3(params[key], obj[key]);
	        extend$3(passedParams[key], obj[key]);
	      } else {
	        params[key] = obj[key];
	        passedParams[key] = obj[key];
	      }
	    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
	      params.on["" + key[2].toLowerCase() + key.substr(3)] = obj[key];
	    } else {
	      rest[key] = obj[key];
	    }
	  });
	  return {
	    params: params,
	    passedParams: passedParams,
	    rest: rest
	  };
	}

	// eslint-disable-next-line

	function initSwiper(_ref, swiperParams) {
	  var el = _ref.el,
	      nextEl = _ref.nextEl,
	      prevEl = _ref.prevEl,
	      paginationEl = _ref.paginationEl,
	      scrollbarEl = _ref.scrollbarEl;

	  if (needsNavigation(swiperParams) && nextEl && prevEl) {
	    if (swiperParams.navigation === true) {
	      swiperParams.navigation = {};
	    }

	    swiperParams.navigation.nextEl = nextEl;
	    swiperParams.navigation.prevEl = prevEl;
	  }

	  if (needsPagination(swiperParams) && paginationEl) {
	    if (swiperParams.pagination === true) {
	      swiperParams.pagination = {};
	    }

	    swiperParams.pagination.el = paginationEl;
	  }

	  if (needsScrollbar(swiperParams) && scrollbarEl) {
	    if (swiperParams.scrollbar === true) {
	      swiperParams.scrollbar = {};
	    }

	    swiperParams.scrollbar.el = scrollbarEl;
	  }

	  return new Swiper(el, swiperParams);
	}

	function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

	function calcLoopedSlides(slides, swiperParams) {
	  var slidesPerViewParams = swiperParams.slidesPerView;

	  if (swiperParams.breakpoints) {
	    var breakpoint = Swiper.prototype.getBreakpoint(swiperParams.breakpoints);
	    var breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

	    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
	      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
	    }
	  }

	  var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
	  loopedSlides += swiperParams.loopAdditionalSlides;

	  if (loopedSlides > slides.length) {
	    loopedSlides = slides.length;
	  }

	  return loopedSlides;
	}

	function renderLoop(swiperRef, slides, swiperParams) {
	  var modifiedSlides = slides.map(function (child, index) {
	    if (!child.props) child.props = {};
	    child.props.swiperRef = swiperRef;
	    child.props['data-swiper-slide-index'] = index;
	    return child;
	  });

	  function duplicateSlide(child, index, position) {
	    if (!child.props) child.props = {};
	    return h(child.type, _extends$6({}, child.props, {
	      key: child.key + "-duplicate-" + index + "-" + position,
	      class: (child.props.className || '') + " " + swiperParams.slideDuplicateClass + " " + (child.props.class || '')
	    }), child.children);
	  }

	  if (swiperParams.loopFillGroupWithBlank) {
	    var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

	    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
	      for (var i = 0; i < blankSlidesNum; i += 1) {
	        var blankSlide = h('div', {
	          class: swiperParams.slideClass + " " + swiperParams.slideBlankClass
	        });
	        modifiedSlides.push(blankSlide);
	      }
	    }
	  }

	  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
	    swiperParams.loopedSlides = modifiedSlides.length;
	  }

	  var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
	  var prependSlides = [];
	  var appendSlides = [];
	  modifiedSlides.forEach(function (child, index) {
	    if (index < loopedSlides) {
	      appendSlides.push(duplicateSlide(child, index, 'prepend'));
	    }

	    if (index < modifiedSlides.length && index >= modifiedSlides.length - loopedSlides) {
	      prependSlides.push(duplicateSlide(child, index, 'append'));
	    }
	  });

	  if (swiperRef.value) {
	    swiperRef.value.loopedSlides = loopedSlides;
	  }

	  return [].concat(prependSlides, modifiedSlides, appendSlides);
	}

	function getChangedParams(swiperParams, oldParams, children, oldChildren) {
	  var keys = [];
	  if (!oldParams) return keys;

	  var addKey = function addKey(key) {
	    if (keys.indexOf(key) < 0) keys.push(key);
	  };

	  var oldChildrenKeys = oldChildren.map(function (child) {
	    return child.props && child.props.key;
	  });
	  var childrenKeys = children.map(function (child) {
	    return child.props && child.props.key;
	  });
	  if (oldChildrenKeys.join('') !== childrenKeys.join('')) keys.push('children');
	  if (oldChildren.length !== children.length) keys.push('children');
	  var watchParams = paramsList.filter(function (key) {
	    return key[0] === '_';
	  }).map(function (key) {
	    return key.replace(/_/, '');
	  });
	  watchParams.forEach(function (key) {
	    if (key in swiperParams && key in oldParams) {
	      if (isObject$4(swiperParams[key]) && isObject$4(oldParams[key])) {
	        var newKeys = Object.keys(swiperParams[key]);
	        var oldKeys = Object.keys(oldParams[key]);

	        if (newKeys.length !== oldKeys.length) {
	          addKey(key);
	        } else {
	          newKeys.forEach(function (newKey) {
	            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
	              addKey(key);
	            }
	          });
	          oldKeys.forEach(function (oldKey) {
	            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
	          });
	        }
	      } else if (swiperParams[key] !== oldParams[key]) {
	        addKey(key);
	      }
	    }
	  });
	  return keys;
	}

	function getChildren$1(originalSlots, slidesRef, oldSlidesRef) {
	  if (originalSlots === void 0) {
	    originalSlots = {};
	  }

	  var slides = [];
	  var slots = {
	    'container-start': [],
	    'container-end': [],
	    'wrapper-start': [],
	    'wrapper-end': []
	  };

	  var getSlidesFromElements = function getSlidesFromElements(els, slotName) {
	    if (!Array.isArray(els)) {
	      return;
	    }

	    els.forEach(function (vnode) {
	      var isFragment = typeof vnode.type === 'symbol';
	      if (slotName === 'default') slotName = 'container-end';

	      if (isFragment && vnode.children) {
	        getSlidesFromElements(vnode.children, 'default');
	      } else if (vnode.type && vnode.type.name === 'SwiperSlide') {
	        slides.push(vnode);
	      } else if (slots[slotName]) {
	        slots[slotName].push(vnode);
	      }
	    });
	  };

	  Object.keys(originalSlots).forEach(function (slotName) {
	    var els = originalSlots[slotName]();
	    getSlidesFromElements(els, slotName);
	  });
	  oldSlidesRef.value = slidesRef.value;
	  slidesRef.value = slides;
	  return {
	    slides: slides,
	    slots: slots
	  };
	}

	function updateSwiper(swiper, slides, passedParams, changedParams) {
	  var updateParams = changedParams.filter(function (key) {
	    return key !== 'children' && key !== 'direction';
	  });
	  var currentParams = swiper.params,
	      pagination = swiper.pagination,
	      navigation = swiper.navigation,
	      scrollbar = swiper.scrollbar,
	      virtual = swiper.virtual,
	      thumbs = swiper.thumbs;
	  var needThumbsInit;
	  var needControllerInit;
	  var needPaginationInit;
	  var needScrollbarInit;
	  var needNavigationInit;

	  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
	    needThumbsInit = true;
	  }

	  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
	    needControllerInit = true;
	  }

	  if (changedParams.includes('pagination') && passedParams.pagination && passedParams.pagination.el && currentParams.pagination && pagination && !pagination.el) {
	    needPaginationInit = true;
	  }

	  if (changedParams.includes('scrollbar') && passedParams.scrollbar && passedParams.scrollbar.el && currentParams.scrollbar && scrollbar && !scrollbar.el) {
	    needScrollbarInit = true;
	  }

	  if (changedParams.includes('navigation') && passedParams.navigation && passedParams.navigation.prevEl && passedParams.navigation.nextEl && currentParams.navigation && navigation && !navigation.prevEl && !navigation.nextEl) {
	    needNavigationInit = true;
	  }

	  updateParams.forEach(function (key) {
	    if (isObject$4(currentParams[key]) && isObject$4(passedParams[key])) {
	      extend$3(currentParams[key], passedParams[key]);
	    } else {
	      currentParams[key] = passedParams[key];
	    }
	  });

	  if (changedParams.includes('children') && virtual && currentParams.virtual.enabled) {
	    virtual.slides = slides;
	    virtual.update(true);
	  }

	  if (needThumbsInit) {
	    var initialized = thumbs.init();
	    if (initialized) thumbs.update(true);
	  }

	  if (needControllerInit) {
	    swiper.controller.control = currentParams.controller.control;
	  }

	  if (needPaginationInit) {
	    pagination.init();
	    pagination.render();
	    pagination.update();
	  }

	  if (needScrollbarInit) {
	    scrollbar.init();
	    scrollbar.updateSize();
	    scrollbar.setTranslate();
	  }

	  if (needNavigationInit) {
	    navigation.init();
	    navigation.update();
	  }

	  if (changedParams.includes('allowSlideNext')) {
	    swiper.allowSlideNext = passedParams.allowSlideNext;
	  }

	  if (changedParams.includes('allowSlidePrev')) {
	    swiper.allowSlidePrev = passedParams.allowSlidePrev;
	  }

	  if (changedParams.includes('direction')) {
	    swiper.changeDirection(passedParams.direction, false);
	  }

	  swiper.update();
	}

	function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

	function updateOnVirtualData(swiper) {
	  if (!swiper || swiper.destroyed) return;
	  swiper.updateSlides();
	  swiper.updateProgress();
	  swiper.updateSlidesClasses();

	  if (swiper.lazy && swiper.params.lazy.enabled) {
	    swiper.lazy.load();
	  }
	}

	function renderVirtual(swiperRef, slides, virtualData) {
	  var _ref;

	  if (!virtualData) return null;
	  var style = swiperRef.value.isHorizontal() ? (_ref = {}, _ref[swiperRef.value.rtlTranslate ? 'right' : 'left'] = virtualData.offset + "px", _ref) : {
	    top: virtualData.offset + "px"
	  };
	  return slides.filter(function (slide, index) {
	    return index >= virtualData.from && index <= virtualData.to;
	  }).map(function (slide) {
	    if (!slide.props) slide.props = {};
	    if (!slide.props.style) slide.props.style = {};
	    slide.props.swiperRef = swiperRef;
	    slide.props.style = style;
	    return h(slide.type, _extends$7({}, slide.props), slide.children);
	  });
	}

	var Swiper$1 = {
	  name: 'Swiper',
	  props: {
	    tag: {
	      type: String,
	      default: 'div'
	    },
	    wrapperTag: {
	      type: String,
	      default: 'div'
	    },
	    init: {
	      type: Boolean,
	      default: undefined
	    },
	    direction: {
	      type: String,
	      default: undefined
	    },
	    touchEventsTarget: {
	      type: String,
	      default: undefined
	    },
	    initialSlide: {
	      type: Number,
	      default: undefined
	    },
	    speed: {
	      type: Number,
	      default: undefined
	    },
	    cssMode: {
	      type: Boolean,
	      default: undefined
	    },
	    updateOnWindowResize: {
	      type: Boolean,
	      default: undefined
	    },
	    nested: {
	      type: Boolean,
	      default: undefined
	    },
	    width: {
	      type: Number,
	      default: undefined
	    },
	    height: {
	      type: Number,
	      default: undefined
	    },
	    preventInteractionOnTransition: {
	      type: Boolean,
	      default: undefined
	    },
	    userAgent: {
	      type: String,
	      default: undefined
	    },
	    url: {
	      type: String,
	      default: undefined
	    },
	    edgeSwipeDetection: {
	      type: Boolean,
	      default: undefined
	    },
	    edgeSwipeThreshold: {
	      type: Number,
	      default: undefined
	    },
	    freeMode: {
	      type: Boolean,
	      default: undefined
	    },
	    freeModeMomentum: {
	      type: Boolean,
	      default: undefined
	    },
	    freeModeMomentumRatio: {
	      type: Number,
	      default: undefined
	    },
	    freeModeMomentumBounce: {
	      type: Boolean,
	      default: undefined
	    },
	    freeModeMomentumBounceRatio: {
	      type: Number,
	      default: undefined
	    },
	    freeModeMomentumVelocityRatio: {
	      type: Number,
	      default: undefined
	    },
	    freeModeSticky: {
	      type: Boolean,
	      default: undefined
	    },
	    freeModeMinimumVelocity: {
	      type: Number,
	      default: undefined
	    },
	    autoHeight: {
	      type: Boolean,
	      default: undefined
	    },
	    setWrapperSize: {
	      type: Boolean,
	      default: undefined
	    },
	    virtualTranslate: {
	      type: Boolean,
	      default: undefined
	    },
	    effect: {
	      type: String,
	      default: undefined
	    },
	    breakpoints: {
	      type: Object,
	      default: undefined
	    },
	    spaceBetween: {
	      type: Number,
	      default: undefined
	    },
	    slidesPerView: {
	      type: [Number, String],
	      default: undefined
	    },
	    slidesPerColumn: {
	      type: Number,
	      default: undefined
	    },
	    slidesPerColumnFill: {
	      type: String,
	      default: undefined
	    },
	    slidesPerGroup: {
	      type: Number,
	      default: undefined
	    },
	    slidesPerGroupSkip: {
	      type: Number,
	      default: undefined
	    },
	    centeredSlides: {
	      type: Boolean,
	      default: undefined
	    },
	    centeredSlidesBounds: {
	      type: Boolean,
	      default: undefined
	    },
	    slidesOffsetBefore: {
	      type: Number,
	      default: undefined
	    },
	    slidesOffsetAfter: {
	      type: Number,
	      default: undefined
	    },
	    normalizeSlideIndex: {
	      type: Boolean,
	      default: undefined
	    },
	    centerInsufficientSlides: {
	      type: Boolean,
	      default: undefined
	    },
	    watchOverflow: {
	      type: Boolean,
	      default: undefined
	    },
	    roundLengths: {
	      type: Boolean,
	      default: undefined
	    },
	    touchRatio: {
	      type: Number,
	      default: undefined
	    },
	    touchAngle: {
	      type: Number,
	      default: undefined
	    },
	    simulateTouch: {
	      type: Boolean,
	      default: undefined
	    },
	    shortSwipes: {
	      type: Boolean,
	      default: undefined
	    },
	    longSwipes: {
	      type: Boolean,
	      default: undefined
	    },
	    longSwipesRatio: {
	      type: Number,
	      default: undefined
	    },
	    longSwipesMs: {
	      type: Number,
	      default: undefined
	    },
	    followFinger: {
	      type: Boolean,
	      default: undefined
	    },
	    allowTouchMove: {
	      type: Boolean,
	      default: undefined
	    },
	    threshold: {
	      type: Number,
	      default: undefined
	    },
	    touchMoveStopPropagation: {
	      type: Boolean,
	      default: undefined
	    },
	    touchStartPreventDefault: {
	      type: Boolean,
	      default: undefined
	    },
	    touchStartForcePreventDefault: {
	      type: Boolean,
	      default: undefined
	    },
	    touchReleaseOnEdges: {
	      type: Boolean,
	      default: undefined
	    },
	    uniqueNavElements: {
	      type: Boolean,
	      default: undefined
	    },
	    resistance: {
	      type: Boolean,
	      default: undefined
	    },
	    resistanceRatio: {
	      type: Number,
	      default: undefined
	    },
	    watchSlidesProgress: {
	      type: Boolean,
	      default: undefined
	    },
	    watchSlidesVisibility: {
	      type: Boolean,
	      default: undefined
	    },
	    grabCursor: {
	      type: Boolean,
	      default: undefined
	    },
	    preventClicks: {
	      type: Boolean,
	      default: undefined
	    },
	    preventClicksPropagation: {
	      type: Boolean,
	      default: undefined
	    },
	    slideToClickedSlide: {
	      type: Boolean,
	      default: undefined
	    },
	    preloadImages: {
	      type: Boolean,
	      default: undefined
	    },
	    updateOnImagesReady: {
	      type: Boolean,
	      default: undefined
	    },
	    loop: {
	      type: Boolean,
	      default: undefined
	    },
	    loopAdditionalSlides: {
	      type: Number,
	      default: undefined
	    },
	    loopedSlides: {
	      type: Number,
	      default: undefined
	    },
	    loopFillGroupWithBlank: {
	      type: Boolean,
	      default: undefined
	    },
	    loopPreventsSlide: {
	      type: Boolean,
	      default: undefined
	    },
	    allowSlidePrev: {
	      type: Boolean,
	      default: undefined
	    },
	    allowSlideNext: {
	      type: Boolean,
	      default: undefined
	    },
	    swipeHandler: {
	      type: Boolean,
	      default: undefined
	    },
	    noSwiping: {
	      type: Boolean,
	      default: undefined
	    },
	    noSwipingClass: {
	      type: String,
	      default: undefined
	    },
	    noSwipingSelector: {
	      type: String,
	      default: undefined
	    },
	    passiveListeners: {
	      type: Boolean,
	      default: undefined
	    },
	    containerModifierClass: {
	      type: String,
	      default: undefined
	    },
	    slideClass: {
	      type: String,
	      default: undefined
	    },
	    slideBlankClass: {
	      type: String,
	      default: undefined
	    },
	    slideActiveClass: {
	      type: String,
	      default: undefined
	    },
	    slideDuplicateActiveClass: {
	      type: String,
	      default: undefined
	    },
	    slideVisibleClass: {
	      type: String,
	      default: undefined
	    },
	    slideDuplicateClass: {
	      type: String,
	      default: undefined
	    },
	    slideNextClass: {
	      type: String,
	      default: undefined
	    },
	    slideDuplicateNextClass: {
	      type: String,
	      default: undefined
	    },
	    slidePrevClass: {
	      type: String,
	      default: undefined
	    },
	    slideDuplicatePrevClass: {
	      type: String,
	      default: undefined
	    },
	    wrapperClass: {
	      type: String,
	      default: undefined
	    },
	    runCallbacksOnInit: {
	      type: Boolean,
	      default: undefined
	    },
	    a11y: {
	      type: [Boolean, Object],
	      default: undefined
	    },
	    autoplay: {
	      type: [Boolean, Object],
	      default: undefined
	    },
	    controller: {
	      type: Object,
	      default: undefined
	    },
	    coverflowEffect: {
	      type: Object,
	      default: undefined
	    },
	    cubeEffect: {
	      type: Object,
	      default: undefined
	    },
	    fadeEffect: {
	      type: Object,
	      default: undefined
	    },
	    flipEffect: {
	      type: Object,
	      default: undefined
	    },
	    hashNavigation: {
	      type: [Boolean, Object],
	      default: undefined
	    },
	    history: {
	      type: [Boolean, Object],
	      default: undefined
	    },
	    keyboard: {
	      type: [Boolean, Object],
	      default: undefined
	    },
	    lazy: {
	      type: [Boolean, Object],
	      default: undefined
	    },
	    mousewheel: {
	      type: [Boolean, Object],
	      default: undefined
	    },
	    navigation: {
	      type: [Boolean, Object],
	      default: undefined
	    },
	    pagination: {
	      type: [Boolean, Object],
	      default: undefined
	    },
	    parallax: {
	      type: [Boolean, Object],
	      default: undefined
	    },
	    scrollbar: {
	      type: [Boolean, Object],
	      default: undefined
	    },
	    thumbs: {
	      type: Object,
	      default: undefined
	    },
	    virtual: {
	      type: [Boolean, Object],
	      default: undefined
	    },
	    zoom: {
	      type: [Boolean, Object],
	      default: undefined
	    }
	  },
	  emits: ['_beforeBreakpoint', '_containerClasses', '_slideClass', '_swiper', 'activeIndexChange', 'afterInit', 'autoplay', 'autoplayStart', 'autoplayStop', 'beforeDestroy', 'beforeInit', 'beforeLoopFix', 'beforeResize', 'beforeSlideChangeStart', 'beforeTransitionStart', 'breakpoint', 'changeDirection', 'click', 'doubleTap', 'doubleClick', 'destroy', 'fromEdge', 'hashChange', 'hashSet', 'imagesReady', 'init', 'keyPress', 'lazyImageLoad', 'lazyImageReady', 'loopFix', 'momentumBounce', 'navigationHide', 'navigationShow', 'observerUpdate', 'orientationchange', 'paginationHide', 'paginationRender', 'paginationShow', 'paginationUpdate', 'progress', 'reachBeginning', 'reachEnd', 'realIndexChange', 'resize', 'scroll', 'scrollbarDragEnd', 'scrollbarDragMove', 'scrollbarDragStart', 'setTransition', 'setTranslate', 'slideChange', 'slideChangeTransitionEnd', 'slideChangeTransitionStart', 'slideNextTransitionEnd', 'slideNextTransitionStart', 'slidePrevTransitionEnd', 'slidePrevTransitionStart', 'slideResetTransitionStart', 'slideResetTransitionEnd', 'sliderMove', 'sliderFirstMove', 'slidesLengthChange', 'slidesGridLengthChange', 'snapGridLengthChange', 'snapIndexChange', 'swiper', 'tap', 'toEdge', 'touchEnd', 'touchMove', 'touchMoveOpposite', 'touchStart', 'transitionEnd', 'transitionStart', 'update', 'zoomChange'],
	  setup: function setup(props, _ref) {
	    var originalSlots = _ref.slots,
	        emit = _ref.emit;
	    var Tag = props.tag,
	        WrapperTag = props.wrapperTag;
	    var containerClasses = ref('swiper-container');
	    var virtualData = ref(null);
	    var breakpointChanged = ref(false);
	    var initializedRef = ref(false);
	    var swiperElRef = ref(null);
	    var swiperRef = ref(null);
	    var oldPassedParamsRef = ref(null);
	    var slidesRef = {
	      value: []
	    };
	    var oldSlidesRef = {
	      value: []
	    };
	    var nextElRef = ref(null);
	    var prevElRef = ref(null);
	    var paginationElRef = ref(null);
	    var scrollbarElRef = ref(null);

	    var _getParams = getParams(props),
	        swiperParams = _getParams.params,
	        passedParams = _getParams.passedParams;

	    getChildren$1(originalSlots, slidesRef, oldSlidesRef);
	    oldPassedParamsRef.value = passedParams;
	    oldSlidesRef.value = slidesRef.value;

	    var onBeforeBreakpoint = function onBeforeBreakpoint() {
	      getChildren$1(originalSlots, slidesRef, oldSlidesRef);
	      breakpointChanged.value = true;
	    };

	    swiperParams.onAny = function (event) {
	      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }

	      emit.apply(void 0, [event].concat(args));
	    };

	    Object.assign(swiperParams.on, {
	      _beforeBreakpoint: onBeforeBreakpoint,
	      _containerClasses: function _containerClasses(swiper, classes) {
	        containerClasses.value = classes;
	      },
	      _swiper: function _swiper(swiper) {
	        swiper.loopCreate = function () {};

	        swiper.loopDestroy = function () {};

	        if (swiperParams.loop) {
	          swiper.loopedSlides = calcLoopedSlides(slidesRef.value, swiperParams);
	        }

	        swiperRef.value = swiper;

	        if (swiper.virtual && swiper.params.virtual.enabled) {
	          swiper.virtual.slides = slidesRef.value;
	          swiper.params.virtual.cache = false;

	          swiper.params.virtual.renderExternal = function (data) {
	            virtualData.value = data;
	          };

	          swiper.params.virtual.renderExternalUpdate = false;
	        }
	      }
	    });
	    onUpdated(function () {
	      // set initialized flag
	      if (!initializedRef.value && swiperRef.value) {
	        swiperRef.value.emitSlidesClasses();
	        initializedRef.value = true;
	      } // watch for params change


	      var _getParams2 = getParams(props),
	          newPassedParams = _getParams2.passedParams;

	      var changedParams = getChangedParams(newPassedParams, oldPassedParamsRef.value, slidesRef.value, oldSlidesRef.value);
	      oldPassedParamsRef.value = newPassedParams;

	      if ((changedParams.length || breakpointChanged.value) && swiperRef.value && !swiperRef.value.destroyed) {
	        updateSwiper(swiperRef.value, slidesRef.value, newPassedParams, changedParams);
	      }

	      breakpointChanged.value = false;
	    }); // update on virtual update

	    watch(virtualData, function () {
	      updateOnVirtualData(swiperRef.value);
	    }); // init swiper

	    onMounted(function () {
	      if (!swiperElRef.value) return;
	      initSwiper({
	        el: swiperElRef.value,
	        nextEl: nextElRef.value,
	        prevEl: prevElRef.value,
	        paginationEl: paginationElRef.value,
	        scrollbarEl: scrollbarElRef.value
	      }, swiperParams);
	      emit('swiper', swiperRef.value);
	    });
	    onBeforeUnmount(function () {
	      if (swiperRef.value && !swiperRef.value.destroyed) {
	        swiperRef.value.destroy(true, false);
	      }
	    }); // bypass swiper instance to slides

	    function renderSlides(slides) {
	      if (swiperParams.virtual) {
	        return renderVirtual(swiperRef, slides, virtualData.value);
	      }

	      if (!swiperParams.loop || swiperRef.value && swiperRef.value.destroyed) {
	        slides.forEach(function (slide) {
	          if (!slide.props) slide.props = {};
	          slide.props.swiperRef = swiperRef;
	        });
	        return slides;
	      }

	      return renderLoop(swiperRef, slides, swiperParams);
	    }

	    return function () {
	      var _getChildren = getChildren$1(originalSlots, slidesRef, oldSlidesRef),
	          slides = _getChildren.slides,
	          slots = _getChildren.slots;

	      return h(Tag, {
	        ref: swiperElRef,
	        class: uniqueClasses(containerClasses.value)
	      }, [slots['container-start'], needsNavigation(props) && [h('div', {
	        ref: prevElRef,
	        class: 'swiper-button-prev'
	      }), h('div', {
	        ref: nextElRef,
	        class: 'swiper-button-next'
	      })], needsScrollbar(props) && h('div', {
	        ref: scrollbarElRef,
	        class: 'swiper-scrollbar'
	      }), needsPagination(props) && h('div', {
	        ref: paginationElRef,
	        class: 'swiper-pagination'
	      }), h(WrapperTag, {
	        class: 'swiper-wrapper'
	      }, [slots['wrapper-start'], renderSlides(slides), slots['wrapper-end']]), slots['container-end']]);
	    };
	  }
	};

	var SwiperSlide = {
	  name: 'SwiperSlide',
	  props: {
	    tag: {
	      type: String,
	      default: 'div'
	    },
	    swiperRef: Object,
	    zoom: {
	      type: Boolean,
	      default: undefined
	    },
	    virtualIndex: {
	      type: [String, Number],
	      default: undefined
	    }
	  },
	  setup: function setup(props, _ref) {
	    var slots = _ref.slots;
	    var eventAttached = false;
	    var swiperRef = props.swiperRef;
	    var slideElRef = ref(null);
	    var slideClasses = ref('swiper-slide');

	    function updateClasses(swiper, el, classNames) {
	      if (el === slideElRef.value) {
	        slideClasses.value = classNames;
	      }
	    }

	    onMounted(function () {
	      if (!swiperRef.value) return;
	      swiperRef.value.on('_slideClass', updateClasses);
	      eventAttached = true;
	    });
	    onBeforeUpdate(function () {
	      if (eventAttached || !swiperRef || !swiperRef.value) return;
	      swiperRef.value.on('_slideClass', updateClasses);
	      eventAttached = true;
	    });
	    onUpdated(function () {
	      if (!slideElRef.value || !swiperRef || !swiperRef.value) return;

	      if (swiperRef.value.destroyed) {
	        if (slideClasses.value !== 'swiper-slide') {
	          slideClasses.value = 'swiper-slide';
	        }
	      }
	    });
	    onBeforeUnmount(function () {
	      if (!swiperRef || !swiperRef.value) return;
	      swiperRef.value.off('_slideClass', updateClasses);
	    });
	    var slideData = computed$1(function () {
	      return {
	        isActive: slideClasses.value.indexOf('swiper-slide-active') >= 0 || slideClasses.value.indexOf('swiper-slide-duplicate-active') >= 0,
	        isVisible: slideClasses.value.indexOf('swiper-slide-visible') >= 0,
	        isDuplicate: slideClasses.value.indexOf('swiper-slide-duplicate') >= 0,
	        isPrev: slideClasses.value.indexOf('swiper-slide-prev') >= 0 || slideClasses.value.indexOf('swiper-slide-duplicate-prev') >= 0,
	        isNext: slideClasses.value.indexOf('swiper-slide-next') >= 0 || slideClasses.value.indexOf('swiper-slide-duplicate-next') >= 0
	      };
	    });
	    return function () {
	      return h(props.tag, {
	        class: uniqueClasses("" + slideClasses.value),
	        ref: slideElRef,
	        'data-swiper-slide-index': props.virtualIndex
	      }, props.zoom ? h('div', {
	        class: 'swiper-zoom-container',
	        'data-swiper-zoom': typeof props.zoom === 'number' ? props.zoom : undefined
	      }, slots.default && slots.default(slideData.value)) : slots.default && slots.default(slideData.value));
	    };
	  }
	};

	var script$H = {
		components: {
			'v-swiper-slide': SwiperSlide
		},

		mixins: [
			script$2
		],

		props: {
			options: {
				type: Object,
				default: null
			},
			pagination: {
				type: Object,
				default: null
			}
		},

		data() {
			return {
				slider: {},
				uniqueId: uniqueId('swiper-')
			};
		},

		computed: {
			computedOptions() {
				let result = {
					watchOverflow: true,
					slidesPerView: 1,
					spaceBetween: 0,
					speed: 600,
					loop: this.slider.slides.length > 1,
					// effect: 'fade',
					// fadeEffect: {
					// 	crossFade: true
					// },
				};
				if (this.options) {
					Object.keys(this.options).forEach((key) => {
						if (typeof this.options[key] !== 'undefined') {
							result[key] = this.options[key];
						}
					});
				}
				return result;
			},
		},

		mounted() {
			this.$refs.swiperSlider;
		},

		methods: {
			dataSet(data) {
				this.slider = data;

				if (this.slider?.slides?.length) {
					this.$nextTick(() => {
						this.$refs.swiperSlider.dataNavigation = {
							nextEl: this.$refs.next,
							prevEl: this.$refs.prev,
						};
					});
				}
			}
		},
	};

	const _hoisted_1$A = { class: "v-hero-slider hero-slider" };
	const _hoisted_2$v = {
	  class: "hero-slider__arrow hero-slider__arrow--prev",
	  ref: "prev"
	};
	const _hoisted_3$q = /*#__PURE__*/createVNode("svg", { class: "svg-icon hero-slider__icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-left-slider" })
	], -1 /* HOISTED */);
	const _hoisted_4$j = {
	  class: "hero-slider__arrow hero-slider__arrow--next",
	  ref: "next"
	};
	const _hoisted_5$g = /*#__PURE__*/createVNode("svg", { class: "svg-icon hero-slider__icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-slider" })
	], -1 /* HOISTED */);

	function render$J(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_hero_block = resolveComponent("v-hero-block");
	  const _component_v_swiper_slide = resolveComponent("v-swiper-slide");
	  const _component_v_swiper_slider = resolveComponent("v-swiper-slider");

	  return (openBlock(), createBlock("div", _hoisted_1$A, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    createVNode("div", _hoisted_2$v, [
	      _hoisted_3$q
	    ], 512 /* NEED_PATCH */),
	    createVNode("div", _hoisted_4$j, [
	      _hoisted_5$g
	    ], 512 /* NEED_PATCH */),
	    ($data.slider?.slides?.length)
	      ? (openBlock(), createBlock(_component_v_swiper_slider, {
	          options: $options.computedOptions,
	          key: $data.uniqueId,
	          pagination: $props.pagination,
	          navigation: "navigation",
	          ref: "swiperSlider"
	        }, {
	          main: withCtx(() => [
	            (openBlock(true), createBlock(Fragment, null, renderList($data.slider.slides, (slide, index) => {
	              return (openBlock(), createBlock(_component_v_swiper_slide, {
	                key: slide.id || index
	              }, {
	                default: withCtx(() => [
	                  createVNode(_component_v_hero_block, { "data-source": slide }, null, 8 /* PROPS */, ["data-source"])
	                ]),
	                _: 2 /* DYNAMIC */
	              }, 1024 /* DYNAMIC_SLOTS */))
	            }), 128 /* KEYED_FRAGMENT */))
	          ]),
	          _: 1 /* STABLE */
	        }, 8 /* PROPS */, ["options", "pagination"]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$H.render = render$J;
	script$H.__file = "local/assets/source/components/v-hero-slider.vue";

	var script$I = {
		mixins: [
			script$y
		],

		props: {
			price: {
				type: Object,
				default: null
			},

			size: {
				type: String,
				default: 'md'
			}
		}
	};

	const _hoisted_1$B = {
	  key: 0,
	  class: "price__group"
	};
	const _hoisted_2$w = {
	  key: 0,
	  class: "price__prefix"
	};
	const _hoisted_3$r = {
	  key: 1,
	  class: "price__value"
	};
	const _hoisted_4$k = /*#__PURE__*/createVNode("span", { class: "price__value" }, " - ", -1 /* HOISTED */);
	const _hoisted_5$h = {
	  key: 0,
	  class: "price__value"
	};
	const _hoisted_6$g = {
	  key: 1,
	  class: "price__currency"
	};
	const _hoisted_7$e = {
	  key: 2,
	  class: "price__unit"
	};
	const _hoisted_8$a = {
	  key: 0,
	  class: "price__prefix"
	};
	const _hoisted_9$a = {
	  key: 1,
	  class: "price__value"
	};
	const _hoisted_10$7 = {
	  key: 2,
	  class: "price__value"
	};
	const _hoisted_11$7 = {
	  key: 3,
	  class: "price__currency"
	};
	const _hoisted_12$7 = {
	  key: 4,
	  class: "price__unit"
	};
	const _hoisted_13$6 = {
	  key: 1,
	  class: "price__caption"
	};
	const _hoisted_14$6 = {
	  key: 2,
	  class: "price__group price__group--old"
	};
	const _hoisted_15$6 = {
	  key: 0,
	  class: "price__prefix"
	};
	const _hoisted_16$5 = {
	  key: 1,
	  class: "price__value"
	};
	const _hoisted_17$3 = {
	  key: 2,
	  class: "price__currency"
	};
	const _hoisted_18$2 = {
	  key: 3,
	  class: "price__unit"
	};

	function render$K(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", {
	    class: ["v-price price", ['price--' + $props.size, $props.price.view ? 'price--' + $props.price.view : '']]
	  }, [
	    ($props.price)
	      ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	          ($props.price.min)
	            ? (openBlock(), createBlock("div", _hoisted_1$B, [
	                ($props.price.min.prefix)
	                  ? (openBlock(), createBlock("span", _hoisted_2$w, toDisplayString($props.price.min.prefix) + " ", 1 /* TEXT */))
	                  : createCommentVNode("v-if", true),
	                ($props.price.min.value)
	                  ? (openBlock(), createBlock("span", _hoisted_3$r, toDisplayString(_ctx.formatPrice($props.price.min.value)) + " ", 1 /* TEXT */))
	                  : createCommentVNode("v-if", true),
	                ($props.price.max)
	                  ? (openBlock(), createBlock(Fragment, { key: 2 }, [
	                      _hoisted_4$k,
	                      ($props.price.max.value)
	                        ? (openBlock(), createBlock("span", _hoisted_5$h, toDisplayString(_ctx.formatPrice($props.price.max.value)) + " ", 1 /* TEXT */))
	                        : createCommentVNode("v-if", true),
	                      ($props.price.max.currency)
	                        ? (openBlock(), createBlock("span", _hoisted_6$g, toDisplayString($props.price.max.currency), 1 /* TEXT */))
	                        : createCommentVNode("v-if", true),
	                      ($props.price.max.unit)
	                        ? (openBlock(), createBlock("span", _hoisted_7$e, " " + toDisplayString($props.price.max.unit), 1 /* TEXT */))
	                        : createCommentVNode("v-if", true)
	                    ], 64 /* STABLE_FRAGMENT */))
	                  : createCommentVNode("v-if", true)
	              ]))
	            : (openBlock(), createBlock(Fragment, { key: 1 }, [
	                ($props.price.current)
	                  ? (openBlock(), createBlock("div", {
	                      key: 0,
	                      class: ["price__group", {'price__group--new': $props.price.old}]
	                    }, [
	                      ($props.price.current.prefix)
	                        ? (openBlock(), createBlock("span", _hoisted_8$a, toDisplayString($props.price.current.prefix) + " ", 1 /* TEXT */))
	                        : createCommentVNode("v-if", true),
	                      ($props.price.current.valueText)
	                        ? (openBlock(), createBlock("span", _hoisted_9$a, toDisplayString($props.price.current.valueText) + " ", 1 /* TEXT */))
	                        : ($props.price.current.value)
	                          ? (openBlock(), createBlock("span", _hoisted_10$7, toDisplayString(_ctx.formatPrice($props.price.current.value)) + " ", 1 /* TEXT */))
	                          : createCommentVNode("v-if", true),
	                      ($props.price.current.currency)
	                        ? (openBlock(), createBlock("span", _hoisted_11$7, toDisplayString($props.price.current.currency), 1 /* TEXT */))
	                        : createCommentVNode("v-if", true),
	                      ($props.price.current.unit)
	                        ? (openBlock(), createBlock("span", _hoisted_12$7, " " + toDisplayString($props.price.current.unit), 1 /* TEXT */))
	                        : createCommentVNode("v-if", true)
	                    ], 2 /* CLASS */))
	                  : createCommentVNode("v-if", true),
	                ($props.price.view === 'discount')
	                  ? (openBlock(), createBlock("div", _hoisted_13$6, "ваша цена"))
	                  : createCommentVNode("v-if", true),
	                ($props.price.old)
	                  ? (openBlock(), createBlock("div", _hoisted_14$6, [
	                      ($props.price.old.prefix)
	                        ? (openBlock(), createBlock("span", _hoisted_15$6, toDisplayString($props.price.old.prefix) + " ", 1 /* TEXT */))
	                        : createCommentVNode("v-if", true),
	                      ($props.price.old.value)
	                        ? (openBlock(), createBlock("span", _hoisted_16$5, toDisplayString(_ctx.formatPrice($props.price.old.value)) + " ", 1 /* TEXT */))
	                        : createCommentVNode("v-if", true),
	                      ($props.price.old.currency)
	                        ? (openBlock(), createBlock("span", _hoisted_17$3, toDisplayString($props.price.old.currency), 1 /* TEXT */))
	                        : createCommentVNode("v-if", true),
	                      ($props.price.old.unit)
	                        ? (openBlock(), createBlock("span", _hoisted_18$2, " " + toDisplayString($props.price.old.unit), 1 /* TEXT */))
	                        : createCommentVNode("v-if", true)
	                    ]))
	                  : createCommentVNode("v-if", true)
	              ], 64 /* STABLE_FRAGMENT */))
	        ], 64 /* STABLE_FRAGMENT */))
	      : createCommentVNode("v-if", true)
	  ], 2 /* CLASS */))
	}

	script$I.render = render$K;
	script$I.__file = "local/assets/source/components/v-price.vue";

	var script$J = {
		props: {
			status: {
				type: Array,
				default: null
			}
		}
	};

	const _hoisted_1$C = { class: "v-status status" };
	const _hoisted_2$x = {
	  key: 0,
	  class: "status__list"
	};
	const _hoisted_3$s = { class: "status__item" };

	function render$L(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$C, [
	    ($props.status)
	      ? (openBlock(), createBlock("div", _hoisted_2$x, [
	          (openBlock(true), createBlock(Fragment, null, renderList($props.status, (item) => {
	            return (openBlock(), createBlock("div", _hoisted_3$s, [
	              createVNode("div", {
	                class: "status-label",
	                style: {'background': item.background, 'color': item.color}
	              }, toDisplayString(item.text), 5 /* TEXT, STYLE */)
	            ]))
	          }), 256 /* UNKEYED_FRAGMENT */))
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$J.render = render$L;
	script$J.__file = "local/assets/source/components/v-status.vue";

	var script$K = {
		props: {
			label: {
				type: Array,
				default: function () {
					return []
				}
			},
		},
	};

	const _hoisted_1$D = { class: "v-label label" };
	const _hoisted_2$y = { class: "label__list" };
	const _hoisted_3$t = {
	  key: 0,
	  class: "label__item-text"
	};
	const _hoisted_4$l = {
	  key: 1,
	  class: "label__item-icon"
	};
	const _hoisted_5$i = { class: "svg-icon" };

	function render$M(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$D, [
	    createVNode("div", _hoisted_2$y, [
	      (openBlock(true), createBlock(Fragment, null, renderList($props.label, (labelItem) => {
	        return (openBlock(), createBlock("div", {
	          class: "label__item",
	          style: {color: labelItem.color, background: labelItem.background}
	        }, [
	          (labelItem.text)
	            ? (openBlock(), createBlock("div", _hoisted_3$t, toDisplayString(labelItem.text), 1 /* TEXT */))
	            : createCommentVNode("v-if", true),
	          (labelItem.icon)
	            ? (openBlock(), createBlock("div", _hoisted_4$l, [
	                (openBlock(), createBlock("svg", _hoisted_5$i, [
	                  createVNode("use", {
	                    "xlink:href": '/local/assets/dist/icons/sprite.svg#svg-icon-' + labelItem.icon
	                  }, null, 8 /* PROPS */, ["xlink:href"])
	                ]))
	              ]))
	            : createCommentVNode("v-if", true)
	        ], 4 /* STYLE */))
	      }), 256 /* UNKEYED_FRAGMENT */))
	    ])
	  ]))
	}

	script$K.render = render$M;
	script$K.__file = "local/assets/source/components/v-label.vue";

	var script$L = {
		mixins: [
			script$2
		],

		data() {
			return {
				catalog: null,
				state: {
					pages: null,
					sort: null,
					filter: null
				},
				changedFilters: null,
				asideOpen: false,
				scrollTimeout: null,
				openDescription: false,
			};
		},

		computed: {
			computedAutoScroll() {
				return this.catalog?.pages?.autoload && controller.touch && this.catalog?.pages?.offset / this.catalog?.pages?.limit < 3;
			},

			computedProductsText() {
				if (this.catalog.quantity % 10 === 1 && this.catalog.quantity !== 11) {
					return 'товар'
				} else if (this.catalog.quantity % 10 > 1 && this.catalog.quantity % 10 < 5) {
					return 'товара'
				} else {
					return 'товаров'
				}
			},
		},

		watch: {
			catalog() {
				if (this.catalog && this.catalog.pages && this.catalog.pages.autoload) {
					this.bindScroll();
				}
			}
		},

		created() {
			this.bindScroll();
		},

		mounted() {
			this.$nextTick(() => {
				View.initAllLocal(this.$el);
			});
		},

		updated() {
			this.$nextTick(() => {
				View.initAllLocal(this.$el);
			});
		},

		methods: {
			isEmptyObj(obj) {
				for (let key in obj) {
					return false;
				}
				return true;
			},

			dataSet(data, options = {}) {
				if (options.append && this.catalog && this.catalog.items) {
					let oldItems = this.catalog.items;
					this.catalog = data;
					this.catalog.items = oldItems.concat(this.catalog.items);
				} else {
					this.catalog = data;
				}

				if (options.setPage) {
					controller.scrollTop();
				}

				this.state.sort = this.catalog.sort ? this.catalog.sort.value : null;
				this.state.pages = this.catalog.pages;
			},

			navigate(pages) {
				this.state.pages.offset = pages.offset;
				this.state.pages.limit = pages.limit;
				this.requestDataLoad({append: pages.append, setPage: !pages.append});
			},

			loadMore() {
				if (!this.catalog.pages) {
					return;
				}
				this.state.pages.offset = parseInt(this.catalog.pages.offset) + parseInt(this.catalog.pages.limit);
				this.state.pages.limit = this.catalog.pages.limit;
				this.requestDataLoad({append: this.catalog.pages.append});
			},

			bindScroll() {
				document.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
			},

			handleScroll() {
				if (this.computedAutoScroll && this.$refs?.products && !this.scrollTimeout) {
					this.scrollTimeout = setTimeout(() => {
						if (!this.loading && parseInt(this.catalog.pages.count) > parseInt(this.catalog.pages.offset) + parseInt(this.catalog.pages.limit)
							&& this.$refs.products.getBoundingClientRect().bottom <= window.innerHeight) {
							this.loadMore();
						}
						this.scrollTimeout = null;
					}, 200);
				}
			},

			filterUpdated(filterValue, changedFilters) {
				this.state.filter = filterValue;
				this.changedFilters = changedFilters;

				// update url except markup pages
				if (window.location.pathname.indexOf('/local/') < 0 && window.location.pathname + window.location.search != this.catalog.remote) {
					window.history.pushState(null, null, this.catalog.remote);
				}
			},

			filterChanged(filterValue) {
				this.state.filter = filterValue;
				this.requestDataLoad();
			},

			sortChanged() {
				this.state.pages.offset = 0;
				controller.closeSort();
				this.requestDataLoad();
			},

			requestDataLoad(dataSetOptions) {
				if (this.loading) {
					return;
				}

				this.dataLoad({
					url: this.catalog.remote,
					delay: true,
					data: {
						pages: this.state.pages,
						sort: this.state.sort,
						filter: this.isEmptyObj(this.state.filter) ? {'empty': true} : this.state.filter
					}
				}, dataSetOptions);
			},

			toggleAside() {
				controller.toggleClassPage('open-filter');
			},

			toggleSort() {
				controller.toggleClassPage('open-sort');
			},

			resetFilter(e) {
				if (this.$refs.filter){
					this.$refs.filter.resetFilter(e);
				}
			},

			resetAllFilters(e) {
				if (this.$refs.filter){
					this.$refs.filter.resetAll(e);
				}
			},

			toggleDescription() {
				this.openDescription = !this.openDescription;
			},
		}
	};

	const _hoisted_1$E = { class: "v-catalog catalog" };
	const _hoisted_2$z = {
	  key: 0,
	  class: "container"
	};
	const _hoisted_3$u = {
	  class: "catalog__list-message flc",
	  key: "no-items"
	};
	const _hoisted_4$m = {
	  key: 0,
	  class: "catalog__list-message-title h3 flc"
	};
	const _hoisted_5$j = /*#__PURE__*/createVNode("div", { class: "catalog__list-message-body flc" }, "Попробуйте изменить параметры поиска или перейдите на главную страницу.", -1 /* HOISTED */);
	const _hoisted_6$h = { class: "catalog__list-message-actions flc" };
	const _hoisted_7$f = { class: "catalog__list-message-actions-grid" };
	const _hoisted_8$b = {
	  key: 1,
	  class: "catalog__list-message-action"
	};
	const _hoisted_9$b = /*#__PURE__*/createVNode("div", { class: "catalog__list-message-action" }, [
	  /*#__PURE__*/createVNode("a", {
	    class: "btn",
	    href: "/"
	  }, "На главную страницу")
	], -1 /* HOISTED */);
	const _hoisted_10$8 = { class: "catalog__header" };
	const _hoisted_11$8 = {
	  key: 0,
	  class: "page-title"
	};
	const _hoisted_12$8 = { class: "h2 page-title__value" };
	const _hoisted_13$7 = /*#__PURE__*/createTextVNode();
	const _hoisted_14$7 = {
	  key: 0,
	  class: "catalog__qauntity"
	};
	const _hoisted_15$7 = {
	  key: 1,
	  class: "fixed-block fixed-block--animate js-fixed--up hidden-lg hidden-md"
	};
	const _hoisted_16$6 = { class: "catalog__toolbar fixed-block__content js-fixed__content" };
	const _hoisted_17$4 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-sort" })
	], -1 /* HOISTED */);
	const _hoisted_18$3 = /*#__PURE__*/createVNode("span", null, "Сортировка", -1 /* HOISTED */);
	const _hoisted_19$2 = /*#__PURE__*/createVNode("svg", { class: "svg-icon svg-icon--active" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-filter-active" })
	], -1 /* HOISTED */);
	const _hoisted_20$2 = /*#__PURE__*/createVNode("svg", { class: "svg-icon svg-icon--inactive" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-filter" })
	], -1 /* HOISTED */);
	const _hoisted_21$2 = /*#__PURE__*/createVNode("span", null, "Фильтр", -1 /* HOISTED */);
	const _hoisted_22$2 = {
	  key: 0,
	  class: "catalog__links flc"
	};
	const _hoisted_23$2 = { class: "catalog__layout" };
	const _hoisted_24$1 = {
	  key: 0,
	  class: "catalog__layout-sort hidden-lg hidden-md"
	};
	const _hoisted_25$1 = { class: "mobile-popup mobile-popup--sort" };
	const _hoisted_26$1 = /*#__PURE__*/createVNode("div", { class: "mobile-popup__overlay js-detect-swipe js-overlay" }, null, -1 /* HOISTED */);
	const _hoisted_27$1 = { class: "mobile-popup__wrapper" };
	const _hoisted_28$1 = { class: "mobile-popup__header js-detect-swipe" };
	const _hoisted_29$1 = /*#__PURE__*/createVNode("div", { class: "mobile-popup__title" }, "Сортировка", -1 /* HOISTED */);
	const _hoisted_30$1 = { class: "mobile-popup__body" };
	const _hoisted_31$1 = {
	  key: 1,
	  class: "catalog__layout-aside"
	};
	const _hoisted_32$1 = { class: "mobile-popup mobile-popup--filter" };
	const _hoisted_33$1 = /*#__PURE__*/createVNode("div", { class: "mobile-popup__overlay js-detect-swipe js-overlay" }, null, -1 /* HOISTED */);
	const _hoisted_34$1 = { class: "mobile-popup__wrapper" };
	const _hoisted_35$1 = { class: "mobile-popup__header js-detect-swipe" };
	const _hoisted_36$1 = /*#__PURE__*/createVNode("div", { class: "mobile-popup__title" }, "Фильтр", -1 /* HOISTED */);
	const _hoisted_37$1 = { class: "mobile-popup__body" };
	const _hoisted_38$1 = {
	  key: 0,
	  class: "catalog__filter flc"
	};
	const _hoisted_39$1 = { class: "catalog__layout-main" };
	const _hoisted_40$1 = {
	  key: 1,
	  class: "catalog__top-nav flc hidden-sm hidden-xs"
	};
	const _hoisted_41$1 = { class: "catalog__top-nav-grid" };
	const _hoisted_42$1 = {
	  key: 0,
	  class: "catalog__top-nav-cell catalog__top-nav-cell--select"
	};
	const _hoisted_43$1 = {
	  class: "catalog__list flc",
	  ref: "products"
	};
	const _hoisted_44$1 = {
	  key: 1,
	  class: "catalog__nav flc"
	};

	function render$N(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_filter = resolveComponent("v-filter");
	  const _component_v_field = resolveComponent("v-field");
	  const _component_v_product_grid = resolveComponent("v-product-grid");
	  const _component_v_article_grid = resolveComponent("v-article-grid");
	  const _component_v_page_nav = resolveComponent("v-page-nav");

	  return (openBlock(), createBlock("div", _hoisted_1$E, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.catalog)
	      ? (openBlock(), createBlock("div", _hoisted_2$z, [
	          (!$data.catalog.items || !$data.catalog.items.length)
	            ? (openBlock(), createBlock("div", _hoisted_3$u, [
	                ($data.catalog.title)
	                  ? (openBlock(), createBlock("div", _hoisted_4$m, toDisplayString($data.catalog.title), 1 /* TEXT */))
	                  : createCommentVNode("v-if", true),
	                _hoisted_5$j,
	                createVNode("div", _hoisted_6$h, [
	                  createVNode("div", _hoisted_7$f, [
	                    ($data.changedFilters && $data.changedFilters.length)
	                      ? (openBlock(), createBlock(_component_v_filter, {
	                          key: 0,
	                          class: "hidden",
	                          ref: "filter",
	                          links: $data.catalog.links,
	                          onFilterChanged: $options.filterChanged
	                        }, null, 8 /* PROPS */, ["links", "onFilterChanged"]))
	                      : createCommentVNode("v-if", true),
	                    ($data.changedFilters && $data.changedFilters.length)
	                      ? (openBlock(), createBlock("div", _hoisted_8$b, [
	                          createVNode("button", {
	                            class: "btn",
	                            type: "button",
	                            onClick: _cache[1] || (_cache[1] = (...args) => ($options.resetAllFilters && $options.resetAllFilters(...args)))
	                          }, "Очистить фильтр")
	                        ]))
	                      : createCommentVNode("v-if", true),
	                    _hoisted_9$b
	                  ])
	                ])
	              ]))
	            : (openBlock(), createBlock(Fragment, { key: 1 }, [
	                createVNode("div", _hoisted_10$8, [
	                  ($data.catalog.title)
	                    ? (openBlock(), createBlock("div", _hoisted_11$8, [
	                        createVNode("h1", _hoisted_12$8, [
	                          createVNode("span", null, toDisplayString($data.catalog.title), 1 /* TEXT */),
	                          _hoisted_13$7,
	                          ($data.catalog.quantity)
	                            ? (openBlock(), createBlock("span", _hoisted_14$7, toDisplayString($data.catalog.quantity) + " " + toDisplayString($options.computedProductsText), 1 /* TEXT */))
	                            : createCommentVNode("v-if", true)
	                        ])
	                      ]))
	                    : createCommentVNode("v-if", true),
	                  ($data.catalog?.items.length)
	                    ? (openBlock(), createBlock("div", _hoisted_15$7, [
	                        createVNode("div", _hoisted_16$6, [
	                          ($data.catalog.sort?.options?.length)
	                            ? (openBlock(), createBlock("button", {
	                                key: 0,
	                                class: "catalog__toolbar-toggle",
	                                type: "button",
	                                onClick: _cache[2] || (_cache[2] = (...args) => ($options.toggleSort && $options.toggleSort(...args))),
	                                "aria-label": "Открыть сортировку",
	                                title: "Открыть сортировку"
	                              }, [
	                                _hoisted_17$4,
	                                _hoisted_18$3
	                              ]))
	                            : createCommentVNode("v-if", true),
	                          ($data.catalog.filters?.length)
	                            ? (openBlock(), createBlock("button", {
	                                key: 1,
	                                class: ["catalog__toolbar-toggle catalog__toolbar-toggle--filter", {'catalog__toolbar-toggle--active': $data.changedFilters?.length}],
	                                type: "button",
	                                onClick: _cache[3] || (_cache[3] = (...args) => ($options.toggleAside && $options.toggleAside(...args))),
	                                "aria-label": "Открыть фильтр",
	                                title: "Открыть фильтр"
	                              }, [
	                                _hoisted_19$2,
	                                _hoisted_20$2,
	                                _hoisted_21$2
	                              ], 2 /* CLASS */))
	                            : createCommentVNode("v-if", true)
	                        ])
	                      ]))
	                    : createCommentVNode("v-if", true)
	                ]),
	                ($data.catalog.links && $data.catalog?.items.length)
	                  ? (openBlock(), createBlock("div", _hoisted_22$2, [
	                      createVNode(_component_v_filter, {
	                        ref: "filter",
	                        links: $data.catalog.links
	                      }, null, 8 /* PROPS */, ["links"])
	                    ]))
	                  : createCommentVNode("v-if", true),
	                createVNode("div", _hoisted_23$2, [
	                  ($data.catalog?.items.length)
	                    ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	                        ($data.catalog?.sort)
	                          ? (openBlock(), createBlock("div", _hoisted_24$1, [
	                              createVNode("div", _hoisted_25$1, [
	                                _hoisted_26$1,
	                                createVNode("div", _hoisted_27$1, [
	                                  createVNode("div", _hoisted_28$1, [
	                                    _hoisted_29$1,
	                                    createVNode("button", {
	                                      class: "mobile-popup__close",
	                                      type: "button",
	                                      "aria-label": "Закрыть сортировку",
	                                      title: "Закрыть сортировку",
	                                      onClick: _cache[4] || (_cache[4] = (...args) => ($options.toggleSort && $options.toggleSort(...args)))
	                                    })
	                                  ]),
	                                  createVNode("div", _hoisted_30$1, [
	                                    createVNode(_component_v_field, {
	                                      field: {type: 'radio-list', options: $data.catalog.sort.options},
	                                      modelValue: $data.state.sort,
	                                      "onUpdate:modelValue": [
	                                        _cache[5] || (_cache[5] = $event => ($data.state.sort = $event)),
	                                        $options.sortChanged
	                                      ]
	                                    }, null, 8 /* PROPS */, ["field", "modelValue", "onUpdate:modelValue"])
	                                  ])
	                                ])
	                              ])
	                            ]))
	                          : createCommentVNode("v-if", true),
	                        ($data.catalog.filters?.length)
	                          ? (openBlock(), createBlock("div", _hoisted_31$1, [
	                              createVNode("div", _hoisted_32$1, [
	                                _hoisted_33$1,
	                                createVNode("div", _hoisted_34$1, [
	                                  createVNode("div", _hoisted_35$1, [
	                                    _hoisted_36$1,
	                                    createVNode("button", {
	                                      class: "mobile-popup__close",
	                                      type: "button",
	                                      "aria-label": "Закрыть фильтр",
	                                      title: "Закрыть фильтр",
	                                      onClick: _cache[6] || (_cache[6] = (...args) => ($options.toggleAside && $options.toggleAside(...args)))
	                                    })
	                                  ]),
	                                  createVNode("div", _hoisted_37$1, [
	                                    ($data.catalog.filters)
	                                      ? (openBlock(), createBlock("div", _hoisted_38$1, [
	                                          createVNode(_component_v_filter, {
	                                            class: "filter--aside",
	                                            ref: "filter",
	                                            quantity: $data.catalog.quantity,
	                                            filters: $data.catalog.filters,
	                                            onFilterChanged: $options.filterChanged,
	                                            onFilterUpdated: $options.filterUpdated,
	                                            onRequestReset: $options.resetFilter,
	                                            onRequestResetAll: $options.resetAllFilters
	                                          }, null, 8 /* PROPS */, ["quantity", "filters", "onFilterChanged", "onFilterUpdated", "onRequestReset", "onRequestResetAll"])
	                                        ]))
	                                      : createCommentVNode("v-if", true)
	                                  ])
	                                ])
	                              ])
	                            ]))
	                          : createCommentVNode("v-if", true)
	                      ], 64 /* STABLE_FRAGMENT */))
	                    : createCommentVNode("v-if", true),
	                  createVNode("div", _hoisted_39$1, [
	                    ($data.catalog?.items.length)
	                      ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	                          ($data.catalog.topText)
	                            ? (openBlock(), createBlock("div", {
	                                key: 0,
	                                class: "catalog__top-text flc",
	                                innerHTML: $data.catalog.topText
	                              }, null, 8 /* PROPS */, ["innerHTML"]))
	                            : createCommentVNode("v-if", true),
	                          ($data.catalog.sort)
	                            ? (openBlock(), createBlock("div", _hoisted_40$1, [
	                                createVNode("div", _hoisted_41$1, [
	                                  ($data.catalog.sort)
	                                    ? (openBlock(), createBlock("div", _hoisted_42$1, [
	                                        createVNode(_component_v_field, {
	                                          class: "field--select-underline",
	                                          field: {type: 'select', placeholder: 'Сортировать:', options: $data.catalog.sort.options},
	                                          modelValue: $data.state.sort,
	                                          "onUpdate:modelValue": [
	                                            _cache[7] || (_cache[7] = $event => ($data.state.sort = $event)),
	                                            $options.sortChanged
	                                          ]
	                                        }, null, 8 /* PROPS */, ["field", "modelValue", "onUpdate:modelValue"])
	                                      ]))
	                                    : createCommentVNode("v-if", true)
	                                ])
	                              ]))
	                            : createCommentVNode("v-if", true)
	                        ], 64 /* STABLE_FRAGMENT */))
	                      : createCommentVNode("v-if", true),
	                    createVNode("div", _hoisted_43$1, [
	                      createVNode(Transition, {
	                        name: "fade",
	                        mode: "out-in"
	                      }, {
	                        default: withCtx(() => [
	                          ($data.catalog.type == 'products')
	                            ? (openBlock(), createBlock(_component_v_product_grid, {
	                                items: $data.catalog.items,
	                                discount: $data.catalog.discountList,
	                                key: "catalog-type-products-grid"
	                              }, null, 8 /* PROPS */, ["items", "discount"]))
	                            : ($data.catalog.type == 'articles')
	                              ? (openBlock(), createBlock(_component_v_article_grid, {
	                                  items: $data.catalog.items,
	                                  key: "catalog-type-articles"
	                                }, null, 8 /* PROPS */, ["items"]))
	                              : createCommentVNode("v-if", true)
	                        ]),
	                        _: 1 /* STABLE */
	                      })
	                    ], 512 /* NEED_PATCH */),
	                    (!$options.computedAutoScroll)
	                      ? (openBlock(), createBlock("div", _hoisted_44$1, [
	                          createVNode(_component_v_page_nav, {
	                            pages: $data.catalog.pages,
	                            onNavigate: $options.navigate
	                          }, null, 8 /* PROPS */, ["pages", "onNavigate"])
	                        ]))
	                      : createCommentVNode("v-if", true),
	                    ($data.catalog.seoText)
	                      ? (openBlock(), createBlock("div", {
	                          key: 2,
	                          class: ["catalog__description", {'catalog__description--open': $data.openDescription}]
	                        }, [
	                          ($data.catalog.seoText)
	                            ? (openBlock(), createBlock("div", {
	                                key: 0,
	                                class: "catalog__description-text",
	                                innerHTML: $data.catalog.seoText
	                              }, null, 8 /* PROPS */, ["innerHTML"]))
	                            : createCommentVNode("v-if", true),
	                          createVNode("button", {
	                            class: "catalog__description-toggle",
	                            type: "button",
	                            onClick: _cache[8] || (_cache[8] = (...args) => ($options.toggleDescription && $options.toggleDescription(...args))),
	                            "aria-label": "Читать полностью",
	                            title: "Читать полностью"
	                          }, "Читать полностью")
	                        ], 2 /* CLASS */))
	                      : createCommentVNode("v-if", true)
	                  ])
	                ])
	              ], 64 /* STABLE_FRAGMENT */))
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$L.render = render$N;
	script$L.__file = "local/assets/source/components/v-catalog.vue";

	var script$M = {
		props: {
			links: {
				type: Array,
				default: null
			},

			filters: {
				type: Array,
				default: null
			},

			quantity: {
				type: [Number, String],
				default: null
			}
		},

		emits: [
			'filter-changed',
			'filter-updated'
		],

		data() {
			return {
				localFilters: [],
				filterDebounceTimeout: null,
				lastChangedFilterId: null
			};
		},

		computed: {
			changedFilters() {
				let result = [];
				this.localFilters.forEach((filter) => {
					if (this.isFilterChanged(filter)) {
						result.push(filter);
					}
				});
				return result;
			}
		},

		watch: {
			filters() {
				this.applyNewFilters();
			}
		},

		created() {
			if (this?.filters?.length) {
				this.applyNewFilters();
			}
		},

		methods: {
			isFilterChanged(filter) {
				if (typeof filter.value == 'number' ||
					(filter.type === 'switch' && filter.value) ||
					(filter.value && filter.value.length && filter.value.length > 0) ||
					(filter.type === 'range' && filter.value && ((filter.value.min > filter.min) || (filter.value.max < filter.max)) ) ||
					(filter.type === 'range-slider' && filter.value && ((filter.value.min > filter.min) || (filter.value.max < filter.max)) )
				) {
					return true;
				}
				return false;
			},

			isFilterBlocked(filterId) {
				return this.lastChangedFilterId && this.lastChangedFilterId !== filterId;
			},

			applyNewFilters() {
				let tmpFilters = [];
				this.filters.forEach((filter) => {
					let oldFilter = this.localFilters.find((item) => item.id === filter.id);
					filter.open = oldFilter ? oldFilter.open : !!filter.open;
					tmpFilters.push(filter);
				});
				this.localFilters = JSON.parse(JSON.stringify(tmpFilters));
				this.$emit('filter-updated', this.createValue(), this.changedFilters);
			},

			resetFilter(options) {
				console.log('resetFilter options', options);
				let filter = this.localFilters.find((filter) => filter.id === options.id);

				if (!filter) {
					return;
				}

				if (filter.type == 'range' || filter.type == 'range-slider') {
					filter.value.min = filter.min;
					filter.value.max = filter.max;
				} else {
					if (options.value && Array.isArray(filter.value)) {
						filter.value.splice(filter.value.indexOf(options.value), 1);
					} else {
						filter.value = [];
					}
				}

				if (!options.silent) {
					this.filterChange();
				}
			},

			resetAll() {
				this.localFilters.forEach((filter) => {
					this.resetFilter({id: filter.id, silent: true});
				});
				this.filterChange();
			},

			createValue() {
				let result = {};
				this.changedFilters.forEach((filter) => {
					result[filter.id] = {value: filter.value, type: filter.type};
				});
				return result;
			},

			filterChange(filterId, fast = false) {
				let time = 1000;
				if (fast) {
					time = 0;
				}
				this.lastChangedFilterId = filterId;
				clearTimeout(this.filterDebounceTimeout);
				this.filterDebounceTimeout = setTimeout(() => {
					this.lastChangedFilterId = null;
					this.$emit('filter-changed', this.createValue(), this.changedFilters);
				}, time);
			},

			closeFilter() {
				controller.closeFilter();
			},
		}
	};

	const _hoisted_1$F = {
	  key: 0,
	  class: "filter__actions flc fcc hidden-lg hidden-md"
	};
	const _hoisted_2$A = { class: "filter__actions-item" };
	const _hoisted_3$v = {
	  key: 0,
	  class: "filter__group filter__group--links flc"
	};
	const _hoisted_4$n = { class: "filter__list" };
	const _hoisted_5$k = { class: "filter__list-item" };
	const _hoisted_6$i = {
	  key: 1,
	  class: "filter__filter-list"
	};
	const _hoisted_7$g = {
	  key: 0,
	  class: "filter__group-title h4 flc"
	};
	const _hoisted_8$c = { class: "filter__group-body flc" };
	const _hoisted_9$c = { class: "filter__actions-bottom" };

	function render$O(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_field = resolveComponent("v-field");

	  return (openBlock(), createBlock("div", {
	    class: ["v-filter filter", {'filter--changed': $options.changedFilters?.length}]
	  }, [
	    createVNode(Transition, { name: "fade" }, {
	      default: withCtx(() => [
	        ($options.changedFilters && $options.changedFilters.length)
	          ? (openBlock(), createBlock("div", _hoisted_1$F, [
	              createVNode("div", _hoisted_2$A, [
	                createVNode("button", {
	                  class: "filter__clear-btn",
	                  type: "button",
	                  onClick: _cache[1] || (_cache[1] = (...args) => ($options.resetAll && $options.resetAll(...args)))
	                }, "Очистить фильтр")
	              ])
	            ]))
	          : createCommentVNode("v-if", true)
	      ]),
	      _: 1 /* STABLE */
	    }),
	    ($props.links)
	      ? (openBlock(), createBlock("div", _hoisted_3$v, [
	          createVNode("ul", _hoisted_4$n, [
	            (openBlock(true), createBlock(Fragment, null, renderList($props.links, (link) => {
	              return (openBlock(), createBlock("li", _hoisted_5$k, [
	                createVNode("a", {
	                  class: ["filter__link", {'filter__link--current': link.current}],
	                  href: link.link,
	                  "data-not-scroll": true
	                }, toDisplayString(link.text), 11 /* TEXT, CLASS, PROPS */, ["href"])
	              ]))
	            }), 256 /* UNKEYED_FRAGMENT */))
	          ])
	        ]))
	      : createCommentVNode("v-if", true),
	    ($data.localFilters?.length)
	      ? (openBlock(), createBlock("div", _hoisted_6$i, [
	          (openBlock(true), createBlock(Fragment, null, renderList($data.localFilters, (filter) => {
	            return (openBlock(), createBlock("div", {
	              class: ["filter__group filter__group--filter flc fcc", ['filter__group--' + filter.type]],
	              key: filter.id
	            }, [
	              (filter.title)
	                ? (openBlock(), createBlock("div", _hoisted_7$g, toDisplayString(filter.title), 1 /* TEXT */))
	                : createCommentVNode("v-if", true),
	              createVNode("div", _hoisted_8$c, [
	                createVNode(_component_v_field, {
	                  field: {...filter, disabled: $options.isFilterBlocked(filter.id)},
	                  modelValue: filter.value,
	                  "onUpdate:modelValue": [$event => (filter.value = $event), $event => ($options.filterChange(filter.id))]
	                }, null, 8 /* PROPS */, ["field", "modelValue", "onUpdate:modelValue"])
	              ])
	            ], 2 /* CLASS */))
	          }), 128 /* KEYED_FRAGMENT */))
	        ]))
	      : createCommentVNode("v-if", true),
	    createVNode("div", _hoisted_9$c, [
	      createVNode("button", {
	        class: ["filter__show-products-btn btn btn--primary btn--full", {'btn--primary-red': $options.changedFilters?.length}],
	        type: "button",
	        onClick: _cache[2] || (_cache[2] = (...args) => ($options.closeFilter && $options.closeFilter(...args)))
	      }, "Смотреть " + toDisplayString($props.quantity), 3 /* TEXT, CLASS */)
	    ])
	  ], 2 /* CLASS */))
	}

	script$M.render = render$O;
	script$M.__file = "local/assets/source/components/v-filter.vue";

	var script$N = {
		props: {
			numbers: {
				type: Boolean,
				default: true
			},
			pages: {
				type: Object,
				default: () => {
					return {
						offset: 0,
						limit: 0,
						count: 0
					};
				}
			}
		},

		emits: [
			'navigate'
		],

		data() {
			return {
				localPages: {
					offset: 0,
					limit: 0,
					default: 0
				},
				short: false
			};
		},

		computed: {
			pageNumber() {
				return Math.ceil(this.localPages.offset / this.localPages.limit) + 1;
			},

			lastPageNumber() {
				return Math.ceil(this.localPages.count / this.localPages.limit);
			},

			pageOptions() {
				let result = [];
				if (this.localPages.limit) {
					let pageDispersion = this.pageNumber > 5 ? 4 : 5;
					// show last 10
					if (this.lastPageNumber - this.pageNumber < 5) {
						pageDispersion = 9 - this.lastPageNumber + this.pageNumber;
					}
					pageDispersion -= 2;
					// short mode for 3xs screen
					if (this.short) {
						pageDispersion -= 1;
					}
					// build array of page
					for (let i = 1; i <= this.lastPageNumber; i++) {
						if (i - Math.max(pageDispersion, this.pageNumber) <= pageDispersion && i - Math.max(pageDispersion, this.pageNumber) >= -pageDispersion) {
							result.push({value: i, text: i});
						}
					}
				}
				return result;
			}
		},

		watch: {
			pages: {
				handler() {
					this.initlocalPages();
				},
				deep: true
			}
		},

		created() {
			this.initlocalPages();
			window.addEventListener('resize', this.handleResize);
		},

		unmounted() {
			window.removeEventListener('resize', this.handleResize);
		},

		methods: {
			initlocalPages() {
				this.localPages = {
					offset: parseInt(this.pages.offset) || 0,
					limit: parseInt(this.pages.limit) || 0,
					count: parseInt(this.pages.count) || 0
				};
			},

			navigateToAppend() {
				let vm = this;
				this.$emit('navigate', {
					offset: vm.localPages.offset + this.localPages.limit,
					limit: vm.localPages.limit,
					append: true
				});
			},

			navigateToPage(page) {
				let vm = this;
				this.$emit('navigate', {
					offset: vm.localPages.limit * (page - 1),
					limit: vm.localPages.limit,
					append: false
				});
			},

			getPageLink(page) {
				return window.location.href + (window.location.href.indexOf('?') > -1 ? '&' : '?') +
					'state[pages][limit]=' + this.localPages.limit +
					'&state[pages][offset]=' + this.localPages.limit * (page - 1);
			},

			handleResize() {
				this.short = window.innerWidth <= breakpoints['3xs-max'];
			}
		}
	};

	const _hoisted_1$G = {
	  key: 0,
	  class: "v-page-nav page-nav"
	};
	const _hoisted_2$B = { class: "page-nav__top" };
	const _hoisted_3$w = {
	  class: "btn btn--full btn--gray",
	  key: "last-page",
	  type: "button",
	  disabled: ""
	};
	const _hoisted_4$o = {
	  key: 0,
	  class: "page-nav__row hidden-sm hidden-xs"
	};
	const _hoisted_5$l = { class: "page-nav__cell" };
	const _hoisted_6$j = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-left-text" })
	], -1 /* HOISTED */);
	const _hoisted_7$h = /*#__PURE__*/createVNode("span", null, "Назад", -1 /* HOISTED */);
	const _hoisted_8$d = { class: "page-nav__cell" };
	const _hoisted_9$d = {
	  key: 0,
	  class: "page-nav__links"
	};
	const _hoisted_10$9 = {
	  key: 1,
	  class: "page-nav__link-spacer"
	};
	const _hoisted_11$9 = {
	  key: 2,
	  class: "page-nav__link-spacer"
	};
	const _hoisted_12$9 = { class: "page-nav__cell" };
	const _hoisted_13$8 = /*#__PURE__*/createVNode("span", null, "Вперед", -1 /* HOISTED */);
	const _hoisted_14$8 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-text" })
	], -1 /* HOISTED */);

	function render$P(_ctx, _cache, $props, $setup, $data, $options) {
	  return ($data.localPages.count > $data.localPages.limit)
	    ? (openBlock(), createBlock("div", _hoisted_1$G, [
	        createVNode("div", _hoisted_2$B, [
	          createVNode(Transition, {
	            name: "content-fade",
	            mode: "out-in"
	          }, {
	            default: withCtx(() => [
	              ($data.localPages.offset + $data.localPages.limit < $data.localPages.count)
	                ? (openBlock(), createBlock("button", {
	                    class: "btn btn--full btn--gray",
	                    key: "show-more",
	                    type: "button",
	                    onClick: _cache[1] || (_cache[1] = (...args) => ($options.navigateToAppend && $options.navigateToAppend(...args)))
	                  }, "Показать еще"))
	                : (openBlock(), createBlock("button", _hoisted_3$w, "Это последняя страница"))
	            ]),
	            _: 1 /* STABLE */
	          })
	        ]),
	        ($props.numbers)
	          ? (openBlock(), createBlock("div", _hoisted_4$o, [
	              createVNode("div", _hoisted_5$l, [
	                ($options.pageNumber > 1)
	                  ? (openBlock(), createBlock("a", {
	                      key: 0,
	                      class: "page-nav__btn",
	                      href: $options.getPageLink(1),
	                      onClick: _cache[2] || (_cache[2] = withModifiers($event => ($options.navigateToPage($options.pageNumber - 1)), ["prevent"]))
	                    }, [
	                      _hoisted_6$j,
	                      _hoisted_7$h
	                    ], 8 /* PROPS */, ["href"]))
	                  : createCommentVNode("v-if", true)
	              ]),
	              createVNode("div", _hoisted_8$d, [
	                ($options.pageOptions && $options.pageOptions.length)
	                  ? (openBlock(), createBlock("div", _hoisted_9$d, [
	                      ($options.pageOptions[0].value > 1)
	                        ? (openBlock(), createBlock("a", {
	                            key: 0,
	                            class: "page-nav__link",
	                            href: $options.getPageLink(1),
	                            onClick: _cache[3] || (_cache[3] = withModifiers($event => ($options.navigateToPage(1)), ["prevent"]))
	                          }, "1", 8 /* PROPS */, ["href"]))
	                        : createCommentVNode("v-if", true),
	                      ($options.pageOptions[0].value > 2)
	                        ? (openBlock(), createBlock("span", _hoisted_10$9, "..."))
	                        : createCommentVNode("v-if", true),
	                      (openBlock(true), createBlock(Fragment, null, renderList($options.pageOptions, (option) => {
	                        return (openBlock(), createBlock("a", {
	                          class: ["page-nav__link", {'page-nav__link--active': option.value == $options.pageNumber}],
	                          href: option.value == $options.pageNumber ? null : $options.getPageLink(option.value),
	                          key: option.value,
	                          onClick: withModifiers($event => ($options.navigateToPage(option.value)), ["prevent"])
	                        }, toDisplayString(option.text), 11 /* TEXT, CLASS, PROPS */, ["href", "onClick"]))
	                      }), 128 /* KEYED_FRAGMENT */)),
	                      ($options.pageOptions[$options.pageOptions.length-1].value < $options.lastPageNumber - 1)
	                        ? (openBlock(), createBlock("span", _hoisted_11$9, "..."))
	                        : createCommentVNode("v-if", true),
	                      ($options.pageOptions[$options.pageOptions.length-1].value < $options.lastPageNumber)
	                        ? (openBlock(), createBlock("a", {
	                            key: 3,
	                            class: "page-nav__link",
	                            href: $options.getPageLink($options.lastPageNumber),
	                            onClick: _cache[4] || (_cache[4] = withModifiers($event => ($options.navigateToPage($options.lastPageNumber)), ["prevent"]))
	                          }, toDisplayString($options.lastPageNumber), 9 /* TEXT, PROPS */, ["href"]))
	                        : createCommentVNode("v-if", true)
	                    ]))
	                  : createCommentVNode("v-if", true)
	              ]),
	              createVNode("div", _hoisted_12$9, [
	                ($options.pageNumber < $options.lastPageNumber)
	                  ? (openBlock(), createBlock("a", {
	                      key: 0,
	                      class: "page-nav__btn",
	                      href: $options.getPageLink(1),
	                      onClick: _cache[5] || (_cache[5] = withModifiers($event => ($options.navigateToPage($options.pageNumber + 1)), ["prevent"]))
	                    }, [
	                      _hoisted_13$8,
	                      _hoisted_14$8
	                    ], 8 /* PROPS */, ["href"]))
	                  : createCommentVNode("v-if", true)
	              ])
	            ]))
	          : createCommentVNode("v-if", true)
	      ]))
	    : createCommentVNode("v-if", true)
	}

	script$N.render = render$P;
	script$N.__file = "local/assets/source/components/v-page-nav.vue";

	var script$O = {
		mixins: [
			script$2
		],

		data() {
			return {
				menu: [],
				openMenuId: null,
				openTimeout: null,
				closeTimeout: null,
				touch: controller.touch
			};
		},

		created() {
			document.addEventListener('click', this.handleClickOutside);
			document.addEventListener('keydown', this.handleEsc);
		},

		unmounted() {
			document.removeEventListener('click', this.handleClickOutside);
			document.removeEventListener('keydown', this.handleEsc);
		},

		methods: {
			dataSet(data) {
				this.menu.push(data);
				this.menu.sort((groupA) => groupA.type && groupA.type === 'catalog' ? -1 : 1);

				this.menu.forEach((group, groupIndex) => {
					group.items.forEach((item, itemIndex) => {
						item.menuId = groupIndex + '-' + itemIndex;
					});
				});

				this.$nextTick(() => {
					controller.navigationUpdated(data);
				});
			},

			mouseenter(item) {
				if (this.touch) {
					return;
				}

				if (this.openMenuId === item.menuId) {
					clearTimeout(this.closeTimeout);
				}
			},

			mouseleave() {
				if (this.touch) {
					return;
				}

				clearTimeout(this.openTimeout);
				this.closeTimeout = setTimeout(() => {
					this.openMenuId = null;
				}, 300);
			},

			mousemove(item) {
				if (this.touch) {
					return;
				}

				clearTimeout(this.openTimeout);
				if (item.items && item.items.length) {
					this.openTimeout = setTimeout(() => {
						clearTimeout(this.closeTimeout);
						this.openMenuId = item.menuId;
					}, 40);
				}
			},

			itemClick(item, e) {
				if (!this.touch) {
					return;
				}

				if (this.openMenuId !== item.menuId && item.items && item.items.length) {
					e.preventDefault();
					this.openMenuId = item.menuId;
				} else {
					this.openMenuId = null;
				}
			},

			handleClickOutside(e) {
				if (!this.$el.contains(e.target)) {
					this.openMenuId = null;
				}
			},

			handleEsc(e) {
				if (e.keyCode == 27 && this.openMenuId) {
					e.stopPropagation();
					this.openMenuId = null;
				}
			}
		},
	};

	const _hoisted_1$H = { class: "v-main-nav main-nav" };
	const _hoisted_2$C = { class: "container" };
	const _hoisted_3$x = {
	  class: "main-nav__wrapper scroll-shadow-edge scroll-shadow-edge--horizontal js-scroll-shadow-edge",
	  "data-position": "Left"
	};
	const _hoisted_4$p = { class: "main-nav__layout js-scroll-shadow-edge__content" };
	const _hoisted_5$m = {
	  key: 0,
	  class: "main-nav__link-main"
	};
	const _hoisted_6$k = { class: "container main-nav__dd-container" };
	const _hoisted_7$i = { class: "main-nav__dd-grid" };
	const _hoisted_8$e = { class: "main-nav__dd-cell" };
	const _hoisted_9$e = { class: "main-nav__dd-list" };
	const _hoisted_10$a = { class: "main-nav__dd-list-head flc" };
	const _hoisted_11$a = { class: "main-nav__dd-list-body flc" };
	const _hoisted_12$a = { class: "main-nav__dd-list-item" };

	function render$Q(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("nav", _hoisted_1$H, [
	    createVNode("div", _hoisted_2$C, [
	      createVNode("div", _hoisted_3$x, [
	        createVNode("ul", _hoisted_4$p, [
	          (openBlock(true), createBlock(Fragment, null, renderList($data.menu, (group) => {
	            return (openBlock(), createBlock(Fragment, null, [
	              (openBlock(true), createBlock(Fragment, null, renderList(group.items, (item) => {
	                return (openBlock(), createBlock("li", {
	                  class: ["main-nav__cell", {'main-nav__cell--with-dropdown': item?.items?.length}]
	                }, [
	                  createVNode("a", {
	                    class: ["main-nav__link", {'main-nav__link--open': $data.openMenuId === item.menuId}],
	                    href: item.link,
	                    tabindex: "0",
	                    onMouseenter: $event => ($options.mouseenter(item)),
	                    onMouseleave: $event => ($options.mouseleave(item)),
	                    onMousemove: $event => ($options.mousemove(item)),
	                    onClick: $event => ($options.itemClick(item, $event))
	                  }, [
	                    (item.text)
	                      ? (openBlock(), createBlock("div", _hoisted_5$m, toDisplayString(item.text), 1 /* TEXT */))
	                      : createCommentVNode("v-if", true)
	                  ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, ["href", "onMouseenter", "onMouseleave", "onMousemove", "onClick"]),
	                  (item.items && item.items.length)
	                    ? (openBlock(), createBlock("div", {
	                        key: 0,
	                        class: ["main-nav__dd", {'main-nav__dd--open': $data.openMenuId === item.menuId}],
	                        onMouseenter: $event => ($options.mouseenter(item)),
	                        onMouseleave: $event => ($options.mouseleave(item))
	                      }, [
	                        createVNode("div", _hoisted_6$k, [
	                          createVNode("div", _hoisted_7$i, [
	                            (openBlock(true), createBlock(Fragment, null, renderList(item.items, (itemL2) => {
	                              return (openBlock(), createBlock("div", _hoisted_8$e, [
	                                createVNode("div", _hoisted_9$e, [
	                                  createVNode("div", _hoisted_10$a, [
	                                    createVNode("a", {
	                                      class: ["main-nav__dd-list-head-link", {'main-nav__dd-list-head-link--link': itemL2.link}],
	                                      href: itemL2.link
	                                    }, toDisplayString(itemL2.text), 11 /* TEXT, CLASS, PROPS */, ["href"])
	                                  ]),
	                                  createVNode("div", _hoisted_11$a, [
	                                    (openBlock(true), createBlock(Fragment, null, renderList(itemL2.items, (itemL3) => {
	                                      return (openBlock(), createBlock("div", _hoisted_12$a, [
	                                        createVNode("a", {
	                                          class: "main-nav__dd-list-link",
	                                          href: itemL3.link
	                                        }, toDisplayString(itemL3.text), 9 /* TEXT, PROPS */, ["href"])
	                                      ]))
	                                    }), 256 /* UNKEYED_FRAGMENT */))
	                                  ])
	                                ])
	                              ]))
	                            }), 256 /* UNKEYED_FRAGMENT */))
	                          ]),
	                          (item.aside)
	                            ? (openBlock(), createBlock("div", {
	                                key: 0,
	                                class: "main-nav__dd-aside",
	                                innerHTML: item.aside
	                              }, null, 8 /* PROPS */, ["innerHTML"]))
	                            : createCommentVNode("v-if", true)
	                        ])
	                      ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, ["onMouseenter", "onMouseleave"]))
	                    : createCommentVNode("v-if", true)
	                ], 2 /* CLASS */))
	              }), 256 /* UNKEYED_FRAGMENT */))
	            ], 64 /* STABLE_FRAGMENT */))
	          }), 256 /* UNKEYED_FRAGMENT */))
	        ])
	      ])
	    ])
	  ]))
	}

	script$O.render = render$Q;
	script$O.__file = "local/assets/source/components/v-main-nav.vue";

	var script$P = {
		computed: {
			showSuccessModal() {
				return this.$store.getters['basket/showSuccessModal'];
			},
		},

		watch: {
			showSuccessModal(newValue) {
				if (newValue instanceof Object) {
					controller.openMessage({product: this.showSuccessModal});
				}
			}
		},

		created() {
			controller.events.on('navigation-updated', () => {
				View.initAllLocal(this.$el.parentElement);
			});
		},

		mounted() {
			this.$nextTick(() => {
				View.initAllLocal(this.$el.parentElement);
			});
		}
	};

	const _hoisted_1$I = { class: "v-page-header page-header fixed-block js-fixed" };
	const _hoisted_2$D = { class: "fixed-block__content js-fixed__content" };
	const _hoisted_3$y = { class: "page-header__wrapper" };
	const _hoisted_4$q = { class: "container" };
	const _hoisted_5$n = { class: "page-header__layout" };
	const _hoisted_6$l = {
	  key: 0,
	  class: "page-header__cell page-header__cell--back"
	};
	const _hoisted_7$j = { class: "page-header__cell page-header__cell--logo" };
	const _hoisted_8$f = {
	  key: 1,
	  class: "page-header__cell page-header__cell--search"
	};
	const _hoisted_9$f = {
	  key: 2,
	  class: "page-header__cell page-header__cell--delivery"
	};
	const _hoisted_10$b = {
	  key: 3,
	  class: "page-header__cell page-header__cell--shop"
	};
	const _hoisted_11$b = {
	  key: 4,
	  class: "page-header__cell page-header__cell--user"
	};
	const _hoisted_12$b = { class: "page-header__cell page-header__cell--favorite" };
	const _hoisted_13$9 = { class: "page-header__cell page-header__cell--basket" };

	function render$R(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_favorite_small = resolveComponent("v-favorite-small");
	  const _component_v_basket_small = resolveComponent("v-basket-small");

	  return (openBlock(), createBlock("header", _hoisted_1$I, [
	    createVNode("div", _hoisted_2$D, [
	      createVNode("div", _hoisted_3$y, [
	        createVNode("div", _hoisted_4$q, [
	          createVNode("div", _hoisted_5$n, [
	            (_ctx.$slots['back-order'])
	              ? (openBlock(), createBlock("div", _hoisted_6$l, [
	                  renderSlot(_ctx.$slots, "back-order")
	                ]))
	              : createCommentVNode("v-if", true),
	            createVNode("div", _hoisted_7$j, [
	              renderSlot(_ctx.$slots, "logo")
	            ]),
	            (_ctx.$slots['search'])
	              ? (openBlock(), createBlock("div", _hoisted_8$f, [
	                  renderSlot(_ctx.$slots, "search")
	                ]))
	              : createCommentVNode("v-if", true),
	            (_ctx.$slots['delivery'])
	              ? (openBlock(), createBlock("div", _hoisted_9$f, [
	                  renderSlot(_ctx.$slots, "delivery")
	                ]))
	              : createCommentVNode("v-if", true),
	            (_ctx.$slots['shop'])
	              ? (openBlock(), createBlock("div", _hoisted_10$b, [
	                  renderSlot(_ctx.$slots, "shop")
	                ]))
	              : createCommentVNode("v-if", true),
	            (_ctx.$slots['user'])
	              ? (openBlock(), createBlock("div", _hoisted_11$b, [
	                  renderSlot(_ctx.$slots, "user")
	                ]))
	              : createCommentVNode("v-if", true),
	            createVNode("div", _hoisted_12$b, [
	              createVNode(_component_v_favorite_small)
	            ]),
	            createVNode("div", _hoisted_13$9, [
	              createVNode(_component_v_basket_small)
	            ])
	          ])
	        ])
	      ]),
	      renderSlot(_ctx.$slots, "menu")
	    ])
	  ]))
	}

	script$P.render = render$R;
	script$P.__file = "local/assets/source/components/v-page-header.vue";

	var script$Q = {
		computed: {
			...mapGetters$1({
				basketCount: 'basket/basketCount'
			}),

			basket() {
				return this.$store.state.basket;
			}
		}
	};

	const _hoisted_1$J = { class: "v-basket-small basket-small" };
	const _hoisted_2$E = { class: "basket-small__cell-icon" };
	const _hoisted_3$z = /*#__PURE__*/createVNode("svg", { class: "svg-icon basket-small__icon hidden-xs" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-basket" })
	], -1 /* HOISTED */);
	const _hoisted_4$r = /*#__PURE__*/createVNode("svg", { class: "svg-icon basket-small__icon hidden-lg hidden-md hidden-sm" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-basket-mobile" })
	], -1 /* HOISTED */);
	const _hoisted_5$o = {
	  key: 0,
	  class: "basket-small__badge badge badge--primary"
	};
	const _hoisted_6$m = /*#__PURE__*/createVNode("div", { class: "basket-small__cell-name" }, "Корзина", -1 /* HOISTED */);

	function render$S(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$J, [
	    createVNode("a", {
	      class: "basket-small__widget",
	      href: $options.basket.link
	    }, [
	      createVNode("div", _hoisted_2$E, [
	        _hoisted_3$z,
	        _hoisted_4$r,
	        (_ctx.basketCount)
	          ? (openBlock(), createBlock("div", _hoisted_5$o, toDisplayString(_ctx.basketCount), 1 /* TEXT */))
	          : createCommentVNode("v-if", true)
	      ]),
	      _hoisted_6$m
	    ], 8 /* PROPS */, ["href"])
	  ]))
	}

	script$Q.render = render$S;
	script$Q.__file = "local/assets/source/components/v-basket-small.vue";

	var script$R = {
		props: {
			id: {
				type: [String, Number],
				default: null
			},

			disabled: {
				type: Boolean,
				default: false
			},

			buttons: {
				type: Object,
				default() {
					return {}
				}
			},

			count: {
				type: Object,
				default() {
					return {}
				}
			},
		},

		data() {
			return {
				loading: false,
				localCount: this.count.value ?? 1
			};
		},

		computed: {
			basketCountByItem() {
				return this.$store.getters['basket/basketCountByItem'](this.id);
			}
		},

		created() {
			this.updateValue();
		},

		methods: {
			updateValue() {
				this.localCount = this.count.value || 1;
			},

			handleInput(value) {
				this.localCount = value;
			},

			setBasketCount() {
				this.loading = true;
				this.$store.dispatch('basket/add', {
					id: this.id,
					count: this.localCount
				}).then(() => {
					setTimeout(() => {
						this.loading = false;
						this.updateValue();
					}, 300);
				});
			}
		}
	};

	const _hoisted_1$K = {
	  key: 0,
	  class: "basket-action__cell-input"
	};
	const _hoisted_2$F = { class: "basket-action__cell-main" };
	const _hoisted_3$A = {
	  key: 0,
	  class: "svg-icon"
	};
	const _hoisted_4$s = {
	  key: 0,
	  class: "svg-icon"
	};

	function render$T(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_field = resolveComponent("v-field");

	  return (openBlock(), createBlock("div", {
	    class: ["v-basket-action basket-action", {'basket-action--active': $options.basketCountByItem, 'basket-action--disabled': $props.disabled}]
	  }, [
	    createVNode(_component_v_loader, { loading: $data.loading }, null, 8 /* PROPS */, ["loading"]),
	    createVNode("div", {
	      class: ["basket-action__widget", {'basket-action__widget--link':$props.buttons.redirectToDetail}]
	    }, [
	      (!$props.buttons.redirectToDetail)
	        ? (openBlock(), createBlock("div", _hoisted_1$K, [
	            createVNode(_component_v_field, {
	              modelValue: $data.localCount,
	              "onUpdate:modelValue": [
	                _cache[1] || (_cache[1] = $event => ($data.localCount = $event)),
	                $options.handleInput
	              ],
	              field: {type: 'count', min: $props.count.min ? $props.count.min : 1, max: $props.count.max, multiplicity: $props.count.multiplicity}
	            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "field"])
	          ]))
	        : createCommentVNode("v-if", true),
	      createVNode("div", _hoisted_2$F, [
	        ($props.buttons.addToBasket)
	          ? (openBlock(), createBlock("button", {
	              key: 0,
	              class: ["basket-action__btn basket-action__btn--half btn btn--md btn--full btn--primary-red", [$props.buttons.addToBasket.className]],
	              type: "button",
	              disabled: $props.disabled,
	              onClick: _cache[2] || (_cache[2] = (...args) => ($options.setBasketCount && $options.setBasketCount(...args))),
	              "aria-label": $props.buttons.addToBasket.text
	            }, [
	              ($props.buttons.addToBasket.icon)
	                ? (openBlock(), createBlock("svg", _hoisted_3$A, [
	                    createVNode("use", {
	                      "xlink:href": '/local/assets/dist/icons/sprite.svg#svg-icon-' + $props.buttons.addToBasket.icon
	                    }, null, 8 /* PROPS */, ["xlink:href"])
	                  ]))
	                : createCommentVNode("v-if", true),
	              createTextVNode(toDisplayString($options.basketCountByItem ? 'Добавить' : $props.buttons.addToBasket.text), 1 /* TEXT */)
	            ], 10 /* CLASS, PROPS */, ["disabled", "aria-label"]))
	          : createCommentVNode("v-if", true),
	        ($props.buttons.redirectToDetail)
	          ? (openBlock(), createBlock("a", {
	              key: 1,
	              class: ["basket-action__btn btn btn--md btn--full", [$props.buttons.redirectToDetail.className]],
	              href: $props.buttons.redirectToDetail.link,
	              disabled: $props.disabled,
	              "aria-label": $props.buttons.redirectToDetail.text
	            }, [
	              ($props.buttons.redirectToDetail.icon)
	                ? (openBlock(), createBlock("svg", _hoisted_4$s, [
	                    createVNode("use", {
	                      "xlink:href": '/local/assets/dist/icons/sprite.svg#svg-icon-' + $props.buttons.redirectToDetail.icon
	                    }, null, 8 /* PROPS */, ["xlink:href"])
	                  ]))
	                : createCommentVNode("v-if", true),
	              createTextVNode(toDisplayString($props.buttons.redirectToDetail.text), 1 /* TEXT */)
	            ], 10 /* CLASS, PROPS */, ["href", "disabled", "aria-label"]))
	          : createCommentVNode("v-if", true)
	      ])
	    ], 2 /* CLASS */)
	  ], 2 /* CLASS */))
	}

	script$R.render = render$T;
	script$R.__file = "local/assets/source/components/v-basket-action.vue";

	var script$S = {
		props: {
			productId: {
				type: [String, Number],
				default: null
			},

			full: {
				type: Boolean,
				default: false,
			},

			sizeMid: {
				type: Boolean,
				default: false
			}
		},

		computed: {
			...mapGetters$1({
				favoriteList: 'favorite/favoriteList'
			}),

			favoriteActive() {
				return this.favoriteList.filter((product) => parseInt(product.id) === parseInt(this.productId)).length
			}
		},

		methods: {
			...mapActions$1({
				addToFavorite: 'favorite/add',
				removeFromFavorite: 'favorite/remove',
			}),

			toggleFavorite() {
				if (this.favoriteActive) {
					this.removeFromFavorite({id: this.productId})
						.then(() => {
							controller.openMessage({
								content: {
									text: 'Удалено из избранного',
									background: 'linear-gradient(268.03deg, #EAFF97 0%, #ECECEC 90.33%)',
									width: '270px'
								}
							});
							controller.removeFavorite(this.productId);
						});
				} else {
					this.addToFavorite({id: this.productId})
						.then(() => {
							controller.openMessage({
								content: {
									text: 'Добавлено в избранное',
									background: 'linear-gradient(268.03deg, #EAFF97 0%, #ECECEC 90.33%)',
									width: '270px'
								}
							});
						});
				}
			}
		},
	};

	const _hoisted_1$L = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-heart-small" })
	], -1 /* HOISTED */);
	const _hoisted_2$G = { key: 0 };

	function render$U(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", {
	    class: ["v-favorite-action favorite-action", {'favorite-action--active': $options.favoriteActive, 'favorite-action--full': $props.full, 'favorite-action--mid': $props.sizeMid}]
	  }, [
	    createVNode("button", {
	      class: "favorite-action__toggle",
	      type: "button",
	      onClick: _cache[1] || (_cache[1] = (...args) => ($options.toggleFavorite && $options.toggleFavorite(...args)))
	    }, [
	      _hoisted_1$L,
	      ($props.full)
	        ? (openBlock(), createBlock("b", _hoisted_2$G, toDisplayString($options.favoriteActive ? 'В избранном' : 'В избранное'), 1 /* TEXT */))
	        : createCommentVNode("v-if", true)
	    ])
	  ], 2 /* CLASS */))
	}

	script$S.render = render$U;
	script$S.__file = "local/assets/source/components/v-favorite-action.vue";

	var script$T = {
		props: {
			rating: {
				type: Object,
				default() {
					return {count: 0}
				}
			},
		},

		emits: [
			'input'
		],

		data() {
			return {
				localValue: 0
			}
		},

		computed: {
			computedCountText() {
				if (this.rating.count % 10 === 1 && this.rating.count !== 11) {
					return 'отзыв'
				} else if (this.rating.count % 10 > 1 && this.rating.count % 10 < 5) {
					return 'отзыва'
				} else {
					return 'отзывов'
				}
			}
		},

		watch: {
			rating() {
				this.localValue = this.rating.value;
			}
		},

		mounted() {
			this.localValue = this.rating.value;
		},

		methods: {
			changeRating() {
				this.$emit('input', this.localValue);
			}
		},
	};

	const _hoisted_1$M = { class: "v-rating-action rating-action" };
	const _hoisted_2$H = {
	  key: 0,
	  class: "rating-action__rating"
	};
	const _hoisted_3$B = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_4$t = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_5$p = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_6$n = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_7$k = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_8$g = {
	  key: 1,
	  class: "rating-action__rating rating-action__rating--hover"
	};
	const _hoisted_9$g = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_10$c = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_11$c = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_12$c = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_13$a = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_14$9 = {
	  key: 2,
	  class: "rating-action__count"
	};

	function render$V(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$M, [
	    ($props.rating.readOnly)
	      ? (openBlock(), createBlock("div", _hoisted_2$H, [
	          createVNode("div", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue > 0}]
	          }, [
	            _hoisted_3$B
	          ], 2 /* CLASS */),
	          createVNode("div", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue > 20}]
	          }, [
	            _hoisted_4$t
	          ], 2 /* CLASS */),
	          createVNode("div", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue > 40}]
	          }, [
	            _hoisted_5$p
	          ], 2 /* CLASS */),
	          createVNode("div", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue > 60}]
	          }, [
	            _hoisted_6$n
	          ], 2 /* CLASS */),
	          createVNode("div", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue > 80}]
	          }, [
	            _hoisted_7$k
	          ], 2 /* CLASS */)
	        ]))
	      : (openBlock(), createBlock("div", _hoisted_8$g, [
	          createVNode("button", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue > 0}],
	            type: "button",
	            onClick: _cache[1] || (_cache[1] = $event => {$data.localValue = 20; $options.changeRating();})
	          }, [
	            _hoisted_9$g
	          ], 2 /* CLASS */),
	          createVNode("button", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue > 20}],
	            type: "button",
	            onClick: _cache[2] || (_cache[2] = $event => {$data.localValue = 40; $options.changeRating();})
	          }, [
	            _hoisted_10$c
	          ], 2 /* CLASS */),
	          createVNode("button", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue > 40}],
	            type: "button",
	            onClick: _cache[3] || (_cache[3] = $event => {$data.localValue = 60; $options.changeRating();})
	          }, [
	            _hoisted_11$c
	          ], 2 /* CLASS */),
	          createVNode("button", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue > 60}],
	            type: "button",
	            onClick: _cache[4] || (_cache[4] = $event => {$data.localValue = 80; $options.changeRating();})
	          }, [
	            _hoisted_12$c
	          ], 2 /* CLASS */),
	          createVNode("button", {
	            class: ["rating-action__rating-item", {'rating-action__rating-item--active': $data.localValue > 80}],
	            type: "button",
	            onClick: _cache[5] || (_cache[5] = $event => {$data.localValue = 100; $options.changeRating();})
	          }, [
	            _hoisted_13$a
	          ], 2 /* CLASS */)
	        ])),
	    ($props.rating.count)
	      ? (openBlock(), createBlock("div", _hoisted_14$9, toDisplayString($props.rating.count) + " " + toDisplayString($options.computedCountText), 1 /* TEXT */))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$T.render = render$V;
	script$T.__file = "local/assets/source/components/v-rating-action.vue";

	var script$U = {
		computed: {
			favorite() {
				return this.$store.state.favorite;
			},

			favoriteCount() {
				return this.$store.getters['favorite/favoriteCount'];
			}
		}
	};

	const _hoisted_1$N = { class: "v-favorite-small basket-small" };
	const _hoisted_2$I = { class: "basket-small__cell-icon" };
	const _hoisted_3$C = /*#__PURE__*/createVNode("svg", { class: "svg-icon basket-small__icon hidden-xs" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-favorite" })
	], -1 /* HOISTED */);
	const _hoisted_4$u = /*#__PURE__*/createVNode("svg", { class: "svg-icon basket-small__icon hidden-lg hidden-md hidden-sm" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-favorite-mobile" })
	], -1 /* HOISTED */);
	const _hoisted_5$q = {
	  key: 0,
	  class: "basket-small__badge badge badge--primary"
	};
	const _hoisted_6$o = /*#__PURE__*/createVNode("div", { class: "basket-small__cell-name" }, "Избранное", -1 /* HOISTED */);

	function render$W(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$N, [
	    createVNode("a", {
	      class: "basket-small__widget",
	      href: $options.favorite.link
	    }, [
	      createVNode("div", _hoisted_2$I, [
	        _hoisted_3$C,
	        _hoisted_4$u,
	        ($options.favoriteCount)
	          ? (openBlock(), createBlock("div", _hoisted_5$q, toDisplayString($options.favoriteCount), 1 /* TEXT */))
	          : createCommentVNode("v-if", true)
	      ]),
	      _hoisted_6$o
	    ], 8 /* PROPS */, ["href"])
	  ]))
	}

	script$U.render = render$W;
	script$U.__file = "local/assets/source/components/v-favorite-small.vue";

	var script$V = {
		props: {
		    discount: {
				type: Object,
				default: null
			},
			items: {
				type: Array,
				default: null
			},

			quickView: {
				type: Boolean,
				default: false
			}
		},

		methods: {
			handleClickProduct(id) {
				window.localStorage.setItem('clickedProduct', id);
			},
		},

		mounted() {
			this.$nextTick(() => {
				const id = window.localStorage.getItem('clickedProduct');
				if (id) {
					window.localStorage.removeItem('clickedProduct');
					const product = this.$el.querySelector(`[data-id="${id}"]`);

					if (product) {
						const topPosition = product.getBoundingClientRect().top;
						const header = document.querySelector('.js-fixed__content');

						window.scrollTo({top: topPosition - header.clientHeight - 20, behavior: 'smooth'});
					}
				}
			});
		}
	};

	const _hoisted_1$O = { class: "v-product-grid product-grid" };
	const _hoisted_2$J = { class: "product-grid__grid" };
	const _hoisted_3$D = { class: "product-grid__cell product-grid__cell--empty" };

	function render$X(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_product = resolveComponent("v-product");

	  return (openBlock(), createBlock("div", _hoisted_1$O, [
	    createVNode("div", _hoisted_2$J, [
	      (openBlock(true), createBlock(Fragment, null, renderList($props.items, (item, index) => {
	        return (openBlock(), createBlock("div", {
	          class: "product-grid__cell",
	          key: item.id || index
	        }, [
	          createVNode(_component_v_product, {
	            template: "grid",
	            product: item,
	            discount: $props.discount,
	            "quick-view": $props.quickView,
	            onClick: $event => ($options.handleClickProduct(item.id)),
	            "data-id": item.id
	          }, null, 8 /* PROPS */, ["product", "discount", "quick-view", "onClick", "data-id"])
	        ]))
	      }), 128 /* KEYED_FRAGMENT */)),
	      (openBlock(), createBlock(Fragment, null, renderList(5, (item, index) => {
	        return createVNode("div", _hoisted_3$D)
	      }), 64 /* STABLE_FRAGMENT */))
	    ])
	  ]))
	}

	script$V.render = render$X;
	script$V.__file = "local/assets/source/components/v-product-grid.vue";

	var script$W = {
		components: {
			'v-swiper-slide': SwiperSlide
		},

		mixins: [
			script$2
		],

		props: {
			options: {
				type: Object,
				default: null
			}
		},

		data() {
			return {
				slider: {},
				uniqueId: uniqueId('swiper-')
			};
		},

		computed: {
			computedOptions() {
				let result = {
					watchOverflow: true,
					slidesPerView: 1,
					spaceBetween: 22,
					loop: false,
					breakpoints: {
						[breakpoints['lg-min']]: {
							slidesPerView: 6
						},
						[breakpoints['md-min']]: {
							slidesPerView: 5
						},
						[breakpoints['sm-min']]: {
							slidesPerView: 4
						},
						540: {
							slidesPerView: 3
						},
						[breakpoints['3xs-min']]: {
							slidesPerView: 2,
							spaceBetween: 22
						},
						[breakpoints['4xs-min']]: {
							slidesPerView: 2,
							spaceBetween: 10
						}
					}
				};
				if (this.options) {
					Object.keys(this.options).forEach((key) => {
						if (typeof this.options[key] !== 'undefined') {
							result[key] = this.options[key];
						}
					});
				}
				return result;
			},
		},

		methods: {
			dataSet(data) {
				this.slider = data;

				if (this.slider?.items?.length) {
					this.$nextTick(() => {
						this.$refs.swiperSlider.dataNavigation = {
							nextEl: this.$refs.next,
							prevEl: this.$refs.prev,
						};
					});
				}
			}
		}
	};

	const _hoisted_1$P = { class: "v-product-slider product-slider" };
	const _hoisted_2$K = {
	  class: "product-slider__arrow product-slider__arrow--prev",
	  type: "button",
	  ref: "prev"
	};
	const _hoisted_3$E = /*#__PURE__*/createVNode("svg", { class: "svg-icon product-slider__icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-left-slider" })
	], -1 /* HOISTED */);
	const _hoisted_4$v = {
	  class: "product-slider__arrow product-slider__arrow--next",
	  type: "button",
	  ref: "next"
	};
	const _hoisted_5$r = /*#__PURE__*/createVNode("svg", { class: "svg-icon product-slider__icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-slider" })
	], -1 /* HOISTED */);

	function render$Y(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_product = resolveComponent("v-product");
	  const _component_v_swiper_slide = resolveComponent("v-swiper-slide");
	  const _component_v_swiper_slider = resolveComponent("v-swiper-slider");

	  return (openBlock(), createBlock("div", _hoisted_1$P, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    createVNode("button", _hoisted_2$K, [
	      _hoisted_3$E
	    ], 512 /* NEED_PATCH */),
	    createVNode("button", _hoisted_4$v, [
	      _hoisted_5$r
	    ], 512 /* NEED_PATCH */),
	    ($data.slider && $data.slider.items && $data.slider.items.length)
	      ? (openBlock(), createBlock(_component_v_swiper_slider, {
	          options: $options.computedOptions,
	          key: $data.uniqueId,
	          pagination: {type: 'bullets', clickable: true, dynamicBullets: 3},
	          navigation: "navigation",
	          ref: "swiperSlider"
	        }, {
	          main: withCtx(() => [
	            (openBlock(true), createBlock(Fragment, null, renderList($data.slider.items, (item, index) => {
	              return (openBlock(), createBlock(_component_v_swiper_slide, {
	                class: "product-slider__slide",
	                key: item.id || index
	              }, {
	                default: withCtx(() => [
	                  createVNode(_component_v_product, {
	                    product: item,
	                    discount: $data.slider.discountList
	                  }, null, 8 /* PROPS */, ["product", "discount"])
	                ]),
	                _: 2 /* DYNAMIC */
	              }, 1024 /* DYNAMIC_SLOTS */))
	            }), 128 /* KEYED_FRAGMENT */))
	          ]),
	          _: 1 /* STABLE */
	        }, 8 /* PROPS */, ["options"]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$W.render = render$Y;
	script$W.__file = "local/assets/source/components/v-product-slider.vue";

	var script$X = {
		mixins: [
			script$2
		],

		data() {
			return {
				content: null,
			};
		},

		methods: {
			dataSet(data) {
				this.content = data;
			}
		}
	};

	const _hoisted_1$Q = { class: "v-product-discount product-discount__products" };
	const _hoisted_2$L = {
	  key: 1,
	  class: "product-discount__action"
	};
	const _hoisted_3$F = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-long" })
	], -1 /* HOISTED */);

	function render$Z(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_product_grid = resolveComponent("v-product-grid");

	  return (openBlock(), createBlock("div", _hoisted_1$Q, [
	    ($data.content?.items?.length)
	      ? (openBlock(), createBlock(_component_v_product_grid, {
	          items: $data.content.items,
	          discount: $data.content.discountList,
	          key: "catalog-type-products-grid"
	        }, null, 8 /* PROPS */, ["items", "discount"]))
	      : createCommentVNode("v-if", true),
	    ($data.content?.buttons?.length)
	      ? (openBlock(), createBlock("div", _hoisted_2$L, [
	          (openBlock(true), createBlock(Fragment, null, renderList($data.content.buttons, (item) => {
	            return (openBlock(), createBlock("a", {
	              class: "product-discount__all btn btn--gray btn--full",
	              href: item.link
	            }, [
	              createTextVNode(toDisplayString(item.text), 1 /* TEXT */),
	              _hoisted_3$F
	            ], 8 /* PROPS */, ["href"]))
	          }), 256 /* UNKEYED_FRAGMENT */))
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$X.render = render$Z;
	script$X.__file = "local/assets/source/components/v-product-discount.vue";

	var script$Y = {
		components: {
			'v-swiper-slide': SwiperSlide
		},

		mixins: [script$2],

		props: {
			options: {
				type: Object,
				default: null
			},
		},

		data() {
			return {
				brands: {},
				uniqueId: uniqueId('swiper-')
			}
		},

		computed: {
			computedOptions() {
				let result = {
					spaceBetween: 20,
					loop: false,
					slidesPerView: 'auto'
				};
				if (this.options) {
					Object.keys(this.options).forEach((key) => {
						if (typeof this.options[key] !== 'undefined') {
							result[key] = this.options[key];
						}
					});
				}
				return result;
			},

			computedNavigation() {
				return {
					prevEl: this.$refs.prev,
					nextEl: this.$refs.next
				};
			}
		},

		methods: {
			dataSet(data) {
				this.brands = data;
			}
		},
	};

	const _hoisted_1$R = { class: "v-brands brands" };
	const _hoisted_2$M = {
	  key: 0,
	  class: "brands__list"
	};
	const _hoisted_3$G = { class: "brands__item" };
	const _hoisted_4$w = { class: "brands__item-bg" };
	const _hoisted_5$s = {
	  key: 1,
	  class: "brands__item-content"
	};
	const _hoisted_6$p = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-long-2" })
	], -1 /* HOISTED */);
	const _hoisted_7$l = {
	  key: 2,
	  class: "brands__item-action"
	};
	const _hoisted_8$h = {
	  key: 2,
	  class: "brands__item-brands"
	};
	const _hoisted_9$h = {
	  key: 0,
	  class: "brands__brands-list"
	};
	const _hoisted_10$d = { class: "brands__item-action" };

	function render$_(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_picture = resolveComponent("v-picture");
	  const _component_v_brand_products = resolveComponent("v-brand-products");
	  const _component_v_swiper_slide = resolveComponent("v-swiper-slide");
	  const _component_v_swiper_slider = resolveComponent("v-swiper-slider");

	  return (openBlock(), createBlock("div", _hoisted_1$R, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.brands?.items?.length)
	      ? (openBlock(), createBlock("div", _hoisted_2$M, [
	          createVNode(_component_v_swiper_slider, {
	            options: $options.computedOptions,
	            key: $data.uniqueId
	          }, {
	            main: withCtx(() => [
	              (openBlock(true), createBlock(Fragment, null, renderList($data.brands.items, (item, index) => {
	                return (openBlock(), createBlock(_component_v_swiper_slide, {
	                  key: item.id || index
	                }, {
	                  default: withCtx(() => [
	                    createVNode("div", _hoisted_3$G, [
	                      (item.link)
	                        ? (openBlock(), createBlock("a", {
	                            key: 0,
	                            class: "brands__item-link",
	                            href: item.link
	                          }, null, 8 /* PROPS */, ["href"]))
	                        : createCommentVNode("v-if", true),
	                      createVNode("div", _hoisted_4$w, [
	                        (item.imageSources)
	                          ? (openBlock(), createBlock(_component_v_picture, {
	                              key: 0,
	                              sources: item.imageSources,
	                              alt: item.name,
	                              width: 295,
	                              height: 448
	                            }, null, 8 /* PROPS */, ["sources", "alt"]))
	                          : createCommentVNode("v-if", true)
	                      ]),
	                      (item.name || item?.products?.length)
	                        ? (openBlock(), createBlock("div", _hoisted_5$s, [
	                            (item.name)
	                              ? (openBlock(), createBlock("a", {
	                                  key: 0,
	                                  class: "brands__item-name",
	                                  href: item.link
	                                }, [
	                                  createVNode("span", null, toDisplayString(item.name), 1 /* TEXT */),
	                                  _hoisted_6$p
	                                ], 8 /* PROPS */, ["href"]))
	                              : createCommentVNode("v-if", true),
	                            (item?.products?.length)
	                              ? (openBlock(), createBlock(_component_v_brand_products, {
	                                  key: 1,
	                                  "data-source": item.products,
	                                  bxajaxid: "productbrandFilter"
	                                }, null, 8 /* PROPS */, ["data-source"]))
	                              : createCommentVNode("v-if", true),
	                            (item?.buttons?.length)
	                              ? (openBlock(), createBlock("div", _hoisted_7$l, [
	                                  (openBlock(true), createBlock(Fragment, null, renderList(item.buttons, (btn) => {
	                                    return (openBlock(), createBlock("a", {
	                                      class: "brands__brands-all btn btn--primary",
	                                      href: btn.url
	                                    }, toDisplayString(btn.text), 9 /* TEXT, PROPS */, ["href"]))
	                                  }), 256 /* UNKEYED_FRAGMENT */))
	                                ]))
	                              : createCommentVNode("v-if", true)
	                          ]))
	                        : createCommentVNode("v-if", true),
	                      (item?.allBrands?.length)
	                        ? (openBlock(), createBlock("div", _hoisted_8$h, [
	                            (item?.allBrands?.length)
	                              ? (openBlock(), createBlock("div", _hoisted_9$h, [
	                                  (openBlock(true), createBlock(Fragment, null, renderList(item.allBrands, (link, index) => {
	                                    return (openBlock(), createBlock(Fragment, {
	                                      key: link.name
	                                    }, [
	                                      (index <= 4)
	                                        ? (openBlock(), createBlock("a", {
	                                            key: 0,
	                                            class: "brands__brands-link",
	                                            href: link.link
	                                          }, toDisplayString(link.name), 9 /* TEXT, PROPS */, ["href"]))
	                                        : createCommentVNode("v-if", true)
	                                    ], 64 /* STABLE_FRAGMENT */))
	                                  }), 128 /* KEYED_FRAGMENT */))
	                                ]))
	                              : createCommentVNode("v-if", true),
	                            createVNode("div", _hoisted_10$d, [
	                              (openBlock(true), createBlock(Fragment, null, renderList(item.buttons, (btn) => {
	                                return (openBlock(), createBlock("a", {
	                                  class: "brands__brands-all btn btn--primary",
	                                  href: btn.url
	                                }, toDisplayString(btn.text), 9 /* TEXT, PROPS */, ["href"]))
	                              }), 256 /* UNKEYED_FRAGMENT */))
	                            ])
	                          ]))
	                        : createCommentVNode("v-if", true)
	                    ])
	                  ]),
	                  _: 2 /* DYNAMIC */
	                }, 1024 /* DYNAMIC_SLOTS */))
	              }), 128 /* KEYED_FRAGMENT */))
	            ]),
	            _: 1 /* STABLE */
	          }, 8 /* PROPS */, ["options"])
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$Y.render = render$_;
	script$Y.__file = "local/assets/source/components/v-brands.vue";

	var script$Z = {
		props: {
			product: {
				type: Object,
				default: null
			},
			discount: {
				type: Object,
				default: null
			},
			template: {
				type: String,
				default: 'grid'
			},

			quickView: {
				type: Boolean,
				default: false
			},
		},

		computed: {
			computedProductInfo() {
				return {
					'name': this.product.name,
					'img': this.product.imageSources.orig,
				}
			},
		},

		methods: {
			openDetails(e) {
				if (this.quickView) {
					e.preventDefault();

					controller.openModal({
						className: 'modal--page',
						historyUrl: this.product.link,
						component: {
							name: 'v-catalog-item',
							props: {
								dataSource: this.product.quickViewLink
							}
						}
					});
				}
			},
			// модалка подписки на товар
			openNotification() {
				controller.openModal({
					className: 'modal--sm',
					component: {
						name: 'v-add-review',
						props: {
							bxajaxid: 'subsribe-product',
							product: this.computedProductInfo,
							dataSource: this.product.subscribe,
							title: this.product.subscribeText,
						}
					}
				});
			},
		},

		created() {
			this.product.imageSources = {...this.product.imageSources, big: this.product.imageSources.middle, big_2x: this.product.imageSources.middle_2x};
		}
	};

	const _hoisted_1$S = { class: "v-product product" };
	const _hoisted_2$N = {
	  key: 0,
	  class: "product-t-grid"
	};
	const _hoisted_3$H = { class: "product-t-grid__top" };
	const _hoisted_4$x = { class: "product-t-grid__visual flc" };
	const _hoisted_5$t = { class: "product-t-grid__label" };
	const _hoisted_6$q = { class: "product-t-grid__favorite" };
	const _hoisted_7$m = { class: "product-t-grid__action" };
	const _hoisted_8$i = {
	  key: 0,
	  class: "product-t-grid__price flc"
	};
	const _hoisted_9$i = {
	  key: 1,
	  class: "product-t-grid__name flc"
	};
	const _hoisted_10$e = {
	  key: 0,
	  class: "product-t-grid__status"
	};
	const _hoisted_11$d = {
	  key: 1,
	  class: "product-t-grid__brand"
	};
	const _hoisted_12$d = { class: "product-t-grid__rating" };
	const _hoisted_13$b = {
	  key: 2,
	  class: "product-t-grid__rating"
	};
	const _hoisted_14$a = {
	  key: 3,
	  class: "product-t-grid__note"
	};
	const _hoisted_15$8 = {
	  key: 4,
	  class: "product-t-grid__name flc"
	};
	const _hoisted_16$7 = { class: "product-t-grid__rating" };

	function render$$(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_picture = resolveComponent("v-picture");
	  const _component_v_label = resolveComponent("v-label");
	  const _component_v_favorite_action = resolveComponent("v-favorite-action");
	  const _component_v_basket_action = resolveComponent("v-basket-action");
	  const _component_v_price = resolveComponent("v-price");
	  const _component_v_status = resolveComponent("v-status");
	  const _component_v_rating_action = resolveComponent("v-rating-action");

	  return (openBlock(), createBlock("div", _hoisted_1$S, [
	    ($props.template === 'grid')
	      ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	          ($props.product)
	            ? (openBlock(), createBlock("div", _hoisted_2$N, [
	                ($props.product.link)
	                  ? (openBlock(), createBlock("a", {
	                      key: 0,
	                      class: "product-t-grid__link",
	                      href: $props.product.link,
	                      onClick: _cache[1] || (_cache[1] = (...args) => ($options.openDetails && $options.openDetails(...args))),
	                      "aria-label": $props.product.name
	                    }, null, 8 /* PROPS */, ["href", "aria-label"]))
	                  : createCommentVNode("v-if", true),
	                createVNode("div", {
	                  class: ["product-t-grid__card", $props.product?.availability?.class]
	                }, [
	                  createVNode("div", _hoisted_3$H, [
	                    createVNode("div", _hoisted_4$x, [
	                      createVNode(_component_v_picture, {
	                        class: "product-t-grid__image",
	                        sources: $props.product.imageSources
	                      }, null, 8 /* PROPS */, ["sources"]),
	                      createVNode("div", _hoisted_5$t, [
	                        createVNode(_component_v_label, {
	                          label: $props.product.label
	                        }, null, 8 /* PROPS */, ["label"])
	                      ]),
	                      createVNode("div", _hoisted_6$q, [
	                        createVNode(_component_v_favorite_action, {
	                          "product-id": $props.product.id
	                        }, null, 8 /* PROPS */, ["product-id"])
	                      ]),
	                      createVNode("div", _hoisted_7$m, [
	                        ($props.product.subscribe)
	                          ? (openBlock(), createBlock("button", {
	                              key: 0,
	                              class: "btn btn--md btn--full btn--primary-red",
	                              type: "button",
	                              "aria-label": $props.product.subscribeText,
	                              title: $props.product.subscribeText,
	                              onClick: _cache[2] || (_cache[2] = (...args) => ($options.openNotification && $options.openNotification(...args)))
	                            }, toDisplayString($props.product.subscribeText), 9 /* TEXT, PROPS */, ["aria-label", "title"]))
	                          : (openBlock(), createBlock(_component_v_basket_action, {
	                              key: 1,
	                              id: $props.product.id,
	                              count: $props.product.count,
	                              buttons: $props.product.buttons
	                            }, null, 8 /* PROPS */, ["id", "count", "buttons"]))
	                      ])
	                    ]),
	                    ($props.product.price)
	                      ? (openBlock(), createBlock("div", _hoisted_8$i, [
	                          createVNode(_component_v_price, {
	                            price: $props.product.price
	                          }, null, 8 /* PROPS */, ["price"])
	                        ]))
	                      : createCommentVNode("v-if", true),
	                    ($props.product.name)
	                      ? (openBlock(), createBlock("div", _hoisted_9$i, [
	                          ($props.product.status && $props.product.status.length)
	                            ? (openBlock(), createBlock("div", _hoisted_10$e, [
	                                createVNode(_component_v_status, {
	                                  status: $props.product.status
	                                }, null, 8 /* PROPS */, ["status"])
	                              ]))
	                            : createCommentVNode("v-if", true),
	                          ($props.product.brand?.text)
	                            ? (openBlock(), createBlock("span", _hoisted_11$d, toDisplayString($props.product.brand.text), 1 /* TEXT */))
	                            : createCommentVNode("v-if", true),
	                          createTextVNode(" " + toDisplayString($props.product.name), 1 /* TEXT */),
	                          createVNode("div", _hoisted_12$d, [
	                            ($props.product.adminlink)
	                              ? (openBlock(), createBlock("a", {
	                                  key: 0,
	                                  class: "product__admin-link link",
	                                  target: "_blank",
	                                  href: $props.product.adminlink
	                                }, "В админке", 8 /* PROPS */, ["href"]))
	                              : createCommentVNode("v-if", true)
	                          ])
	                        ]))
	                      : createCommentVNode("v-if", true),
	                    ($props.product.rating)
	                      ? (openBlock(), createBlock("div", _hoisted_13$b, [
	                          createVNode(_component_v_rating_action, {
	                            rating: $props.product.rating
	                          }, null, 8 /* PROPS */, ["rating"])
	                        ]))
	                      : createCommentVNode("v-if", true),
	                    ($props.product.note)
	                      ? (openBlock(), createBlock("div", _hoisted_14$a, toDisplayString($props.product.note), 1 /* TEXT */))
	                      : createCommentVNode("v-if", true),
	                    ($props.product.offerNote)
	                      ? (openBlock(), createBlock("div", _hoisted_15$8, [
	                          createVNode("div", _hoisted_16$7, toDisplayString($props.product.offerNote), 1 /* TEXT */)
	                        ]))
	                      : createCommentVNode("v-if", true)
	                  ])
	                ], 2 /* CLASS */)
	              ]))
	            : createCommentVNode("v-if", true)
	        ], 64 /* STABLE_FRAGMENT */))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$Z.render = render$$;
	script$Z.__file = "local/assets/source/components/v-product.vue";

	var script$_ = {
		components: {
			'v-swiper-slide': SwiperSlide
		},

		mixins: [
			script$2
		],

		data() {
			return {
				content: {},
				sliderOptions: {
					slidesPerView: 'auto',
					spaceBetween: 20,
					loop: false,
				},
				desktopSize: true,
				uniqueId: uniqueId('swiper-')
			};
		},

		computed: {
			allItems() {
				if (this.content) {
					return [].concat(this.content?.slider?.slides).concat(this.content?.items);
				} else {
					return []
				}
			}
		},

		mounted() {
			window.addEventListener('resize', this.checkWindowSize);
			this.checkWindowSize();
		},

		unmounted() {
			window.removeEventListener('resize', this.checkWindowSize);
		},

		methods: {
			dataSet(data) {
				this.content = data;
			},

			checkWindowSize() {
				this.desktopSize = window.innerWidth >= breakpoints['md-min'];
			}
		},
	};

	const _hoisted_1$T = { class: "v-blog-preview blog-preview" };
	const _hoisted_2$O = {
	  key: 0,
	  class: "blog-preview__desktop"
	};
	const _hoisted_3$I = { class: "blog-preview__desktop-slider" };
	const _hoisted_4$y = {
	  key: 0,
	  class: "blog-preview__items"
	};
	const _hoisted_5$u = { class: "blog-preview__items-grid" };
	const _hoisted_6$r = { class: "blog-preview__items-cell" };
	const _hoisted_7$n = {
	  key: 0,
	  class: "blog-preview__items-cell"
	};
	const _hoisted_8$j = { class: "blog-preview__instagram__img" };
	const _hoisted_9$j = {
	  key: 0,
	  class: "blog-preview__instagram__text"
	};
	const _hoisted_10$f = {
	  key: 1,
	  class: "blog-preview__instagram__title"
	};
	const _hoisted_11$e = {
	  key: 1,
	  class: "blog-preview__adaptive"
	};
	const _hoisted_12$e = {
	  key: 0,
	  class: "blog-preview__adaptive-slider"
	};
	const _hoisted_13$c = {
	  key: 1,
	  class: "blog-preview__action"
	};
	const _hoisted_14$b = { class: "blog-preview__instagram__img" };
	const _hoisted_15$9 = { class: "blog-preview__instagram__content" };
	const _hoisted_16$8 = {
	  key: 0,
	  class: "blog-preview__instagram__text"
	};
	const _hoisted_17$5 = {
	  key: 1,
	  class: "blog-preview__instagram__title"
	};
	const _hoisted_18$4 = /*#__PURE__*/createVNode("span", { class: "blog-preview__instagram__arrow" }, [
	  /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	    /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-long" })
	  ])
	], -1 /* HOISTED */);

	function render$10(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_hero_slider = resolveComponent("v-hero-slider");
	  const _component_v_blog_item = resolveComponent("v-blog-item");
	  const _component_v_swiper_slide = resolveComponent("v-swiper-slide");
	  const _component_v_swiper_slider = resolveComponent("v-swiper-slider");

	  return (openBlock(), createBlock("div", _hoisted_1$T, [
	    ($data.desktopSize)
	      ? (openBlock(), createBlock("div", _hoisted_2$O, [
	          createVNode("div", _hoisted_3$I, [
	            createVNode(_component_v_hero_slider, {
	              class: "hero-slider--tile",
	              "data-source": $data.content.slider,
	              pagination: {type: 'bullets', clickable: true, dynamicBullets: 3}
	            }, null, 8 /* PROPS */, ["data-source"])
	          ]),
	          ($data.content?.items?.length)
	            ? (openBlock(), createBlock("div", _hoisted_4$y, [
	                createVNode("div", _hoisted_5$u, [
	                  (openBlock(true), createBlock(Fragment, null, renderList($data.content.items, (item) => {
	                    return (openBlock(), createBlock("div", _hoisted_6$r, [
	                      createVNode(_component_v_blog_item, { item: item }, null, 8 /* PROPS */, ["item"])
	                    ]))
	                  }), 256 /* UNKEYED_FRAGMENT */)),
	                  ($data.content?.instagram)
	                    ? (openBlock(), createBlock("div", _hoisted_7$n, [
	                        createVNode("a", {
	                          class: "blog-preview__instagram",
	                          href: $data.content.instagram.link
	                        }, [
	                          createVNode("span", _hoisted_8$j, [
	                            createVNode("img", {
	                              src: $data.content.instagram.img,
	                              loading: "lazy",
	                              decoding: "async",
	                              alt: $data.content.instagram.title,
	                              title: $data.content.instagram.title,
	                              width: "74",
	                              height: "72"
	                            }, null, 8 /* PROPS */, ["src", "alt", "title"])
	                          ]),
	                          ($data.content.instagram.text)
	                            ? (openBlock(), createBlock("span", _hoisted_9$j, toDisplayString($data.content.instagram.text), 1 /* TEXT */))
	                            : createCommentVNode("v-if", true),
	                          ($data.content.instagram.title)
	                            ? (openBlock(), createBlock("span", _hoisted_10$f, toDisplayString($data.content.instagram.title), 1 /* TEXT */))
	                            : createCommentVNode("v-if", true)
	                        ], 8 /* PROPS */, ["href"])
	                      ]))
	                    : createCommentVNode("v-if", true)
	                ])
	              ]))
	            : createCommentVNode("v-if", true)
	        ]))
	      : (openBlock(), createBlock("div", _hoisted_11$e, [
	          ($options.allItems?.length)
	            ? (openBlock(), createBlock("div", _hoisted_12$e, [
	                createVNode(_component_v_swiper_slider, {
	                  options: $data.sliderOptions,
	                  key: $data.uniqueId
	                }, {
	                  main: withCtx(() => [
	                    (openBlock(true), createBlock(Fragment, null, renderList($options.allItems, (item, index) => {
	                      return (openBlock(), createBlock(_component_v_swiper_slide, {
	                        key: item?.id || index
	                      }, {
	                        default: withCtx(() => [
	                          createVNode(_component_v_blog_item, { item: item }, null, 8 /* PROPS */, ["item"])
	                        ]),
	                        _: 2 /* DYNAMIC */
	                      }, 1024 /* DYNAMIC_SLOTS */))
	                    }), 128 /* KEYED_FRAGMENT */))
	                  ]),
	                  _: 1 /* STABLE */
	                }, 8 /* PROPS */, ["options"])
	              ]))
	            : createCommentVNode("v-if", true),
	          ($data.content?.instagram)
	            ? (openBlock(), createBlock("div", _hoisted_13$c, [
	                createVNode("a", {
	                  class: "blog-preview__instagram",
	                  href: $data.content.instagram.link
	                }, [
	                  createVNode("span", _hoisted_14$b, [
	                    createVNode("img", {
	                      src: $data.content.instagram.img,
	                      loading: "lazy",
	                      decoding: "async",
	                      alt: $data.content.instagram.title,
	                      title: $data.content.instagram.title
	                    }, null, 8 /* PROPS */, ["src", "alt", "title"])
	                  ]),
	                  createVNode("span", _hoisted_15$9, [
	                    ($data.content.instagram.text)
	                      ? (openBlock(), createBlock("span", _hoisted_16$8, toDisplayString($data.content.instagram.text), 1 /* TEXT */))
	                      : createCommentVNode("v-if", true),
	                    ($data.content.instagram.title)
	                      ? (openBlock(), createBlock("span", _hoisted_17$5, toDisplayString($data.content.instagram.title), 1 /* TEXT */))
	                      : createCommentVNode("v-if", true)
	                  ]),
	                  _hoisted_18$4
	                ], 8 /* PROPS */, ["href"])
	              ]))
	            : createCommentVNode("v-if", true)
	        ]))
	  ]))
	}

	script$_.render = render$10;
	script$_.__file = "local/assets/source/components/v-blog-preview.vue";

	var script$$ = {
		props: {
			item: {
				type: Object,
				default: function () {
					return {}
				}
			},
		},
	};

	const _hoisted_1$U = { class: "v-blog-item blog-item" };
	const _hoisted_2$P = {
	  key: 1,
	  class: "blog-item__visual"
	};
	const _hoisted_3$J = /*#__PURE__*/createVNode("div", { class: "blog-item__arrow" }, [
	  /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	    /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-long" })
	  ])
	], -1 /* HOISTED */);
	const _hoisted_4$z = { class: "blog-item__content" };

	function render$11(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_picture = resolveComponent("v-picture");

	  return (openBlock(), createBlock("div", _hoisted_1$U, [
	    ($props.item.link)
	      ? (openBlock(), createBlock("a", {
	          key: 0,
	          class: "blog-item__link",
	          href: $props.item.link
	        }, null, 8 /* PROPS */, ["href"]))
	      : createCommentVNode("v-if", true),
	    ($props.item.imageSources)
	      ? (openBlock(), createBlock("div", _hoisted_2$P, [
	          createVNode(_component_v_picture, {
	            sources: $props.item.imageSources,
	            alt: $props.item.title
	          }, null, 8 /* PROPS */, ["sources", "alt"]),
	          _hoisted_3$J
	        ]))
	      : createCommentVNode("v-if", true),
	    createVNode("div", _hoisted_4$z, [
	      ($props.item.title)
	        ? (openBlock(), createBlock("a", {
	            key: 0,
	            class: "blog-item__title",
	            title: $props.item.title,
	            href: $props.item.link
	          }, toDisplayString($props.item.title), 9 /* TEXT, PROPS */, ["title", "href"]))
	        : createCommentVNode("v-if", true)
	    ])
	  ]))
	}

	script$$.render = render$11;
	script$$.__file = "local/assets/source/components/v-blog-item.vue";

	var script$10 = {
		props: {
			src: {
				type: String,
				default: null
			},

			sources: {
				type: Array,
				default: null
			},

			alt: {
				type: String,
				default: ''
			}
		},

		data() {
			return {
				loaded: false
			};
		},
	};

	const _hoisted_1$V = {
	  class: "product-image__placeholder",
	  key: "no-src"
	};
	const _hoisted_2$Q = /*#__PURE__*/createVNode("svg", { class: "svg-icon product-image__placeholder-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-no-photo" })
	], -1 /* HOISTED */);

	function render$12(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_image = resolveComponent("v-image");

	  return (openBlock(), createBlock("div", {
	    class: ["v-product-image product-image", {'product-image--loading': !$data.loaded}]
	  }, [
	    ($props.src)
	      ? (openBlock(), createBlock(_component_v_image, {
	          class: "product-image__image",
	          src: $props.src,
	          sources: $props.sources,
	          alt: $props.alt,
	          key: "src",
	          onLoad: _cache[1] || (_cache[1] = $event => ($data.loaded = true))
	        }, null, 8 /* PROPS */, ["src", "sources", "alt"]))
	      : (openBlock(), createBlock("div", _hoisted_1$V, [
	          _hoisted_2$Q
	        ]))
	  ], 2 /* CLASS */))
	}

	script$10.render = render$12;
	script$10.__file = "local/assets/source/components/v-product-image.vue";

	var script$11 = {
		mixins: [script$2],

		data() {
			return {
				articles: {
					pages: {
						offset: null,
						limit: null,
						count: null,
						autoload: false
					},
				},
				state: {
					pages: null,
				},
				scrollTimeout: null,
			}
		},

		mounted() {
			this.$nextTick(() => {
				document.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
			});
		},

		unmounted() {
			document.removeEventListener('scroll', this.handleScroll);
		},

		methods: {
			dataSet(data, options = {}) {
				if (options.append && this.articles && this.articles.items) {
					let oldItems = this.articles.items;
					this.articles = data;
					this.articles.items = oldItems.concat(this.articles.items);
				} else {
					this.articles = data;
				}

				this.state.pages = this.articles.pages;
			},

			requestDataLoad(dataSetOptions) {
				if (this.loading) {
					return;
				}

				this.dataLoad({
					url: this.articles.remote,
					delay: true,
					data: {
						pages: this.state.pages,
					}
				}, dataSetOptions);
			},


			handleScroll() {
				if (this.$refs?.products && !this.scrollTimeout) {
					this.scrollTimeout = setTimeout(() => {
						if (!this.loading && parseInt(this.articles.pages.count) > parseInt(this.articles.pages.offset) + parseInt(this.articles.pages.limit)
							&& this.$refs.products.getBoundingClientRect().bottom <= window.innerHeight) {
							this.loadMore();
						}
						this.scrollTimeout = null;
					}, 200);
				}
			},

			loadMore() {
				if (!this.articles.pages) {
					return;
				}
				this.state.pages.offset = parseInt(this.articles.pages.offset) + parseInt(this.articles.pages.limit);
				this.state.pages.limit = this.articles.pages.limit;
				this.requestDataLoad({append: this.articles.pages.append});
			},

		},
	};

	const _hoisted_1$W = { class: "v-article-grid article-grid" };
	const _hoisted_2$R = {
	  key: 0,
	  class: "article-grid__wrapper container"
	};
	const _hoisted_3$K = {
	  key: 0,
	  class: "article-grid__header"
	};
	const _hoisted_4$A = { class: "article-grid__title h3" };
	const _hoisted_5$v = {
	  key: 1,
	  class: "article-grid__grid",
	  ref: "products"
	};

	function render$13(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_article_poster = resolveComponent("v-article-poster");

	  return (openBlock(), createBlock("section", _hoisted_1$W, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.articles)
	      ? (openBlock(), createBlock("div", _hoisted_2$R, [
	          ($data.articles.title)
	            ? (openBlock(), createBlock("div", _hoisted_3$K, [
	                createVNode("h1", _hoisted_4$A, toDisplayString($data.articles.title), 1 /* TEXT */)
	              ]))
	            : createCommentVNode("v-if", true),
	          ($data.articles.items?.length)
	            ? (openBlock(), createBlock("div", _hoisted_5$v, [
	                (openBlock(true), createBlock(Fragment, null, renderList($data.articles.items, (item, index) => {
	                  return (openBlock(), createBlock("div", {
	                    class: ["article-grid__cell", [index <= 1 ? 'article-grid__cell--large' : 'article-grid__cell--small']],
	                    key: item.id || index
	                  }, [
	                    createVNode(_component_v_article_poster, { article: item }, null, 8 /* PROPS */, ["article"])
	                  ], 2 /* CLASS */))
	                }), 128 /* KEYED_FRAGMENT */))
	              ], 512 /* NEED_PATCH */))
	            : createCommentVNode("v-if", true)
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$11.render = render$13;
	script$11.__file = "local/assets/source/components/v-article-grid.vue";

	var script$12 = {
		props: {
			article: {
				type: Object,
				default: null
			}
		},

		methods: {
			getDate(date) {
				return new Date(date).toLocaleString('ru', {year: 'numeric', month: 'numeric', day: 'numeric'})
			},
		},
	};

	const _hoisted_1$X = { class: "v-article-poster article-poster" };
	const _hoisted_2$S = { class: "article-poster__visual flc" };
	const _hoisted_3$L = {
	  key: 0,
	  class: "article-poster__arrow"
	};
	const _hoisted_4$B = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-long" })
	], -1 /* HOISTED */);
	const _hoisted_5$w = { class: "article-poster__content" };
	const _hoisted_6$s = {
	  key: 0,
	  class: "article-poster__title flc"
	};

	function render$14(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_picture = resolveComponent("v-picture");

	  return (openBlock(), createBlock("div", _hoisted_1$X, [
	    ($props.article.link)
	      ? (openBlock(), createBlock("a", {
	          key: 0,
	          class: "article-poster__link",
	          href: $props.article.link,
	          "aria-label": $props.article.name
	        }, null, 8 /* PROPS */, ["href", "aria-label"]))
	      : createCommentVNode("v-if", true),
	    createVNode("div", _hoisted_2$S, [
	      createVNode(_component_v_picture, {
	        sources: $props.article.imageSources,
	        alt: $props.article.name
	      }, null, 8 /* PROPS */, ["sources", "alt"]),
	      ($props.article.link)
	        ? (openBlock(), createBlock("div", _hoisted_3$L, [
	            _hoisted_4$B
	          ]))
	        : createCommentVNode("v-if", true)
	    ]),
	    createVNode("div", _hoisted_5$w, [
	      ($props.article.name)
	        ? (openBlock(), createBlock("div", _hoisted_6$s, toDisplayString($props.article.name), 1 /* TEXT */))
	        : createCommentVNode("v-if", true),
	      ($props.article.date)
	        ? (openBlock(), createBlock("time", {
	            key: 1,
	            class: "article-poster__date flc",
	            datetime: $props.article.date
	          }, toDisplayString($options.getDate($props.article.date)), 9 /* TEXT, PROPS */, ["datetime"]))
	        : createCommentVNode("v-if", true)
	    ])
	  ]))
	}

	script$12.render = render$14;
	script$12.__file = "local/assets/source/components/v-article-poster.vue";

	var script$13 = {
		components: {
			'v-swiper-slide': SwiperSlide
		},

		mixins: [script$2],

		props: { 
		},

		data() {
			return {
				uniqueId: uniqueId('gallery-'),
				banners: {}
			}
		},

		computed: {
			
			computedOptionsBanners() {
				let result = {
					watchOverflow: true,
					slidesPerView: 1,
					spaceBetween: 8,
					loop: false
				};
				return result;
			},
		},

		methods: {
			dataSet(data) {
				this.banners = data.banners;
			}
		},
	};

	const _hoisted_1$Y = {
	  key: 0,
	  class: "v-catalog-item-banners catalog-item__banners"
	};
	const _hoisted_2$T = {
	  key: 0,
	  class: "catalog-item__banners-arrow catalog-item__banners-arrow--prev",
	  type: "button",
	  ref: "prevBanner"
	};
	const _hoisted_3$M = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-left-slider-small" })
	], -1 /* HOISTED */);
	const _hoisted_4$C = {
	  key: 1,
	  class: "catalog-item__banners-arrow catalog-item__banners-arrow--next",
	  type: "button",
	  ref: "nextBanner"
	};
	const _hoisted_5$x = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-slider-small" })
	], -1 /* HOISTED */);

	function render$15(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_swiper_slide = resolveComponent("v-swiper-slide");
	  const _component_v_swiper_slider = resolveComponent("v-swiper-slider");

	  return ($data.banners?.length)
	    ? (openBlock(), createBlock("div", _hoisted_1$Y, [
	        createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	        ($data.banners?.length>1)
	          ? (openBlock(), createBlock("button", _hoisted_2$T, [
	              _hoisted_3$M
	            ], 512 /* NEED_PATCH */))
	          : createCommentVNode("v-if", true),
	        createVNode(_component_v_swiper_slider, {
	          options: $options.computedOptionsBanners,
	          pagination: {clickable: false},
	          ref: "bannersSlider",
	          key: $data.uniqueId
	        }, {
	          main: withCtx(() => [
	            (openBlock(true), createBlock(Fragment, null, renderList($data.banners, (slide, index) => {
	              return (openBlock(), createBlock(_component_v_swiper_slide, { key: index }, {
	                default: withCtx(() => [
	                  createVNode("a", {
	                    href: slide.link
	                  }, [
	                    createVNode("img", {
	                      class: "catalog-item__gallery-slide-image",
	                      src: slide.image.big,
	                      alt: ""
	                    }, null, 8 /* PROPS */, ["src"])
	                  ], 8 /* PROPS */, ["href"])
	                ]),
	                _: 2 /* DYNAMIC */
	              }, 1024 /* DYNAMIC_SLOTS */))
	            }), 128 /* KEYED_FRAGMENT */))
	          ]),
	          _: 1 /* STABLE */
	        }, 8 /* PROPS */, ["options"]),
	        ($data.banners?.length>1)
	          ? (openBlock(), createBlock("button", _hoisted_4$C, [
	              _hoisted_5$x
	            ], 512 /* NEED_PATCH */))
	          : createCommentVNode("v-if", true)
	      ]))
	    : createCommentVNode("v-if", true)
	}

	script$13.render = render$15;
	script$13.__file = "local/assets/source/components/v-catalog-item-banners.vue";

	var script$14 = {
		components: {
			'v-swiper-slide': SwiperSlide
		},

		mixins: [
			script$2
		],

		data() {
			return {
				catalog: null,
				uniqueId: uniqueId('gallery-'),
				state: {
					filter: null
				},
				changedFilters: null,
				options: {
					type: Object,
					default: null
				},
				hideToolbar: false,
				adaptiveDevice: false,

				openDescription: false,
				openDescriptionInit: false,
				showMethodUse: false,
				showComposition: false,

				zoomActive: false,
				zoomImageSrc: null,
				zoomViewerWidth: 0,
				zoomViewerHeight: 0,
				zoomMoveX: 0,
				zoomMoveY: 0,
			};
		},

		computed: {
			computedDiscountData(){
				return {
				 'discountList': this.catalog.discountList? this.catalog.discountList : null,
				 'items': [this.catalog.item]
				};
			}, 
			...mapGetters$1({
				userAuthorized: 'user/userAuthorized'
			}),

			computedSlides() {
				let result = [];
				if (this.catalog.item.images?.length) {
					result = result.concat(this.catalog.item.images);
				}
				if (this.catalog.item.videos?.length) {
					result = result.concat(this.catalog.item.videos);
				}
				return result
			},
	 

			computedNewReview() {
				return {
					product: {
						'name': this.catalog.item.name,
						'img': this.catalog.item.images[0].orig,
					},
					form: this.catalog.newReviewLink
				}
			},
		},

		created() {
			window.addEventListener('resizcatalog.item.chockDiscoue', this.getDevice);
			this.getDevice();
		},

		unmounted() {
			window.removeEventListener('resize', this.getDevice);
		},

		methods: {
		

			dataSet(data) {

				if (this.catalog && this.catalog.remote != data.remote) {
					window.history.replaceState(null, null, data.remote);
				}

				this.catalog = data;

				if (this.catalog.item.buttons?.addToBasket) {
					this.catalog.item.buttons.addToBasket.icon = 'basket-mobile';
				}


				this.$nextTick(() => {
					if (this.$refs.description?.clientHeight > 50) {
						this.openDescriptionInit = true;
					}

					controller.slideUp(this.$refs.methodUse, 300);
					controller.slideUp(this.$refs.composition, 300);

					if (this.$refs.bannersSlider) {
						this.$refs.bannersSlider.dataNavigation = {
							nextEl: this.$refs.nextBanner,
							prevEl: this.$refs.prevBanner,
						};
					}

					this.toggleToolbar();

					this.zoomInit();

					document.querySelector('.js-mobile-toolbar').before(this.$refs.toolbar);
				});
			},

			createFilterValue() {
				if (this.catalog && this.catalog.filters) {
					let result = {
						action: 'change-filter',
						filter: {},
						OFFER_ID: null,
					};
					this.catalog.filters.forEach(filter => {
						if (filter.id == 'offers') {
							result['OFFER_ID'] = filter.value;
						} else {
							result['filter'][filter.id] = {'value': [filter.value], 'type': filter.type};
						}

					});


					return result;
				} else {
					return null;
				}
			},

			filterChanged() {
				this.requestDataLoad(this.createFilterValue());
			},

			requestDataLoad(data, dataSetOptions) {
				this.dataLoad({
					url: this.catalog.remote,
					delay: true,
					data: data
				}, dataSetOptions);
			},

			// переключение аккордиона описание
			toggleDescription() {
				this.openDescription = !this.openDescription;
			},

			// переключение аккордиона способ применения
			toggleMethodUse() {
				if (this.showMethodUse) {
					controller.slideUp(this.$refs.methodUse, 300);
					this.showMethodUse = false;
				} else {
					controller.slideDown(this.$refs.methodUse, 300);
					this.showMethodUse = true;
				}
			},

			// переключение аккордиона состав
			toggleComposition() {
				if (this.showComposition) {
					controller.slideUp(this.$refs.composition, 300);
					this.showComposition = false;
				} else {
					controller.slideDown(this.$refs.composition, 300);
					this.showComposition = true;
				}
			},

			// модалка подписки на товар
			openNotification() {
				controller.openModal({
					className: 'modal--sm',
					component: {
						name: 'v-add-review',
						props: {
							bxajaxid: 'subsribe-product',
							product: this.computedNewReview.product,
							dataSource: this.catalog.item.subscribe,
							title: this.catalog.item.subscribeText,
						}
					}
				});
			},

			// модалка подписки на товар
			openShopList() {
				controller.openModal({
					className: 'modal--sm shops-list',
					component: {
						name: 'v-shop-list',
						props: {
							bxajaxid: 'stores-loader',
							dataSource: this.catalog.item.availabilityOfflineLink,
							title: 'Наличие в'
						}
					}
				});
			},

			// переключение видимости фиксированного тоолбара на мобилке
			toggleToolbar() {
				const vm = this;
				const target = this.$refs.toolbar;
				if (target) {
					const options = {root: null, rootMargin: '0px', threshold: 0};
					const callback = function (entries) {
						entries.forEach(entry => {
							if (entry.isIntersecting) {
								vm.hideToolbar = true;
							} else {
								if (entry.boundingClientRect.top < 0) {
									vm.hideToolbar = true;
								} else {
									vm.hideToolbar = false;
								}
							}
						});
					};
					const observer = new IntersectionObserver(callback, options);
					observer.observe(target);
				}
			},

			// отправка измененного состояния отзыва
			changeHelped(options) {
				this.requestDataLoad({
					action: 'change-helped',
					...options
				});
			},

			// подскролл к отзывам
			scrollToReviews() {
				controller.scrollTo(this.$refs.reviews);
			},

			// определение адаптивного устройства
			getDevice() {
				this.adaptiveDevice = window.innerWidth < breakpoints['sm-max'];
			},

			zoomUpdate() {
				var zoomBox = this.$refs.zoomBox;

				if (zoomBox) {
					this.zoomViewerWidth = zoomBox.offsetWidth;
					this.zoomViewerHeight = zoomBox.offsetHeight;
				}
			},

			zoomMove(moveX, moveY) {
				this.zoomMoveX = -moveX * 100;
				this.zoomMoveY = -moveY * 100;
			},

			zoomInit() {
				var zoomBox = this.$refs.zoomBox;
				this.zoomViewerWidth = zoomBox.offsetWidth;
				this.zoomViewerHeight = zoomBox.offsetHeight;

				if (this.$refs.imageGallery) {
					this.$refs.imageGallery.$emit('galleryUpdate');
				}
			},

			zoomActivated: function (image) {
				if (!image)
					return;

				var inst = this;

				this.zoomActive = true;
				this.zoomImageSrc = image.orig;

				setTimeout(function () {
					var zoomBox = inst.$refs.zoomBox;
					if (zoomBox) {
						inst.zoomViewerWidth = zoomBox.offsetWidth;
						inst.zoomViewerHeight = zoomBox.offsetHeight;
					}
				}, 0);
			},

			zoomDeactivated: function () {
				this.zoomActive = false;
			},
		}
	};

	const _hoisted_1$Z = { class: "v-catalog-item catalog-item" };
	const _hoisted_2$U = { class: "container" };
	const _hoisted_3$N = {
	  key: 0,
	  class: "catalog__placeholder"
	};
	const _hoisted_4$D = {
	  key: 1,
	  class: "catalog-item__wrap"
	};
	const _hoisted_5$y = { class: "catalog-item__main" };
	const _hoisted_6$t = {
	  key: 0,
	  class: "catalog-item__name hidden-lg hidden-md"
	};
	const _hoisted_7$o = /*#__PURE__*/createTextVNode();
	const _hoisted_8$k = { class: "catalog-item__visual-wrap" };
	const _hoisted_9$k = { class: "catalog-item__visual" };
	const _hoisted_10$g = {
	  key: 0,
	  class: "catalog-item__label"
	};
	const _hoisted_11$f = {
	  key: 1,
	  class: "catalog-item__status"
	};
	const _hoisted_12$f = {
	  key: 1,
	  class: "catalog-item__rating-empty"
	};
	const _hoisted_13$d = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_14$c = /*#__PURE__*/createVNode("span", null, "отзывов нет", -1 /* HOISTED */);
	const _hoisted_15$a = { class: "catalog-item__favorite" };
	const _hoisted_16$9 = { class: "catalog-item__price flc" };
	const _hoisted_17$6 = { class: "catalog-item__notes" };
	const _hoisted_18$5 = {
	  key: 0,
	  class: "catalog-item__discount-card hidden"
	};
	const _hoisted_19$3 = { class: "catalog-item__filter" };
	const _hoisted_20$3 = { class: "catalog-item__filter-item" };
	const _hoisted_21$3 = {
	  key: 1,
	  class: "catalog-item__availability"
	};
	const _hoisted_22$3 = {
	  key: 2,
	  class: "catalog-item__props"
	};
	const _hoisted_23$3 = {
	  key: 0,
	  class: "catalog-item__props-title h5"
	};
	const _hoisted_24$2 = { class: "catalog-item__props-list" };
	const _hoisted_25$2 = { class: "catalog-item__props-item" };
	const _hoisted_26$2 = {
	  key: 0,
	  class: "catalog-item__props-img"
	};
	const _hoisted_27$2 = {
	  key: 1,
	  class: "catalog-item__props-name"
	};
	const _hoisted_28$2 = {
	  key: 3,
	  class: "catalog-item__description flc"
	};
	const _hoisted_29$2 = { class: "catalog-item__description-body" };
	const _hoisted_30$2 = {
	  key: 0,
	  class: "catalog-item__description-title h5"
	};
	const _hoisted_31$2 = {
	  key: 1,
	  class: "catalog-item__description-props"
	};
	const _hoisted_32$2 = { class: "catalog-item__description-prop" };
	const _hoisted_33$2 = {
	  key: 1,
	  class: "catalog-item__description-info"
	};
	const _hoisted_34$2 = { class: "catalog-item__description-prop" };
	const _hoisted_35$2 = { class: "catalog-item__description-prop-name" };
	const _hoisted_36$2 = { class: "catalog-item__description-prop-val" };
	const _hoisted_37$2 = {
	  key: 0,
	  class: "catalog-item__description-action"
	};
	const _hoisted_38$2 = /*#__PURE__*/createVNode("span", { class: "catalog-item__description-toggle-open" }, "Подробнее", -1 /* HOISTED */);
	const _hoisted_39$2 = /*#__PURE__*/createVNode("span", { class: "catalog-item__description-toggle-close" }, "Свернуть", -1 /* HOISTED */);
	const _hoisted_40$2 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-down-2" })
	], -1 /* HOISTED */);
	const _hoisted_41$2 = {
	  key: 4,
	  class: "catalog-item__accordions"
	};
	const _hoisted_42$2 = { class: "h5" };
	const _hoisted_43$2 = /*#__PURE__*/createVNode("div", { class: "catalog-item__accordion-toggle-icon" }, null, -1 /* HOISTED */);
	const _hoisted_44$2 = { class: "h5" };
	const _hoisted_45$1 = /*#__PURE__*/createVNode("div", { class: "catalog-item__accordion-toggle-icon" }, null, -1 /* HOISTED */);
	const _hoisted_46$1 = {
	  class: "catalog-item__reviews",
	  ref: "reviews"
	};
	const _hoisted_47$1 = {
	  class: "js-catalog-item__toolbar catalog-item__toolbar hidden-lg hidden-md",
	  ref: "toolbar"
	};
	const _hoisted_48$1 = /*#__PURE__*/createVNode("svg", { class: "svg-icon svg-icon--notification" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-notification" })
	], -1 /* HOISTED */);
	const _hoisted_49$1 = {
	  key: 0,
	  class: "catalog-item__aside"
	};
	const _hoisted_50$1 = { class: "catalog-item__panel" };
	const _hoisted_51$1 = {
	  key: 1,
	  class: "catalog-item__rating-empty"
	};
	const _hoisted_52$1 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star" })
	], -1 /* HOISTED */);
	const _hoisted_53$1 = /*#__PURE__*/createVNode("span", null, "отзывов нет", -1 /* HOISTED */);
	const _hoisted_54$1 = { class: "catalog-item__favorite" };
	const _hoisted_55$1 = {
	  key: 1,
	  class: "catalog-item__name"
	};
	const _hoisted_56$1 = { class: "catalog-item__price flc" };
	const _hoisted_57$1 = { class: "catalog-item__notes" };
	const _hoisted_58$1 = {
	  key: 3,
	  class: "catalog-item__discount-card hidden"
	};
	const _hoisted_59$1 = { class: "catalog-item__filter" };
	const _hoisted_60$1 = { class: "catalog-item__filter-item" };
	const _hoisted_61$1 = { class: "catalog-item__basket-action flc" };
	const _hoisted_62$1 = {
	  key: 1,
	  class: "catalog-item__availability"
	};
	const _hoisted_63$1 = /*#__PURE__*/createVNode("svg", { class: "svg-icon svg-icon--notification" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-notification" })
	], -1 /* HOISTED */);
	const _hoisted_64$1 = {
	  key: 4,
	  class: "catalog-item__availability"
	};

	function render$16(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_label = resolveComponent("v-label");
	  const _component_v_status = resolveComponent("v-status");
	  const _component_v_image_gallery = resolveComponent("v-image-gallery");
	  const _component_v_rating_action = resolveComponent("v-rating-action");
	  const _component_v_favorite_action = resolveComponent("v-favorite-action");
	  const _component_v_price = resolveComponent("v-price");
	  const _component_v_discount_block = resolveComponent("v-discount-block");
	  const _component_v_field = resolveComponent("v-field");
	  const _component_v_reviews = resolveComponent("v-reviews");
	  const _component_v_basket_action = resolveComponent("v-basket-action");

	  return (openBlock(), createBlock("section", _hoisted_1$Z, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    createVNode("div", _hoisted_2$U, [
	      (!$data.catalog)
	        ? (openBlock(), createBlock("div", _hoisted_3$N))
	        : createCommentVNode("v-if", true),
	      ($data.catalog)
	        ? (openBlock(), createBlock("div", _hoisted_4$D, [
	            createVNode("div", _hoisted_5$y, [
	              ($data.adaptiveDevice && $data.catalog.item.element_name)
	                ? (openBlock(), createBlock("h1", _hoisted_6$t, [
	                    ($data.catalog.item.brand?.text)
	                      ? (openBlock(), createBlock("a", {
	                          key: 0,
	                          href: $data.catalog.item.brand.link
	                        }, toDisplayString($data.catalog.item.brand.text), 9 /* TEXT, PROPS */, ["href"]))
	                      : createCommentVNode("v-if", true),
	                    _hoisted_7$o,
	                    createVNode("span", null, toDisplayString($data.catalog.item.element_name), 1 /* TEXT */),
	                    ($data.catalog.item.adminlink)
	                      ? (openBlock(), createBlock("a", {
	                          key: 1,
	                          class: "product__admin-link link",
	                          target: "_blank",
	                          href: $data.catalog.item.adminlink
	                        }, "В админке", 8 /* PROPS */, ["href"]))
	                      : createCommentVNode("v-if", true)
	                  ]))
	                : createCommentVNode("v-if", true),
	              createVNode("div", _hoisted_8$k, [
	                createVNode("div", _hoisted_9$k, [
	                  ($data.catalog.item.label?.length)
	                    ? (openBlock(), createBlock("div", _hoisted_10$g, [
	                        createVNode(_component_v_label, {
	                          class: "label--mid",
	                          label: $data.catalog.item.label
	                        }, null, 8 /* PROPS */, ["label"])
	                      ]))
	                    : createCommentVNode("v-if", true),
	                  ($data.catalog.item.status?.length)
	                    ? (openBlock(), createBlock("div", _hoisted_11$f, [
	                        createVNode(_component_v_status, {
	                          status: $data.catalog.item.status
	                        }, null, 8 /* PROPS */, ["status"])
	                      ]))
	                    : createCommentVNode("v-if", true),
	                  createVNode(_component_v_image_gallery, {
	                    ref: "imageGallery",
	                    slides: $options.computedSlides,
	                    onZoomActivated: $options.zoomActivated,
	                    onZoomDeactivated: $options.zoomDeactivated,
	                    onGalleryUpdate: $options.zoomUpdate,
	                    onZoomMove: $options.zoomMove,
	                    "zoom-viewer-width": $data.zoomViewerWidth,
	                    "zoom-viewer-height": $data.zoomViewerHeight
	                  }, null, 8 /* PROPS */, ["slides", "onZoomActivated", "onZoomDeactivated", "onGalleryUpdate", "onZoomMove", "zoom-viewer-width", "zoom-viewer-height"]),
	                  createVNode("div", {
	                    class: ["catalog-item__zoom-box", {active: $data.zoomActive && $data.zoomImageSrc}],
	                    ref: "zoomBox"
	                  }, [
	                    createVNode("img", {
	                      class: "catalog-item__zoom-box-img",
	                      src: $data.zoomImageSrc,
	                      alt: "",
	                      style: {'transform': 'translate3d('+$data.zoomMoveX+'%,'+$data.zoomMoveY+'%,0)', '-webkit-transform': 'translate('+$data.zoomMoveX+'%,'+$data.zoomMoveY+'%)'}
	                    }, null, 12 /* STYLE, PROPS */, ["src"])
	                  ], 2 /* CLASS */)
	                ])
	              ]),
	              ($data.adaptiveDevice)
	                ? (openBlock(), createBlock("div", {
	                    key: 1,
	                    class: ["catalog-item__panel", $data.catalog?.item?.availability?.class]
	                  }, [
	                    createVNode("div", {
	                      class: "catalog-item__rating",
	                      onClick: _cache[1] || (_cache[1] = (...args) => ($options.scrollToReviews && $options.scrollToReviews(...args)))
	                    }, [
	                      ($data.catalog.item.rating)
	                        ? (openBlock(), createBlock(_component_v_rating_action, {
	                            key: 0,
	                            class: "rating-action--mid",
	                            rating: $data.catalog.item.rating
	                          }, null, 8 /* PROPS */, ["rating"]))
	                        : (openBlock(), createBlock("div", _hoisted_12$f, [
	                            _hoisted_13$d,
	                            _hoisted_14$c
	                          ]))
	                    ]),
	                    createVNode("div", _hoisted_15$a, [
	                      createVNode(_component_v_favorite_action, {
	                        "product-id": $data.catalog.item.id,
	                        "size-mid": "size-mid"
	                      }, null, 8 /* PROPS */, ["product-id"])
	                    ]),
	                    createVNode("div", _hoisted_16$9, [
	                      createVNode(_component_v_price, {
	                        price: $data.catalog.item.price,
	                        size: "lg"
	                      }, null, 8 /* PROPS */, ["price"])
	                    ]),
	                    createVNode("div", _hoisted_17$6, [
	                      (openBlock(true), createBlock(Fragment, null, renderList($data.catalog.item.notes, (note) => {
	                        return (openBlock(), createBlock("div", {
	                          class: "catalog-item__note",
	                          style: {background: note.background, color: note.color}
	                        }, toDisplayString(note.name), 5 /* TEXT, STYLE */))
	                      }), 256 /* UNKEYED_FRAGMENT */))
	                    ]),
	                    ($data.catalog.item.chockDiscount?.length)
	                      ? (openBlock(), createBlock("div", _hoisted_18$5, [
	                          createVNode(_component_v_discount_block, { "data-source": $options.computedDiscountData }, null, 8 /* PROPS */, ["data-source"])
	                        ]))
	                      : createCommentVNode("v-if", true),
	                    createVNode("div", _hoisted_19$3, [
	                      (openBlock(true), createBlock(Fragment, null, renderList($data.catalog.filters, (filter) => {
	                        return (openBlock(), createBlock("div", _hoisted_20$3, [
	                          createVNode(_component_v_field, {
	                            modelValue: filter.value,
	                            "onUpdate:modelValue": [$event => (filter.value = $event), $options.filterChanged],
	                            field: filter
	                          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "field"])
	                        ]))
	                      }), 256 /* UNKEYED_FRAGMENT */))
	                    ]),
	                    ($data.catalog.item.availabilityOffline?.items?.length)
	                      ? (openBlock(), createBlock("div", _hoisted_21$3, [
	                          createVNode("button", {
	                            class: "btn btn--full btn--gray",
	                            type: "button",
	                            onClick: _cache[2] || (_cache[2] = (...args) => ($options.openShopList && $options.openShopList(...args))),
	                            "aria-label": $data.catalog.item.availabilityOffline.text,
	                            title: $data.catalog.item.availabilityOffline.text
	                          }, toDisplayString($data.catalog.item.availabilityOffline.text) + " (" + toDisplayString($data.catalog.item.availabilityOffline.items.length) + ")", 9 /* TEXT, PROPS */, ["aria-label", "title"])
	                        ]))
	                      : createCommentVNode("v-if", true)
	                  ], 2 /* CLASS */))
	                : createCommentVNode("v-if", true),
	              ($data.catalog?.item?.props?.items?.length)
	                ? (openBlock(), createBlock("div", _hoisted_22$3, [
	                    ($data.catalog.item.props.title)
	                      ? (openBlock(), createBlock("div", _hoisted_23$3, toDisplayString($data.catalog.item.props.title), 1 /* TEXT */))
	                      : createCommentVNode("v-if", true),
	                    createVNode("div", _hoisted_24$2, [
	                      (openBlock(true), createBlock(Fragment, null, renderList($data.catalog.item.props.items, (prop) => {
	                        return (openBlock(), createBlock("div", _hoisted_25$2, [
	                          (prop.img)
	                            ? (openBlock(), createBlock("div", _hoisted_26$2, [
	                                createVNode("img", {
	                                  src: prop.img,
	                                  loading: "lazy",
	                                  decoding: "async",
	                                  alt: prop.name,
	                                  title: prop.name
	                                }, null, 8 /* PROPS */, ["src", "alt", "title"])
	                              ]))
	                            : createCommentVNode("v-if", true),
	                          (prop.name)
	                            ? (openBlock(), createBlock("div", _hoisted_27$2, toDisplayString(prop.name), 1 /* TEXT */))
	                            : createCommentVNode("v-if", true)
	                        ]))
	                      }), 256 /* UNKEYED_FRAGMENT */))
	                    ])
	                  ]))
	                : createCommentVNode("v-if", true),
	              ($data.catalog.item.description)
	                ? (openBlock(), createBlock("div", _hoisted_28$2, [
	                    createVNode("div", _hoisted_29$2, [
	                      ($data.catalog.item.description.title)
	                        ? (openBlock(), createBlock("div", _hoisted_30$2, toDisplayString($data.catalog.item.description.title), 1 /* TEXT */))
	                        : createCommentVNode("v-if", true),
	                      ($data.catalog.item.description?.props?.length)
	                        ? (openBlock(), createBlock("div", _hoisted_31$2, [
	                            (openBlock(true), createBlock(Fragment, null, renderList($data.catalog.item.description.props, (prop) => {
	                              return (openBlock(), createBlock("div", _hoisted_32$2, toDisplayString(prop.name) + " " + toDisplayString(prop.value), 1 /* TEXT */))
	                            }), 256 /* UNKEYED_FRAGMENT */))
	                          ]))
	                        : createCommentVNode("v-if", true),
	                      createVNode("div", {
	                        class: ["catalog-item__description-body-wrap", {'open': $data.openDescription, 'init': $data.openDescriptionInit}],
	                        ref: "description"
	                      }, [
	                        ($data.catalog.item.description.content)
	                          ? (openBlock(), createBlock("div", {
	                              key: 0,
	                              class: "catalog-item__description-content text-guide",
	                              innerHTML: $data.catalog.item.description.content
	                            }, null, 8 /* PROPS */, ["innerHTML"]))
	                          : createCommentVNode("v-if", true),
	                        ($data.catalog.item.description?.info?.length)
	                          ? (openBlock(), createBlock("div", _hoisted_33$2, [
	                              (openBlock(true), createBlock(Fragment, null, renderList($data.catalog.item.description.info, (prop) => {
	                                return (openBlock(), createBlock("div", _hoisted_34$2, [
	                                  createVNode("div", _hoisted_35$2, toDisplayString(prop.name), 1 /* TEXT */),
	                                  createVNode("div", _hoisted_36$2, toDisplayString(prop.value), 1 /* TEXT */)
	                                ]))
	                              }), 256 /* UNKEYED_FRAGMENT */))
	                            ]))
	                          : createCommentVNode("v-if", true)
	                      ], 2 /* CLASS */)
	                    ]),
	                    ($data.openDescriptionInit)
	                      ? (openBlock(), createBlock("div", _hoisted_37$2, [
	                          createVNode("button", {
	                            class: ["catalog-item__description-toggle btn btn--full btn--gray", {'open': $data.openDescription}],
	                            type: "button",
	                            onClick: _cache[3] || (_cache[3] = (...args) => ($options.toggleDescription && $options.toggleDescription(...args))),
	                            "aria-label": "Развернуть описание",
	                            title: "Развернуть описание"
	                          }, [
	                            _hoisted_38$2,
	                            _hoisted_39$2,
	                            _hoisted_40$2
	                          ], 2 /* CLASS */)
	                        ]))
	                      : createCommentVNode("v-if", true)
	                  ]))
	                : createCommentVNode("v-if", true),
	              ($data.catalog.item.methodUse || $data.catalog.item.composition)
	                ? (openBlock(), createBlock("div", _hoisted_41$2, [
	                    ($data.catalog.item.methodUse)
	                      ? (openBlock(), createBlock("div", {
	                          key: 0,
	                          class: ["catalog-item__accordion", {'open': $data.showMethodUse}]
	                        }, [
	                          ($data.catalog.item.methodUse.title)
	                            ? (openBlock(), createBlock("div", {
	                                key: 0,
	                                class: "catalog-item__accordion-toggle",
	                                onClick: _cache[4] || (_cache[4] = (...args) => ($options.toggleMethodUse && $options.toggleMethodUse(...args)))
	                              }, [
	                                createVNode("div", _hoisted_42$2, toDisplayString($data.catalog.item.methodUse.title), 1 /* TEXT */),
	                                _hoisted_43$2
	                              ]))
	                            : createCommentVNode("v-if", true),
	                          ($data.catalog.item.methodUse.content)
	                            ? (openBlock(), createBlock("div", {
	                                key: 1,
	                                class: "catalog-item__accordion-content",
	                                ref: "methodUse",
	                                innerHTML: $data.catalog.item.methodUse.content
	                              }, null, 8 /* PROPS */, ["innerHTML"]))
	                            : createCommentVNode("v-if", true)
	                        ], 2 /* CLASS */))
	                      : createCommentVNode("v-if", true),
	                    ($data.catalog.item.composition)
	                      ? (openBlock(), createBlock("div", {
	                          key: 1,
	                          class: ["catalog-item__accordion", {'open': $data.showComposition}]
	                        }, [
	                          ($data.catalog.item.composition.title)
	                            ? (openBlock(), createBlock("div", {
	                                key: 0,
	                                class: "catalog-item__accordion-toggle",
	                                onClick: _cache[5] || (_cache[5] = (...args) => ($options.toggleComposition && $options.toggleComposition(...args)))
	                              }, [
	                                createVNode("div", _hoisted_44$2, toDisplayString($data.catalog.item.composition.title), 1 /* TEXT */),
	                                _hoisted_45$1
	                              ]))
	                            : createCommentVNode("v-if", true),
	                          ($data.catalog.item.composition.content)
	                            ? (openBlock(), createBlock("div", {
	                                key: 1,
	                                class: "catalog-item__accordion-content",
	                                ref: "composition",
	                                innerHTML: $data.catalog.item.composition.content
	                              }, null, 8 /* PROPS */, ["innerHTML"]))
	                            : createCommentVNode("v-if", true)
	                        ], 2 /* CLASS */))
	                      : createCommentVNode("v-if", true)
	                  ]))
	                : createCommentVNode("v-if", true),
	              ($data.adaptiveDevice)
	                ? renderSlot(_ctx.$slots, "banners", { key: 5 })
	                : createCommentVNode("v-if", true),
	              createVNode("div", _hoisted_46$1, [
	                createVNode(_component_v_reviews, {
	                  "data-source": $data.catalog.reviewsLink,
	                  onChangeHelped: $options.changeHelped,
	                  bxajaxid: "review-list-ajax",
	                  "new-review": $options.computedNewReview
	                }, null, 8 /* PROPS */, ["data-source", "onChangeHelped", "new-review"])
	              ], 512 /* NEED_PATCH */),
	              createCommentVNode(".catalog-item__toolbar-trigger(ref=\"toolbar\")"),
	              createCommentVNode(".catalog-item__toolbar(v-if=\"adaptiveDevice\" :class=\"{'hide':hideToolbar}\")"),
	              createVNode("div", _hoisted_47$1, [
	                ($data.catalog.item.availability.value)
	                  ? (openBlock(), createBlock(_component_v_basket_action, {
	                      key: 0,
	                      class: "basket-action--detail",
	                      id: $data.catalog.item.id,
	                      buttons: $data.catalog.item.buttons,
	                      count: $data.catalog.item.count
	                    }, null, 8 /* PROPS */, ["id", "buttons", "count"]))
	                  : createCommentVNode("v-if", true),
	                ($data.catalog.item.subscribe)
	                  ? (openBlock(), createBlock("button", {
	                      key: 1,
	                      class: "catalog-item__notification btn btn--primary-red btn--full",
	                      type: "button",
	                      onClick: _cache[6] || (_cache[6] = (...args) => ($options.openNotification && $options.openNotification(...args))),
	                      title: $data.catalog.item.subscribeText
	                    }, [
	                      _hoisted_48$1,
	                      createVNode("span", null, toDisplayString($data.catalog.item.subscribeText), 1 /* TEXT */)
	                    ], 8 /* PROPS */, ["title"]))
	                  : createCommentVNode("v-if", true)
	              ], 512 /* NEED_PATCH */)
	            ]),
	            (!$data.adaptiveDevice)
	              ? (openBlock(), createBlock("div", _hoisted_49$1, [
	                  createVNode("div", {
	                    class: ["catalog-item__aside-wrap", $data.catalog?.item?.availability?.class]
	                  }, [
	                    createVNode("div", _hoisted_50$1, [
	                      createVNode("div", {
	                        class: "catalog-item__rating",
	                        onClick: _cache[7] || (_cache[7] = (...args) => ($options.scrollToReviews && $options.scrollToReviews(...args)))
	                      }, [
	                        ($data.catalog.item.rating)
	                          ? (openBlock(), createBlock(_component_v_rating_action, {
	                              key: 0,
	                              class: "rating-action--mid",
	                              rating: $data.catalog.item.rating
	                            }, null, 8 /* PROPS */, ["rating"]))
	                          : (openBlock(), createBlock("div", _hoisted_51$1, [
	                              _hoisted_52$1,
	                              _hoisted_53$1
	                            ]))
	                      ]),
	                      createVNode("div", _hoisted_54$1, [
	                        createVNode(_component_v_favorite_action, {
	                          "product-id": $data.catalog.item.id,
	                          "size-mid": "size-mid"
	                        }, null, 8 /* PROPS */, ["product-id"])
	                      ]),
	                      ($data.catalog.item.brand?.text)
	                        ? (openBlock(), createBlock("a", {
	                            key: 0,
	                            class: "catalog-item__brand",
	                            href: $data.catalog.item.brand.link
	                          }, toDisplayString($data.catalog.item.brand.text), 9 /* TEXT, PROPS */, ["href"]))
	                        : createCommentVNode("v-if", true),
	                      ($data.catalog.item.element_name)
	                        ? (openBlock(), createBlock("h1", _hoisted_55$1, toDisplayString($data.catalog.item.element_name), 1 /* TEXT */))
	                        : createCommentVNode("v-if", true),
	                      ($data.catalog.item.adminlink)
	                        ? (openBlock(), createBlock("a", {
	                            key: 2,
	                            class: "product__admin-link link",
	                            target: "_blank",
	                            href: $data.catalog.item.adminlink
	                          }, "В админке", 8 /* PROPS */, ["href"]))
	                        : createCommentVNode("v-if", true),
	                      createVNode("div", _hoisted_56$1, [
	                        createVNode(_component_v_price, {
	                          price: $data.catalog.item.price,
	                          size: "lg"
	                        }, null, 8 /* PROPS */, ["price"])
	                      ]),
	                      createVNode("div", _hoisted_57$1, [
	                        (openBlock(true), createBlock(Fragment, null, renderList($data.catalog.item.notes, (note) => {
	                          return (openBlock(), createBlock("div", {
	                            class: "catalog-item__note",
	                            style: {background: note.background, color: note.color}
	                          }, toDisplayString(note.name), 5 /* TEXT, STYLE */))
	                        }), 256 /* UNKEYED_FRAGMENT */))
	                      ]),
	                      ($data.catalog.item.chockDiscount?.length)
	                        ? (openBlock(), createBlock("div", _hoisted_58$1, [
	                            createVNode(_component_v_discount_block, { "data-source": $options.computedDiscountData }, null, 8 /* PROPS */, ["data-source"])
	                          ]))
	                        : createCommentVNode("v-if", true),
	                      createVNode("div", _hoisted_59$1, [
	                        (openBlock(true), createBlock(Fragment, null, renderList($data.catalog.filters, (filter) => {
	                          return (openBlock(), createBlock("div", _hoisted_60$1, [
	                            createVNode(_component_v_field, {
	                              modelValue: filter.value,
	                              "onUpdate:modelValue": [$event => (filter.value = $event), $options.filterChanged],
	                              field: filter
	                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "field"])
	                          ]))
	                        }), 256 /* UNKEYED_FRAGMENT */))
	                      ]),
	                      createVNode("div", _hoisted_61$1, [
	                        ($data.catalog.item.availability.value)
	                          ? (openBlock(), createBlock(_component_v_basket_action, {
	                              key: 0,
	                              class: "basket-action--detail",
	                              id: $data.catalog.item.id,
	                              buttons: $data.catalog.item.buttons,
	                              count: $data.catalog.item.count
	                            }, null, 8 /* PROPS */, ["id", "buttons", "count"]))
	                          : createCommentVNode("v-if", true),
	                        ($data.catalog.item.subscribe)
	                          ? (openBlock(), createBlock("div", _hoisted_62$1, [
	                              createVNode("button", {
	                                class: "catalog-item__notification btn btn--primary-red btn--full",
	                                type: "button",
	                                onClick: _cache[8] || (_cache[8] = (...args) => ($options.openNotification && $options.openNotification(...args))),
	                                title: $data.catalog.item.subscribeText
	                              }, [
	                                _hoisted_63$1,
	                                createVNode("span", null, toDisplayString($data.catalog.item.subscribeText), 1 /* TEXT */)
	                              ], 8 /* PROPS */, ["title"])
	                            ]))
	                          : createCommentVNode("v-if", true)
	                      ]),
	                      ($data.catalog.item.availabilityOffline?.items?.length)
	                        ? (openBlock(), createBlock("div", _hoisted_64$1, [
	                            createVNode("button", {
	                              class: "btn btn--full btn--gray",
	                              type: "button",
	                              onClick: _cache[9] || (_cache[9] = (...args) => ($options.openShopList && $options.openShopList(...args))),
	                              "aria-label": $data.catalog.item.availabilityOffline.text,
	                              title: $data.catalog.item.availabilityOffline.text
	                            }, toDisplayString($data.catalog.item.availabilityOffline.text) + " (" + toDisplayString($data.catalog.item.availabilityOffline.items.length) + ")", 9 /* TEXT, PROPS */, ["aria-label", "title"])
	                          ]))
	                        : createCommentVNode("v-if", true)
	                    ]),
	                    renderSlot(_ctx.$slots, "banners")
	                  ], 2 /* CLASS */)
	                ]))
	              : createCommentVNode("v-if", true)
	          ]))
	        : createCommentVNode("v-if", true)
	    ])
	  ]))
	}

	script$14.render = render$16;
	script$14.__file = "local/assets/source/components/v-catalog-item.vue";

	var script$15 = {
		mixins: [
			script$2,
			script$y,
		],

		data() {
			return {
				input: null,
				active: false,
				adaptiveDevice: false,
				loading: false,
				localQuery: null,
				searchTimeout: null,
				field: {
					'type': 'search',
					'label': null,
					'inputmode': 'search',
					'placeholder': 'Товар, бренд или артикул'
				},
				search: {
					remote: null,
					query: null,
					link: null,
					suggestions: null
				},
				outsideClickStart: false
			};
		},

		computed: {
			checkSearchQuery() {
				return this.localQuery?.length;
			},

			computedResultText() {
				if (this.search.itemsTotal % 10 === 1 && this.search.itemsTotal !== 11) {
					return 'результат'
				} else if (this.search.itemsTotal % 10 > 1 && this.search.itemsTotal % 10 < 5) {
					return 'результата'
				} else {
					return 'результатов'
				}
			},

			computedSuggestionsList() {
				if (this.search?.suggestions?.length) {
					return this.search.suggestions.map((item) => {
						const name = item.name;
						const posSearchValue = name.toLowerCase().indexOf(this.search.query);
						let computedName = name.slice(0, posSearchValue) + `<b>${name.substr(posSearchValue, this.search.query.length)}</b>` +
							name.slice(posSearchValue + this.search.query.length);
						if (posSearchValue === -1) {
							computedName = name;
						}
						return {...item, name: computedName}
					})
				} else {
					return []
				}
			}
		},

		watch: {
			localQuery() {
				this.searchInput();
			}
		},

		created() {
			document.addEventListener('click', this.clickOutside);
			document.addEventListener('mousedown', this.checkClickStart);
			document.addEventListener('touchstart', this.checkClickStart);
			controller.events.on('search-small-open', this.open);
			controller.events.on('search-small-close', this.close);

			window.addEventListener('resize', this.getDevice);
			this.getDevice();
		},

		unmounted() {
			document.removeEventListener('click', this.clickOutside);
			document.removeEventListener('mousedown', this.checkClickStart);
			document.removeEventListener('touchstart', this.checkClickStart);
			window.removeEventListener('resize', this.getDevice);
		},

		methods: {

			getDevice() {
				this.adaptiveDevice = window.innerWidth < breakpoints['xs-max'];
			},

			relocate(e) {
				e.preventDefault();

				if (this.search.link && this.checkSearchQuery) {
					let searchUrl = new URL(window.location.protocol + window.location.host + this.search.link);
					searchUrl.searchParams.append('query', this.localQuery);
					searchUrl.searchParams.append('q', this.localQuery);

					if (typeof (controller.loadPage) != 'function' || controller.loadPage(searchUrl, null)) {
						window.location = searchUrl;
						this.close();
					}
				}

				return false;
			},

			open() {
				document.body.classList.add('state--search-small-open');
			},

			close() {
				this.localQuery = null;
				this.search.suggestions = null;
				this.search.empty = null;
				document.body.classList.remove('state--search-small-open');
			},

			clear() {
				this.localQuery = null;
				this.search.suggestions = [];
				this.input.focus();
			},

			back() {
				this.close();
				controller.closeModal();
			},

			focusField() {
				this.active = true;
			},

			blurField() {
				this.active = false;
			},

			clickOutside(e) {
				const check = Array.from(document.querySelectorAll('.v-search-small')).every((element) => {
					if (!element.contains(e.target)) {
						return true
					}
				});
				if (check && this.outsideClickStart) {
					controller.closeSearchSmall();
				}
			},

			searchInput() {
				clearTimeout(this.searchTimeout);
				if (this.localQuery && this.localQuery.length >= 3) {
					this.searchTimeout = setTimeout(() => {
						this.requestDataLoad();
					}, 500);
				} else {
					controller.closeSearchSmall();
				}
			},

			requestDataLoad() {
				this.dataLoad({
					url: this.search.remote,
					delay: true,
					data: {
						query: this.localQuery,
						bxajaxid: this.bxajaxid
					}
				});
			},

			dataSet(data) {
				if (this.$el) {
					this.input = this.$el.querySelector('input');
				}

				this.search = data;
				if (this.checkSearchQuery) {
					this.search = data;
				}
				if (this.search.empty || this.search.suggestions?.length) {
					controller.openSearchSmall();
				}
			},

			openModal() {
				controller.openModal({
					className: 'modal--sm  modal--search',
					component: {
						name: 'v-search-small',
						props: {
							dataSource: this.search,
							bxajaxid: this.bxajaxid,
							title: null
						}
					}
				});
			},

			checkClickStart(e) {
				if (!e.target.closest('.v-search-small')) {
					this.outsideClickStart = true;
				} else {
					this.outsideClickStart = false;
				}
			},
		}
	};

	const _hoisted_1$_ = { class: "search-small__wrap" };
	const _hoisted_2$V = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-left-text" })
	], -1 /* HOISTED */);
	const _hoisted_3$O = {
	  key: 1,
	  class: "search-small__submit-btn",
	  "aria-label": "Найти",
	  type: "submit"
	};
	const _hoisted_4$E = /*#__PURE__*/createVNode("svg", { class: "svg-icon search-small__submit-btn-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-lens" })
	], -1 /* HOISTED */);
	const _hoisted_5$z = { class: "search-small__result" };
	const _hoisted_6$u = {
	  class: "search-small__loader-wrap",
	  key: "loading"
	};
	const _hoisted_7$p = {
	  class: "search-small__result-message",
	  key: "no-suggestions"
	};
	const _hoisted_8$l = /*#__PURE__*/createVNode("div", { class: "search-small__result-icon" }, [
	  /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	    /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-empty-search" })
	  ])
	], -1 /* HOISTED */);
	const _hoisted_9$l = {
	  class: "search-small__result-wrap scrollbar",
	  key: "suggestions"
	};
	const _hoisted_10$h = { class: "search-small__suggestion-list" };
	const _hoisted_11$g = { class: "search-small__suggestion" };
	const _hoisted_12$g = { class: "search-small__visual" };
	const _hoisted_13$e = {
	  key: 1,
	  class: "svg-icon"
	};
	const _hoisted_14$d = /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-lens" }, null, -1 /* HOISTED */);
	const _hoisted_15$b = { class: "search-small__content" };
	const _hoisted_16$a = { class: "search-small__category" };
	const _hoisted_17$7 = {
	  key: 1,
	  class: "search-small__price"
	};
	const _hoisted_18$6 = { key: 0 };
	const _hoisted_19$4 = { key: 1 };
	const _hoisted_20$4 = { key: 2 };
	const _hoisted_21$4 = { key: 0 };
	const _hoisted_22$4 = { key: 1 };
	const _hoisted_23$4 = {
	  key: 0,
	  class: "search-small__action"
	};
	const _hoisted_24$3 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-long" })
	], -1 /* HOISTED */);

	function render$17(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_field = resolveComponent("v-field");
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_picture = resolveComponent("v-picture");

	  return (openBlock(), createBlock("div", {
	    class: ["v-search-small search-small", {'search-small--full': $data.search.suggestions?.length, 'search-small--active': $data.active}]
	  }, [
	    createVNode("div", _hoisted_1$_, [
	      ($data.adaptiveDevice)
	        ? (openBlock(), createBlock("button", {
	            key: 0,
	            class: "search-small__open-modal",
	            type: "button",
	            onClick: _cache[1] || (_cache[1] = (...args) => ($options.openModal && $options.openModal(...args)))
	          }))
	        : createCommentVNode("v-if", true),
	      createVNode("form", {
	        class: "search-small__form",
	        onSubmit: _cache[5] || (_cache[5] = withModifiers((...args) => ($options.relocate && $options.relocate(...args)), ["prevent"]))
	      }, [
	        createVNode(_component_v_field, {
	          class: "search-small__field",
	          field: $data.field,
	          modelValue: $data.localQuery,
	          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ($data.localQuery = $event)),
	          onFocus: $options.focusField,
	          onBlur: $options.blurField
	        }, null, 8 /* PROPS */, ["field", "modelValue", "onFocus", "onBlur"]),
	        ($options.checkSearchQuery)
	          ? (openBlock(), createBlock("button", {
	              key: 0,
	              class: "search-small__close-btn",
	              "aria-label": "Очистить",
	              type: "button",
	              onClick: _cache[3] || (_cache[3] = (...args) => ($options.clear && $options.clear(...args)))
	            }))
	          : createCommentVNode("v-if", true),
	        withDirectives(createVNode("button", {
	          class: "search-small__back-btn",
	          onClick: _cache[4] || (_cache[4] = (...args) => ($options.back && $options.back(...args))),
	          "aria-label": "Закрыть",
	          type: "button"
	        }, [
	          _hoisted_2$V
	        ], 512 /* NEED_PATCH */), [
	          [vShow, $options.checkSearchQuery || $data.active]
	        ]),
	        (!$options.checkSearchQuery && !$data.active)
	          ? (openBlock(), createBlock("button", _hoisted_3$O, [
	              _hoisted_4$E
	            ]))
	          : createCommentVNode("v-if", true)
	      ], 32 /* HYDRATE_EVENTS */),
	      createVNode("div", _hoisted_5$z, [
	        ($data.loading)
	          ? (openBlock(), createBlock("div", _hoisted_6$u, [
	              createVNode(_component_v_loader, { loading: $data.loading }, null, 8 /* PROPS */, ["loading"])
	            ]))
	          : ($data.search && $data.search.suggestions && !$data.search.suggestions.length && $data.search.empty)
	            ? (openBlock(), createBlock("div", _hoisted_7$p, [
	                _hoisted_8$l,
	                createTextVNode(toDisplayString($data.search.empty), 1 /* TEXT */)
	              ]))
	            : createCommentVNode("v-if", true),
	        withDirectives(createVNode("div", _hoisted_9$l, [
	          createVNode("div", _hoisted_10$h, [
	            (openBlock(true), createBlock(Fragment, null, renderList($options.computedSuggestionsList, (suggestion, index) => {
	              return (openBlock(), createBlock("div", {
	                class: "search-small__suggestion-wrap flc",
	                key: index
	              }, [
	                createVNode("a", {
	                  class: "search-small__link",
	                  href: suggestion.link
	                }, toDisplayString(suggestion.text), 9 /* TEXT, PROPS */, ["href"]),
	                createVNode("div", _hoisted_11$g, [
	                  createVNode("div", _hoisted_12$g, [
	                    (suggestion.imageSources)
	                      ? (openBlock(), createBlock(_component_v_picture, {
	                          key: 0,
	                          sources: suggestion.imageSources,
	                          alt: suggestion.name
	                        }, null, 8 /* PROPS */, ["sources", "alt"]))
	                      : (openBlock(), createBlock("svg", _hoisted_13$e, [
	                          _hoisted_14$d
	                        ]))
	                  ]),
	                  createVNode("div", _hoisted_15$b, [
	                    (suggestion.name)
	                      ? (openBlock(), createBlock("div", {
	                          key: 0,
	                          class: "search-small__name",
	                          innerHTML: suggestion.name
	                        }, null, 8 /* PROPS */, ["innerHTML"]))
	                      : createCommentVNode("v-if", true),
	                    createVNode("div", _hoisted_16$a, toDisplayString(suggestion.category), 1 /* TEXT */),
	                    (suggestion.price)
	                      ? (openBlock(), createBlock("div", _hoisted_17$7, [
	                          (suggestion.price.min)
	                            ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	                                (suggestion.price.min)
	                                  ? (openBlock(), createBlock("span", _hoisted_18$6, toDisplayString(_ctx.formatPrice(suggestion.price.min.value)), 1 /* TEXT */))
	                                  : createCommentVNode("v-if", true),
	                                (suggestion.price.max)
	                                  ? (openBlock(), createBlock("span", _hoisted_19$4, "—"))
	                                  : createCommentVNode("v-if", true),
	                                (suggestion.price.max)
	                                  ? (openBlock(), createBlock("span", _hoisted_20$4, toDisplayString(_ctx.formatPrice(suggestion.price.max.value)) + " " + toDisplayString(suggestion.price.max.currency), 1 /* TEXT */))
	                                  : createCommentVNode("v-if", true)
	                              ], 64 /* STABLE_FRAGMENT */))
	                            : (suggestion.price.current)
	                              ? (openBlock(), createBlock(Fragment, { key: 1 }, [
	                                  (suggestion.price.current)
	                                    ? (openBlock(), createBlock("span", _hoisted_21$4, toDisplayString(_ctx.formatPrice(suggestion.price.current.value)), 1 /* TEXT */))
	                                    : createCommentVNode("v-if", true),
	                                  (suggestion.price.current.currency)
	                                    ? (openBlock(), createBlock("span", _hoisted_22$4, toDisplayString(suggestion.price.current.currency), 1 /* TEXT */))
	                                    : createCommentVNode("v-if", true)
	                                ], 64 /* STABLE_FRAGMENT */))
	                              : createCommentVNode("v-if", true)
	                        ]))
	                      : createCommentVNode("v-if", true)
	                  ])
	                ])
	              ]))
	            }), 128 /* KEYED_FRAGMENT */))
	          ]),
	          ($data.search.suggestions?.length)
	            ? (openBlock(), createBlock("div", _hoisted_23$4, [
	                createVNode("a", {
	                  class: "btn btn--primary btn--full",
	                  href: $data.search.link
	                }, [
	                  createTextVNode("Все " + toDisplayString($data.search.itemsTotal) + " " + toDisplayString($options.computedResultText), 1 /* TEXT */),
	                  _hoisted_24$3
	                ], 8 /* PROPS */, ["href"])
	              ]))
	            : createCommentVNode("v-if", true)
	        ], 512 /* NEED_PATCH */), [
	          [vShow, $data.search.suggestions?.length]
	        ])
	      ])
	    ])
	  ], 2 /* CLASS */))
	}

	script$15.render = render$17;
	script$15.__file = "local/assets/source/components/v-search-small.vue";

	/*!
	 * Lightweight URL manipulation with JavaScript
	 * This library is independent of any other libraries and has pretty simple
	 * interface and lightweight code-base.
	 * Some ideas of query string parsing had been taken from Jan Wolter
	 * @see http://unixpapa.com/js/querystring.html
	 *
	 * @license MIT
	 * @author Mykhailo Stadnyk <mikhus@gmail.com> and contributors
	 * @see https://github.com/Mikhus/domurl/graphs/contributors
	 */

	var ns = window;
	var RX_PROTOCOL = /^[a-z]+:/;
	var RX_PORT = /[-a-z0-9]+(\.[-a-z0-9])*:\d+/i;
	var RX_CREDS = /\/\/(.*?)(?::(.*?))?@/;
	var RX_WIN = /^win/i;
	var RX_PROTOCOL_REPL = /:$/;
	var RX_QUERY_REPL = /^\?/;
	var RX_HASH_REPL = /^#/;
	var RX_PATH = /(.*\/)/;
	var RX_PATH_FIX = /^\/{2,}/;
	// https://news.ycombinator.com/item?id=3939454
	var RX_PATH_IE_FIX = /(^\/?)/;
	var RX_SINGLE_QUOTE = /'/g;
	var RX_DECODE_1 = /%([ef][0-9a-f])%([89ab][0-9a-f])%([89ab][0-9a-f])/gi;
	var RX_DECODE_2 = /%([cd][0-9a-f])%([89ab][0-9a-f])/gi;
	var RX_DECODE_3 = /%([0-7][0-9a-f])/gi;
	var RX_PLUS = /\+/g;
	var RX_PATH_SEMI = /^\w:$/;
	var RX_URL_TEST = /[^/#?]/;

	// configure given url options
	function urlConfig(url) {
		var config = {
			path: true,
			query: true,
			hash: true
		};

		if (!url) {
			return config;
		}

		if (RX_PROTOCOL.test(url)) {
			config.protocol = true;
			config.host = true;

			if (RX_PORT.test(url)) {
				config.port = true;
			}

			if (RX_CREDS.test(url)) {
				config.user = true;
				config.pass = true;
			}
		}

		return config;
	}

	var isNode = typeof window === 'undefined' &&
		typeof global !== 'undefined' &&
		typeof require === 'function';
	var isIe = !isNode && ns.navigator && ns.navigator.userAgent &&
		~ns.navigator.userAgent.indexOf('MSIE');

	// Trick to bypass Webpack's require at compile time
	var nodeRequire = isNode ? ns['require'] : null;

	// mapping between what we want and <a> element properties
	var map$1 = {
		protocol: 'protocol',
		host: 'hostname',
		port: 'port',
		path: 'pathname',
		query: 'search',
		hash: 'hash'
	};

	// jscs: disable
	/**
	 * default ports as defined by http://url.spec.whatwg.org/#default-port
	 * We need them to fix IE behavior,
	 * @see https://github.com/Mikhus/jsurl/issues/2
	 */
	// jscs: enable
	var defaultPorts = {
		ftp: 21,
		gopher: 70,
		http: 80,
		https: 443,
		ws: 80,
		wss: 443
	};

	var _currNodeUrl;

	function getCurrUrl() {
		if (isNode) {
			if (!_currNodeUrl) {
				_currNodeUrl = ('file://' +
					(process.platform.match(RX_WIN) ? '/' : '') +
					nodeRequire('fs').realpathSync('.')
				);
			}
			return _currNodeUrl;
		} else if (document.location.href === 'about:srcdoc') {
			return self.parent.document.location.href;
		} else {
			return document.location.href;
		}
	}

	function parse(self, url, absolutize) {
		var link, i, auth;

		if (!url) {
			url = getCurrUrl();
		}

		if (isNode) {
			link = nodeRequire('url').parse(url);
		} else {
			link = document.createElement('a');
			link.href = url;
		}

		var config = urlConfig(url);

		auth = url.match(RX_CREDS) || [];

		for (i in map$1) {
			if (config[i]) {
				self[i] = link[map$1[i]] || '';
			} else {
				self[i] = '';
			}
		}

		// fix-up some parts
		self.protocol = self.protocol.replace(RX_PROTOCOL_REPL, '');
		self.query = self.query.replace(RX_QUERY_REPL, '');
		self.hash = decode(self.hash.replace(RX_HASH_REPL, ''));
		self.user = decode(auth[1] || '');
		self.pass = decode(auth[2] || '');
		/* jshint ignore:start */
		self.port = (
			// loosely compare because port can be a string
			defaultPorts[self.protocol] == self.port || self.port == 0
		) ? '' : self.port; // IE fix, Android browser fix
		/* jshint ignore:end */

		if (!config.protocol && RX_URL_TEST.test(url.charAt(0))) {
			self.path = url.split('?')[0].split('#')[0];
		}

		if (!config.protocol && absolutize) {
			// is IE and path is relative
			var base = new Url(getCurrUrl().match(RX_PATH)[0]);
			var basePath = base.path.split('/');
			var selfPath = self.path.split('/');
			var props = ['protocol', 'user', 'pass', 'host', 'port'];
			var s = props.length;

			basePath.pop();

			for (i = 0; i < s; i++) {
				self[props[i]] = base[props[i]];
			}

			while (selfPath[0] === '..') { // skip all "../
				basePath.pop();
				selfPath.shift();
			}

			self.path =
				(url.charAt(0) !== '/' ? basePath.join('/') : '') +
				'/' + selfPath.join('/')
			;
		}

		self.path = self.path.replace(RX_PATH_FIX, '/');
		isIe && (self.path = self.path.replace(RX_PATH_IE_FIX, '/'));

		self.paths(self.paths());

		self.query = new QueryString(self.query);
	}

	function encode(s) {
		return encodeURIComponent(s).replace(RX_SINGLE_QUOTE, '%27');
	}

	function decode(s) {
		s = s.replace(RX_PLUS, ' ');
		s = s.replace(RX_DECODE_1, function (code, hex1, hex2, hex3) {
			var n1 = parseInt(hex1, 16) - 0xE0;
			var n2 = parseInt(hex2, 16) - 0x80;

			if (n1 === 0 && n2 < 32) {
				return code;
			}

			var n3 = parseInt(hex3, 16) - 0x80;
			var n = (n1 << 12) + (n2 << 6) + n3;

			if (n > 0xFFFF) {
				return code;
			}

			return String.fromCharCode(n);
		});
		s = s.replace(RX_DECODE_2, function (code, hex1, hex2) {
			var n1 = parseInt(hex1, 16) - 0xC0;

			if (n1 < 2) {
				return code;
			}

			var n2 = parseInt(hex2, 16) - 0x80;

			return String.fromCharCode((n1 << 6) + n2);
		});

		return s.replace(RX_DECODE_3, function (code, hex) {
			return String.fromCharCode(parseInt(hex, 16));
		});
	}

	/**
	 * Class QueryString
	 *
	 * @param {string} qs - string representation of QueryString
	 * @constructor
	 */
	function QueryString(qs) {
		var parts = qs.split('&');

		for (var i = 0, s = parts.length; i < s; i++) {
			var keyVal = parts[i].split('=');
			var key = decodeURIComponent(keyVal[0].replace(RX_PLUS, ' '));
			key = key.replace('[]', '');
			if (!key) {
				continue;
			}

			var value = keyVal[1] !== undefined ? decode(keyVal[1]) : null;

			if (this[key] === undefined) {
				this[key] = value;
			} else {
				if (!(this[key] instanceof Array)) {
					this[key] = [this[key]];
				}

				this[key].push(value);
			}
		}
	}

	/**
	 * Converts QueryString object back to string representation
	 *
	 * @returns {string}
	 */
	QueryString.prototype.toString = function () {
		var s = '';
		var e = encode;
		var i, ii;

		for (i in this) {
			var w = this[i];

			if (w instanceof Function || w === undefined) {
				continue;
			}

			if (w instanceof Array) {
				var len = w.length;

				if (!len) {
					// Parameter is an empty array, so treat as
					// an empty argument
					s += (s ? '&' : '') + e(i) + '=';
					continue;
				}

				for (ii = 0; ii < len; ii++) {
					var v = w[ii];
					if (v === undefined) {
						continue;
					}
					s += s ? '&' : '';
					s += e(i) + '[]' + (v === null ? '' : '=' + e(v));

					console.log(e(i) + '[]' + (v === null ? '' : '=' + e(v)));
				}
				continue;
			}

			// Plain value
			s += s ? '&' : '';
			s += e(i) + (w === null ? '' : '=' + e(w));
		}

		return s;
	};

	/**
	 * Class Url
	 *
	 * @param {string} [url] - string URL representation
	 * @param {boolean} [noTransform] - do not transform to absolute URL
	 * @constructor
	 */
	function Url(url, noTransform) {
		parse(this, url, !noTransform);
	}

	/**
	 * Clears QueryString, making it contain no params at all
	 *
	 * @returns {Url}
	 */
	Url.prototype.clearQuery = function () {
		for (var key in this.query) {
			if (!(this.query[key] instanceof Function)) {
				delete this.query[key];
			}
		}

		return this;
	};

	/**
	 * Returns total number of parameters in QueryString
	 *
	 * @returns {number}
	 */
	Url.prototype.queryLength = function () {
		var count = 0;

		for (var key in this.query) {
			if (!(this.query[key] instanceof Function)) {
				count++;
			}
		}

		return count;
	};

	/**
	 * Returns true if QueryString contains no parameters, false otherwise
	 *
	 * @returns {boolean}
	 */
	Url.prototype.isEmptyQuery = function () {
		return this.queryLength() === 0;
	};

	/**
	 *
	 * @param {Array} [paths] - an array pf path parts (if given will modify
	 *                          Url.path property
	 * @returns {Array} - an array representation of the Url.path property
	 */
	Url.prototype.paths = function (paths) {
		var prefix = '';
		var i = 0;
		var s;

		if (paths && paths.length && paths + '' !== paths) {
			if (this.isAbsolute()) {
				prefix = '/';
			}

			for (s = paths.length; i < s; i++) {
				paths[i] = !i && RX_PATH_SEMI.test(paths[i])
					? paths[i]
					: encode(paths[i]);
			}

			this.path = prefix + paths.join('/');
		}

		paths = (this.path.charAt(0) === '/' ?
			this.path.slice(1) : this.path).split('/');

		for (i = 0, s = paths.length; i < s; i++) {
			paths[i] = decode(paths[i]);
		}

		return paths;
	};

	/**
	 * Performs URL-specific encoding of the given string
	 *
	 * @method Url#encode
	 * @param {string} s - string to encode
	 * @returns {string}
	 */
	Url.prototype.encode = encode;

	/**
	 * Performs URL-specific decoding of the given encoded string
	 *
	 * @method Url#decode
	 * @param {string} s - string to decode
	 * @returns {string}
	 */
	Url.prototype.decode = decode;

	/**
	 * Checks if current URL is an absolute resource locator (globally absolute
	 * or absolute path to current server)
	 *
	 * @returns {boolean}
	 */
	Url.prototype.isAbsolute = function () {
		return this.protocol || this.path.charAt(0) === '/';
	};

	/**
	 * Returns string representation of current Url object
	 *
	 * @returns {string}
	 */
	Url.prototype.toString = function () {
		return (
			(this.protocol && (this.protocol + '://')) +
			(this.user && (
				encode(this.user) + (this.pass && (':' + encode(this.pass))
				) + '@')) +
			(this.host && this.host) +
			(this.port && (':' + this.port)) +
			(this.path && this.path) +
			(this.query.toString() && ('?' + this.query)) +
			(this.hash && ('#' + encode(this.hash)))
		);
	};

	var script$16 = {
		data() {
			return {
				modals: [],
				loading: null,
				closeTimeout: null,
				historyEventIsHashChange: false,
				historyEventIsManual: false
			};
		},

		computed: {
			topModal() {
				return this.modals.length ? this.modals[this.modals.length - 1] : null;
			}
		},

		created() {
			window.modalController = this;

			let matches = (el, selector) => {
				try {
					return (el.matches || el.matchesSelector || el.msMatchesSelector).call(el, selector);
				} catch (e) {
					return false;
				}
			};

			let closestMatch = (el, selectors) => {
				while (el) {
					for (let i = 0; i < selectors.length; i++) {
						if (matches(el, selectors[i])) {
							return {el: el, selector: selectors[i]};
						}
					}
					el = el.parentNode;
				}
				return null;
			};

			let openModal = (element) => {
				let modalURL = element.el.getAttribute('data-modal-url')? element.el.getAttribute('data-modal-url') :element.el.getAttribute('href');
				let modalData;

				try {
					modalData = JSON.parse(element.el.getAttribute('data-modal-data'));
				} catch (e) {
					modalData = null;
					if (!modalURL) {
						console.warn('v-modal: wrong modalData on .js-open-modal', e);
					}
				}

				if (modalData || modalURL) {
					let options = modalData || {};
					if (modalURL) {
						options.url = modalURL;
					}
					this.open(options);
				}
			};

			if (document.getElementsByClassName('js-open-modal-on-page-start').length) {
				openModal({el: document.getElementsByClassName('js-open-modal-on-page-start')[0]});
				document.getElementsByClassName('js-open-modal-on-page-start')[0].remove();
			}

			// event delegation
			document.addEventListener('click', (e) => {
				let button = closestMatch(e.target, [
					'.js-replace-modal',
					'.js-open-modal',
					'.js-close-modal',
					'.js-open-modal-gallery'
				]);

				if (!button) {
					return;
				}

				if (button.selector === '.js-replace-modal') {
					this.close().then(() => {
						openModal(button);
					});
				} else if (button.selector === '.js-open-modal') {
					openModal(button);
				} else if (button.selector === '.js-close-modal') {
					this.close();
				} else if (button.selector === '.js-open-modal-gallery') {
					let dataSource = button.el.dataset.gallery;
					let initialIndex = parseInt(button.el.dataset.initialindex) || 0;

					this.open({
						className: 'modal--gallery',
						content: `<v-gallery :data-source='${(dataSource ? dataSource : null)}' :initial-index="${initialIndex}"></v-gallery>`
					});
				}
			});

			document.addEventListener('keyup', this.handleEsc);
		},

		unmounted() {
			document.documentElement.classList.remove('state--modal-open');
			document.removeEventListener('keyup', this.handleEsc);
		},

		methods: {
			async open(options = {}) {
				// load modal by URL
				if (options.url) {
					let parsedURL = new Url(options.url);
					// convert any options.data to transfer as FormData
					let formattedData = JSON.stringify(parsedURL.query);
					parsedURL = new Url(parsedURL.path);
					parsedURL.query.AJAXMODE = 'Y';
					const response = await fetch(parsedURL.toString(), {
						method: 'POST',
						body: formattedData,
						headers: {
							'Content-Type': 'text/plain;charset=UTF-8'
						}
					});
					options.content = await response.text();
				} else if (options.content && options.content.indexOf('v-modal-window') == -1 && options.content.indexOf('v-gallery') == -1) {
					options.content = '<v-modal-window>' + options.content + '</v-modal-window>';
				}

				if (this.closeTimeout) {
					clearTimeout(this.closeTimeout);
					this.closeTimeout = null;
					this.modals.pop();
				}
				options.key = Math.random() + '-' + (new Date()).getMilliseconds();
				this.modals.pop();
				this.modals.push(options);
				//window.history.pushState({component: 'v-modal'}, '', options.historyUrl || window.location.href);

				this.$nextTick(() => {
					setTimeout(() => {
						document.documentElement.classList.add('state--modal-open');

						const modalSearch = this.$el.querySelector('.search-small__result-wrap');
						if (modalSearch) {
							controller.lockScrolling(modalSearch);
						} else {
							const modalBody = document.querySelector('.modal-window__body');
							const unlockElems = Array.from(modalBody.querySelectorAll('.field-select__list-container'));
							unlockElems.push(modalBody);
							controller.lockScrolling(unlockElems);
						}
					});
					View.initAllLocal(this.$el);
				});
			},

			async close(options = {}) {
				return new Promise((resolve) => {
					if (this.modals.length > 1) {
						this.modals.pop();
						resolve();
					} else {
						if (this.modals.length <= 1 && (!options || !options.replace)) {
							document.documentElement.classList.remove('state--modal-open');
						}
						// if modal is the last add 250ms delay to prevent jump to small-white-brick-empty-modal and let transition play
						this.closeTimeout = setTimeout(() => {
							if (this.modals.length <= 1 && (!options || !options.replace)) {
								this.$nextTick(() => {
									controller.unlockScrolling(this.$el.querySelector('.modal-window__body'));
									controller.unlockScrolling(this.$el.querySelector('.search-small__result-wrap'));
								});
							}
							this.modals.pop();
							resolve();
						}, 250);
					}
				});
			},

			async closeAll() {
				while (this.modals.length > 0) {
					await this.close();
				}
			},

			overlayClick(e) {
				let $target = e.target;
				if (!$target.closest('.modal-window') && !$target.closest('.js-pause-button') &&
					!$target.closest('.gallery__view-item-wrapper') && $target.closest('body')) {
					this.close();
				}
			}
		}
	};

	const _hoisted_1$$ = /*#__PURE__*/createVNode("div", { class: "modal-window__overlay js-detect-swipe" }, null, -1 /* HOISTED */);
	const _hoisted_2$W = {
	  class: "modal__content-slot",
	  key: "no-modal-content"
	};

	function render$18(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_modal_window = resolveComponent("v-modal-window");

	  return (openBlock(), createBlock("div", {
	    class: ["v-modal modal", $options.topModal ? $options.topModal.className : '']
	  }, [
	    createVNode("div", {
	      class: "modal__surface",
	      onMousedown: _cache[1] || (_cache[1] = (...args) => ($options.overlayClick && $options.overlayClick(...args)))
	    }, [
	      (openBlock(true), createBlock(Fragment, null, renderList($data.modals, (modal, index) => {
	        return withDirectives((openBlock(), createBlock(resolveDynamicComponent(modal.content ? 'v-lazy-component' : 'div'), {
	          class: "modal__container",
	          key: modal.key
	        }, {
	          default: withCtx(() => [
	            _hoisted_1$$,
	            (modal.content)
	              ? (openBlock(), createBlock("div", {
	                  class: "modal__content-slot",
	                  innerHTML: modal.content,
	                  key: "modal-content"
	                }, null, 8 /* PROPS */, ["innerHTML"]))
	              : (openBlock(), createBlock("div", _hoisted_2$W, [
	                  createVNode(_component_v_modal_window, {
	                    title: modal.component.props.title
	                  }, {
	                    default: withCtx(() => [
	                      (openBlock(), createBlock(resolveDynamicComponent(modal.component.name), modal.component.props, null, 16 /* FULL_PROPS */))
	                    ]),
	                    _: 2 /* DYNAMIC */
	                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"])
	                ]))
	          ]),
	          _: 2 /* DYNAMIC */
	        }, 1536 /* NEED_PATCH, DYNAMIC_SLOTS */)), [
	          [vShow, index === $data.modals.length - 1]
	        ])
	      }), 128 /* KEYED_FRAGMENT */))
	    ], 32 /* HYDRATE_EVENTS */)
	  ], 2 /* CLASS */))
	}

	script$16.render = render$18;
	script$16.__file = "local/assets/source/components/v-modal.vue";

	var script$17 = {
		props: {
			open: {
				type: Boolean,
				default: false
			},

			duration: {
				type: Number,
				default: 500
			}
		},

		methods: {
			openState(el) {
				el.style.height = el.scrollHeight + 'px';
				el.style.marginTop = '';
				el.style.marginBottom = '';
				el.style.paddingTop = '';
				el.style.paddingBottom = '';
				el.style.transition = this.duration + 'ms';
				el.style.overflow = 'hidden';
			},

			closeState(el) {
				el.style.height = '0';
				el.style.marginTop = '0';
				el.style.marginBottom = '0';
				el.style.paddingTop = '0';
				el.style.paddingBottom = '0';
				el.style.transition = this.duration + 'ms';
				el.style.overflow = 'hidden';
			},

			cleanState(el) {
				el.style.height = '';
				el.style.marginTop = '';
				el.style.marginBottom = '';
				el.style.paddingTop = '';
				el.style.paddingBottom = '';
			}
		}
	};

	const _hoisted_1$10 = { class: "v-collapse collapse" };

	function render$19(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$10, [
	    createVNode(Transition, {
	      name: "collapse",
	      duration: $props.duration,
	      onBeforeEnter: $options.closeState,
	      onEnter: $options.openState,
	      onAfterEnter: $options.cleanState,
	      onBeforeLeave: $options.openState,
	      onLeave: $options.closeState,
	      onAfterLeave: $options.cleanState
	    }, {
	      default: withCtx(() => [
	        ($props.open)
	          ? renderSlot(_ctx.$slots, "default", { key: 0 })
	          : createCommentVNode("v-if", true)
	      ]),
	      _: 1 /* STABLE */
	    }, 8 /* PROPS */, ["duration", "onBeforeEnter", "onEnter", "onAfterEnter", "onBeforeLeave", "onLeave", "onAfterLeave"])
	  ]))
	}

	script$17.render = render$19;
	script$17.__file = "local/assets/source/components/v-collapse.vue";

	var script$18 = {
		props: {
			title: {
				type: String,
				default: ''
			}
		},

		data() {
			return {
				uniqueId: uniqueId('modal-'),
				active: true
			};
		},

		mounted() {
			setTimeout(() => {
				if (this.$refs.body.clientHeight === this.$refs.body.scrollHeight) {
					controller.unlockScrolling(this.$refs.body);
					this.$refs.body.classList.remove('scrollbar');
				}
			}, 300);
		}
	};

	const _hoisted_1$11 = { class: "modal-window__header js-detect-swipe" };
	const _hoisted_2$X = /*#__PURE__*/createVNode("button", {
	  class: "modal-window__close js-close-modal",
	  type: "button",
	  "aria-label": "Закрыть"
	}, null, -1 /* HOISTED */);
	const _hoisted_3$P = {
	  class: "modal-window__body scrollbar",
	  ref: "body"
	};

	function render$1a(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", {
	    class: "modal-window",
	    role: "dialog",
	    "aria-labelledby": $data.uniqueId
	  }, [
	    createVNode("div", _hoisted_1$11, [
	      ($props.title)
	        ? (openBlock(), createBlock("div", {
	            key: 0,
	            class: "modal-window__header-title h5",
	            id: $data.uniqueId
	          }, toDisplayString($props.title), 9 /* TEXT, PROPS */, ["id"]))
	        : createCommentVNode("v-if", true),
	      _hoisted_2$X
	    ]),
	    createVNode("div", _hoisted_3$P, [
	      renderSlot(_ctx.$slots, "default")
	    ], 512 /* NEED_PATCH */)
	  ], 8 /* PROPS */, ["aria-labelledby"]))
	}

	script$18.render = render$1a;
	script$18.__file = "local/assets/source/components/v-modal-window.vue";

	var script$19 = {
		data() {
			return {
				timeout: null,
				show: false,
				content: null
			}
		},

		created() {
			window.messageController = this;
		},

		methods: {
			close() {
				this.show = false;
			},
			open(options) {
				this.content = options;
				this.show = true;

				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					this.show = false;
				}, 3000);
			}
		},
	};

	const _hoisted_1$12 = {
	  key: 0,
	  class: "modal-message__visual"
	};
	const _hoisted_2$Y = { class: "modal-message__content" };
	const _hoisted_3$Q = /*#__PURE__*/createVNode("div", { class: "modal-message__subtitle" }, "Товар добавлен в корзину", -1 /* HOISTED */);
	const _hoisted_4$F = {
	  key: 1,
	  class: "modal-message__info"
	};
	const _hoisted_5$A = {
	  key: 0,
	  class: "modal-message__quantity"
	};
	const _hoisted_6$v = {
	  key: 1,
	  class: "modal-message__price"
	};
	const _hoisted_7$q = {
	  key: 1,
	  class: "modal-message__text"
	};

	function render$1b(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", {
	    class: ["v-modal-message modal-message", {'modal-message--product': $data.content?.product, 'modal-message--text': $data.content?.content}]
	  }, [
	    createVNode(Transition, { name: "modal-message" }, {
	      default: withCtx(() => [
	        ($data.show)
	          ? (openBlock(), createBlock("div", {
	              key: 0,
	              class: "modal-message__wrapper",
	              style: {background: $data.content?.content?.background, width: $data.content?.content?.width}
	            }, [
	              createVNode("button", {
	                class: "modal-message__close",
	                type: "button",
	                onClick: _cache[1] || (_cache[1] = (...args) => ($options.close && $options.close(...args)))
	              }),
	              ($data.content?.product)
	                ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	                    ($data.content.product?.imageSources?.orig)
	                      ? (openBlock(), createBlock("div", _hoisted_1$12, [
	                          createVNode("img", {
	                            src: $data.content.product.imageSources.orig,
	                            loading: "lazy",
	                            decoding: "async",
	                            alt: $data.content.product.name,
	                            title: $data.content.product.name
	                          }, null, 8 /* PROPS */, ["src", "alt", "title"])
	                        ]))
	                      : createCommentVNode("v-if", true),
	                    createVNode("div", _hoisted_2$Y, [
	                      _hoisted_3$Q,
	                      ($data.content.product.name)
	                        ? (openBlock(), createBlock("div", {
	                            key: 0,
	                            class: "modal-message__title",
	                            innerHTML: $data.content.product.name
	                          }, null, 8 /* PROPS */, ["innerHTML"]))
	                        : createCommentVNode("v-if", true),
	                      ($data.content.product.count || $data.content.product.price)
	                        ? (openBlock(), createBlock("div", _hoisted_4$F, [
	                            ($data.content.product?.count?.value)
	                              ? (openBlock(), createBlock("div", _hoisted_5$A, toDisplayString($data.content.product.count.value) + "x", 1 /* TEXT */))
	                              : createCommentVNode("v-if", true),
	                            ($data.content.product?.price?.current?.value)
	                              ? (openBlock(), createBlock("div", _hoisted_6$v, toDisplayString($data.content.product.price.current.value) + " " + toDisplayString($data.content.product.price.current.currency), 1 /* TEXT */))
	                              : createCommentVNode("v-if", true)
	                          ]))
	                        : createCommentVNode("v-if", true)
	                    ])
	                  ], 64 /* STABLE_FRAGMENT */))
	                : createCommentVNode("v-if", true),
	              ($data.content?.content)
	                ? (openBlock(), createBlock("div", _hoisted_7$q, toDisplayString($data.content.content.text), 1 /* TEXT */))
	                : createCommentVNode("v-if", true)
	            ], 4 /* STYLE */))
	          : createCommentVNode("v-if", true)
	      ]),
	      _: 1 /* STABLE */
	    })
	  ], 2 /* CLASS */))
	}

	script$19.render = render$1b;
	script$19.__file = "local/assets/source/components/v-modal-message.vue";

	var script$1a = {
		mixins: [
			script$2
		],

		props: {
			initialIndex: {
				type: Number,
				default: 0
			}
		},

		data() {
			return {
				remote: null,
				gallery: null,
				loading: false,
				loadingMinTimeout: null,
				touchMode: controller.touch,
				currentIndex: 0,
				resizeTimeout: null,
				setPositionQueue: false,
				setScaleQueue: false,
				touchActive: false,
				touchStartPoint: null,
				touchStartPoint2: null,
				touchIntentMinOffset: 0,
				touchIntent: 0,
				debug: null,
				dragOffset: 0,
				scaleActive: false,
				scaleRatio: 1,
				scaleRatioPrevious: 1,
				scaleOffset: {x: 0, y: 0},
				scaleOffsetPrevious: {x: 0, y: 0}
			};
		},

		watch: {
			gallery() {
				this.setPosition(true);
			}
		},

		created() {
			this.currentIndex = this.initialIndex;
			this.updateIntentOffset();
			window.addEventListener('resize', this.handleResize, controller.passiveEventsSupported ? {passive: true} : undefined);
			if (controller.touch) {
				document.addEventListener('touchend', this.stopTouchAction, controller.passiveEventsSupported ? {passive: true} : undefined);
				document.addEventListener('touchmove', this.handleTouchAction, controller.passiveEventsSupported ? {passive: true} : undefined);
			}
		},

		mounted() {
			this.$nextTick(() => {
				this.$el.querySelectorAll('img').forEach((img) => {
					img.addEventListener('click', (e) => {
						e.stopPropagation();
					});
				});
			});
		},

		unmounted() {
			window.removeEventListener('resize', this.handleResize);
			if (controller.touch) {
				document.removeEventListener('touchend', this.stopTouchAction);
				document.addEventListener('touchmove', this.handleTouchAction);
			}
		},

		methods: {
			pauseVideo() {
				this.$refs.video.forEach((item) => {
					item.pauseVideo();
				});
			},

			goTo(index) {
				if (index != this.currentIndex) {
					this.currentIndex = Math.max(0, Math.min(this.gallery.items.length - 1, index));
					this.scaleActive = false;
					this.scaleRatio = 1;
					this.scaleOffsetPrevious.x = 0;
					this.scaleOffsetPrevious.y = 0;
				}
				this.setPosition();
			},

			setPosition(silent) {
				// if list is not rendered yet
				if (!this.$refs['view-list']) {
					return;
				}

				cancelAnimationFrame(this.setPositionQueue);
				this.setPositionQueue = requestAnimationFrame(() => {
					if (silent) {
						this.$refs['view-list'].style.transition = '0s';
					}

					this.$refs['view-list'].style.transform =
						'translate3d(' + (-this.$refs['view-list'].offsetWidth * this.currentIndex + this.dragOffset) + 'px,0,0)';

					if (silent) {
						requestAnimationFrame(() => {
							this.$refs['view-list'].style.transition = '';
						});
					}
				});
			},

			setScale(silent) {
				// if list is not rendered yet
				if (!this.$refs['view-item-wrapper']) {
					return;
				}

				cancelAnimationFrame(this.setScaleQueue);
				this.setScaleQueue = requestAnimationFrame(() => {
					for (let i = 0; i < this.$refs['view-item-wrapper'].length; i++) {
						if (i != this.currentIndex) {
							this.$refs['view-item-wrapper'][i].style.transform = '';
						}
					}

					if (silent) {
						this.$refs['view-item-wrapper'][this.currentIndex].style.transition = '0s';
					}

					this.$refs['view-item-wrapper'][this.currentIndex].style.transform =
						this.scaleActive ? 'translate3d(' + this.scaleOffset.x + 'px,' + this.scaleOffset.y + 'px,0) scale(' + this.scaleRatio + ')' : '';

					if (silent) {
						requestAnimationFrame(() => {
							this.$refs['view-item-wrapper'][this.currentIndex].style.transition = '';
						});
					}
				});
			},

			startTouchAction(e) {
				this.touchActive = true;
				this.touchStartPoint = {x: e.touches[0].pageX, y: e.touches[0].pageY};
				if (e.touches.length == 2) {
					this.scaleActive = true;
					this.touchStartPoint2 = {x: e.touches[1].pageX, y: e.touches[1].pageY};
				}
			},

			stopTouchAction(e) {
				// when last touch ended
				if (this.touchActive && !e.touches.length) {
					this.touchActive = false;
					this.dragOffset = 0;
					this.goTo(this.currentIndex + this.touchIntent);
				}

				if (this.scaleActive) {
					if (e.touches.length < 2) {
						this.touchActive = false;
						this.scaleRatio = Math.max(1, Math.min(2, this.scaleRatio));
						this.scaleActive = this.scaleRatio != 1;
						this.scaleRatioPrevious = this.scaleRatio;
					}

					if (this.scaleActive) {
						this.scaleOffsetPrevious.x = this.scaleOffset.x;
						this.scaleOffsetPrevious.y = this.scaleOffset.y;
					} else {
						this.scaleOffsetPrevious.x = 0;
						this.scaleOffsetPrevious.y = 0;
					}
				}

				this.setScale();
			},

			handleTouchAction(e) {
				if (this.touchActive) {
					// scale mode is active, scale != 1
					// scale or move active image
					if (this.scaleActive) {
						// multitouch - change scale
						if (e.touches.length > 1) {
							// scale (Pythagoras)
							let initialDistance = Math.sqrt(Math.pow(this.touchStartPoint.x - this.touchStartPoint2.x, 2) + Math.pow(this.touchStartPoint.y - this.touchStartPoint2.y, 2));
							let currentDistance = Math.sqrt(Math.pow(e.touches[0].pageX - e.touches[1].pageX, 2) + Math.pow(e.touches[0].pageY - e.touches[1].pageY, 2));
							this.scaleRatio = Math.max(0.9, Math.min(2.2, this.scaleRatioPrevious * currentDistance / initialDistance));

							// drag inside scaled slide
							this.scaleOffset.x = this.scaleOffsetPrevious.x + e.touches[0].pageX - this.touchStartPoint.x + (e.touches[1].pageX - this.touchStartPoint2.x) / 2;
							this.scaleOffset.y = this.scaleOffsetPrevious.y + e.touches[0].pageY - this.touchStartPoint.y + (e.touches[1].pageY - this.touchStartPoint2.y) / 2;
						} else {
							// non-multitouch - drag inside scaled slide
							this.debug = this.scaleOffsetPrevious;
							// drag inside scaled slide
							this.scaleOffset.x = this.scaleOffsetPrevious.x + e.touches[0].pageX - this.touchStartPoint.x;
							this.scaleOffset.y = this.scaleOffsetPrevious.y + e.touches[0].pageY - this.touchStartPoint.y;
						}

						this.dragOffset = 0;
						this.touchIntent = 0;
						this.setScale(true);
					} else {// else - drag slide list
						// multitouch drag - never works because of scaleActive but...
						if (e.touches.length > 1) {
							this.dragOffset = e.touches[0].pageX - this.touchStartPoint.x + (e.touches[1].pageX - this.touchStartPoint2.x) / 2;
						} else {
							// non-multitouch drag
							this.dragOffset = e.touches[0].pageX - this.touchStartPoint.x;
						}

						// rubber effect at the ends
						if (this.currentIndex == 0 && this.dragOffset > 0 || this.currentIndex == this.gallery.items.length - 1 && this.dragOffset < 0) {
							this.dragOffset = Math.sign(this.dragOffset) * Math.pow(Math.abs(this.dragOffset), .75);
						}

						this.setPosition(true);

						// determine intended swipe direction
						if (this.dragOffset >= this.touchIntentMinOffset) {
							this.touchIntent = -1;
						} else if (this.dragOffset <= -this.touchIntentMinOffset) {
							this.touchIntent = 1;
						} else {
							this.touchIntent = 0;
						}
					}
				}
			},

			updateIntentOffset() {
				// min drag offset to consider it as slide
				// is 25% of gallery width but inbetween 50 and 200
				this.touchIntentMinOffset = Math.min(200, Math.max(50, (this.$refs['view-list'] || document.body).offsetWidth * 0.25));
			},

			dataSet(data) {
				this.gallery = data;
				nextTick(() => {
					this.setPosition(true);
				});
			},

			handleResize() {
				if (!this.resizeTimeout) {
					this.resizeTimeout = setTimeout(() => {
						this.updateIntentOffset();
						this.setPosition(true);
						this.resizeTimeout = null;
					}, 100);
				}
			}
		}
	};

	const _hoisted_1$13 = { class: "v-gallery gallery" };
	const _hoisted_2$Z = /*#__PURE__*/createVNode("button", {
	  class: "gallery__close js-close-modal",
	  type: "button"
	}, [
	  /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	    /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-close" })
	  ])
	], -1 /* HOISTED */);
	const _hoisted_3$R = /*#__PURE__*/createVNode("svg", { class: "svg-icon gallery__arrow-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-slide-left" })
	], -1 /* HOISTED */);
	const _hoisted_4$G = /*#__PURE__*/createVNode("svg", { class: "svg-icon gallery__arrow-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-slide-right" })
	], -1 /* HOISTED */);
	const _hoisted_5$B = {
	  class: "gallery__view-list",
	  ref: "view-list"
	};
	const _hoisted_6$w = {
	  class: "gallery__view-item-wrapper",
	  ref: "view-item-wrapper",
	  key: "image"
	};
	const _hoisted_7$r = {
	  class: "gallery__iframe-wrapper",
	  key: "iframe"
	};
	const _hoisted_8$m = {
	  class: "gallery__video-wrapper",
	  key: "video"
	};
	const _hoisted_9$m = {
	  key: 3,
	  class: "gallery__view-item-note"
	};
	const _hoisted_10$i = {
	  key: 0,
	  class: "gallery__previews"
	};
	const _hoisted_11$h = { class: "gallery__previews-container" };
	const _hoisted_12$h = { class: "gallery__previews-list" };

	function render$1c(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_image = resolveComponent("v-image");
	  const _component_v_video = resolveComponent("v-video");

	  return (openBlock(), createBlock("div", _hoisted_1$13, [
	    createVNode(_component_v_loader, { loading: $data.loading }, null, 8 /* PROPS */, ["loading"]),
	    _hoisted_2$Z,
	    ($data.gallery)
	      ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	          createVNode("div", {
	            class: "gallery__view",
	            onTouchstart: _cache[3] || (_cache[3] = (...args) => ($options.startTouchAction && $options.startTouchAction(...args)))
	          }, [
	            createVNode("button", {
	              class: ["gallery__arrow gallery__arrow--prev js-pause-button", {'disabled': $data.currentIndex == 0}],
	              type: "button",
	              onClick: _cache[1] || (_cache[1] = $event => ($options.goTo($data.currentIndex-1)))
	            }, [
	              _hoisted_3$R
	            ], 2 /* CLASS */),
	            createVNode("button", {
	              class: ["gallery__arrow gallery__arrow--next js-pause-button", {'disabled': $data.currentIndex == $data.gallery.items.length-1}],
	              type: "button",
	              onClick: _cache[2] || (_cache[2] = $event => ($options.goTo($data.currentIndex+1)))
	            }, [
	              _hoisted_4$G
	            ], 2 /* CLASS */),
	            createVNode("div", _hoisted_5$B, [
	              (openBlock(true), createBlock(Fragment, null, renderList($data.gallery.items, (item, index) => {
	                return (openBlock(), createBlock("div", {
	                  class: "gallery__view-item",
	                  key: index
	                }, [
	                  (item.type === 'image')
	                    ? (openBlock(), createBlock("div", _hoisted_6$w, [
	                        createVNode(_component_v_image, {
	                          src: item.src || item.srcFull || item.poster,
	                          alt: ""
	                        }, null, 8 /* PROPS */, ["src"])
	                      ], 512 /* NEED_PATCH */))
	                    : (item.type === 'iframe')
	                      ? (openBlock(), createBlock("div", _hoisted_7$r, [
	                          (openBlock(), createBlock("iframe", {
	                            src: item.src,
	                            key: index == $data.currentIndex ? 1 : 2,
	                            allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
	                            allowfullscreen: "allowfullscreen"
	                          }, null, 8 /* PROPS */, ["src"]))
	                        ]))
	                      : (item.type === 'video')
	                        ? (openBlock(), createBlock("div", _hoisted_8$m, [
	                            createVNode(_component_v_video, {
	                              src: item.src,
	                              poster: item.videoPoster || item.poster,
	                              key: index == $data.currentIndex ? 1 : 2
	                            }, null, 8 /* PROPS */, ["src", "poster"])
	                          ]))
	                        : createCommentVNode("v-if", true),
	                  (item.note)
	                    ? (openBlock(), createBlock("div", _hoisted_9$m, [
	                        createVNode("div", {
	                          class: "gallery__view-item-note-box",
	                          innerHTML: item.note
	                        }, null, 8 /* PROPS */, ["innerHTML"])
	                      ]))
	                    : createCommentVNode("v-if", true)
	                ]))
	              }), 128 /* KEYED_FRAGMENT */))
	            ], 512 /* NEED_PATCH */)
	          ], 32 /* HYDRATE_EVENTS */),
	          ($data.gallery.previews)
	            ? (openBlock(), createBlock("div", _hoisted_10$i, [
	                createVNode("div", _hoisted_11$h, [
	                  createVNode("div", _hoisted_12$h, [
	                    (openBlock(true), createBlock(Fragment, null, renderList($data.gallery.items, (item, index) => {
	                      return (openBlock(), createBlock("a", {
	                        class: ["gallery__previews-item", {'active': index == $data.currentIndex}],
	                        tabindex: "0",
	                        onClick: $event => ($options.goTo(index)),
	                        onKeyup: withKeys($event => ($options.goTo(index)), ["enter"]),
	                        style: {'background-image': 'url('+(item.poster || item.src || item.srcFull)+')'}
	                      }, null, 46 /* CLASS, STYLE, PROPS, HYDRATE_EVENTS */, ["onClick", "onKeyup"]))
	                    }), 256 /* UNKEYED_FRAGMENT */))
	                  ])
	                ])
	              ]))
	            : createCommentVNode("v-if", true)
	        ], 64 /* STABLE_FRAGMENT */))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1a.render = render$1c;
	script$1a.__file = "local/assets/source/components/v-gallery.vue";

	var script$1b = {
		mixins: [script$2],

		data() {
			return {
				brands: null,
				localFilterValue: '',
			}
		},

		computed: {
			computedGroupList() {
				const resultObj = {};
				this.brands.items.forEach((brand) => {
					const firstLetter = brand.name[0].toLowerCase();

					if (!resultObj[firstLetter]) {
						resultObj[firstLetter] = [];
					}
					resultObj[firstLetter].push(brand);
				});
				const resultArr = Object.keys(resultObj).map((key) => {
					return {
						name: key,
						items: resultObj[key]
					}
				});
				resultArr.sort((a, b) => a.name.localeCompare(b.name));
				return resultArr;
			},

			computedFilteredList() {
				return this.brands.items.filter((item) => {
					if (this.localFilterValue?.length && item.name.toLowerCase().includes(this.localFilterValue)) {
						return item
					}
				}).map((item) => {
					const name = item.name;
					const posSearchValue = name.toLowerCase().indexOf(this.localFilterValue);
					const computedName = name.slice(0, posSearchValue) + `<b>${name.substr(posSearchValue, this.localFilterValue.length)}</b>` + name.slice(posSearchValue + this.localFilterValue.length);
					return {...item, name: computedName}
				})
			}
		},

		methods: {
			dataSet(data) {
				this.brands = data;
			},

			filterChanged(value) {
				this.localFilterValue = value.toLowerCase();
			},

			clearFilter() {
				this.localFilterValue = null;
			},

			click() {
				document.documentElement.classList.remove('open-catalog-menu');
			}
		},
	};

	const _hoisted_1$14 = { class: "v-brand-search brand-search" };
	const _hoisted_2$_ = {
	  key: 0,
	  class: "brand-search__wrapper"
	};
	const _hoisted_3$S = {
	  key: 0,
	  class: "brand-search__filter"
	};
	const _hoisted_4$H = {
	  key: 1,
	  class: "brand-search__groups"
	};
	const _hoisted_5$C = { class: "brand-search__group" };
	const _hoisted_6$x = { class: "brand-search__group-name" };
	const _hoisted_7$s = { class: "brand-search__list" };
	const _hoisted_8$n = {
	  key: 2,
	  class: "brand-search__list"
	};

	function render$1d(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_field = resolveComponent("v-field");

	  return (openBlock(), createBlock("div", _hoisted_1$14, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.brands)
	      ? (openBlock(), createBlock("div", _hoisted_2$_, [
	          ($data.brands?.filter)
	            ? (openBlock(), createBlock("div", _hoisted_3$S, [
	                createVNode(_component_v_field, {
	                  modelValue: $data.localFilterValue,
	                  "onUpdate:modelValue": [
	                    _cache[1] || (_cache[1] = $event => ($data.localFilterValue = $event)),
	                    $options.filterChanged
	                  ],
	                  field: $data.brands.filter
	                }, null, 8 /* PROPS */, ["modelValue", "field", "onUpdate:modelValue"]),
	                withDirectives(createVNode("button", {
	                  class: "brand-search__clear",
	                  type: "button",
	                  onClick: _cache[2] || (_cache[2] = (...args) => ($options.clearFilter && $options.clearFilter(...args)))
	                }, null, 512 /* NEED_PATCH */), [
	                  [vShow, $data.localFilterValue?.length]
	                ])
	              ]))
	            : createCommentVNode("v-if", true),
	          ($options.computedGroupList && !$data.localFilterValue?.length)
	            ? (openBlock(), createBlock("div", _hoisted_4$H, [
	                (openBlock(true), createBlock(Fragment, null, renderList($options.computedGroupList, (group) => {
	                  return (openBlock(), createBlock("div", _hoisted_5$C, [
	                    createVNode("div", _hoisted_6$x, toDisplayString(group.name), 1 /* TEXT */),
	                    createVNode("div", _hoisted_7$s, [
	                      (openBlock(true), createBlock(Fragment, null, renderList(group.items, (item) => {
	                        return (openBlock(), createBlock("a", {
	                          class: "brand-search__link",
	                          onClick: _cache[3] || (_cache[3] = (...args) => ($options.click && $options.click(...args))),
	                          href: item.link
	                        }, toDisplayString(item.name), 9 /* TEXT, PROPS */, ["href"]))
	                      }), 256 /* UNKEYED_FRAGMENT */))
	                    ])
	                  ]))
	                }), 256 /* UNKEYED_FRAGMENT */))
	              ]))
	            : createCommentVNode("v-if", true),
	          ($options.computedFilteredList?.length)
	            ? (openBlock(), createBlock("div", _hoisted_8$n, [
	                (openBlock(true), createBlock(Fragment, null, renderList($options.computedFilteredList, (item) => {
	                  return (openBlock(), createBlock("a", {
	                    class: "brand-search__link brand-search__link--mark",
	                    onClick: _cache[4] || (_cache[4] = (...args) => ($options.click && $options.click(...args))),
	                    href: item.link,
	                    innerHTML: item.name
	                  }, null, 8 /* PROPS */, ["href", "innerHTML"]))
	                }), 256 /* UNKEYED_FRAGMENT */))
	              ]))
	            : createCommentVNode("v-if", true)
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1b.render = render$1d;
	script$1b.__file = "local/assets/source/components/v-brand-search.vue";

	var script$1c = {
		mixins: [
			script$2,
			script$y
		],

		data() {
			return {
				basket: null,
				adaptiveDevice: false,
				hideToolbar: false,
				disabledSubmit: false,
			};
		},

		computed: {
		   	computedDiscountData(){
				return {
				 'discountList': this.basket.discountList? this.basket.discountList : null,
				 'items': this.basket.items
				};
			},

			computedDiscountPrice() {
				return {
					"current": {
						"value": this.basket.discountList.list.find(item => item.id === this.basket.discountList.nextLevelId).priceFormated,
						"currency": "р."
					},
					"old": {
						"value": this.formatPrice(this.basket.resume.total.value) || null,
						"currency": this.basket.resume.total.currency || null
					}
				}
			},

			...mapGetters$1({
				userAuthorized: 'user/userAuthorized'
			})
		},

		created() {
			window.addEventListener('resize', this.getDevice);
			this.getDevice();

			controller.events.on('remove-basket-item', (productId) => {
				this.deleteBasketItem(productId);
			});

			controller.events.on('clean-basket', () => {
				this.cleanBasket();
			});
		},

		unmounted() {
			window.removeEventListener('resize', this.getDevice);
		},

		methods: { 

			...mapActions$1({
				basketRemove: 'basket/remove'
			}),

			dataSet(data, options = {}) {
				this.basket = data.basket;

				this.$nextTick(() => {
					this.toggleToolbar();
					View.initAllLocal(this.$el);
				});
			},

			updateBasket(dataSetOptions) {
				this.dataLoad({
					url: this.basket.remote,
					delay: true,
					data: {}
				}, dataSetOptions);
			},

			// удаление товаров из корзины
			cleanBasket() {
				this.basketRemove({
					id: 'all'
				}).then(() => {
					this.updateBasket();
				});
			},
			openCleanModal() {
				controller.openModal({
					className: 'modal--sm',
					component: {
						name: 'v-clean-basket',
						props: {
							title: 'Очистить корзину'
						}
					}
				});
			},
			deleteBasketItem(productId) {
				this.basketRemove({
					id: productId
				}).then(() => {
					this.updateBasket();
				});
			},

			changePromocode() {
				this.disabledSubmit = true;
			},
			// работа с промокодом
			sendPromocode(value) {
				this.disabledSubmit = false;
				this.dataLoad({
					url: this.basket.remote,
					delay: true,
					data: {

						giftCertCode: value,
					}
				}, {});
			},
			removePromocode() {
				this.disabledSubmit = false;
				this.dataLoad({
					url: this.basket.remote,
					delay: true,
					data: {
						giftCertCode: 'reset-coupon',
					}
				}, {});
			},

			continueOrder() {
				if (this.basket.userAuthorized) {
					window.location.href = this.basket.orderLink;
				} else {
					controller.openModal({
						className: 'modal--sm',
						component: {
							name: 'v-copy-bonuses',
							props: {
								dataSource: this.basket.authModal,
								title: this.basket.authModal.title
							}
						}
					});
				}
			},

			removeMessage(index) {
				this.basket.messages.splice(index, 1);
			},

			getDevice() {
				this.adaptiveDevice = window.innerWidth < breakpoints['sm-max'];
			},

			// переключение видимости фиксированного тоолбара на мобилке
			toggleToolbar() {
				const vm = this;
				const target = this.$refs.toolbar;
				if (target) {
					const options = {root: null, rootMargin: '0px', threshold: 0};
					const callback = function (entries) {
						entries.forEach(entry => {
							if (entry.isIntersecting) {
								vm.hideToolbar = true;
							} else {
								if (entry.boundingClientRect.top < 0) {
									vm.hideToolbar = true;
								} else {
									vm.hideToolbar = false;
								}
							}
						});
					};
					const observer = new IntersectionObserver(callback, options);
					observer.observe(target);
				}
			}
		},
	};

	const _hoisted_1$15 = { class: "v-basket-big basket" };
	const _hoisted_2$$ = {
	  key: 0,
	  class: "container"
	};
	const _hoisted_3$T = { class: "basket__header" };
	const _hoisted_4$I = {
	  key: 0,
	  class: "page-title"
	};
	const _hoisted_5$D = { class: "h2 page-title__value" };
	const _hoisted_6$y = {
	  key: 0,
	  class: "page-title__count"
	};
	const _hoisted_7$t = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-delete" })
	], -1 /* HOISTED */);
	const _hoisted_8$o = { class: "basket__layout" };
	const _hoisted_9$n = {
	  key: 0,
	  class: "basket__messages"
	};
	const _hoisted_10$j = { class: "basket__message" };
	const _hoisted_11$i = { class: "basket__main" };
	const _hoisted_12$i = { class: "basket__list flc" };
	const _hoisted_13$f = { class: "basket__toolbar hidden-lg hidden-md" };
	const _hoisted_14$e = {
	  class: "btn btn--primary-gray js-toggle-class-page",
	  type: "button",
	  "data-class": "open-basket-resume",
	  "aria-label": "Открыть детали заказа",
	  title: "Открыть детали заказа"
	};
	const _hoisted_15$c = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-down" })
	], -1 /* HOISTED */);
	const _hoisted_16$b = /*#__PURE__*/createVNode("span", null, "Оформить заказ", -1 /* HOISTED */);
	const _hoisted_17$8 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-long" })
	], -1 /* HOISTED */);
	const _hoisted_18$7 = {
	  key: 1,
	  class: "basket__aside"
	};
	const _hoisted_19$5 = {
	  key: 0,
	  class: "basket__messages"
	};
	const _hoisted_20$5 = { class: "basket__message" };
	const _hoisted_21$5 = { class: "mobile-popup mobile-popup--resume" };
	const _hoisted_22$5 = /*#__PURE__*/createVNode("div", { class: "mobile-popup__overlay js-detect-swipe js-overlay" }, null, -1 /* HOISTED */);
	const _hoisted_23$5 = { class: "mobile-popup__wrapper" };
	const _hoisted_24$4 = /*#__PURE__*/createVNode("div", { class: "mobile-popup__header js-detect-swipe" }, [
	  /*#__PURE__*/createVNode("div", { class: "mobile-popup__title" }, "Ваш заказ"),
	  /*#__PURE__*/createVNode("button", {
	    class: "mobile-popup__close js-toggle-class-page",
	    type: "button",
	    "data-class": "open-basket-resume",
	    "aria-label": "Закрыть детали заказа",
	    title: "Закрыть детали заказа"
	  })
	], -1 /* HOISTED */);
	const _hoisted_25$3 = { class: "mobile-popup__body" };
	const _hoisted_26$3 = { class: "basket__resume" };
	const _hoisted_27$3 = { class: "basket__props" };
	const _hoisted_28$3 = {
	  key: 0,
	  class: "basket__prop"
	};
	const _hoisted_29$3 = { class: "basket__prop-entry" };
	const _hoisted_30$3 = { class: "basket__prop-name" };
	const _hoisted_31$3 = { class: "basket__prop-value" };
	const _hoisted_32$3 = { class: "basket__prop-currency" };
	const _hoisted_33$3 = {
	  key: 1,
	  class: "basket__prop basket__prop--discount"
	};
	const _hoisted_34$3 = { class: "basket__prop-entry accordion__toggler js-accordion__toggler" };
	const _hoisted_35$3 = { class: "basket__prop-name" };
	const _hoisted_36$3 = { class: "basket__prop-value" };
	const _hoisted_37$3 = { class: "basket__prop-currency" };
	const _hoisted_38$3 = { class: "basket__prop-entry accordion__toggler js-accordion__toggler" };
	const _hoisted_39$3 = { class: "basket__prop-name" };
	const _hoisted_40$3 = { class: "basket__prop-value" };
	const _hoisted_41$3 = { class: "basket__prop-currency" };
	const _hoisted_42$3 = {
	  key: 0,
	  class: "accordion__icon"
	};
	const _hoisted_43$3 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-down" })
	], -1 /* HOISTED */);
	const _hoisted_44$3 = {
	  key: 0,
	  class: "basket__prop-items accordion__content js-accordion__content"
	};
	const _hoisted_45$2 = { class: "accordion__content-wrap" };
	const _hoisted_46$2 = { class: "basket__prop-entry" };
	const _hoisted_47$2 = { class: "basket__prop-name" };
	const _hoisted_48$2 = { class: "basket__prop-value" };
	const _hoisted_49$2 = { class: "basket__prop-currency" };
	const _hoisted_50$2 = {
	  key: 3,
	  class: "basket__prop basket__prop--discount"
	};
	const _hoisted_51$2 = { class: "basket__prop-entry" };
	const _hoisted_52$2 = { class: "basket__prop-name" };
	const _hoisted_53$2 = { class: "basket__prop-value" };
	const _hoisted_54$2 = {
	  key: 4,
	  class: "basket__prop basket__prop--total"
	};
	const _hoisted_55$2 = { class: "basket__prop-entry" };
	const _hoisted_56$2 = { class: "basket__prop-name" };
	const _hoisted_57$2 = { class: "basket__prop-value" };
	const _hoisted_58$2 = { class: "basket__prop-currency" };
	const _hoisted_59$2 = {
	  key: 0,
	  class: "basket__discount-card"
	};
	const _hoisted_60$2 = { class: "basket__action" };
	const _hoisted_61$2 = /*#__PURE__*/createVNode("span", null, "Оформить заказ", -1 /* HOISTED */);
	const _hoisted_62$2 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-long" })
	], -1 /* HOISTED */);
	const _hoisted_63$2 = { class: "basket__resume" };
	const _hoisted_64$2 = { class: "basket__resume-header" };
	const _hoisted_65$1 = {
	  key: 0,
	  class: "h4"
	};
	const _hoisted_66$1 = { class: "basket__props" };
	const _hoisted_67$1 = {
	  key: 0,
	  class: "basket__prop"
	};
	const _hoisted_68 = { class: "basket__prop-entry" };
	const _hoisted_69 = { class: "basket__prop-name" };
	const _hoisted_70 = { class: "basket__prop-value" };
	const _hoisted_71 = { class: "basket__prop-currency" };
	const _hoisted_72 = {
	  key: 1,
	  class: "basket__prop basket__prop--discount"
	};
	const _hoisted_73 = { class: "basket__prop-entry accordion__toggler js-accordion__toggler" };
	const _hoisted_74 = { class: "basket__prop-name" };
	const _hoisted_75 = { class: "basket__prop-value" };
	const _hoisted_76 = { class: "basket__prop-currency" };
	const _hoisted_77 = { class: "basket__prop-entry accordion__toggler js-accordion__toggler" };
	const _hoisted_78 = { class: "basket__prop-name" };
	const _hoisted_79 = { class: "basket__prop-value" };
	const _hoisted_80 = { class: "basket__prop-currency" };
	const _hoisted_81 = {
	  key: 0,
	  class: "accordion__icon"
	};
	const _hoisted_82 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-down" })
	], -1 /* HOISTED */);
	const _hoisted_83 = {
	  key: 0,
	  class: "basket__prop-items accordion__content js-accordion__content"
	};
	const _hoisted_84 = { class: "accordion__content-wrap" };
	const _hoisted_85 = { class: "basket__prop-entry" };
	const _hoisted_86 = { class: "basket__prop-name" };
	const _hoisted_87 = { class: "basket__prop-value" };
	const _hoisted_88 = { class: "basket__prop-currency" };
	const _hoisted_89 = {
	  key: 3,
	  class: "basket__prop basket__prop--discount"
	};
	const _hoisted_90 = { class: "basket__prop-entry" };
	const _hoisted_91 = { class: "basket__prop-name" };
	const _hoisted_92 = { class: "basket__prop-value" };
	const _hoisted_93 = {
	  key: 4,
	  class: "basket__prop basket__prop--total"
	};
	const _hoisted_94 = { class: "basket__prop-entry" };
	const _hoisted_95 = { class: "basket__prop-name" };
	const _hoisted_96 = { class: "basket__prop-value" };
	const _hoisted_97 = { class: "basket__prop-currency" };
	const _hoisted_98 = {
	  key: 0,
	  class: "basket__discount-card"
	};
	const _hoisted_99 = { class: "basket__action" };
	const _hoisted_100 = /*#__PURE__*/createVNode("span", null, "Оформить заказ", -1 /* HOISTED */);
	const _hoisted_101 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-long" })
	], -1 /* HOISTED */);

	function render$1e(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_basket_item = resolveComponent("v-basket-item");
	  const _component_v_discount_block = resolveComponent("v-discount-block");
	  const _component_v_promocode = resolveComponent("v-promocode");

	  return (openBlock(), createBlock("section", _hoisted_1$15, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.basket)
	      ? (openBlock(), createBlock("div", _hoisted_2$$, [
	          ($data.basket.success)
	            ? (openBlock(), createBlock("div", {
	                key: 0,
	                class: "basket__placeholder",
	                innerHTML: $data.basket.successMessage
	              }, null, 8 /* PROPS */, ["innerHTML"]))
	            : (!$data.basket?.items?.length)
	              ? (openBlock(), createBlock("div", {
	                  key: 1,
	                  class: "basket__placeholder",
	                  innerHTML: $data.basket.emptyMessage
	                }, null, 8 /* PROPS */, ["innerHTML"]))
	              : ($data.basket.step==1)
	                ? (openBlock(), createBlock(Fragment, { key: 2 }, [
	                    createVNode("div", _hoisted_3$T, [
	                      ($data.basket.title)
	                        ? (openBlock(), createBlock("div", _hoisted_4$I, [
	                            createVNode("h1", _hoisted_5$D, [
	                              createTextVNode(toDisplayString($data.basket.title), 1 /* TEXT */),
	                              ($data.basket.items.length)
	                                ? (openBlock(), createBlock("span", _hoisted_6$y, toDisplayString($data.basket.items.length) + " шт.", 1 /* TEXT */))
	                                : createCommentVNode("v-if", true)
	                            ])
	                          ]))
	                        : createCommentVNode("v-if", true),
	                      createVNode("button", {
	                        class: "basket__clean",
	                        type: "button",
	                        onClick: _cache[1] || (_cache[1] = (...args) => ($options.openCleanModal && $options.openCleanModal(...args))),
	                        "aria-label": "Очистить корзину",
	                        title: "Очистить корзину"
	                      }, [
	                        _hoisted_7$t
	                      ])
	                    ]),
	                    createVNode("div", _hoisted_8$o, [
	                      ($data.adaptiveDevice && $data.basket.messages?.length)
	                        ? (openBlock(), createBlock("div", _hoisted_9$n, [
	                            (openBlock(true), createBlock(Fragment, null, renderList($data.basket.messages, (message, index) => {
	                              return (openBlock(), createBlock("div", _hoisted_10$j, [
	                                createTextVNode(toDisplayString(message), 1 /* TEXT */),
	                                createVNode("button", {
	                                  class: "basket__message-close",
	                                  onClick: $event => ($options.removeMessage(index)),
	                                  type: "button"
	                                }, null, 8 /* PROPS */, ["onClick"])
	                              ]))
	                            }), 256 /* UNKEYED_FRAGMENT */))
	                          ]))
	                        : createCommentVNode("v-if", true),
	                      createVNode("div", _hoisted_11$i, [
	                        createVNode("div", _hoisted_12$i, [
	                          (openBlock(true), createBlock(Fragment, null, renderList($data.basket.items, (item) => {
	                            return (openBlock(), createBlock(_component_v_basket_item, {
	                              product: item,
	                              discount: $data.basket.discountList,
	                              key: item.id,
	                              "set-value": 1,
	                              "all-gifts": $data.basket.gifts,
	                              onDeleteProduct: $event => ($options.deleteBasketItem(item.id)),
	                              onChangeProduct: $options.updateBasket
	                            }, null, 8 /* PROPS */, ["product", "discount", "all-gifts", "onDeleteProduct", "onChangeProduct"]))
	                          }), 128 /* KEYED_FRAGMENT */)),
	                          createCommentVNode("transition()"),
	                          createCommentVNode("transition(name=\"fade\" mode=\"out-in\")")
	                        ])
	                      ]),
	                      createCommentVNode(".basket__toolbar-trigger(ref=\"toolbar\")"),
	                      createCommentVNode(".basket__toolbar.hidden-lg.hidden-md(:class=\"{'hide':hideToolbar}\")"),
	                      createVNode("div", _hoisted_13$f, [
	                        createVNode("button", _hoisted_14$e, [
	                          createTextVNode(toDisplayString(_ctx.formatPrice($data.basket.resume.total.value)) + " " + toDisplayString($data.basket.resume.total.currency), 1 /* TEXT */),
	                          _hoisted_15$c
	                        ]),
	                        createVNode("button", {
	                          class: "basket__order btn btn--primary-red",
	                          type: "button",
	                          onClick: _cache[2] || (_cache[2] = (...args) => ($options.continueOrder && $options.continueOrder(...args)))
	                        }, [
	                          _hoisted_16$b,
	                          _hoisted_17$8
	                        ])
	                      ]),
	                      ($data.basket.resume)
	                        ? (openBlock(), createBlock("div", _hoisted_18$7, [
	                            (!$data.adaptiveDevice && $data.basket.messages?.length)
	                              ? (openBlock(), createBlock("div", _hoisted_19$5, [
	                                  (openBlock(true), createBlock(Fragment, null, renderList($data.basket.messages, (message, index) => {
	                                    return (openBlock(), createBlock("div", _hoisted_20$5, [
	                                      createTextVNode(toDisplayString(message), 1 /* TEXT */),
	                                      createVNode("button", {
	                                        class: "basket__message-close",
	                                        onClick: $event => ($options.removeMessage(index)),
	                                        type: "button"
	                                      }, null, 8 /* PROPS */, ["onClick"])
	                                    ]))
	                                  }), 256 /* UNKEYED_FRAGMENT */))
	                                ]))
	                              : createCommentVNode("v-if", true),
	                            createVNode("div", _hoisted_21$5, [
	                              _hoisted_22$5,
	                              createVNode("div", _hoisted_23$5, [
	                                _hoisted_24$4,
	                                createVNode("div", _hoisted_25$3, [
	                                  createVNode("div", _hoisted_26$3, [
	                                    createVNode("div", _hoisted_27$3, [
	                                      ($data.basket.resume.productsPrice)
	                                        ? (openBlock(), createBlock("div", _hoisted_28$3, [
	                                            createVNode("div", _hoisted_29$3, [
	                                              createVNode("div", _hoisted_30$3, toDisplayString($data.basket.resume.productsPrice.name) + " (" + toDisplayString($data.basket.items.length) + ")", 1 /* TEXT */),
	                                              createVNode("div", _hoisted_31$3, toDisplayString(_ctx.formatPrice($data.basket.resume.productsPrice.value)), 1 /* TEXT */),
	                                              createVNode("div", _hoisted_32$3, toDisplayString($data.basket.resume.productsPrice.currency), 1 /* TEXT */)
	                                            ])
	                                          ]))
	                                        : createCommentVNode("v-if", true),
	                                      ($data.basket.resume.sertif)
	                                        ? (openBlock(), createBlock("div", _hoisted_33$3, [
	                                            createVNode("div", _hoisted_34$3, [
	                                              createVNode("div", _hoisted_35$3, toDisplayString($data.basket.resume.sertif.name), 1 /* TEXT */),
	                                              createVNode("div", _hoisted_36$3, toDisplayString(_ctx.formatPrice($data.basket.resume.sertif.value)), 1 /* TEXT */),
	                                              createVNode("div", _hoisted_37$3, toDisplayString($data.basket.resume.sertif.currency), 1 /* TEXT */)
	                                            ])
	                                          ]))
	                                        : createCommentVNode("v-if", true),
	                                      ($data.basket.resume.discount)
	                                        ? (openBlock(), createBlock("div", {
	                                            key: 2,
	                                            class: ["basket__prop basket__prop--discount", {'accordion  accordion--native  js-accordion': $data.basket.resume.discount?.items?.length}]
	                                          }, [
	                                            createVNode("div", _hoisted_38$3, [
	                                              createVNode("div", _hoisted_39$3, toDisplayString($data.basket.resume.discount.name), 1 /* TEXT */),
	                                              createVNode("div", _hoisted_40$3, toDisplayString(_ctx.formatPrice($data.basket.resume.discount.value)), 1 /* TEXT */),
	                                              createVNode("div", _hoisted_41$3, toDisplayString($data.basket.resume.discount.currency), 1 /* TEXT */),
	                                              ($data.basket.resume.discount?.items?.length)
	                                                ? (openBlock(), createBlock("i", _hoisted_42$3, [
	                                                    _hoisted_43$3
	                                                  ]))
	                                                : createCommentVNode("v-if", true)
	                                            ]),
	                                            ($data.basket.resume.discount?.items?.length)
	                                              ? (openBlock(), createBlock("div", _hoisted_44$3, [
	                                                  createVNode("div", _hoisted_45$2, [
	                                                    (openBlock(true), createBlock(Fragment, null, renderList($data.basket.resume.discount.items, (item) => {
	                                                      return (openBlock(), createBlock("div", _hoisted_46$2, [
	                                                        createVNode("div", _hoisted_47$2, toDisplayString(item.name), 1 /* TEXT */),
	                                                        createVNode("div", _hoisted_48$2, toDisplayString(_ctx.formatPrice(item.value)), 1 /* TEXT */),
	                                                        createVNode("div", _hoisted_49$2, toDisplayString(item.currency), 1 /* TEXT */)
	                                                      ]))
	                                                    }), 256 /* UNKEYED_FRAGMENT */))
	                                                  ])
	                                                ]))
	                                              : createCommentVNode("v-if", true)
	                                          ], 2 /* CLASS */))
	                                        : createCommentVNode("v-if", true),
	                                      ($data.basket.resume.discountChockPercent)
	                                        ? (openBlock(), createBlock("div", _hoisted_50$2, [
	                                            createVNode("div", _hoisted_51$2, [
	                                              createVNode("div", _hoisted_52$2, toDisplayString($data.basket.resume.discountChockPercent.name), 1 /* TEXT */),
	                                              createVNode("div", _hoisted_53$2, toDisplayString($data.basket.resume.discountChockPercent.value), 1 /* TEXT */)
	                                            ])
	                                          ]))
	                                        : createCommentVNode("v-if", true),
	                                      ($data.basket.resume.total)
	                                        ? (openBlock(), createBlock("div", _hoisted_54$2, [
	                                            createVNode("div", _hoisted_55$2, [
	                                              createVNode("div", _hoisted_56$2, toDisplayString($data.basket.resume.total.name), 1 /* TEXT */),
	                                              createVNode("div", _hoisted_57$2, toDisplayString(_ctx.formatPrice($data.basket.resume.total.value)), 1 /* TEXT */),
	                                              createVNode("div", _hoisted_58$2, toDisplayString($data.basket.resume.total.currency), 1 /* TEXT */)
	                                            ])
	                                          ]))
	                                        : createCommentVNode("v-if", true),
	                                      ($data.basket.resume.free_delivery)
	                                        ? (openBlock(), createBlock("div", {
	                                            key: 5,
	                                            class: "basket__prop basket__prop--total",
	                                            innerHTML: $data.basket.resume.free_delivery
	                                          }, null, 8 /* PROPS */, ["innerHTML"]))
	                                        : createCommentVNode("v-if", true)
	                                    ]),
	                                    ($data.basket.discountList && $data.basket.discountList.nextLevelId)
	                                      ? (openBlock(), createBlock("div", _hoisted_59$2, [
	                                          createVNode(_component_v_discount_block, { "data-source": $options.computedDiscountData }, null, 8 /* PROPS */, ["data-source"])
	                                        ]))
	                                      : createCommentVNode("v-if", true),
	                                    createVNode("div", _hoisted_60$2, [
	                                      ($data.basket.resume?.promocode)
	                                        ? (openBlock(), createBlock(_component_v_promocode, {
	                                            key: 0,
	                                            promocode: $data.basket.resume.promocode,
	                                            onAddPromocode: $options.sendPromocode,
	                                            onRemovePromocode: $options.removePromocode,
	                                            onChangePromocode: $options.changePromocode
	                                          }, null, 8 /* PROPS */, ["promocode", "onAddPromocode", "onRemovePromocode", "onChangePromocode"]))
	                                        : createCommentVNode("v-if", true),
	                                      createVNode("button", {
	                                        class: "basket__order btn btn--primary-red btn--full",
	                                        type: "button",
	                                        onClick: _cache[3] || (_cache[3] = (...args) => ($options.continueOrder && $options.continueOrder(...args))),
	                                        disabled: $data.disabledSubmit
	                                      }, [
	                                        _hoisted_61$2,
	                                        _hoisted_62$2
	                                      ], 8 /* PROPS */, ["disabled"])
	                                    ])
	                                  ])
	                                ])
	                              ])
	                            ]),
	                            createVNode("div", _hoisted_63$2, [
	                              createVNode("div", _hoisted_64$2, [
	                                ($data.basket.resume.title)
	                                  ? (openBlock(), createBlock("div", _hoisted_65$1, toDisplayString($data.basket.resume.title), 1 /* TEXT */))
	                                  : createCommentVNode("v-if", true)
	                              ]),
	                              createVNode("div", _hoisted_66$1, [
	                                ($data.basket.resume.productsPrice)
	                                  ? (openBlock(), createBlock("div", _hoisted_67$1, [
	                                      createVNode("div", _hoisted_68, [
	                                        createVNode("div", _hoisted_69, toDisplayString($data.basket.resume.productsPrice.name) + " (" + toDisplayString($data.basket.items.length) + ")", 1 /* TEXT */),
	                                        createVNode("div", _hoisted_70, toDisplayString(_ctx.formatPrice($data.basket.resume.productsPrice.value)), 1 /* TEXT */),
	                                        createVNode("div", _hoisted_71, toDisplayString($data.basket.resume.productsPrice.currency), 1 /* TEXT */)
	                                      ])
	                                    ]))
	                                  : createCommentVNode("v-if", true),
	                                ($data.basket.resume.sertif)
	                                  ? (openBlock(), createBlock("div", _hoisted_72, [
	                                      createVNode("div", _hoisted_73, [
	                                        createVNode("div", _hoisted_74, toDisplayString($data.basket.resume.sertif.name), 1 /* TEXT */),
	                                        createVNode("div", _hoisted_75, toDisplayString(_ctx.formatPrice($data.basket.resume.sertif.value)), 1 /* TEXT */),
	                                        createVNode("div", _hoisted_76, toDisplayString($data.basket.resume.sertif.currency), 1 /* TEXT */)
	                                      ])
	                                    ]))
	                                  : createCommentVNode("v-if", true),
	                                ($data.basket.resume.discount)
	                                  ? (openBlock(), createBlock("div", {
	                                      key: 2,
	                                      class: ["basket__prop basket__prop--discount", {'accordion  accordion--native  js-accordion': $data.basket.resume.discount?.items?.length}]
	                                    }, [
	                                      createVNode("div", _hoisted_77, [
	                                        createVNode("div", _hoisted_78, toDisplayString($data.basket.resume.discount.name), 1 /* TEXT */),
	                                        createVNode("div", _hoisted_79, toDisplayString(_ctx.formatPrice($data.basket.resume.discount.value)), 1 /* TEXT */),
	                                        createVNode("div", _hoisted_80, toDisplayString($data.basket.resume.discount.currency), 1 /* TEXT */),
	                                        ($data.basket.resume.discount?.items?.length)
	                                          ? (openBlock(), createBlock("i", _hoisted_81, [
	                                              _hoisted_82
	                                            ]))
	                                          : createCommentVNode("v-if", true)
	                                      ]),
	                                      ($data.basket.resume.discount?.items?.length)
	                                        ? (openBlock(), createBlock("div", _hoisted_83, [
	                                            createVNode("div", _hoisted_84, [
	                                              (openBlock(true), createBlock(Fragment, null, renderList($data.basket.resume.discount.items, (item) => {
	                                                return (openBlock(), createBlock("div", _hoisted_85, [
	                                                  createVNode("div", _hoisted_86, toDisplayString(item.name), 1 /* TEXT */),
	                                                  createVNode("div", _hoisted_87, toDisplayString(_ctx.formatPrice(item.value)), 1 /* TEXT */),
	                                                  createVNode("div", _hoisted_88, toDisplayString(item.currency), 1 /* TEXT */)
	                                                ]))
	                                              }), 256 /* UNKEYED_FRAGMENT */))
	                                            ])
	                                          ]))
	                                        : createCommentVNode("v-if", true)
	                                    ], 2 /* CLASS */))
	                                  : createCommentVNode("v-if", true),
	                                ($data.basket.resume.discountChockPercent)
	                                  ? (openBlock(), createBlock("div", _hoisted_89, [
	                                      createVNode("div", _hoisted_90, [
	                                        createVNode("div", _hoisted_91, toDisplayString($data.basket.resume.discountChockPercent.name), 1 /* TEXT */),
	                                        createVNode("div", _hoisted_92, toDisplayString($data.basket.resume.discountChockPercent.value), 1 /* TEXT */)
	                                      ])
	                                    ]))
	                                  : createCommentVNode("v-if", true),
	                                ($data.basket.resume.total)
	                                  ? (openBlock(), createBlock("div", _hoisted_93, [
	                                      createVNode("div", _hoisted_94, [
	                                        createVNode("div", _hoisted_95, toDisplayString($data.basket.resume.total.name), 1 /* TEXT */),
	                                        createVNode("div", _hoisted_96, toDisplayString(_ctx.formatPrice($data.basket.resume.total.value)), 1 /* TEXT */),
	                                        createVNode("div", _hoisted_97, toDisplayString($data.basket.resume.total.currency), 1 /* TEXT */)
	                                      ])
	                                    ]))
	                                  : createCommentVNode("v-if", true),
	                                ($data.basket.resume.free_delivery)
	                                  ? (openBlock(), createBlock("div", {
	                                      key: 5,
	                                      class: "basket__prop basket__prop--total",
	                                      innerHTML: $data.basket.resume.free_delivery
	                                    }, null, 8 /* PROPS */, ["innerHTML"]))
	                                  : createCommentVNode("v-if", true)
	                              ]),
	                              ($data.basket.discountList && $data.basket.discountList.nextLevelId)
	                                ? (openBlock(), createBlock("div", _hoisted_98, [
	                                    createVNode(_component_v_discount_block, { "data-source": $options.computedDiscountData }, null, 8 /* PROPS */, ["data-source"])
	                                  ]))
	                                : createCommentVNode("v-if", true),
	                              createVNode("div", _hoisted_99, [
	                                ($data.basket.resume?.promocode)
	                                  ? (openBlock(), createBlock(_component_v_promocode, {
	                                      key: 0,
	                                      promocode: $data.basket.resume.promocode,
	                                      onChangePromocode: $options.changePromocode,
	                                      onAddPromocode: $options.sendPromocode,
	                                      onRemovePromocode: $options.removePromocode
	                                    }, null, 8 /* PROPS */, ["promocode", "onChangePromocode", "onAddPromocode", "onRemovePromocode"]))
	                                  : createCommentVNode("v-if", true),
	                                createVNode("button", {
	                                  class: "basket__order btn btn--primary-red btn--full hidden-sm hidden-xs",
	                                  type: "button",
	                                  onClick: _cache[4] || (_cache[4] = (...args) => ($options.continueOrder && $options.continueOrder(...args))),
	                                  disabled: $data.disabledSubmit
	                                }, [
	                                  _hoisted_100,
	                                  _hoisted_101
	                                ], 8 /* PROPS */, ["disabled"])
	                              ])
	                            ])
	                          ]))
	                        : createCommentVNode("v-if", true)
	                    ])
	                  ], 64 /* STABLE_FRAGMENT */))
	                : createCommentVNode("v-if", true)
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1c.render = render$1e;
	script$1c.__file = "local/assets/source/components/v-basket-big.vue";

	var script$1d = {
		props: {
			setValue: {
				type: Number,
				default: 1
			},
			discount: {
				type: Object,
				default: null
			},
			product: {
				type: Object,
				default: null
			},

			allGifts: {
				type: Array,
				default: null
			},
		},

		emits: [
			'delete-product',
			'change-product',
		],

		data() {
			return {
				localCount: null,
				timeout: null,
			};
		},


		computed: {
			computedProps() {
				return this.product.paramsTop.reverse()
			},

			// собираем массив подарков относящихся к данному продукту
			computedGifts() {
				const result = [];
				if (this.product?.gifts?.length) {
					this.product.gifts.forEach((item) => {
						const filteredGift = this.allGifts.filter((gift) => parseInt(gift.id) === parseInt(item.id))[0];
						const copyGift = JSON.parse(JSON.stringify(filteredGift));
						copyGift.count = item.count;
						result.push(copyGift);
					});
				}
				return result;
			},

			computedShowAvailability() {
				return this.product.availability.value && this.product.availability.oldValue > this.product.availability.value
			},

			computedProductAvailable() {
				return this.product.availability.value
			},
		},

		watch: {
			product: {
				immediate: true,
				handler(newValue) {
					this.localCount = newValue.count.value ?? 1;
				}
			}
		},

		methods: {
			...mapActions$1({
				basketAdd: 'basket/add'
			}),

			deleteBasketItem() {
				this.$emit('delete-product', this.product.id);
			},

			changeCount(value) {
				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					this.basketAdd({
						id: this.product.id,
						count: value,
						setValue: this.setValue
					}).then(() => {
						this.$emit('change-product');
					});
				}, 1000);
			},

			openDeleteModal() {
				controller.openModal({
					className: 'modal--sm',
					component: {
						name: 'v-delete-basket-item',
						props: {
							productId: this.product.id,
							title: 'Удаление'
						}
					}
				});
			},

			openNotification() {
				controller.openModal({
					className: 'modal--sm',
					component: {
						name: 'v-add-review',
						props: {
							bxajaxid: 'subsribe-product',
							product: this.product,
							dataSource: this.product.subscribe,
							title: this.product.subscribeText,
						}
					}
				});

			},

			getDevice() {
				this.adaptiveDevice = window.innerWidth < breakpoints['sm-max'];
			},
		}

	};

	const _hoisted_1$16 = { class: "basket-item__content" };
	const _hoisted_2$10 = { class: "basket-item__content-wrap" };
	const _hoisted_3$U = { class: "basket-item__header" };
	const _hoisted_4$J = {
	  key: 0,
	  class: "basket-item__brand"
	};
	const _hoisted_5$E = {
	  key: 1,
	  class: "basket-item__price"
	};
	const _hoisted_6$z = { class: "basket-item__body" };
	const _hoisted_7$u = {
	  key: 0,
	  class: "basket-item__props"
	};
	const _hoisted_8$p = {
	  key: 0,
	  class: "basket-item__prop-separator"
	};
	const _hoisted_9$o = { class: "basket-item__prop" };
	const _hoisted_10$k = {
	  key: 0,
	  class: "basket-item__prop-icon"
	};
	const _hoisted_11$j = {
	  key: 1,
	  class: "basket-item__prop-value"
	};
	const _hoisted_12$j = {
	  key: 1,
	  class: "basket-item__availability"
	};
	const _hoisted_13$g = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-availability" })
	], -1 /* HOISTED */);
	const _hoisted_14$f = {
	  key: 0,
	  class: "basket-item__footer"
	};
	const _hoisted_15$d = {
	  key: 0,
	  class: "basket-item__counter"
	};
	const _hoisted_16$c = { class: "basket-item__favorite" };
	const _hoisted_17$9 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-delete" })
	], -1 /* HOISTED */);
	const _hoisted_18$8 = {
	  key: 1,
	  class: "basket-item__action"
	};
	const _hoisted_19$6 = /*#__PURE__*/createVNode("svg", { class: "svg-icon svg-icon--notification" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-notification" })
	], -1 /* HOISTED */);
	const _hoisted_20$6 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-delete" })
	], -1 /* HOISTED */);
	const _hoisted_21$6 = {
	  key: 2,
	  class: "basket-item__gifts"
	};

	function render$1f(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_picture = resolveComponent("v-picture");
	  const _component_v_price = resolveComponent("v-price");
	  const _component_v_field = resolveComponent("v-field");
	  const _component_v_favorite_action = resolveComponent("v-favorite-action");
	  const _component_v_gift_short = resolveComponent("v-gift-short");

	  return (openBlock(), createBlock("div", {
	    class: ["v-basket-item basket-item", {'basket-item--disabled': !$options.computedProductAvailable, 'basket-item--change-count': !$options.computedShowAvailability}]
	  }, [
	    createVNode("a", {
	      class: "basket-item__visual",
	      href: $props.product.link,
	      target: "_blank"
	    }, [
	      createVNode(_component_v_picture, {
	        sources: $props.product.imageSources
	      }, null, 8 /* PROPS */, ["sources"])
	    ], 8 /* PROPS */, ["href"]),
	    createVNode("div", _hoisted_1$16, [
	      createVNode("div", _hoisted_2$10, [
	        createVNode("div", _hoisted_3$U, [
	          ($props.product.name)
	            ? (openBlock(), createBlock("a", {
	                key: 0,
	                class: "basket-item__name",
	                href: $props.product.link,
	                target: "_blank"
	              }, [
	                ($props.product.brand?.text)
	                  ? (openBlock(), createBlock("div", _hoisted_4$J, toDisplayString($props.product.brand.text), 1 /* TEXT */))
	                  : createCommentVNode("v-if", true),
	                createTextVNode(" " + toDisplayString($props.product.name), 1 /* TEXT */),
	                ($props.product.adminlink)
	                  ? (openBlock(), createBlock("a", {
	                      key: 1,
	                      class: "product__admin-link link",
	                      target: "_blank",
	                      href: $props.product.adminlink
	                    }, " В админке", 8 /* PROPS */, ["href"]))
	                  : createCommentVNode("v-if", true)
	              ], 8 /* PROPS */, ["href"]))
	            : createCommentVNode("v-if", true),
	          ($props.product.price)
	            ? (openBlock(), createBlock("div", _hoisted_5$E, [
	                createVNode(_component_v_price, {
	                  price: $props.product.price
	                }, null, 8 /* PROPS */, ["price"])
	              ]))
	            : createCommentVNode("v-if", true)
	        ]),
	        createVNode("div", _hoisted_6$z, [
	          ($options.computedProps?.length)
	            ? (openBlock(), createBlock("div", _hoisted_7$u, [
	                (openBlock(true), createBlock(Fragment, null, renderList($options.computedProps, (prop, index) => {
	                  return (openBlock(), createBlock(Fragment, null, [
	                    (index !== 0)
	                      ? (openBlock(), createBlock("div", _hoisted_8$p))
	                      : createCommentVNode("v-if", true),
	                    (openBlock(true), createBlock(Fragment, null, renderList(prop.options, (option) => {
	                      return (openBlock(), createBlock("div", _hoisted_9$o, [
	                        (option.image)
	                          ? (openBlock(), createBlock("div", _hoisted_10$k, [
	                              createVNode("img", {
	                                src: option.image,
	                                loading: "lazy",
	                                decoding: "async",
	                                alt: option.text,
	                                title: option.text
	                              }, null, 8 /* PROPS */, ["src", "alt", "title"])
	                            ]))
	                          : createCommentVNode("v-if", true),
	                        (option.text)
	                          ? (openBlock(), createBlock("div", _hoisted_11$j, toDisplayString(option.text), 1 /* TEXT */))
	                          : createCommentVNode("v-if", true)
	                      ]))
	                    }), 256 /* UNKEYED_FRAGMENT */))
	                  ], 64 /* STABLE_FRAGMENT */))
	                }), 256 /* UNKEYED_FRAGMENT */))
	              ]))
	            : createCommentVNode("v-if", true),
	          ($options.computedShowAvailability)
	            ? (openBlock(), createBlock("div", _hoisted_12$j, [
	                _hoisted_13$g,
	                createVNode("span", null, "Для заказа доступно — " + toDisplayString($props.product.availability.quantity) + " " + toDisplayString($props.product.unit), 1 /* TEXT */)
	              ]))
	            : createCommentVNode("v-if", true)
	        ])
	      ]),
	      ($options.computedProductAvailable)
	        ? (openBlock(), createBlock("div", _hoisted_14$f, [
	            ($props.product.count)
	              ? (openBlock(), createBlock("div", _hoisted_15$d, [
	                  createVNode(_component_v_field, {
	                    class: "field--no-border",
	                    modelValue: $data.localCount,
	                    "onUpdate:modelValue": [
	                      _cache[1] || (_cache[1] = $event => ($data.localCount = $event)),
	                      $options.changeCount
	                    ],
	                    field: {type: 'count', min: $props.product.count.min ? $props.product.count.min : 1, max: $props.product.count.max, multiplicity: $props.product.count.multiplicity}
	                  }, null, 8 /* PROPS */, ["modelValue", "field", "onUpdate:modelValue"])
	                ]))
	              : createCommentVNode("v-if", true),
	            createVNode("div", _hoisted_16$c, [
	              createVNode(_component_v_favorite_action, {
	                "product-id": $props.product.id,
	                full: "full"
	              }, null, 8 /* PROPS */, ["product-id"])
	            ]),
	            createVNode("button", {
	              class: "basket-item__delete",
	              type: "button",
	              onClick: _cache[2] || (_cache[2] = (...args) => ($options.openDeleteModal && $options.openDeleteModal(...args))),
	              title: "Удалить товар из корзины"
	            }, [
	              _hoisted_17$9
	            ])
	          ]))
	        : createCommentVNode("v-if", true),
	      (!$options.computedProductAvailable &&  $props.product.subscribe)
	        ? (openBlock(), createBlock("div", _hoisted_18$8, [
	            createVNode("button", {
	              class: "basket-item__notification-btn btn btn--primary",
	              type: "button",
	              onClick: _cache[3] || (_cache[3] = (...args) => ($options.openNotification && $options.openNotification(...args))),
	              title: $props.product.subscribeText
	            }, [
	              _hoisted_19$6,
	              createVNode("span", null, toDisplayString($props.product.subscribeText), 1 /* TEXT */)
	            ], 8 /* PROPS */, ["title"]),
	            createVNode("button", {
	              class: "basket-item__delete",
	              type: "button",
	              onClick: _cache[4] || (_cache[4] = (...args) => ($options.openDeleteModal && $options.openDeleteModal(...args))),
	              title: "Удалить товар из корзины"
	            }, [
	              _hoisted_20$6
	            ])
	          ]))
	        : createCommentVNode("v-if", true),
	      ($options.computedGifts?.length && $options.computedProductAvailable)
	        ? (openBlock(), createBlock("div", _hoisted_21$6, [
	            (openBlock(true), createBlock(Fragment, null, renderList($options.computedGifts, (gift) => {
	              return (openBlock(), createBlock(_component_v_gift_short, { gift: gift }, null, 8 /* PROPS */, ["gift"]))
	            }), 256 /* UNKEYED_FRAGMENT */))
	          ]))
	        : createCommentVNode("v-if", true)
	    ])
	  ], 2 /* CLASS */))
	}

	script$1d.render = render$1f;
	script$1d.__file = "local/assets/source/components/v-basket-item.vue";

	var script$1e = {
		props: {
			discount: {
				type: Object,
				default: null
			},
			product: {
				type: Object,
				default: null
			},
		},

		computed: {
			computedProps() {
				return this.product.paramsTop.reverse()
			},
		}
	};

	const _hoisted_1$17 = { class: "v-order-item order-item" };
	const _hoisted_2$11 = { class: "order-item__content" };
	const _hoisted_3$V = { class: "order-item__content-wrap" };
	const _hoisted_4$K = { class: "order-item__header" };
	const _hoisted_5$F = {
	  key: 0,
	  class: "order-item__price"
	};
	const _hoisted_6$A = {
	  key: 0,
	  class: "order-item__brand"
	};
	const _hoisted_7$v = { class: "order-item__body" };
	const _hoisted_8$q = {
	  key: 0,
	  class: "order-item__props"
	};
	const _hoisted_9$p = {
	  key: 0,
	  class: "order-item__prop-separator"
	};
	const _hoisted_10$l = { class: "order-item__prop" };
	const _hoisted_11$k = {
	  key: 0,
	  class: "order-item__prop-icon"
	};
	const _hoisted_12$k = {
	  key: 1,
	  class: "order-item__prop-value"
	};

	function render$1g(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_picture = resolveComponent("v-picture");
	  const _component_v_price = resolveComponent("v-price");

	  return (openBlock(), createBlock("div", _hoisted_1$17, [
	    createVNode("a", {
	      class: "order-item__visual",
	      href: $props.product.link
	    }, [
	      createVNode(_component_v_picture, {
	        sources: $props.product.imageSources
	      }, null, 8 /* PROPS */, ["sources"])
	    ], 8 /* PROPS */, ["href"]),
	    createVNode("div", _hoisted_2$11, [
	      createVNode("div", _hoisted_3$V, [
	        createVNode("div", _hoisted_4$K, [
	          ($props.product.price)
	            ? (openBlock(), createBlock("div", _hoisted_5$F, [
	                createVNode(_component_v_price, {
	                  price: $props.product.price
	                }, null, 8 /* PROPS */, ["price"])
	              ]))
	            : createCommentVNode("v-if", true),
	          ($props.product.name)
	            ? (openBlock(), createBlock("a", {
	                key: 1,
	                class: "order-item__name",
	                href: $props.product.link
	              }, [
	                ($props.product.brand?.text)
	                  ? (openBlock(), createBlock("div", _hoisted_6$A, toDisplayString($props.product.brand.text), 1 /* TEXT */))
	                  : createCommentVNode("v-if", true),
	                createTextVNode(" " + toDisplayString($props.product.name), 1 /* TEXT */)
	              ], 8 /* PROPS */, ["href"]))
	            : createCommentVNode("v-if", true)
	        ]),
	        createVNode("div", _hoisted_7$v, [
	          ($options.computedProps?.length)
	            ? (openBlock(), createBlock("div", _hoisted_8$q, [
	                (openBlock(true), createBlock(Fragment, null, renderList($options.computedProps, (prop, index) => {
	                  return (openBlock(), createBlock(Fragment, null, [
	                    (index !== 0)
	                      ? (openBlock(), createBlock("div", _hoisted_9$p))
	                      : createCommentVNode("v-if", true),
	                    (openBlock(true), createBlock(Fragment, null, renderList(prop.options, (option) => {
	                      return (openBlock(), createBlock("div", _hoisted_10$l, [
	                        (option.image)
	                          ? (openBlock(), createBlock("div", _hoisted_11$k, [
	                              createVNode("img", {
	                                src: option.image,
	                                loading: "lazy",
	                                decoding: "async",
	                                alt: option.text,
	                                title: option.text
	                              }, null, 8 /* PROPS */, ["src", "alt", "title"])
	                            ]))
	                          : createCommentVNode("v-if", true),
	                        (option.text)
	                          ? (openBlock(), createBlock("div", _hoisted_12$k, toDisplayString(option.text), 1 /* TEXT */))
	                          : createCommentVNode("v-if", true)
	                      ]))
	                    }), 256 /* UNKEYED_FRAGMENT */))
	                  ], 64 /* STABLE_FRAGMENT */))
	                }), 256 /* UNKEYED_FRAGMENT */))
	              ]))
	            : createCommentVNode("v-if", true)
	        ])
	      ])
	    ])
	  ]))
	}

	script$1e.render = render$1g;
	script$1e.__file = "local/assets/source/components/v-order-item.vue";

	var script$1f = {
		props: {
			gift: {
				type: Object,
				default: null
			},
		},
	};

	const _hoisted_1$18 = { class: "v-gift-short gift-short" };
	const _hoisted_2$12 = {
	  key: 1,
	  class: "gift-short__visual"
	};
	const _hoisted_3$W = {
	  key: 0,
	  class: "gift-short__count"
	};
	const _hoisted_4$L = { class: "gift-short__content" };
	const _hoisted_5$G = {
	  key: 0,
	  class: "gift-short__category"
	};
	const _hoisted_6$B = {
	  key: 1,
	  class: "gift-short__name"
	};

	function render$1h(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_picture = resolveComponent("v-picture");

	  return (openBlock(), createBlock("div", _hoisted_1$18, [
	    ($props.gift.link)
	      ? (openBlock(), createBlock("a", {
	          key: 0,
	          class: "gift-short__link",
	          href: $props.gift.link,
	          onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.openDetails && _ctx.openDetails(...args))),
	          "aria-label": $props.gift.name
	        }, null, 8 /* PROPS */, ["href", "aria-label"]))
	      : createCommentVNode("v-if", true),
	    ($props.gift.imageSources)
	      ? (openBlock(), createBlock("div", _hoisted_2$12, [
	          ($props.gift.count && $props.gift.count > 1)
	            ? (openBlock(), createBlock("div", _hoisted_3$W, toDisplayString($props.gift.count), 1 /* TEXT */))
	            : createCommentVNode("v-if", true),
	          createVNode(_component_v_picture, {
	            sources: $props.gift.imageSources
	          }, null, 8 /* PROPS */, ["sources"])
	        ]))
	      : createCommentVNode("v-if", true),
	    createVNode("div", _hoisted_4$L, [
	      ($props.gift.category)
	        ? (openBlock(), createBlock("div", _hoisted_5$G, toDisplayString($props.gift.category), 1 /* TEXT */))
	        : createCommentVNode("v-if", true),
	      ($props.gift.name)
	        ? (openBlock(), createBlock("div", _hoisted_6$B, toDisplayString($props.gift.name), 1 /* TEXT */))
	        : createCommentVNode("v-if", true)
	    ])
	  ]))
	}

	script$1f.render = render$1h;
	script$1f.__file = "local/assets/source/components/v-gift-short.vue";

	var script$1g = {

		mixins: [script$2],
		props: {
			reviews: {
				type: Object,
				default: null
			},
			newReview: {
				type: Object,
				default: null
			},
		},

		emits: ['change-helped'],

		data() {
			return {
				reviewData: {},
			}
		},


		created() {
			controller.events.on('open-add-review', this.openAddReview);
		},

		methods: {
			dataSet(data, options = {}) {

				if (options.append && this.reviewData && this.reviewData.items) {
					let oldItems = this.reviewData.items;
					this.reviewData = data;
					this.reviewData.items = oldItems.concat(this.reviewData.items);
				} else {
					this.catalog = data;
				}
				this.reviewData = data;
			},


			navigate(pages) {
				this.reviewData.pages.offset = pages.offset;
				this.reviewData.pages.limit = pages.limit;
				this.requestDataLoad({append: pages.append});
			},

			requestDataLoad(dataSetOptions) {
				if (this.loading) {
					return;
				}

				this.dataLoad({
					url: this.reviewData.remote,
					delay: true,
					data: {
						pages: this.reviewData.pages,
					}
				}, dataSetOptions);
			},

			changeHelped(options) {
				this.$emit('change-helped', options);
			},

			// модалка подписки на товар
			openAddReview() {
				controller.openModal({
					className: 'modal--sm',
					component: {
						name: 'v-add-review',
						props: {
							bxajaxid:'review-add-form',
							product:this.newReview.product,
							dataSource: this.newReview.form,
							title: 'Новый отзыв'
						}
					}
				});
			},
		},
	};

	const _hoisted_1$19 = { class: "v-reviews reviews" };
	const _hoisted_2$13 = {
	  key: 0,
	  class: "reviews__wrapper"
	};
	const _hoisted_3$X = {
	  class: "reviews__header",
	  ref: "reviews"
	};
	const _hoisted_4$M = { class: "reviews__header-top" };
	const _hoisted_5$H = {
	  key: 0,
	  class: "reviews__title h5"
	};
	const _hoisted_6$C = {
	  key: 1,
	  class: "reviews__empty-info"
	};
	const _hoisted_7$w = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star-big" })
	], -1 /* HOISTED */);
	const _hoisted_8$r = /*#__PURE__*/createVNode("span", null, "Отзывов пока нет", -1 /* HOISTED */);
	const _hoisted_9$q = {
	  key: 0,
	  class: "reviews__info"
	};
	const _hoisted_10$m = { class: "reviews__chart" };
	const _hoisted_11$l = { class: "reviews__chart-item" };
	const _hoisted_12$l = { class: "reviews__chart-name" };
	const _hoisted_13$h = { class: "reviews__chart-value" };
	const _hoisted_14$g = {
	  key: 0,
	  class: "reviews__rating"
	};
	const _hoisted_15$e = { class: "reviews__rating-count" };
	const _hoisted_16$d = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-star-big" })
	], -1 /* HOISTED */);
	const _hoisted_17$a = { class: "reviews__rating-text" };
	const _hoisted_18$9 = {
	  key: 1,
	  class: "reviews__empty"
	};
	const _hoisted_19$7 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-review-add" })
	], -1 /* HOISTED */);
	const _hoisted_20$7 = /*#__PURE__*/createVNode("div", { class: "reviews__add-input" }, [
	  /*#__PURE__*/createVNode("span", null, "Оставьте свой отзыв"),
	  /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	    /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-long" })
	  ])
	], -1 /* HOISTED */);
	const _hoisted_21$7 = {
	  key: 0,
	  class: "reviews__list"
	};
	const _hoisted_22$6 = { class: "reviews__item" };

	function render$1i(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_review_item = resolveComponent("v-review-item");
	  const _component_v_page_nav = resolveComponent("v-page-nav");

	  return (openBlock(), createBlock("section", _hoisted_1$19, [
	    ($data.reviewData)
	      ? (openBlock(), createBlock("div", _hoisted_2$13, [
	          createVNode("div", _hoisted_3$X, [
	            createVNode("div", _hoisted_4$M, [
	              ($data.reviewData.title)
	                ? (openBlock(), createBlock("h2", _hoisted_5$H, toDisplayString($data.reviewData.title), 1 /* TEXT */))
	                : createCommentVNode("v-if", true),
	              (!$data.reviewData.items?.length)
	                ? (openBlock(), createBlock("div", _hoisted_6$C, [
	                    _hoisted_7$w,
	                    _hoisted_8$r
	                  ]))
	                : createCommentVNode("v-if", true)
	            ]),
	            ($data.reviewData.chart?.length)
	              ? (openBlock(), createBlock("div", _hoisted_9$q, [
	                  createVNode("div", _hoisted_10$m, [
	                    (openBlock(true), createBlock(Fragment, null, renderList($data.reviewData.chart, (item) => {
	                      return (openBlock(), createBlock("div", _hoisted_11$l, [
	                        createVNode("div", _hoisted_12$l, toDisplayString(item.key), 1 /* TEXT */),
	                        createVNode("div", _hoisted_13$h, [
	                          createVNode("div", {
	                            class: "reviews__chart-active",
	                            style: {width: item.value + '%'}
	                          }, null, 4 /* STYLE */)
	                        ])
	                      ]))
	                    }), 256 /* UNKEYED_FRAGMENT */))
	                  ]),
	                  ($data.reviewData.rating)
	                    ? (openBlock(), createBlock("div", _hoisted_14$g, [
	                        createVNode("div", _hoisted_15$e, [
	                          createVNode("span", null, toDisplayString($data.reviewData.rating.value), 1 /* TEXT */),
	                          _hoisted_16$d
	                        ]),
	                        createVNode("div", _hoisted_17$a, toDisplayString($data.reviewData.rating.counter), 1 /* TEXT */)
	                      ]))
	                    : createCommentVNode("v-if", true)
	                ]))
	              : (openBlock(), createBlock("div", _hoisted_18$9, toDisplayString($data.reviewData.empty), 1 /* TEXT */)),
	            createVNode("button", {
	              class: "reviews__add hidden-xs",
	              type: "button",
	              onClick: _cache[1] || (_cache[1] = (...args) => ($options.openAddReview && $options.openAddReview(...args))),
	              "aria-label": "Оставьте свой отзыв",
	              title: "Оставьте свой отзыв"
	            }, [
	              _hoisted_19$7,
	              _hoisted_20$7
	            ]),
	            createVNode("button", {
	              class: "reviews__add btn btn--full btn--primary hidden-lg hidden-md hidden-sm",
	              type: "button",
	              onClick: _cache[2] || (_cache[2] = (...args) => ($options.openAddReview && $options.openAddReview(...args))),
	              "aria-label": "Оставить отзыв",
	              title: "Оставить отзыв"
	            }, "Оставить отзыв")
	          ], 512 /* NEED_PATCH */),
	          ($data.reviewData.items?.length)
	            ? (openBlock(), createBlock("ul", _hoisted_21$7, [
	                (openBlock(true), createBlock(Fragment, null, renderList($data.reviewData.items, (review, index) => {
	                  return (openBlock(), createBlock("li", _hoisted_22$6, [
	                    createVNode(_component_v_review_item, {
	                      review: review,
	                      onChangeHelped: $options.changeHelped
	                    }, null, 8 /* PROPS */, ["review", "onChangeHelped"])
	                  ]))
	                }), 256 /* UNKEYED_FRAGMENT */))
	              ]))
	            : createCommentVNode("v-if", true),
	          createVNode(_component_v_page_nav, {
	            pages: $data.reviewData.pages,
	            onNavigate: $options.navigate,
	            numbers: false
	          }, null, 8 /* PROPS */, ["pages", "onNavigate"])
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1g.render = render$1i;
	script$1g.__file = "local/assets/source/components/v-reviews.vue";

	var script$1h = {
		props: {
			review: {
				type: Object,
				default: null
			},
		},

		emits: ['change-helped'],

		data() {
			return {
				init: false,
				open: false,
			}
		},

		computed: {
			computedRating() {
				return {
					'value': this.review.rating,
					'readOnly': true
				};
			}
		},

		mounted() {
			this.$nextTick(() => {
				if (this.$refs.comment.clientHeight > 72) {
					this.init = true;
				}
			});
		},

		methods: {
			getDate(date) {
				return new Date(date).toLocaleString('ru', {year: 'numeric', month: 'long', day: 'numeric'}).slice(0, -2)
			},

			toggleOpen() {
				this.open = !this.open;
			},

			changeHelped(options) {
				const result = {...options};
				result.id = this.review.id;
				result.active = !options.active;
				if (options.active) {
					--result.count;
				} else {
					++result.count;
				}
				this.$emit('change-helped', result);
			},
		},
	};

	const _hoisted_1$1a = { class: "v-review-item review-item" };
	const _hoisted_2$14 = {
	  key: 0,
	  class: "review-item__wrapper"
	};
	const _hoisted_3$Y = { class: "review-item__header" };
	const _hoisted_4$N = { class: "review-item__header-main" };
	const _hoisted_5$I = {
	  key: 0,
	  class: "review-item__author"
	};
	const _hoisted_6$D = { class: "review-item__header-aside" };
	const _hoisted_7$x = {
	  key: 0,
	  class: "review-item__date"
	};
	const _hoisted_8$s = { class: "review-item__body" };
	const _hoisted_9$r = {
	  key: 0,
	  class: "review-item__title"
	};
	const _hoisted_10$n = /*#__PURE__*/createVNode("span", { class: "review-item__toggle-open" }, "Читать полностью", -1 /* HOISTED */);
	const _hoisted_11$m = /*#__PURE__*/createVNode("span", { class: "review-item__toggle-close" }, "Свернуть", -1 /* HOISTED */);
	const _hoisted_12$m = {
	  key: 0,
	  class: "review-item__footer"
	};
	const _hoisted_13$i = /*#__PURE__*/createVNode("div", { class: "review-item__note" }, "Вам помог отзыв?", -1 /* HOISTED */);
	const _hoisted_14$h = { class: "review-item__tools" };
	const _hoisted_15$f = /*#__PURE__*/createTextVNode("Да");
	const _hoisted_16$e = /*#__PURE__*/createTextVNode("Нет");
	const _hoisted_17$b = {
	  key: 1,
	  class: "review-item__answers"
	};
	const _hoisted_18$a = { class: "review-item__answer" };
	const _hoisted_19$8 = { class: "review-item__header" };
	const _hoisted_20$8 = { class: "review-item__header-main" };
	const _hoisted_21$8 = {
	  key: 0,
	  class: "review-item__author"
	};
	const _hoisted_22$7 = { class: "review-item__header-aside" };
	const _hoisted_23$6 = {
	  key: 0,
	  class: "review-item__date"
	};
	const _hoisted_24$5 = { class: "review-item__body" };
	const _hoisted_25$4 = {
	  key: 0,
	  class: "review-item__title"
	};
	const _hoisted_26$4 = {
	  key: 1,
	  class: "review-item__comment"
	};

	function render$1j(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_rating_action = resolveComponent("v-rating-action");

	  return (openBlock(), createBlock("article", _hoisted_1$1a, [
	    ($props.review)
	      ? (openBlock(), createBlock("div", _hoisted_2$14, [
	          createVNode("header", _hoisted_3$Y, [
	            createVNode("div", _hoisted_4$N, [
	              ($props.review.author)
	                ? (openBlock(), createBlock("div", _hoisted_5$I, toDisplayString($props.review.author), 1 /* TEXT */))
	                : createCommentVNode("v-if", true),
	              createVNode(_component_v_rating_action, { rating: $options.computedRating }, null, 8 /* PROPS */, ["rating"])
	            ]),
	            createVNode("div", _hoisted_6$D, [
	              ($props.review.date)
	                ? (openBlock(), createBlock("div", _hoisted_7$x, toDisplayString($props.review.date), 1 /* TEXT */))
	                : createCommentVNode("v-if", true)
	            ])
	          ]),
	          createVNode("div", _hoisted_8$s, [
	            ($props.review.title)
	              ? (openBlock(), createBlock("h5", _hoisted_9$r, toDisplayString($props.review.title), 1 /* TEXT */))
	              : createCommentVNode("v-if", true),
	            ($props.review.comment)
	              ? (openBlock(), createBlock("blockquote", {
	                  key: 1,
	                  class: ["review-item__comment", {'open': $data.open, 'init': $data.init}],
	                  ref: "comment"
	                }, toDisplayString($props.review.comment), 3 /* TEXT, CLASS */))
	              : createCommentVNode("v-if", true),
	            ($data.init)
	              ? (openBlock(), createBlock("button", {
	                  key: 2,
	                  class: ["review-item__toggle", {'open': $data.open, 'init': $data.init}],
	                  type: "button",
	                  onClick: _cache[1] || (_cache[1] = (...args) => ($options.toggleOpen && $options.toggleOpen(...args))),
	                  "aria-label": "Читать полностью",
	                  title: "Читать полностью"
	                }, [
	                  _hoisted_10$n,
	                  _hoisted_11$m
	                ], 2 /* CLASS */))
	              : createCommentVNode("v-if", true)
	          ]),
	          ($props.review.helped)
	            ? (openBlock(), createBlock("footer", _hoisted_12$m, [
	                _hoisted_13$i,
	                createVNode("div", _hoisted_14$h, [
	                  ($props.review.helped.yes)
	                    ? (openBlock(), createBlock("button", {
	                        key: 0,
	                        class: ["review-item__tools-btn btn btn--xs", [$props.review.helped.yes.active ? 'btn--primary' : 'btn--primary-gray']],
	                        type: "button",
	                        onClick: _cache[2] || (_cache[2] = $event => ($options.changeHelped($props.review.helped.yes))),
	                        "aria-label": "Да",
	                        title: "Да"
	                      }, [
	                        _hoisted_15$f,
	                        createVNode("span", null, toDisplayString($props.review.helped.yes.count), 1 /* TEXT */)
	                      ], 2 /* CLASS */))
	                    : createCommentVNode("v-if", true),
	                  ($props.review.helped.no)
	                    ? (openBlock(), createBlock("button", {
	                        key: 1,
	                        class: ["review-item__tools-btn btn btn--xs", [$props.review.helped.no.active ? 'btn--primary' : 'btn--primary-gray']],
	                        type: "button",
	                        onClick: _cache[3] || (_cache[3] = $event => ($options.changeHelped($props.review.helped.no))),
	                        "aria-label": "Нет",
	                        title: "Нет"
	                      }, [
	                        _hoisted_16$e,
	                        createVNode("span", null, toDisplayString($props.review.helped.no.count), 1 /* TEXT */)
	                      ], 2 /* CLASS */))
	                    : createCommentVNode("v-if", true)
	                ])
	              ]))
	            : createCommentVNode("v-if", true),
	          ($props.review.answers?.length)
	            ? (openBlock(), createBlock("div", _hoisted_17$b, [
	                (openBlock(true), createBlock(Fragment, null, renderList($props.review.answers, (answer) => {
	                  return (openBlock(), createBlock("div", _hoisted_18$a, [
	                    createVNode("div", _hoisted_19$8, [
	                      createVNode("div", _hoisted_20$8, [
	                        (answer.author)
	                          ? (openBlock(), createBlock("div", _hoisted_21$8, toDisplayString(answer.author), 1 /* TEXT */))
	                          : createCommentVNode("v-if", true)
	                      ]),
	                      createVNode("div", _hoisted_22$7, [
	                        (answer.date)
	                          ? (openBlock(), createBlock("div", _hoisted_23$6, toDisplayString(answer.date), 1 /* TEXT */))
	                          : createCommentVNode("v-if", true)
	                      ])
	                    ]),
	                    createVNode("div", _hoisted_24$5, [
	                      (answer.title)
	                        ? (openBlock(), createBlock("h5", _hoisted_25$4, toDisplayString(answer.title), 1 /* TEXT */))
	                        : createCommentVNode("v-if", true),
	                      (answer.comment)
	                        ? (openBlock(), createBlock("blockquote", _hoisted_26$4, toDisplayString(answer.comment), 1 /* TEXT */))
	                        : createCommentVNode("v-if", true)
	                    ])
	                  ]))
	                }), 256 /* UNKEYED_FRAGMENT */))
	              ]))
	            : createCommentVNode("v-if", true)
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1h.render = render$1j;
	script$1h.__file = "local/assets/source/components/v-review-item.vue";

	var script$1i = {
		mixins: [script$2],

		data() {
			return {
				list: null
			}
		},

		methods: {
			dataSet(data) {
				this.list = data;
			}
		},
	};

	const _hoisted_1$1b = { class: "v-shop-list shop-list" };
	const _hoisted_2$15 = {
	  key: 0,
	  class: "shop-list__list"
	};
	const _hoisted_3$Z = { class: "shop-list__item" };
	const _hoisted_4$O = {
	  key: 0,
	  class: "shop-list__name"
	};
	const _hoisted_5$J = {
	  key: 1,
	  class: "shop-list__address"
	};
	const _hoisted_6$E = {
	  key: 2,
	  class: "shop-list__statuses"
	};
	const _hoisted_7$y = {
	  key: 4,
	  class: "shop-list__metro"
	};
	const _hoisted_8$t = {
	  key: 5,
	  class: "shop-list__phones"
	};

	function render$1k(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$1b, [
	    ($data.list && $data.list.items?.length)
	      ? (openBlock(), createBlock("ul", _hoisted_2$15, [
	          (openBlock(true), createBlock(Fragment, null, renderList($data.list.items, (item) => {
	            return (openBlock(), createBlock("li", _hoisted_3$Z, [
	              (item.name)
	                ? (openBlock(), createBlock("div", _hoisted_4$O, toDisplayString(item.name), 1 /* TEXT */))
	                : createCommentVNode("v-if", true),
	              (item.address)
	                ? (openBlock(), createBlock("div", _hoisted_5$J, toDisplayString(item.address.text), 1 /* TEXT */))
	                : createCommentVNode("v-if", true),
	              (item.status?.length)
	                ? (openBlock(), createBlock("div", _hoisted_6$E, [
	                    (openBlock(true), createBlock(Fragment, null, renderList(item.status, (status) => {
	                      return (openBlock(), createBlock("div", {
	                        class: "shop-list__status",
	                        style: {color: status.color}
	                      }, toDisplayString(status.name), 5 /* TEXT, STYLE */))
	                    }), 256 /* UNKEYED_FRAGMENT */))
	                  ]))
	                : createCommentVNode("v-if", true),
	              (item.workTime)
	                ? (openBlock(), createBlock("div", {
	                    key: 3,
	                    class: "shop-list__work-time",
	                    innerHTML: item.workTime
	                  }, null, 8 /* PROPS */, ["innerHTML"]))
	                : createCommentVNode("v-if", true),
	              (item.metro)
	                ? (openBlock(), createBlock("div", _hoisted_7$y, toDisplayString(item.metro.text), 1 /* TEXT */))
	                : createCommentVNode("v-if", true),
	              (item.phones?.length)
	                ? (openBlock(), createBlock("div", _hoisted_8$t, [
	                    (openBlock(true), createBlock(Fragment, null, renderList(item.phones, (phone) => {
	                      return (openBlock(), createBlock("a", {
	                        class: "shop-list__phone",
	                        href: 'tel:' + phone.link
	                      }, toDisplayString(phone.text), 9 /* TEXT, PROPS */, ["href"]))
	                    }), 256 /* UNKEYED_FRAGMENT */))
	                  ]))
	                : createCommentVNode("v-if", true)
	            ]))
	          }), 256 /* UNKEYED_FRAGMENT */))
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1i.render = render$1k;
	script$1i.__file = "local/assets/source/components/v-shop-list.vue";

	var script$1j = {
		mixins: [script$2],
		props: {
			product: {
				type: Object,
				default: null
			},
			 
		},
		data() {
			return { 
				formData: null,
				localFormData: new FormData(),
			}
		},

		methods: {
			dataSet(data) {
				this.formData = data;
			},
		},
	};

	const _hoisted_1$1c = { class: "v-add-review add-review" };
	const _hoisted_2$16 = {
	  key: 0,
	  class: "add-review__wrapper"
	};
	const _hoisted_3$_ = {
	  key: 0,
	  class: "add-review__product"
	};
	const _hoisted_4$P = {
	  key: 0,
	  class: "add-review__visual"
	};
	const _hoisted_5$K = {
	  key: 1,
	  class: "add-review__visual"
	};
	const _hoisted_6$F = {
	  key: 2,
	  class: "add-review__name"
	};

	function render$1l(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_form = resolveComponent("v-form");

	  return (openBlock(), createBlock("div", _hoisted_1$1c, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.formData)
	      ? (openBlock(), createBlock("div", _hoisted_2$16, [
	          ($props.product)
	            ? (openBlock(), createBlock("div", _hoisted_3$_, [
	                ($props.product?.img)
	                  ? (openBlock(), createBlock("div", _hoisted_4$P, [
	                      createVNode("img", {
	                        src: $props.product.img,
	                        loading: "lazy",
	                        decoding: "async",
	                        alt: $props.product.name,
	                        title: $props.product.name
	                      }, null, 8 /* PROPS */, ["src", "alt", "title"])
	                    ]))
	                  : createCommentVNode("v-if", true),
	                ($props.product?.images?.length)
	                  ? (openBlock(), createBlock("div", _hoisted_5$K, [
	                      createVNode("img", {
	                        src: $props.product.images[0].small,
	                        loading: "lazy",
	                        decoding: "async",
	                        alt: $props.product.name,
	                        title: $props.product.name
	                      }, null, 8 /* PROPS */, ["src", "alt", "title"])
	                    ]))
	                  : createCommentVNode("v-if", true),
	                ($props.product?.name)
	                  ? (openBlock(), createBlock("div", _hoisted_6$F, toDisplayString($props.product.name), 1 /* TEXT */))
	                  : createCommentVNode("v-if", true)
	              ]))
	            : createCommentVNode("v-if", true),
	          createVNode(_component_v_form, {
	            bxajaxid: _ctx.bxajaxid,
	            "data-source": $data.formData
	          }, null, 8 /* PROPS */, ["bxajaxid", "data-source"]),
	           createCommentVNode("v-if", true)
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1j.render = render$1l;
	script$1j.__file = "local/assets/source/components/v-add-review.vue";

	var script$1k = {
		mixins: [script$2],

		data() {
			return {
				result: null
			}
		},

		methods: {
			dataSet(data) {
				this.result = data;
			},

			close() {
				if (this.result.success) {
					controller.closeAllModals();
				} else {
					controller.openAddReview();
				}
			},
		},
	};

	const _hoisted_1$1d = { class: "v-result-add-review result-add-review" };
	const _hoisted_2$17 = {
	  key: 0,
	  class: "result-add-review__wrapper"
	};
	const _hoisted_3$$ = {
	  key: 0,
	  class: "result-add-review__visual"
	};
	const _hoisted_4$Q = {
	  key: 1,
	  class: "result-add-review__title"
	};
	const _hoisted_5$L = {
	  key: 2,
	  class: "result-add-review__text"
	};
	const _hoisted_6$G = {
	  key: 3,
	  class: "result-add-review__action"
	};

	function render$1m(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$1d, [
	    ($data.result)
	      ? (openBlock(), createBlock("div", _hoisted_2$17, [
	          ($data.result?.img)
	            ? (openBlock(), createBlock("div", _hoisted_3$$, [
	                createVNode("img", {
	                  src: $data.result.img,
	                  loading: "lazy",
	                  decoding: "async",
	                  alt: $data.result.title,
	                  title: $data.result.title
	                }, null, 8 /* PROPS */, ["src", "alt", "title"])
	              ]))
	            : createCommentVNode("v-if", true),
	          ($data.result.title)
	            ? (openBlock(), createBlock("div", _hoisted_4$Q, toDisplayString($data.result.title), 1 /* TEXT */))
	            : createCommentVNode("v-if", true),
	          ($data.result.text)
	            ? (openBlock(), createBlock("div", _hoisted_5$L, toDisplayString($data.result.text), 1 /* TEXT */))
	            : createCommentVNode("v-if", true),
	          ($data.result.button)
	            ? (openBlock(), createBlock("div", _hoisted_6$G, [
	                createVNode("button", {
	                  class: ["btn", [$data.result.button.className]],
	                  onClick: _cache[1] || (_cache[1] = (...args) => ($options.close && $options.close(...args))),
	                  "aria-label": $data.result.button.text,
	                  title: $data.result.button.text
	                }, toDisplayString($data.result.button.text), 11 /* TEXT, CLASS, PROPS */, ["aria-label", "title"])
	              ]))
	            : createCommentVNode("v-if", true)
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1k.render = render$1m;
	script$1k.__file = "local/assets/source/components/v-result-add-review.vue";

	var script$1l = {
		mixins: [
			script$2,
		],

		data() {
			return {
				result: null,
				open: false,
			};
		},

		methods: {
			dataSet(data, options = {}) {
				this.result = data;
			},

			handler(nameMethod) {
				this[nameMethod]();
			},

			toggleAccordion() {
				this.open = !this.open;
			},

			async copy(text) {
				if (navigator.clipboard) {
					await navigator.clipboard.writeText(text);
				}
			}
		},
	};

	const _hoisted_1$1e = { class: "v-order-result order-result" };
	const _hoisted_2$18 = {
	  key: 0,
	  class: "container"
	};
	const _hoisted_3$10 = { class: "order-result__wrapper" };
	const _hoisted_4$R = {
	  key: 0,
	  class: "order-result__icon"
	};
	const _hoisted_5$M = { class: "svg-icon" };
	const _hoisted_6$H = {
	  key: 1,
	  class: "order-result__title h5"
	};
	const _hoisted_7$z = {
	  key: 0,
	  class: "order-result__order-header"
	};
	const _hoisted_8$u = /*#__PURE__*/createTextVNode("Заказ №");
	const _hoisted_9$s = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-copy" })
	], -1 /* HOISTED */);
	const _hoisted_10$o = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-down-2" })
	], -1 /* HOISTED */);
	const _hoisted_11$n = {
	  key: 0,
	  class: "order-result__order-body"
	};
	const _hoisted_12$n = { class: "order-result__group" };
	const _hoisted_13$j = {
	  key: 0,
	  class: "order-result__group-name"
	};
	const _hoisted_14$i = {
	  key: 1,
	  class: "order-result__props"
	};
	const _hoisted_15$g = { class: "order-result__prop" };
	const _hoisted_16$f = {
	  key: 0,
	  class: "order-result__prop-name"
	};
	const _hoisted_17$c = /*#__PURE__*/createTextVNode();
	const _hoisted_18$b = {
	  key: 1,
	  class: "order-result__prop-value"
	};
	const _hoisted_19$9 = {
	  key: 5,
	  class: "order-result__action"
	};

	function render$1n(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_collapse = resolveComponent("v-collapse");

	  return (openBlock(), createBlock("div", _hoisted_1$1e, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.result)
	      ? (openBlock(), createBlock("div", _hoisted_2$18, [
	          createVNode("div", _hoisted_3$10, [
	            ($data.result.icon)
	              ? (openBlock(), createBlock("div", _hoisted_4$R, [
	                  (openBlock(), createBlock("svg", _hoisted_5$M, [
	                    createVNode("use", {
	                      "xlink:href": '/local/assets/dist/icons/sprite.svg#svg-icon-' + $data.result.icon
	                    }, null, 8 /* PROPS */, ["xlink:href"])
	                  ]))
	                ]))
	              : createCommentVNode("v-if", true),
	            ($data.result.title)
	              ? (openBlock(), createBlock("div", _hoisted_6$H, toDisplayString($data.result.title), 1 /* TEXT */))
	              : createCommentVNode("v-if", true),
	            ($data.result.text)
	              ? (openBlock(), createBlock("div", {
	                  key: 2,
	                  class: "order-result__text",
	                  innerHTML: $data.result.text
	                }, null, 8 /* PROPS */, ["innerHTML"]))
	              : createCommentVNode("v-if", true),
	            ($data.result.order)
	              ? (openBlock(), createBlock("div", {
	                  key: 3,
	                  class: ["order-result__order", {'order-result__order--open': $data.open}]
	                }, [
	                  ($data.result.order.orderNumber)
	                    ? (openBlock(), createBlock("h1", _hoisted_7$z, [
	                        _hoisted_8$u,
	                        ($data.result.order.orderNumber)
	                          ? (openBlock(), createBlock("div", {
	                              key: 0,
	                              class: "order-result__order-number",
	                              onClick: _cache[1] || (_cache[1] = (...args) => ($options.toggleAccordion && $options.toggleAccordion(...args)))
	                            }, toDisplayString($data.result.order.orderNumber), 1 /* TEXT */))
	                          : createCommentVNode("v-if", true),
	                        createVNode("button", {
	                          class: "order-result__order-copy",
	                          onClick: _cache[2] || (_cache[2] = $event => ($options.copy($data.result.order.orderNumber))),
	                          type: "button",
	                          "aria-label": "Скопировать номер заказа",
	                          title: "Скопировать номер заказа"
	                        }, [
	                          _hoisted_9$s
	                        ]),
	                        createVNode("button", {
	                          class: "order-result__order-toggle",
	                          type: "button",
	                          onClick: _cache[3] || (_cache[3] = (...args) => ($options.toggleAccordion && $options.toggleAccordion(...args)))
	                        }, [
	                          _hoisted_10$o
	                        ])
	                      ]))
	                    : createCommentVNode("v-if", true),
	                  createVNode(_component_v_collapse, { open: $data.open }, {
	                    default: withCtx(() => [
	                      ($data.result.order?.info?.length)
	                        ? (openBlock(), createBlock("div", _hoisted_11$n, [
	                            (openBlock(true), createBlock(Fragment, null, renderList($data.result.order.info, (group) => {
	                              return (openBlock(), createBlock("div", _hoisted_12$n, [
	                                (group.name)
	                                  ? (openBlock(), createBlock("div", _hoisted_13$j, toDisplayString(group.name), 1 /* TEXT */))
	                                  : createCommentVNode("v-if", true),
	                                (group.props?.length)
	                                  ? (openBlock(), createBlock("div", _hoisted_14$i, [
	                                      (openBlock(true), createBlock(Fragment, null, renderList(group.props, (prop) => {
	                                        return (openBlock(), createBlock("div", _hoisted_15$g, [
	                                          (prop.name)
	                                            ? (openBlock(), createBlock("span", _hoisted_16$f, toDisplayString(prop.name), 1 /* TEXT */))
	                                            : createCommentVNode("v-if", true),
	                                          _hoisted_17$c,
	                                          (prop.value)
	                                            ? (openBlock(), createBlock("span", _hoisted_18$b, toDisplayString(prop.value), 1 /* TEXT */))
	                                            : createCommentVNode("v-if", true)
	                                        ]))
	                                      }), 256 /* UNKEYED_FRAGMENT */))
	                                    ]))
	                                  : createCommentVNode("v-if", true)
	                              ]))
	                            }), 256 /* UNKEYED_FRAGMENT */))
	                          ]))
	                        : createCommentVNode("v-if", true)
	                    ]),
	                    _: 1 /* STABLE */
	                  }, 8 /* PROPS */, ["open"])
	                ], 2 /* CLASS */))
	              : createCommentVNode("v-if", true),
	            ($data.result.payButton)
	              ? (openBlock(), createBlock("div", {
	                  key: 4,
	                  class: "order-result__action",
	                  innerHTML: $data.result.payButton
	                }, null, 8 /* PROPS */, ["innerHTML"]))
	              : createCommentVNode("v-if", true),
	            ($data.result.buttons?.length)
	              ? (openBlock(), createBlock("div", _hoisted_19$9, [
	                  (openBlock(true), createBlock(Fragment, null, renderList($data.result.buttons, (btn) => {
	                    return (openBlock(), createBlock(Fragment, null, [
	                      (btn.link)
	                        ? (openBlock(), createBlock("a", {
	                            key: 0,
	                            href: btn.link,
	                            "aria-label": btn.text,
	                            title: btn.text,
	                            class: [btn.className]
	                          }, toDisplayString(btn.text), 11 /* TEXT, CLASS, PROPS */, ["href", "aria-label", "title"]))
	                        : createCommentVNode("v-if", true),
	                      (btn.handler)
	                        ? (openBlock(), createBlock("button", {
	                            key: 1,
	                            onClick: $event => ($options.handler(btn.handler)),
	                            type: "button",
	                            "aria-label": btn.text,
	                            title: btn.text,
	                            class: [btn.className]
	                          }, toDisplayString(btn.text), 11 /* TEXT, CLASS, PROPS */, ["onClick", "aria-label", "title"]))
	                        : createCommentVNode("v-if", true)
	                    ], 64 /* STABLE_FRAGMENT */))
	                  }), 256 /* UNKEYED_FRAGMENT */))
	                ]))
	              : createCommentVNode("v-if", true)
	          ])
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1l.render = render$1n;
	script$1l.__file = "local/assets/source/components/v-order-result.vue";

	var script$1m = {

		mixins: [
			script$2,
		],

		data() {
			return {
				address: null,
			};
		},

		created() {
			controller.events.on('lk-edit-item', this.update);
		},

		methods: {
			dataSet(data, options = {}) {
				this.address = data;
			},
			update() {
				this.dataLoad({
					url: this.data.remote,
					delay: true,
					data: {
						bxajaxid: this.bxajaxid,
					}
				});
			},
			
		},
	};

	const _hoisted_1$1f = { class: "v-address-list address-list" };
	const _hoisted_2$19 = {
	  key: 0,
	  class: "address-list__wrapper"
	};
	const _hoisted_3$11 = {
	  key: 0,
	  class: "address-list__list"
	};
	const _hoisted_4$S = {
	  key: 0,
	  class: "address-list__icon"
	};
	const _hoisted_5$N = { class: "svg-icon" };
	const _hoisted_6$I = {
	  key: 1,
	  class: "address-list__name"
	};
	const _hoisted_7$A = /*#__PURE__*/createVNode("div", { class: "address-list__arrow" }, [
	  /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	    /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-text" })
	  ])
	], -1 /* HOISTED */);
	const _hoisted_8$v = {
	  key: 1,
	  class: "address-list__list"
	};
	const _hoisted_9$t = {
	  key: 2,
	  class: "address-list__action"
	};

	function render$1o(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$1f, [
	    ($data.address)
	      ? (openBlock(), createBlock("div", _hoisted_2$19, [
	          ($data.address.items?.length)
	            ? (openBlock(), createBlock("div", _hoisted_3$11, [
	                (openBlock(true), createBlock(Fragment, null, renderList($data.address.items, (item) => {
	                  return (openBlock(), createBlock("button", {
	                    class: "address-list__item js-open-modal",
	                    type: "button",
	                    "aria-label": item.name,
	                    title: item.name,
	                    "data-modal-data": "{\"className\": \"modal--sm\"}",
	                    "data-modal-url": item.editLink
	                  }, [
	                    (item.icon)
	                      ? (openBlock(), createBlock("div", _hoisted_4$S, [
	                          (openBlock(), createBlock("svg", _hoisted_5$N, [
	                            createVNode("use", {
	                              "xlink:href": '/local/assets/dist/icons/sprite.svg#svg-icon-' + item.icon
	                            }, null, 8 /* PROPS */, ["xlink:href"])
	                          ]))
	                        ]))
	                      : createCommentVNode("v-if", true),
	                    (item.name)
	                      ? (openBlock(), createBlock("div", _hoisted_6$I, toDisplayString(item.name), 1 /* TEXT */))
	                      : createCommentVNode("v-if", true),
	                    _hoisted_7$A
	                  ], 8 /* PROPS */, ["aria-label", "title", "data-modal-url"]))
	                }), 256 /* UNKEYED_FRAGMENT */))
	              ]))
	            : ($data.address.emptyText)
	              ? (openBlock(), createBlock("div", _hoisted_8$v, [
	                  createVNode("button", {
	                    class: "address-list__item",
	                    innerHTML: $data.address.emptyText
	                  }, null, 8 /* PROPS */, ["innerHTML"])
	                ]))
	              : createCommentVNode("v-if", true),
	          ($data.address.buttons?.length)
	            ? (openBlock(), createBlock("div", _hoisted_9$t, [
	                (openBlock(true), createBlock(Fragment, null, renderList($data.address.buttons, (btn) => {
	                  return (openBlock(), createBlock("button", {
	                    class: ["js-open-modal", [btn.className]],
	                    type: "button",
	                    "data-modal-data": "{\"className\": \"modal--sm\"}",
	                    "data-modal-url": btn.editLink,
	                    "aria-label": btn.text,
	                    title: btn.text
	                  }, toDisplayString(btn.text), 11 /* TEXT, CLASS, PROPS */, ["data-modal-url", "aria-label", "title"]))
	                }), 256 /* UNKEYED_FRAGMENT */))
	              ]))
	            : createCommentVNode("v-if", true)
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1m.render = render$1o;
	script$1m.__file = "local/assets/source/components/v-address-list.vue";

	var script$1n = {
		mixins: [
			script$2,
		],

		data() {
			return {
				orders: null,
				pages: null,
				order: null,
			}
		},

		created() {
			controller.events.on('order_list_update', this.update);
		},

		methods: {
			update(){
				this.resetOrder();
				this.dataLoad({
					url: this.orders.remote,
					delay: true,
					data: {
						bxajaxid: this.bxajaxid,
					}
				});
			},

			repeatOrder(){
				window.location.href=this.order.repeatLink;
			},

			setOrder(orderData){
				this.order = orderData;
				controller.scrollTop();
				return false;
			},

			resetOrder(){
				this.order = null;
			},
			dataSet(data, options = {}) {
				if (options.append && this.orders && this.orders.items) {
					let oldItems = this.orders.items;
					this.orders = data;
					this.orders.items = oldItems.concat(this.orders.items);
				} else {
					this.orders = data;
				}

				if (options.setPage) {
					controller.scrollTop();
				}

				this.pages = data.pages;
			},

			requestDataLoad(dataSetOptions) {
				if (this.loading) {
					return;
				}

				this.dataLoad({
					url: this.orders.remote,
					delay: true,
					data: {
						pages: this.pages,
					}
				}, dataSetOptions);
			},

			getDate(date) {
				return new Date(date).toLocaleString('ru', {year: 'numeric', month: 'numeric', day: 'numeric'})
			},

			navigate(pages) {
				this.pages.offset = pages.offset;
				this.pages.limit = pages.limit;
				this.requestDataLoad({append: pages.append, setPage: !pages.append});
			},

			async copy(text) {
				if (navigator.clipboard) {
					await navigator.clipboard.writeText(text);
				}
			},

			cancel() {
				controller.openModal({
					className: 'modal--sm',
					component: {
						name: 'v-cancel-order',
						props: {
							title: 'Отмена заказа'
						}
					}
				});
			},
		},
	};

	const _hoisted_1$1g = { class: "v-orders-history orders-history" };
	const _hoisted_2$1a = {
	  key: 1,
	  class: "orders-history__header"
	};
	const _hoisted_3$12 = { class: "h2" };
	const _hoisted_4$T = {
	  key: 2,
	  class: "orders-history__list"
	};
	const _hoisted_5$O = {
	  key: 0,
	  class: "orders-history__item-visual hidden-xs"
	};
	const _hoisted_6$J = { class: "orders-history__item-content" };
	const _hoisted_7$B = { class: "orders-history__item-header" };
	const _hoisted_8$w = { class: "orders-history__item-number h5" };
	const _hoisted_9$u = { class: "orders-history__item-price" };
	const _hoisted_10$p = { class: "orders-history__item-info" };
	const _hoisted_11$o = { class: "orders-history__item-status" };
	const _hoisted_12$o = {
	  key: 0,
	  class: "orders-history__item-tooltip"
	};
	const _hoisted_13$k = {
	  key: 1,
	  class: "orders-history__item-date"
	};
	const _hoisted_14$j = { key: 1 };
	const _hoisted_15$h = { class: "orders-history__item-footer" };
	const _hoisted_16$g = {
	  key: 0,
	  class: "orders-history__child-list"
	};
	const _hoisted_17$d = { class: "orders-history__item-action" };
	const _hoisted_18$c = { class: "orders-history__navigation" };
	const _hoisted_19$a = {
	  key: 1,
	  class: "container"
	};
	const _hoisted_20$9 = { class: "order-detail__back back-link" };
	const _hoisted_21$9 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-left-text" })
	], -1 /* HOISTED */);
	const _hoisted_22$8 = /*#__PURE__*/createVNode("span", null, "Все заказы", -1 /* HOISTED */);
	const _hoisted_23$7 = { class: "order-detail__wrapper" };
	const _hoisted_24$6 = { class: "order-detail__body" };
	const _hoisted_25$5 = { class: "order-detail__header" };
	const _hoisted_26$5 = { class: "order-detail__header-main" };
	const _hoisted_27$4 = { class: "order-detail__title h3" };
	const _hoisted_28$4 = /*#__PURE__*/createTextVNode("Заказ №");
	const _hoisted_29$4 = {
	  key: 0,
	  class: "order-detail__order-number"
	};
	const _hoisted_30$4 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-copy" })
	], -1 /* HOISTED */);
	const _hoisted_31$4 = {
	  key: 0,
	  class: "order-detail__text"
	};
	const _hoisted_32$4 = { class: "order-detail__header-aside" };
	const _hoisted_33$4 = { class: "order-detail__item-status" };
	const _hoisted_34$4 = {
	  key: 0,
	  class: "order-detail__item-tooltip"
	};
	const _hoisted_35$4 = {
	  key: 0,
	  class: "order-detail__groups"
	};
	const _hoisted_36$4 = { class: "order-detail__group" };
	const _hoisted_37$4 = {
	  key: 0,
	  class: "order-detail__group-name"
	};
	const _hoisted_38$4 = {
	  key: 0,
	  class: "svg-icon"
	};
	const _hoisted_39$4 = {
	  key: 1,
	  class: "order-detail__props"
	};
	const _hoisted_40$4 = { class: "order-detail__prop" };
	const _hoisted_41$4 = {
	  key: 0,
	  class: "order-detail__prop-name"
	};
	const _hoisted_42$4 = /*#__PURE__*/createTextVNode();
	const _hoisted_43$4 = {
	  key: 1,
	  class: "order-detail__prop-value"
	};
	const _hoisted_44$4 = /*#__PURE__*/createVNode("div", { class: "order-detail__list-title" }, "Состав заказа", -1 /* HOISTED */);
	const _hoisted_45$3 = {
	  key: 0,
	  class: "order-detail__list"
	};
	const _hoisted_46$3 = {
	  key: 1,
	  class: "order-detail__action"
	};
	const _hoisted_47$3 = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-refresh" })
	], -1 /* HOISTED */);

	function render$1p(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_picture = resolveComponent("v-picture");
	  const _component_v_price = resolveComponent("v-price");
	  const _component_v_status = resolveComponent("v-status");
	  const _component_v_tooltip = resolveComponent("v-tooltip");
	  const _component_v_page_nav = resolveComponent("v-page-nav");
	  const _component_v_order_product = resolveComponent("v-order-product");

	  return (openBlock(), createBlock("div", _hoisted_1$1g, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.orders && !$data.order)
	      ? (openBlock(), createBlock("div", {
	          class: "container",
	          key: $data.orders.time
	        }, [
	          (!$data.orders.items || !$data.orders.items.length)
	            ? (openBlock(), createBlock("div", {
	                key: 0,
	                class: "empty-order-list",
	                innerHTML: $data.orders.message
	              }, null, 8 /* PROPS */, ["innerHTML"]))
	            : createCommentVNode("v-if", true),
	          ($data.orders.items?.length && $data.orders.title)
	            ? (openBlock(), createBlock("div", _hoisted_2$1a, [
	                createVNode("h1", _hoisted_3$12, toDisplayString($data.orders.title), 1 /* TEXT */)
	              ]))
	            : createCommentVNode("v-if", true),
	          ($data.orders.items?.length)
	            ? (openBlock(), createBlock("div", _hoisted_4$T, [
	                (openBlock(true), createBlock(Fragment, null, renderList($data.orders.items, (item) => {
	                  return (openBlock(), createBlock("div", {
	                    class: "orders-history__item",
	                    key: item.id
	                  }, [
	                    createVNode("span", {
	                      class: "link orders-history__item-link",
	                      onClick: $event => ($options.setOrder(item))
	                    }, null, 8 /* PROPS */, ["onClick"]),
	                    (item.items?.length && item)
	                      ? (openBlock(), createBlock("div", _hoisted_5$O, [
	                          createVNode(_component_v_picture, {
	                            sources: item.items[0].images[0]
	                          }, null, 8 /* PROPS */, ["sources"])
	                        ]))
	                      : createCommentVNode("v-if", true),
	                    createVNode("div", _hoisted_6$J, [
	                      createVNode("div", _hoisted_7$B, [
	                        createVNode("div", _hoisted_8$w, "№" + toDisplayString(item.number), 1 /* TEXT */),
	                        createVNode("div", _hoisted_9$u, [
	                          createVNode(_component_v_price, {
	                            price: item.price
	                          }, null, 8 /* PROPS */, ["price"])
	                        ])
	                      ]),
	                      createVNode("div", _hoisted_10$p, [
	                        createVNode("div", _hoisted_11$o, [
	                          createVNode(_component_v_status, {
	                            class: "status--middle",
	                            status: [item.status]
	                          }, null, 8 /* PROPS */, ["status"])
	                        ]),
	                        (item.tooltip)
	                          ? (openBlock(), createBlock("div", _hoisted_12$o, [
	                              createVNode(_component_v_tooltip, {
	                                tooltip: item.tooltip
	                              }, null, 8 /* PROPS */, ["tooltip"])
	                            ]))
	                          : createCommentVNode("v-if", true),
	                        (item.date)
	                          ? (openBlock(), createBlock("div", _hoisted_13$k, [
	                              (item.date.order)
	                                ? (openBlock(), createBlock("time", {
	                                    key: 0,
	                                    datetime: item.date.order
	                                  }, toDisplayString(item.date.order), 9 /* TEXT, PROPS */, ["datetime"]))
	                                : createCommentVNode("v-if", true),
	                              (item.date.pay)
	                                ? (openBlock(), createBlock("span", _hoisted_14$j, " — "))
	                                : createCommentVNode("v-if", true),
	                              (item.date.pay)
	                                ? (openBlock(), createBlock("time", {
	                                    key: 2,
	                                    datetime: item.date.pay
	                                  }, toDisplayString(item.date.pay), 9 /* TEXT, PROPS */, ["datetime"]))
	                                : createCommentVNode("v-if", true)
	                            ]))
	                          : createCommentVNode("v-if", true)
	                      ]),
	                      createVNode("div", _hoisted_15$h, [
	                        (item.items?.length)
	                          ? (openBlock(), createBlock("div", _hoisted_16$g, [
	                              (openBlock(true), createBlock(Fragment, null, renderList(item.items, (child) => {
	                                return (openBlock(), createBlock("div", {
	                                  class: "orders-history__child-item",
	                                  key: child.id
	                                }, [
	                                  createVNode(_component_v_picture, {
	                                    sources: child.images[0]
	                                  }, null, 8 /* PROPS */, ["sources"])
	                                ]))
	                              }), 128 /* KEYED_FRAGMENT */))
	                            ]))
	                          : createCommentVNode("v-if", true),
	                        createVNode("div", _hoisted_17$d, [
	                          createVNode("button", {
	                            class: "hidden-xs btn btn--primary",
	                            onClick: $event => ($options.setOrder(item)),
	                            "aria-label": "Подробнее о заказе",
	                            title: "Подробнее о заказе"
	                          }, "Подробнее о заказе", 8 /* PROPS */, ["onClick"])
	                        ])
	                      ])
	                    ])
	                  ]))
	                }), 128 /* KEYED_FRAGMENT */)),
	                createVNode("div", _hoisted_18$c, [
	                  createVNode(_component_v_page_nav, {
	                    pages: $data.orders.pages,
	                    onNavigate: $options.navigate
	                  }, null, 8 /* PROPS */, ["pages", "onNavigate"])
	                ])
	              ]))
	            : createCommentVNode("v-if", true)
	        ]))
	      : createCommentVNode("v-if", true),
	    ($data.order)
	      ? (openBlock(), createBlock("div", _hoisted_19$a, [
	          createVNode("div", _hoisted_20$9, [
	            createVNode("button", {
	              class: "back-link__link",
	              onClick: _cache[1] || (_cache[1] = (...args) => ($options.resetOrder && $options.resetOrder(...args)))
	            }, [
	              _hoisted_21$9,
	              _hoisted_22$8
	            ])
	          ]),
	          createVNode("div", _hoisted_23$7, [
	            createVNode("div", _hoisted_24$6, [
	              createVNode("div", _hoisted_25$5, [
	                createVNode("div", _hoisted_26$5, [
	                  createVNode("h1", _hoisted_27$4, [
	                    _hoisted_28$4,
	                    ($data.order.number)
	                      ? (openBlock(), createBlock("span", _hoisted_29$4, toDisplayString($data.order.number), 1 /* TEXT */))
	                      : createCommentVNode("v-if", true),
	                    createVNode("button", {
	                      class: "order-detail__order-copy",
	                      onClick: _cache[2] || (_cache[2] = $event => ($options.copy($data.order.number))),
	                      type: "button",
	                      "aria-label": "Скопировать номер заказа",
	                      title: "Скопировать номер заказа"
	                    }, [
	                      _hoisted_30$4
	                    ])
	                  ]),
	                  ($data.order.cancel)
	                    ? (openBlock(), createBlock("div", _hoisted_31$4, [
	                        createTextVNode(toDisplayString($data.order.text) + " ", 1 /* TEXT */),
	                        createVNode("button", {
	                          class: "order-detail__cancel js-open-modal",
	                          type: "button",
	                          "data-modal-data": "{\"className\": \"modal--sm\"}",
	                          "data-modal-url": $data.order.cancelOrder,
	                          "aria-label": "отменить заказ",
	                          title: "отменить заказ"
	                        }, "отменить заказ", 8 /* PROPS */, ["data-modal-url"])
	                      ]))
	                    : createCommentVNode("v-if", true)
	                ]),
	                createVNode("div", _hoisted_32$4, [
	                  createVNode("div", _hoisted_33$4, [
	                    createVNode(_component_v_status, {
	                      class: "status--middle",
	                      status: [$data.order.status]
	                    }, null, 8 /* PROPS */, ["status"])
	                  ]),
	                  ($data.order.tooltip)
	                    ? (openBlock(), createBlock("div", _hoisted_34$4, [
	                        createVNode(_component_v_tooltip, {
	                          tooltip: $data.order.tooltip
	                        }, null, 8 /* PROPS */, ["tooltip"])
	                      ]))
	                    : createCommentVNode("v-if", true)
	                ])
	              ]),
	              ($data.order?.info?.length)
	                ? (openBlock(), createBlock("div", _hoisted_35$4, [
	                    (openBlock(true), createBlock(Fragment, null, renderList($data.order.info, (group) => {
	                      return (openBlock(), createBlock("div", _hoisted_36$4, [
	                        (group.name)
	                          ? (openBlock(), createBlock("div", _hoisted_37$4, [
	                              (group.icon)
	                                ? (openBlock(), createBlock("div", _hoisted_38$4, [
	                                    createVNode("img", {
	                                      src: group.icon,
	                                      loading: "lazy",
	                                      decoding: "async",
	                                      alt: "",
	                                      title: ""
	                                    }, null, 8 /* PROPS */, ["src"])
	                                  ]))
	                                : createCommentVNode("v-if", true),
	                              createVNode("span", null, toDisplayString(group.name), 1 /* TEXT */)
	                            ]))
	                          : createCommentVNode("v-if", true),
	                        (group.props?.length)
	                          ? (openBlock(), createBlock("div", _hoisted_39$4, [
	                              (openBlock(true), createBlock(Fragment, null, renderList(group.props, (prop) => {
	                                return (openBlock(), createBlock("div", _hoisted_40$4, [
	                                  (prop.name)
	                                    ? (openBlock(), createBlock("span", _hoisted_41$4, toDisplayString(prop.name), 1 /* TEXT */))
	                                    : createCommentVNode("v-if", true),
	                                  _hoisted_42$4,
	                                  (prop.value)
	                                    ? (openBlock(), createBlock("span", _hoisted_43$4, toDisplayString(prop.value), 1 /* TEXT */))
	                                    : createCommentVNode("v-if", true)
	                                ]))
	                              }), 256 /* UNKEYED_FRAGMENT */))
	                            ]))
	                          : createCommentVNode("v-if", true)
	                      ]))
	                    }), 256 /* UNKEYED_FRAGMENT */))
	                  ]))
	                : createCommentVNode("v-if", true)
	            ]),
	            _hoisted_44$4,
	            ($data.order.items?.length)
	              ? (openBlock(), createBlock("ul", _hoisted_45$3, [
	                  (openBlock(true), createBlock(Fragment, null, renderList($data.order.items, (item) => {
	                    return (openBlock(), createBlock("li", {
	                      class: "order-detail__item",
	                      key: item.id
	                    }, [
	                      createVNode(_component_v_order_product, { product: item }, null, 8 /* PROPS */, ["product"])
	                    ]))
	                  }), 128 /* KEYED_FRAGMENT */))
	                ]))
	              : createCommentVNode("v-if", true),
	            ($data.order.repeatLink)
	              ? (openBlock(), createBlock("div", _hoisted_46$3, [
	                  createVNode("button", {
	                    class: "btn btn btn--primary-red",
	                    onClick: _cache[3] || (_cache[3] = (...args) => ($options.repeatOrder && $options.repeatOrder(...args)))
	                  }, [
	                    createVNode("span", null, toDisplayString($data.order.repeatButton?  $data.order.repeatButton :'Повторить весь заказ'), 1 /* TEXT */),
	                    _hoisted_47$3
	                  ])
	                ]))
	              : createCommentVNode("v-if", true)
	          ])
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1n.render = render$1p;
	script$1n.__file = "local/assets/source/components/v-orders-history.vue";

	var script$1o = {
		props: {
			product: {
				type: Object,
				default: null
			},
		},
		methods: {
			openAddReview() {
				controller.openModal({
					className: 'modal--sm',
					component: {
						name: 'v-add-review',
						props: {
							bxajaxid:'review-add-form',
							product:this.product,
							dataSource: this.product.newReviewLink,
							title: 'Новый отзыв'
						}
					}
				});
			},
		},
	};

	const _hoisted_1$1h = { class: "v-order-product order-product" };
	const _hoisted_2$1b = { class: "order-product__wrapper" };
	const _hoisted_3$13 = { class: "order-product__content" };
	const _hoisted_4$U = {
	  key: 0,
	  class: "order-product__price"
	};
	const _hoisted_5$P = {
	  key: 0,
	  class: "order-product__brand"
	};
	const _hoisted_6$K = {
	  key: 1,
	  class: "order-product__code"
	};
	const _hoisted_7$C = {
	  key: 2,
	  class: "order-product__props"
	};
	const _hoisted_8$x = { class: "order-product__prop" };
	const _hoisted_9$v = {
	  key: 0,
	  class: "order-product__prop-icon"
	};
	const _hoisted_10$q = {
	  key: 1,
	  class: "order-product__prop-name"
	};
	const _hoisted_11$p = /*#__PURE__*/createVNode("div", { class: "order-product__prop-separator" }, null, -1 /* HOISTED */);
	const _hoisted_12$p = {
	  key: 2,
	  class: "order-product__prop-value"
	};
	const _hoisted_13$l = { class: "order-product__action" };

	function render$1q(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_picture = resolveComponent("v-picture");
	  const _component_v_price = resolveComponent("v-price");

	  return (openBlock(), createBlock("div", _hoisted_1$1h, [
	    createVNode("div", _hoisted_2$1b, [
	      createVNode("a", {
	        class: "order-product__visual",
	        href: $props.product.link
	      }, [
	        createVNode(_component_v_picture, {
	          sources: $props.product.imageSources
	        }, null, 8 /* PROPS */, ["sources"])
	      ], 8 /* PROPS */, ["href"]),
	      createVNode("div", _hoisted_3$13, [
	        ($props.product.price)
	          ? (openBlock(), createBlock("div", _hoisted_4$U, [
	              createVNode(_component_v_price, {
	                price: $props.product.price
	              }, null, 8 /* PROPS */, ["price"])
	            ]))
	          : createCommentVNode("v-if", true),
	        ($props.product.name)
	          ? (openBlock(), createBlock("a", {
	              key: 1,
	              class: "order-product__name",
	              href: $props.product.link
	            }, [
	              ($props.product.brand?.text)
	                ? (openBlock(), createBlock("span", _hoisted_5$P, toDisplayString($props.product.brand.text), 1 /* TEXT */))
	                : createCommentVNode("v-if", true),
	              createTextVNode(" " + toDisplayString($props.product.name), 1 /* TEXT */),
	              ($props.product.code)
	                ? (openBlock(), createBlock("span", _hoisted_6$K, "артикул: " + toDisplayString($props.product.code), 1 /* TEXT */))
	                : createCommentVNode("v-if", true)
	            ], 8 /* PROPS */, ["href"]))
	          : createCommentVNode("v-if", true),
	        ($props.product?.props?.length)
	          ? (openBlock(), createBlock("div", _hoisted_7$C, [
	              (openBlock(true), createBlock(Fragment, null, renderList($props.product.props, (prop) => {
	                return (openBlock(), createBlock("div", _hoisted_8$x, [
	                  (prop.icon)
	                    ? (openBlock(), createBlock("div", _hoisted_9$v, [
	                        createVNode("img", {
	                          src: prop.icon,
	                          loading: "lazy",
	                          decoding: "async",
	                          alt: prop.name,
	                          title: prop.name
	                        }, null, 8 /* PROPS */, ["src", "alt", "title"])
	                      ]))
	                    : createCommentVNode("v-if", true),
	                  (prop.name)
	                    ? (openBlock(), createBlock("div", _hoisted_10$q, toDisplayString(prop.name), 1 /* TEXT */))
	                    : createCommentVNode("v-if", true),
	                  _hoisted_11$p,
	                  (prop.value)
	                    ? (openBlock(), createBlock("div", _hoisted_12$p, toDisplayString(prop.value), 1 /* TEXT */))
	                    : createCommentVNode("v-if", true)
	                ]))
	              }), 256 /* UNKEYED_FRAGMENT */))
	            ]))
	          : createCommentVNode("v-if", true)
	      ])
	    ]),
	    createVNode("div", _hoisted_13$l, [
	      createVNode("button", {
	        class: "order-product__btn btn btn--primary-gray btn--full",
	        onClick: _cache[1] || (_cache[1] = (...args) => ($options.openAddReview && $options.openAddReview(...args))),
	        title: "Написать отзыв"
	      }, "Написать отзыв")
	    ])
	  ]))
	}

	script$1o.render = render$1q;
	script$1o.__file = "local/assets/source/components/v-order-product.vue";

	var script$1p = {
		mixins: [
			script$2,
		],

		data() {
			return {
				subscribtion: null,
				localFormData: new FormData
			};
		},

		methods: {
			dataSet(data, options = {}) {

				this.subscribtion = data;
			},

			subscribe(item) {
				this.localFormData.set(item.name,(item.value? 1 : 0));

				this.localFormData.set('action', 'subscribe-update');
				this.localFormData.set('bxajaxid', this.bxajaxid);
				this.localFormData.set('rubric', item.id);


				this.dataLoad({
					url: this.subscribtion.remote,
					delay: true,
					data: this.localFormData
				});
			},

			removeItem(item) {

				this.dataLoad({
					url: this.subscribtion.remote,
					delay: true,
					data: {
							bxajaxid: this.bxajaxid,
							'subscribe_type_del': item.subscribeType,
							'subscribe_product_del': item.subscribeId}
				});
			},
		},
	};

	const _hoisted_1$1i = { class: "v-subscribtion subscribtion" };
	const _hoisted_2$1c = {
	  key: 0,
	  class: "container"
	};
	const _hoisted_3$14 = { class: "subscribtion__header" };
	const _hoisted_4$V = {
	  key: 0,
	  class: "page-title"
	};
	const _hoisted_5$Q = { class: "h2 page-title__value" };
	const _hoisted_6$L = { class: "subscribtion__layout" };
	const _hoisted_7$D = { class: "subscribtion__main" };
	const _hoisted_8$y = { class: "subscribtion__panel" };
	const _hoisted_9$w = { class: "subscribtion__form" };
	const _hoisted_10$r = { class: "subscribtion__field" };
	const _hoisted_11$q = {
	  key: 0,
	  class: "subscribtion__label"
	};
	const _hoisted_12$q = {
	  key: 1,
	  class: "subscribtion__email"
	};
	const _hoisted_13$m = {
	  key: 0,
	  class: "subscribtion__input"
	};
	const _hoisted_14$k = { class: "subscribtion__products" };
	const _hoisted_15$i = {
	  key: 0,
	  class: "subscribtion__products-title h4"
	};
	const _hoisted_16$h = { class: "subscribtion__list" };
	const _hoisted_17$e = { class: "subscribtion__cell subscribtion__cell--empty" };

	function render$1r(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_field = resolveComponent("v-field");
	  const _component_v_subscribtion_item = resolveComponent("v-subscribtion-item");

	  return (openBlock(), createBlock("section", _hoisted_1$1i, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.subscribtion)
	      ? (openBlock(), createBlock("div", _hoisted_2$1c, [
	          ($data.subscribtion.subscribeProducts?.length || $data.subscribtion.subscribe?.length)
	            ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	                createVNode("div", _hoisted_3$14, [
	                  ($data.subscribtion.title)
	                    ? (openBlock(), createBlock("div", _hoisted_4$V, [
	                        createVNode("h1", _hoisted_5$Q, toDisplayString($data.subscribtion.title), 1 /* TEXT */)
	                      ]))
	                    : createCommentVNode("v-if", true)
	                ]),
	                createVNode("div", _hoisted_6$L, [
	                  createVNode("div", _hoisted_7$D, [
	                    ($data.subscribtion.subscribe?.length)
	                      ? (openBlock(true), createBlock(Fragment, { key: 0 }, renderList($data.subscribtion.subscribe, (item) => {
	                          return (openBlock(), createBlock("div", _hoisted_8$y, [
	                            (item.text)
	                              ? (openBlock(), createBlock("div", {
	                                  key: 0,
	                                  class: "subscribtion__text",
	                                  style: {background: item.background}
	                                }, toDisplayString(item.text), 5 /* TEXT, STYLE */))
	                              : createCommentVNode("v-if", true),
	                            createVNode("div", _hoisted_9$w, [
	                              createVNode("div", _hoisted_10$r, [
	                                (item.label)
	                                  ? (openBlock(), createBlock("div", _hoisted_11$q, toDisplayString(item.label), 1 /* TEXT */))
	                                  : createCommentVNode("v-if", true),
	                                (item.email)
	                                  ? (openBlock(), createBlock("div", _hoisted_12$q, toDisplayString(item.email), 1 /* TEXT */))
	                                  : createCommentVNode("v-if", true)
	                              ]),
	                              (item.field)
	                                ? (openBlock(), createBlock("div", _hoisted_13$m, [
	                                    createVNode(_component_v_field, {
	                                      field: item.field,
	                                      modelValue: item.field.value,
	                                      "onUpdate:modelValue": [$event => (item.field.value = $event), $event => ($options.subscribe(item.field))]
	                                    }, null, 8 /* PROPS */, ["field", "modelValue", "onUpdate:modelValue"])
	                                  ]))
	                                : createCommentVNode("v-if", true)
	                            ])
	                          ]))
	                        }), 256 /* UNKEYED_FRAGMENT */))
	                      : createCommentVNode("v-if", true),
	                    ($data.subscribtion.subscribeProducts?.length)
	                      ? (openBlock(true), createBlock(Fragment, { key: 1 }, renderList($data.subscribtion.subscribeProducts, (productSubscr) => {
	                          return (openBlock(), createBlock("div", _hoisted_14$k, [
	                            (productSubscr.title)
	                              ? (openBlock(), createBlock("div", _hoisted_15$i, toDisplayString(productSubscr.title), 1 /* TEXT */))
	                              : createCommentVNode("v-if", true),
	                            createVNode("div", _hoisted_16$h, [
	                              (openBlock(true), createBlock(Fragment, null, renderList(productSubscr.items, (item) => {
	                                return (openBlock(), createBlock("div", {
	                                  class: "subscribtion__cell",
	                                  key: item.id
	                                }, [
	                                  createVNode(_component_v_subscribtion_item, {
	                                    product: item,
	                                    onRemove: $event => ($options.removeItem(item))
	                                  }, null, 8 /* PROPS */, ["product", "onRemove"])
	                                ]))
	                              }), 128 /* KEYED_FRAGMENT */)),
	                              (openBlock(), createBlock(Fragment, null, renderList(2, (empty) => {
	                                return createVNode("div", _hoisted_17$e)
	                              }), 64 /* STABLE_FRAGMENT */))
	                            ])
	                          ]))
	                        }), 256 /* UNKEYED_FRAGMENT */))
	                      : createCommentVNode("v-if", true)
	                  ])
	                ])
	              ], 64 /* STABLE_FRAGMENT */))
	            : createCommentVNode("v-if", true)
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1p.render = render$1r;
	script$1p.__file = "local/assets/source/components/v-subscribtion.vue";

	var script$1q = {
		props: {
			product: {
				type: Object,
				default: null
			},
		},

		emits: [
			'remove'
		],

		data() {
			return {
				loading: false
			}
		},

		methods: {
			remove() {
				this.$emit('remove', this.product.id);
			},

			addToBasket() {
				this.loading = true;
				this.$store.dispatch('basket/add', {
					id: this.product.id,
					count: 1
				}).then(() => {
					setTimeout(() => {
						this.loading = false;
					}, 300);
				});
			},
		},
	};

	const _hoisted_1$1j = { class: "v-subscribtion-item subscribtion-item" };
	const _hoisted_2$1d = { class: "subscribtion-item__wrapper" };
	const _hoisted_3$15 = { class: "subscribtion-item__content" };
	const _hoisted_4$W = {
	  key: 0,
	  class: "subscribtion-item__price"
	};
	const _hoisted_5$R = {
	  key: 0,
	  class: "subscribtion-item__brand"
	};
	const _hoisted_6$M = {
	  key: 2,
	  class: "subscribtion-item__props"
	};
	const _hoisted_7$E = { class: "subscribtion-item__prop" };
	const _hoisted_8$z = {
	  key: 0,
	  class: "subscribtion-item__prop-icon"
	};
	const _hoisted_9$x = {
	  key: 1,
	  class: "subscribtion-item__prop-name"
	};
	const _hoisted_10$s = /*#__PURE__*/createVNode("div", { class: "subscribtion-item__prop-separator" }, null, -1 /* HOISTED */);
	const _hoisted_11$r = {
	  key: 2,
	  class: "subscribtion-item__prop-value"
	};
	const _hoisted_12$r = {
	  key: 0,
	  class: "subscribtion-item__action"
	};

	function render$1s(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_picture = resolveComponent("v-picture");
	  const _component_v_price = resolveComponent("v-price");
	  const _component_v_loader = resolveComponent("v-loader");

	  return (openBlock(), createBlock("div", _hoisted_1$1j, [
	    createVNode("div", _hoisted_2$1d, [
	      createVNode("button", {
	        class: "subscribtion-item__remove",
	        type: "button",
	        onClick: _cache[1] || (_cache[1] = (...args) => ($options.remove && $options.remove(...args))),
	        "aria-label": "Удалить подписку",
	        title: "Удалить подписку"
	      }),
	      createVNode("a", {
	        class: "subscribtion-item__visual",
	        href: $props.product.link
	      }, [
	        createVNode(_component_v_picture, {
	          sources: $props.product.imageSources
	        }, null, 8 /* PROPS */, ["sources"])
	      ], 8 /* PROPS */, ["href"]),
	      createVNode("div", _hoisted_3$15, [
	        ($props.product.price)
	          ? (openBlock(), createBlock("div", _hoisted_4$W, [
	              createVNode(_component_v_price, {
	                price: $props.product.price
	              }, null, 8 /* PROPS */, ["price"])
	            ]))
	          : createCommentVNode("v-if", true),
	        ($props.product.name)
	          ? (openBlock(), createBlock("a", {
	              key: 1,
	              class: "subscribtion-item__name",
	              href: $props.product.link
	            }, [
	              ($props.product.brand?.text)
	                ? (openBlock(), createBlock("span", _hoisted_5$R, toDisplayString($props.product.brand.text), 1 /* TEXT */))
	                : createCommentVNode("v-if", true),
	              createTextVNode(" " + toDisplayString($props.product.name), 1 /* TEXT */)
	            ], 8 /* PROPS */, ["href"]))
	          : createCommentVNode("v-if", true),
	        ($props.product?.props?.length)
	          ? (openBlock(), createBlock("div", _hoisted_6$M, [
	              (openBlock(true), createBlock(Fragment, null, renderList($props.product.props, (prop) => {
	                return (openBlock(), createBlock("div", _hoisted_7$E, [
	                  (prop.icon)
	                    ? (openBlock(), createBlock("div", _hoisted_8$z, [
	                        createVNode("img", {
	                          src: prop.icon,
	                          loading: "lazy",
	                          decoding: "async",
	                          alt: prop.name,
	                          title: prop.name
	                        }, null, 8 /* PROPS */, ["src", "alt", "title"])
	                      ]))
	                    : createCommentVNode("v-if", true),
	                  (prop.name)
	                    ? (openBlock(), createBlock("div", _hoisted_9$x, toDisplayString(prop.name), 1 /* TEXT */))
	                    : createCommentVNode("v-if", true),
	                  _hoisted_10$s,
	                  (prop.value)
	                    ? (openBlock(), createBlock("div", _hoisted_11$r, toDisplayString(prop.value), 1 /* TEXT */))
	                    : createCommentVNode("v-if", true)
	                ]))
	              }), 256 /* UNKEYED_FRAGMENT */))
	            ]))
	          : createCommentVNode("v-if", true),
	        ($props.product.availability.value)
	          ? (openBlock(), createBlock("div", {
	              key: 3,
	              class: ["subscribtion-item__availability", {'subscribtion-item__availability--available': $props.product.availability.value === 'available'}]
	            }, toDisplayString($props.product.availability.text), 3 /* TEXT, CLASS */))
	          : createCommentVNode("v-if", true)
	      ])
	    ]),
	    ($props.product.availability.value === 'available')
	      ? (openBlock(), createBlock("div", _hoisted_12$r, [
	          createVNode(_component_v_loader, { loading: $data.loading }, null, 8 /* PROPS */, ["loading"]),
	          createVNode("button", {
	            class: "subscribtion-item__btn btn btn--primary btn--full",
	            type: "button",
	            onClick: _cache[2] || (_cache[2] = (...args) => ($options.addToBasket && $options.addToBasket(...args))),
	            title: "В корзину"
	          }, "В корзину")
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1q.render = render$1s;
	script$1q.__file = "local/assets/source/components/v-subscribtion-item.vue";

	var script$1r = {
		mixins: [
			script$2
		],

		data() {
			return {
				favorite: null,
			};
		},

		created() {
			controller.events.on('remove-favorite', (productId) => {
				this.requestDataLoad(productId);
			});
		},

		methods: {
			dataSet(data) {
				this.favorite = data;
			},

			requestDataLoad(productId) {
				this.dataLoad({
					url: this.favorite.remote,
					delay: true,
					data: {
						action: 'remove-favorite',
						id: productId
					}
				});
			},
		}
	};

	const _hoisted_1$1k = { class: "v-favorite favorite" };
	const _hoisted_2$1e = { class: "container" };
	const _hoisted_3$16 = { class: "favorite__header" };
	const _hoisted_4$X = {
	  key: 0,
	  class: "page-title"
	};
	const _hoisted_5$S = { class: "h2 page-title__value" };
	const _hoisted_6$N = {
	  class: "favorite__list flc",
	  ref: "products"
	};
	const _hoisted_7$F = {
	  key: 1,
	  class: "favorite__empty"
	};
	const _hoisted_8$A = {
	  key: 0,
	  class: "favorite__empty-img"
	};
	const _hoisted_9$y = {
	  key: 1,
	  class: "favorite__empty-title h4"
	};
	const _hoisted_10$t = {
	  key: 2,
	  class: "favorite__empty-text"
	};
	const _hoisted_11$s = {
	  key: 3,
	  class: "favorite__empty-action"
	};

	function render$1t(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_product_grid = resolveComponent("v-product-grid");

	  return (openBlock(), createBlock("section", _hoisted_1$1k, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    createVNode("div", _hoisted_2$1e, [
	      ($data.favorite)
	        ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	            ($data.favorite.items?.length)
	              ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	                  createVNode("div", _hoisted_3$16, [
	                    ($data.favorite.title)
	                      ? (openBlock(), createBlock("div", _hoisted_4$X, [
	                          createVNode("h1", _hoisted_5$S, toDisplayString($data.favorite.title), 1 /* TEXT */)
	                        ]))
	                      : createCommentVNode("v-if", true)
	                  ]),
	                  createVNode("div", _hoisted_6$N, [
	                    createVNode(Transition, {
	                      name: "fade",
	                      mode: "out-in"
	                    }, {
	                      default: withCtx(() => [
	                        createVNode(_component_v_product_grid, {
	                          items: $data.favorite.items,
	                          discount: $data.favorite.discountList
	                        }, null, 8 /* PROPS */, ["items", "discount"])
	                      ]),
	                      _: 1 /* STABLE */
	                    })
	                  ], 512 /* NEED_PATCH */)
	                ], 64 /* STABLE_FRAGMENT */))
	              : ($data.favorite.empty)
	                ? (openBlock(), createBlock("div", _hoisted_7$F, [
	                    ($data.favorite.empty.img)
	                      ? (openBlock(), createBlock("div", _hoisted_8$A, [
	                          createVNode("img", {
	                            src: $data.favorite.empty.img,
	                            loading: "lazy",
	                            decoding: "async",
	                            alt: $data.favorite.empty.title,
	                            title: $data.favorite.empty.title
	                          }, null, 8 /* PROPS */, ["src", "alt", "title"])
	                        ]))
	                      : createCommentVNode("v-if", true),
	                    ($data.favorite.empty.title)
	                      ? (openBlock(), createBlock("h1", _hoisted_9$y, toDisplayString($data.favorite.empty.title), 1 /* TEXT */))
	                      : createCommentVNode("v-if", true),
	                    ($data.favorite.empty.text)
	                      ? (openBlock(), createBlock("div", _hoisted_10$t, toDisplayString($data.favorite.empty.text), 1 /* TEXT */))
	                      : createCommentVNode("v-if", true),
	                    ($data.favorite.empty.buttons?.length)
	                      ? (openBlock(), createBlock("div", _hoisted_11$s, [
	                          (openBlock(true), createBlock(Fragment, null, renderList($data.favorite.empty.buttons, (btn) => {
	                            return (openBlock(), createBlock("a", {
	                              href: btn.link,
	                              class: [btn.className]
	                            }, toDisplayString(btn.text), 11 /* TEXT, CLASS, PROPS */, ["href"]))
	                          }), 256 /* UNKEYED_FRAGMENT */))
	                        ]))
	                      : createCommentVNode("v-if", true)
	                  ]))
	                : createCommentVNode("v-if", true)
	          ], 64 /* STABLE_FRAGMENT */))
	        : createCommentVNode("v-if", true)
	    ])
	  ]))
	}

	script$1r.render = render$1t;
	script$1r.__file = "local/assets/source/components/v-favorite.vue";

	var script$1s = {
		mixins: [script$2],

		data() {
			return {
				content: null,
			}
		},
		methods: {
			dataSet(data) {
				this.content = data;
			},

			handler(method) {
				if (typeof this[method] === 'function') {
					this[method]();
				}
			},

			logout() {
				this.dataLoad({
					url: this.content.remote,
					delay: true,
					data: {
						action: 'logout'
					}
				});
			},

			handlerClick() {
				controller.closeAll();
			}
		},
	};

	const _hoisted_1$1l = { class: "v-user-menu user-menu" };
	const _hoisted_2$1f = {
	  key: 0,
	  class: "user-menu__info"
	};
	const _hoisted_3$17 = {
	  key: 0,
	  class: "user-menu__user-photo"
	};
	const _hoisted_4$Y = { class: "user-menu__info-content" };
	const _hoisted_5$T = {
	  key: 0,
	  class: "user-menu__user-name"
	};
	const _hoisted_6$O = {
	  key: 1,
	  class: "user-menu__list"
	};
	const _hoisted_7$G = { class: "user-menu__item" };
	const _hoisted_8$B = {
	  key: 0,
	  class: "svg-icon user-menu__icon"
	};
	const _hoisted_9$z = { key: 1 };
	const _hoisted_10$u = {
	  key: 2,
	  class: "user-menu__footer"
	};

	function render$1u(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");

	  return (openBlock(), createBlock("div", _hoisted_1$1l, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.content)
	      ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	          ($data.content.user)
	            ? (openBlock(), createBlock("div", _hoisted_2$1f, [
	                ($data.content.user.photo)
	                  ? (openBlock(), createBlock("div", _hoisted_3$17, [
	                      createVNode("img", {
	                        src: $data.content.user.photo,
	                        loading: "lazy",
	                        decoding: "async",
	                        alt: $data.content.user.name
	                      }, null, 8 /* PROPS */, ["src", "alt"])
	                    ]))
	                  : createCommentVNode("v-if", true),
	                createVNode("div", _hoisted_4$Y, [
	                  ($data.content.user.name)
	                    ? (openBlock(), createBlock("div", _hoisted_5$T, toDisplayString($data.content.user.name), 1 /* TEXT */))
	                    : createCommentVNode("v-if", true),
	                  ($data.content.user.discount)
	                    ? (openBlock(), createBlock("div", {
	                        key: 1,
	                        class: "user-menu__points",
	                        style: ['background:' + $data.content.user.discount.background]
	                      }, toDisplayString($data.content.user.discount.text), 5 /* TEXT, STYLE */))
	                    : createCommentVNode("v-if", true)
	                ])
	              ]))
	            : createCommentVNode("v-if", true),
	          ($data.content.items?.length)
	            ? (openBlock(), createBlock("ul", _hoisted_6$O, [
	                (openBlock(true), createBlock(Fragment, null, renderList($data.content.items, (item) => {
	                  return (openBlock(), createBlock("li", _hoisted_7$G, [
	                    createVNode("a", {
	                      class: "user-menu__link",
	                      href: item.link,
	                      title: item.name,
	                      onClick: _cache[1] || (_cache[1] = (...args) => ($options.handlerClick && $options.handlerClick(...args)))
	                    }, [
	                      (item.icon)
	                        ? (openBlock(), createBlock("svg", _hoisted_8$B, [
	                            createVNode("use", {
	                              "xlink:href": '/local/assets/dist/icons/sprite.svg#svg-icon-' + item.icon
	                            }, null, 8 /* PROPS */, ["xlink:href"])
	                          ]))
	                        : createCommentVNode("v-if", true),
	                      (item.name)
	                        ? (openBlock(), createBlock("span", _hoisted_9$z, toDisplayString(item.name), 1 /* TEXT */))
	                        : createCommentVNode("v-if", true)
	                    ], 8 /* PROPS */, ["href", "title"])
	                  ]))
	                }), 256 /* UNKEYED_FRAGMENT */))
	              ]))
	            : createCommentVNode("v-if", true),
	          ($data.content.logout)
	            ? (openBlock(), createBlock("div", _hoisted_10$u, [
	                createVNode("a", {
	                  class: ["user-menu__logout", [$data.content.logout.className]],
	                  type: "button",
	                  _target: "",
	                  href: $data.content.logout.link,
	                  "aria-label": $data.content.logout.text,
	                  title: $data.content.logout.text
	                }, toDisplayString($data.content.logout.text), 11 /* TEXT, CLASS, PROPS */, ["href", "aria-label", "title"])
	              ]))
	            : createCommentVNode("v-if", true)
	        ], 64 /* STABLE_FRAGMENT */))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1s.render = render$1u;
	script$1s.__file = "local/assets/source/components/v-user-menu.vue";

	var script$1t = {
		components: {},

		mixins: [
			script$2
		],

		data() {
			return {};
		},

		computed: {
		  
			...mapGetters$1({
				userAuthorized: 'user/userAuthorized'
			}),
	  
		},

		created() {},

		unmounted() {},

		methods: {}
	};

	const _hoisted_1$1m = {
	  key: 0,
	  class: "v-user-auth-banner login-banner"
	};
	const _hoisted_2$1g = /*#__PURE__*/createVNode("button", {
	  class: "login-banner__widget js-open-modal",
	  type: "button",
	  "data-modal-data": "{\"className\": \"modal--sm\"}",
	  "data-modal-url": "/auth/login.php"
	}, [
	  /*#__PURE__*/createVNode("svg", { class: "svg-icon svg-icon--user" }, [
	    /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-user-small" })
	  ]),
	  /*#__PURE__*/createTextVNode("Зарегистрируйтесь и покупайте дешевле"),
	  /*#__PURE__*/createVNode("svg", { class: "svg-icon svg-icon--arrow" }),
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-text" })
	], -1 /* HOISTED */);

	function render$1v(_ctx, _cache, $props, $setup, $data, $options) {
	  return (!_ctx.userAuthorized)
	    ? (openBlock(), createBlock("section", _hoisted_1$1m, [
	        _hoisted_2$1g
	      ]))
	    : createCommentVNode("v-if", true)
	}

	script$1t.render = render$1v;
	script$1t.__file = "local/assets/source/components/v-user-auth-banner.vue";

	var script$1u = {
			components: {},

			mixins: [
				script$2
			],

			data() {
				return {
					data: null,

				};
			},

			computed: {

				...mapGetters$1({
						userAuthorized: 'user/userAuthorized'
				}),

				computedDiscountData() {
					let discountID = this.userAuthorized ? this.data.discountList.nextLevelId : this.data.discountList.maxLevelID;
					return  this.data.discountList.list.find(item => item.id === discountID)
				},

				computedChockDiscountDetected() {

					let  chockDiscountDetected = false;
					if (!this.data.discountList || !this.data.discountList.list.length) {
						return chockDiscountDetected;
					}


					this.data.items.forEach(item => {
						if (item.chockDiscount && item.chockDiscount.length && item.canBuy) {
							chockDiscountDetected = true;
						}
					});

					return chockDiscountDetected;
				},

				computedDiscountPrice() {
					return {
						"current": {
							"value": this.computedCurrentPrice,
							"currency": "р."
						},
						"old": {
							"value": this.computedOldPrice,
							"currency": "р."
						}
					}
				},

				computedCurrentPrice() {
					let priceSumm = 0;
					this.data.items.forEach(item => {
						if (item.canBuy){
							let price = item.price.current.value;
							if (item.chockDiscount && item.chockDiscount.length) {
								price = item.chockDiscount.find(discount => discount.id === this.computedDiscountData.id).price;
							}
							priceSumm +=parseFloat( price )  * parseFloat(item.count.value);
						}
					});

					return priceSumm;
				},

				computedOldPrice() {
					let oldPriceSumm = 0;
					this.data.items.forEach(item => {
						if (item.canBuy){
							oldPriceSumm += parseFloat(item.price.old ? item.price.old.value : item.price.current.value) * parseFloat(item.count.value);
						}
					});
					return oldPriceSumm;
				}

			},


			created() {},

			unmounted() {},

			methods: {

				dataSet(data, options = {}) {
					this.data = data;
				},
					// модалка скидки
				openDiscountModal() {
					controller.openModal({
						className: 'modal--sm',
						component: {
							name: 'v-discount-modal',
							props: {
								bxajaxid: 'discount-modal',
								dataSource: this.data.discountList.link,
								title: 'Условия программы лояльности'
							}
						}
					});
				},
			}
		};

	const _hoisted_1$1n = {
	  key: 0,
	  class: "v-discount-block discount-card"
	};
	const _hoisted_2$1h = { class: "discount-card__title" };
	const _hoisted_3$18 = { class: "discount-card__price-block" };
	const _hoisted_4$Z = { class: "discount-card__value" };
	const _hoisted_5$U = { class: "discount-card__caption" };
	const _hoisted_6$P = /*#__PURE__*/createTextVNode("До скидки в ");
	const _hoisted_7$H = /*#__PURE__*/createTextVNode(" вам осталось приобрести товар на сумму: ");
	const _hoisted_8$C = { class: "discount-card__caption" };
	const _hoisted_9$A = /*#__PURE__*/createTextVNode("Программа лояльности дает возможность покупать товар со скидками ");

	function render$1w(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_price = resolveComponent("v-price");

	  return (openBlock(), createBlock(Fragment, null, [
	    ($options.computedChockDiscountDetected)
	      ? (openBlock(), createBlock("div", _hoisted_1$1n, [
	          createVNode("div", _hoisted_2$1h, toDisplayString(_ctx.userAuthorized ?'Покупать еще выгоднее' : ('Ваша скидка может быть –'+ $options.computedDiscountData.percent +'%')), 1 /* TEXT */),
	          (_ctx.userAuthorized)
	            ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	                createVNode("div", _hoisted_3$18, [
	                  createVNode(_component_v_price, {
	                    class: "discount-card__price",
	                    price: $options.computedDiscountPrice,
	                    size: "lg2"
	                  }, null, 8 /* PROPS */, ["price"]),
	                  createVNode("div", _hoisted_4$Z, "-" + toDisplayString($options.computedDiscountData.percent) + "%", 1 /* TEXT */)
	                ]),
	                createVNode("div", _hoisted_5$U, [
	                  _hoisted_6$P,
	                  createVNode("strong", null, "-" + toDisplayString($options.computedDiscountData.percent) + "%", 1 /* TEXT */),
	                  _hoisted_7$H,
	                  createVNode("strong", null, toDisplayString($data.data.discountList.neadPayOrderForNextFormated), 1 /* TEXT */)
	                ])
	              ], 64 /* STABLE_FRAGMENT */))
	            : (openBlock(), createBlock(Fragment, { key: 1 }, [
	                createVNode(_component_v_price, {
	                  class: "discount-card__price",
	                  price: $options.computedDiscountPrice,
	                  size: "lg2"
	                }, null, 8 /* PROPS */, ["price"]),
	                createVNode("div", _hoisted_8$C, [
	                  _hoisted_9$A,
	                  createVNode("strong", null, [
	                    (openBlock(true), createBlock(Fragment, null, renderList($data.data.discountList.list, (discount) => {
	                      return (openBlock(), createBlock(Fragment, null, [
	                        createTextVNode(toDisplayString(' ' + discount.percent) + "%", 1 /* TEXT */)
	                      ], 64 /* STABLE_FRAGMENT */))
	                    }), 256 /* UNKEYED_FRAGMENT */))
	                  ])
	                ])
	              ], 64 /* STABLE_FRAGMENT */)),
	          createVNode("button", {
	            class: "discount-card__btn",
	            type: "button",
	            onClick: _cache[1] || (_cache[1] = (...args) => ($options.openDiscountModal && $options.openDiscountModal(...args)))
	          }, "Читать условия")
	        ]))
	      : createCommentVNode("v-if", true),
	    createCommentVNode("\ttemplate(v-if=\"userAuthorized\")"),
	    createCommentVNode("\t\t.discount-card__action"),
	    createCommentVNode("\t\t\ta.btn.btn--primary.btn--sm(:href=\"data.catalogLink\")"),
	    createCommentVNode("\t\t\t\t.btn__text Добавить товар"),
	    createCommentVNode("\t\t\t\tsvg.btn__icon.svg-icon"),
	    createCommentVNode("\t\t\t\t\tuse(xlink:href=\"/local/assets/dist/icons/sprite.svg#svg-icon-plus\")")
	  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
	}

	script$1u.render = render$1w;
	script$1u.__file = "local/assets/source/components/v-discount-block.vue";

	var script$1v = {

	};

	const _hoisted_1$1o = { class: "v-mobile-toolbar mobile-toolbar js-mobile-toolbar" };
	const _hoisted_2$1i = { class: "mobile-toolbar__wrapper" };
	const _hoisted_3$19 = { class: "mobile-toolbar__cell mobile-toolbar__cell--menu" };
	const _hoisted_4$_ = { class: "mobile-toolbar__cell mobile-toolbar__cell--user" };
	const _hoisted_5$V = { class: "mobile-toolbar__cell mobile-toolbar__cell--catalog" };
	const _hoisted_6$Q = { class: "mobile-toolbar__cell mobile-toolbar__cell--favorite" };
	const _hoisted_7$I = { class: "mobile-toolbar__cell mobile-toolbar__cell--basket" };

	function render$1x(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$1o, [
	    createVNode("div", _hoisted_2$1i, [
	      createVNode("div", _hoisted_3$19, [
	        renderSlot(_ctx.$slots, "menu")
	      ]),
	      createVNode("div", _hoisted_4$_, [
	        renderSlot(_ctx.$slots, "user")
	      ]),
	      createVNode("div", _hoisted_5$V, [
	        renderSlot(_ctx.$slots, "catalog")
	      ]),
	      createVNode("div", _hoisted_6$Q, [
	        renderSlot(_ctx.$slots, "favorite")
	      ]),
	      createVNode("div", _hoisted_7$I, [
	        renderSlot(_ctx.$slots, "basket")
	      ])
	    ])
	  ]))
	}

	script$1v.render = render$1x;
	script$1v.__file = "local/assets/source/components/v-mobile-toolbar.vue";

	var script$1w = {
		components: {
			VPicture: script$5,
			'v-swiper-slide': SwiperSlide
		},

		mixins: [
			script$2
		],

		props: {
			options: {
				type: Object,
				default: null
			}
		},

		data() {
			return {
				slider: {},
				uniqueId: uniqueId('swiper-')
			};
		},

		computed: {
			computedOptions() {
				let result = {
					loop: false,
					slidesPerView: 'auto',
					centerInsufficientSlides: true,
					watchOverflow: true,
					breakpoints: {
						[breakpoints['sm-min']]: {
							spaceBetween: 22,
						},
						[breakpoints['4xs-min']]: {
							spaceBetween: 9,
						}
					}
				};
				return result;
			},
		},

		methods: {
			dataSet(data) {
				this.slider = data;
			}
		}
	};

	const _hoisted_1$1p = { class: "v-only-slider only-slider" };
	const _hoisted_2$1j = { class: "only-slider__logo" };

	function render$1y(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_picture = resolveComponent("v-picture");
	  const _component_v_swiper_slide = resolveComponent("v-swiper-slide");
	  const _component_v_swiper_slider = resolveComponent("v-swiper-slider");

	  return (openBlock(), createBlock("div", _hoisted_1$1p, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.slider && $data.slider.items && $data.slider.items.length)
	      ? (openBlock(), createBlock(_component_v_swiper_slider, {
	          options: $options.computedOptions,
	          key: $data.uniqueId,
	          pagination: {type: 'bullets', clickable: true, dynamicBullets: 3},
	          ref: "swiperSlider"
	        }, {
	          main: withCtx(() => [
	            (openBlock(true), createBlock(Fragment, null, renderList($data.slider.items, (item, index) => {
	              return (openBlock(), createBlock(_component_v_swiper_slide, {
	                class: "only-slider__slide",
	                key: item.id || index
	              }, {
	                default: withCtx(() => [
	                  createVNode("a", {
	                    class: "only-slider__item",
	                    href: item.link
	                  }, [
	                    createVNode(_component_v_picture, {
	                      sources: item.imageSources,
	                      alt: item.name
	                    }, null, 8 /* PROPS */, ["sources", "alt"]),
	                    createVNode("div", _hoisted_2$1j, [
	                      createVNode(_component_v_picture, {
	                        sources: item.logo,
	                        alt: item.name
	                      }, null, 8 /* PROPS */, ["sources", "alt"])
	                    ])
	                  ], 8 /* PROPS */, ["href"])
	                ]),
	                _: 2 /* DYNAMIC */
	              }, 1024 /* DYNAMIC_SLOTS */))
	            }), 128 /* KEYED_FRAGMENT */))
	          ]),
	          _: 1 /* STABLE */
	        }, 8 /* PROPS */, ["options"]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1w.render = render$1y;
	script$1w.__file = "local/assets/source/components/v-only-slider.vue";

	var script$1x = {
		components: {
			'v-swiper-slide': SwiperSlide
		},

		mixins: [script$2],

		data() {
			return {
				brands: null,
				localFilterValue: '',
				uniqueId: uniqueId('swiper-')
			}
		},

		computed: {
			computedOptions() {
				let result = {
					slidesPerView: 'auto',
					loop: false,
					// скрывать навигацию если не хватает слайдов
					watchOverflow: true,
					breakpoints: {
						[breakpoints['sm-min']]: {
							spaceBetween: 15,
						},
						[breakpoints['4xs-min']]: {
							spaceBetween: 10,
						}
					}
				};
				return result;
			},

			computedGroupList() {
				const resultObj = {};
				this.brands.items.forEach((brand) => {
					const firstLetter = brand.name[0].toLowerCase();

					if (!resultObj[firstLetter]) {
						resultObj[firstLetter] = [];
					}
					resultObj[firstLetter].push(brand);
				});
				const resultArr = Object.keys(resultObj).map((key) => {
					return {
						name: key,
						items: resultObj[key]
					}
				});
				resultArr.sort((a, b) => a.name.localeCompare(b.name));
				return resultArr;
			},

			computedFilteredList() {
				return this.brands.items.filter((item) => {
					if (this.localFilterValue?.length && item.name.toLowerCase().includes(this.localFilterValue)) {
						return item
					}
				}).map((item) => {
					const name = item.name;
					const posSearchValue = name.toLowerCase().indexOf(this.localFilterValue);
					const computedName = name.slice(0, posSearchValue) + `<b>${name.substr(posSearchValue, this.localFilterValue.length)}</b>` + name.slice(posSearchValue + this.localFilterValue.length);
					return {...item, name: computedName}
				})
			}
		},

		methods: {
			dataSet(data) {
				this.brands = data;

				this.$nextTick(() => {
					View.initAllLocal(this.$el);

					this.$refs.swiperSlider.dataNavigation = {
						nextEl: this.$refs.next,
						prevEl: this.$refs.prev,
					};
				});
			},

			filterChanged(value) {
				this.localFilterValue = value.toLowerCase();
			},

			clearFilter() {
				this.localFilterValue = null;
			},

			selectCategory(categoryName) {
				controller.scrollTo(this.$el.querySelector(`[data-group-id='${categoryName}']`), 150);
			},
		},
	};

	const _hoisted_1$1q = { class: "v-brand-list brand-list" };
	const _hoisted_2$1k = {
	  key: 0,
	  class: "brand-list__wrapper container"
	};
	const _hoisted_3$1a = {
	  key: 0,
	  class: "brand-list__title"
	};
	const _hoisted_4$$ = {
	  key: 1,
	  class: "brand-list__nav fixed-block js-fixed--up"
	};
	const _hoisted_5$W = { class: "fixed-block__content js-fixed__content" };
	const _hoisted_6$R = {
	  class: "brand-list__arrow brand-list__arrow--prev",
	  type: "button",
	  ref: "prev"
	};
	const _hoisted_7$J = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-left-text" })
	], -1 /* HOISTED */);
	const _hoisted_8$D = {
	  class: "brand-list__arrow brand-list__arrow--next",
	  type: "button",
	  ref: "next"
	};
	const _hoisted_9$B = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-text" })
	], -1 /* HOISTED */);
	const _hoisted_10$v = {
	  key: 2,
	  class: "brand-list__filter"
	};
	const _hoisted_11$t = {
	  key: 3,
	  class: "brand-list__groups"
	};
	const _hoisted_12$s = { class: "brand-list__group" };
	const _hoisted_13$n = { class: "brand-list__list" };
	const _hoisted_14$l = {
	  key: 4,
	  class: "brand-list__list"
	};

	function render$1z(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_swiper_slide = resolveComponent("v-swiper-slide");
	  const _component_v_swiper_slider = resolveComponent("v-swiper-slider");
	  const _component_v_field = resolveComponent("v-field");

	  return (openBlock(), createBlock("div", _hoisted_1$1q, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.brands)
	      ? (openBlock(), createBlock("div", _hoisted_2$1k, [
	          ($data.brands.title)
	            ? (openBlock(), createBlock("h1", _hoisted_3$1a, toDisplayString($data.brands.title), 1 /* TEXT */))
	            : createCommentVNode("v-if", true),
	          ($options.computedGroupList?.length)
	            ? (openBlock(), createBlock("div", _hoisted_4$$, [
	                createVNode("div", _hoisted_5$W, [
	                  createVNode("button", _hoisted_6$R, [
	                    _hoisted_7$J
	                  ], 512 /* NEED_PATCH */),
	                  createVNode(_component_v_swiper_slider, {
	                    options: $options.computedOptions,
	                    key: $data.uniqueId,
	                    navigation: "navigation",
	                    ref: "swiperSlider"
	                  }, {
	                    main: withCtx(() => [
	                      (openBlock(true), createBlock(Fragment, null, renderList($options.computedGroupList, (item, index) => {
	                        return (openBlock(), createBlock(_component_v_swiper_slide, {
	                          class: "brand-list__slide",
	                          key: item.name || index
	                        }, {
	                          default: withCtx(() => [
	                            createVNode("button", {
	                              class: "brand-list__toggle",
	                              type: "button",
	                              onClick: $event => ($options.selectCategory(item.name))
	                            }, toDisplayString(item.name), 9 /* TEXT, PROPS */, ["onClick"])
	                          ]),
	                          _: 2 /* DYNAMIC */
	                        }, 1024 /* DYNAMIC_SLOTS */))
	                      }), 128 /* KEYED_FRAGMENT */))
	                    ]),
	                    _: 1 /* STABLE */
	                  }, 8 /* PROPS */, ["options"]),
	                  createVNode("button", _hoisted_8$D, [
	                    _hoisted_9$B
	                  ], 512 /* NEED_PATCH */)
	                ])
	              ]))
	            : createCommentVNode("v-if", true),
	          ($data.brands.filter)
	            ? (openBlock(), createBlock("div", _hoisted_10$v, [
	                createVNode(_component_v_field, {
	                  modelValue: $data.localFilterValue,
	                  "onUpdate:modelValue": [
	                    _cache[1] || (_cache[1] = $event => ($data.localFilterValue = $event)),
	                    $options.filterChanged
	                  ],
	                  field: $data.brands.filter
	                }, null, 8 /* PROPS */, ["modelValue", "field", "onUpdate:modelValue"]),
	                withDirectives(createVNode("button", {
	                  class: "brand-list__clear",
	                  type: "button",
	                  onClick: _cache[2] || (_cache[2] = (...args) => ($options.clearFilter && $options.clearFilter(...args)))
	                }, null, 512 /* NEED_PATCH */), [
	                  [vShow, $data.localFilterValue?.length]
	                ])
	              ]))
	            : createCommentVNode("v-if", true),
	          ($options.computedGroupList && !$data.localFilterValue?.length)
	            ? (openBlock(), createBlock("div", _hoisted_11$t, [
	                (openBlock(true), createBlock(Fragment, null, renderList($options.computedGroupList, (group) => {
	                  return (openBlock(), createBlock("div", _hoisted_12$s, [
	                    createVNode("div", {
	                      class: "brand-list__group-name",
	                      "data-group-id": group.name
	                    }, toDisplayString(group.name), 9 /* TEXT, PROPS */, ["data-group-id"]),
	                    createVNode("div", _hoisted_13$n, [
	                      (openBlock(true), createBlock(Fragment, null, renderList(group.items, (item) => {
	                        return (openBlock(), createBlock("a", {
	                          class: "brand-list__link",
	                          href: item.link
	                        }, toDisplayString(item.name), 9 /* TEXT, PROPS */, ["href"]))
	                      }), 256 /* UNKEYED_FRAGMENT */))
	                    ])
	                  ]))
	                }), 256 /* UNKEYED_FRAGMENT */))
	              ]))
	            : createCommentVNode("v-if", true),
	          ($options.computedFilteredList?.length)
	            ? (openBlock(), createBlock("div", _hoisted_14$l, [
	                (openBlock(true), createBlock(Fragment, null, renderList($options.computedFilteredList, (item) => {
	                  return (openBlock(), createBlock("a", {
	                    class: "brand-list__link brand-list__link--mark",
	                    href: item.link,
	                    innerHTML: item.name
	                  }, null, 8 /* PROPS */, ["href", "innerHTML"]))
	                }), 256 /* UNKEYED_FRAGMENT */))
	              ]))
	            : createCommentVNode("v-if", true)
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1x.render = render$1z;
	script$1x.__file = "local/assets/source/components/v-brand-list.vue";

	var script$1y = {
		components: {
			'v-swiper-slide': SwiperSlide
		},

		mixins: [
			script$2
		],

		props: {
			options: {
				type: Object,
				default: null
			}
		},

		data() {
			return {
				slider: {},
				uniqueId: uniqueId('swiper-')
			};
		},

		computed: {
			computedOptions() {
				let result = {
					watchOverflow: true,
					slidesPerView: 1,
					loop: false,
				};
				if (this.options) {
					Object.keys(this.options).forEach((key) => {
						if (typeof this.options[key] !== 'undefined') {
							result[key] = this.options[key];
						}
					});
				}
				return result;
			},
		},

		methods: {
			dataSet(data) {
				this.slider = data;

				if (this.slider?.items?.length) {
					this.$nextTick(() => {
						this.$refs.swiperSlider.dataNavigation = {
							nextEl: this.$refs.next,
							prevEl: this.$refs.prev,
						};
					});
				}
			}
		}
	};

	const _hoisted_1$1r = { class: "v-article-banner article-banner" };
	const _hoisted_2$1l = {
	  class: "article-banner__arrow article-banner__arrow--prev",
	  type: "button",
	  ref: "prev"
	};
	const _hoisted_3$1b = /*#__PURE__*/createVNode("svg", { class: "svg-icon article-banner__icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-left-slider" })
	], -1 /* HOISTED */);
	const _hoisted_4$10 = {
	  class: "article-banner__arrow article-banner__arrow--next",
	  type: "button",
	  ref: "next"
	};
	const _hoisted_5$X = /*#__PURE__*/createVNode("svg", { class: "svg-icon article-banner__icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-slider" })
	], -1 /* HOISTED */);
	const _hoisted_6$S = { class: "article-banner__item-wrapper container" };
	const _hoisted_7$K = {
	  key: 0,
	  class: "h1 article-banner__item-title"
	};
	const _hoisted_8$E = { class: "article-banner__item-action" };
	const _hoisted_9$C = { class: "article-banner__item-visual" };

	function render$1A(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_picture = resolveComponent("v-picture");
	  const _component_v_swiper_slide = resolveComponent("v-swiper-slide");
	  const _component_v_swiper_slider = resolveComponent("v-swiper-slider");

	  return (openBlock(), createBlock("section", _hoisted_1$1r, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    createVNode("button", _hoisted_2$1l, [
	      _hoisted_3$1b
	    ], 512 /* NEED_PATCH */),
	    createVNode("button", _hoisted_4$10, [
	      _hoisted_5$X
	    ], 512 /* NEED_PATCH */),
	    ($data.slider && $data.slider.items && $data.slider.items.length)
	      ? (openBlock(), createBlock(_component_v_swiper_slider, {
	          options: $options.computedOptions,
	          key: $data.uniqueId,
	          pagination: {type: 'bullets', clickable: true, dynamicBullets: 3},
	          navigation: "navigation",
	          ref: "swiperSlider"
	        }, {
	          main: withCtx(() => [
	            (openBlock(true), createBlock(Fragment, null, renderList($data.slider.items, (item, index) => {
	              return (openBlock(), createBlock(_component_v_swiper_slide, {
	                class: "article-banner__slide",
	                key: item.id || index
	              }, {
	                default: withCtx(() => [
	                  createVNode("div", {
	                    class: "article-banner__item",
	                    style: {background: item.background}
	                  }, [
	                    createVNode("div", _hoisted_6$S, [
	                      createVNode("div", {
	                        class: "article-banner__item-content",
	                        style: {color: item.color}
	                      }, [
	                        (item.title)
	                          ? (openBlock(), createBlock("div", _hoisted_7$K, toDisplayString(item.title), 1 /* TEXT */))
	                          : createCommentVNode("v-if", true),
	                        createVNode("div", _hoisted_8$E, [
	                          (openBlock(true), createBlock(Fragment, null, renderList(item.buttons, (btn) => {
	                            return (openBlock(), createBlock("a", {
	                              class: [btn.className],
	                              href: btn.link,
	                              "aria-label": btn.text,
	                              title: btn.text
	                            }, toDisplayString(btn.text), 11 /* TEXT, CLASS, PROPS */, ["href", "aria-label", "title"]))
	                          }), 256 /* UNKEYED_FRAGMENT */))
	                        ])
	                      ], 4 /* STYLE */),
	                      createVNode("div", _hoisted_9$C, [
	                        createVNode(_component_v_picture, {
	                          sources: item.imageSources
	                        }, null, 8 /* PROPS */, ["sources"])
	                      ])
	                    ])
	                  ], 4 /* STYLE */)
	                ]),
	                _: 2 /* DYNAMIC */
	              }, 1024 /* DYNAMIC_SLOTS */))
	            }), 128 /* KEYED_FRAGMENT */))
	          ]),
	          _: 1 /* STABLE */
	        }, 8 /* PROPS */, ["options"]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1y.render = render$1A;
	script$1y.__file = "local/assets/source/components/v-article-banner.vue";

	const map$2 = {
		instance: null,
		objectManager: null
	};
	var script$1z = {
		components: {VPicture: script$5},
		mixins: [script$2],

		data() {
			return {
				contacts: null,
				adaptiveDevice: false,
				mapInstance: null,
				objectManager: null,
				prevMarkId: null,

			}
		},

		computed: {
			computeMapData() {
				const result = {
					'type': 'FeatureCollection',
					'features': []
				};

				this.contacts.items.forEach((item) => {
					result.features.push({id: item.id, ...item.map});
				});

				return result;
			}
		},

		mounted() {
			this.getDevice();
			window.addEventListener('resize', this.getDevice);
		},

		unmounted() {
			window.removeEventListener('resize', this.getDevice);
		},

		methods: {
			dataSet(data) {
				this.contacts = data;
				controller.loadDelayScript('https://api-maps.yandex.ru/2.1.73/?lang=ru_RU', this.initMaps);
			},

			// инициализация всех яндекс карт на сайте
			initMaps() {
				const vm = this;

				ymaps.ready(function () {
					map$2.instance = new ymaps.Map(vm.$refs.map, {
						center: [50.79, 37.64],
						controls: ['zoomControl', 'geolocationControl'],
						zoom: 18,
					}, {
						searchControlProvider: 'yandex#search'
					});
					map$2.objectManager = new ymaps.ObjectManager({
						// Чтобы метки начали кластеризоваться, выставляем опцию.
						clusterize: true,
						// ObjectManager принимает те же опции, что и кластеризатор.
						gridSize: 32,
						clusterDisableClickZoom: true,
					});

					// стилизация меток на карте
					map$2.objectManager.objects.options.set('iconLayout', 'default#image');
					map$2.objectManager.objects.options.set('iconImageHref', '/local/assets/images/markup-images/icon__map-marker.svg');
					map$2.objectManager.objects.options.set('iconImageSize', [40, 40]);
					map$2.objectManager.objects.options.set('iconImageOffset', [-20, -10]);
					map$2.objectManager.objects.options.set('balloonOffset', [-70, -5]);
					map$2.objectManager.objects.options.set('openBalloonOnClick', false);
					map$2.objectManager.objects.options.set('hideIconOnBalloonOpen', false);

					// обработка события клика по метке на карте
					map$2.objectManager.objects.events.add('click', function (e) {
						var pmId = e.get('objectId');
						var currentItem = vm.contacts.items.filter((item) => item.id === pmId)[0];
						vm.openBalloon(currentItem);
					});

					// обработка события закрытия баллуна
					map$2.objectManager.objects.events.add('balloonclose', function (e) {
						var pmId = e.get('objectId');
						// сброс параметров метки на не выбранную
						vm.resetPrevMark(pmId);
					});

					// Добавляем объекты на карту.
					map$2.objectManager.add(vm.computeMapData);
					map$2.instance.geoObjects.add(map$2.objectManager);

					// устанавливаем нужный центр и зум карты, чтобы было видно все метки и задаем нужный отступ меток от края карты
					map$2.instance.setBounds(map$2.instance.geoObjects.getBounds(), {checkZoomRange: true, zoomMargin: 30})
						.then(function () {
							//после установки проверяем зум и не даем выйти за рамки нужного
							if (map$2.instance.getZoom() > 15) {
								map$2.instance.setZoom(15);
							}
						});
				});
			},

			openBalloon(item) {
				// центровка карты по выбранной метке
				map$2.instance.setCenter(Object.values(item.map.geometry.coordinates));

				if (this.adaptiveDevice) {
					controller.openModal({
						className: 'modal--sm',
						component: {
							name: 'v-random-html',
							props: {
								title: item.name,
								html: item.map.properties.balloonContentBody
							}
						}
					});
				} else {
					// открытие баллуна выбранной метки
					map$2.objectManager.objects.balloon.open(item.id);
					this.setCurrentMark(item.id);
				}
			},

			// сброс метки карты на не выбранную
			resetPrevMark(prevId) {
				map$2.objectManager.objects.setObjectOptions(prevId, {
					iconImageHref: '/local/assets/images/markup-images/icon__map-marker.svg',
				});
			},

			// установка красной метки на выбранную метку карты
			setCurrentMark(markId) {
				map$2.objectManager.objects.setObjectOptions(markId, {
					iconImageHref: '/local/assets/images/markup-images/icon__map-marker-active.svg',
				});
			},

			getDevice() {
				this.adaptiveDevice = window.innerWidth < breakpoints['xs-max'];
			},
		},
	};

	const _hoisted_1$1s = { class: "v-contacts contacts" };
	const _hoisted_2$1m = {
	  key: 0,
	  class: "contacts__wrapper"
	};
	const _hoisted_3$1c = { class: "contacts__list" };
	const _hoisted_4$11 = {
	  key: 0,
	  class: "contacts__header"
	};
	const _hoisted_5$Y = { class: "contacts__title h2" };
	const _hoisted_6$T = {
	  key: 1,
	  class: "contacts__items"
	};
	const _hoisted_7$L = { class: "contacts__item-main" };
	const _hoisted_8$F = {
	  key: 0,
	  class: "contacts__caption h5"
	};
	const _hoisted_9$D = {
	  key: 0,
	  class: "svg-icon"
	};
	const _hoisted_10$w = {
	  key: 2,
	  class: "contacts__metro"
	};
	const _hoisted_11$u = {
	  key: 0,
	  class: "svg-icon"
	};
	const _hoisted_12$t = { class: "contacts__footer" };
	const _hoisted_13$o = {
	  key: 0,
	  class: "contacts__work-time"
	};
	const _hoisted_14$m = { class: "contacts__work-time-item" };
	const _hoisted_15$j = {
	  key: 1,
	  class: "contacts__phones"
	};
	const _hoisted_16$i = { class: "contacts__item-aside" };
	const _hoisted_17$f = {
	  key: 0,
	  class: "contacts__visual"
	};
	const _hoisted_18$d = { class: "contacts__map" };
	const _hoisted_19$b = {
	  class: "contacts__map-iframe",
	  ref: "map"
	};

	function render$1B(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_loader = resolveComponent("v-loader");
	  const _component_v_picture = resolveComponent("v-picture");

	  return (openBlock(), createBlock("section", _hoisted_1$1s, [
	    createVNode(_component_v_loader, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"]),
	    ($data.contacts)
	      ? (openBlock(), createBlock("div", _hoisted_2$1m, [
	          createVNode("div", _hoisted_3$1c, [
	            ($data.contacts.title)
	              ? (openBlock(), createBlock("div", _hoisted_4$11, [
	                  createVNode("h1", _hoisted_5$Y, toDisplayString($data.contacts.title), 1 /* TEXT */)
	                ]))
	              : createCommentVNode("v-if", true),
	            ($data.contacts.items?.length)
	              ? (openBlock(), createBlock("div", _hoisted_6$T, [
	                  (openBlock(true), createBlock(Fragment, null, renderList($data.contacts.items, (item, index) => {
	                    return (openBlock(), createBlock("div", {
	                      class: "contacts__item",
	                      key: item.id || index
	                    }, [
	                      createVNode("div", _hoisted_7$L, [
	                        (item.name)
	                          ? (openBlock(), createBlock("div", _hoisted_8$F, toDisplayString(item.name), 1 /* TEXT */))
	                          : createCommentVNode("v-if", true),
	                        (item.address)
	                          ? (openBlock(), createBlock("button", {
	                              key: 1,
	                              class: "contacts__address",
	                              onClick: $event => ($options.openBalloon(item)),
	                              type: "button",
	                              "aria-label": "Показать на карте",
	                              title: "Показать на карте"
	                            }, [
	                              (item.address.icon)
	                                ? (openBlock(), createBlock("svg", _hoisted_9$D, [
	                                    createVNode("use", {
	                                      "xlink:href": '/local/assets/dist/icons/sprite.svg#svg-icon-' + item.address.icon
	                                    }, null, 8 /* PROPS */, ["xlink:href"])
	                                  ]))
	                                : createCommentVNode("v-if", true),
	                              createTextVNode(toDisplayString(item.address.text), 1 /* TEXT */)
	                            ], 8 /* PROPS */, ["onClick"]))
	                          : createCommentVNode("v-if", true),
	                        (item.metro)
	                          ? (openBlock(), createBlock("div", _hoisted_10$w, [
	                              (item.metro.icon)
	                                ? (openBlock(), createBlock("svg", _hoisted_11$u, [
	                                    createVNode("use", {
	                                      "xlink:href": '/local/assets/dist/icons/sprite.svg#svg-icon-' + item.metro.icon
	                                    }, null, 8 /* PROPS */, ["xlink:href"])
	                                  ]))
	                                : createCommentVNode("v-if", true),
	                              createTextVNode(toDisplayString(item.metro.text), 1 /* TEXT */)
	                            ]))
	                          : createCommentVNode("v-if", true),
	                        createVNode("div", _hoisted_12$t, [
	                          (item.workTime?.length)
	                            ? (openBlock(), createBlock("div", _hoisted_13$o, [
	                                (openBlock(true), createBlock(Fragment, null, renderList(item.workTime, (time) => {
	                                  return (openBlock(), createBlock("div", _hoisted_14$m, toDisplayString(time), 1 /* TEXT */))
	                                }), 256 /* UNKEYED_FRAGMENT */))
	                              ]))
	                            : createCommentVNode("v-if", true),
	                          (item.phones?.length)
	                            ? (openBlock(), createBlock("div", _hoisted_15$j, [
	                                (openBlock(true), createBlock(Fragment, null, renderList(item.phones, (phone) => {
	                                  return (openBlock(), createBlock("a", {
	                                    class: "contacts__phone",
	                                    href: 'tel:' + phone.link
	                                  }, toDisplayString(phone.text), 9 /* TEXT, PROPS */, ["href"]))
	                                }), 256 /* UNKEYED_FRAGMENT */))
	                              ]))
	                            : createCommentVNode("v-if", true)
	                        ]),
	                        (openBlock(true), createBlock(Fragment, null, renderList(item.emails, (email) => {
	                          return (openBlock(), createBlock("a", {
	                            class: "contacts__email hidden-lg hidden-md hidden-sm",
	                            href: 'tel:' + email
	                          }, toDisplayString(email), 9 /* TEXT, PROPS */, ["href"]))
	                        }), 256 /* UNKEYED_FRAGMENT */))
	                      ]),
	                      createVNode("div", _hoisted_16$i, [
	                        (item.imageSources)
	                          ? (openBlock(), createBlock("div", _hoisted_17$f, [
	                              createVNode(_component_v_picture, {
	                                sources: item.imageSources,
	                                alt: item.name
	                              }, null, 8 /* PROPS */, ["sources", "alt"])
	                            ]))
	                          : createCommentVNode("v-if", true),
	                        (openBlock(true), createBlock(Fragment, null, renderList(item.emails, (email) => {
	                          return (openBlock(), createBlock("a", {
	                            class: "contacts__email hidden-xs",
	                            href: 'tel:' + email
	                          }, toDisplayString(email), 9 /* TEXT, PROPS */, ["href"]))
	                        }), 256 /* UNKEYED_FRAGMENT */))
	                      ])
	                    ]))
	                  }), 128 /* KEYED_FRAGMENT */))
	                ]))
	              : createCommentVNode("v-if", true)
	          ]),
	          createVNode("div", _hoisted_18$d, [
	            createVNode("div", _hoisted_19$b, null, 512 /* NEED_PATCH */)
	          ])
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1z.render = render$1B;
	script$1z.__file = "local/assets/source/components/v-contacts.vue";

	var script$1A = {
		props: {
			html: {
				type: String,
				default: null
			},
		},
	};

	const _hoisted_1$1t = { class: "v-random-html random-html" };

	function render$1C(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$1t, [
	    ($props.html)
	      ? (openBlock(), createBlock("div", {
	          key: 0,
	          class: "random-html__content",
	          innerHTML: $props.html
	        }, null, 8 /* PROPS */, ["innerHTML"]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1A.render = render$1C;
	script$1A.__file = "local/assets/source/components/v-random-html.vue";

	var script$1B = {
		data() {
			return {
				menu: null,
			};
		},

		created() {
			controller.events.on('navigation-updated', this.getData);
		},

		methods: {
			getData() {
				this.menu = controller.navigationData;
				this.$nextTick(() => {
					this.initMenu();
					View.initAllLocal(this.$el);
				});
			},
			initMenu() {
				const vm = this;
				var hamburgerMenuContainer = document.querySelector('.js-hamburger-menu-container');
				var hamburgerMenuAll = document.querySelectorAll('.js-hamburger-menu');

				if (hamburgerMenuContainer) {
					hamburgerMenuContainer.classList.add('scroll');

					hamburgerMenuAll.forEach(function (hamburgerMenu) {
						var hamburgerMenuToggles = hamburgerMenu.querySelectorAll('.js-hamburger-menu__toggle');
						var hamburgerSubLists = hamburgerMenu.querySelectorAll('.js-hamburger-menu__sub-list');
						var checkAllSublistClosed = [];

						hamburgerMenuToggles.forEach(function (hamburgerMenuToggle) {
							hamburgerMenuToggle.addEventListener('click', function (e) {
								e.preventDefault();
								var self = this;
								var parentSelf = self.parents('.js-hamburger-menu__item')[1] || null;
								if (parentSelf) {
									parentSelf = Array.prototype.slice.call(parentSelf.children).filter(function (item) {
										return item.matches('.js-hamburger-menu__toggle');
									})[0];
								}
								var sublist = self.nextElementSibling;
								var backToggle = sublist.querySelector('.js-hamburger-menu__btn-back');

								hamburgerMenuContainer.classList.remove('scroll');
								hamburgerMenuContainer.scrollTop = 0;
								hamburgerSubLists.forEach(function (sublist) {
									sublist.scrollTop = 0;
								});

								hamburgerMenu.classList.add('open');
								hamburgerMenuToggles.forEach(function (elem) {
									elem.classList.remove('scroll');
								});
								self.classList.add('open', 'scroll');

								// обработчик назад
								backToggle.addEventListener('click', function () {
									self.classList.remove('open');
									if (parentSelf) {
										parentSelf.classList.add('scroll');
									}

									// если все вложенные меню закрыты снимаем класс со всего меню
									checkAllSublistClosed.length = 0;
									hamburgerMenuToggles.forEach(function (toggle) {
										checkAllSublistClosed.push(!toggle.classList.contains('open'));
									});
									if (checkAllSublistClosed.every(function (check) {
										return check;
									})) {
										hamburgerMenuContainer.classList.add('scroll');
										hamburgerMenu.classList.remove('open');
										hamburgerMenuToggles.forEach(function (elem) {
											elem.classList.remove('scroll');
										});
									}
								});
							});
						});

						// закрыть уровни мобильного меню каталога
						vm.initMenu.closeAll = function () {
							hamburgerMenuAll.forEach(function (menu) {
								menu.classList.remove('open');
							});
							hamburgerMenuToggles.forEach(function (elem) {
								elem.classList.remove('open');
							});
						};

						setTimeout(() => {
							controller.events.on('close-hamburger-menu', vm.initMenu.closeAll);
						});
					});
				}
			},
			closeAll() {
				controller.closeAll();
			},
		}
	};

	const _hoisted_1$1u = { class: "v-hamburger-menu hamburger-menu js-hamburger-menu" };
	const _hoisted_2$1n = {
	  key: 0,
	  class: "hamburger-menu__list"
	};
	const _hoisted_3$1d = { class: "hamburger-menu__item hamburger-menu__item--has-sunmenu js-hamburger-menu__item" };
	const _hoisted_4$12 = {
	  key: 0,
	  class: "hamburger-menu__toggle js-hamburger-menu__toggle"
	};
	const _hoisted_5$Z = { key: 1 };
	const _hoisted_6$U = { key: 1 };
	const _hoisted_7$M = {
	  key: 2,
	  class: "hamburger-menu__sub-list js-hamburger-menu__sub-list"
	};
	const _hoisted_8$G = { class: "hamburger-menu__item-back" };
	const _hoisted_9$E = { class: "hamburger-menu__btn-back js-hamburger-menu__btn-back" };
	const _hoisted_10$x = /*#__PURE__*/createVNode("i", { class: "hamburger-menu__btn-back-icon" }, [
	  /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	    /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-left" })
	  ])
	], -1 /* HOISTED */);
	const _hoisted_11$v = { class: "hamburger-menu__btn-back-text" };
	const _hoisted_12$u = { class: "hamburger-menu__sub-wrap" };
	const _hoisted_13$p = { class: "hamburger-menu__sub-item accordion accordion--native js-accordion" };
	const _hoisted_14$n = { class: "hamburger-menu__sub-toggle accordion__toggler js-accordion__toggler" };
	const _hoisted_15$k = { key: 1 };
	const _hoisted_16$j = {
	  key: 2,
	  class: "accordion__icon"
	};
	const _hoisted_17$g = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-down" })
	], -1 /* HOISTED */);
	const _hoisted_18$e = { class: "accordion__content js-accordion__content" };
	const _hoisted_19$c = { class: "accordion__content-wrap" };
	const _hoisted_20$a = { class: "hamburger-menu__child-list" };
	const _hoisted_21$a = { key: 1 };

	function render$1D(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_picture = resolveComponent("v-picture");

	  return (openBlock(), createBlock("nav", _hoisted_1$1u, [
	    ($data.menu)
	      ? (openBlock(), createBlock("ul", _hoisted_2$1n, [
	          (openBlock(true), createBlock(Fragment, null, renderList($data.menu.items, (item) => {
	            return (openBlock(), createBlock("li", _hoisted_3$1d, [
	              (item.items?.length || item.slot)
	                ? (openBlock(), createBlock("div", _hoisted_4$12, [
	                    (item.images)
	                      ? (openBlock(), createBlock(_component_v_picture, {
	                          key: 0,
	                          type: "middle",
	                          sources: item.images,
	                          alt: item.text,
	                          width: "76",
	                          height: "76"
	                        }, null, 8 /* PROPS */, ["sources", "alt"]))
	                      : createCommentVNode("v-if", true),
	                    (item.text)
	                      ? (openBlock(), createBlock("span", _hoisted_5$Z, toDisplayString(item.text), 1 /* TEXT */))
	                      : createCommentVNode("v-if", true)
	                  ]))
	                : (openBlock(), createBlock("a", {
	                    key: 1,
	                    class: "hamburger-menu__toggle",
	                    href: item.link,
	                    onClick: _cache[1] || (_cache[1] = (...args) => ($options.closeAll && $options.closeAll(...args)))
	                  }, [
	                    (item.images)
	                      ? (openBlock(), createBlock(_component_v_picture, {
	                          key: 0,
	                          type: "middle",
	                          sources: item.images,
	                          alt: item.text,
	                          width: "76",
	                          height: "76"
	                        }, null, 8 /* PROPS */, ["sources", "alt"]))
	                      : createCommentVNode("v-if", true),
	                    (item.text)
	                      ? (openBlock(), createBlock("span", _hoisted_6$U, toDisplayString(item.text), 1 /* TEXT */))
	                      : createCommentVNode("v-if", true)
	                  ], 8 /* PROPS */, ["href"])),
	              (item.items?.length || item.slot)
	                ? (openBlock(), createBlock("div", _hoisted_7$M, [
	                    createVNode("div", _hoisted_8$G, [
	                      createVNode("button", _hoisted_9$E, [
	                        _hoisted_10$x,
	                        createVNode("span", _hoisted_11$v, toDisplayString(item.text), 1 /* TEXT */)
	                      ]),
	                      createVNode("button", {
	                        class: "mobile-popup__close",
	                        onClick: _cache[2] || (_cache[2] = (...args) => ($options.closeAll && $options.closeAll(...args))),
	                        type: "button",
	                        "aria-label": "Закрыть меню каталога",
	                        title: "Закрыть меню каталога"
	                      })
	                    ]),
	                    createVNode("div", _hoisted_12$u, [
	                      (item.slot)
	                        ? renderSlot(_ctx.$slots, item.slot, { key: 0 })
	                        : createCommentVNode("v-if", true),
	                      (openBlock(true), createBlock(Fragment, null, renderList(item.items, (itemL2) => {
	                        return (openBlock(), createBlock("div", _hoisted_13$p, [
	                          (itemL2.items?.length)
	                            ? (openBlock(), createBlock(Fragment, { key: 0 }, [
	                                createVNode("div", _hoisted_14$n, [
	                                  (itemL2.images)
	                                    ? (openBlock(), createBlock(_component_v_picture, {
	                                        key: 0,
	                                        type: "middle",
	                                        sources: itemL2.images,
	                                        alt: itemL2.text,
	                                        width: "39",
	                                        height: "39"
	                                      }, null, 8 /* PROPS */, ["sources", "alt"]))
	                                    : createCommentVNode("v-if", true),
	                                  (itemL2.text)
	                                    ? (openBlock(), createBlock("span", _hoisted_15$k, toDisplayString(itemL2.text), 1 /* TEXT */))
	                                    : createCommentVNode("v-if", true),
	                                  (itemL2.items?.length)
	                                    ? (openBlock(), createBlock("i", _hoisted_16$j, [
	                                        _hoisted_17$g
	                                      ]))
	                                    : createCommentVNode("v-if", true)
	                                ]),
	                                createVNode("div", _hoisted_18$e, [
	                                  createVNode("div", _hoisted_19$c, [
	                                    createVNode("div", _hoisted_20$a, [
	                                      createVNode("a", {
	                                        class: "hamburger-menu__child-link hamburger-menu__child-link--all",
	                                        href: itemL2.link,
	                                        onClick: _cache[3] || (_cache[3] = (...args) => ($options.closeAll && $options.closeAll(...args)))
	                                      }, "Показать все", 8 /* PROPS */, ["href"]),
	                                      (openBlock(true), createBlock(Fragment, null, renderList(itemL2.items, (itemL3) => {
	                                        return (openBlock(), createBlock("a", {
	                                          class: ["hamburger-menu__child-link", {'hamburger-menu__child-link--all': itemL3.all}],
	                                          href: itemL3.link,
	                                          onClick: _cache[4] || (_cache[4] = (...args) => ($options.closeAll && $options.closeAll(...args)))
	                                        }, toDisplayString(itemL3.text), 11 /* TEXT, CLASS, PROPS */, ["href"]))
	                                      }), 256 /* UNKEYED_FRAGMENT */))
	                                    ])
	                                  ])
	                                ])
	                              ], 64 /* STABLE_FRAGMENT */))
	                            : (openBlock(), createBlock("a", {
	                                key: 1,
	                                class: "hamburger-menu__sub-toggle",
	                                href: itemL2.link,
	                                onClick: _cache[5] || (_cache[5] = (...args) => ($options.closeAll && $options.closeAll(...args)))
	                              }, [
	                                (itemL2.images)
	                                  ? (openBlock(), createBlock(_component_v_picture, {
	                                      key: 0,
	                                      type: "middle",
	                                      sources: itemL2.images,
	                                      alt: itemL2.text,
	                                      width: "39",
	                                      height: "39"
	                                    }, null, 8 /* PROPS */, ["sources", "alt"]))
	                                  : createCommentVNode("v-if", true),
	                                (itemL2.text)
	                                  ? (openBlock(), createBlock("span", _hoisted_21$a, toDisplayString(itemL2.text), 1 /* TEXT */))
	                                  : createCommentVNode("v-if", true)
	                              ], 8 /* PROPS */, ["href"]))
	                        ]))
	                      }), 256 /* UNKEYED_FRAGMENT */))
	                    ])
	                  ]))
	                : createCommentVNode("v-if", true)
	            ]))
	          }), 256 /* UNKEYED_FRAGMENT */))
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1B.render = render$1D;
	script$1B.__file = "local/assets/source/components/v-hamburger-menu.vue";

	var script$1C = {
		data() {
			return {
				menu: null,
			};
		},

		created() {
			controller.events.on('navigation-updated', this.getData);
		},

		methods: {
			getData() {
				this.menu = controller.navigationData;
			},
		}
	};

	const _hoisted_1$1v = { class: "v-footer-catalog page-footer__catalog-list" };
	const _hoisted_2$1o = {
	  key: 0,
	  class: "page-footer__catalog-grid"
	};
	const _hoisted_3$1e = { class: "page-footer__catalog-cell" };

	function render$1E(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$1v, [
	    ($data.menu)
	      ? (openBlock(), createBlock("div", _hoisted_2$1o, [
	          (openBlock(true), createBlock(Fragment, null, renderList($data.menu.items, (item) => {
	            return (openBlock(), createBlock("div", _hoisted_3$1e, [
	              createVNode("a", {
	                class: "page-footer__catalog-link",
	                href: item.link
	              }, toDisplayString(item.text), 9 /* TEXT, PROPS */, ["href"])
	            ]))
	          }), 256 /* UNKEYED_FRAGMENT */))
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1C.render = render$1E;
	script$1C.__file = "local/assets/source/components/v-footer-catalog.vue";

	var script$1D = {
		mixins: [
			script$2
		],

		data() {
			return {
				menu: null,
			};
		},

		methods: {
			dataSet(data) {
				this.menu = data;

				this.$nextTick(() => {
					controller.menuUpdated(data);
					View.initAllLocal(this.$el);
				});
			},
		}
	};

	const _hoisted_1$1w = { class: "v-footer-menu page-footer__menu-grid" };
	const _hoisted_2$1p = { class: "page-footer__menu-cell" };
	const _hoisted_3$1f = {
	  class: "page-footer__block flc accordion accordion--native js-accordion--adaptive",
	  "data-max-width": "1023"
	};
	const _hoisted_4$13 = { class: "page-footer__block-title flc accordion__toggler js-accordion__toggler" };
	const _hoisted_5$_ = /*#__PURE__*/createVNode("i", { class: "accordion__icon" }, [
	  /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	    /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-down" })
	  ])
	], -1 /* HOISTED */);
	const _hoisted_6$V = {
	  key: 0,
	  class: "page-footer__block-body flc accordion__content js-accordion__content"
	};
	const _hoisted_7$N = { class: "accordion__content-wrap" };
	const _hoisted_8$H = { class: "page-footer-menu" };
	const _hoisted_9$F = { class: "page-footer-menu__item" };

	function render$1F(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$1w, [
	    ($data.menu)
	      ? (openBlock(true), createBlock(Fragment, { key: 0 }, renderList($data.menu.items, (item) => {
	          return (openBlock(), createBlock("div", _hoisted_2$1p, [
	            createVNode("div", _hoisted_3$1f, [
	              createVNode("div", _hoisted_4$13, [
	                createTextVNode(toDisplayString(item.text), 1 /* TEXT */),
	                _hoisted_5$_
	              ]),
	              (item.items?.length)
	                ? (openBlock(), createBlock("div", _hoisted_6$V, [
	                    createVNode("div", _hoisted_7$N, [
	                      createVNode("ul", _hoisted_8$H, [
	                        (openBlock(true), createBlock(Fragment, null, renderList(item.items, (itemL2) => {
	                          return (openBlock(), createBlock("li", _hoisted_9$F, [
	                            createVNode("a", {
	                              class: "page-footer-menu__link",
	                              href: itemL2.link
	                            }, toDisplayString(itemL2.text), 9 /* TEXT, PROPS */, ["href"])
	                          ]))
	                        }), 256 /* UNKEYED_FRAGMENT */))
	                      ])
	                    ])
	                  ]))
	                : createCommentVNode("v-if", true)
	            ])
	          ]))
	        }), 256 /* UNKEYED_FRAGMENT */))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1D.render = render$1F;
	script$1D.__file = "local/assets/source/components/v-footer-menu.vue";

	var script$1E = {
		data() {
			return {
				menu: null,
			};
		},

		created() {
			controller.events.on('menu-updated', this.getData);
		},

		methods: {
			getData() {
				this.menu = controller.menuData;
			},

			click() {
				document.documentElement.classList.remove('open-site-menu');
			}
		}
	};

	const _hoisted_1$1x = { class: "v-site-menu site-menu" };
	const _hoisted_2$1q = {
	  key: 0,
	  class: "site-menu__list"
	};
	const _hoisted_3$1g = { class: "site-menu__item" };

	function render$1G(_ctx, _cache, $props, $setup, $data, $options) {
	  return (openBlock(), createBlock("div", _hoisted_1$1x, [
	    ($data.menu)
	      ? (openBlock(), createBlock("div", _hoisted_2$1q, [
	          (openBlock(true), createBlock(Fragment, null, renderList($data.menu.items, (item) => {
	            return (openBlock(), createBlock("div", _hoisted_3$1g, [
	              (item.text)
	                ? (openBlock(), createBlock("a", {
	                    key: 0,
	                    class: "site-menu__caption",
	                    href: item.link,
	                    onClick: _cache[1] || (_cache[1] = (...args) => ($options.click && $options.click(...args)))
	                  }, toDisplayString(item.text), 9 /* TEXT, PROPS */, ["href"]))
	                : createCommentVNode("v-if", true),
	              (openBlock(true), createBlock(Fragment, null, renderList(item.items, (itemL2) => {
	                return (openBlock(), createBlock("a", {
	                  class: "site-menu__link",
	                  href: itemL2.link,
	                  onClick: _cache[2] || (_cache[2] = (...args) => ($options.click && $options.click(...args)))
	                }, toDisplayString(itemL2.text), 9 /* TEXT, PROPS */, ["href"]))
	              }), 256 /* UNKEYED_FRAGMENT */))
	            ]))
	          }), 256 /* UNKEYED_FRAGMENT */))
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1E.render = render$1G;
	script$1E.__file = "local/assets/source/components/v-site-menu.vue";

	var script$1F = {
		mixins: [script$2, script$y],


		data() {
			return {
				content: null,
			}
		},

		methods: {
			dataSet(data) {
				this.content = data;
			}
		},
	};

	const _hoisted_1$1y = {
	  key: 0,
	  class: "v-brand-products brands__products"
	};
	const _hoisted_2$1r = { class: "brands__product" };
	const _hoisted_3$1h = { class: "brands__product-visual" };
	const _hoisted_4$14 = {
	  key: 0,
	  class: "brands__product-price"
	};
	const _hoisted_5$$ = { class: "brands__price-prefix" };
	const _hoisted_6$W = { class: "brands__price-value" };
	const _hoisted_7$O = { class: "brands__price-large" };
	const _hoisted_8$I = { class: "brands__price-small" };
	const _hoisted_9$G = {
	  key: 1,
	  class: "brands__product-price"
	};
	const _hoisted_10$y = { class: "brands__price-prefix" };
	const _hoisted_11$w = { class: "brands__price-value" };
	const _hoisted_12$v = { class: "brands__price-large" };
	const _hoisted_13$q = { class: "brands__price-small" };

	function render$1H(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_picture = resolveComponent("v-picture");

	  return ($data.content?.items?.length)
	    ? (openBlock(), createBlock("div", _hoisted_1$1y, [
	        (openBlock(true), createBlock(Fragment, null, renderList($data.content.items, (product) => {
	          return (openBlock(), createBlock("div", _hoisted_2$1r, [
	            createVNode("a", {
	              class: "brands__product-link",
	              href: product.link
	            }, null, 8 /* PROPS */, ["href"]),
	            createVNode("div", _hoisted_3$1h, [
	              (product.imageSources)
	                ? (openBlock(), createBlock(_component_v_picture, {
	                    key: 0,
	                    sources: product.imageSources,
	                    alt: product.name,
	                    width: 72,
	                    height: 97
	                  }, null, 8 /* PROPS */, ["sources", "alt"]))
	                : createCommentVNode("v-if", true)
	            ]),
	            (product?.price?.current)
	              ? (openBlock(), createBlock("div", _hoisted_4$14, [
	                  createVNode("div", _hoisted_5$$, toDisplayString(product.price.current.prefix), 1 /* TEXT */),
	                  createVNode("div", _hoisted_6$W, [
	                    createVNode("div", _hoisted_7$O, toDisplayString(Math.floor(product.price.current.value)), 1 /* TEXT */),
	                    createVNode("div", _hoisted_8$I, toDisplayString(_ctx.getPriceCoins(product.price.current.value)) + " " + toDisplayString(product.price.current.currency), 1 /* TEXT */)
	                  ])
	                ]))
	              : (product?.price?.min)
	                ? (openBlock(), createBlock("div", _hoisted_9$G, [
	                    createVNode("div", _hoisted_10$y, toDisplayString(product.price.min.prefix), 1 /* TEXT */),
	                    createVNode("div", _hoisted_11$w, [
	                      createVNode("div", _hoisted_12$v, toDisplayString(Math.floor(product.price.min.value)), 1 /* TEXT */),
	                      createVNode("div", _hoisted_13$q, toDisplayString(_ctx.getPriceCoins(product.price.min.value)) + " " + toDisplayString(product.price.min.currency), 1 /* TEXT */)
	                    ])
	                  ]))
	                : createCommentVNode("v-if", true)
	          ]))
	        }), 256 /* UNKEYED_FRAGMENT */))
	      ]))
	    : createCommentVNode("v-if", true)
	}

	script$1F.render = render$1H;
	script$1F.__file = "local/assets/source/components/v-brand-products.vue";

	var simpleZoomVars = {
		zoomOffsetX: 0,
		zoomOffsetY: 0,
		zoomImageWidth: 0,
		zoomImageHeight: 0,
		zoomOriginalWidth: 0,
		zoomOriginalHeight: 0,
		zoomTarget: null
	};

	var script$1G = {
		components: {
			'v-swiper-slide': SwiperSlide
		},

		props: {
			slides: {
				type: Array,
				default: []
			},
			zoom: {
				type: Boolean,
				default: true
			},
			zoomViewerWidth: {
				default: null
			},
			zoomViewerHeight: {
				default: null
			},
		},

		data() {
			return {
				uniqueId: uniqueId('gallery-'),
				zoomActive: false,
				zoomLoaded: false,
				zoomLensX: 0,
				zoomLensY: 0,
				zoomLensWidth: 0,
				zoomLensHeight: 0,
				currentIndex: 0,
			};
		},

		computed: {
			computedDataGallery() {
				let data = {
					previews: false,
					items: []
				};
				data.items = this.slides.map((item) => {
					return {
						type: item.video ? 'iframe' : 'image',
						poster: null,
						src: item.video ? item.video : item.orig,
						note: null
					};
				});
				return JSON.stringify(data);
			},

			computedOptions() {
				let result = {
					watchOverflow: true,
					slidesPerView: 1,
					spaceBetween: 0,
					loop: false
				};
				return result;
			},

			computedOptionsThumbs() {
				let result = {
					watchOverflow: true,
					slidesPerView: 7,
					spaceBetween: 7,
					loop: false,
					direction: 'vertical',
					height: 399,
					// watchSlidesProgress: true,
					// если слайдов не хватает для скролла - центровать те что есть, не совместим с бесконечным скролом
					// centerInsufficientSlides: false,
				};
				return result;
			},
		},

		methods: {
			slideChange(swiper) {
				this.currentIndex = swiper.activeIndex;
			},

			zoomMove: function (e) {
				simpleZoomVars.zoomOffsetX = e.offsetX;
				simpleZoomVars.zoomOffsetY = e.offsetY;
				simpleZoomVars.zoomTarget = e.target;

				if (requestAnimationFrame)
					requestAnimationFrame(this.zoomMoveSet);
				else
					zoomMoveSet();

				e.preventDefault();
			},

			zoomMoveSet: function () {
				var inst = this;

				var scaleX = Math.min(inst.zoomViewerWidth / simpleZoomVars.zoomOriginalWidth, 1);
				var scaleY = Math.min(inst.zoomViewerHeight / simpleZoomVars.zoomOriginalHeight, 1);
				inst.zoomLensWidth = simpleZoomVars.zoomImageWidth * scaleX;
				inst.zoomLensHeight = simpleZoomVars.zoomImageHeight * scaleY;

				// if (scale < 1)
				// 	inst.zoomLensHeight *= inst.zoomViewerHeight / inst.zoomViewerWidth;
				inst.zoomLensHeight = Math.round(inst.zoomLensHeight);
				inst.zoomLensWidth = Math.round(inst.zoomLensWidth);

				inst.zoomLensX = simpleZoomVars.zoomOffsetX - inst.zoomLensWidth / 2;
				inst.zoomLensY = simpleZoomVars.zoomOffsetY - inst.zoomLensHeight / 2;

				if (inst.zoomLensX < 0)
					inst.zoomLensX = 0;
				if (inst.zoomLensX + inst.zoomLensWidth > simpleZoomVars.zoomImageWidth)
					inst.zoomLensX = simpleZoomVars.zoomImageWidth - inst.zoomLensWidth;

				if (inst.zoomLensY < 0)
					inst.zoomLensY = 0;
				if (inst.zoomLensY + inst.zoomLensHeight > simpleZoomVars.zoomImageHeight)
					inst.zoomLensY = simpleZoomVars.zoomImageHeight - inst.zoomLensHeight;

				inst.$emit('zoomMove', inst.zoomLensX / simpleZoomVars.zoomImageWidth, inst.zoomLensY / simpleZoomVars.zoomImageHeight);
			},

			zoomShow: function (e) {
				var inst = this;

				if (!controller.touch && window.innerWidth > breakpoints['sm-max']) {
					this.$nextTick(function () {
						inst.zoomActive = true;
						simpleZoomVars.zoomImageWidth = e.target.offsetWidth;
						simpleZoomVars.zoomImageHeight = e.target.offsetHeight;

						if (!inst.zoomLoaded) {
							var testImage = new Image();

							testImage.onload = function () {
								simpleZoomVars.zoomOriginalWidth = testImage.width;
								simpleZoomVars.zoomOriginalHeight = testImage.height;

								if (simpleZoomVars.zoomOriginalWidth < simpleZoomVars.zoomImageWidth * 1.5 &&
									simpleZoomVars.zoomOriginalHeight < simpleZoomVars.zoomImageHeight * 1.5) {
									inst.zoomActive = false;
									return;
								}

								inst.zoomLoaded = true;

								inst.$emit('zoomActivated', inst.slides[inst.currentIndex]);
							};

							testImage.src = inst.slides[inst.currentIndex].orig;
						} else {
							inst.$emit('zoomActivated', inst.slides[this.currentIndex]);
						}
					});
				}
			},

			zoomHide: function (e) {
				this.zoomActive = false;
				this.zoomLoaded = false;
				this.$emit('zoomDeactivated');

			},
		}
	};

	const _hoisted_1$1z = { class: "image-gallery__video-icon" };
	const _hoisted_2$1s = {
	  key: 0,
	  class: "svg-icon"
	};
	const _hoisted_3$1i = /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-play" }, null, -1 /* HOISTED */);
	const _hoisted_4$15 = {
	  key: 2,
	  class: "image-gallery__image-wrap"
	};
	const _hoisted_5$10 = {
	  key: 0,
	  class: "svg-icon"
	};
	const _hoisted_6$X = /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-play" }, null, -1 /* HOISTED */);

	function render$1I(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_swiper_slide = resolveComponent("v-swiper-slide");
	  const _component_v_swiper_slider = resolveComponent("v-swiper-slider");

	  return (openBlock(), createBlock("section", {
	    class: ["v-image-gallery image-gallery", {'image-gallery--zoom-active': $data.zoomActive && $data.zoomLoaded}]
	  }, [
	    ($props.slides?.length)
	      ? (openBlock(), createBlock(_component_v_swiper_slider, {
	          class: "image-gallery__gallery",
	          options: $options.computedOptions,
	          "options-thumbs": $options.computedOptionsThumbs,
	          pagination: {clickable: false},
	          onSlideChange: $options.slideChange,
	          "inner-navigation": "inner-navigation",
	          ref: "gallery",
	          key: $data.uniqueId,
	          thumbs: "thumbs"
	        }, createSlots({
	          main: withCtx(() => [
	            (openBlock(true), createBlock(Fragment, null, renderList($props.slides, (slide, index) => {
	              return (openBlock(), createBlock(_component_v_swiper_slide, {
	                class: ["image-gallery__gallery-slide", {'image-gallery__gallery-slide--video': slide.video}],
	                key: index
	              }, {
	                default: withCtx(() => [
	                  (slide.video)
	                    ? (openBlock(), createBlock("div", {
	                        key: 0,
	                        class: "image-gallery__video js-open-modal-gallery",
	                        "data-gallery": $options.computedDataGallery,
	                        "data-initialindex": index
	                      }, [
	                        createVNode("div", _hoisted_1$1z, [
	                          (slide.video)
	                            ? (openBlock(), createBlock("svg", _hoisted_2$1s, [
	                                _hoisted_3$1i
	                              ]))
	                            : createCommentVNode("v-if", true)
	                        ])
	                      ], 8 /* PROPS */, ["data-gallery", "data-initialindex"]))
	                    : createCommentVNode("v-if", true),
	                  (slide.video)
	                    ? (openBlock(), createBlock("img", {
	                        key: 1,
	                        class: "image-gallery__gallery-slide-image",
	                        src: slide.orig,
	                        loading: "lazy",
	                        decoding: "async",
	                        alt: ""
	                      }, null, 8 /* PROPS */, ["src"]))
	                    : (openBlock(), createBlock("div", _hoisted_4$15, [
	                        createVNode("img", {
	                          class: "image-gallery__gallery-slide-image js-open-modal-gallery",
	                          src: slide.big,
	                          loading: "lazy",
	                          decoding: "async",
	                          alt: "",
	                          "data-gallery": $options.computedDataGallery,
	                          "data-initialindex": index,
	                          onMouseenter: _cache[1] || (_cache[1] = (...args) => ($options.zoomShow && $options.zoomShow(...args))),
	                          onMouseleave: _cache[2] || (_cache[2] = (...args) => ($options.zoomHide && $options.zoomHide(...args))),
	                          onMousemove: _cache[3] || (_cache[3] = (...args) => ($options.zoomMove && $options.zoomMove(...args)))
	                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, ["src", "data-gallery", "data-initialindex"]),
	                        createVNode("div", {
	                          class: "image-gallery__lens",
	                          style: {left: $data.zoomLensX + 'px', top: $data.zoomLensY + 'px', width: $data.zoomLensWidth + 'px', height: $data.zoomLensHeight + 'px'}
	                        }, null, 4 /* STYLE */)
	                      ]))
	                ]),
	                _: 2 /* DYNAMIC */
	              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"]))
	            }), 128 /* KEYED_FRAGMENT */))
	          ]),
	          _: 2 /* DYNAMIC */
	        }, [
	          ($props.slides.length > 1)
	            ? {
	                name: "thumbs",
	                fn: withCtx(() => [
	                  (openBlock(true), createBlock(Fragment, null, renderList($props.slides, (slide, index) => {
	                    return (openBlock(), createBlock(_component_v_swiper_slide, {
	                      class: "image-gallery__gallery-thumb",
	                      key: index + 'thumb'
	                    }, {
	                      default: withCtx(() => [
	                        (slide.video)
	                          ? (openBlock(), createBlock("svg", _hoisted_5$10, [
	                              _hoisted_6$X
	                            ]))
	                          : createCommentVNode("v-if", true),
	                        (slide.video)
	                          ? (openBlock(), createBlock("img", {
	                              key: 1,
	                              class: "image-gallery__gallery-thumb-image",
	                              src: slide.orig,
	                              loading: "lazy",
	                              decoding: "async",
	                              alt: ""
	                            }, null, 8 /* PROPS */, ["src"]))
	                          : (openBlock(), createBlock("img", {
	                              key: 2,
	                              class: "image-gallery__gallery-thumb-image",
	                              src: slide.small,
	                              loading: "lazy",
	                              decoding: "async",
	                              alt: ""
	                            }, null, 8 /* PROPS */, ["src"]))
	                      ]),
	                      _: 2 /* DYNAMIC */
	                    }, 1024 /* DYNAMIC_SLOTS */))
	                  }), 128 /* KEYED_FRAGMENT */))
	                ])
	              }
	            : undefined
	        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["options", "options-thumbs", "onSlideChange"]))
	      : createCommentVNode("v-if", true)
	  ], 2 /* CLASS */))
	}

	script$1G.render = render$1I;
	script$1G.__file = "local/assets/source/components/v-image-gallery.vue";

	var script$1H = {
		data() {
			return {
				isMd: false,
				isSm: false,
				isXs: false
			};
		},

		created() {
			this.getIsMob(true);
			window.addEventListener('resize', this.getIsMob);
		},

		unmounted() {
			window.removeEventListener('resize', this.getIsMob);
		},

		methods: {
			checkBreakpoints() {
				this.isMd = window.innerWidth <= breakpoints['md-max'];
				this.isSm = window.innerWidth <= breakpoints['sm-max'];
				this.isXs = window.innerWidth <= breakpoints['xs-max'];
			},

			getIsMob(immediately) {
				if (immediately) {
					this.checkBreakpoints();
				} else {
					clearTimeout(this.isMobTimeout);
					this.isMobTimeout = setTimeout(() => {
						this.checkBreakpoints();
					}, 500);
				}
			}
		}
	};

	const render$1J = () => {};


	script$1H.render = render$1J;
	script$1H.__file = "local/assets/source/components/mixins/v-mixin-is-mob.vue";

	var script$1I = {
		mixins: [
			script$2,
			script$1H
		],

		data() {
			return {
				panel: null,
				open: true,
				userCloseBanner: 0,
			};
		},

		computed: {
		  
			...mapGetters$1({
				userAuthorized: 'user/userAuthorized'
			}),
	  
		},
		methods: {
			getCookie(name) {
				let matches = document.cookie.match(new RegExp(
					"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
				));
				return matches ? decodeURIComponent(matches[1]) : false;
			},

			setCookie(name, value, options = {}) {
				options = {
					path: '/',
					...options
				};
				if (options.expires instanceof Date) {
					options.expires = options.expires.toUTCString();
				}
				let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
				for (let optionKey in options) {
					updatedCookie += '; ' + optionKey;
					let optionValue = options[optionKey];
					if (optionValue !== true) {
						updatedCookie += '=' + optionValue;
					}
				}
				document.cookie = updatedCookie;
			},

			deleteCookie(name) {
				this.setCookie(name, '', {'max-age': -1});
			},

			confirm(showBonusHelp = false) {
				const expiresDays = this.panel.cookieData.expiresDays;
				const date = new Date(Date.now() + (expiresDays * 24 * 60 * 60 * 1000));
				this.setCookie(this.panel.cookieData.variable, this.panel.cookieData.value, {
					expires: date.toUTCString()
				});
				this.open = false;
				if (showBonusHelp && this.panel.button && this.panel.button.link) {
					console.log('this.panel.button.link', this.panel.button.link);
					document.location = this.panel.button.link;
				}
			},

			dataSet(data) {
				this.panel = data;
				if (this.panel.cookieData){
					this.userCloseBanner = parseInt(this.getCookie(this.panel.cookieData.variable ));
				}
			}
		}
	};

	const _hoisted_1$1A = { class: "confirm-panel__container container" };
	const _hoisted_2$1t = { class: "confirm-panel__text" };
	const _hoisted_3$1j = {
	  key: 0,
	  class: "confirm-panel__action"
	};
	const _hoisted_4$16 = /*#__PURE__*/createVNode("svg", { class: "confirm-panel__action-close-icon svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-confirm-close" })
	], -1 /* HOISTED */);

	function render$1K(_ctx, _cache, $props, $setup, $data, $options) {
	  return ($data.panel && !_ctx.userAuthorized && !$data.userCloseBanner)
	    ? (openBlock(), createBlock("div", {
	        key: 0,
	        class: ["v-confirm-panel confirm-panel", {'open': $data.open}]
	      }, [
	        createVNode("div", _hoisted_1$1A, [
	          createVNode("div", {
	            class: "confirm-panel__main",
	            style: {'background-image': `url(${_ctx.isXs ? $data.panel.backgroundMob : $data.panel.background})`}
	          }, [
	            createVNode("div", _hoisted_2$1t, toDisplayString($data.panel.text), 1 /* TEXT */),
	            ($data.panel.button)
	              ? (openBlock(), createBlock("div", _hoisted_3$1j, [
	                  createVNode("button", {
	                    class: "confirm-panel__action-btn btn btn--primary",
	                    type: "button",
	                    onClick: _cache[1] || (_cache[1] = $event => ($options.confirm(true)))
	                  }, toDisplayString($data.panel.button.text), 1 /* TEXT */)
	                ]))
	              : createCommentVNode("v-if", true),
	            createVNode("button", {
	              class: "confirm-panel__action-close",
	              "aria-label": "Закрыть",
	              onClick: _cache[2] || (_cache[2] = withModifiers($event => ($options.confirm(false)), ["prevent"]))
	            }, [
	              _hoisted_4$16
	            ])
	          ], 4 /* STYLE */)
	        ])
	      ], 2 /* CLASS */))
	    : createCommentVNode("v-if", true)
	}

	script$1I.render = render$1K;
	script$1I.__file = "local/assets/source/components/v-confirm-panel.vue";

	var script$1J = {
		mixins: [
			script$2
		],

		data() {
			return {
				discountModal: null
			}
		},

		methods: {
			dataSet(data) {
				this.discountModal = data;
			}
		}
	};

	const _hoisted_1$1B = {
	  key: 0,
	  class: "v-discount-modal discount-modal"
	};
	const _hoisted_2$1u = {
	  key: 0,
	  class: "discount-modal__discount-blocks"
	};
	const _hoisted_3$1k = { class: "discount-block" };
	const _hoisted_4$17 = {
	  key: 1,
	  class: "discount-modal__discount-small-card flc"
	};
	const _hoisted_5$11 = { class: "discount-small-card__label" };
	const _hoisted_6$Y = { class: "discount-small-card__title" };
	const _hoisted_7$P = { class: "discount-small-card__text" };
	const _hoisted_8$J = {
	  key: 2,
	  class: "discount-modal__action"
	};
	const _hoisted_9$H = { class: "btn__text" };
	const _hoisted_10$z = /*#__PURE__*/createVNode("svg", { class: "btn__icon svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-long" })
	], -1 /* HOISTED */);

	function render$1L(_ctx, _cache, $props, $setup, $data, $options) {
	  return ($data.discountModal)
	    ? (openBlock(), createBlock("div", _hoisted_1$1B, [
	        ($data.discountModal.discountBlocks)
	          ? (openBlock(), createBlock("div", _hoisted_2$1u, [
	              (openBlock(true), createBlock(Fragment, null, renderList($data.discountModal.discountBlocks, (item, index) => {
	                return (openBlock(), createBlock("div", {
	                  key: index,
	                  class: "discount-modal__discount-block flc"
	                }, [
	                  createVNode("div", _hoisted_3$1k, [
	                    createVNode("div", {
	                      class: "discount-block__value",
	                      style: 'background: ' + item.background
	                    }, toDisplayString(item.value), 5 /* TEXT, STYLE */),
	                    createVNode("div", {
	                      class: "discount-block__text",
	                      innerHTML: item.text
	                    }, null, 8 /* PROPS */, ["innerHTML"])
	                  ])
	                ]))
	              }), 128 /* KEYED_FRAGMENT */))
	            ]))
	          : createCommentVNode("v-if", true),
	        ($data.discountModal.discountCard)
	          ? (openBlock(), createBlock("div", _hoisted_4$17, [
	              createVNode("div", {
	                class: "discount-small-card",
	                style: 'background: ' + $data.discountModal.discountCard.background
	              }, [
	                createVNode("div", _hoisted_5$11, toDisplayString($data.discountModal.discountCard.label), 1 /* TEXT */),
	                createVNode("div", _hoisted_6$Y, toDisplayString($data.discountModal.discountCard.title), 1 /* TEXT */),
	                createVNode("div", _hoisted_7$P, toDisplayString($data.discountModal.discountCard.text), 1 /* TEXT */)
	              ], 4 /* STYLE */)
	            ]))
	          : createCommentVNode("v-if", true),
	        createVNode("div", {
	          class: "discount-modal__description text-guide flc",
	          innerHTML: $data.discountModal.description
	        }, null, 8 /* PROPS */, ["innerHTML"]),
	        ($data.discountModal.link)
	          ? (openBlock(), createBlock("div", _hoisted_8$J, [
	              createVNode("a", {
	                class: "btn btn--primary btn--full btn--lg",
	                href: $data.discountModal.link.link
	              }, [
	                createVNode("div", _hoisted_9$H, toDisplayString($data.discountModal.link.text), 1 /* TEXT */),
	                _hoisted_10$z
	              ], 8 /* PROPS */, ["href"])
	            ]))
	          : createCommentVNode("v-if", true)
	      ]))
	    : createCommentVNode("v-if", true)
	}

	script$1J.render = render$1L;
	script$1J.__file = "local/assets/source/components/v-discount-modal.vue";

	// install Swiper components
	Swiper.use([
		Navigation$1,
		Pagination$1,
		Controller$2,
		A11y$1,
		Thumbs$1
	]);

	// Import Swiper styles
	var script$1K = {
		components: {
			'v-swiper': Swiper$1
		},

		emits: ['slideChange'],

		props: {
			options: {
				type: Object,
				default: null
			},

			optionsThumbs: {
				type: Object,
				default: null
			},

			thumbs: {
				type: Boolean,
				default: false
			},

			pagination: {
				type: [Boolean, Object],
				default: false
			},

			navigation: {
				type: [Boolean, Object],
				default: false
			},

			innerNavigation: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				sliderReady: false,
				uniqueId: uniqueId('swiper-slider_'),
				uniqueIdThumb: uniqueId('swiper-slider-thumb_'),
				thumbsSwiper: null,
				dataNavigation: {
					nextEl: null,
					prevEl: null
				},
				dataNavigationThumbs: {
					nextEl: null,
					prevEl: null
				}
			};
		},

		computed: {
			computedPagination() {
				if (!this.pagination) {
					return false;
				}
				return this.applyDefaults({
					dynamicBullets: 3,
					clickable: true
				}, this.pagination);
			},

			computedOptions() {
				return this.applyDefaults({
					watchOverflow: true,
					slidesPerView: 1,
					spaceBetween: 0,
					loop: false
				}, this.options);
			},

			computedOptionsThumbs() {
				return this.applyDefaults({
					watchOverflow: true,
					slidesPerView: 7,
					spaceBetween: 7,
					loop: false,
					direction: 'vertical',
					// если слайдов не хватает для скролла - центровать те что есть, не совместим с бесконечным скролом
					centerInsufficientSlides: true,
					height: 399,

				}, this.optionsThumbs);
			},
		},

		mounted() {
			this.sliderReady = true;
			this.$nextTick(() => {
				this.dataNavigationThumbs = {
					nextEl: this.$refs.nextArrowThumbs,
					prevEl: this.$refs.prevArrowThumbs
				};

				if (this.innerNavigation) {
					this.dataNavigation = {
						nextEl: this.$refs.nextArrow,
						prevEl: this.$refs.prevArrow
					};
				}
			});
		},

		methods: {
			applyDefaults(defaults, options) {
				if (options && typeof options === 'object') {
					Object.keys(options).forEach(key => {
						if (typeof options[key] !== 'undefined') {
							defaults[key] = options[key];
						}
					});
				}
				return defaults;
			},

			setThumbsSwiper(swiper) {
				this.thumbsSwiper = swiper;
			},

			slideChange(swiper) {
				this.$emit('slideChange', swiper);
			}
		}
	};

	const _hoisted_1$1C = { class: "v-swiper-slider swiper-slider" };
	const _hoisted_2$1v = {
	  key: 0,
	  class: "swiper-slider__thumbs-wrap"
	};
	const _hoisted_3$1l = {
	  class: "swiper-slider__thumb-arrow swiper-slider__thumb-arrow--prev",
	  ref: "prevArrowThumbs"
	};
	const _hoisted_4$18 = /*#__PURE__*/createVNode("svg", { class: "svg-icon swiper-slider__thumb-arrow-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-top-thumbs" })
	], -1 /* HOISTED */);
	const _hoisted_5$12 = {
	  class: "swiper-slider__thumb-arrow swiper-slider__thumb-arrow--next",
	  ref: "nextArrowThumbs"
	};
	const _hoisted_6$Z = /*#__PURE__*/createVNode("svg", { class: "svg-icon swiper-slider__thumb-arrow-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-bottom-thumbs" })
	], -1 /* HOISTED */);
	const _hoisted_7$Q = {
	  key: 0,
	  class: "swiper-slider__thumbs"
	};
	const _hoisted_8$K = {
	  key: 1,
	  class: "swiper-slider__slider"
	};
	const _hoisted_9$I = {
	  key: 0,
	  class: "swiper-slider__arrow swiper-slider__arrow--prev",
	  ref: "prevArrow"
	};
	const _hoisted_10$A = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-left-slider" })
	], -1 /* HOISTED */);
	const _hoisted_11$x = {
	  key: 1,
	  class: "swiper-slider__arrow swiper-slider__arrow--next",
	  ref: "nextArrow"
	};
	const _hoisted_12$w = /*#__PURE__*/createVNode("svg", { class: "svg-icon" }, [
	  /*#__PURE__*/createVNode("use", { "xlink:href": "/local/assets/dist/icons/sprite.svg#svg-icon-arrow-right-slider" })
	], -1 /* HOISTED */);

	function render$1M(_ctx, _cache, $props, $setup, $data, $options) {
	  const _component_v_swiper = resolveComponent("v-swiper");

	  return (openBlock(), createBlock("div", _hoisted_1$1C, [
	    ($props.thumbs)
	      ? (openBlock(), createBlock("div", _hoisted_2$1v, [
	          createVNode("div", _hoisted_3$1l, [
	            _hoisted_4$18
	          ], 512 /* NEED_PATCH */),
	          createVNode("div", _hoisted_5$12, [
	            _hoisted_6$Z
	          ], 512 /* NEED_PATCH */),
	          ($data.sliderReady)
	            ? (openBlock(), createBlock("div", _hoisted_7$Q, [
	                createVNode(_component_v_swiper, mergeProps($options.computedOptionsThumbs, {
	                  id: $data.uniqueIdThumb,
	                  navigation: $data.dataNavigationThumbs,
	                  "watch-slides-visibility": "watch-slides-visibility",
	                  "watch-slides-progress": "watch-slides-progress",
	                  onSwiper: $options.setThumbsSwiper
	                }), {
	                  default: withCtx(() => [
	                    renderSlot(_ctx.$slots, "thumbs")
	                  ]),
	                  _: 3 /* FORWARDED */
	                }, 16 /* FULL_PROPS */, ["id", "navigation", "onSwiper"])
	              ]))
	            : createCommentVNode("v-if", true)
	        ]))
	      : createCommentVNode("v-if", true),
	    ($data.sliderReady)
	      ? (openBlock(), createBlock("div", _hoisted_8$K, [
	          ($props.innerNavigation)
	            ? (openBlock(), createBlock("div", _hoisted_9$I, [
	                _hoisted_10$A
	              ], 512 /* NEED_PATCH */))
	            : createCommentVNode("v-if", true),
	          ($props.innerNavigation)
	            ? (openBlock(), createBlock("div", _hoisted_11$x, [
	                _hoisted_12$w
	              ], 512 /* NEED_PATCH */))
	            : createCommentVNode("v-if", true),
	          createVNode(_component_v_swiper, mergeProps($options.computedOptions, {
	            navigation: $data.dataNavigation,
	            pagination: $options.computedPagination,
	            onSlideChange: $options.slideChange,
	            thumbs: $props.thumbs ? {swiper: $data.thumbsSwiper} : null,
	            id: $data.uniqueId
	          }), {
	            default: withCtx(() => [
	              renderSlot(_ctx.$slots, "main")
	            ]),
	            _: 3 /* FORWARDED */
	          }, 16 /* FULL_PROPS */, ["navigation", "pagination", "onSlideChange", "thumbs", "id"])
	        ]))
	      : createCommentVNode("v-if", true)
	  ]))
	}

	script$1K.render = render$1M;
	script$1K.__file = "local/assets/source/components/v-swiper-slider.vue";

	// helpers


	var components = {
		// helpers
		'v-scope': script,
		'v-source': script$1,
		'v-model-source': script$3,
		'v-loader': script$4,
		'v-picture': script$5,
		'v-image': script$6,
		'v-video': script$7,
		'v-lazy-component': script$8,
		'v-tooltip': script$9,

		// forms
		'v-form': script$a,
		'v-subscription-form': script$b,
		'v-field': script$c,
		'v-field-text': script$d,
		'v-field-select': script$e,
		'v-field-checkbox': script$f,
		'v-field-switch': script$g,
		'v-field-check-list': script$h,
		'v-field-count': script$i,
		'v-field-range': script$j,
		'v-field-range-slider': script$k,
		'v-field-file': script$l,
		'v-field-view-picker': script$m,
		'v-field-toggles': script$n,
		'v-field-colors': script$o,
		'v-field-radio-buttons': script$p,
		'v-field-number-range': script$q,
		'v-field-tooltip': script$r,
		'v-field-rating': script$s,
		'v-field-tumbler': script$t,
		'v-promocode': script$u,
		'v-delete-basket-item': script$v,
		'v-clean-basket': script$w,
		'v-copy-bonuses': script$x,
		'v-order': script$z,
		'v-my-data': script$A,

		// other
		'v-page-section': script$B,

		'v-page-loader': script$D,
		'v-page-section-header': script$E,
		'v-hero-block': script$G,
		'v-hero-slider': script$H,
		'v-main-banner': script$F,
		'v-price': script$I,
		'v-status': script$J,
		'v-label': script$K,
		'v-catalog': script$L,
		'v-filter': script$M,
		'v-product-slider-section': script$C,
		'v-page-nav': script$N,
		'v-main-nav': script$O,
		'v-page-header': script$P,
		'v-basket-small': script$Q,
		'v-basket-action': script$R,
		'v-favorite-action': script$S,
		'v-rating-action': script$T,
		'v-favorite-small': script$U,
		'v-product-grid': script$V,
		'v-product-slider': script$W,
		'v-product-discount': script$X,
		'v-brands': script$Y,
		'v-product': script$Z,
		'v-blog-preview': script$_,
		'v-blog-item': script$$,
		'v-product-image': script$10,
		'v-article-grid': script$11,
		'v-article-poster': script$12,
		'v-catalog-item-banners': script$13,
		'v-catalog-item': script$14,
		'v-search-small': script$15,
		'v-modal': script$16,
		'v-modal-window': script$18,
		'v-modal-message': script$19,
		'v-collapse': script$17,
		'v-gallery': script$1a,
		'v-brand-search': script$1b,
		'v-basket-big': script$1c,
		'v-basket-item': script$1d,
		'v-order-item': script$1e,
		'v-gift-short': script$1f,
		'v-reviews': script$1g,
		'v-review-item': script$1h,
		'v-shop-list': script$1i,
		'v-add-review': script$1j,
		'v-result-add-review': script$1k,
		'v-order-result': script$1l,
		'v-address-list': script$1m,
		'v-orders-history': script$1n,
		'v-order-product': script$1o,
		'v-subscribtion': script$1p,
		'v-subscribtion-item': script$1q,
		'v-favorite': script$1r,
		'v-user-menu': script$1s,
		'v-user-auth-banner': script$1t,
		'v-discount-block': script$1u,
		'v-mobile-toolbar': script$1v,
		'v-only-slider': script$1w,
		'v-brand-list': script$1x,
		'v-article-banner': script$1y,
		'v-contacts': script$1z,
		'v-random-html': script$1A,
		'v-hamburger-menu': script$1B,
		'v-footer-catalog': script$1C,
		'v-footer-menu': script$1D,
		'v-site-menu': script$1E,
		'v-brand-products': script$1F,
		'v-image-gallery': script$1G,
		'v-confirm-panel': script$1I,
		'v-discount-modal': script$1J,

		// plugins
		'v-swiper-slider': script$1K
	};

	/*!
	 * maska v1.3.2
	 * (c) 2019-2020 Alexander Shabunevich
	 * Released under the MIT License.
	 */
	function e(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function t(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}function n(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function r(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r);}return n}function a(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?r(Object(a),!0).forEach((function(t){n(e,t,a[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):r(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t));}));}return e}function o(e,t,n){var r=!(arguments.length>3&&void 0!==arguments[3])||arguments[3];return u(t).length>1?i(t)(e,t,n,r):s(e,t,n,r)}function u(e){try{return JSON.parse(e)}catch(t){return [e]}}function i(e){var t=u(e).sort((function(e,t){return e.length-t.length}));return function(e,n,r){for(var a=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],o=0;o<t.length;){var u=t[o];o++;var i=t[o];if(!(i&&s(e,i,r,!0).length>u.length))return s(e,u,r,a)}return ""}}function s(e,t,n){for(var r=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],a=0,o=0,u="",i="";a<t.length&&o<e.length;){var s=t[a],c=e[o],p=n[s];if(p&&p.pattern)p.pattern.test(c)&&(u+=l(c,p),a++,r&&t[a]&&!n[t[a]]&&(u+=t[a],a++)),o++;else if(p&&p.repeat){var f=n[t[a-1]];f&&!f.pattern.test(c)?a++:a--;}else p&&p.escape&&(s=t[++a]),r&&(u+=s),c===s&&o++,a++;}for(;r&&a<t.length;){var v=t[a];if(n[v]){i="";break}i+=v,a++;}return u+i}function l(e,t){return t.transform&&(e=t.transform(e)),t.uppercase?e.toLocaleUpperCase():t.lowercase?e.toLocaleLowerCase():e}var c={"#":{pattern:/[0-9]/},X:{pattern:/[0-9a-zA-Z]/},S:{pattern:/[a-zA-Z]/},A:{pattern:/[a-zA-Z]/,uppercase:!0},a:{pattern:/[a-zA-Z]/,lowercase:!0},"!":{escape:!0},"*":{repeat:!0}};function p$1(e){return e instanceof HTMLInputElement?e:e.querySelector("input")||e}function f(e){return "[object String]"===Object.prototype.toString.call(e)}var v=function(){function n(t){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(e(this,n),!t)throw new Error("Maska: no element for mask");if(r.tokens)for(var o in r.tokens)r.tokens[o]=a({},r.tokens[o]),r.tokens[o].pattern&&f(r.tokens[o].pattern)&&(r.tokens[o].pattern=new RegExp(r.tokens[o].pattern));this._opts={mask:r.mask,tokens:a(a({},c),r.tokens)},this._el=f(t)?document.querySelectorAll(t):t.length?t:[t],this.init();}var r,u;return r=n,(u=[{key:"init",value:function(){for(var e=this,t=0;t<this._el.length;t++){var n=p$1(this._el[t]);!this._opts.mask||n.dataset.mask&&n.dataset.mask===this._opts.mask||(n.dataset.mask=this._opts.mask),this.updateValue(n),n.dataset.maskInited||(n.dataset.maskInited=!0,n.addEventListener("input",(function(t){return e.updateValue(t.target,t)})),n.addEventListener("beforeinput",(function(t){return e.beforeInput(t)})));}}},{key:"destroy",value:function(){for(var e=this,t=0;t<this._el.length;t++){var n=p$1(this._el[t]);n.removeEventListener("input",(function(t){return e.updateValue(t.target,t)})),n.removeEventListener("beforeinput",(function(t){return e.beforeInput(t)})),delete n.dataset.mask,delete n.dataset.maskInited;}}},{key:"updateValue",value:function(e,t){var n=e.type.match(/^number$/i)&&e.validity.badInput;if((e.value||n)&&e.dataset.mask){var r=e.selectionEnd,a=e.value,u=a[r-1];e.value=o(e.value,e.dataset.mask,this._opts.tokens),t&&"insertText"===t.inputType&&r===a.length&&(r=e.value.length),function(e,t,n){for(;t&&t<e.value.length&&e.value.charAt(t-1)!==n;)t++;(e.type?e.type.match(/^(text|search|password|tel|url)$/i):!e.type)&&e===document.activeElement&&(e.setSelectionRange(t,t),setTimeout((function(){e.setSelectionRange(t,t);}),0));}(e,r,u),e.value!==a&&e.dispatchEvent(function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,n=document.createEvent("Event");return n.initEvent(e,!0,!0),t&&(n.inputType=t),n}("input",t&&t.inputType||null));}}},{key:"beforeInput",value:function(e){e.target.type.match(/^number$/i)&&e.data&&isNaN(e.target.value+e.data)&&e.preventDefault();}}])&&t(r.prototype,u),n}();function d(e,t){if(t.value)return t.value&&function(e){return !(f(e.value)&&e.value===e.oldValue||Array.isArray(e.value)&&JSON.stringify(e.value)===JSON.stringify(e.oldValue)||e.value&&e.value.mask&&e.oldValue&&e.oldValue.mask&&e.value.mask===e.oldValue.mask)}(t)?new v(e,function(e){var t={};return e.mask?(t.mask=Array.isArray(e.mask)?JSON.stringify(e.mask):e.mask,t.tokens=e.tokens?a({},e.tokens):{}):t.mask=Array.isArray(e)?JSON.stringify(e):e,t}(t.value)):void 0}function h$1(e){e.directive("maska",d);}"undefined"!=typeof window&&window.Vue&&window.Vue.use&&window.Vue.use(h$1);

	document.body.addEventListener('touchmove',function(e){
		e.preventDefault();
	});

	const createAppExt = (el) => {
		let app = createApp({
			mounted() {
				this.$el.parentNode.replaceWith(this.$el);
			}
		});

		app.use(store);
		app.directive('maska', d);

		for (let name in components) {
			app.component(name, components[name]);
		}

		if (el) {
			app.mount(el);
		}

		return app;
	};

	// import jquery from 'jquery'

	// window.$ = window.jQuery = jquery

	//axios.defaults.withCredentials = true;

	document.querySelectorAll('v-scope, [v-scope]').forEach(element => createAppExt(element));

}());
